
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired9d8"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired9d8"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));



var $acw62 = parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};

$parcel$export($7e96a608cb33bf79$exports, "createRoot", () => $7e96a608cb33bf79$export$882461b6382ed46c, (v) => $7e96a608cb33bf79$export$882461b6382ed46c = v);
$parcel$export($7e96a608cb33bf79$exports, "hydrateRoot", () => $7e96a608cb33bf79$export$757ceba2d55c277e, (v) => $7e96a608cb33bf79$export$757ceba2d55c277e = v);
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


const $a7f559d5d89c892f$export$6d3c090e66a883b1 = ()=>undefined;


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const $029952e65115eee5$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $029952e65115eee5$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $029952e65115eee5$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $029952e65115eee5$export$a39cad550e7ab28a = function(message) {
    return new Error('Firebase Database (' + $029952e65115eee5$export$588c7fdda06fbb0a.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $029952e65115eee5$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const $029952e65115eee5$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($029952e65115eee5$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $029952e65115eee5$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $029952e65115eee5$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $029952e65115eee5$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const $029952e65115eee5$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $029952e65115eee5$var$stringToByteArray$1(str);
    return $029952e65115eee5$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $029952e65115eee5$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $029952e65115eee5$export$e510a73ee562749(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $029952e65115eee5$export$c62426fdd000a97e = function(str) {
    try {
        return $029952e65115eee5$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $029952e65115eee5$export$6c40052bed430212(value) {
    return $029952e65115eee5$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $029952e65115eee5$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$029952e65115eee5$var$isValidKey(prop)) continue;
        target[prop] = $029952e65115eee5$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $029952e65115eee5$var$isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $029952e65115eee5$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $029952e65115eee5$var$getDefaultsFromGlobal = ()=>$029952e65115eee5$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $029952e65115eee5$var$getDefaultsFromEnvVariable = ()=>{
    return;
};
const $029952e65115eee5$var$getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $029952e65115eee5$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $029952e65115eee5$export$212bb2fc580a90a8 = ()=>{
    try {
        return (0, $a7f559d5d89c892f$export$6d3c090e66a883b1)() || $029952e65115eee5$var$getDefaultsFromGlobal() || $029952e65115eee5$var$getDefaultsFromEnvVariable() || $029952e65115eee5$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $029952e65115eee5$export$9c11895284c8adad = (productName)=>$029952e65115eee5$export$212bb2fc580a90a8()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $029952e65115eee5$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $029952e65115eee5$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $029952e65115eee5$export$3dfb6827a9f89756 = ()=>$029952e65115eee5$export$212bb2fc580a90a8()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $029952e65115eee5$export$5539a1a3afe87d6 = (name)=>$029952e65115eee5$export$212bb2fc580a90a8()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $029952e65115eee5$export$85f6557964517f1a {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(header)),
        $029952e65115eee5$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $029952e65115eee5$export$c36915b22ce77c19() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $029952e65115eee5$export$872f8323f01d7ae0() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($029952e65115eee5$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $029952e65115eee5$export$8ee0fc9ee280b4ee() {
    const forceEnvironment = $029952e65115eee5$export$212bb2fc580a90a8()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function $029952e65115eee5$export$4e09c449d6c407f7() {
    return typeof window !== 'undefined' || $029952e65115eee5$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context.
 */ function $029952e65115eee5$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function $029952e65115eee5$export$ad9e9b75cb9fb797() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function $029952e65115eee5$export$caa8774a9107a58e() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $029952e65115eee5$export$f7a1e23e542d38e3() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function $029952e65115eee5$export$f2f6a8999f8ebd30() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function $029952e65115eee5$export$7e7b1a9668aaed8() {
    const ua = $029952e65115eee5$export$c36915b22ce77c19();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function $029952e65115eee5$export$202944b2d2824246() {
    return $029952e65115eee5$export$c36915b22ce77c19().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $029952e65115eee5$export$5d1d834fbbf8bab7() {
    return $029952e65115eee5$export$588c7fdda06fbb0a.NODE_CLIENT === true || $029952e65115eee5$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $029952e65115eee5$export$95df08bae54cb4df() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function $029952e65115eee5$export$ef10bcfb06572016() {
    return !$029952e65115eee5$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $029952e65115eee5$export$3865db50535c2055() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $029952e65115eee5$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $029952e65115eee5$export$f172b7eb6cf60599() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $029952e65115eee5$var$ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $029952e65115eee5$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $029952e65115eee5$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, $029952e65115eee5$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $029952e65115eee5$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $029952e65115eee5$export$3fa6e1b18a3b2d40 {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $029952e65115eee5$var$replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $029952e65115eee5$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
}
function $029952e65115eee5$var$replaceTemplate(template, data) {
    return template.replace($029952e65115eee5$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $029952e65115eee5$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $029952e65115eee5$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $029952e65115eee5$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[0]) || '');
        claims = $029952e65115eee5$export$c5a53ce6a17cf18d($029952e65115eee5$export$c62426fdd000a97e(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$5f870fcca7ae6a88 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$701c661ec91095f2 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $029952e65115eee5$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $029952e65115eee5$export$fc970ed23da99565 = function(token) {
    const claims = $029952e65115eee5$export$2f872c0f2117be69(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $029952e65115eee5$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $029952e65115eee5$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $029952e65115eee5$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $029952e65115eee5$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($029952e65115eee5$var$isObject(aProp) && $029952e65115eee5$var$isObject(bProp)) {
            if (!$029952e65115eee5$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $029952e65115eee5$var$isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $029952e65115eee5$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $029952e65115eee5$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $029952e65115eee5$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $029952e65115eee5$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $029952e65115eee5$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $029952e65115eee5$export$c85d589bf4e25fef {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $029952e65115eee5$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $029952e65115eee5$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $029952e65115eee5$var$ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if ($029952e65115eee5$var$implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $029952e65115eee5$var$noop;
        if (observer.error === undefined) observer.error = $029952e65115eee5$var$noop;
        if (observer.complete === undefined) observer.complete = $029952e65115eee5$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $029952e65115eee5$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $029952e65115eee5$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function $029952e65115eee5$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $029952e65115eee5$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $029952e65115eee5$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $029952e65115eee5$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function $029952e65115eee5$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid function.');
}
function $029952e65115eee5$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error($029952e65115eee5$export$adea4917e02d93dc(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $029952e65115eee5$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $029952e65115eee5$export$a7a9523472993e97(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $029952e65115eee5$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $029952e65115eee5$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $029952e65115eee5$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $029952e65115eee5$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $029952e65115eee5$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $029952e65115eee5$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($029952e65115eee5$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $029952e65115eee5$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $029952e65115eee5$var$indicator(i);
}
function $029952e65115eee5$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $029952e65115eee5$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function $029952e65115eee5$export$5b4d24b45140ad90(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function $029952e65115eee5$export$c0f0d0ce4283a937(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function $029952e65115eee5$export$7220bf91e5c1b402(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hexHash;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$16fa2f45be04daa8 {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5782dd2556309534$var$DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $5782dd2556309534$export$2881499e37b75b9a {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $029952e65115eee5$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($5782dd2556309534$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $5782dd2556309534$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $5782dd2556309534$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $5782dd2556309534$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $5782dd2556309534$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function $5782dd2556309534$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $5782dd2556309534$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $5782dd2556309534$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $5782dd2556309534$export$436a80eea5d5c0c5 {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $5782dd2556309534$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $59d1e3b150b2f36d$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $59d1e3b150b2f36d$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($59d1e3b150b2f36d$export$243e62d78d3b544d || ($59d1e3b150b2f36d$export$243e62d78d3b544d = {}));
const $59d1e3b150b2f36d$var$levelStringToEnum = {
    'debug': $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG,
    'verbose': $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE,
    'info': $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO,
    'warn': $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN,
    'error': $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR,
    'silent': $59d1e3b150b2f36d$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $59d1e3b150b2f36d$var$defaultLogLevel = $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $59d1e3b150b2f36d$var$ConsoleMethod = {
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG]: 'log',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE]: 'log',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.INFO]: 'info',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.WARN]: 'warn',
    [$59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $59d1e3b150b2f36d$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $59d1e3b150b2f36d$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $59d1e3b150b2f36d$export$efa9a398d6368992 {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $59d1e3b150b2f36d$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $59d1e3b150b2f36d$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $59d1e3b150b2f36d$var$instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $59d1e3b150b2f36d$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? $59d1e3b150b2f36d$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $59d1e3b150b2f36d$export$243e62d78d3b544d.ERROR, ...args);
    }
}
function $59d1e3b150b2f36d$export$c622e99c0ce7b1c9(level) {
    $59d1e3b150b2f36d$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $59d1e3b150b2f36d$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $59d1e3b150b2f36d$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $59d1e3b150b2f36d$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: $59d1e3b150b2f36d$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $e67bf383372d72f4$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $e67bf383372d72f4$var$idbProxyableTypes;
let $e67bf383372d72f4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getIdbProxyableTypes() {
    return $e67bf383372d72f4$var$idbProxyableTypes || ($e67bf383372d72f4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $e67bf383372d72f4$var$getCursorAdvanceMethods() {
    return $e67bf383372d72f4$var$cursorAdvanceMethods || ($e67bf383372d72f4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $e67bf383372d72f4$var$cursorRequestMap = new WeakMap();
const $e67bf383372d72f4$var$transactionDoneMap = new WeakMap();
const $e67bf383372d72f4$var$transactionStoreNamesMap = new WeakMap();
const $e67bf383372d72f4$var$transformCache = new WeakMap();
const $e67bf383372d72f4$export$407448d2b89b1813 = new WeakMap();
function $e67bf383372d72f4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($e67bf383372d72f4$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $e67bf383372d72f4$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $e67bf383372d72f4$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $e67bf383372d72f4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($e67bf383372d72f4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $e67bf383372d72f4$var$transactionDoneMap.set(tx, done);
}
let $e67bf383372d72f4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $e67bf383372d72f4$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || $e67bf383372d72f4$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $e67bf383372d72f4$export$43caf9889c228507(callback) {
    $e67bf383372d72f4$var$idbProxyTraps = callback($e67bf383372d72f4$var$idbProxyTraps);
}
function $e67bf383372d72f4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($e67bf383372d72f4$export$3b14a55fb2447963(this), storeNames, ...args);
        $e67bf383372d72f4$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($e67bf383372d72f4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args);
        return $e67bf383372d72f4$export$efccba1c4a2ef57b($e67bf383372d72f4$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $e67bf383372d72f4$export$efccba1c4a2ef57b(func.apply($e67bf383372d72f4$export$3b14a55fb2447963(this), args));
    };
}
function $e67bf383372d72f4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $e67bf383372d72f4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $e67bf383372d72f4$var$cacheDonePromiseForTransaction(value);
    if ($e67bf383372d72f4$export$23f2a1d2818174ef(value, $e67bf383372d72f4$var$getIdbProxyableTypes())) return new Proxy(value, $e67bf383372d72f4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $e67bf383372d72f4$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $e67bf383372d72f4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($e67bf383372d72f4$var$transformCache.has(value)) return $e67bf383372d72f4$var$transformCache.get(value);
    const newValue = $e67bf383372d72f4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $e67bf383372d72f4$var$transformCache.set(value, newValue);
        $e67bf383372d72f4$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $e67bf383372d72f4$export$3b14a55fb2447963 = (value)=>$e67bf383372d72f4$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $e67bf383372d72f4$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
(0, $e67bf383372d72f4$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($5e587d655f0a08bb$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $5e587d655f0a08bb$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const $5e587d655f0a08bb$var$name$q = "@firebase/app";
const $5e587d655f0a08bb$var$version$1 = "0.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$logger = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)('@firebase/app');
const $5e587d655f0a08bb$var$name$p = "@firebase/app-compat";
const $5e587d655f0a08bb$var$name$o = "@firebase/analytics-compat";
const $5e587d655f0a08bb$var$name$n = "@firebase/analytics";
const $5e587d655f0a08bb$var$name$m = "@firebase/app-check-compat";
const $5e587d655f0a08bb$var$name$l = "@firebase/app-check";
const $5e587d655f0a08bb$var$name$k = "@firebase/auth";
const $5e587d655f0a08bb$var$name$j = "@firebase/auth-compat";
const $5e587d655f0a08bb$var$name$i = "@firebase/database";
const $5e587d655f0a08bb$var$name$h = "@firebase/data-connect";
const $5e587d655f0a08bb$var$name$g = "@firebase/database-compat";
const $5e587d655f0a08bb$var$name$f = "@firebase/functions";
const $5e587d655f0a08bb$var$name$e = "@firebase/functions-compat";
const $5e587d655f0a08bb$var$name$d = "@firebase/installations";
const $5e587d655f0a08bb$var$name$c = "@firebase/installations-compat";
const $5e587d655f0a08bb$var$name$b = "@firebase/messaging";
const $5e587d655f0a08bb$var$name$a = "@firebase/messaging-compat";
const $5e587d655f0a08bb$var$name$9 = "@firebase/performance";
const $5e587d655f0a08bb$var$name$8 = "@firebase/performance-compat";
const $5e587d655f0a08bb$var$name$7 = "@firebase/remote-config";
const $5e587d655f0a08bb$var$name$6 = "@firebase/remote-config-compat";
const $5e587d655f0a08bb$var$name$5 = "@firebase/storage";
const $5e587d655f0a08bb$var$name$4 = "@firebase/storage-compat";
const $5e587d655f0a08bb$var$name$3 = "@firebase/firestore";
const $5e587d655f0a08bb$var$name$2 = "@firebase/ai";
const $5e587d655f0a08bb$var$name$1 = "@firebase/firestore-compat";
const $5e587d655f0a08bb$var$name = "firebase";
const $5e587d655f0a08bb$var$version = "12.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $5e587d655f0a08bb$export$9f30fa0c10967f7f = '[DEFAULT]';
const $5e587d655f0a08bb$var$PLATFORM_LOG_STRING = {
    [$5e587d655f0a08bb$var$name$q]: 'fire-core',
    [$5e587d655f0a08bb$var$name$p]: 'fire-core-compat',
    [$5e587d655f0a08bb$var$name$n]: 'fire-analytics',
    [$5e587d655f0a08bb$var$name$o]: 'fire-analytics-compat',
    [$5e587d655f0a08bb$var$name$l]: 'fire-app-check',
    [$5e587d655f0a08bb$var$name$m]: 'fire-app-check-compat',
    [$5e587d655f0a08bb$var$name$k]: 'fire-auth',
    [$5e587d655f0a08bb$var$name$j]: 'fire-auth-compat',
    [$5e587d655f0a08bb$var$name$i]: 'fire-rtdb',
    [$5e587d655f0a08bb$var$name$h]: 'fire-data-connect',
    [$5e587d655f0a08bb$var$name$g]: 'fire-rtdb-compat',
    [$5e587d655f0a08bb$var$name$f]: 'fire-fn',
    [$5e587d655f0a08bb$var$name$e]: 'fire-fn-compat',
    [$5e587d655f0a08bb$var$name$d]: 'fire-iid',
    [$5e587d655f0a08bb$var$name$c]: 'fire-iid-compat',
    [$5e587d655f0a08bb$var$name$b]: 'fire-fcm',
    [$5e587d655f0a08bb$var$name$a]: 'fire-fcm-compat',
    [$5e587d655f0a08bb$var$name$9]: 'fire-perf',
    [$5e587d655f0a08bb$var$name$8]: 'fire-perf-compat',
    [$5e587d655f0a08bb$var$name$7]: 'fire-rc',
    [$5e587d655f0a08bb$var$name$6]: 'fire-rc-compat',
    [$5e587d655f0a08bb$var$name$5]: 'fire-gcs',
    [$5e587d655f0a08bb$var$name$4]: 'fire-gcs-compat',
    [$5e587d655f0a08bb$var$name$3]: 'fire-fst',
    [$5e587d655f0a08bb$var$name$1]: 'fire-fst-compat',
    [$5e587d655f0a08bb$var$name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [$5e587d655f0a08bb$var$name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $5e587d655f0a08bb$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $5e587d655f0a08bb$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5e587d655f0a08bb$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $5e587d655f0a08bb$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $5e587d655f0a08bb$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $5e587d655f0a08bb$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($5e587d655f0a08bb$export$9566bce3835c0f28.has(componentName)) {
        $5e587d655f0a08bb$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $5e587d655f0a08bb$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $5e587d655f0a08bb$export$b4e3c36c855b14b5.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.values())$5e587d655f0a08bb$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $5e587d655f0a08bb$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    $5e587d655f0a08bb$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$38e311c93c671bec(obj) {
    if ($5e587d655f0a08bb$export$110778f8e98b8257(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $5e587d655f0a08bb$export$643c8bc6c389f34e(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $5e587d655f0a08bb$export$3685d89b9c3cdfaf() {
    $5e587d655f0a08bb$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const $5e587d655f0a08bb$var$ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('app', 'Firebase', $5e587d655f0a08bb$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function $5e587d655f0a08bb$var$validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, $029952e65115eee5$export$c62426fdd000a97e)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class $5e587d655f0a08bb$var$FirebaseServerAppImpl extends $5e587d655f0a08bb$var$FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled: automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) $5e587d655f0a08bb$var$validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $5e587d655f0a08bb$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $5e587d655f0a08bb$export$31499a9cd224b78c = $5e587d655f0a08bb$var$version;
function $5e587d655f0a08bb$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = {
        name: $5e587d655f0a08bb$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!options) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(name);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseAppImpl(options, config, container);
    $5e587d655f0a08bb$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $5e587d655f0a08bb$export$45a407ab953b136b(_options, _serverAppConfig = {}) {
    if ((0, $029952e65115eee5$export$4e09c449d6c407f7)() && !(0, $029952e65115eee5$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if ($5e587d655f0a08bb$export$110778f8e98b8257(_options)) firebaseOptions = _options.options;
        else if ($5e587d655f0a08bb$export$38e311c93c671bec(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, $029952e65115eee5$export$3dfb6827a9f89756)());
    if (!firebaseOptions) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $5782dd2556309534$export$436a80eea5d5c0c5)(nameString);
    for (const component of $5e587d655f0a08bb$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $5e587d655f0a08bb$var$FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $5e587d655f0a08bb$export$f9962582c9e66d99(name = $5e587d655f0a08bb$export$9f30fa0c10967f7f) {
    const app = $5e587d655f0a08bb$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $5e587d655f0a08bb$export$9f30fa0c10967f7f && (0, $029952e65115eee5$export$3dfb6827a9f89756)()) return $5e587d655f0a08bb$export$c55cfd413944906d();
    if (!app) throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $5e587d655f0a08bb$export$68ddedf7d44b3bdf() {
    return Array.from($5e587d655f0a08bb$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $5e587d655f0a08bb$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($5e587d655f0a08bb$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $5e587d655f0a08bb$export$b4e3c36c855b14b5.delete(name);
    } else if ($5e587d655f0a08bb$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $5e587d655f0a08bb$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $5e587d655f0a08bb$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = $5e587d655f0a08bb$var$PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $5e587d655f0a08bb$var$logger.warn(warning.join(' '));
        return;
    }
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $5e587d655f0a08bb$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $59d1e3b150b2f36d$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $5e587d655f0a08bb$export$c622e99c0ce7b1c9(logLevel) {
    (0, $59d1e3b150b2f36d$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$DB_NAME = 'firebase-heartbeat-database';
const $5e587d655f0a08bb$var$DB_VERSION = 1;
const $5e587d655f0a08bb$var$STORE_NAME = 'firebase-heartbeat-store';
let $5e587d655f0a08bb$var$dbPromise = null;
function $5e587d655f0a08bb$var$getDbPromise() {
    if (!$5e587d655f0a08bb$var$dbPromise) $5e587d655f0a08bb$var$dbPromise = (0, $da032767b57a4aa4$export$ca0ed41b1a2af7e)($5e587d655f0a08bb$var$DB_NAME, $5e587d655f0a08bb$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($5e587d655f0a08bb$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $5e587d655f0a08bb$var$dbPromise;
}
async function $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME);
        const result = await tx.objectStore($5e587d655f0a08bb$var$STORE_NAME).get($5e587d655f0a08bb$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
async function $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $5e587d655f0a08bb$var$getDbPromise();
        const tx = db.transaction($5e587d655f0a08bb$var$STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore($5e587d655f0a08bb$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $5e587d655f0a08bb$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) $5e587d655f0a08bb$var$logger.warn(e.message);
        else {
            const idbGetError = $5e587d655f0a08bb$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            $5e587d655f0a08bb$var$logger.warn(idbGetError.message);
        }
    }
}
function $5e587d655f0a08bb$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5e587d655f0a08bb$var$MAX_HEADER_BYTES = 1024;
const $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS = 30;
class $5e587d655f0a08bb$var$HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new $5e587d655f0a08bb$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date: date,
                    agent: agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > $5e587d655f0a08bb$var$MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = $5e587d655f0a08bb$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $5e587d655f0a08bb$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $029952e65115eee5$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $5e587d655f0a08bb$var$logger.warn(e);
            return '';
        }
    }
}
function $5e587d655f0a08bb$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $5e587d655f0a08bb$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $5e587d655f0a08bb$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($5e587d655f0a08bb$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $5e587d655f0a08bb$var$HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return false;
        else return (0, $029952e65115eee5$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $5e587d655f0a08bb$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $5e587d655f0a08bb$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $5e587d655f0a08bb$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $029952e65115eee5$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function $5e587d655f0a08bb$var$getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $5e587d655f0a08bb$var$registerCoreComponents(variant) {
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('platform-logger', (container)=>new $5e587d655f0a08bb$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $5e587d655f0a08bb$export$c930050e7bb63965(new (0, $5782dd2556309534$export$16fa2f45be04daa8)('heartbeat', (container)=>new $5e587d655f0a08bb$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    $5e587d655f0a08bb$export$d29d5299a7137abc($5e587d655f0a08bb$var$name$q, $5e587d655f0a08bb$var$version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    $5e587d655f0a08bb$export$d29d5299a7137abc('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $5e587d655f0a08bb$var$registerCoreComponents('');


var $b20e7fc8482ee2a9$var$name = "firebase";
var $b20e7fc8482ee2a9$var$version = "12.15.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($b20e7fc8482ee2a9$var$name, $b20e7fc8482ee2a9$var$version, 'app');






/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const $c079a574c124a39d$export$d66501df72047452 = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const $c079a574c124a39d$export$9e5f44173e64f162 = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const $c079a574c124a39d$export$25ce5a424b770e84 = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const $c079a574c124a39d$export$c4ce752e73470fba = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const $c079a574c124a39d$export$ebd11618f299a286 = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$_debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function $c079a574c124a39d$var$_prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $c079a574c124a39d$export$7f8ddf7c7c20b3cd = $c079a574c124a39d$var$_debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const $c079a574c124a39d$export$9bb611d729802a56 = $c079a574c124a39d$var$_prodErrorMap;
const $c079a574c124a39d$var$_DEFAULT_AUTH_ERROR_FACTORY = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', $c079a574c124a39d$var$_prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const $c079a574c124a39d$export$b4171a6734a65d42 = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$logClient = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)('@firebase/auth');
function $c079a574c124a39d$var$_logWarn(msg, ...args) {
    if ($c079a574c124a39d$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) $c079a574c124a39d$var$logClient.warn(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
function $c079a574c124a39d$var$_logError(msg, ...args) {
    if ($c079a574c124a39d$var$logClient.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) $c079a574c124a39d$var$logClient.error(`Auth (${(0, $5e587d655f0a08bb$export$31499a9cd224b78c)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$export$28f7fcd39efa255(authOrCode, ...rest) {
    throw $c079a574c124a39d$var$createErrorInternal(authOrCode, ...rest);
}
function $c079a574c124a39d$export$890c4ad488842ce7(authOrCode, ...rest) {
    return $c079a574c124a39d$var$createErrorInternal(authOrCode, ...rest);
}
function $c079a574c124a39d$var$_errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...$c079a574c124a39d$export$9bb611d729802a56(),
        [code]: message
    };
    const factory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function $c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth) {
    return $c079a574c124a39d$var$_errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function $c079a574c124a39d$var$_assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) $c079a574c124a39d$export$28f7fcd39efa255(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw $c079a574c124a39d$var$_errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function $c079a574c124a39d$var$createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return $c079a574c124a39d$var$_DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function $c079a574c124a39d$export$24baa2b76016ce0e(assertion, authOrCode, ...rest) {
    if (!assertion) throw $c079a574c124a39d$var$createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function $c079a574c124a39d$var$debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    $c079a574c124a39d$var$_logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function $c079a574c124a39d$export$d66dc83d8cfc8dd(assertion, message) {
    if (!assertion) $c079a574c124a39d$var$debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$_getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function $c079a574c124a39d$var$_isHttpOrHttps() {
    return $c079a574c124a39d$var$_getCurrentScheme() === 'http:' || $c079a574c124a39d$var$_getCurrentScheme() === 'https:';
}
function $c079a574c124a39d$var$_getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function $c079a574c124a39d$var$_isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    ($c079a574c124a39d$var$_isHttpOrHttps() || (0, $029952e65115eee5$export$caa8774a9107a58e)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function $c079a574c124a39d$var$_getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class $c079a574c124a39d$var$Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        $c079a574c124a39d$export$d66dc83d8cfc8dd(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, $029952e65115eee5$export$872f8323f01d7ae0)() || (0, $029952e65115eee5$export$f7a1e23e542d38e3)();
    }
    get() {
        if (!$c079a574c124a39d$var$_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$_emulatorUrl(config, path) {
    $c079a574c124a39d$export$d66dc83d8cfc8dd(config.emulator, 'Emulator should always be set here');
    const { url: url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$export$f96d196f7728bb5 {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        $c079a574c124a39d$var$debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        $c079a574c124a39d$var$debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        $c079a574c124a39d$var$debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const $c079a574c124a39d$var$SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const $c079a574c124a39d$var$DEFAULT_API_TIMEOUT_MS = new $c079a574c124a39d$var$Delay(30000, 60000);
function $c079a574c124a39d$var$_addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function $c079a574c124a39d$var$_performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return $c079a574c124a39d$var$_performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, $029952e65115eee5$export$ac4103b836844853)({
            ...params,
            key: auth.config.apiKey
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method: method,
            headers: headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, $029952e65115eee5$export$ad9e9b75cb9fb797)()) fetchArgs.referrerPolicy = 'strict-origin-when-cross-origin';
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return $c079a574c124a39d$export$f96d196f7728bb5.fetch()(await $c079a574c124a39d$var$_getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function $c079a574c124a39d$var$_performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...$c079a574c124a39d$var$SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new $c079a574c124a39d$var$NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw $c079a574c124a39d$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw $c079a574c124a39d$var$_makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw $c079a574c124a39d$var$_makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw $c079a574c124a39d$var$_makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw $c079a574c124a39d$var$_errorWithCustomMessage(auth, authError, serverErrorMessage);
            else $c079a574c124a39d$export$28f7fcd39efa255(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        $c079a574c124a39d$export$28f7fcd39efa255(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function $c079a574c124a39d$var$_performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await $c079a574c124a39d$var$_performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) $c079a574c124a39d$export$28f7fcd39efa255(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function $c079a574c124a39d$var$_getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? $c079a574c124a39d$var$_emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if ($c079a574c124a39d$var$CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function $c079a574c124a39d$var$_parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class $c079a574c124a39d$var$NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject($c079a574c124a39d$export$890c4ad488842ce7(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $c079a574c124a39d$var$DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function $c079a574c124a39d$var$_makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = $c079a574c124a39d$export$890c4ad488842ce7(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function $c079a574c124a39d$var$isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class $c079a574c124a39d$var$RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return $c079a574c124a39d$var$_parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$getRecaptchaParams(auth) {
    return (await $c079a574c124a39d$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function $c079a574c124a39d$var$getRecaptchaConfig(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$deleteAccount(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function $c079a574c124a39d$var$deleteLinkedAccounts(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function $c079a574c124a39d$var$getAccountInfo(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function $c079a574c124a39d$export$7a38258bbe170828(user, forceRefresh = false) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function $c079a574c124a39d$export$2f6ca3d3b1f80bf5(user, forceRefresh = false) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = $c079a574c124a39d$var$_parseToken(token);
    $c079a574c124a39d$export$24baa2b76016ce0e(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims: claims,
        token: token,
        authTime: $c079a574c124a39d$var$utcTimestampToDateString($c079a574c124a39d$var$secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: $c079a574c124a39d$var$utcTimestampToDateString($c079a574c124a39d$var$secondsStringToMilliseconds(claims.iat)),
        expirationTime: $c079a574c124a39d$var$utcTimestampToDateString($c079a574c124a39d$var$secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function $c079a574c124a39d$var$secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function $c079a574c124a39d$var$_parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        $c079a574c124a39d$var$_logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, $029952e65115eee5$export$c62426fdd000a97e)(payload);
        if (!decoded) {
            $c079a574c124a39d$var$_logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        $c079a574c124a39d$var$_logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function $c079a574c124a39d$var$_tokenExpiresIn(token) {
    const parsedToken = $c079a574c124a39d$var$_parseToken(token);
    $c079a574c124a39d$export$24baa2b76016ce0e(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $c079a574c124a39d$export$24baa2b76016ce0e(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    $c079a574c124a39d$export$24baa2b76016ce0e(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$_logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, $029952e65115eee5$export$dd24e9cd51226c56) && $c079a574c124a39d$var$isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function $c079a574c124a39d$var$isUserInvalidated({ code: code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = $c079a574c124a39d$var$utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = $c079a574c124a39d$var$utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$_reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await $c079a574c124a39d$var$_logoutIfInvalidated(user, $c079a574c124a39d$var$getAccountInfo(auth, {
        idToken: idToken
    }));
    $c079a574c124a39d$export$24baa2b76016ce0e(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? $c079a574c124a39d$var$extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = $c079a574c124a39d$var$mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData: providerData,
        metadata: new $c079a574c124a39d$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous: isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function $c079a574c124a39d$export$6554612db691658e(user) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $c079a574c124a39d$var$_reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function $c079a574c124a39d$var$mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function $c079a574c124a39d$var$extractProviderData(providers) {
    return providers.map(({ providerId: providerId, ...provider })=>{
        return {
            providerId: providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$requestStsToken(auth, refreshToken) {
    const response = await $c079a574c124a39d$var$_performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, $029952e65115eee5$export$ac4103b836844853)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost: tokenApiHost, apiKey: apiKey } = auth.config;
        const url = await $c079a574c124a39d$var$_getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers: headers,
            body: body
        };
        if (auth.emulatorConfig && (0, $029952e65115eee5$export$5b4d24b45140ad90)(auth.emulatorConfig.host)) options.credentials = 'include';
        return $c079a574c124a39d$export$f96d196f7728bb5.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function $c079a574c124a39d$var$revokeToken(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class $c079a574c124a39d$var$StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        $c079a574c124a39d$export$24baa2b76016ce0e(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : $c079a574c124a39d$var$_tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        $c079a574c124a39d$export$24baa2b76016ce0e(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = $c079a574c124a39d$var$_tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        $c079a574c124a39d$export$24baa2b76016ce0e(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken: accessToken, refreshToken: refreshToken, expiresIn: expiresIn } = await $c079a574c124a39d$var$requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken: refreshToken, accessToken: accessToken, expirationTime: expirationTime } = object;
        const manager = new $c079a574c124a39d$var$StsTokenManager();
        if (refreshToken) {
            $c079a574c124a39d$export$24baa2b76016ce0e(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            $c079a574c124a39d$export$24baa2b76016ce0e(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            $c079a574c124a39d$export$24baa2b76016ce0e(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName: appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new $c079a574c124a39d$var$StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return $c079a574c124a39d$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$assertStringOrUndefined(assertion, appName) {
    $c079a574c124a39d$export$24baa2b76016ce0e(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName: appName
    });
}
class $c079a574c124a39d$export$91477dc880baac21 {
    constructor({ uid: uid, auth: auth, stsTokenManager: stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new $c079a574c124a39d$var$ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new $c079a574c124a39d$var$UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await $c079a574c124a39d$var$_logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        $c079a574c124a39d$export$24baa2b76016ce0e(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return $c079a574c124a39d$export$2f6ca3d3b1f80bf5(this, forceRefresh);
    }
    reload() {
        return $c079a574c124a39d$export$6554612db691658e(this);
    }
    _assign(user) {
        if (this === user) return;
        $c079a574c124a39d$export$24baa2b76016ce0e(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new $c079a574c124a39d$export$91477dc880baac21({
            ...this,
            auth: auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        $c079a574c124a39d$export$24baa2b76016ce0e(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await $c079a574c124a39d$var$_reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await $c079a574c124a39d$var$_logoutIfInvalidated(this, $c079a574c124a39d$var$deleteAccount(this.auth, {
            idToken: idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid: uid, emailVerified: emailVerified, isAnonymous: isAnonymous, providerData: providerData, stsTokenManager: plainObjectTokenManager } = object;
        $c079a574c124a39d$export$24baa2b76016ce0e(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = $c079a574c124a39d$var$StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c079a574c124a39d$var$assertStringOrUndefined(displayName, auth.name);
        $c079a574c124a39d$var$assertStringOrUndefined(email, auth.name);
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        $c079a574c124a39d$var$assertStringOrUndefined(phoneNumber, auth.name);
        $c079a574c124a39d$var$assertStringOrUndefined(photoURL, auth.name);
        $c079a574c124a39d$var$assertStringOrUndefined(tenantId, auth.name);
        $c079a574c124a39d$var$assertStringOrUndefined(_redirectEventId, auth.name);
        $c079a574c124a39d$var$assertStringOrUndefined(createdAt, auth.name);
        $c079a574c124a39d$var$assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new $c079a574c124a39d$export$91477dc880baac21({
            uid: uid,
            auth: auth,
            email: email,
            emailVerified: emailVerified,
            displayName: displayName,
            isAnonymous: isAnonymous,
            photoURL: photoURL,
            phoneNumber: phoneNumber,
            tenantId: tenantId,
            stsTokenManager: stsTokenManager,
            createdAt: createdAt,
            lastLoginAt: lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new $c079a574c124a39d$var$StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new $c079a574c124a39d$export$91477dc880baac21({
            uid: idTokenResponse.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await $c079a574c124a39d$var$_reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        $c079a574c124a39d$export$24baa2b76016ce0e(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? $c079a574c124a39d$var$extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new $c079a574c124a39d$var$StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new $c079a574c124a39d$export$91477dc880baac21({
            uid: coreAccount.localId,
            auth: auth,
            stsTokenManager: stsTokenManager,
            isAnonymous: isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData: providerData,
            metadata: new $c079a574c124a39d$var$UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$instanceCache = new Map();
function $c079a574c124a39d$export$cf2f7c5792f80b46(cls) {
    $c079a574c124a39d$export$d66dc83d8cfc8dd(cls instanceof Function, 'Expected a class definition');
    let instance = $c079a574c124a39d$var$instanceCache.get(cls);
    if (instance) {
        $c079a574c124a39d$export$d66dc83d8cfc8dd(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    $c079a574c124a39d$var$instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
$c079a574c124a39d$var$InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const $c079a574c124a39d$export$e7c866399fa523f5 = $c079a574c124a39d$var$InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$export$53a70dd1ebbae346(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class $c079a574c124a39d$var$PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config: config, name: name } = this.auth;
        this.fullUserKey = $c079a574c124a39d$export$53a70dd1ebbae346(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = $c079a574c124a39d$export$53a70dd1ebbae346("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await $c079a574c124a39d$var$getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return $c079a574c124a39d$export$91477dc880baac21._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return $c079a574c124a39d$export$91477dc880baac21._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new $c079a574c124a39d$var$PersistenceUserManager($c079a574c124a39d$export$cf2f7c5792f80b46($c079a574c124a39d$export$e7c866399fa523f5), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || $c079a574c124a39d$export$cf2f7c5792f80b46($c079a574c124a39d$export$e7c866399fa523f5);
        const key = $c079a574c124a39d$export$53a70dd1ebbae346(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await $c079a574c124a39d$var$getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await $c079a574c124a39d$export$91477dc880baac21._fromGetAccountInfoResponse(auth, response, blob);
                } else user = $c079a574c124a39d$export$91477dc880baac21._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new $c079a574c124a39d$var$PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new $c079a574c124a39d$var$PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function $c079a574c124a39d$var$_getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if ($c079a574c124a39d$var$_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if ($c079a574c124a39d$var$_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if ($c079a574c124a39d$var$_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if ($c079a574c124a39d$var$_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if ($c079a574c124a39d$var$_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || $c079a574c124a39d$var$_isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if ($c079a574c124a39d$export$9fa96a7d116ea3ce(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function $c079a574c124a39d$var$_isFirefox(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /firefox\//i.test(ua);
}
function $c079a574c124a39d$var$_isSafari(userAgent = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function $c079a574c124a39d$var$_isChromeIOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /crios\//i.test(ua);
}
function $c079a574c124a39d$var$_isIEMobile(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iemobile/i.test(ua);
}
function $c079a574c124a39d$export$9fa96a7d116ea3ce(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /android/i.test(ua);
}
function $c079a574c124a39d$var$_isBlackBerry(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /blackberry/i.test(ua);
}
function $c079a574c124a39d$var$_isWebOS(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /webos/i.test(ua);
}
function $c079a574c124a39d$export$92108d983e8ee699(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function $c079a574c124a39d$export$9d398bebfec1c039(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function $c079a574c124a39d$var$_isIOSStandalone(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    return $c079a574c124a39d$export$92108d983e8ee699(ua) && !!window.navigator?.standalone;
}
function $c079a574c124a39d$var$_isIE10() {
    return (0, $029952e65115eee5$export$7e7b1a9668aaed8)() && document.documentMode === 10;
}
function $c079a574c124a39d$var$_isMobileBrowser(ua = (0, $029952e65115eee5$export$c36915b22ce77c19)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return $c079a574c124a39d$export$92108d983e8ee699(ua) || $c079a574c124a39d$export$9fa96a7d116ea3ce(ua) || $c079a574c124a39d$var$_isWebOS(ua) || $c079a574c124a39d$var$_isBlackBerry(ua) || /windows phone/i.test(ua) || $c079a574c124a39d$var$_isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function $c079a574c124a39d$export$faec65b429be379(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = $c079a574c124a39d$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${$c079a574c124a39d$var$_getBrowserName((0, $029952e65115eee5$export$c36915b22ce77c19)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, $5e587d655f0a08bb$export$31499a9cd224b78c}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function $c079a574c124a39d$var$_getPasswordPolicy(auth, request = {}) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const $c079a574c124a39d$var$MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class $c079a574c124a39d$var$PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? $c079a574c124a39d$var$MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$export$9f4f30ee63539e24 {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new $c079a574c124a39d$var$Subscription(this);
        this.idTokenSubscription = new $c079a574c124a39d$var$Subscription(this);
        this.beforeStateQueue = new $c079a574c124a39d$var$AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = $c079a574c124a39d$var$_DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = $c079a574c124a39d$export$cf2f7c5792f80b46(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await $c079a574c124a39d$var$PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await $c079a574c124a39d$var$getAccountInfo(this, {
                idToken: idToken
            });
            const user = await $c079a574c124a39d$export$91477dc880baac21._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        $c079a574c124a39d$export$24baa2b76016ce0e(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await $c079a574c124a39d$var$_reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = $c079a574c124a39d$var$_getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, $029952e65115eee5$export$4befe9b5fa509a1b)(userExtern) : null;
        if (user) $c079a574c124a39d$export$24baa2b76016ce0e(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) $c079a574c124a39d$export$24baa2b76016ce0e(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence($c079a574c124a39d$export$cf2f7c5792f80b46(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await $c079a574c124a39d$var$_getPasswordPolicy(this);
        const passwordPolicy = new $c079a574c124a39d$var$PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, $029952e65115eee5$export$3fa6e1b18a3b2d40)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token: token,
                idToken: idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await $c079a574c124a39d$var$revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && $c079a574c124a39d$export$cf2f7c5792f80b46(popupRedirectResolver) || this._popupRedirectResolver;
            $c079a574c124a39d$export$24baa2b76016ce0e(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await $c079a574c124a39d$var$PersistenceUserManager.create(this, [
                $c079a574c124a39d$export$cf2f7c5792f80b46(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        $c079a574c124a39d$export$24baa2b76016ce0e(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        $c079a574c124a39d$export$24baa2b76016ce0e(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = $c079a574c124a39d$export$faec65b429be379(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        $c079a574c124a39d$var$_logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function $c079a574c124a39d$export$23ebac1979863676(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
}
/** Helper class to wrap subscriber logic */ class $c079a574c124a39d$var$Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, $029952e65115eee5$export$364097d812234b3f)((observer)=>this.observer = observer);
    }
    get next() {
        $c079a574c124a39d$export$24baa2b76016ce0e(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $c079a574c124a39d$var$externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function $c079a574c124a39d$var$_setExternalJSProvider(p) {
    $c079a574c124a39d$var$externalJSProvider = p;
}
function $c079a574c124a39d$var$_loadJS(url) {
    return $c079a574c124a39d$var$externalJSProvider.loadJS(url);
}
function $c079a574c124a39d$var$_recaptchaV2ScriptUrl() {
    return $c079a574c124a39d$var$externalJSProvider.recaptchaV2Script;
}
function $c079a574c124a39d$var$_recaptchaEnterpriseScriptUrl() {
    return $c079a574c124a39d$var$externalJSProvider.recaptchaEnterpriseScript;
}
function $c079a574c124a39d$var$_gapiScriptUrl() {
    return $c079a574c124a39d$var$externalJSProvider.gapiScript;
}
function $c079a574c124a39d$var$_generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$_SOLVE_TIME_MS = 500;
const $c079a574c124a39d$var$_EXPIRATION_TIME_MS = 60000;
const $c079a574c124a39d$var$_WIDGET_ID_START = 1000000000000;
class $c079a574c124a39d$var$MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = $c079a574c124a39d$var$_WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new $c079a574c124a39d$var$MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || $c079a574c124a39d$var$_WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || $c079a574c124a39d$var$_WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || $c079a574c124a39d$var$_WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class $c079a574c124a39d$var$MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new $c079a574c124a39d$var$MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $c079a574c124a39d$var$MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class $c079a574c124a39d$var$MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $c079a574c124a39d$export$24baa2b76016ce0e(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName: appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = $c079a574c124a39d$var$generateRandomAlphaNumericString(50);
            const { callback: callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, $c079a574c124a39d$var$_EXPIRATION_TIME_MS);
        }, $c079a574c124a39d$var$_SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function $c079a574c124a39d$var$generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const $c079a574c124a39d$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const $c079a574c124a39d$var$FAKE_TOKEN = 'NO_RECAPTCHA';
const $c079a574c124a39d$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME = 'onFirebaseAuthREInstanceReady';
class $c079a574c124a39d$var$RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = $c079a574c124a39d$var$RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = $c079a574c124a39d$export$23ebac1979863676(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                $c079a574c124a39d$var$getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new $c079a574c124a39d$var$RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if ($c079a574c124a39d$var$isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action: action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve($c079a574c124a39d$var$FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new $c079a574c124a39d$var$MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then(async (siteKey)=>{
                if (!forceRefresh && $c079a574c124a39d$var$isEnterprise(window.grecaptcha) && // If download has already been initiated, do not trigger another
                // download, await the promise here.
                $c079a574c124a39d$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred) {
                    await $c079a574c124a39d$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred.promise;
                    retrieveRecaptchaToken(siteKey, resolve, reject);
                } else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = $c079a574c124a39d$var$_recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey + `&onload=${$c079a574c124a39d$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME}`;
                    // Existence of deferred indicates download has been initiated.
                    $c079a574c124a39d$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred = new (0, $029952e65115eee5$export$85f6557964517f1a)();
                    /**
                     * Script attached to global window object that will be called
                     * when the ReCAPTCHA Enterprise instance is ready.
                     * grecaptcha.ready() is not reliable when there are multiple
                     * scripts on the page, and script.onload only indicates the
                     * script has downloaded, not that it has initialized.
                     */ window[$c079a574c124a39d$var$RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME] = ()=>{
                        $c079a574c124a39d$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.resolve();
                    };
                    $c079a574c124a39d$var$_loadJS(url).then(()=>$c079a574c124a39d$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.promise).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
/**
 * Deferred that resolves when script tag has been injected onto the page
 * and the script is ready (grecaptcha.ready() and script.onload are not
 * reliable indicators, so this resolves when the global
 * `window[RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME]()` callback provided to the recaptcha url param "onload"
 * is triggered).
 * As a static variable this is applied to all instances of the class.
 * This will cause an error if users try to create multiple RecaptchaVerifiers
 * with different Recaptcha Enterprise sitekeys, which should be an
 * unuspported use case.
 */ $c079a574c124a39d$var$RecaptchaEnterpriseVerifier.scriptInjectionDeferred = null;
async function $c079a574c124a39d$var$injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new $c079a574c124a39d$var$RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = $c079a574c124a39d$var$FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber: phoneNumber,
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken: recaptchaToken,
                    captchaResponse: captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse: captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function $c079a574c124a39d$var$handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await $c079a574c124a39d$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await $c079a574c124a39d$var$injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await $c079a574c124a39d$var$injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await $c079a574c124a39d$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await $c079a574c124a39d$var$injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function $c079a574c124a39d$var$_initializeRecaptchaConfig(auth) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const response = await $c079a574c124a39d$var$getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new $c079a574c124a39d$var$RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new $c079a574c124a39d$var$RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function $c079a574c124a39d$export$3466f893ebf79586(app, deps) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(initialOptions, deps ?? {})) return auth;
        else $c079a574c124a39d$export$28f7fcd39efa255(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function $c079a574c124a39d$var$_initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map($c079a574c124a39d$export$cf2f7c5792f80b46);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function $c079a574c124a39d$export$61196ced6d74a310(auth, url, options) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    $c079a574c124a39d$export$24baa2b76016ce0e(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = $c079a574c124a39d$var$extractProtocol(url);
    const { host: host, port: port } = $c079a574c124a39d$var$extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host: host,
        port: port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings: disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        $c079a574c124a39d$export$24baa2b76016ce0e(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        $c079a574c124a39d$export$24baa2b76016ce0e((0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulator, authInternal.config.emulator) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, $029952e65115eee5$export$5b4d24b45140ad90)(host)) (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`${protocol}//${host}${portStr}`);
    else if (!disableWarnings) $c079a574c124a39d$var$emitEmulatorWarning();
}
function $c079a574c124a39d$var$extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function $c079a574c124a39d$var$extractHostAndPort(url) {
    const protocol = $c079a574c124a39d$var$extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host: host,
            port: $c079a574c124a39d$var$parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host: host,
            port: $c079a574c124a39d$var$parsePort(port)
        };
    }
}
function $c079a574c124a39d$var$parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function $c079a574c124a39d$var$emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $c079a574c124a39d$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return $c079a574c124a39d$var$debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return $c079a574c124a39d$var$debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return $c079a574c124a39d$var$debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return $c079a574c124a39d$var$debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$resetPassword(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
async function $c079a574c124a39d$var$updateEmailPassword(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function $c079a574c124a39d$var$linkEmailPassword(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function $c079a574c124a39d$var$applyActionCode$1(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$signInWithPassword(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
async function $c079a574c124a39d$var$sendOobCode(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
async function $c079a574c124a39d$var$sendEmailVerification$1(auth, request) {
    return $c079a574c124a39d$var$sendOobCode(auth, request);
}
async function $c079a574c124a39d$var$sendPasswordResetEmail$1(auth, request) {
    return $c079a574c124a39d$var$sendOobCode(auth, request);
}
async function $c079a574c124a39d$var$sendSignInLinkToEmail$1(auth, request) {
    return $c079a574c124a39d$var$sendOobCode(auth, request);
}
async function $c079a574c124a39d$var$verifyAndChangeEmail(auth, request) {
    return $c079a574c124a39d$var$sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$signInWithEmailLink$1(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
async function $c079a574c124a39d$var$signInWithEmailLinkForLinking(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class $c079a574c124a39d$export$a07804094c3ecf2d extends $c079a574c124a39d$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new $c079a574c124a39d$export$a07804094c3ecf2d(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new $c079a574c124a39d$export$a07804094c3ecf2d(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $c079a574c124a39d$var$handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , $c079a574c124a39d$var$signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $c079a574c124a39d$var$signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $c079a574c124a39d$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken: idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return $c079a574c124a39d$var$handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $c079a574c124a39d$var$linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return $c079a574c124a39d$var$signInWithEmailLinkForLinking(auth, {
                    idToken: idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                $c079a574c124a39d$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$signInWithIdp(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class $c079a574c124a39d$export$3722cfe417b6ed86 extends $c079a574c124a39d$export$3a1a48c8f6ef640e {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new $c079a574c124a39d$export$3722cfe417b6ed86(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else $c079a574c124a39d$export$28f7fcd39efa255("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new $c079a574c124a39d$export$3722cfe417b6ed86(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $c079a574c124a39d$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $c079a574c124a39d$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $c079a574c124a39d$var$signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: $c079a574c124a39d$var$IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, $029952e65115eee5$export$ac4103b836844853)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$sendPhoneVerificationCode(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
async function $c079a574c124a39d$var$signInWithPhoneNumber$1(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
async function $c079a574c124a39d$var$linkWithPhoneNumber$1(auth, request) {
    const response = await $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw $c079a574c124a39d$var$_makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const $c079a574c124a39d$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function $c079a574c124a39d$var$verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, apiRequest), $c079a574c124a39d$var$VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class $c079a574c124a39d$export$3a6d5c9ae78a2c08 extends $c079a574c124a39d$export$3a1a48c8f6ef640e {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new $c079a574c124a39d$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new $c079a574c124a39d$export$3a6d5c9ae78a2c08({
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return $c079a574c124a39d$var$signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return $c079a574c124a39d$var$linkWithPhoneNumber$1(auth, {
            idToken: idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return $c079a574c124a39d$var$verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof: temporaryProof, phoneNumber: phoneNumber, verificationId: verificationId, verificationCode: verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof: temporaryProof,
            phoneNumber: phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId: verificationId, verificationCode: verificationCode, phoneNumber: phoneNumber, temporaryProof: temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new $c079a574c124a39d$export$3a6d5c9ae78a2c08({
            verificationId: verificationId,
            verificationCode: verificationCode,
            phoneNumber: phoneNumber,
            temporaryProof: temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function $c079a574c124a39d$var$parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function $c079a574c124a39d$var$parseDeepLink(url) {
    const link = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class $c079a574c124a39d$export$3b513254972cfc9c {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, $029952e65115eee5$export$c1271ca4c8a70741)((0, $029952e65115eee5$export$1a8408415472d8ed)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = $c079a574c124a39d$var$parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        $c079a574c124a39d$export$24baa2b76016ce0e(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = $c079a574c124a39d$var$parseDeepLink(link);
        try {
            return new $c079a574c124a39d$export$3b513254972cfc9c(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function $c079a574c124a39d$export$21579262ef46735b(link) {
    return $c079a574c124a39d$export$3b513254972cfc9c.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class $c079a574c124a39d$export$71cec2538cb2c617 {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = $c079a574c124a39d$export$71cec2538cb2c617.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return $c079a574c124a39d$export$a07804094c3ecf2d._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = $c079a574c124a39d$export$3b513254972cfc9c.parseLink(emailLink);
        $c079a574c124a39d$export$24baa2b76016ce0e(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c079a574c124a39d$export$a07804094c3ecf2d._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ $c079a574c124a39d$export$71cec2538cb2c617.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ $c079a574c124a39d$export$71cec2538cb2c617.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ $c079a574c124a39d$export$71cec2538cb2c617.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class $c079a574c124a39d$var$FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class $c079a574c124a39d$var$BaseOAuthProvider extends $c079a574c124a39d$var$FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $c079a574c124a39d$export$71511d61b312f219 extends $c079a574c124a39d$var$BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        $c079a574c124a39d$export$24baa2b76016ce0e('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c079a574c124a39d$export$3722cfe417b6ed86._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        $c079a574c124a39d$export$24baa2b76016ce0e(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return $c079a574c124a39d$export$3722cfe417b6ed86._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c079a574c124a39d$export$71511d61b312f219.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$71511d61b312f219.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret, pendingToken: pendingToken, nonce: nonce, providerId: providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new $c079a574c124a39d$export$71511d61b312f219(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce: nonce,
                pendingToken: pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $c079a574c124a39d$export$78acf4525d8a74c4 extends $c079a574c124a39d$var$BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return $c079a574c124a39d$export$3722cfe417b6ed86._fromParams({
            providerId: $c079a574c124a39d$export$78acf4525d8a74c4.PROVIDER_ID,
            signInMethod: $c079a574c124a39d$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c079a574c124a39d$export$78acf4525d8a74c4.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$78acf4525d8a74c4.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $c079a574c124a39d$export$78acf4525d8a74c4.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ $c079a574c124a39d$export$78acf4525d8a74c4.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ $c079a574c124a39d$export$78acf4525d8a74c4.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class $c079a574c124a39d$export$8743009a87fcb00f extends $c079a574c124a39d$var$BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return $c079a574c124a39d$export$3722cfe417b6ed86._fromParams({
            providerId: $c079a574c124a39d$export$8743009a87fcb00f.PROVIDER_ID,
            signInMethod: $c079a574c124a39d$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD,
            idToken: idToken,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c079a574c124a39d$export$8743009a87fcb00f.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$8743009a87fcb00f.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken: oauthIdToken, oauthAccessToken: oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return $c079a574c124a39d$export$8743009a87fcb00f.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ $c079a574c124a39d$export$8743009a87fcb00f.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ $c079a574c124a39d$export$8743009a87fcb00f.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class $c079a574c124a39d$export$dc98b0b04f4c7758 extends $c079a574c124a39d$var$BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return $c079a574c124a39d$export$3722cfe417b6ed86._fromParams({
            providerId: $c079a574c124a39d$export$dc98b0b04f4c7758.PROVIDER_ID,
            signInMethod: $c079a574c124a39d$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD,
            accessToken: accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c079a574c124a39d$export$dc98b0b04f4c7758.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$dc98b0b04f4c7758.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return $c079a574c124a39d$export$dc98b0b04f4c7758.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ $c079a574c124a39d$export$dc98b0b04f4c7758.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ $c079a574c124a39d$export$dc98b0b04f4c7758.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class $c079a574c124a39d$export$738ab4df8bf92ae9 extends $c079a574c124a39d$export$3a1a48c8f6ef640e {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return $c079a574c124a39d$var$signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return $c079a574c124a39d$var$signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return $c079a574c124a39d$var$signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId: providerId, signInMethod: signInMethod, pendingToken: pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new $c079a574c124a39d$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new $c079a574c124a39d$export$738ab4df8bf92ae9(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: $c079a574c124a39d$var$IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class $c079a574c124a39d$export$3d8c2f653ac9d0b9 extends $c079a574c124a39d$var$FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        $c079a574c124a39d$export$24baa2b76016ce0e(providerId.startsWith($c079a574c124a39d$var$SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c079a574c124a39d$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$3d8c2f653ac9d0b9.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = $c079a574c124a39d$export$738ab4df8bf92ae9.fromJSON(json);
        $c079a574c124a39d$export$24baa2b76016ce0e(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken: pendingToken, providerId: providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return $c079a574c124a39d$export$738ab4df8bf92ae9._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class $c079a574c124a39d$export$34aec0b863436764 extends $c079a574c124a39d$var$BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return $c079a574c124a39d$export$3722cfe417b6ed86._fromParams({
            providerId: $c079a574c124a39d$export$34aec0b863436764.PROVIDER_ID,
            signInMethod: $c079a574c124a39d$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return $c079a574c124a39d$export$34aec0b863436764.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$34aec0b863436764.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken: oauthAccessToken, oauthTokenSecret: oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return $c079a574c124a39d$export$34aec0b863436764.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ $c079a574c124a39d$export$34aec0b863436764.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ $c079a574c124a39d$export$34aec0b863436764.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$signUp(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await $c079a574c124a39d$export$91477dc880baac21._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = $c079a574c124a39d$var$providerIdForResponse(idTokenResponse);
        const userCred = new $c079a574c124a39d$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: idTokenResponse,
            operationType: operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = $c079a574c124a39d$var$providerIdForResponse(response);
        return new $c079a574c124a39d$var$UserCredentialImpl({
            user: user,
            providerId: providerId,
            _tokenResponse: response,
            operationType: operationType
        });
    }
}
function $c079a574c124a39d$var$providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function $c079a574c124a39d$export$3c2fa207a37baaea(auth) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new $c079a574c124a39d$var$UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await $c079a574c124a39d$var$signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await $c079a574c124a39d$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$MultiFactorError extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c079a574c124a39d$var$MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType: operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new $c079a574c124a39d$var$MultiFactorError(auth, error, operationType, user);
    }
}
function $c079a574c124a39d$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw $c079a574c124a39d$var$MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function $c079a574c124a39d$var$providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId: providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function $c079a574c124a39d$export$8a5498727ef6be21(user, providerId) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $c079a574c124a39d$var$_assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo: providerUserInfo } = await $c079a574c124a39d$var$deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = $c079a574c124a39d$var$providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function $c079a574c124a39d$var$_link$1(user, credential, bypassAuthState = false) {
    const response = await $c079a574c124a39d$var$_logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return $c079a574c124a39d$var$UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function $c079a574c124a39d$var$_assertLinkedStatus(expected, user, provider) {
    await $c079a574c124a39d$var$_reloadWithoutSaving(user);
    const providerIds = $c079a574c124a39d$var$providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    $c079a574c124a39d$export$24baa2b76016ce0e(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$_reauthenticate(user, credential, bypassAuthState = false) {
    const { auth: auth } = user;
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await $c079a574c124a39d$var$_logoutIfInvalidated(user, $c079a574c124a39d$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        $c079a574c124a39d$export$24baa2b76016ce0e(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = $c079a574c124a39d$var$_parseToken(response.idToken);
        $c079a574c124a39d$export$24baa2b76016ce0e(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        $c079a574c124a39d$export$24baa2b76016ce0e(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return $c079a574c124a39d$var$UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) $c079a574c124a39d$export$28f7fcd39efa255(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$_signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await $c079a574c124a39d$var$_processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await $c079a574c124a39d$var$UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c079a574c124a39d$export$ce26c07117d59d6a(auth, credential) {
    return $c079a574c124a39d$var$_signInWithCredential($c079a574c124a39d$export$23ebac1979863676(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c079a574c124a39d$export$6559d589eb85fbb6(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $c079a574c124a39d$var$_assertLinkedStatus(false, userInternal, credential.providerId);
    return $c079a574c124a39d$var$_link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function $c079a574c124a39d$export$efca4cbe5dd06740(user, credential) {
    return $c079a574c124a39d$var$_reauthenticate((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$signInWithCustomToken$1(auth, request) {
    return $c079a574c124a39d$var$_performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function $c079a574c124a39d$export$a8550f7dbe79f93a(auth, customToken) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const response = await $c079a574c124a39d$var$signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await $c079a574c124a39d$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return $c079a574c124a39d$var$PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return $c079a574c124a39d$var$TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return $c079a574c124a39d$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class $c079a574c124a39d$var$PhoneMultiFactorInfoImpl extends $c079a574c124a39d$var$MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $c079a574c124a39d$var$PhoneMultiFactorInfoImpl(enrollment);
    }
}
class $c079a574c124a39d$var$TotpMultiFactorInfoImpl extends $c079a574c124a39d$var$MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new $c079a574c124a39d$var$TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$_setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    $c079a574c124a39d$export$24baa2b76016ce0e(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    $c079a574c124a39d$export$24baa2b76016ce0e(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    $c079a574c124a39d$export$24baa2b76016ce0e(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        $c079a574c124a39d$export$24baa2b76016ce0e(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        $c079a574c124a39d$export$24baa2b76016ce0e(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function $c079a574c124a39d$var$recachePasswordPolicy(auth) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c079a574c124a39d$export$2e2af4578d910ddf(auth, email, actionCodeSettings) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) $c079a574c124a39d$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await $c079a574c124a39d$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $c079a574c124a39d$var$sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function $c079a574c124a39d$export$a93c5207d687da10(auth, oobCode, newPassword) {
    await $c079a574c124a39d$var$resetPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode,
        newPassword: newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $c079a574c124a39d$var$recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $c079a574c124a39d$export$c3950d9923825c02(auth, oobCode) {
    await $c079a574c124a39d$var$applyActionCode$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), {
        oobCode: oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function $c079a574c124a39d$export$a9c996f45e5784d0(auth, oobCode) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const response = await $c079a574c124a39d$var$resetPassword(authModular, {
        oobCode: oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    $c079a574c124a39d$export$24baa2b76016ce0e(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            $c079a574c124a39d$export$24baa2b76016ce0e(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            $c079a574c124a39d$export$24baa2b76016ce0e(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            $c079a574c124a39d$export$24baa2b76016ce0e(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = $c079a574c124a39d$var$MultiFactorInfoImpl._fromServerResponse($c079a574c124a39d$export$23ebac1979863676(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo: multiFactorInfo
        },
        operation: operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function $c079a574c124a39d$export$7910e0436ed8d1de(auth, code) {
    const { data: data } = await $c079a574c124a39d$export$a9c996f45e5784d0((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function $c079a574c124a39d$export$555508cbc6add439(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const request = {
        returnSecureToken: true,
        email: email,
        password: password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = $c079a574c124a39d$var$handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , $c079a574c124a39d$var$signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $c079a574c124a39d$var$recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await $c079a574c124a39d$var$UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function $c079a574c124a39d$export$2219238a014317b0(auth, email, password) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    return $c079a574c124a39d$export$ce26c07117d59d6a((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), $c079a574c124a39d$export$71cec2538cb2c617.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) $c079a574c124a39d$var$recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c079a574c124a39d$export$4c3d22f3d993c33f(auth, email, actionCodeSettings) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email: email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        $c079a574c124a39d$export$24baa2b76016ce0e(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) $c079a574c124a39d$var$_setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await $c079a574c124a39d$var$handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , $c079a574c124a39d$var$sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function $c079a574c124a39d$export$f787f51d84a910ad(auth, emailLink) {
    const actionCodeUrl = $c079a574c124a39d$export$3b513254972cfc9c.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function $c079a574c124a39d$export$c9170ad7d4cd7e57(auth, email, emailLink) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const credential = $c079a574c124a39d$export$71cec2538cb2c617.credentialWithLink(email, emailLink || $c079a574c124a39d$var$_getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    $c079a574c124a39d$export$24baa2b76016ce0e(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return $c079a574c124a39d$export$ce26c07117d59d6a(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$createAuthUri(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function $c079a574c124a39d$export$ee7c8ad385a60b7b(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = $c079a574c124a39d$var$_isHttpOrHttps() ? $c079a574c124a39d$var$_getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri: continueUri
    };
    const { signinMethods: signinMethods } = await $c079a574c124a39d$var$createAuthUri((0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c079a574c124a39d$export$995eb9fca571757(user, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken: idToken
    };
    if (actionCodeSettings) $c079a574c124a39d$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $c079a574c124a39d$var$sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function $c079a574c124a39d$export$f38c853ae54ed474(user, newEmail, actionCodeSettings) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken: idToken,
        newEmail: newEmail
    };
    if (actionCodeSettings) $c079a574c124a39d$var$_setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email: email } = await $c079a574c124a39d$var$verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$var$updateProfile$1(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function $c079a574c124a39d$export$ab83b03e4111b1d0(user, { displayName: displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken: idToken,
        displayName: displayName,
        photoUrl: photoUrl,
        returnSecureToken: true
    };
    const response = await $c079a574c124a39d$var$_logoutIfInvalidated(userInternal, $c079a574c124a39d$var$updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId: providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function $c079a574c124a39d$export$1a82df3d29112e01(user, newEmail) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return $c079a574c124a39d$var$updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function $c079a574c124a39d$export$306ddfe3a8403e2(user, newPassword) {
    return $c079a574c124a39d$var$updateEmailOrPassword((0, $029952e65115eee5$export$4befe9b5fa509a1b)(user), null, newPassword);
}
async function $c079a574c124a39d$var$updateEmailOrPassword(user, email, password) {
    const { auth: auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken: idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await $c079a574c124a39d$var$_logoutIfInvalidated(user, $c079a574c124a39d$var$updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function $c079a574c124a39d$var$_fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId: providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = $c079a574c124a39d$var$_parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new $c079a574c124a39d$var$GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new $c079a574c124a39d$var$FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new $c079a574c124a39d$var$GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new $c079a574c124a39d$var$GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new $c079a574c124a39d$var$TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new $c079a574c124a39d$var$GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new $c079a574c124a39d$var$GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class $c079a574c124a39d$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class $c079a574c124a39d$var$FederatedAdditionalUserInfoWithUsername extends $c079a574c124a39d$var$GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class $c079a574c124a39d$var$FacebookAdditionalUserInfo extends $c079a574c124a39d$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class $c079a574c124a39d$var$GithubAdditionalUserInfo extends $c079a574c124a39d$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class $c079a574c124a39d$var$GoogleAdditionalUserInfo extends $c079a574c124a39d$var$GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class $c079a574c124a39d$var$TwitterAdditionalUserInfo extends $c079a574c124a39d$var$FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function $c079a574c124a39d$export$d24c54395ce0c509(userCredential) {
    const { user: user, _tokenResponse: _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return $c079a574c124a39d$var$_fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function $c079a574c124a39d$export$625550452a3fa3ec(auth, persistence) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c079a574c124a39d$export$90a7f3efeed30595(auth) {
    return $c079a574c124a39d$var$_initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function $c079a574c124a39d$export$efccba1c4a2ef57b(auth, password) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $c079a574c124a39d$export$d141bba7fdc215a3(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function $c079a574c124a39d$export$4a5767248b18ef41(auth, callback, onAbort) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function $c079a574c124a39d$export$df995fae86a55f06(auth, nextOrObserver, error, completed) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c079a574c124a39d$export$ef35774e6d314e91(auth) {
    (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function $c079a574c124a39d$export$e7094788287c5e9b(auth, user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function $c079a574c124a39d$export$96f57966bedc81b4(auth) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function $c079a574c124a39d$export$a9c23c6ac3fc3eca(auth, token) {
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function $c079a574c124a39d$export$2329c99376c9d0a4(user) {
    return (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new $c079a574c124a39d$var$MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new $c079a574c124a39d$var$MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return $c079a574c124a39d$var$MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return $c079a574c124a39d$var$MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = $c079a574c124a39d$export$23ebac1979863676(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>$c079a574c124a39d$var$MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        $c079a574c124a39d$export$24baa2b76016ce0e(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = $c079a574c124a39d$var$MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new $c079a574c124a39d$var$MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await $c079a574c124a39d$var$UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    $c079a574c124a39d$export$24baa2b76016ce0e(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return $c079a574c124a39d$var$UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    $c079a574c124a39d$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function $c079a574c124a39d$export$493d36ec626b6698(auth, error) {
    const authModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(auth);
    const errorInternal = error;
    $c079a574c124a39d$export$24baa2b76016ce0e(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    $c079a574c124a39d$export$24baa2b76016ce0e(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return $c079a574c124a39d$var$MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$startEnrollPhoneMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
function $c079a574c124a39d$var$finalizeEnrollPhoneMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
function $c079a574c124a39d$var$startEnrollTotpMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
function $c079a574c124a39d$var$finalizeEnrollTotpMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
function $c079a574c124a39d$var$withdrawMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
class $c079a574c124a39d$var$MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>$c079a574c124a39d$var$MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new $c079a574c124a39d$var$MultiFactorUserImpl(user);
    }
    async getSession() {
        return $c079a574c124a39d$var$MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await $c079a574c124a39d$var$_logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await $c079a574c124a39d$var$_logoutIfInvalidated(this.user, $c079a574c124a39d$var$withdrawMfa(this.user.auth, {
                idToken: idToken,
                mfaEnrollmentId: mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid: uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const $c079a574c124a39d$var$multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function $c079a574c124a39d$export$1fbe638ecf81657e(user) {
    const userModular = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if (!$c079a574c124a39d$var$multiFactorUserCache.has(userModular)) $c079a574c124a39d$var$multiFactorUserCache.set(userModular, $c079a574c124a39d$var$MultiFactorUserImpl._fromUser(userModular));
    return $c079a574c124a39d$var$multiFactorUserCache.get(userModular);
}
const $c079a574c124a39d$var$STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class $c079a574c124a39d$var$BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem($c079a574c124a39d$var$STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem($c079a574c124a39d$var$STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const $c079a574c124a39d$var$_POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const $c079a574c124a39d$var$IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class $c079a574c124a39d$var$BrowserLocalPersistence extends $c079a574c124a39d$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = $c079a574c124a39d$var$_isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if ($c079a574c124a39d$var$_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, $c079a574c124a39d$var$IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key: key,
                    oldValue: oldValue,
                    newValue: newValue
                }), /* poll */ true);
            });
        }, $c079a574c124a39d$var$_POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
$c079a574c124a39d$var$BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const $c079a574c124a39d$export$8b22cf2602fb60ce = $c079a574c124a39d$var$BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function $c079a574c124a39d$var$getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function $c079a574c124a39d$var$getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class $c079a574c124a39d$var$CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = $c079a574c124a39d$var$getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return $c079a574c124a39d$var$getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = $c079a574c124a39d$var$getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = $c079a574c124a39d$var$getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = $c079a574c124a39d$var$getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = $c079a574c124a39d$var$getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, $c079a574c124a39d$var$POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
$c079a574c124a39d$var$CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const $c079a574c124a39d$export$407448d2b89b1813 = $c079a574c124a39d$var$CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$BrowserSessionPersistence extends $c079a574c124a39d$var$BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
$c079a574c124a39d$var$BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const $c079a574c124a39d$export$db3b6bfb95261072 = $c079a574c124a39d$var$BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function $c079a574c124a39d$var$_allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value: value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason: reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class $c079a574c124a39d$var$Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new $c079a574c124a39d$var$Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId: eventId, eventType: eventType, data: data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId: eventId,
            eventType: eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await $c079a574c124a39d$var$_allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId: eventId,
            eventType: eventType,
            response: response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
$c079a574c124a39d$var$Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$export$c03999cb2f36933f(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class $c079a574c124a39d$var$Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = $c079a574c124a39d$export$c03999cb2f36933f('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel: messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType: eventType,
                eventId: eventId,
                data: data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function $c079a574c124a39d$var$_window() {
    return window;
}
function $c079a574c124a39d$var$_setWindowLocation(url) {
    $c079a574c124a39d$var$_window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$_isWorker() {
    return typeof $c079a574c124a39d$var$_window()['WorkerGlobalScope'] !== 'undefined' && typeof $c079a574c124a39d$var$_window()['importScripts'] === 'function';
}
async function $c079a574c124a39d$var$_getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function $c079a574c124a39d$var$_getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function $c079a574c124a39d$var$_getWorkerGlobalScope() {
    return $c079a574c124a39d$var$_isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$DB_NAME = 'firebaseLocalStorageDb';
const $c079a574c124a39d$var$DB_VERSION = 1;
const $c079a574c124a39d$var$DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const $c079a574c124a39d$var$DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class $c079a574c124a39d$var$DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function $c079a574c124a39d$var$getObjectStore(db, isReadWrite) {
    return db.transaction([
        $c079a574c124a39d$var$DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore($c079a574c124a39d$var$DB_OBJECTSTORE_NAME);
}
function $c079a574c124a39d$var$_deleteDatabase() {
    const request = indexedDB.deleteDatabase($c079a574c124a39d$var$DB_NAME);
    return new $c079a574c124a39d$var$DBPromise(request).toPromise();
}
function $c079a574c124a39d$var$_openDatabase() {
    const request = indexedDB.open($c079a574c124a39d$var$DB_NAME, $c079a574c124a39d$var$DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore($c079a574c124a39d$var$DB_OBJECTSTORE_NAME, {
                    keyPath: $c079a574c124a39d$var$DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains($c079a574c124a39d$var$DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await $c079a574c124a39d$var$_deleteDatabase();
                resolve(await $c079a574c124a39d$var$_openDatabase());
            } else resolve(db);
        });
    });
}
async function $c079a574c124a39d$var$_putObject(db, key, value) {
    const request = $c079a574c124a39d$var$getObjectStore(db, true).put({
        [$c079a574c124a39d$var$DB_DATA_KEYPATH]: key,
        value: value
    });
    return new $c079a574c124a39d$var$DBPromise(request).toPromise();
}
async function $c079a574c124a39d$var$getObject(db, key) {
    const request = $c079a574c124a39d$var$getObjectStore(db, false).get(key);
    const data = await new $c079a574c124a39d$var$DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function $c079a574c124a39d$var$_deleteObject(db, key) {
    const request = $c079a574c124a39d$var$getObjectStore(db, true).delete(key);
    return new $c079a574c124a39d$var$DBPromise(request).toPromise();
}
const $c079a574c124a39d$var$_POLLING_INTERVAL_MS = 800;
const $c079a574c124a39d$var$_TRANSACTION_RETRY_COUNT = 3;
class $c079a574c124a39d$var$IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this.dbPromise = null;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.dbPromise) return this.dbPromise;
        this.dbPromise = $c079a574c124a39d$var$_openDatabase();
        this.dbPromise.catch(()=>{
            this.dbPromise = null;
        });
        return this.dbPromise;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > $c079a574c124a39d$var$_TRANSACTION_RETRY_COUNT) throw e;
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = null;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return $c079a574c124a39d$var$_isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = $c079a574c124a39d$var$Receiver._getInstance($c079a574c124a39d$var$_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await $c079a574c124a39d$var$_getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new $c079a574c124a39d$var$Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || $c079a574c124a39d$var$_getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key: key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            await this._withRetries(async (db)=>{
                await $c079a574c124a39d$var$_putObject(db, $c079a574c124a39d$var$STORAGE_AVAILABLE_KEY, '1');
                await $c079a574c124a39d$var$_deleteObject(db, $c079a574c124a39d$var$STORAGE_AVAILABLE_KEY);
            });
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$c079a574c124a39d$var$_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>$c079a574c124a39d$var$getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>$c079a574c124a39d$var$_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = $c079a574c124a39d$var$getObjectStore(db, false).getAll();
            return new $c079a574c124a39d$var$DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value: value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), $c079a574c124a39d$var$_POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
$c079a574c124a39d$var$IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const $c079a574c124a39d$export$23f2a1d2818174ef = $c079a574c124a39d$var$IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$startSignInPhoneMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
function $c079a574c124a39d$var$finalizeSignInPhoneMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
function $c079a574c124a39d$var$finalizeSignInTotpMfa(auth, request) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , $c079a574c124a39d$var$_addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const $c079a574c124a39d$var$_JSLOAD_CALLBACK = $c079a574c124a39d$var$_generateCallbackName('rcb');
const $c079a574c124a39d$var$NETWORK_TIMEOUT_DELAY = new $c079a574c124a39d$var$Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class $c079a574c124a39d$var$ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!$c079a574c124a39d$var$_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        $c079a574c124a39d$export$24baa2b76016ce0e($c079a574c124a39d$var$isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && $c079a574c124a39d$var$isV2($c079a574c124a39d$var$_window().grecaptcha)) return Promise.resolve($c079a574c124a39d$var$_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = $c079a574c124a39d$var$_window().setTimeout(()=>{
                reject($c079a574c124a39d$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, $c079a574c124a39d$var$NETWORK_TIMEOUT_DELAY.get());
            $c079a574c124a39d$var$_window()[$c079a574c124a39d$var$_JSLOAD_CALLBACK] = ()=>{
                $c079a574c124a39d$var$_window().clearTimeout(networkTimeout);
                delete $c079a574c124a39d$var$_window()[$c079a574c124a39d$var$_JSLOAD_CALLBACK];
                const recaptcha = $c079a574c124a39d$var$_window().grecaptcha;
                if (!recaptcha || !$c079a574c124a39d$var$isV2(recaptcha)) {
                    reject($c079a574c124a39d$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${$c079a574c124a39d$var$_recaptchaV2ScriptUrl()}?${(0, $029952e65115eee5$export$ac4103b836844853)({
                onload: $c079a574c124a39d$var$_JSLOAD_CALLBACK,
                render: 'explicit',
                hl: hl
            })}`;
            $c079a574c124a39d$var$_loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject($c079a574c124a39d$export$890c4ad488842ce7(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!$c079a574c124a39d$var$_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function $c079a574c124a39d$var$isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class $c079a574c124a39d$var$MockReCaptchaLoaderImpl {
    async load(auth) {
        return new $c079a574c124a39d$var$MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const $c079a574c124a39d$var$DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class $c079a574c124a39d$export$db202ddc8be9136 {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...$c079a574c124a39d$var$DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = $c079a574c124a39d$var$RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = $c079a574c124a39d$export$23ebac1979863676(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        $c079a574c124a39d$export$24baa2b76016ce0e(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new $c079a574c124a39d$var$MockReCaptchaLoaderImpl() : new $c079a574c124a39d$var$ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        $c079a574c124a39d$export$24baa2b76016ce0e(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c079a574c124a39d$export$24baa2b76016ce0e(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = $c079a574c124a39d$var$_window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        $c079a574c124a39d$export$24baa2b76016ce0e(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        $c079a574c124a39d$export$24baa2b76016ce0e($c079a574c124a39d$var$_isHttpOrHttps() && !$c079a574c124a39d$var$_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await $c079a574c124a39d$var$domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await $c079a574c124a39d$var$getRecaptchaParams(this.auth);
        $c079a574c124a39d$export$24baa2b76016ce0e(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        $c079a574c124a39d$export$24baa2b76016ce0e(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function $c079a574c124a39d$var$domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = $c079a574c124a39d$export$3a6d5c9ae78a2c08._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c079a574c124a39d$export$2408f22a0fab9ae5(auth, phoneNumber, appVerifier) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const verificationId = await $c079a574c124a39d$var$_verifyPhoneNumber(authInternal, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $c079a574c124a39d$var$ConfirmationResultImpl(verificationId, (cred)=>$c079a574c124a39d$export$ce26c07117d59d6a(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c079a574c124a39d$export$882b5998b3b9117c(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    await $c079a574c124a39d$var$_assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await $c079a574c124a39d$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $c079a574c124a39d$var$ConfirmationResultImpl(verificationId, (cred)=>$c079a574c124a39d$export$6559d589eb85fbb6(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function $c079a574c124a39d$export$43caf9889c228507(user, phoneNumber, appVerifier) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await $c079a574c124a39d$var$_verifyPhoneNumber(userInternal.auth, phoneNumber, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(appVerifier));
    return new $c079a574c124a39d$var$ConfirmationResultImpl(verificationId, (cred)=>$c079a574c124a39d$export$efca4cbe5dd06740(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function $c079a574c124a39d$var$_verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await $c079a574c124a39d$var$_initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                $c079a574c124a39d$export$24baa2b76016ce0e(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === $c079a574c124a39d$var$FAKE_TOKEN) {
                        $c079a574c124a39d$export$24baa2b76016ce0e(verifier?.type === $c079a574c124a39d$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $c079a574c124a39d$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $c079a574c124a39d$var$startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $c079a574c124a39d$var$startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = $c079a574c124a39d$var$handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                $c079a574c124a39d$export$24baa2b76016ce0e(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                $c079a574c124a39d$export$24baa2b76016ce0e(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId: mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === $c079a574c124a39d$var$FAKE_TOKEN) {
                        $c079a574c124a39d$export$24baa2b76016ce0e(verifier?.type === $c079a574c124a39d$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await $c079a574c124a39d$var$injectRecaptchaV2Token(authInstance, request, verifier);
                        return $c079a574c124a39d$var$startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return $c079a574c124a39d$var$startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = $c079a574c124a39d$var$handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === $c079a574c124a39d$var$FAKE_TOKEN) {
                    $c079a574c124a39d$export$24baa2b76016ce0e(verifier?.type === $c079a574c124a39d$var$RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await $c079a574c124a39d$var$injectRecaptchaV2Token(authInstance, request, verifier);
                    return $c079a574c124a39d$var$sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return $c079a574c124a39d$var$sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = $c079a574c124a39d$var$handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function $c079a574c124a39d$export$3b14a55fb2447963(user, credential) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await $c079a574c124a39d$var$_link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function $c079a574c124a39d$var$injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    $c079a574c124a39d$export$24baa2b76016ce0e(recaptchaV2Verifier.type === $c079a574c124a39d$var$RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    $c079a574c124a39d$export$24baa2b76016ce0e(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber: phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse: captchaResponse,
                clientType: clientType,
                recaptchaVersion: recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class $c079a574c124a39d$export$56c0d5a1e737357d {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = $c079a574c124a39d$export$56c0d5a1e737357d.PROVIDER_ID;
        this.auth = $c079a574c124a39d$export$23ebac1979863676(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return $c079a574c124a39d$var$_verifyPhoneNumber(this.auth, phoneOptions, (0, $029952e65115eee5$export$4befe9b5fa509a1b)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return $c079a574c124a39d$export$3a6d5c9ae78a2c08._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return $c079a574c124a39d$export$56c0d5a1e737357d.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return $c079a574c124a39d$export$56c0d5a1e737357d.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber: phoneNumber, temporaryProof: temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return $c079a574c124a39d$export$3a6d5c9ae78a2c08._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ $c079a574c124a39d$export$56c0d5a1e737357d.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ $c079a574c124a39d$export$56c0d5a1e737357d.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function $c079a574c124a39d$var$_withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return $c079a574c124a39d$export$cf2f7c5792f80b46(resolverOverride);
    $c079a574c124a39d$export$24baa2b76016ce0e(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$IdpCredential extends $c079a574c124a39d$export$3a1a48c8f6ef640e {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return $c079a574c124a39d$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return $c079a574c124a39d$var$signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return $c079a574c124a39d$var$signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function $c079a574c124a39d$var$_signIn(params) {
    return $c079a574c124a39d$var$_signInWithCredential(params.auth, new $c079a574c124a39d$var$IdpCredential(params), params.bypassAuthState);
}
function $c079a574c124a39d$var$_reauth(params) {
    const { auth: auth, user: user } = params;
    $c079a574c124a39d$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $c079a574c124a39d$var$_reauthenticate(user, new $c079a574c124a39d$var$IdpCredential(params), params.bypassAuthState);
}
async function $c079a574c124a39d$var$_link(params) {
    const { auth: auth, user: user } = params;
    $c079a574c124a39d$export$24baa2b76016ce0e(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return $c079a574c124a39d$var$_link$1(user, new $c079a574c124a39d$var$IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class $c079a574c124a39d$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve: resolve,
                reject: reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse: urlResponse, sessionId: sessionId, postBody: postBody, tenantId: tenantId, error: error, type: type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return $c079a574c124a39d$var$_signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return $c079a574c124a39d$var$_link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return $c079a574c124a39d$var$_reauth;
            default:
                $c079a574c124a39d$export$28f7fcd39efa255(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        $c079a574c124a39d$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        $c079a574c124a39d$export$d66dc83d8cfc8dd(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$_POLL_WINDOW_CLOSE_TIMEOUT = new $c079a574c124a39d$var$Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c079a574c124a39d$export$4368d992c4eafac0(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$export$890c4ad488842ce7(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    $c079a574c124a39d$var$_assertInstanceOf(auth, provider, $c079a574c124a39d$var$FederatedAuthProvider);
    const resolverInternal = $c079a574c124a39d$var$_withDefaultResolver(authInternal, resolver);
    const action = new $c079a574c124a39d$var$PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c079a574c124a39d$export$2d1720544b23b823(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($c079a574c124a39d$export$890c4ad488842ce7(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    $c079a574c124a39d$var$_assertInstanceOf(userInternal.auth, provider, $c079a574c124a39d$var$FederatedAuthProvider);
    const resolverInternal = $c079a574c124a39d$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $c079a574c124a39d$var$PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c079a574c124a39d$export$f1e1789686576879(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $c079a574c124a39d$var$_assertInstanceOf(userInternal.auth, provider, $c079a574c124a39d$var$FederatedAuthProvider);
    const resolverInternal = $c079a574c124a39d$var$_withDefaultResolver(userInternal.auth, resolver);
    const action = new $c079a574c124a39d$var$PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class $c079a574c124a39d$var$PopupOperation extends $c079a574c124a39d$var$AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if ($c079a574c124a39d$var$PopupOperation.currentPopupAction) $c079a574c124a39d$var$PopupOperation.currentPopupAction.cancel();
        $c079a574c124a39d$var$PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        $c079a574c124a39d$export$24baa2b76016ce0e(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        $c079a574c124a39d$export$d66dc83d8cfc8dd(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = $c079a574c124a39d$export$c03999cb2f36933f();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject($c079a574c124a39d$export$890c4ad488842ce7(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject($c079a574c124a39d$export$890c4ad488842ce7(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        $c079a574c124a39d$var$PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject($c079a574c124a39d$export$890c4ad488842ce7(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, $c079a574c124a39d$var$_POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
$c079a574c124a39d$var$PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const $c079a574c124a39d$var$redirectOutcomeMap = new Map();
class $c079a574c124a39d$var$RedirectAction extends $c079a574c124a39d$var$AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = $c079a574c124a39d$var$redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await $c079a574c124a39d$var$_getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            $c079a574c124a39d$var$redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) $c079a574c124a39d$var$redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function $c079a574c124a39d$var$_getAndClearPendingRedirectStatus(resolver, auth) {
    const key = $c079a574c124a39d$var$pendingRedirectKey(auth);
    const persistence = $c079a574c124a39d$var$resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function $c079a574c124a39d$var$_setPendingRedirectStatus(resolver, auth) {
    return $c079a574c124a39d$var$resolverPersistence(resolver)._set($c079a574c124a39d$var$pendingRedirectKey(auth), 'true');
}
function $c079a574c124a39d$export$a05254e7c3aeba6e() {
    $c079a574c124a39d$var$redirectOutcomeMap.clear();
}
function $c079a574c124a39d$export$b9a6b53f9be3734(auth, result) {
    $c079a574c124a39d$var$redirectOutcomeMap.set(auth._key(), result);
}
function $c079a574c124a39d$var$resolverPersistence(resolver) {
    return $c079a574c124a39d$export$cf2f7c5792f80b46(resolver._redirectPersistence);
}
function $c079a574c124a39d$var$pendingRedirectKey(auth) {
    return $c079a574c124a39d$export$53a70dd1ebbae346($c079a574c124a39d$var$PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c079a574c124a39d$export$39b482c5e57630a8(auth, provider, resolver) {
    return $c079a574c124a39d$var$_signInWithRedirect(auth, provider, resolver);
}
async function $c079a574c124a39d$var$_signInWithRedirect(auth, provider, resolver) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    $c079a574c124a39d$var$_assertInstanceOf(auth, provider, $c079a574c124a39d$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = $c079a574c124a39d$var$_withDefaultResolver(authInternal, resolver);
    await $c079a574c124a39d$var$_setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c079a574c124a39d$export$35e795649ee09318(user, provider, resolver) {
    return $c079a574c124a39d$var$_reauthenticateWithRedirect(user, provider, resolver);
}
async function $c079a574c124a39d$var$_reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $c079a574c124a39d$var$_assertInstanceOf(userInternal.auth, provider, $c079a574c124a39d$var$FederatedAuthProvider);
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(userInternal.auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $c079a574c124a39d$var$_withDefaultResolver(userInternal.auth, resolver);
    await $c079a574c124a39d$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $c079a574c124a39d$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function $c079a574c124a39d$export$dda1d9f60106f0e9(user, provider, resolver) {
    return $c079a574c124a39d$var$_linkWithRedirect(user, provider, resolver);
}
async function $c079a574c124a39d$var$_linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(user);
    $c079a574c124a39d$var$_assertInstanceOf(userInternal.auth, provider, $c079a574c124a39d$var$FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = $c079a574c124a39d$var$_withDefaultResolver(userInternal.auth, resolver);
    await $c079a574c124a39d$var$_assertLinkedStatus(false, userInternal, provider.providerId);
    await $c079a574c124a39d$var$_setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await $c079a574c124a39d$var$prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function $c079a574c124a39d$export$342063e11d6c3cad(auth, resolver) {
    await $c079a574c124a39d$export$23ebac1979863676(auth)._initializationPromise;
    return $c079a574c124a39d$export$a33b77bbdbb8366c(auth, resolver, false);
}
async function $c079a574c124a39d$export$a33b77bbdbb8366c(auth, resolverExtern, bypassAuthState = false) {
    if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(auth.app)) return Promise.reject($c079a574c124a39d$var$_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = $c079a574c124a39d$export$23ebac1979863676(auth);
    const resolver = $c079a574c124a39d$var$_withDefaultResolver(authInternal, resolverExtern);
    const action = new $c079a574c124a39d$var$RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function $c079a574c124a39d$var$prepareUserForRedirect(user) {
    const eventId = $c079a574c124a39d$export$c03999cb2f36933f(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const $c079a574c124a39d$var$EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class $c079a574c124a39d$export$158acd800e1ef08b {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !$c079a574c124a39d$var$isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !$c079a574c124a39d$var$isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError($c079a574c124a39d$export$890c4ad488842ce7(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= $c079a574c124a39d$var$EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has($c079a574c124a39d$var$eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add($c079a574c124a39d$var$eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function $c079a574c124a39d$var$eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function $c079a574c124a39d$var$isNullRedirectEvent({ type: type, error: error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function $c079a574c124a39d$var$isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return $c079a574c124a39d$var$isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function $c079a574c124a39d$export$91c6e00c14e7e6fd(auth, request = {}) {
    return $c079a574c124a39d$var$_performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const $c079a574c124a39d$var$HTTP_REGEX = /^https?/;
async function $c079a574c124a39d$var$_validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains: authorizedDomains } = await $c079a574c124a39d$export$91c6e00c14e7e6fd(auth);
    for (const domain of authorizedDomains)try {
        if ($c079a574c124a39d$var$matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    $c079a574c124a39d$export$28f7fcd39efa255(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function $c079a574c124a39d$var$matchDomain(expected) {
    const currentUrl = $c079a574c124a39d$var$_getCurrentUrl();
    const { protocol: protocol, hostname: hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!$c079a574c124a39d$var$HTTP_REGEX.test(protocol)) return false;
    if ($c079a574c124a39d$var$IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$NETWORK_TIMEOUT = new $c079a574c124a39d$var$Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function $c079a574c124a39d$var$resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = $c079a574c124a39d$var$_window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function $c079a574c124a39d$var$loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            $c079a574c124a39d$var$resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    $c079a574c124a39d$var$resetUnloadedGapiModules();
                    reject($c079a574c124a39d$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: $c079a574c124a39d$var$NETWORK_TIMEOUT.get()
            });
        }
        if ($c079a574c124a39d$var$_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!$c079a574c124a39d$var$_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = $c079a574c124a39d$var$_generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            $c079a574c124a39d$var$_window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject($c079a574c124a39d$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return $c079a574c124a39d$var$_loadJS(`${$c079a574c124a39d$var$_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        $c079a574c124a39d$var$cachedGApiLoader = null;
        throw error;
    });
}
let $c079a574c124a39d$var$cachedGApiLoader = null;
function $c079a574c124a39d$var$_loadGapi(auth) {
    $c079a574c124a39d$var$cachedGApiLoader = $c079a574c124a39d$var$cachedGApiLoader || $c079a574c124a39d$var$loadGapi(auth);
    return $c079a574c124a39d$var$cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$PING_TIMEOUT = new $c079a574c124a39d$var$Delay(5000, 15000);
const $c079a574c124a39d$var$IFRAME_PATH = '__/auth/iframe';
const $c079a574c124a39d$var$EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const $c079a574c124a39d$var$IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const $c079a574c124a39d$var$EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function $c079a574c124a39d$var$getIframeUrl(auth) {
    const config = auth.config;
    $c079a574c124a39d$export$24baa2b76016ce0e(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? $c079a574c124a39d$var$_emulatorUrl(config, $c079a574c124a39d$var$EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${$c079a574c124a39d$var$IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c)
    };
    const eid = $c079a574c124a39d$var$EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, $029952e65115eee5$export$ac4103b836844853)(params).slice(1)}`;
}
async function $c079a574c124a39d$var$_openIframe(auth) {
    const context = await $c079a574c124a39d$var$_loadGapi(auth);
    const gapi1 = $c079a574c124a39d$var$_window().gapi;
    $c079a574c124a39d$export$24baa2b76016ce0e(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: $c079a574c124a39d$var$getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: $c079a574c124a39d$var$IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = $c079a574c124a39d$export$890c4ad488842ce7(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = $c079a574c124a39d$var$_window().setTimeout(()=>{
                reject(networkError);
            }, $c079a574c124a39d$var$PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                $c079a574c124a39d$var$_window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const $c079a574c124a39d$var$DEFAULT_WIDTH = 500;
const $c079a574c124a39d$var$DEFAULT_HEIGHT = 600;
const $c079a574c124a39d$var$TARGET_BLANK = '_blank';
const $c079a574c124a39d$var$FIREFOX_EMPTY_URL = 'http://localhost';
class $c079a574c124a39d$export$2ed0fc6709e59212 {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function $c079a574c124a39d$var$_open(auth, url, name, width = $c079a574c124a39d$var$DEFAULT_WIDTH, height = $c079a574c124a39d$var$DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...$c079a574c124a39d$var$BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top: top,
        left: left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, $029952e65115eee5$export$c36915b22ce77c19)().toLowerCase();
    if (name) target = $c079a574c124a39d$var$_isChromeIOS(ua) ? $c079a574c124a39d$var$TARGET_BLANK : name;
    if ($c079a574c124a39d$var$_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || $c079a574c124a39d$var$FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if ($c079a574c124a39d$var$_isIOSStandalone(ua) && target !== '_self') {
        $c079a574c124a39d$var$openAsNewWindowIOS(url || '', target);
        return new $c079a574c124a39d$export$2ed0fc6709e59212(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    $c079a574c124a39d$export$24baa2b76016ce0e(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new $c079a574c124a39d$export$2ed0fc6709e59212(newWin);
}
function $c079a574c124a39d$var$openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const $c079a574c124a39d$var$WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const $c079a574c124a39d$var$EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const $c079a574c124a39d$var$FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function $c079a574c124a39d$export$3d12bd131bb975d1(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    $c079a574c124a39d$export$24baa2b76016ce0e(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    $c079a574c124a39d$export$24baa2b76016ce0e(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType: authType,
        redirectUrl: redirectUrl,
        v: (0, $5e587d655f0a08bb$export$31499a9cd224b78c),
        eventId: eventId
    };
    if (provider instanceof $c079a574c124a39d$var$FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, $029952e65115eee5$export$dd1bc94b04021eeb)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof $c079a574c124a39d$var$BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${$c079a574c124a39d$var$FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${$c079a574c124a39d$var$getHandlerBase(auth)}?${(0, $029952e65115eee5$export$ac4103b836844853)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function $c079a574c124a39d$var$getHandlerBase({ config: config }) {
    if (!config.emulator) return `https://${config.authDomain}/${$c079a574c124a39d$var$WIDGET_PATH}`;
    return $c079a574c124a39d$var$_emulatorUrl(config, $c079a574c124a39d$var$EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const $c079a574c124a39d$var$WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class $c079a574c124a39d$var$BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = $c079a574c124a39d$export$db3b6bfb95261072;
        this._completeRedirectFn = $c079a574c124a39d$export$a33b77bbdbb8366c;
        this._overrideRedirectResult = $c079a574c124a39d$export$b9a6b53f9be3734;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        $c079a574c124a39d$export$d66dc83d8cfc8dd(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await $c079a574c124a39d$export$3d12bd131bb975d1(auth, provider, authType, $c079a574c124a39d$var$_getCurrentUrl(), eventId);
        return $c079a574c124a39d$var$_open(auth, url, $c079a574c124a39d$export$c03999cb2f36933f());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await $c079a574c124a39d$export$3d12bd131bb975d1(auth, provider, authType, $c079a574c124a39d$var$_getCurrentUrl(), eventId);
        $c079a574c124a39d$var$_setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager: manager, promise: promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                $c079a574c124a39d$export$d66dc83d8cfc8dd(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise: promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await $c079a574c124a39d$var$_openIframe(auth);
        const manager = new $c079a574c124a39d$export$158acd800e1ef08b(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            $c079a574c124a39d$export$24baa2b76016ce0e(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager: manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send($c079a574c124a39d$var$WEB_STORAGE_SUPPORT_KEY, {
            type: $c079a574c124a39d$var$WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[$c079a574c124a39d$var$WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            $c079a574c124a39d$export$28f7fcd39efa255(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = $c079a574c124a39d$var$_validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return $c079a574c124a39d$var$_isMobileBrowser() || $c079a574c124a39d$var$_isSafari() || $c079a574c124a39d$export$92108d983e8ee699();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const $c079a574c124a39d$export$953cecd6e717a553 = $c079a574c124a39d$var$BrowserPopupRedirectResolver;
class $c079a574c124a39d$var$MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return $c079a574c124a39d$var$debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class $c079a574c124a39d$var$PhoneMultiFactorAssertionImpl extends $c079a574c124a39d$var$MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new $c079a574c124a39d$var$PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return $c079a574c124a39d$var$finalizeEnrollPhoneMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return $c079a574c124a39d$var$finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class $c079a574c124a39d$export$7ccc53e8f1e7dfc5 {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return $c079a574c124a39d$var$PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ $c079a574c124a39d$export$7ccc53e8f1e7dfc5.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class $c079a574c124a39d$export$971d5caa766a69d7 {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return $c079a574c124a39d$var$TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return $c079a574c124a39d$var$TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await $c079a574c124a39d$var$startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return $c079a574c124a39d$export$ae1af26003f05816._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ $c079a574c124a39d$export$971d5caa766a69d7.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class $c079a574c124a39d$var$TotpMultiFactorAssertionImpl extends $c079a574c124a39d$var$MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new $c079a574c124a39d$var$TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new $c079a574c124a39d$var$TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        $c079a574c124a39d$export$24baa2b76016ce0e(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return $c079a574c124a39d$var$finalizeEnrollTotpMfa(auth, {
            idToken: idToken,
            displayName: displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        $c079a574c124a39d$export$24baa2b76016ce0e(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return $c079a574c124a39d$var$finalizeSignInTotpMfa(auth, {
            mfaPendingCredential: mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo: totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class $c079a574c124a39d$export$ae1af26003f05816 {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new $c079a574c124a39d$export$ae1af26003f05816(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if ($c079a574c124a39d$var$_isEmptyString(accountName) || $c079a574c124a39d$var$_isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if ($c079a574c124a39d$var$_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if ($c079a574c124a39d$var$_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function $c079a574c124a39d$var$_isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var $c079a574c124a39d$var$name = "@firebase/auth";
var $c079a574c124a39d$var$version = "1.13.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c079a574c124a39d$var$AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken: accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        $c079a574c124a39d$export$24baa2b76016ce0e(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c079a574c124a39d$var$getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function $c079a574c124a39d$var$registerAuth(clientPlatform) {
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey: apiKey, authDomain: authDomain } = app.options;
        $c079a574c124a39d$export$24baa2b76016ce0e(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey: apiKey,
            authDomain: authDomain,
            clientPlatform: clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: $c079a574c124a39d$export$faec65b429be379(clientPlatform)
        };
        const authInstance = new $c079a574c124a39d$export$9f4f30ee63539e24(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        $c079a574c124a39d$var$_initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = $c079a574c124a39d$export$23ebac1979863676(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new $c079a574c124a39d$var$AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($c079a574c124a39d$var$name, $c079a574c124a39d$var$version, $c079a574c124a39d$var$getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($c079a574c124a39d$var$name, $c079a574c124a39d$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c079a574c124a39d$var$DEFAULT_ID_TOKEN_MAX_AGE = 300;
const $c079a574c124a39d$var$authIdTokenMaxAge = (0, $029952e65115eee5$export$5539a1a3afe87d6)('authIdTokenMaxAge') || $c079a574c124a39d$var$DEFAULT_ID_TOKEN_MAX_AGE;
let $c079a574c124a39d$var$lastPostedIdToken = null;
const $c079a574c124a39d$var$mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > $c079a574c124a39d$var$authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if ($c079a574c124a39d$var$lastPostedIdToken === idToken) return;
        $c079a574c124a39d$var$lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function $c079a574c124a39d$export$ffb5f4729a158638(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)()) {
    const provider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = $c079a574c124a39d$export$3466f893ebf79586(app, {
        popupRedirectResolver: $c079a574c124a39d$export$953cecd6e717a553,
        persistence: [
            $c079a574c124a39d$export$23f2a1d2818174ef,
            $c079a574c124a39d$export$8b22cf2602fb60ce,
            $c079a574c124a39d$export$db3b6bfb95261072
        ]
    });
    const authTokenSyncPath = (0, $029952e65115eee5$export$5539a1a3afe87d6)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = $c079a574c124a39d$var$mintCookieFactory(authTokenSyncUrl.toString());
            $c079a574c124a39d$export$4a5767248b18ef41(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            $c079a574c124a39d$export$d141bba7fdc215a3(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, $029952e65115eee5$export$9c11895284c8adad)('auth');
    if (authEmulatorHost) $c079a574c124a39d$export$61196ced6d74a310(auth, `http://${authEmulatorHost}`);
    return auth;
}
function $c079a574c124a39d$var$getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
$c079a574c124a39d$var$_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = $c079a574c124a39d$export$890c4ad488842ce7("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            $c079a574c124a39d$var$getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
$c079a574c124a39d$var$registerAuth("Browser" /* ClientPlatform.BROWSER */ );














var $906344b47e605252$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $906344b47e605252$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $906344b47e605252$export$70ffa26850098d01;
var $906344b47e605252$export$9f5a3dfc7a9f5dd;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        const f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        let g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        const c = a - this.blockSize, f = this.C;
        let e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(let f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        const c = [];
        let f = !0;
        for(let e = d.length - 1; e >= 0; e--){
            const g = d[e] | 0;
            f && g == a || (c[e] = g, f = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        const a = [];
        let c = 1;
        for(let f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        const c = v(Math.pow(a, 8));
        let f = w;
        for(let g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            const b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        let d = 0, a = 1;
        for(let c = 0; c < this.g.length; c++){
            const f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        const a = v(Math.pow(d, 6));
        var c = this;
        let f = "";
        for(;;){
            const e = D(c, a).g;
            c = F(c, e.j(a));
            let g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return !1;
        for(let a = 0; a < d.g.length; a++)if (d.g[a] != 0) return !1;
        return !0;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        const a = d.g.length, c = [];
        for(let f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        let f = 0;
        for(let e = 0; e <= a; e++){
            let g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        const a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(let e = 0; e < d.g.length; e++){
            const g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        const a = d.g.length + 1, c = [];
        for(let f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        const c = a >> 5;
        a %= 32;
        const f = d.g.length - c, e = [];
        for(let g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    $906344b47e605252$export$9f5a3dfc7a9f5dd = $906344b47e605252$export$2e2bcd8739ae039.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    $906344b47e605252$export$70ffa26850098d01 = $906344b47e605252$export$2e2bcd8739ae039.Integer = t;
}).apply(typeof $906344b47e605252$var$commonjsGlobal !== 'undefined' ? $906344b47e605252$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});



var $33cb313d667e3306$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
var $33cb313d667e3306$export$2e2bcd8739ae039 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var $33cb313d667e3306$export$26404658cda3ee02;
var $33cb313d667e3306$export$ddb1030448106742;
var $33cb313d667e3306$export$aa726fb96ad3e039;
var $33cb313d667e3306$export$3d7865934588d77e;
var $33cb313d667e3306$export$d4e71bc0b80dc0fb;
var $33cb313d667e3306$export$cbbc350c1dfc80cb;
var $33cb313d667e3306$export$d61e24a684f9e51;
var $33cb313d667e3306$export$888d0d9ab79d08fc;
var $33cb313d667e3306$export$66869136fc133c3a;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof $33cb313d667e3306$var$commonjsGlobal && $33cb313d667e3306$var$commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a;
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? (a)=>a && AsyncContext.Snapshot.wrap(a) : (a)=>a;
    function ja(a) {
        const b = a.length;
        if (b > 0) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(let d = 1; d < arguments.length; d++){
            const e = arguments[d];
            var c = typeof e;
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                const f = e.length || 0;
                a.length = c + f;
                for(let g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    class la {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function ma(a) {
        l.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class pa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = qa.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var qa = new la(()=>new ra, (a)=>a.reset());
    class ra {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let u, v = !1, oa = new pa, ta = ()=>{
        const a = Promise.resolve(void 0);
        u = ()=>{
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = !1;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = !1;
    w.prototype.dispose = function() {
        this.u || (this.u = !0, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    x.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        const c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        const a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = !1;
    }
    function xa(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        const f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        const g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = !1)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        const c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(let e = 0; e < a.length; ++e){
            const f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (d && d.once) return La(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !1, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        const g = n(e) ? !!e.capture : !!e;
        let k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Ra;
        return a;
    }
    function La(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)La(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !0, d, e);
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = !0;
        else {
            b = new z(b, this);
            const c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = !0;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = !0;
        let f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, !0, b) && e;
        f = b.g = a;
        e = Va(f, d, !0, b) && e;
        e = Va(f, d, !1, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, !1, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(const c in a.g){
                const d = a.g[c];
                for(let e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        let e = !0;
        for(let f = 0; f < b.length; ++f){
            const g = b[f];
            if (g && !g.da && g.capture == c) {
                const k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(()=>{
            a.g = null;
            a.i && (a.i = !1, Xa(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class Ya extends w {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : Xa(this);
        }
        N() {
            super.N();
            this.g && (l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = class {
        stringify(a) {
            return l.JSON.stringify(a, void 0);
        }
        parse(a) {
            return l.JSON.parse(a, void 0);
        }
    };
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        const b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        const b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = !0;
    }
    pb.prototype.ua = function() {
        this.g = !1;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(let m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            const r = q[0];
                            q = q[1];
                            const A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            const f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(let g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = !1;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = !1;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = !1;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = !0;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(let f = 0; f < e.length; f++){
            const g = Ka(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        const b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            let r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        const b = Ib(a.g);
        if (b === "") return "";
        let c = "";
        const d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(let f = 0; f < d; f++)a.h.h = !0, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : !1;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = !0;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        const a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    let m = e[b];
                    const r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                const A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                const M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                const F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                const G = a.g;
                                if (G) {
                                    const za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        const bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.G);
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(let c = 0; c < a.length; c++){
                const d = a[c].indexOf("=");
                let e, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = !1;
        let b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = !1, kc(this, b[1] || "", !0), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", !0), lc(this, b[4]), this.h = oc(b[5] || "", !0), mc(this, b[6] || "", !0), this.m = oc(b[7] || "")) : (this.l = !1, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        const a = [];
        var b = this.j;
        b && a.push(qc(b, rc, !0), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, !0), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        const b = O(this);
        let c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                const f = [];
                for(let g = 0; g < e.length;){
                    const k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        let c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        let c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(let d = 0; d < b.length; d++){
            var c = b[d];
            const e = L(c);
            c = Ac(this, c);
            for(let f = 0; f < c.length; f++){
                let g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        const b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            const e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        const c = new pb;
        if (l.Image) {
            const d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", !1, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Cc(a, b) {
        const c = new pb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || !1;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = !1;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = !0;
        const b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = !1, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function() {
            return this.m === "include";
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        let b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = !1;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = !1;
        this.m = null;
        this.F = "";
        this.H = !1;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = !0, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Pc(this, !0));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = !1;
                try {
                    const f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            let g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            const c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        const b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            const e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", !1, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = !0;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || !1;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || !1;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || !1;
        this.R = a && a.encodeInitMessageHeaders || !1;
        this.S && this.R && (this.R = !1);
        this.Ra = a && a.Pb || !1;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = !1);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || !1;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = !1;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = !1;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = !0);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = !0;
            var b = a.Ea;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return !1;
        if (a.m) return a.i = b.G.concat(a.i), !0;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return !1;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return !0;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    const e = new N(this, this.j, a);
                    let f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = !0, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        const d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        const d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            let k = -1;
            for(;;){
                const q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                let m = !0;
                for(let r = 0; r < c; r++){
                    var f = e[r].g;
                    const A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = !1;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            for (const [M, F] of g){
                                let G = F;
                                n(F) && (G = ab(F));
                                q.push(f + M + "=" + encodeURIComponent(G));
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return !1;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return !0;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.P = !0, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = !0;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        let c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            const b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            const f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || !1;
        this.v = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    $33cb313d667e3306$export$66869136fc133c3a = $33cb313d667e3306$export$2e2bcd8739ae039.createWebChannelTransport = function() {
        return new bd;
    };
    $33cb313d667e3306$export$888d0d9ab79d08fc = $33cb313d667e3306$export$2e2bcd8739ae039.getStatEventTarget = function() {
        return jb();
    };
    $33cb313d667e3306$export$d61e24a684f9e51 = $33cb313d667e3306$export$2e2bcd8739ae039.Event = I;
    $33cb313d667e3306$export$cbbc350c1dfc80cb = $33cb313d667e3306$export$2e2bcd8739ae039.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    $33cb313d667e3306$export$d4e71bc0b80dc0fb = $33cb313d667e3306$export$2e2bcd8739ae039.ErrorCode = ub;
    vb.COMPLETE = "complete";
    $33cb313d667e3306$export$3d7865934588d77e = $33cb313d667e3306$export$2e2bcd8739ae039.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    $33cb313d667e3306$export$aa726fb96ad3e039 = $33cb313d667e3306$export$2e2bcd8739ae039.WebChannel = fb;
    $33cb313d667e3306$export$ddb1030448106742 = $33cb313d667e3306$export$2e2bcd8739ae039.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    $33cb313d667e3306$export$26404658cda3ee02 = $33cb313d667e3306$export$2e2bcd8739ae039.XhrIo = X;
}).apply(typeof $33cb313d667e3306$var$commonjsGlobal !== 'undefined' ? $33cb313d667e3306$var$commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});


/*!
 * re2js
 * RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
 *
 * @version v0.4.3
 * @author Alexey Vasiliev
 * @homepage https://github.com/le0pard/re2js#readme
 * @repository github:le0pard/re2js
 * @license MIT
 */ //// Parser flags.
class $4f6bfbff25a5c30c$var$RE2Flags {
    // Fold case during matching (case-insensitive).
    static FOLD_CASE = 0x01;
    // Treat pattern as a literal string instead of a regexp.
    static LITERAL = 0x02;
    // Allow character classes like [^a-z] and [[:space:]] to match newline.
    static CLASS_NL = 0x04;
    // Allow '.' to match newline.
    static DOT_NL = 0x08;
    // Treat ^ and $ as only matching at beginning and end of text, not
    // around embedded newlines.  (Perl's default).
    static ONE_LINE = 0x10;
    // Make repetition operators default to non-greedy.
    static NON_GREEDY = 0x20;
    // allow Perl extensions:
    //   non-capturing parens - (?: )
    //   non-greedy operators - *? +? ?? {}?
    //   flag edits - (?i) (?-i) (?i: )
    //     i - FoldCase
    //     m - !OneLine
    //     s - DotNL
    //     U - NonGreedy
    //   line ends: \A \z
    //   \Q and \E to disable/enable metacharacters
    //   (?P<name>expr) for named captures
    // \C (any byte) is not supported.
    static PERL_X = 0x40;
    // Allow \p{Han}, \P{Han} for Unicode group and negation.
    static UNICODE_GROUPS = 0x80;
    // Regexp END_TEXT was $, not \z.  Internal use only.
    static WAS_DOLLAR = 0x100;
    static MATCH_NL = (()=>$4f6bfbff25a5c30c$var$RE2Flags.CLASS_NL | $4f6bfbff25a5c30c$var$RE2Flags.DOT_NL)();
    // As close to Perl as possible.
    static PERL = (()=>$4f6bfbff25a5c30c$var$RE2Flags.CLASS_NL | $4f6bfbff25a5c30c$var$RE2Flags.ONE_LINE | $4f6bfbff25a5c30c$var$RE2Flags.PERL_X | $4f6bfbff25a5c30c$var$RE2Flags.UNICODE_GROUPS)();
    // POSIX syntax.
    static POSIX = 0;
    //// Anchors
    static UNANCHORED = 0;
    static ANCHOR_START = 1;
    static ANCHOR_BOTH = 2;
}
/**
 * Various constants and helper for unicode codepoints.
 */ class $4f6bfbff25a5c30c$var$Codepoint {
    // codePointAt(0)
    static CODES = (()=>new Map([
            [
                '\x07',
                7
            ],
            [
                '\b',
                8
            ],
            [
                '\t',
                9
            ],
            [
                '\n',
                10
            ],
            [
                '\v',
                11
            ],
            [
                '\f',
                12
            ],
            [
                '\r',
                13
            ],
            [
                ' ',
                32
            ],
            [
                '"',
                34
            ],
            [
                '$',
                36
            ],
            [
                '&',
                38
            ],
            [
                '(',
                40
            ],
            [
                ')',
                41
            ],
            [
                '*',
                42
            ],
            [
                '+',
                43
            ],
            [
                '-',
                45
            ],
            [
                '.',
                46
            ],
            [
                '0',
                48
            ],
            [
                '1',
                49
            ],
            [
                '2',
                50
            ],
            [
                '3',
                51
            ],
            [
                '4',
                52
            ],
            [
                '5',
                53
            ],
            [
                '6',
                54
            ],
            [
                '7',
                55
            ],
            [
                '8',
                56
            ],
            [
                '9',
                57
            ],
            [
                ':',
                58
            ],
            [
                '<',
                60
            ],
            [
                '>',
                62
            ],
            [
                '?',
                63
            ],
            [
                'A',
                65
            ],
            [
                'B',
                66
            ],
            [
                'C',
                67
            ],
            [
                'F',
                70
            ],
            [
                'P',
                80
            ],
            [
                'Q',
                81
            ],
            [
                'U',
                85
            ],
            [
                'Z',
                90
            ],
            [
                '[',
                91
            ],
            [
                '\\',
                92
            ],
            [
                ']',
                93
            ],
            [
                '^',
                94
            ],
            [
                '_',
                95
            ],
            [
                'a',
                97
            ],
            [
                'b',
                98
            ],
            [
                'f',
                102
            ],
            [
                'i',
                105
            ],
            [
                'm',
                109
            ],
            [
                'n',
                110
            ],
            [
                'r',
                114
            ],
            [
                's',
                115
            ],
            [
                't',
                116
            ],
            [
                'v',
                118
            ],
            [
                'x',
                120
            ],
            [
                'z',
                122
            ],
            [
                '{',
                123
            ],
            [
                '|',
                124
            ],
            [
                '}',
                125
            ]
        ]))();
    // convert unicode codepoint to upper case codepoint
    // return same codepoint, if cannot do it (or codepoint not have upper variation)
    static toUpperCase(codepoint) {
        const s = String.fromCodePoint(codepoint).toUpperCase();
        if (s.length > 1) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toLowerCase();
        if (sOrigin.length > 1 || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
    // convert unicode codepoint to lower case codepoint
    // return same codepoint, if cannot do it (or codepoint not have lower variation)
    static toLowerCase(codepoint) {
        const s = String.fromCodePoint(codepoint).toLowerCase();
        if (s.length > 1) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toUpperCase();
        if (sOrigin.length > 1 || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
}
// GENERATED BY tools/scripts/genUnicodeTable.js; DO NOT EDIT.
// yarn node ./tools/scripts/genUnicodeTable.js > src/UnicodeTables.js
class $4f6bfbff25a5c30c$var$UnicodeTables {
    static CASE_ORBIT = (()=>new Map([
            [
                75,
                107
            ],
            [
                107,
                8490
            ],
            [
                8490,
                75
            ],
            [
                83,
                115
            ],
            [
                115,
                383
            ],
            [
                383,
                83
            ],
            [
                181,
                924
            ],
            [
                924,
                956
            ],
            [
                956,
                181
            ],
            [
                197,
                229
            ],
            [
                229,
                8491
            ],
            [
                8491,
                197
            ],
            [
                452,
                453
            ],
            [
                453,
                454
            ],
            [
                454,
                452
            ],
            [
                455,
                456
            ],
            [
                456,
                457
            ],
            [
                457,
                455
            ],
            [
                458,
                459
            ],
            [
                459,
                460
            ],
            [
                460,
                458
            ],
            [
                497,
                498
            ],
            [
                498,
                499
            ],
            [
                499,
                497
            ],
            [
                837,
                921
            ],
            [
                921,
                953
            ],
            [
                953,
                8126
            ],
            [
                8126,
                837
            ],
            [
                914,
                946
            ],
            [
                946,
                976
            ],
            [
                976,
                914
            ],
            [
                917,
                949
            ],
            [
                949,
                1013
            ],
            [
                1013,
                917
            ],
            [
                920,
                952
            ],
            [
                952,
                977
            ],
            [
                977,
                1012
            ],
            [
                1012,
                920
            ],
            [
                922,
                954
            ],
            [
                954,
                1008
            ],
            [
                1008,
                922
            ],
            [
                928,
                960
            ],
            [
                960,
                982
            ],
            [
                982,
                928
            ],
            [
                929,
                961
            ],
            [
                961,
                1009
            ],
            [
                1009,
                929
            ],
            [
                931,
                962
            ],
            [
                962,
                963
            ],
            [
                963,
                931
            ],
            [
                934,
                966
            ],
            [
                966,
                981
            ],
            [
                981,
                934
            ],
            [
                937,
                969
            ],
            [
                969,
                8486
            ],
            [
                8486,
                937
            ],
            [
                1042,
                1074
            ],
            [
                1074,
                7296
            ],
            [
                7296,
                1042
            ],
            [
                1044,
                1076
            ],
            [
                1076,
                7297
            ],
            [
                7297,
                1044
            ],
            [
                1054,
                1086
            ],
            [
                1086,
                7298
            ],
            [
                7298,
                1054
            ],
            [
                1057,
                1089
            ],
            [
                1089,
                7299
            ],
            [
                7299,
                1057
            ],
            [
                1058,
                1090
            ],
            [
                1090,
                7300
            ],
            [
                7300,
                7301
            ],
            [
                7301,
                1058
            ],
            [
                1066,
                1098
            ],
            [
                1098,
                7302
            ],
            [
                7302,
                1066
            ],
            [
                1122,
                1123
            ],
            [
                1123,
                7303
            ],
            [
                7303,
                1122
            ],
            [
                7304,
                42570
            ],
            [
                42570,
                42571
            ],
            [
                42571,
                7304
            ],
            [
                7776,
                7777
            ],
            [
                7777,
                7835
            ],
            [
                7835,
                7776
            ],
            [
                223,
                7838
            ],
            [
                7838,
                223
            ],
            [
                8064,
                8072
            ],
            [
                8072,
                8064
            ],
            [
                8065,
                8073
            ],
            [
                8073,
                8065
            ],
            [
                8066,
                8074
            ],
            [
                8074,
                8066
            ],
            [
                8067,
                8075
            ],
            [
                8075,
                8067
            ],
            [
                8068,
                8076
            ],
            [
                8076,
                8068
            ],
            [
                8069,
                8077
            ],
            [
                8077,
                8069
            ],
            [
                8070,
                8078
            ],
            [
                8078,
                8070
            ],
            [
                8071,
                8079
            ],
            [
                8079,
                8071
            ],
            [
                8080,
                8088
            ],
            [
                8088,
                8080
            ],
            [
                8081,
                8089
            ],
            [
                8089,
                8081
            ],
            [
                8082,
                8090
            ],
            [
                8090,
                8082
            ],
            [
                8083,
                8091
            ],
            [
                8091,
                8083
            ],
            [
                8084,
                8092
            ],
            [
                8092,
                8084
            ],
            [
                8085,
                8093
            ],
            [
                8093,
                8085
            ],
            [
                8086,
                8094
            ],
            [
                8094,
                8086
            ],
            [
                8087,
                8095
            ],
            [
                8095,
                8087
            ],
            [
                8096,
                8104
            ],
            [
                8104,
                8096
            ],
            [
                8097,
                8105
            ],
            [
                8105,
                8097
            ],
            [
                8098,
                8106
            ],
            [
                8106,
                8098
            ],
            [
                8099,
                8107
            ],
            [
                8107,
                8099
            ],
            [
                8100,
                8108
            ],
            [
                8108,
                8100
            ],
            [
                8101,
                8109
            ],
            [
                8109,
                8101
            ],
            [
                8102,
                8110
            ],
            [
                8110,
                8102
            ],
            [
                8103,
                8111
            ],
            [
                8111,
                8103
            ],
            [
                8115,
                8124
            ],
            [
                8124,
                8115
            ],
            [
                8131,
                8140
            ],
            [
                8140,
                8131
            ],
            [
                912,
                8147
            ],
            [
                8147,
                912
            ],
            [
                944,
                8163
            ],
            [
                8163,
                944
            ],
            [
                8179,
                8188
            ],
            [
                8188,
                8179
            ],
            [
                64261,
                64262
            ],
            [
                64262,
                64261
            ],
            [
                66560,
                66600
            ],
            [
                66600,
                66560
            ],
            [
                66561,
                66601
            ],
            [
                66601,
                66561
            ],
            [
                66562,
                66602
            ],
            [
                66602,
                66562
            ],
            [
                66563,
                66603
            ],
            [
                66603,
                66563
            ],
            [
                66564,
                66604
            ],
            [
                66604,
                66564
            ],
            [
                66565,
                66605
            ],
            [
                66605,
                66565
            ],
            [
                66566,
                66606
            ],
            [
                66606,
                66566
            ],
            [
                66567,
                66607
            ],
            [
                66607,
                66567
            ],
            [
                66568,
                66608
            ],
            [
                66608,
                66568
            ],
            [
                66569,
                66609
            ],
            [
                66609,
                66569
            ],
            [
                66570,
                66610
            ],
            [
                66610,
                66570
            ],
            [
                66571,
                66611
            ],
            [
                66611,
                66571
            ],
            [
                66572,
                66612
            ],
            [
                66612,
                66572
            ],
            [
                66573,
                66613
            ],
            [
                66613,
                66573
            ],
            [
                66574,
                66614
            ],
            [
                66614,
                66574
            ],
            [
                66575,
                66615
            ],
            [
                66615,
                66575
            ],
            [
                66576,
                66616
            ],
            [
                66616,
                66576
            ],
            [
                66577,
                66617
            ],
            [
                66617,
                66577
            ],
            [
                66578,
                66618
            ],
            [
                66618,
                66578
            ],
            [
                66579,
                66619
            ],
            [
                66619,
                66579
            ],
            [
                66580,
                66620
            ],
            [
                66620,
                66580
            ],
            [
                66581,
                66621
            ],
            [
                66621,
                66581
            ],
            [
                66582,
                66622
            ],
            [
                66622,
                66582
            ],
            [
                66583,
                66623
            ],
            [
                66623,
                66583
            ],
            [
                66584,
                66624
            ],
            [
                66624,
                66584
            ],
            [
                66585,
                66625
            ],
            [
                66625,
                66585
            ],
            [
                66586,
                66626
            ],
            [
                66626,
                66586
            ],
            [
                66587,
                66627
            ],
            [
                66627,
                66587
            ],
            [
                66588,
                66628
            ],
            [
                66628,
                66588
            ],
            [
                66589,
                66629
            ],
            [
                66629,
                66589
            ],
            [
                66590,
                66630
            ],
            [
                66630,
                66590
            ],
            [
                66591,
                66631
            ],
            [
                66631,
                66591
            ],
            [
                66592,
                66632
            ],
            [
                66632,
                66592
            ],
            [
                66593,
                66633
            ],
            [
                66633,
                66593
            ],
            [
                66594,
                66634
            ],
            [
                66634,
                66594
            ],
            [
                66595,
                66635
            ],
            [
                66635,
                66595
            ],
            [
                66596,
                66636
            ],
            [
                66636,
                66596
            ],
            [
                66597,
                66637
            ],
            [
                66637,
                66597
            ],
            [
                66598,
                66638
            ],
            [
                66638,
                66598
            ],
            [
                66599,
                66639
            ],
            [
                66639,
                66599
            ],
            [
                66736,
                66776
            ],
            [
                66776,
                66736
            ],
            [
                66737,
                66777
            ],
            [
                66777,
                66737
            ],
            [
                66738,
                66778
            ],
            [
                66778,
                66738
            ],
            [
                66739,
                66779
            ],
            [
                66779,
                66739
            ],
            [
                66740,
                66780
            ],
            [
                66780,
                66740
            ],
            [
                66741,
                66781
            ],
            [
                66781,
                66741
            ],
            [
                66742,
                66782
            ],
            [
                66782,
                66742
            ],
            [
                66743,
                66783
            ],
            [
                66783,
                66743
            ],
            [
                66744,
                66784
            ],
            [
                66784,
                66744
            ],
            [
                66745,
                66785
            ],
            [
                66785,
                66745
            ],
            [
                66746,
                66786
            ],
            [
                66786,
                66746
            ],
            [
                66747,
                66787
            ],
            [
                66787,
                66747
            ],
            [
                66748,
                66788
            ],
            [
                66788,
                66748
            ],
            [
                66749,
                66789
            ],
            [
                66789,
                66749
            ],
            [
                66750,
                66790
            ],
            [
                66790,
                66750
            ],
            [
                66751,
                66791
            ],
            [
                66791,
                66751
            ],
            [
                66752,
                66792
            ],
            [
                66792,
                66752
            ],
            [
                66753,
                66793
            ],
            [
                66793,
                66753
            ],
            [
                66754,
                66794
            ],
            [
                66794,
                66754
            ],
            [
                66755,
                66795
            ],
            [
                66795,
                66755
            ],
            [
                66756,
                66796
            ],
            [
                66796,
                66756
            ],
            [
                66757,
                66797
            ],
            [
                66797,
                66757
            ],
            [
                66758,
                66798
            ],
            [
                66798,
                66758
            ],
            [
                66759,
                66799
            ],
            [
                66799,
                66759
            ],
            [
                66760,
                66800
            ],
            [
                66800,
                66760
            ],
            [
                66761,
                66801
            ],
            [
                66801,
                66761
            ],
            [
                66762,
                66802
            ],
            [
                66802,
                66762
            ],
            [
                66763,
                66803
            ],
            [
                66803,
                66763
            ],
            [
                66764,
                66804
            ],
            [
                66804,
                66764
            ],
            [
                66765,
                66805
            ],
            [
                66805,
                66765
            ],
            [
                66766,
                66806
            ],
            [
                66806,
                66766
            ],
            [
                66767,
                66807
            ],
            [
                66807,
                66767
            ],
            [
                66768,
                66808
            ],
            [
                66808,
                66768
            ],
            [
                66769,
                66809
            ],
            [
                66809,
                66769
            ],
            [
                66770,
                66810
            ],
            [
                66810,
                66770
            ],
            [
                66771,
                66811
            ],
            [
                66811,
                66771
            ],
            [
                66928,
                66967
            ],
            [
                66967,
                66928
            ],
            [
                66929,
                66968
            ],
            [
                66968,
                66929
            ],
            [
                66930,
                66969
            ],
            [
                66969,
                66930
            ],
            [
                66931,
                66970
            ],
            [
                66970,
                66931
            ],
            [
                66932,
                66971
            ],
            [
                66971,
                66932
            ],
            [
                66933,
                66972
            ],
            [
                66972,
                66933
            ],
            [
                66934,
                66973
            ],
            [
                66973,
                66934
            ],
            [
                66935,
                66974
            ],
            [
                66974,
                66935
            ],
            [
                66936,
                66975
            ],
            [
                66975,
                66936
            ],
            [
                66937,
                66976
            ],
            [
                66976,
                66937
            ],
            [
                66938,
                66977
            ],
            [
                66977,
                66938
            ],
            [
                66940,
                66979
            ],
            [
                66979,
                66940
            ],
            [
                66941,
                66980
            ],
            [
                66980,
                66941
            ],
            [
                66942,
                66981
            ],
            [
                66981,
                66942
            ],
            [
                66943,
                66982
            ],
            [
                66982,
                66943
            ],
            [
                66944,
                66983
            ],
            [
                66983,
                66944
            ],
            [
                66945,
                66984
            ],
            [
                66984,
                66945
            ],
            [
                66946,
                66985
            ],
            [
                66985,
                66946
            ],
            [
                66947,
                66986
            ],
            [
                66986,
                66947
            ],
            [
                66948,
                66987
            ],
            [
                66987,
                66948
            ],
            [
                66949,
                66988
            ],
            [
                66988,
                66949
            ],
            [
                66950,
                66989
            ],
            [
                66989,
                66950
            ],
            [
                66951,
                66990
            ],
            [
                66990,
                66951
            ],
            [
                66952,
                66991
            ],
            [
                66991,
                66952
            ],
            [
                66953,
                66992
            ],
            [
                66992,
                66953
            ],
            [
                66954,
                66993
            ],
            [
                66993,
                66954
            ],
            [
                66956,
                66995
            ],
            [
                66995,
                66956
            ],
            [
                66957,
                66996
            ],
            [
                66996,
                66957
            ],
            [
                66958,
                66997
            ],
            [
                66997,
                66958
            ],
            [
                66959,
                66998
            ],
            [
                66998,
                66959
            ],
            [
                66960,
                66999
            ],
            [
                66999,
                66960
            ],
            [
                66961,
                67000
            ],
            [
                67000,
                66961
            ],
            [
                66962,
                67001
            ],
            [
                67001,
                66962
            ],
            [
                66964,
                67003
            ],
            [
                67003,
                66964
            ],
            [
                66965,
                67004
            ],
            [
                67004,
                66965
            ],
            [
                68736,
                68800
            ],
            [
                68800,
                68736
            ],
            [
                68737,
                68801
            ],
            [
                68801,
                68737
            ],
            [
                68738,
                68802
            ],
            [
                68802,
                68738
            ],
            [
                68739,
                68803
            ],
            [
                68803,
                68739
            ],
            [
                68740,
                68804
            ],
            [
                68804,
                68740
            ],
            [
                68741,
                68805
            ],
            [
                68805,
                68741
            ],
            [
                68742,
                68806
            ],
            [
                68806,
                68742
            ],
            [
                68743,
                68807
            ],
            [
                68807,
                68743
            ],
            [
                68744,
                68808
            ],
            [
                68808,
                68744
            ],
            [
                68745,
                68809
            ],
            [
                68809,
                68745
            ],
            [
                68746,
                68810
            ],
            [
                68810,
                68746
            ],
            [
                68747,
                68811
            ],
            [
                68811,
                68747
            ],
            [
                68748,
                68812
            ],
            [
                68812,
                68748
            ],
            [
                68749,
                68813
            ],
            [
                68813,
                68749
            ],
            [
                68750,
                68814
            ],
            [
                68814,
                68750
            ],
            [
                68751,
                68815
            ],
            [
                68815,
                68751
            ],
            [
                68752,
                68816
            ],
            [
                68816,
                68752
            ],
            [
                68753,
                68817
            ],
            [
                68817,
                68753
            ],
            [
                68754,
                68818
            ],
            [
                68818,
                68754
            ],
            [
                68755,
                68819
            ],
            [
                68819,
                68755
            ],
            [
                68756,
                68820
            ],
            [
                68820,
                68756
            ],
            [
                68757,
                68821
            ],
            [
                68821,
                68757
            ],
            [
                68758,
                68822
            ],
            [
                68822,
                68758
            ],
            [
                68759,
                68823
            ],
            [
                68823,
                68759
            ],
            [
                68760,
                68824
            ],
            [
                68824,
                68760
            ],
            [
                68761,
                68825
            ],
            [
                68825,
                68761
            ],
            [
                68762,
                68826
            ],
            [
                68826,
                68762
            ],
            [
                68763,
                68827
            ],
            [
                68827,
                68763
            ],
            [
                68764,
                68828
            ],
            [
                68828,
                68764
            ],
            [
                68765,
                68829
            ],
            [
                68829,
                68765
            ],
            [
                68766,
                68830
            ],
            [
                68830,
                68766
            ],
            [
                68767,
                68831
            ],
            [
                68831,
                68767
            ],
            [
                68768,
                68832
            ],
            [
                68832,
                68768
            ],
            [
                68769,
                68833
            ],
            [
                68833,
                68769
            ],
            [
                68770,
                68834
            ],
            [
                68834,
                68770
            ],
            [
                68771,
                68835
            ],
            [
                68835,
                68771
            ],
            [
                68772,
                68836
            ],
            [
                68836,
                68772
            ],
            [
                68773,
                68837
            ],
            [
                68837,
                68773
            ],
            [
                68774,
                68838
            ],
            [
                68838,
                68774
            ],
            [
                68775,
                68839
            ],
            [
                68839,
                68775
            ],
            [
                68776,
                68840
            ],
            [
                68840,
                68776
            ],
            [
                68777,
                68841
            ],
            [
                68841,
                68777
            ],
            [
                68778,
                68842
            ],
            [
                68842,
                68778
            ],
            [
                68779,
                68843
            ],
            [
                68843,
                68779
            ],
            [
                68780,
                68844
            ],
            [
                68844,
                68780
            ],
            [
                68781,
                68845
            ],
            [
                68845,
                68781
            ],
            [
                68782,
                68846
            ],
            [
                68846,
                68782
            ],
            [
                68783,
                68847
            ],
            [
                68847,
                68783
            ],
            [
                68784,
                68848
            ],
            [
                68848,
                68784
            ],
            [
                68785,
                68849
            ],
            [
                68849,
                68785
            ],
            [
                68786,
                68850
            ],
            [
                68850,
                68786
            ],
            [
                71840,
                71872
            ],
            [
                71872,
                71840
            ],
            [
                71841,
                71873
            ],
            [
                71873,
                71841
            ],
            [
                71842,
                71874
            ],
            [
                71874,
                71842
            ],
            [
                71843,
                71875
            ],
            [
                71875,
                71843
            ],
            [
                71844,
                71876
            ],
            [
                71876,
                71844
            ],
            [
                71845,
                71877
            ],
            [
                71877,
                71845
            ],
            [
                71846,
                71878
            ],
            [
                71878,
                71846
            ],
            [
                71847,
                71879
            ],
            [
                71879,
                71847
            ],
            [
                71848,
                71880
            ],
            [
                71880,
                71848
            ],
            [
                71849,
                71881
            ],
            [
                71881,
                71849
            ],
            [
                71850,
                71882
            ],
            [
                71882,
                71850
            ],
            [
                71851,
                71883
            ],
            [
                71883,
                71851
            ],
            [
                71852,
                71884
            ],
            [
                71884,
                71852
            ],
            [
                71853,
                71885
            ],
            [
                71885,
                71853
            ],
            [
                71854,
                71886
            ],
            [
                71886,
                71854
            ],
            [
                71855,
                71887
            ],
            [
                71887,
                71855
            ],
            [
                71856,
                71888
            ],
            [
                71888,
                71856
            ],
            [
                71857,
                71889
            ],
            [
                71889,
                71857
            ],
            [
                71858,
                71890
            ],
            [
                71890,
                71858
            ],
            [
                71859,
                71891
            ],
            [
                71891,
                71859
            ],
            [
                71860,
                71892
            ],
            [
                71892,
                71860
            ],
            [
                71861,
                71893
            ],
            [
                71893,
                71861
            ],
            [
                71862,
                71894
            ],
            [
                71894,
                71862
            ],
            [
                71863,
                71895
            ],
            [
                71895,
                71863
            ],
            [
                71864,
                71896
            ],
            [
                71896,
                71864
            ],
            [
                71865,
                71897
            ],
            [
                71897,
                71865
            ],
            [
                71866,
                71898
            ],
            [
                71898,
                71866
            ],
            [
                71867,
                71899
            ],
            [
                71899,
                71867
            ],
            [
                71868,
                71900
            ],
            [
                71900,
                71868
            ],
            [
                71869,
                71901
            ],
            [
                71901,
                71869
            ],
            [
                71870,
                71902
            ],
            [
                71902,
                71870
            ],
            [
                71871,
                71903
            ],
            [
                71903,
                71871
            ],
            [
                93760,
                93792
            ],
            [
                93792,
                93760
            ],
            [
                93761,
                93793
            ],
            [
                93793,
                93761
            ],
            [
                93762,
                93794
            ],
            [
                93794,
                93762
            ],
            [
                93763,
                93795
            ],
            [
                93795,
                93763
            ],
            [
                93764,
                93796
            ],
            [
                93796,
                93764
            ],
            [
                93765,
                93797
            ],
            [
                93797,
                93765
            ],
            [
                93766,
                93798
            ],
            [
                93798,
                93766
            ],
            [
                93767,
                93799
            ],
            [
                93799,
                93767
            ],
            [
                93768,
                93800
            ],
            [
                93800,
                93768
            ],
            [
                93769,
                93801
            ],
            [
                93801,
                93769
            ],
            [
                93770,
                93802
            ],
            [
                93802,
                93770
            ],
            [
                93771,
                93803
            ],
            [
                93803,
                93771
            ],
            [
                93772,
                93804
            ],
            [
                93804,
                93772
            ],
            [
                93773,
                93805
            ],
            [
                93805,
                93773
            ],
            [
                93774,
                93806
            ],
            [
                93806,
                93774
            ],
            [
                93775,
                93807
            ],
            [
                93807,
                93775
            ],
            [
                93776,
                93808
            ],
            [
                93808,
                93776
            ],
            [
                93777,
                93809
            ],
            [
                93809,
                93777
            ],
            [
                93778,
                93810
            ],
            [
                93810,
                93778
            ],
            [
                93779,
                93811
            ],
            [
                93811,
                93779
            ],
            [
                93780,
                93812
            ],
            [
                93812,
                93780
            ],
            [
                93781,
                93813
            ],
            [
                93813,
                93781
            ],
            [
                93782,
                93814
            ],
            [
                93814,
                93782
            ],
            [
                93783,
                93815
            ],
            [
                93815,
                93783
            ],
            [
                93784,
                93816
            ],
            [
                93816,
                93784
            ],
            [
                93785,
                93817
            ],
            [
                93817,
                93785
            ],
            [
                93786,
                93818
            ],
            [
                93818,
                93786
            ],
            [
                93787,
                93819
            ],
            [
                93819,
                93787
            ],
            [
                93788,
                93820
            ],
            [
                93820,
                93788
            ],
            [
                93789,
                93821
            ],
            [
                93821,
                93789
            ],
            [
                93790,
                93822
            ],
            [
                93822,
                93790
            ],
            [
                93791,
                93823
            ],
            [
                93823,
                93791
            ],
            [
                125184,
                125218
            ],
            [
                125218,
                125184
            ],
            [
                125185,
                125219
            ],
            [
                125219,
                125185
            ],
            [
                125186,
                125220
            ],
            [
                125220,
                125186
            ],
            [
                125187,
                125221
            ],
            [
                125221,
                125187
            ],
            [
                125188,
                125222
            ],
            [
                125222,
                125188
            ],
            [
                125189,
                125223
            ],
            [
                125223,
                125189
            ],
            [
                125190,
                125224
            ],
            [
                125224,
                125190
            ],
            [
                125191,
                125225
            ],
            [
                125225,
                125191
            ],
            [
                125192,
                125226
            ],
            [
                125226,
                125192
            ],
            [
                125193,
                125227
            ],
            [
                125227,
                125193
            ],
            [
                125194,
                125228
            ],
            [
                125228,
                125194
            ],
            [
                125195,
                125229
            ],
            [
                125229,
                125195
            ],
            [
                125196,
                125230
            ],
            [
                125230,
                125196
            ],
            [
                125197,
                125231
            ],
            [
                125231,
                125197
            ],
            [
                125198,
                125232
            ],
            [
                125232,
                125198
            ],
            [
                125199,
                125233
            ],
            [
                125233,
                125199
            ],
            [
                125200,
                125234
            ],
            [
                125234,
                125200
            ],
            [
                125201,
                125235
            ],
            [
                125235,
                125201
            ],
            [
                125202,
                125236
            ],
            [
                125236,
                125202
            ],
            [
                125203,
                125237
            ],
            [
                125237,
                125203
            ],
            [
                125204,
                125238
            ],
            [
                125238,
                125204
            ],
            [
                125205,
                125239
            ],
            [
                125239,
                125205
            ],
            [
                125206,
                125240
            ],
            [
                125240,
                125206
            ],
            [
                125207,
                125241
            ],
            [
                125241,
                125207
            ],
            [
                125208,
                125242
            ],
            [
                125242,
                125208
            ],
            [
                125209,
                125243
            ],
            [
                125243,
                125209
            ],
            [
                125210,
                125244
            ],
            [
                125244,
                125210
            ],
            [
                125211,
                125245
            ],
            [
                125245,
                125211
            ],
            [
                125212,
                125246
            ],
            [
                125246,
                125212
            ],
            [
                125213,
                125247
            ],
            [
                125247,
                125213
            ],
            [
                125214,
                125248
            ],
            [
                125248,
                125214
            ],
            [
                125215,
                125249
            ],
            [
                125249,
                125215
            ],
            [
                125216,
                125250
            ],
            [
                125250,
                125216
            ],
            [
                125217,
                125251
            ],
            [
                125251,
                125217
            ]
        ]))();
    static C = [
        [
            0,
            31,
            1
        ],
        [
            127,
            159,
            1
        ],
        [
            173,
            888,
            715
        ],
        [
            889,
            896,
            7
        ],
        [
            897,
            899,
            1
        ],
        [
            907,
            909,
            2
        ],
        [
            930,
            1328,
            398
        ],
        [
            1367,
            1368,
            1
        ],
        [
            1419,
            1420,
            1
        ],
        [
            1424,
            1480,
            56
        ],
        [
            1481,
            1487,
            1
        ],
        [
            1515,
            1518,
            1
        ],
        [
            1525,
            1541,
            1
        ],
        [
            1564,
            1757,
            193
        ],
        [
            1806,
            1807,
            1
        ],
        [
            1867,
            1868,
            1
        ],
        [
            1970,
            1983,
            1
        ],
        [
            2043,
            2044,
            1
        ],
        [
            2094,
            2095,
            1
        ],
        [
            2111,
            2140,
            29
        ],
        [
            2141,
            2143,
            2
        ],
        [
            2155,
            2159,
            1
        ],
        [
            2191,
            2199,
            1
        ],
        [
            2274,
            2436,
            162
        ],
        [
            2445,
            2446,
            1
        ],
        [
            2449,
            2450,
            1
        ],
        [
            2473,
            2481,
            8
        ],
        [
            2483,
            2485,
            1
        ],
        [
            2490,
            2491,
            1
        ],
        [
            2501,
            2502,
            1
        ],
        [
            2505,
            2506,
            1
        ],
        [
            2511,
            2518,
            1
        ],
        [
            2520,
            2523,
            1
        ],
        [
            2526,
            2532,
            6
        ],
        [
            2533,
            2559,
            26
        ],
        [
            2560,
            2564,
            4
        ],
        [
            2571,
            2574,
            1
        ],
        [
            2577,
            2578,
            1
        ],
        [
            2601,
            2609,
            8
        ],
        [
            2612,
            2618,
            3
        ],
        [
            2619,
            2621,
            2
        ],
        [
            2627,
            2630,
            1
        ],
        [
            2633,
            2634,
            1
        ],
        [
            2638,
            2640,
            1
        ],
        [
            2642,
            2648,
            1
        ],
        [
            2653,
            2655,
            2
        ],
        [
            2656,
            2661,
            1
        ],
        [
            2679,
            2688,
            1
        ],
        [
            2692,
            2702,
            10
        ],
        [
            2706,
            2729,
            23
        ],
        [
            2737,
            2740,
            3
        ],
        [
            2746,
            2747,
            1
        ],
        [
            2758,
            2766,
            4
        ],
        [
            2767,
            2769,
            2
        ],
        [
            2770,
            2783,
            1
        ],
        [
            2788,
            2789,
            1
        ],
        [
            2802,
            2808,
            1
        ],
        [
            2816,
            2820,
            4
        ],
        [
            2829,
            2830,
            1
        ],
        [
            2833,
            2834,
            1
        ],
        [
            2857,
            2865,
            8
        ],
        [
            2868,
            2874,
            6
        ],
        [
            2875,
            2885,
            10
        ],
        [
            2886,
            2889,
            3
        ],
        [
            2890,
            2894,
            4
        ],
        [
            2895,
            2900,
            1
        ],
        [
            2904,
            2907,
            1
        ],
        [
            2910,
            2916,
            6
        ],
        [
            2917,
            2936,
            19
        ],
        [
            2937,
            2945,
            1
        ],
        [
            2948,
            2955,
            7
        ],
        [
            2956,
            2957,
            1
        ],
        [
            2961,
            2966,
            5
        ],
        [
            2967,
            2968,
            1
        ],
        [
            2971,
            2973,
            2
        ],
        [
            2976,
            2978,
            1
        ],
        [
            2981,
            2983,
            1
        ],
        [
            2987,
            2989,
            1
        ],
        [
            3002,
            3005,
            1
        ],
        [
            3011,
            3013,
            1
        ],
        [
            3017,
            3022,
            5
        ],
        [
            3023,
            3025,
            2
        ],
        [
            3026,
            3030,
            1
        ],
        [
            3032,
            3045,
            1
        ],
        [
            3067,
            3071,
            1
        ],
        [
            3085,
            3089,
            4
        ],
        [
            3113,
            3130,
            17
        ],
        [
            3131,
            3141,
            10
        ],
        [
            3145,
            3150,
            5
        ],
        [
            3151,
            3156,
            1
        ],
        [
            3159,
            3163,
            4
        ],
        [
            3164,
            3166,
            2
        ],
        [
            3167,
            3172,
            5
        ],
        [
            3173,
            3184,
            11
        ],
        [
            3185,
            3190,
            1
        ],
        [
            3213,
            3217,
            4
        ],
        [
            3241,
            3252,
            11
        ],
        [
            3258,
            3259,
            1
        ],
        [
            3269,
            3273,
            4
        ],
        [
            3278,
            3284,
            1
        ],
        [
            3287,
            3292,
            1
        ],
        [
            3295,
            3300,
            5
        ],
        [
            3301,
            3312,
            11
        ],
        [
            3316,
            3327,
            1
        ],
        [
            3341,
            3345,
            4
        ],
        [
            3397,
            3401,
            4
        ],
        [
            3408,
            3411,
            1
        ],
        [
            3428,
            3429,
            1
        ],
        [
            3456,
            3460,
            4
        ],
        [
            3479,
            3481,
            1
        ],
        [
            3506,
            3516,
            10
        ],
        [
            3518,
            3519,
            1
        ],
        [
            3527,
            3529,
            1
        ],
        [
            3531,
            3534,
            1
        ],
        [
            3541,
            3543,
            2
        ],
        [
            3552,
            3557,
            1
        ],
        [
            3568,
            3569,
            1
        ],
        [
            3573,
            3584,
            1
        ],
        [
            3643,
            3646,
            1
        ],
        [
            3676,
            3712,
            1
        ],
        [
            3715,
            3717,
            2
        ],
        [
            3723,
            3748,
            25
        ],
        [
            3750,
            3774,
            24
        ],
        [
            3775,
            3781,
            6
        ],
        [
            3783,
            3791,
            8
        ],
        [
            3802,
            3803,
            1
        ],
        [
            3808,
            3839,
            1
        ],
        [
            3912,
            3949,
            37
        ],
        [
            3950,
            3952,
            1
        ],
        [
            3992,
            4029,
            37
        ],
        [
            4045,
            4059,
            14
        ],
        [
            4060,
            4095,
            1
        ],
        [
            4294,
            4296,
            2
        ],
        [
            4297,
            4300,
            1
        ],
        [
            4302,
            4303,
            1
        ],
        [
            4681,
            4686,
            5
        ],
        [
            4687,
            4695,
            8
        ],
        [
            4697,
            4702,
            5
        ],
        [
            4703,
            4745,
            42
        ],
        [
            4750,
            4751,
            1
        ],
        [
            4785,
            4790,
            5
        ],
        [
            4791,
            4799,
            8
        ],
        [
            4801,
            4806,
            5
        ],
        [
            4807,
            4823,
            16
        ],
        [
            4881,
            4886,
            5
        ],
        [
            4887,
            4955,
            68
        ],
        [
            4956,
            4989,
            33
        ],
        [
            4990,
            4991,
            1
        ],
        [
            5018,
            5023,
            1
        ],
        [
            5110,
            5111,
            1
        ],
        [
            5118,
            5119,
            1
        ],
        [
            5789,
            5791,
            1
        ],
        [
            5881,
            5887,
            1
        ],
        [
            5910,
            5918,
            1
        ],
        [
            5943,
            5951,
            1
        ],
        [
            5972,
            5983,
            1
        ],
        [
            5997,
            6001,
            4
        ],
        [
            6004,
            6015,
            1
        ],
        [
            6110,
            6111,
            1
        ],
        [
            6122,
            6127,
            1
        ],
        [
            6138,
            6143,
            1
        ],
        [
            6158,
            6170,
            12
        ],
        [
            6171,
            6175,
            1
        ],
        [
            6265,
            6271,
            1
        ],
        [
            6315,
            6319,
            1
        ],
        [
            6390,
            6399,
            1
        ],
        [
            6431,
            6444,
            13
        ],
        [
            6445,
            6447,
            1
        ],
        [
            6460,
            6463,
            1
        ],
        [
            6465,
            6467,
            1
        ],
        [
            6510,
            6511,
            1
        ],
        [
            6517,
            6527,
            1
        ],
        [
            6572,
            6575,
            1
        ],
        [
            6602,
            6607,
            1
        ],
        [
            6619,
            6621,
            1
        ],
        [
            6684,
            6685,
            1
        ],
        [
            6751,
            6781,
            30
        ],
        [
            6782,
            6794,
            12
        ],
        [
            6795,
            6799,
            1
        ],
        [
            6810,
            6815,
            1
        ],
        [
            6830,
            6831,
            1
        ],
        [
            6863,
            6911,
            1
        ],
        [
            6989,
            6991,
            1
        ],
        [
            7039,
            7156,
            117
        ],
        [
            7157,
            7163,
            1
        ],
        [
            7224,
            7226,
            1
        ],
        [
            7242,
            7244,
            1
        ],
        [
            7305,
            7311,
            1
        ],
        [
            7355,
            7356,
            1
        ],
        [
            7368,
            7375,
            1
        ],
        [
            7419,
            7423,
            1
        ],
        [
            7958,
            7959,
            1
        ],
        [
            7966,
            7967,
            1
        ],
        [
            8006,
            8007,
            1
        ],
        [
            8014,
            8015,
            1
        ],
        [
            8024,
            8030,
            2
        ],
        [
            8062,
            8063,
            1
        ],
        [
            8117,
            8133,
            16
        ],
        [
            8148,
            8149,
            1
        ],
        [
            8156,
            8176,
            20
        ],
        [
            8177,
            8181,
            4
        ],
        [
            8191,
            8203,
            12
        ],
        [
            8204,
            8207,
            1
        ],
        [
            8234,
            8238,
            1
        ],
        [
            8288,
            8303,
            1
        ],
        [
            8306,
            8307,
            1
        ],
        [
            8335,
            8349,
            14
        ],
        [
            8350,
            8351,
            1
        ],
        [
            8385,
            8399,
            1
        ],
        [
            8433,
            8447,
            1
        ],
        [
            8588,
            8591,
            1
        ],
        [
            9255,
            9279,
            1
        ],
        [
            9291,
            9311,
            1
        ],
        [
            11124,
            11125,
            1
        ],
        [
            11158,
            11508,
            350
        ],
        [
            11509,
            11512,
            1
        ],
        [
            11558,
            11560,
            2
        ],
        [
            11561,
            11564,
            1
        ],
        [
            11566,
            11567,
            1
        ],
        [
            11624,
            11630,
            1
        ],
        [
            11633,
            11646,
            1
        ],
        [
            11671,
            11679,
            1
        ],
        [
            11687,
            11743,
            8
        ],
        [
            11870,
            11903,
            1
        ],
        [
            11930,
            12020,
            90
        ],
        [
            12021,
            12031,
            1
        ],
        [
            12246,
            12271,
            1
        ],
        [
            12352,
            12439,
            87
        ],
        [
            12440,
            12544,
            104
        ],
        [
            12545,
            12548,
            1
        ],
        [
            12592,
            12687,
            95
        ],
        [
            12772,
            12782,
            1
        ],
        [
            12831,
            42125,
            29294
        ],
        [
            42126,
            42127,
            1
        ],
        [
            42183,
            42191,
            1
        ],
        [
            42540,
            42559,
            1
        ],
        [
            42744,
            42751,
            1
        ],
        [
            42955,
            42959,
            1
        ],
        [
            42962,
            42964,
            2
        ],
        [
            42970,
            42993,
            1
        ],
        [
            43053,
            43055,
            1
        ],
        [
            43066,
            43071,
            1
        ],
        [
            43128,
            43135,
            1
        ],
        [
            43206,
            43213,
            1
        ],
        [
            43226,
            43231,
            1
        ],
        [
            43348,
            43358,
            1
        ],
        [
            43389,
            43391,
            1
        ],
        [
            43470,
            43482,
            12
        ],
        [
            43483,
            43485,
            1
        ],
        [
            43519,
            43575,
            56
        ],
        [
            43576,
            43583,
            1
        ],
        [
            43598,
            43599,
            1
        ],
        [
            43610,
            43611,
            1
        ],
        [
            43715,
            43738,
            1
        ],
        [
            43767,
            43776,
            1
        ],
        [
            43783,
            43784,
            1
        ],
        [
            43791,
            43792,
            1
        ],
        [
            43799,
            43807,
            1
        ],
        [
            43815,
            43823,
            8
        ],
        [
            43884,
            43887,
            1
        ],
        [
            44014,
            44015,
            1
        ],
        [
            44026,
            44031,
            1
        ],
        [
            55204,
            55215,
            1
        ],
        [
            55239,
            55242,
            1
        ],
        [
            55292,
            63743,
            1
        ],
        [
            64110,
            64111,
            1
        ],
        [
            64218,
            64255,
            1
        ],
        [
            64263,
            64274,
            1
        ],
        [
            64280,
            64284,
            1
        ],
        [
            64311,
            64317,
            6
        ],
        [
            64319,
            64325,
            3
        ],
        [
            64451,
            64466,
            1
        ],
        [
            64912,
            64913,
            1
        ],
        [
            64968,
            64974,
            1
        ],
        [
            64976,
            65007,
            1
        ],
        [
            65050,
            65055,
            1
        ],
        [
            65107,
            65127,
            20
        ],
        [
            65132,
            65135,
            1
        ],
        [
            65141,
            65277,
            136
        ],
        [
            65278,
            65280,
            1
        ],
        [
            65471,
            65473,
            1
        ],
        [
            65480,
            65481,
            1
        ],
        [
            65488,
            65489,
            1
        ],
        [
            65496,
            65497,
            1
        ],
        [
            65501,
            65503,
            1
        ],
        [
            65511,
            65519,
            8
        ],
        [
            65520,
            65531,
            1
        ],
        [
            65534,
            65535,
            1
        ],
        [
            65548,
            65575,
            27
        ],
        [
            65595,
            65598,
            3
        ],
        [
            65614,
            65615,
            1
        ],
        [
            65630,
            65663,
            1
        ],
        [
            65787,
            65791,
            1
        ],
        [
            65795,
            65798,
            1
        ],
        [
            65844,
            65846,
            1
        ],
        [
            65935,
            65949,
            14
        ],
        [
            65950,
            65951,
            1
        ],
        [
            65953,
            65999,
            1
        ],
        [
            66046,
            66175,
            1
        ],
        [
            66205,
            66207,
            1
        ],
        [
            66257,
            66271,
            1
        ],
        [
            66300,
            66303,
            1
        ],
        [
            66340,
            66348,
            1
        ],
        [
            66379,
            66383,
            1
        ],
        [
            66427,
            66431,
            1
        ],
        [
            66462,
            66500,
            38
        ],
        [
            66501,
            66503,
            1
        ],
        [
            66518,
            66559,
            1
        ],
        [
            66718,
            66719,
            1
        ],
        [
            66730,
            66735,
            1
        ],
        [
            66772,
            66775,
            1
        ],
        [
            66812,
            66815,
            1
        ],
        [
            66856,
            66863,
            1
        ],
        [
            66916,
            66926,
            1
        ],
        [
            66939,
            66955,
            16
        ],
        [
            66963,
            66966,
            3
        ],
        [
            66978,
            66994,
            16
        ],
        [
            67002,
            67005,
            3
        ],
        [
            67006,
            67071,
            1
        ],
        [
            67383,
            67391,
            1
        ],
        [
            67414,
            67423,
            1
        ],
        [
            67432,
            67455,
            1
        ],
        [
            67462,
            67505,
            43
        ],
        [
            67515,
            67583,
            1
        ],
        [
            67590,
            67591,
            1
        ],
        [
            67593,
            67638,
            45
        ],
        [
            67641,
            67643,
            1
        ],
        [
            67645,
            67646,
            1
        ],
        [
            67670,
            67743,
            73
        ],
        [
            67744,
            67750,
            1
        ],
        [
            67760,
            67807,
            1
        ],
        [
            67827,
            67830,
            3
        ],
        [
            67831,
            67834,
            1
        ],
        [
            67868,
            67870,
            1
        ],
        [
            67898,
            67902,
            1
        ],
        [
            67904,
            67967,
            1
        ],
        [
            68024,
            68027,
            1
        ],
        [
            68048,
            68049,
            1
        ],
        [
            68100,
            68103,
            3
        ],
        [
            68104,
            68107,
            1
        ],
        [
            68116,
            68120,
            4
        ],
        [
            68150,
            68151,
            1
        ],
        [
            68155,
            68158,
            1
        ],
        [
            68169,
            68175,
            1
        ],
        [
            68185,
            68191,
            1
        ],
        [
            68256,
            68287,
            1
        ],
        [
            68327,
            68330,
            1
        ],
        [
            68343,
            68351,
            1
        ],
        [
            68406,
            68408,
            1
        ],
        [
            68438,
            68439,
            1
        ],
        [
            68467,
            68471,
            1
        ],
        [
            68498,
            68504,
            1
        ],
        [
            68509,
            68520,
            1
        ],
        [
            68528,
            68607,
            1
        ],
        [
            68681,
            68735,
            1
        ],
        [
            68787,
            68799,
            1
        ],
        [
            68851,
            68857,
            1
        ],
        [
            68904,
            68911,
            1
        ],
        [
            68922,
            69215,
            1
        ],
        [
            69247,
            69290,
            43
        ],
        [
            69294,
            69295,
            1
        ],
        [
            69298,
            69372,
            1
        ],
        [
            69416,
            69423,
            1
        ],
        [
            69466,
            69487,
            1
        ],
        [
            69514,
            69551,
            1
        ],
        [
            69580,
            69599,
            1
        ],
        [
            69623,
            69631,
            1
        ],
        [
            69710,
            69713,
            1
        ],
        [
            69750,
            69758,
            1
        ],
        [
            69821,
            69827,
            6
        ],
        [
            69828,
            69839,
            1
        ],
        [
            69865,
            69871,
            1
        ],
        [
            69882,
            69887,
            1
        ],
        [
            69941,
            69960,
            19
        ],
        [
            69961,
            69967,
            1
        ],
        [
            70007,
            70015,
            1
        ],
        [
            70112,
            70133,
            21
        ],
        [
            70134,
            70143,
            1
        ],
        [
            70162,
            70210,
            48
        ],
        [
            70211,
            70271,
            1
        ],
        [
            70279,
            70281,
            2
        ],
        [
            70286,
            70302,
            16
        ],
        [
            70314,
            70319,
            1
        ],
        [
            70379,
            70383,
            1
        ],
        [
            70394,
            70399,
            1
        ],
        [
            70404,
            70413,
            9
        ],
        [
            70414,
            70417,
            3
        ],
        [
            70418,
            70441,
            23
        ],
        [
            70449,
            70452,
            3
        ],
        [
            70458,
            70469,
            11
        ],
        [
            70470,
            70473,
            3
        ],
        [
            70474,
            70478,
            4
        ],
        [
            70479,
            70481,
            2
        ],
        [
            70482,
            70486,
            1
        ],
        [
            70488,
            70492,
            1
        ],
        [
            70500,
            70501,
            1
        ],
        [
            70509,
            70511,
            1
        ],
        [
            70517,
            70655,
            1
        ],
        [
            70748,
            70754,
            6
        ],
        [
            70755,
            70783,
            1
        ],
        [
            70856,
            70863,
            1
        ],
        [
            70874,
            71039,
            1
        ],
        [
            71094,
            71095,
            1
        ],
        [
            71134,
            71167,
            1
        ],
        [
            71237,
            71247,
            1
        ],
        [
            71258,
            71263,
            1
        ],
        [
            71277,
            71295,
            1
        ],
        [
            71354,
            71359,
            1
        ],
        [
            71370,
            71423,
            1
        ],
        [
            71451,
            71452,
            1
        ],
        [
            71468,
            71471,
            1
        ],
        [
            71495,
            71679,
            1
        ],
        [
            71740,
            71839,
            1
        ],
        [
            71923,
            71934,
            1
        ],
        [
            71943,
            71944,
            1
        ],
        [
            71946,
            71947,
            1
        ],
        [
            71956,
            71959,
            3
        ],
        [
            71990,
            71993,
            3
        ],
        [
            71994,
            72007,
            13
        ],
        [
            72008,
            72015,
            1
        ],
        [
            72026,
            72095,
            1
        ],
        [
            72104,
            72105,
            1
        ],
        [
            72152,
            72153,
            1
        ],
        [
            72165,
            72191,
            1
        ],
        [
            72264,
            72271,
            1
        ],
        [
            72355,
            72367,
            1
        ],
        [
            72441,
            72447,
            1
        ],
        [
            72458,
            72703,
            1
        ],
        [
            72713,
            72759,
            46
        ],
        [
            72774,
            72783,
            1
        ],
        [
            72813,
            72815,
            1
        ],
        [
            72848,
            72849,
            1
        ],
        [
            72872,
            72887,
            15
        ],
        [
            72888,
            72959,
            1
        ],
        [
            72967,
            72970,
            3
        ],
        [
            73015,
            73017,
            1
        ],
        [
            73019,
            73022,
            3
        ],
        [
            73032,
            73039,
            1
        ],
        [
            73050,
            73055,
            1
        ],
        [
            73062,
            73065,
            3
        ],
        [
            73103,
            73106,
            3
        ],
        [
            73113,
            73119,
            1
        ],
        [
            73130,
            73439,
            1
        ],
        [
            73465,
            73471,
            1
        ],
        [
            73489,
            73531,
            42
        ],
        [
            73532,
            73533,
            1
        ],
        [
            73562,
            73647,
            1
        ],
        [
            73649,
            73663,
            1
        ],
        [
            73714,
            73726,
            1
        ],
        [
            74650,
            74751,
            1
        ],
        [
            74863,
            74869,
            6
        ],
        [
            74870,
            74879,
            1
        ],
        [
            75076,
            77711,
            1
        ],
        [
            77811,
            77823,
            1
        ],
        [
            78896,
            78911,
            1
        ],
        [
            78934,
            82943,
            1
        ],
        [
            83527,
            92159,
            1
        ],
        [
            92729,
            92735,
            1
        ],
        [
            92767,
            92778,
            11
        ],
        [
            92779,
            92781,
            1
        ],
        [
            92863,
            92874,
            11
        ],
        [
            92875,
            92879,
            1
        ],
        [
            92910,
            92911,
            1
        ],
        [
            92918,
            92927,
            1
        ],
        [
            92998,
            93007,
            1
        ],
        [
            93018,
            93026,
            8
        ],
        [
            93048,
            93052,
            1
        ],
        [
            93072,
            93759,
            1
        ],
        [
            93851,
            93951,
            1
        ],
        [
            94027,
            94030,
            1
        ],
        [
            94088,
            94094,
            1
        ],
        [
            94112,
            94175,
            1
        ],
        [
            94181,
            94191,
            1
        ],
        [
            94194,
            94207,
            1
        ],
        [
            100344,
            100351,
            1
        ],
        [
            101590,
            101631,
            1
        ],
        [
            101641,
            110575,
            1
        ],
        [
            110580,
            110588,
            8
        ],
        [
            110591,
            110883,
            292
        ],
        [
            110884,
            110897,
            1
        ],
        [
            110899,
            110927,
            1
        ],
        [
            110931,
            110932,
            1
        ],
        [
            110934,
            110947,
            1
        ],
        [
            110952,
            110959,
            1
        ],
        [
            111356,
            113663,
            1
        ],
        [
            113771,
            113775,
            1
        ],
        [
            113789,
            113791,
            1
        ],
        [
            113801,
            113807,
            1
        ],
        [
            113818,
            113819,
            1
        ],
        [
            113824,
            118527,
            1
        ],
        [
            118574,
            118575,
            1
        ],
        [
            118599,
            118607,
            1
        ],
        [
            118724,
            118783,
            1
        ],
        [
            119030,
            119039,
            1
        ],
        [
            119079,
            119080,
            1
        ],
        [
            119155,
            119162,
            1
        ],
        [
            119275,
            119295,
            1
        ],
        [
            119366,
            119487,
            1
        ],
        [
            119508,
            119519,
            1
        ],
        [
            119540,
            119551,
            1
        ],
        [
            119639,
            119647,
            1
        ],
        [
            119673,
            119807,
            1
        ],
        [
            119893,
            119965,
            72
        ],
        [
            119968,
            119969,
            1
        ],
        [
            119971,
            119972,
            1
        ],
        [
            119975,
            119976,
            1
        ],
        [
            119981,
            119994,
            13
        ],
        [
            119996,
            120004,
            8
        ],
        [
            120070,
            120075,
            5
        ],
        [
            120076,
            120085,
            9
        ],
        [
            120093,
            120122,
            29
        ],
        [
            120127,
            120133,
            6
        ],
        [
            120135,
            120137,
            1
        ],
        [
            120145,
            120486,
            341
        ],
        [
            120487,
            120780,
            293
        ],
        [
            120781,
            121484,
            703
        ],
        [
            121485,
            121498,
            1
        ],
        [
            121504,
            121520,
            16
        ],
        [
            121521,
            122623,
            1
        ],
        [
            122655,
            122660,
            1
        ],
        [
            122667,
            122879,
            1
        ],
        [
            122887,
            122905,
            18
        ],
        [
            122906,
            122914,
            8
        ],
        [
            122917,
            122923,
            6
        ],
        [
            122924,
            122927,
            1
        ],
        [
            122990,
            123022,
            1
        ],
        [
            123024,
            123135,
            1
        ],
        [
            123181,
            123183,
            1
        ],
        [
            123198,
            123199,
            1
        ],
        [
            123210,
            123213,
            1
        ],
        [
            123216,
            123535,
            1
        ],
        [
            123567,
            123583,
            1
        ],
        [
            123642,
            123646,
            1
        ],
        [
            123648,
            124111,
            1
        ],
        [
            124154,
            124895,
            1
        ],
        [
            124903,
            124908,
            5
        ],
        [
            124911,
            124927,
            16
        ],
        [
            125125,
            125126,
            1
        ],
        [
            125143,
            125183,
            1
        ],
        [
            125260,
            125263,
            1
        ],
        [
            125274,
            125277,
            1
        ],
        [
            125280,
            126064,
            1
        ],
        [
            126133,
            126208,
            1
        ],
        [
            126270,
            126463,
            1
        ],
        [
            126468,
            126496,
            28
        ],
        [
            126499,
            126501,
            2
        ],
        [
            126502,
            126504,
            2
        ],
        [
            126515,
            126520,
            5
        ],
        [
            126522,
            126524,
            2
        ],
        [
            126525,
            126529,
            1
        ],
        [
            126531,
            126534,
            1
        ],
        [
            126536,
            126540,
            2
        ],
        [
            126544,
            126547,
            3
        ],
        [
            126549,
            126550,
            1
        ],
        [
            126552,
            126560,
            2
        ],
        [
            126563,
            126565,
            2
        ],
        [
            126566,
            126571,
            5
        ],
        [
            126579,
            126589,
            5
        ],
        [
            126591,
            126602,
            11
        ],
        [
            126620,
            126624,
            1
        ],
        [
            126628,
            126634,
            6
        ],
        [
            126652,
            126703,
            1
        ],
        [
            126706,
            126975,
            1
        ],
        [
            127020,
            127023,
            1
        ],
        [
            127124,
            127135,
            1
        ],
        [
            127151,
            127152,
            1
        ],
        [
            127168,
            127184,
            16
        ],
        [
            127222,
            127231,
            1
        ],
        [
            127406,
            127461,
            1
        ],
        [
            127491,
            127503,
            1
        ],
        [
            127548,
            127551,
            1
        ],
        [
            127561,
            127567,
            1
        ],
        [
            127570,
            127583,
            1
        ],
        [
            127590,
            127743,
            1
        ],
        [
            128728,
            128731,
            1
        ],
        [
            128749,
            128751,
            1
        ],
        [
            128765,
            128767,
            1
        ],
        [
            128887,
            128890,
            1
        ],
        [
            128986,
            128991,
            1
        ],
        [
            129004,
            129007,
            1
        ],
        [
            129009,
            129023,
            1
        ],
        [
            129036,
            129039,
            1
        ],
        [
            129096,
            129103,
            1
        ],
        [
            129114,
            129119,
            1
        ],
        [
            129160,
            129167,
            1
        ],
        [
            129198,
            129199,
            1
        ],
        [
            129202,
            129279,
            1
        ],
        [
            129620,
            129631,
            1
        ],
        [
            129646,
            129647,
            1
        ],
        [
            129661,
            129663,
            1
        ],
        [
            129673,
            129679,
            1
        ],
        [
            129726,
            129734,
            8
        ],
        [
            129735,
            129741,
            1
        ],
        [
            129756,
            129759,
            1
        ],
        [
            129769,
            129775,
            1
        ],
        [
            129785,
            129791,
            1
        ],
        [
            129939,
            129995,
            56
        ],
        [
            129996,
            130031,
            1
        ],
        [
            130042,
            131071,
            1
        ],
        [
            173792,
            173823,
            1
        ],
        [
            177978,
            177983,
            1
        ],
        [
            178206,
            178207,
            1
        ],
        [
            183970,
            183983,
            1
        ],
        [
            191457,
            191471,
            1
        ],
        [
            192094,
            194559,
            1
        ],
        [
            195102,
            196607,
            1
        ],
        [
            201547,
            201551,
            1
        ],
        [
            205744,
            917759,
            1
        ],
        [
            918000,
            1114111,
            1
        ]
    ];
    static Cc = [
        [
            0,
            31,
            1
        ],
        [
            127,
            159,
            1
        ]
    ];
    static Cf = [
        [
            173,
            1536,
            1363
        ],
        [
            1537,
            1541,
            1
        ],
        [
            1564,
            1757,
            193
        ],
        [
            1807,
            2192,
            385
        ],
        [
            2193,
            2274,
            81
        ],
        [
            6158,
            8203,
            2045
        ],
        [
            8204,
            8207,
            1
        ],
        [
            8234,
            8238,
            1
        ],
        [
            8288,
            8292,
            1
        ],
        [
            8294,
            8303,
            1
        ],
        [
            65279,
            65529,
            250
        ],
        [
            65530,
            65531,
            1
        ],
        [
            69821,
            69837,
            16
        ],
        [
            78896,
            78911,
            1
        ],
        [
            113824,
            113827,
            1
        ],
        [
            119155,
            119162,
            1
        ],
        [
            917505,
            917536,
            31
        ],
        [
            917537,
            917631,
            1
        ]
    ];
    static Co = [
        [
            57344,
            63743,
            1
        ],
        [
            983040,
            1048573,
            1
        ],
        [
            1048576,
            1114109,
            1
        ]
    ];
    static Cs = [
        [
            55296,
            57343,
            1
        ]
    ];
    static L = [
        [
            65,
            90,
            1
        ],
        [
            97,
            122,
            1
        ],
        [
            170,
            181,
            11
        ],
        [
            186,
            192,
            6
        ],
        [
            193,
            214,
            1
        ],
        [
            216,
            246,
            1
        ],
        [
            248,
            705,
            1
        ],
        [
            710,
            721,
            1
        ],
        [
            736,
            740,
            1
        ],
        [
            748,
            750,
            2
        ],
        [
            880,
            884,
            1
        ],
        [
            886,
            887,
            1
        ],
        [
            890,
            893,
            1
        ],
        [
            895,
            902,
            7
        ],
        [
            904,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            929,
            1
        ],
        [
            931,
            1013,
            1
        ],
        [
            1015,
            1153,
            1
        ],
        [
            1162,
            1327,
            1
        ],
        [
            1329,
            1366,
            1
        ],
        [
            1369,
            1376,
            7
        ],
        [
            1377,
            1416,
            1
        ],
        [
            1488,
            1514,
            1
        ],
        [
            1519,
            1522,
            1
        ],
        [
            1568,
            1610,
            1
        ],
        [
            1646,
            1647,
            1
        ],
        [
            1649,
            1747,
            1
        ],
        [
            1749,
            1765,
            16
        ],
        [
            1766,
            1774,
            8
        ],
        [
            1775,
            1786,
            11
        ],
        [
            1787,
            1788,
            1
        ],
        [
            1791,
            1808,
            17
        ],
        [
            1810,
            1839,
            1
        ],
        [
            1869,
            1957,
            1
        ],
        [
            1969,
            1994,
            25
        ],
        [
            1995,
            2026,
            1
        ],
        [
            2036,
            2037,
            1
        ],
        [
            2042,
            2048,
            6
        ],
        [
            2049,
            2069,
            1
        ],
        [
            2074,
            2084,
            10
        ],
        [
            2088,
            2112,
            24
        ],
        [
            2113,
            2136,
            1
        ],
        [
            2144,
            2154,
            1
        ],
        [
            2160,
            2183,
            1
        ],
        [
            2185,
            2190,
            1
        ],
        [
            2208,
            2249,
            1
        ],
        [
            2308,
            2361,
            1
        ],
        [
            2365,
            2384,
            19
        ],
        [
            2392,
            2401,
            1
        ],
        [
            2417,
            2432,
            1
        ],
        [
            2437,
            2444,
            1
        ],
        [
            2447,
            2448,
            1
        ],
        [
            2451,
            2472,
            1
        ],
        [
            2474,
            2480,
            1
        ],
        [
            2482,
            2486,
            4
        ],
        [
            2487,
            2489,
            1
        ],
        [
            2493,
            2510,
            17
        ],
        [
            2524,
            2525,
            1
        ],
        [
            2527,
            2529,
            1
        ],
        [
            2544,
            2545,
            1
        ],
        [
            2556,
            2565,
            9
        ],
        [
            2566,
            2570,
            1
        ],
        [
            2575,
            2576,
            1
        ],
        [
            2579,
            2600,
            1
        ],
        [
            2602,
            2608,
            1
        ],
        [
            2610,
            2611,
            1
        ],
        [
            2613,
            2614,
            1
        ],
        [
            2616,
            2617,
            1
        ],
        [
            2649,
            2652,
            1
        ],
        [
            2654,
            2674,
            20
        ],
        [
            2675,
            2676,
            1
        ],
        [
            2693,
            2701,
            1
        ],
        [
            2703,
            2705,
            1
        ],
        [
            2707,
            2728,
            1
        ],
        [
            2730,
            2736,
            1
        ],
        [
            2738,
            2739,
            1
        ],
        [
            2741,
            2745,
            1
        ],
        [
            2749,
            2768,
            19
        ],
        [
            2784,
            2785,
            1
        ],
        [
            2809,
            2821,
            12
        ],
        [
            2822,
            2828,
            1
        ],
        [
            2831,
            2832,
            1
        ],
        [
            2835,
            2856,
            1
        ],
        [
            2858,
            2864,
            1
        ],
        [
            2866,
            2867,
            1
        ],
        [
            2869,
            2873,
            1
        ],
        [
            2877,
            2908,
            31
        ],
        [
            2909,
            2911,
            2
        ],
        [
            2912,
            2913,
            1
        ],
        [
            2929,
            2947,
            18
        ],
        [
            2949,
            2954,
            1
        ],
        [
            2958,
            2960,
            1
        ],
        [
            2962,
            2965,
            1
        ],
        [
            2969,
            2970,
            1
        ],
        [
            2972,
            2974,
            2
        ],
        [
            2975,
            2979,
            4
        ],
        [
            2980,
            2984,
            4
        ],
        [
            2985,
            2986,
            1
        ],
        [
            2990,
            3001,
            1
        ],
        [
            3024,
            3077,
            53
        ],
        [
            3078,
            3084,
            1
        ],
        [
            3086,
            3088,
            1
        ],
        [
            3090,
            3112,
            1
        ],
        [
            3114,
            3129,
            1
        ],
        [
            3133,
            3160,
            27
        ],
        [
            3161,
            3162,
            1
        ],
        [
            3165,
            3168,
            3
        ],
        [
            3169,
            3200,
            31
        ],
        [
            3205,
            3212,
            1
        ],
        [
            3214,
            3216,
            1
        ],
        [
            3218,
            3240,
            1
        ],
        [
            3242,
            3251,
            1
        ],
        [
            3253,
            3257,
            1
        ],
        [
            3261,
            3293,
            32
        ],
        [
            3294,
            3296,
            2
        ],
        [
            3297,
            3313,
            16
        ],
        [
            3314,
            3332,
            18
        ],
        [
            3333,
            3340,
            1
        ],
        [
            3342,
            3344,
            1
        ],
        [
            3346,
            3386,
            1
        ],
        [
            3389,
            3406,
            17
        ],
        [
            3412,
            3414,
            1
        ],
        [
            3423,
            3425,
            1
        ],
        [
            3450,
            3455,
            1
        ],
        [
            3461,
            3478,
            1
        ],
        [
            3482,
            3505,
            1
        ],
        [
            3507,
            3515,
            1
        ],
        [
            3517,
            3520,
            3
        ],
        [
            3521,
            3526,
            1
        ],
        [
            3585,
            3632,
            1
        ],
        [
            3634,
            3635,
            1
        ],
        [
            3648,
            3654,
            1
        ],
        [
            3713,
            3714,
            1
        ],
        [
            3716,
            3718,
            2
        ],
        [
            3719,
            3722,
            1
        ],
        [
            3724,
            3747,
            1
        ],
        [
            3749,
            3751,
            2
        ],
        [
            3752,
            3760,
            1
        ],
        [
            3762,
            3763,
            1
        ],
        [
            3773,
            3776,
            3
        ],
        [
            3777,
            3780,
            1
        ],
        [
            3782,
            3804,
            22
        ],
        [
            3805,
            3807,
            1
        ],
        [
            3840,
            3904,
            64
        ],
        [
            3905,
            3911,
            1
        ],
        [
            3913,
            3948,
            1
        ],
        [
            3976,
            3980,
            1
        ],
        [
            4096,
            4138,
            1
        ],
        [
            4159,
            4176,
            17
        ],
        [
            4177,
            4181,
            1
        ],
        [
            4186,
            4189,
            1
        ],
        [
            4193,
            4197,
            4
        ],
        [
            4198,
            4206,
            8
        ],
        [
            4207,
            4208,
            1
        ],
        [
            4213,
            4225,
            1
        ],
        [
            4238,
            4256,
            18
        ],
        [
            4257,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4348,
            4680,
            1
        ],
        [
            4682,
            4685,
            1
        ],
        [
            4688,
            4694,
            1
        ],
        [
            4696,
            4698,
            2
        ],
        [
            4699,
            4701,
            1
        ],
        [
            4704,
            4744,
            1
        ],
        [
            4746,
            4749,
            1
        ],
        [
            4752,
            4784,
            1
        ],
        [
            4786,
            4789,
            1
        ],
        [
            4792,
            4798,
            1
        ],
        [
            4800,
            4802,
            2
        ],
        [
            4803,
            4805,
            1
        ],
        [
            4808,
            4822,
            1
        ],
        [
            4824,
            4880,
            1
        ],
        [
            4882,
            4885,
            1
        ],
        [
            4888,
            4954,
            1
        ],
        [
            4992,
            5007,
            1
        ],
        [
            5024,
            5109,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            5121,
            5740,
            1
        ],
        [
            5743,
            5759,
            1
        ],
        [
            5761,
            5786,
            1
        ],
        [
            5792,
            5866,
            1
        ],
        [
            5873,
            5880,
            1
        ],
        [
            5888,
            5905,
            1
        ],
        [
            5919,
            5937,
            1
        ],
        [
            5952,
            5969,
            1
        ],
        [
            5984,
            5996,
            1
        ],
        [
            5998,
            6000,
            1
        ],
        [
            6016,
            6067,
            1
        ],
        [
            6103,
            6108,
            5
        ],
        [
            6176,
            6264,
            1
        ],
        [
            6272,
            6276,
            1
        ],
        [
            6279,
            6312,
            1
        ],
        [
            6314,
            6320,
            6
        ],
        [
            6321,
            6389,
            1
        ],
        [
            6400,
            6430,
            1
        ],
        [
            6480,
            6509,
            1
        ],
        [
            6512,
            6516,
            1
        ],
        [
            6528,
            6571,
            1
        ],
        [
            6576,
            6601,
            1
        ],
        [
            6656,
            6678,
            1
        ],
        [
            6688,
            6740,
            1
        ],
        [
            6823,
            6917,
            94
        ],
        [
            6918,
            6963,
            1
        ],
        [
            6981,
            6988,
            1
        ],
        [
            7043,
            7072,
            1
        ],
        [
            7086,
            7087,
            1
        ],
        [
            7098,
            7141,
            1
        ],
        [
            7168,
            7203,
            1
        ],
        [
            7245,
            7247,
            1
        ],
        [
            7258,
            7293,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            7401,
            7404,
            1
        ],
        [
            7406,
            7411,
            1
        ],
        [
            7413,
            7414,
            1
        ],
        [
            7418,
            7424,
            6
        ],
        [
            7425,
            7615,
            1
        ],
        [
            7680,
            7957,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7968,
            8005,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8016,
            8023,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8032,
            8061,
            1
        ],
        [
            8064,
            8116,
            1
        ],
        [
            8118,
            8124,
            1
        ],
        [
            8126,
            8130,
            4
        ],
        [
            8131,
            8132,
            1
        ],
        [
            8134,
            8140,
            1
        ],
        [
            8144,
            8147,
            1
        ],
        [
            8150,
            8155,
            1
        ],
        [
            8160,
            8172,
            1
        ],
        [
            8178,
            8180,
            1
        ],
        [
            8182,
            8188,
            1
        ],
        [
            8305,
            8319,
            14
        ],
        [
            8336,
            8348,
            1
        ],
        [
            8450,
            8455,
            5
        ],
        [
            8458,
            8467,
            1
        ],
        [
            8469,
            8473,
            4
        ],
        [
            8474,
            8477,
            1
        ],
        [
            8484,
            8490,
            2
        ],
        [
            8491,
            8493,
            1
        ],
        [
            8495,
            8505,
            1
        ],
        [
            8508,
            8511,
            1
        ],
        [
            8517,
            8521,
            1
        ],
        [
            8526,
            8579,
            53
        ],
        [
            8580,
            11264,
            2684
        ],
        [
            11265,
            11492,
            1
        ],
        [
            11499,
            11502,
            1
        ],
        [
            11506,
            11507,
            1
        ],
        [
            11520,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ],
        [
            11568,
            11623,
            1
        ],
        [
            11631,
            11648,
            17
        ],
        [
            11649,
            11670,
            1
        ],
        [
            11680,
            11686,
            1
        ],
        [
            11688,
            11694,
            1
        ],
        [
            11696,
            11702,
            1
        ],
        [
            11704,
            11710,
            1
        ],
        [
            11712,
            11718,
            1
        ],
        [
            11720,
            11726,
            1
        ],
        [
            11728,
            11734,
            1
        ],
        [
            11736,
            11742,
            1
        ],
        [
            11823,
            12293,
            470
        ],
        [
            12294,
            12337,
            43
        ],
        [
            12338,
            12341,
            1
        ],
        [
            12347,
            12348,
            1
        ],
        [
            12353,
            12438,
            1
        ],
        [
            12445,
            12447,
            1
        ],
        [
            12449,
            12538,
            1
        ],
        [
            12540,
            12543,
            1
        ],
        [
            12549,
            12591,
            1
        ],
        [
            12593,
            12686,
            1
        ],
        [
            12704,
            12735,
            1
        ],
        [
            12784,
            12799,
            1
        ],
        [
            13312,
            19903,
            1
        ],
        [
            19968,
            42124,
            1
        ],
        [
            42192,
            42237,
            1
        ],
        [
            42240,
            42508,
            1
        ],
        [
            42512,
            42527,
            1
        ],
        [
            42538,
            42539,
            1
        ],
        [
            42560,
            42606,
            1
        ],
        [
            42623,
            42653,
            1
        ],
        [
            42656,
            42725,
            1
        ],
        [
            42775,
            42783,
            1
        ],
        [
            42786,
            42888,
            1
        ],
        [
            42891,
            42954,
            1
        ],
        [
            42960,
            42961,
            1
        ],
        [
            42963,
            42965,
            2
        ],
        [
            42966,
            42969,
            1
        ],
        [
            42994,
            43009,
            1
        ],
        [
            43011,
            43013,
            1
        ],
        [
            43015,
            43018,
            1
        ],
        [
            43020,
            43042,
            1
        ],
        [
            43072,
            43123,
            1
        ],
        [
            43138,
            43187,
            1
        ],
        [
            43250,
            43255,
            1
        ],
        [
            43259,
            43261,
            2
        ],
        [
            43262,
            43274,
            12
        ],
        [
            43275,
            43301,
            1
        ],
        [
            43312,
            43334,
            1
        ],
        [
            43360,
            43388,
            1
        ],
        [
            43396,
            43442,
            1
        ],
        [
            43471,
            43488,
            17
        ],
        [
            43489,
            43492,
            1
        ],
        [
            43494,
            43503,
            1
        ],
        [
            43514,
            43518,
            1
        ],
        [
            43520,
            43560,
            1
        ],
        [
            43584,
            43586,
            1
        ],
        [
            43588,
            43595,
            1
        ],
        [
            43616,
            43638,
            1
        ],
        [
            43642,
            43646,
            4
        ],
        [
            43647,
            43695,
            1
        ],
        [
            43697,
            43701,
            4
        ],
        [
            43702,
            43705,
            3
        ],
        [
            43706,
            43709,
            1
        ],
        [
            43712,
            43714,
            2
        ],
        [
            43739,
            43741,
            1
        ],
        [
            43744,
            43754,
            1
        ],
        [
            43762,
            43764,
            1
        ],
        [
            43777,
            43782,
            1
        ],
        [
            43785,
            43790,
            1
        ],
        [
            43793,
            43798,
            1
        ],
        [
            43808,
            43814,
            1
        ],
        [
            43816,
            43822,
            1
        ],
        [
            43824,
            43866,
            1
        ],
        [
            43868,
            43881,
            1
        ],
        [
            43888,
            44002,
            1
        ],
        [
            44032,
            55203,
            1
        ],
        [
            55216,
            55238,
            1
        ],
        [
            55243,
            55291,
            1
        ],
        [
            63744,
            64109,
            1
        ],
        [
            64112,
            64217,
            1
        ],
        [
            64256,
            64262,
            1
        ],
        [
            64275,
            64279,
            1
        ],
        [
            64285,
            64287,
            2
        ],
        [
            64288,
            64296,
            1
        ],
        [
            64298,
            64310,
            1
        ],
        [
            64312,
            64316,
            1
        ],
        [
            64318,
            64320,
            2
        ],
        [
            64321,
            64323,
            2
        ],
        [
            64324,
            64326,
            2
        ],
        [
            64327,
            64433,
            1
        ],
        [
            64467,
            64829,
            1
        ],
        [
            64848,
            64911,
            1
        ],
        [
            64914,
            64967,
            1
        ],
        [
            65008,
            65019,
            1
        ],
        [
            65136,
            65140,
            1
        ],
        [
            65142,
            65276,
            1
        ],
        [
            65313,
            65338,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            65382,
            65470,
            1
        ],
        [
            65474,
            65479,
            1
        ],
        [
            65482,
            65487,
            1
        ],
        [
            65490,
            65495,
            1
        ],
        [
            65498,
            65500,
            1
        ],
        [
            65536,
            65547,
            1
        ],
        [
            65549,
            65574,
            1
        ],
        [
            65576,
            65594,
            1
        ],
        [
            65596,
            65597,
            1
        ],
        [
            65599,
            65613,
            1
        ],
        [
            65616,
            65629,
            1
        ],
        [
            65664,
            65786,
            1
        ],
        [
            66176,
            66204,
            1
        ],
        [
            66208,
            66256,
            1
        ],
        [
            66304,
            66335,
            1
        ],
        [
            66349,
            66368,
            1
        ],
        [
            66370,
            66377,
            1
        ],
        [
            66384,
            66421,
            1
        ],
        [
            66432,
            66461,
            1
        ],
        [
            66464,
            66499,
            1
        ],
        [
            66504,
            66511,
            1
        ],
        [
            66560,
            66717,
            1
        ],
        [
            66736,
            66771,
            1
        ],
        [
            66776,
            66811,
            1
        ],
        [
            66816,
            66855,
            1
        ],
        [
            66864,
            66915,
            1
        ],
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ],
        [
            67072,
            67382,
            1
        ],
        [
            67392,
            67413,
            1
        ],
        [
            67424,
            67431,
            1
        ],
        [
            67456,
            67461,
            1
        ],
        [
            67463,
            67504,
            1
        ],
        [
            67506,
            67514,
            1
        ],
        [
            67584,
            67589,
            1
        ],
        [
            67592,
            67594,
            2
        ],
        [
            67595,
            67637,
            1
        ],
        [
            67639,
            67640,
            1
        ],
        [
            67644,
            67647,
            3
        ],
        [
            67648,
            67669,
            1
        ],
        [
            67680,
            67702,
            1
        ],
        [
            67712,
            67742,
            1
        ],
        [
            67808,
            67826,
            1
        ],
        [
            67828,
            67829,
            1
        ],
        [
            67840,
            67861,
            1
        ],
        [
            67872,
            67897,
            1
        ],
        [
            67968,
            68023,
            1
        ],
        [
            68030,
            68031,
            1
        ],
        [
            68096,
            68112,
            16
        ],
        [
            68113,
            68115,
            1
        ],
        [
            68117,
            68119,
            1
        ],
        [
            68121,
            68149,
            1
        ],
        [
            68192,
            68220,
            1
        ],
        [
            68224,
            68252,
            1
        ],
        [
            68288,
            68295,
            1
        ],
        [
            68297,
            68324,
            1
        ],
        [
            68352,
            68405,
            1
        ],
        [
            68416,
            68437,
            1
        ],
        [
            68448,
            68466,
            1
        ],
        [
            68480,
            68497,
            1
        ],
        [
            68608,
            68680,
            1
        ],
        [
            68736,
            68786,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            68864,
            68899,
            1
        ],
        [
            69248,
            69289,
            1
        ],
        [
            69296,
            69297,
            1
        ],
        [
            69376,
            69404,
            1
        ],
        [
            69415,
            69424,
            9
        ],
        [
            69425,
            69445,
            1
        ],
        [
            69488,
            69505,
            1
        ],
        [
            69552,
            69572,
            1
        ],
        [
            69600,
            69622,
            1
        ],
        [
            69635,
            69687,
            1
        ],
        [
            69745,
            69746,
            1
        ],
        [
            69749,
            69763,
            14
        ],
        [
            69764,
            69807,
            1
        ],
        [
            69840,
            69864,
            1
        ],
        [
            69891,
            69926,
            1
        ],
        [
            69956,
            69959,
            3
        ],
        [
            69968,
            70002,
            1
        ],
        [
            70006,
            70019,
            13
        ],
        [
            70020,
            70066,
            1
        ],
        [
            70081,
            70084,
            1
        ],
        [
            70106,
            70108,
            2
        ],
        [
            70144,
            70161,
            1
        ],
        [
            70163,
            70187,
            1
        ],
        [
            70207,
            70208,
            1
        ],
        [
            70272,
            70278,
            1
        ],
        [
            70280,
            70282,
            2
        ],
        [
            70283,
            70285,
            1
        ],
        [
            70287,
            70301,
            1
        ],
        [
            70303,
            70312,
            1
        ],
        [
            70320,
            70366,
            1
        ],
        [
            70405,
            70412,
            1
        ],
        [
            70415,
            70416,
            1
        ],
        [
            70419,
            70440,
            1
        ],
        [
            70442,
            70448,
            1
        ],
        [
            70450,
            70451,
            1
        ],
        [
            70453,
            70457,
            1
        ],
        [
            70461,
            70480,
            19
        ],
        [
            70493,
            70497,
            1
        ],
        [
            70656,
            70708,
            1
        ],
        [
            70727,
            70730,
            1
        ],
        [
            70751,
            70753,
            1
        ],
        [
            70784,
            70831,
            1
        ],
        [
            70852,
            70853,
            1
        ],
        [
            70855,
            71040,
            185
        ],
        [
            71041,
            71086,
            1
        ],
        [
            71128,
            71131,
            1
        ],
        [
            71168,
            71215,
            1
        ],
        [
            71236,
            71296,
            60
        ],
        [
            71297,
            71338,
            1
        ],
        [
            71352,
            71424,
            72
        ],
        [
            71425,
            71450,
            1
        ],
        [
            71488,
            71494,
            1
        ],
        [
            71680,
            71723,
            1
        ],
        [
            71840,
            71903,
            1
        ],
        [
            71935,
            71942,
            1
        ],
        [
            71945,
            71948,
            3
        ],
        [
            71949,
            71955,
            1
        ],
        [
            71957,
            71958,
            1
        ],
        [
            71960,
            71983,
            1
        ],
        [
            71999,
            72001,
            2
        ],
        [
            72096,
            72103,
            1
        ],
        [
            72106,
            72144,
            1
        ],
        [
            72161,
            72163,
            2
        ],
        [
            72192,
            72203,
            11
        ],
        [
            72204,
            72242,
            1
        ],
        [
            72250,
            72272,
            22
        ],
        [
            72284,
            72329,
            1
        ],
        [
            72349,
            72368,
            19
        ],
        [
            72369,
            72440,
            1
        ],
        [
            72704,
            72712,
            1
        ],
        [
            72714,
            72750,
            1
        ],
        [
            72768,
            72818,
            50
        ],
        [
            72819,
            72847,
            1
        ],
        [
            72960,
            72966,
            1
        ],
        [
            72968,
            72969,
            1
        ],
        [
            72971,
            73008,
            1
        ],
        [
            73030,
            73056,
            26
        ],
        [
            73057,
            73061,
            1
        ],
        [
            73063,
            73064,
            1
        ],
        [
            73066,
            73097,
            1
        ],
        [
            73112,
            73440,
            328
        ],
        [
            73441,
            73458,
            1
        ],
        [
            73474,
            73476,
            2
        ],
        [
            73477,
            73488,
            1
        ],
        [
            73490,
            73523,
            1
        ],
        [
            73648,
            73728,
            80
        ],
        [
            73729,
            74649,
            1
        ],
        [
            74880,
            75075,
            1
        ],
        [
            77712,
            77808,
            1
        ],
        [
            77824,
            78895,
            1
        ],
        [
            78913,
            78918,
            1
        ],
        [
            82944,
            83526,
            1
        ],
        [
            92160,
            92728,
            1
        ],
        [
            92736,
            92766,
            1
        ],
        [
            92784,
            92862,
            1
        ],
        [
            92880,
            92909,
            1
        ],
        [
            92928,
            92975,
            1
        ],
        [
            92992,
            92995,
            1
        ],
        [
            93027,
            93047,
            1
        ],
        [
            93053,
            93071,
            1
        ],
        [
            93760,
            93823,
            1
        ],
        [
            93952,
            94026,
            1
        ],
        [
            94032,
            94099,
            67
        ],
        [
            94100,
            94111,
            1
        ],
        [
            94176,
            94177,
            1
        ],
        [
            94179,
            94208,
            29
        ],
        [
            94209,
            100343,
            1
        ],
        [
            100352,
            101589,
            1
        ],
        [
            101632,
            101640,
            1
        ],
        [
            110576,
            110579,
            1
        ],
        [
            110581,
            110587,
            1
        ],
        [
            110589,
            110590,
            1
        ],
        [
            110592,
            110882,
            1
        ],
        [
            110898,
            110928,
            30
        ],
        [
            110929,
            110930,
            1
        ],
        [
            110933,
            110948,
            15
        ],
        [
            110949,
            110951,
            1
        ],
        [
            110960,
            111355,
            1
        ],
        [
            113664,
            113770,
            1
        ],
        [
            113776,
            113788,
            1
        ],
        [
            113792,
            113800,
            1
        ],
        [
            113808,
            113817,
            1
        ],
        [
            119808,
            119892,
            1
        ],
        [
            119894,
            119964,
            1
        ],
        [
            119966,
            119967,
            1
        ],
        [
            119970,
            119973,
            3
        ],
        [
            119974,
            119977,
            3
        ],
        [
            119978,
            119980,
            1
        ],
        [
            119982,
            119993,
            1
        ],
        [
            119995,
            119997,
            2
        ],
        [
            119998,
            120003,
            1
        ],
        [
            120005,
            120069,
            1
        ],
        [
            120071,
            120074,
            1
        ],
        [
            120077,
            120084,
            1
        ],
        [
            120086,
            120092,
            1
        ],
        [
            120094,
            120121,
            1
        ],
        [
            120123,
            120126,
            1
        ],
        [
            120128,
            120132,
            1
        ],
        [
            120134,
            120138,
            4
        ],
        [
            120139,
            120144,
            1
        ],
        [
            120146,
            120485,
            1
        ],
        [
            120488,
            120512,
            1
        ],
        [
            120514,
            120538,
            1
        ],
        [
            120540,
            120570,
            1
        ],
        [
            120572,
            120596,
            1
        ],
        [
            120598,
            120628,
            1
        ],
        [
            120630,
            120654,
            1
        ],
        [
            120656,
            120686,
            1
        ],
        [
            120688,
            120712,
            1
        ],
        [
            120714,
            120744,
            1
        ],
        [
            120746,
            120770,
            1
        ],
        [
            120772,
            120779,
            1
        ],
        [
            122624,
            122654,
            1
        ],
        [
            122661,
            122666,
            1
        ],
        [
            122928,
            122989,
            1
        ],
        [
            123136,
            123180,
            1
        ],
        [
            123191,
            123197,
            1
        ],
        [
            123214,
            123536,
            322
        ],
        [
            123537,
            123565,
            1
        ],
        [
            123584,
            123627,
            1
        ],
        [
            124112,
            124139,
            1
        ],
        [
            124896,
            124902,
            1
        ],
        [
            124904,
            124907,
            1
        ],
        [
            124909,
            124910,
            1
        ],
        [
            124912,
            124926,
            1
        ],
        [
            124928,
            125124,
            1
        ],
        [
            125184,
            125251,
            1
        ],
        [
            125259,
            126464,
            1205
        ],
        [
            126465,
            126467,
            1
        ],
        [
            126469,
            126495,
            1
        ],
        [
            126497,
            126498,
            1
        ],
        [
            126500,
            126503,
            3
        ],
        [
            126505,
            126514,
            1
        ],
        [
            126516,
            126519,
            1
        ],
        [
            126521,
            126523,
            2
        ],
        [
            126530,
            126535,
            5
        ],
        [
            126537,
            126541,
            2
        ],
        [
            126542,
            126543,
            1
        ],
        [
            126545,
            126546,
            1
        ],
        [
            126548,
            126551,
            3
        ],
        [
            126553,
            126561,
            2
        ],
        [
            126562,
            126564,
            2
        ],
        [
            126567,
            126570,
            1
        ],
        [
            126572,
            126578,
            1
        ],
        [
            126580,
            126583,
            1
        ],
        [
            126585,
            126588,
            1
        ],
        [
            126590,
            126592,
            2
        ],
        [
            126593,
            126601,
            1
        ],
        [
            126603,
            126619,
            1
        ],
        [
            126625,
            126627,
            1
        ],
        [
            126629,
            126633,
            1
        ],
        [
            126635,
            126651,
            1
        ],
        [
            131072,
            173791,
            1
        ],
        [
            173824,
            177977,
            1
        ],
        [
            177984,
            178205,
            1
        ],
        [
            178208,
            183969,
            1
        ],
        [
            183984,
            191456,
            1
        ],
        [
            191472,
            192093,
            1
        ],
        [
            194560,
            195101,
            1
        ],
        [
            196608,
            201546,
            1
        ],
        [
            201552,
            205743,
            1
        ]
    ];
    static foldL = [
        [
            837,
            837,
            1
        ]
    ];
    static Ll = [
        [
            97,
            122,
            1
        ],
        [
            181,
            223,
            42
        ],
        [
            224,
            246,
            1
        ],
        [
            248,
            255,
            1
        ],
        [
            257,
            311,
            2
        ],
        [
            312,
            328,
            2
        ],
        [
            329,
            375,
            2
        ],
        [
            378,
            382,
            2
        ],
        [
            383,
            384,
            1
        ],
        [
            387,
            389,
            2
        ],
        [
            392,
            396,
            4
        ],
        [
            397,
            402,
            5
        ],
        [
            405,
            409,
            4
        ],
        [
            410,
            411,
            1
        ],
        [
            414,
            417,
            3
        ],
        [
            419,
            421,
            2
        ],
        [
            424,
            426,
            2
        ],
        [
            427,
            429,
            2
        ],
        [
            432,
            436,
            4
        ],
        [
            438,
            441,
            3
        ],
        [
            442,
            445,
            3
        ],
        [
            446,
            447,
            1
        ],
        [
            454,
            460,
            3
        ],
        [
            462,
            476,
            2
        ],
        [
            477,
            495,
            2
        ],
        [
            496,
            499,
            3
        ],
        [
            501,
            505,
            4
        ],
        [
            507,
            563,
            2
        ],
        [
            564,
            569,
            1
        ],
        [
            572,
            575,
            3
        ],
        [
            576,
            578,
            2
        ],
        [
            583,
            591,
            2
        ],
        [
            592,
            659,
            1
        ],
        [
            661,
            687,
            1
        ],
        [
            881,
            883,
            2
        ],
        [
            887,
            891,
            4
        ],
        [
            892,
            893,
            1
        ],
        [
            912,
            940,
            28
        ],
        [
            941,
            974,
            1
        ],
        [
            976,
            977,
            1
        ],
        [
            981,
            983,
            1
        ],
        [
            985,
            1007,
            2
        ],
        [
            1008,
            1011,
            1
        ],
        [
            1013,
            1019,
            3
        ],
        [
            1020,
            1072,
            52
        ],
        [
            1073,
            1119,
            1
        ],
        [
            1121,
            1153,
            2
        ],
        [
            1163,
            1215,
            2
        ],
        [
            1218,
            1230,
            2
        ],
        [
            1231,
            1327,
            2
        ],
        [
            1376,
            1416,
            1
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4349,
            4351,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7424,
            7467,
            1
        ],
        [
            7531,
            7543,
            1
        ],
        [
            7545,
            7578,
            1
        ],
        [
            7681,
            7829,
            2
        ],
        [
            7830,
            7837,
            1
        ],
        [
            7839,
            7935,
            2
        ],
        [
            7936,
            7943,
            1
        ],
        [
            7952,
            7957,
            1
        ],
        [
            7968,
            7975,
            1
        ],
        [
            7984,
            7991,
            1
        ],
        [
            8000,
            8005,
            1
        ],
        [
            8016,
            8023,
            1
        ],
        [
            8032,
            8039,
            1
        ],
        [
            8048,
            8061,
            1
        ],
        [
            8064,
            8071,
            1
        ],
        [
            8080,
            8087,
            1
        ],
        [
            8096,
            8103,
            1
        ],
        [
            8112,
            8116,
            1
        ],
        [
            8118,
            8119,
            1
        ],
        [
            8126,
            8130,
            4
        ],
        [
            8131,
            8132,
            1
        ],
        [
            8134,
            8135,
            1
        ],
        [
            8144,
            8147,
            1
        ],
        [
            8150,
            8151,
            1
        ],
        [
            8160,
            8167,
            1
        ],
        [
            8178,
            8180,
            1
        ],
        [
            8182,
            8183,
            1
        ],
        [
            8458,
            8462,
            4
        ],
        [
            8463,
            8467,
            4
        ],
        [
            8495,
            8505,
            5
        ],
        [
            8508,
            8509,
            1
        ],
        [
            8518,
            8521,
            1
        ],
        [
            8526,
            8580,
            54
        ],
        [
            11312,
            11359,
            1
        ],
        [
            11361,
            11365,
            4
        ],
        [
            11366,
            11372,
            2
        ],
        [
            11377,
            11379,
            2
        ],
        [
            11380,
            11382,
            2
        ],
        [
            11383,
            11387,
            1
        ],
        [
            11393,
            11491,
            2
        ],
        [
            11492,
            11500,
            8
        ],
        [
            11502,
            11507,
            5
        ],
        [
            11520,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ],
        [
            42561,
            42605,
            2
        ],
        [
            42625,
            42651,
            2
        ],
        [
            42787,
            42799,
            2
        ],
        [
            42800,
            42801,
            1
        ],
        [
            42803,
            42865,
            2
        ],
        [
            42866,
            42872,
            1
        ],
        [
            42874,
            42876,
            2
        ],
        [
            42879,
            42887,
            2
        ],
        [
            42892,
            42894,
            2
        ],
        [
            42897,
            42899,
            2
        ],
        [
            42900,
            42901,
            1
        ],
        [
            42903,
            42921,
            2
        ],
        [
            42927,
            42933,
            6
        ],
        [
            42935,
            42947,
            2
        ],
        [
            42952,
            42954,
            2
        ],
        [
            42961,
            42969,
            2
        ],
        [
            42998,
            43002,
            4
        ],
        [
            43824,
            43866,
            1
        ],
        [
            43872,
            43880,
            1
        ],
        [
            43888,
            43967,
            1
        ],
        [
            64256,
            64262,
            1
        ],
        [
            64275,
            64279,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            66600,
            66639,
            1
        ],
        [
            66776,
            66811,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            71872,
            71903,
            1
        ],
        [
            93792,
            93823,
            1
        ],
        [
            119834,
            119859,
            1
        ],
        [
            119886,
            119892,
            1
        ],
        [
            119894,
            119911,
            1
        ],
        [
            119938,
            119963,
            1
        ],
        [
            119990,
            119993,
            1
        ],
        [
            119995,
            119997,
            2
        ],
        [
            119998,
            120003,
            1
        ],
        [
            120005,
            120015,
            1
        ],
        [
            120042,
            120067,
            1
        ],
        [
            120094,
            120119,
            1
        ],
        [
            120146,
            120171,
            1
        ],
        [
            120198,
            120223,
            1
        ],
        [
            120250,
            120275,
            1
        ],
        [
            120302,
            120327,
            1
        ],
        [
            120354,
            120379,
            1
        ],
        [
            120406,
            120431,
            1
        ],
        [
            120458,
            120485,
            1
        ],
        [
            120514,
            120538,
            1
        ],
        [
            120540,
            120545,
            1
        ],
        [
            120572,
            120596,
            1
        ],
        [
            120598,
            120603,
            1
        ],
        [
            120630,
            120654,
            1
        ],
        [
            120656,
            120661,
            1
        ],
        [
            120688,
            120712,
            1
        ],
        [
            120714,
            120719,
            1
        ],
        [
            120746,
            120770,
            1
        ],
        [
            120772,
            120777,
            1
        ],
        [
            120779,
            122624,
            1845
        ],
        [
            122625,
            122633,
            1
        ],
        [
            122635,
            122654,
            1
        ],
        [
            122661,
            122666,
            1
        ],
        [
            125218,
            125251,
            1
        ]
    ];
    static foldLl = [
        [
            65,
            90,
            1
        ],
        [
            192,
            214,
            1
        ],
        [
            216,
            222,
            1
        ],
        [
            256,
            302,
            2
        ],
        [
            306,
            310,
            2
        ],
        [
            313,
            327,
            2
        ],
        [
            330,
            376,
            2
        ],
        [
            377,
            381,
            2
        ],
        [
            385,
            386,
            1
        ],
        [
            388,
            390,
            2
        ],
        [
            391,
            393,
            2
        ],
        [
            394,
            395,
            1
        ],
        [
            398,
            401,
            1
        ],
        [
            403,
            404,
            1
        ],
        [
            406,
            408,
            1
        ],
        [
            412,
            413,
            1
        ],
        [
            415,
            416,
            1
        ],
        [
            418,
            422,
            2
        ],
        [
            423,
            425,
            2
        ],
        [
            428,
            430,
            2
        ],
        [
            431,
            433,
            2
        ],
        [
            434,
            435,
            1
        ],
        [
            437,
            439,
            2
        ],
        [
            440,
            444,
            4
        ],
        [
            452,
            453,
            1
        ],
        [
            455,
            456,
            1
        ],
        [
            458,
            459,
            1
        ],
        [
            461,
            475,
            2
        ],
        [
            478,
            494,
            2
        ],
        [
            497,
            498,
            1
        ],
        [
            500,
            502,
            2
        ],
        [
            503,
            504,
            1
        ],
        [
            506,
            562,
            2
        ],
        [
            570,
            571,
            1
        ],
        [
            573,
            574,
            1
        ],
        [
            577,
            579,
            2
        ],
        [
            580,
            582,
            1
        ],
        [
            584,
            590,
            2
        ],
        [
            837,
            880,
            43
        ],
        [
            882,
            886,
            4
        ],
        [
            895,
            902,
            7
        ],
        [
            904,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            913,
            2
        ],
        [
            914,
            929,
            1
        ],
        [
            931,
            939,
            1
        ],
        [
            975,
            984,
            9
        ],
        [
            986,
            1006,
            2
        ],
        [
            1012,
            1015,
            3
        ],
        [
            1017,
            1018,
            1
        ],
        [
            1021,
            1071,
            1
        ],
        [
            1120,
            1152,
            2
        ],
        [
            1162,
            1216,
            2
        ],
        [
            1217,
            1229,
            2
        ],
        [
            1232,
            1326,
            2
        ],
        [
            1329,
            1366,
            1
        ],
        [
            4256,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            5024,
            5109,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            7680,
            7828,
            2
        ],
        [
            7838,
            7934,
            2
        ],
        [
            7944,
            7951,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7976,
            7983,
            1
        ],
        [
            7992,
            7999,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8040,
            8047,
            1
        ],
        [
            8072,
            8079,
            1
        ],
        [
            8088,
            8095,
            1
        ],
        [
            8104,
            8111,
            1
        ],
        [
            8120,
            8124,
            1
        ],
        [
            8136,
            8140,
            1
        ],
        [
            8152,
            8155,
            1
        ],
        [
            8168,
            8172,
            1
        ],
        [
            8184,
            8188,
            1
        ],
        [
            8486,
            8490,
            4
        ],
        [
            8491,
            8498,
            7
        ],
        [
            8579,
            11264,
            2685
        ],
        [
            11265,
            11311,
            1
        ],
        [
            11360,
            11362,
            2
        ],
        [
            11363,
            11364,
            1
        ],
        [
            11367,
            11373,
            2
        ],
        [
            11374,
            11376,
            1
        ],
        [
            11378,
            11381,
            3
        ],
        [
            11390,
            11392,
            1
        ],
        [
            11394,
            11490,
            2
        ],
        [
            11499,
            11501,
            2
        ],
        [
            11506,
            42560,
            31054
        ],
        [
            42562,
            42604,
            2
        ],
        [
            42624,
            42650,
            2
        ],
        [
            42786,
            42798,
            2
        ],
        [
            42802,
            42862,
            2
        ],
        [
            42873,
            42877,
            2
        ],
        [
            42878,
            42886,
            2
        ],
        [
            42891,
            42893,
            2
        ],
        [
            42896,
            42898,
            2
        ],
        [
            42902,
            42922,
            2
        ],
        [
            42923,
            42926,
            1
        ],
        [
            42928,
            42932,
            1
        ],
        [
            42934,
            42948,
            2
        ],
        [
            42949,
            42951,
            1
        ],
        [
            42953,
            42960,
            7
        ],
        [
            42966,
            42968,
            2
        ],
        [
            42997,
            65313,
            22316
        ],
        [
            65314,
            65338,
            1
        ],
        [
            66560,
            66599,
            1
        ],
        [
            66736,
            66771,
            1
        ],
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            68736,
            68786,
            1
        ],
        [
            71840,
            71871,
            1
        ],
        [
            93760,
            93791,
            1
        ],
        [
            125184,
            125217,
            1
        ]
    ];
    static Lm = [
        [
            688,
            705,
            1
        ],
        [
            710,
            721,
            1
        ],
        [
            736,
            740,
            1
        ],
        [
            748,
            750,
            2
        ],
        [
            884,
            890,
            6
        ],
        [
            1369,
            1600,
            231
        ],
        [
            1765,
            1766,
            1
        ],
        [
            2036,
            2037,
            1
        ],
        [
            2042,
            2074,
            32
        ],
        [
            2084,
            2088,
            4
        ],
        [
            2249,
            2417,
            168
        ],
        [
            3654,
            3782,
            128
        ],
        [
            4348,
            6103,
            1755
        ],
        [
            6211,
            6823,
            612
        ],
        [
            7288,
            7293,
            1
        ],
        [
            7468,
            7530,
            1
        ],
        [
            7544,
            7579,
            35
        ],
        [
            7580,
            7615,
            1
        ],
        [
            8305,
            8319,
            14
        ],
        [
            8336,
            8348,
            1
        ],
        [
            11388,
            11389,
            1
        ],
        [
            11631,
            11823,
            192
        ],
        [
            12293,
            12337,
            44
        ],
        [
            12338,
            12341,
            1
        ],
        [
            12347,
            12445,
            98
        ],
        [
            12446,
            12540,
            94
        ],
        [
            12541,
            12542,
            1
        ],
        [
            40981,
            42232,
            1251
        ],
        [
            42233,
            42237,
            1
        ],
        [
            42508,
            42623,
            115
        ],
        [
            42652,
            42653,
            1
        ],
        [
            42775,
            42783,
            1
        ],
        [
            42864,
            42888,
            24
        ],
        [
            42994,
            42996,
            1
        ],
        [
            43000,
            43001,
            1
        ],
        [
            43471,
            43494,
            23
        ],
        [
            43632,
            43741,
            109
        ],
        [
            43763,
            43764,
            1
        ],
        [
            43868,
            43871,
            1
        ],
        [
            43881,
            65392,
            21511
        ],
        [
            65438,
            65439,
            1
        ],
        [
            67456,
            67461,
            1
        ],
        [
            67463,
            67504,
            1
        ],
        [
            67506,
            67514,
            1
        ],
        [
            92992,
            92995,
            1
        ],
        [
            94099,
            94111,
            1
        ],
        [
            94176,
            94177,
            1
        ],
        [
            94179,
            110576,
            16397
        ],
        [
            110577,
            110579,
            1
        ],
        [
            110581,
            110587,
            1
        ],
        [
            110589,
            110590,
            1
        ],
        [
            122928,
            122989,
            1
        ],
        [
            123191,
            123197,
            1
        ],
        [
            124139,
            125259,
            1120
        ]
    ];
    static Lo = [
        [
            170,
            186,
            16
        ],
        [
            443,
            448,
            5
        ],
        [
            449,
            451,
            1
        ],
        [
            660,
            1488,
            828
        ],
        [
            1489,
            1514,
            1
        ],
        [
            1519,
            1522,
            1
        ],
        [
            1568,
            1599,
            1
        ],
        [
            1601,
            1610,
            1
        ],
        [
            1646,
            1647,
            1
        ],
        [
            1649,
            1747,
            1
        ],
        [
            1749,
            1774,
            25
        ],
        [
            1775,
            1786,
            11
        ],
        [
            1787,
            1788,
            1
        ],
        [
            1791,
            1808,
            17
        ],
        [
            1810,
            1839,
            1
        ],
        [
            1869,
            1957,
            1
        ],
        [
            1969,
            1994,
            25
        ],
        [
            1995,
            2026,
            1
        ],
        [
            2048,
            2069,
            1
        ],
        [
            2112,
            2136,
            1
        ],
        [
            2144,
            2154,
            1
        ],
        [
            2160,
            2183,
            1
        ],
        [
            2185,
            2190,
            1
        ],
        [
            2208,
            2248,
            1
        ],
        [
            2308,
            2361,
            1
        ],
        [
            2365,
            2384,
            19
        ],
        [
            2392,
            2401,
            1
        ],
        [
            2418,
            2432,
            1
        ],
        [
            2437,
            2444,
            1
        ],
        [
            2447,
            2448,
            1
        ],
        [
            2451,
            2472,
            1
        ],
        [
            2474,
            2480,
            1
        ],
        [
            2482,
            2486,
            4
        ],
        [
            2487,
            2489,
            1
        ],
        [
            2493,
            2510,
            17
        ],
        [
            2524,
            2525,
            1
        ],
        [
            2527,
            2529,
            1
        ],
        [
            2544,
            2545,
            1
        ],
        [
            2556,
            2565,
            9
        ],
        [
            2566,
            2570,
            1
        ],
        [
            2575,
            2576,
            1
        ],
        [
            2579,
            2600,
            1
        ],
        [
            2602,
            2608,
            1
        ],
        [
            2610,
            2611,
            1
        ],
        [
            2613,
            2614,
            1
        ],
        [
            2616,
            2617,
            1
        ],
        [
            2649,
            2652,
            1
        ],
        [
            2654,
            2674,
            20
        ],
        [
            2675,
            2676,
            1
        ],
        [
            2693,
            2701,
            1
        ],
        [
            2703,
            2705,
            1
        ],
        [
            2707,
            2728,
            1
        ],
        [
            2730,
            2736,
            1
        ],
        [
            2738,
            2739,
            1
        ],
        [
            2741,
            2745,
            1
        ],
        [
            2749,
            2768,
            19
        ],
        [
            2784,
            2785,
            1
        ],
        [
            2809,
            2821,
            12
        ],
        [
            2822,
            2828,
            1
        ],
        [
            2831,
            2832,
            1
        ],
        [
            2835,
            2856,
            1
        ],
        [
            2858,
            2864,
            1
        ],
        [
            2866,
            2867,
            1
        ],
        [
            2869,
            2873,
            1
        ],
        [
            2877,
            2908,
            31
        ],
        [
            2909,
            2911,
            2
        ],
        [
            2912,
            2913,
            1
        ],
        [
            2929,
            2947,
            18
        ],
        [
            2949,
            2954,
            1
        ],
        [
            2958,
            2960,
            1
        ],
        [
            2962,
            2965,
            1
        ],
        [
            2969,
            2970,
            1
        ],
        [
            2972,
            2974,
            2
        ],
        [
            2975,
            2979,
            4
        ],
        [
            2980,
            2984,
            4
        ],
        [
            2985,
            2986,
            1
        ],
        [
            2990,
            3001,
            1
        ],
        [
            3024,
            3077,
            53
        ],
        [
            3078,
            3084,
            1
        ],
        [
            3086,
            3088,
            1
        ],
        [
            3090,
            3112,
            1
        ],
        [
            3114,
            3129,
            1
        ],
        [
            3133,
            3160,
            27
        ],
        [
            3161,
            3162,
            1
        ],
        [
            3165,
            3168,
            3
        ],
        [
            3169,
            3200,
            31
        ],
        [
            3205,
            3212,
            1
        ],
        [
            3214,
            3216,
            1
        ],
        [
            3218,
            3240,
            1
        ],
        [
            3242,
            3251,
            1
        ],
        [
            3253,
            3257,
            1
        ],
        [
            3261,
            3293,
            32
        ],
        [
            3294,
            3296,
            2
        ],
        [
            3297,
            3313,
            16
        ],
        [
            3314,
            3332,
            18
        ],
        [
            3333,
            3340,
            1
        ],
        [
            3342,
            3344,
            1
        ],
        [
            3346,
            3386,
            1
        ],
        [
            3389,
            3406,
            17
        ],
        [
            3412,
            3414,
            1
        ],
        [
            3423,
            3425,
            1
        ],
        [
            3450,
            3455,
            1
        ],
        [
            3461,
            3478,
            1
        ],
        [
            3482,
            3505,
            1
        ],
        [
            3507,
            3515,
            1
        ],
        [
            3517,
            3520,
            3
        ],
        [
            3521,
            3526,
            1
        ],
        [
            3585,
            3632,
            1
        ],
        [
            3634,
            3635,
            1
        ],
        [
            3648,
            3653,
            1
        ],
        [
            3713,
            3714,
            1
        ],
        [
            3716,
            3718,
            2
        ],
        [
            3719,
            3722,
            1
        ],
        [
            3724,
            3747,
            1
        ],
        [
            3749,
            3751,
            2
        ],
        [
            3752,
            3760,
            1
        ],
        [
            3762,
            3763,
            1
        ],
        [
            3773,
            3776,
            3
        ],
        [
            3777,
            3780,
            1
        ],
        [
            3804,
            3807,
            1
        ],
        [
            3840,
            3904,
            64
        ],
        [
            3905,
            3911,
            1
        ],
        [
            3913,
            3948,
            1
        ],
        [
            3976,
            3980,
            1
        ],
        [
            4096,
            4138,
            1
        ],
        [
            4159,
            4176,
            17
        ],
        [
            4177,
            4181,
            1
        ],
        [
            4186,
            4189,
            1
        ],
        [
            4193,
            4197,
            4
        ],
        [
            4198,
            4206,
            8
        ],
        [
            4207,
            4208,
            1
        ],
        [
            4213,
            4225,
            1
        ],
        [
            4238,
            4352,
            114
        ],
        [
            4353,
            4680,
            1
        ],
        [
            4682,
            4685,
            1
        ],
        [
            4688,
            4694,
            1
        ],
        [
            4696,
            4698,
            2
        ],
        [
            4699,
            4701,
            1
        ],
        [
            4704,
            4744,
            1
        ],
        [
            4746,
            4749,
            1
        ],
        [
            4752,
            4784,
            1
        ],
        [
            4786,
            4789,
            1
        ],
        [
            4792,
            4798,
            1
        ],
        [
            4800,
            4802,
            2
        ],
        [
            4803,
            4805,
            1
        ],
        [
            4808,
            4822,
            1
        ],
        [
            4824,
            4880,
            1
        ],
        [
            4882,
            4885,
            1
        ],
        [
            4888,
            4954,
            1
        ],
        [
            4992,
            5007,
            1
        ],
        [
            5121,
            5740,
            1
        ],
        [
            5743,
            5759,
            1
        ],
        [
            5761,
            5786,
            1
        ],
        [
            5792,
            5866,
            1
        ],
        [
            5873,
            5880,
            1
        ],
        [
            5888,
            5905,
            1
        ],
        [
            5919,
            5937,
            1
        ],
        [
            5952,
            5969,
            1
        ],
        [
            5984,
            5996,
            1
        ],
        [
            5998,
            6000,
            1
        ],
        [
            6016,
            6067,
            1
        ],
        [
            6108,
            6176,
            68
        ],
        [
            6177,
            6210,
            1
        ],
        [
            6212,
            6264,
            1
        ],
        [
            6272,
            6276,
            1
        ],
        [
            6279,
            6312,
            1
        ],
        [
            6314,
            6320,
            6
        ],
        [
            6321,
            6389,
            1
        ],
        [
            6400,
            6430,
            1
        ],
        [
            6480,
            6509,
            1
        ],
        [
            6512,
            6516,
            1
        ],
        [
            6528,
            6571,
            1
        ],
        [
            6576,
            6601,
            1
        ],
        [
            6656,
            6678,
            1
        ],
        [
            6688,
            6740,
            1
        ],
        [
            6917,
            6963,
            1
        ],
        [
            6981,
            6988,
            1
        ],
        [
            7043,
            7072,
            1
        ],
        [
            7086,
            7087,
            1
        ],
        [
            7098,
            7141,
            1
        ],
        [
            7168,
            7203,
            1
        ],
        [
            7245,
            7247,
            1
        ],
        [
            7258,
            7287,
            1
        ],
        [
            7401,
            7404,
            1
        ],
        [
            7406,
            7411,
            1
        ],
        [
            7413,
            7414,
            1
        ],
        [
            7418,
            8501,
            1083
        ],
        [
            8502,
            8504,
            1
        ],
        [
            11568,
            11623,
            1
        ],
        [
            11648,
            11670,
            1
        ],
        [
            11680,
            11686,
            1
        ],
        [
            11688,
            11694,
            1
        ],
        [
            11696,
            11702,
            1
        ],
        [
            11704,
            11710,
            1
        ],
        [
            11712,
            11718,
            1
        ],
        [
            11720,
            11726,
            1
        ],
        [
            11728,
            11734,
            1
        ],
        [
            11736,
            11742,
            1
        ],
        [
            12294,
            12348,
            54
        ],
        [
            12353,
            12438,
            1
        ],
        [
            12447,
            12449,
            2
        ],
        [
            12450,
            12538,
            1
        ],
        [
            12543,
            12549,
            6
        ],
        [
            12550,
            12591,
            1
        ],
        [
            12593,
            12686,
            1
        ],
        [
            12704,
            12735,
            1
        ],
        [
            12784,
            12799,
            1
        ],
        [
            13312,
            19903,
            1
        ],
        [
            19968,
            40980,
            1
        ],
        [
            40982,
            42124,
            1
        ],
        [
            42192,
            42231,
            1
        ],
        [
            42240,
            42507,
            1
        ],
        [
            42512,
            42527,
            1
        ],
        [
            42538,
            42539,
            1
        ],
        [
            42606,
            42656,
            50
        ],
        [
            42657,
            42725,
            1
        ],
        [
            42895,
            42999,
            104
        ],
        [
            43003,
            43009,
            1
        ],
        [
            43011,
            43013,
            1
        ],
        [
            43015,
            43018,
            1
        ],
        [
            43020,
            43042,
            1
        ],
        [
            43072,
            43123,
            1
        ],
        [
            43138,
            43187,
            1
        ],
        [
            43250,
            43255,
            1
        ],
        [
            43259,
            43261,
            2
        ],
        [
            43262,
            43274,
            12
        ],
        [
            43275,
            43301,
            1
        ],
        [
            43312,
            43334,
            1
        ],
        [
            43360,
            43388,
            1
        ],
        [
            43396,
            43442,
            1
        ],
        [
            43488,
            43492,
            1
        ],
        [
            43495,
            43503,
            1
        ],
        [
            43514,
            43518,
            1
        ],
        [
            43520,
            43560,
            1
        ],
        [
            43584,
            43586,
            1
        ],
        [
            43588,
            43595,
            1
        ],
        [
            43616,
            43631,
            1
        ],
        [
            43633,
            43638,
            1
        ],
        [
            43642,
            43646,
            4
        ],
        [
            43647,
            43695,
            1
        ],
        [
            43697,
            43701,
            4
        ],
        [
            43702,
            43705,
            3
        ],
        [
            43706,
            43709,
            1
        ],
        [
            43712,
            43714,
            2
        ],
        [
            43739,
            43740,
            1
        ],
        [
            43744,
            43754,
            1
        ],
        [
            43762,
            43777,
            15
        ],
        [
            43778,
            43782,
            1
        ],
        [
            43785,
            43790,
            1
        ],
        [
            43793,
            43798,
            1
        ],
        [
            43808,
            43814,
            1
        ],
        [
            43816,
            43822,
            1
        ],
        [
            43968,
            44002,
            1
        ],
        [
            44032,
            55203,
            1
        ],
        [
            55216,
            55238,
            1
        ],
        [
            55243,
            55291,
            1
        ],
        [
            63744,
            64109,
            1
        ],
        [
            64112,
            64217,
            1
        ],
        [
            64285,
            64287,
            2
        ],
        [
            64288,
            64296,
            1
        ],
        [
            64298,
            64310,
            1
        ],
        [
            64312,
            64316,
            1
        ],
        [
            64318,
            64320,
            2
        ],
        [
            64321,
            64323,
            2
        ],
        [
            64324,
            64326,
            2
        ],
        [
            64327,
            64433,
            1
        ],
        [
            64467,
            64829,
            1
        ],
        [
            64848,
            64911,
            1
        ],
        [
            64914,
            64967,
            1
        ],
        [
            65008,
            65019,
            1
        ],
        [
            65136,
            65140,
            1
        ],
        [
            65142,
            65276,
            1
        ],
        [
            65382,
            65391,
            1
        ],
        [
            65393,
            65437,
            1
        ],
        [
            65440,
            65470,
            1
        ],
        [
            65474,
            65479,
            1
        ],
        [
            65482,
            65487,
            1
        ],
        [
            65490,
            65495,
            1
        ],
        [
            65498,
            65500,
            1
        ],
        [
            65536,
            65547,
            1
        ],
        [
            65549,
            65574,
            1
        ],
        [
            65576,
            65594,
            1
        ],
        [
            65596,
            65597,
            1
        ],
        [
            65599,
            65613,
            1
        ],
        [
            65616,
            65629,
            1
        ],
        [
            65664,
            65786,
            1
        ],
        [
            66176,
            66204,
            1
        ],
        [
            66208,
            66256,
            1
        ],
        [
            66304,
            66335,
            1
        ],
        [
            66349,
            66368,
            1
        ],
        [
            66370,
            66377,
            1
        ],
        [
            66384,
            66421,
            1
        ],
        [
            66432,
            66461,
            1
        ],
        [
            66464,
            66499,
            1
        ],
        [
            66504,
            66511,
            1
        ],
        [
            66640,
            66717,
            1
        ],
        [
            66816,
            66855,
            1
        ],
        [
            66864,
            66915,
            1
        ],
        [
            67072,
            67382,
            1
        ],
        [
            67392,
            67413,
            1
        ],
        [
            67424,
            67431,
            1
        ],
        [
            67584,
            67589,
            1
        ],
        [
            67592,
            67594,
            2
        ],
        [
            67595,
            67637,
            1
        ],
        [
            67639,
            67640,
            1
        ],
        [
            67644,
            67647,
            3
        ],
        [
            67648,
            67669,
            1
        ],
        [
            67680,
            67702,
            1
        ],
        [
            67712,
            67742,
            1
        ],
        [
            67808,
            67826,
            1
        ],
        [
            67828,
            67829,
            1
        ],
        [
            67840,
            67861,
            1
        ],
        [
            67872,
            67897,
            1
        ],
        [
            67968,
            68023,
            1
        ],
        [
            68030,
            68031,
            1
        ],
        [
            68096,
            68112,
            16
        ],
        [
            68113,
            68115,
            1
        ],
        [
            68117,
            68119,
            1
        ],
        [
            68121,
            68149,
            1
        ],
        [
            68192,
            68220,
            1
        ],
        [
            68224,
            68252,
            1
        ],
        [
            68288,
            68295,
            1
        ],
        [
            68297,
            68324,
            1
        ],
        [
            68352,
            68405,
            1
        ],
        [
            68416,
            68437,
            1
        ],
        [
            68448,
            68466,
            1
        ],
        [
            68480,
            68497,
            1
        ],
        [
            68608,
            68680,
            1
        ],
        [
            68864,
            68899,
            1
        ],
        [
            69248,
            69289,
            1
        ],
        [
            69296,
            69297,
            1
        ],
        [
            69376,
            69404,
            1
        ],
        [
            69415,
            69424,
            9
        ],
        [
            69425,
            69445,
            1
        ],
        [
            69488,
            69505,
            1
        ],
        [
            69552,
            69572,
            1
        ],
        [
            69600,
            69622,
            1
        ],
        [
            69635,
            69687,
            1
        ],
        [
            69745,
            69746,
            1
        ],
        [
            69749,
            69763,
            14
        ],
        [
            69764,
            69807,
            1
        ],
        [
            69840,
            69864,
            1
        ],
        [
            69891,
            69926,
            1
        ],
        [
            69956,
            69959,
            3
        ],
        [
            69968,
            70002,
            1
        ],
        [
            70006,
            70019,
            13
        ],
        [
            70020,
            70066,
            1
        ],
        [
            70081,
            70084,
            1
        ],
        [
            70106,
            70108,
            2
        ],
        [
            70144,
            70161,
            1
        ],
        [
            70163,
            70187,
            1
        ],
        [
            70207,
            70208,
            1
        ],
        [
            70272,
            70278,
            1
        ],
        [
            70280,
            70282,
            2
        ],
        [
            70283,
            70285,
            1
        ],
        [
            70287,
            70301,
            1
        ],
        [
            70303,
            70312,
            1
        ],
        [
            70320,
            70366,
            1
        ],
        [
            70405,
            70412,
            1
        ],
        [
            70415,
            70416,
            1
        ],
        [
            70419,
            70440,
            1
        ],
        [
            70442,
            70448,
            1
        ],
        [
            70450,
            70451,
            1
        ],
        [
            70453,
            70457,
            1
        ],
        [
            70461,
            70480,
            19
        ],
        [
            70493,
            70497,
            1
        ],
        [
            70656,
            70708,
            1
        ],
        [
            70727,
            70730,
            1
        ],
        [
            70751,
            70753,
            1
        ],
        [
            70784,
            70831,
            1
        ],
        [
            70852,
            70853,
            1
        ],
        [
            70855,
            71040,
            185
        ],
        [
            71041,
            71086,
            1
        ],
        [
            71128,
            71131,
            1
        ],
        [
            71168,
            71215,
            1
        ],
        [
            71236,
            71296,
            60
        ],
        [
            71297,
            71338,
            1
        ],
        [
            71352,
            71424,
            72
        ],
        [
            71425,
            71450,
            1
        ],
        [
            71488,
            71494,
            1
        ],
        [
            71680,
            71723,
            1
        ],
        [
            71935,
            71942,
            1
        ],
        [
            71945,
            71948,
            3
        ],
        [
            71949,
            71955,
            1
        ],
        [
            71957,
            71958,
            1
        ],
        [
            71960,
            71983,
            1
        ],
        [
            71999,
            72001,
            2
        ],
        [
            72096,
            72103,
            1
        ],
        [
            72106,
            72144,
            1
        ],
        [
            72161,
            72163,
            2
        ],
        [
            72192,
            72203,
            11
        ],
        [
            72204,
            72242,
            1
        ],
        [
            72250,
            72272,
            22
        ],
        [
            72284,
            72329,
            1
        ],
        [
            72349,
            72368,
            19
        ],
        [
            72369,
            72440,
            1
        ],
        [
            72704,
            72712,
            1
        ],
        [
            72714,
            72750,
            1
        ],
        [
            72768,
            72818,
            50
        ],
        [
            72819,
            72847,
            1
        ],
        [
            72960,
            72966,
            1
        ],
        [
            72968,
            72969,
            1
        ],
        [
            72971,
            73008,
            1
        ],
        [
            73030,
            73056,
            26
        ],
        [
            73057,
            73061,
            1
        ],
        [
            73063,
            73064,
            1
        ],
        [
            73066,
            73097,
            1
        ],
        [
            73112,
            73440,
            328
        ],
        [
            73441,
            73458,
            1
        ],
        [
            73474,
            73476,
            2
        ],
        [
            73477,
            73488,
            1
        ],
        [
            73490,
            73523,
            1
        ],
        [
            73648,
            73728,
            80
        ],
        [
            73729,
            74649,
            1
        ],
        [
            74880,
            75075,
            1
        ],
        [
            77712,
            77808,
            1
        ],
        [
            77824,
            78895,
            1
        ],
        [
            78913,
            78918,
            1
        ],
        [
            82944,
            83526,
            1
        ],
        [
            92160,
            92728,
            1
        ],
        [
            92736,
            92766,
            1
        ],
        [
            92784,
            92862,
            1
        ],
        [
            92880,
            92909,
            1
        ],
        [
            92928,
            92975,
            1
        ],
        [
            93027,
            93047,
            1
        ],
        [
            93053,
            93071,
            1
        ],
        [
            93952,
            94026,
            1
        ],
        [
            94032,
            94208,
            176
        ],
        [
            94209,
            100343,
            1
        ],
        [
            100352,
            101589,
            1
        ],
        [
            101632,
            101640,
            1
        ],
        [
            110592,
            110882,
            1
        ],
        [
            110898,
            110928,
            30
        ],
        [
            110929,
            110930,
            1
        ],
        [
            110933,
            110948,
            15
        ],
        [
            110949,
            110951,
            1
        ],
        [
            110960,
            111355,
            1
        ],
        [
            113664,
            113770,
            1
        ],
        [
            113776,
            113788,
            1
        ],
        [
            113792,
            113800,
            1
        ],
        [
            113808,
            113817,
            1
        ],
        [
            122634,
            123136,
            502
        ],
        [
            123137,
            123180,
            1
        ],
        [
            123214,
            123536,
            322
        ],
        [
            123537,
            123565,
            1
        ],
        [
            123584,
            123627,
            1
        ],
        [
            124112,
            124138,
            1
        ],
        [
            124896,
            124902,
            1
        ],
        [
            124904,
            124907,
            1
        ],
        [
            124909,
            124910,
            1
        ],
        [
            124912,
            124926,
            1
        ],
        [
            124928,
            125124,
            1
        ],
        [
            126464,
            126467,
            1
        ],
        [
            126469,
            126495,
            1
        ],
        [
            126497,
            126498,
            1
        ],
        [
            126500,
            126503,
            3
        ],
        [
            126505,
            126514,
            1
        ],
        [
            126516,
            126519,
            1
        ],
        [
            126521,
            126523,
            2
        ],
        [
            126530,
            126535,
            5
        ],
        [
            126537,
            126541,
            2
        ],
        [
            126542,
            126543,
            1
        ],
        [
            126545,
            126546,
            1
        ],
        [
            126548,
            126551,
            3
        ],
        [
            126553,
            126561,
            2
        ],
        [
            126562,
            126564,
            2
        ],
        [
            126567,
            126570,
            1
        ],
        [
            126572,
            126578,
            1
        ],
        [
            126580,
            126583,
            1
        ],
        [
            126585,
            126588,
            1
        ],
        [
            126590,
            126592,
            2
        ],
        [
            126593,
            126601,
            1
        ],
        [
            126603,
            126619,
            1
        ],
        [
            126625,
            126627,
            1
        ],
        [
            126629,
            126633,
            1
        ],
        [
            126635,
            126651,
            1
        ],
        [
            131072,
            173791,
            1
        ],
        [
            173824,
            177977,
            1
        ],
        [
            177984,
            178205,
            1
        ],
        [
            178208,
            183969,
            1
        ],
        [
            183984,
            191456,
            1
        ],
        [
            191472,
            192093,
            1
        ],
        [
            194560,
            195101,
            1
        ],
        [
            196608,
            201546,
            1
        ],
        [
            201552,
            205743,
            1
        ]
    ];
    static Lt = [
        [
            453,
            459,
            3
        ],
        [
            498,
            8072,
            7574
        ],
        [
            8073,
            8079,
            1
        ],
        [
            8088,
            8095,
            1
        ],
        [
            8104,
            8111,
            1
        ],
        [
            8124,
            8140,
            16
        ],
        [
            8188,
            8188,
            1
        ]
    ];
    static foldLt = [
        [
            452,
            454,
            2
        ],
        [
            455,
            457,
            2
        ],
        [
            458,
            460,
            2
        ],
        [
            497,
            499,
            2
        ],
        [
            8064,
            8071,
            1
        ],
        [
            8080,
            8087,
            1
        ],
        [
            8096,
            8103,
            1
        ],
        [
            8115,
            8131,
            16
        ],
        [
            8179,
            8179,
            1
        ]
    ];
    static Lu = [
        [
            65,
            90,
            1
        ],
        [
            192,
            214,
            1
        ],
        [
            216,
            222,
            1
        ],
        [
            256,
            310,
            2
        ],
        [
            313,
            327,
            2
        ],
        [
            330,
            376,
            2
        ],
        [
            377,
            381,
            2
        ],
        [
            385,
            386,
            1
        ],
        [
            388,
            390,
            2
        ],
        [
            391,
            393,
            2
        ],
        [
            394,
            395,
            1
        ],
        [
            398,
            401,
            1
        ],
        [
            403,
            404,
            1
        ],
        [
            406,
            408,
            1
        ],
        [
            412,
            413,
            1
        ],
        [
            415,
            416,
            1
        ],
        [
            418,
            422,
            2
        ],
        [
            423,
            425,
            2
        ],
        [
            428,
            430,
            2
        ],
        [
            431,
            433,
            2
        ],
        [
            434,
            435,
            1
        ],
        [
            437,
            439,
            2
        ],
        [
            440,
            444,
            4
        ],
        [
            452,
            461,
            3
        ],
        [
            463,
            475,
            2
        ],
        [
            478,
            494,
            2
        ],
        [
            497,
            500,
            3
        ],
        [
            502,
            504,
            1
        ],
        [
            506,
            562,
            2
        ],
        [
            570,
            571,
            1
        ],
        [
            573,
            574,
            1
        ],
        [
            577,
            579,
            2
        ],
        [
            580,
            582,
            1
        ],
        [
            584,
            590,
            2
        ],
        [
            880,
            882,
            2
        ],
        [
            886,
            895,
            9
        ],
        [
            902,
            904,
            2
        ],
        [
            905,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            913,
            2
        ],
        [
            914,
            929,
            1
        ],
        [
            931,
            939,
            1
        ],
        [
            975,
            978,
            3
        ],
        [
            979,
            980,
            1
        ],
        [
            984,
            1006,
            2
        ],
        [
            1012,
            1015,
            3
        ],
        [
            1017,
            1018,
            1
        ],
        [
            1021,
            1071,
            1
        ],
        [
            1120,
            1152,
            2
        ],
        [
            1162,
            1216,
            2
        ],
        [
            1217,
            1229,
            2
        ],
        [
            1232,
            1326,
            2
        ],
        [
            1329,
            1366,
            1
        ],
        [
            4256,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            5024,
            5109,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            7680,
            7828,
            2
        ],
        [
            7838,
            7934,
            2
        ],
        [
            7944,
            7951,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7976,
            7983,
            1
        ],
        [
            7992,
            7999,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8040,
            8047,
            1
        ],
        [
            8120,
            8123,
            1
        ],
        [
            8136,
            8139,
            1
        ],
        [
            8152,
            8155,
            1
        ],
        [
            8168,
            8172,
            1
        ],
        [
            8184,
            8187,
            1
        ],
        [
            8450,
            8455,
            5
        ],
        [
            8459,
            8461,
            1
        ],
        [
            8464,
            8466,
            1
        ],
        [
            8469,
            8473,
            4
        ],
        [
            8474,
            8477,
            1
        ],
        [
            8484,
            8490,
            2
        ],
        [
            8491,
            8493,
            1
        ],
        [
            8496,
            8499,
            1
        ],
        [
            8510,
            8511,
            1
        ],
        [
            8517,
            8579,
            62
        ],
        [
            11264,
            11311,
            1
        ],
        [
            11360,
            11362,
            2
        ],
        [
            11363,
            11364,
            1
        ],
        [
            11367,
            11373,
            2
        ],
        [
            11374,
            11376,
            1
        ],
        [
            11378,
            11381,
            3
        ],
        [
            11390,
            11392,
            1
        ],
        [
            11394,
            11490,
            2
        ],
        [
            11499,
            11501,
            2
        ],
        [
            11506,
            42560,
            31054
        ],
        [
            42562,
            42604,
            2
        ],
        [
            42624,
            42650,
            2
        ],
        [
            42786,
            42798,
            2
        ],
        [
            42802,
            42862,
            2
        ],
        [
            42873,
            42877,
            2
        ],
        [
            42878,
            42886,
            2
        ],
        [
            42891,
            42893,
            2
        ],
        [
            42896,
            42898,
            2
        ],
        [
            42902,
            42922,
            2
        ],
        [
            42923,
            42926,
            1
        ],
        [
            42928,
            42932,
            1
        ],
        [
            42934,
            42948,
            2
        ],
        [
            42949,
            42951,
            1
        ],
        [
            42953,
            42960,
            7
        ],
        [
            42966,
            42968,
            2
        ],
        [
            42997,
            65313,
            22316
        ],
        [
            65314,
            65338,
            1
        ],
        [
            66560,
            66599,
            1
        ],
        [
            66736,
            66771,
            1
        ],
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            68736,
            68786,
            1
        ],
        [
            71840,
            71871,
            1
        ],
        [
            93760,
            93791,
            1
        ],
        [
            119808,
            119833,
            1
        ],
        [
            119860,
            119885,
            1
        ],
        [
            119912,
            119937,
            1
        ],
        [
            119964,
            119966,
            2
        ],
        [
            119967,
            119973,
            3
        ],
        [
            119974,
            119977,
            3
        ],
        [
            119978,
            119980,
            1
        ],
        [
            119982,
            119989,
            1
        ],
        [
            120016,
            120041,
            1
        ],
        [
            120068,
            120069,
            1
        ],
        [
            120071,
            120074,
            1
        ],
        [
            120077,
            120084,
            1
        ],
        [
            120086,
            120092,
            1
        ],
        [
            120120,
            120121,
            1
        ],
        [
            120123,
            120126,
            1
        ],
        [
            120128,
            120132,
            1
        ],
        [
            120134,
            120138,
            4
        ],
        [
            120139,
            120144,
            1
        ],
        [
            120172,
            120197,
            1
        ],
        [
            120224,
            120249,
            1
        ],
        [
            120276,
            120301,
            1
        ],
        [
            120328,
            120353,
            1
        ],
        [
            120380,
            120405,
            1
        ],
        [
            120432,
            120457,
            1
        ],
        [
            120488,
            120512,
            1
        ],
        [
            120546,
            120570,
            1
        ],
        [
            120604,
            120628,
            1
        ],
        [
            120662,
            120686,
            1
        ],
        [
            120720,
            120744,
            1
        ],
        [
            120778,
            125184,
            4406
        ],
        [
            125185,
            125217,
            1
        ]
    ];
    static Upper = this.Lu;
    static foldLu = [
        [
            97,
            122,
            1
        ],
        [
            181,
            223,
            42
        ],
        [
            224,
            246,
            1
        ],
        [
            248,
            255,
            1
        ],
        [
            257,
            303,
            2
        ],
        [
            307,
            311,
            2
        ],
        [
            314,
            328,
            2
        ],
        [
            331,
            375,
            2
        ],
        [
            378,
            382,
            2
        ],
        [
            383,
            384,
            1
        ],
        [
            387,
            389,
            2
        ],
        [
            392,
            396,
            4
        ],
        [
            402,
            405,
            3
        ],
        [
            409,
            410,
            1
        ],
        [
            414,
            417,
            3
        ],
        [
            419,
            421,
            2
        ],
        [
            424,
            429,
            5
        ],
        [
            432,
            436,
            4
        ],
        [
            438,
            441,
            3
        ],
        [
            445,
            447,
            2
        ],
        [
            453,
            454,
            1
        ],
        [
            456,
            457,
            1
        ],
        [
            459,
            460,
            1
        ],
        [
            462,
            476,
            2
        ],
        [
            477,
            495,
            2
        ],
        [
            498,
            499,
            1
        ],
        [
            501,
            505,
            4
        ],
        [
            507,
            543,
            2
        ],
        [
            547,
            563,
            2
        ],
        [
            572,
            575,
            3
        ],
        [
            576,
            578,
            2
        ],
        [
            583,
            591,
            2
        ],
        [
            592,
            596,
            1
        ],
        [
            598,
            599,
            1
        ],
        [
            601,
            603,
            2
        ],
        [
            604,
            608,
            4
        ],
        [
            609,
            613,
            2
        ],
        [
            614,
            616,
            2
        ],
        [
            617,
            620,
            1
        ],
        [
            623,
            625,
            2
        ],
        [
            626,
            629,
            3
        ],
        [
            637,
            640,
            3
        ],
        [
            642,
            643,
            1
        ],
        [
            647,
            652,
            1
        ],
        [
            658,
            669,
            11
        ],
        [
            670,
            837,
            167
        ],
        [
            881,
            883,
            2
        ],
        [
            887,
            891,
            4
        ],
        [
            892,
            893,
            1
        ],
        [
            940,
            943,
            1
        ],
        [
            945,
            974,
            1
        ],
        [
            976,
            977,
            1
        ],
        [
            981,
            983,
            1
        ],
        [
            985,
            1007,
            2
        ],
        [
            1008,
            1011,
            1
        ],
        [
            1013,
            1019,
            3
        ],
        [
            1072,
            1119,
            1
        ],
        [
            1121,
            1153,
            2
        ],
        [
            1163,
            1215,
            2
        ],
        [
            1218,
            1230,
            2
        ],
        [
            1231,
            1327,
            2
        ],
        [
            1377,
            1414,
            1
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4349,
            4351,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7545,
            7549,
            4
        ],
        [
            7566,
            7681,
            115
        ],
        [
            7683,
            7829,
            2
        ],
        [
            7835,
            7841,
            6
        ],
        [
            7843,
            7935,
            2
        ],
        [
            7936,
            7943,
            1
        ],
        [
            7952,
            7957,
            1
        ],
        [
            7968,
            7975,
            1
        ],
        [
            7984,
            7991,
            1
        ],
        [
            8000,
            8005,
            1
        ],
        [
            8017,
            8023,
            2
        ],
        [
            8032,
            8039,
            1
        ],
        [
            8048,
            8061,
            1
        ],
        [
            8112,
            8113,
            1
        ],
        [
            8126,
            8144,
            18
        ],
        [
            8145,
            8160,
            15
        ],
        [
            8161,
            8165,
            4
        ],
        [
            8526,
            8580,
            54
        ],
        [
            11312,
            11359,
            1
        ],
        [
            11361,
            11365,
            4
        ],
        [
            11366,
            11372,
            2
        ],
        [
            11379,
            11382,
            3
        ],
        [
            11393,
            11491,
            2
        ],
        [
            11500,
            11502,
            2
        ],
        [
            11507,
            11520,
            13
        ],
        [
            11521,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ],
        [
            42561,
            42605,
            2
        ],
        [
            42625,
            42651,
            2
        ],
        [
            42787,
            42799,
            2
        ],
        [
            42803,
            42863,
            2
        ],
        [
            42874,
            42876,
            2
        ],
        [
            42879,
            42887,
            2
        ],
        [
            42892,
            42897,
            5
        ],
        [
            42899,
            42900,
            1
        ],
        [
            42903,
            42921,
            2
        ],
        [
            42933,
            42947,
            2
        ],
        [
            42952,
            42954,
            2
        ],
        [
            42961,
            42967,
            6
        ],
        [
            42969,
            42998,
            29
        ],
        [
            43859,
            43888,
            29
        ],
        [
            43889,
            43967,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            66600,
            66639,
            1
        ],
        [
            66776,
            66811,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            71872,
            71903,
            1
        ],
        [
            93792,
            93823,
            1
        ],
        [
            125218,
            125251,
            1
        ]
    ];
    static M = [
        [
            768,
            879,
            1
        ],
        [
            1155,
            1161,
            1
        ],
        [
            1425,
            1469,
            1
        ],
        [
            1471,
            1473,
            2
        ],
        [
            1474,
            1476,
            2
        ],
        [
            1477,
            1479,
            2
        ],
        [
            1552,
            1562,
            1
        ],
        [
            1611,
            1631,
            1
        ],
        [
            1648,
            1750,
            102
        ],
        [
            1751,
            1756,
            1
        ],
        [
            1759,
            1764,
            1
        ],
        [
            1767,
            1768,
            1
        ],
        [
            1770,
            1773,
            1
        ],
        [
            1809,
            1840,
            31
        ],
        [
            1841,
            1866,
            1
        ],
        [
            1958,
            1968,
            1
        ],
        [
            2027,
            2035,
            1
        ],
        [
            2045,
            2070,
            25
        ],
        [
            2071,
            2073,
            1
        ],
        [
            2075,
            2083,
            1
        ],
        [
            2085,
            2087,
            1
        ],
        [
            2089,
            2093,
            1
        ],
        [
            2137,
            2139,
            1
        ],
        [
            2200,
            2207,
            1
        ],
        [
            2250,
            2273,
            1
        ],
        [
            2275,
            2307,
            1
        ],
        [
            2362,
            2364,
            1
        ],
        [
            2366,
            2383,
            1
        ],
        [
            2385,
            2391,
            1
        ],
        [
            2402,
            2403,
            1
        ],
        [
            2433,
            2435,
            1
        ],
        [
            2492,
            2494,
            2
        ],
        [
            2495,
            2500,
            1
        ],
        [
            2503,
            2504,
            1
        ],
        [
            2507,
            2509,
            1
        ],
        [
            2519,
            2530,
            11
        ],
        [
            2531,
            2558,
            27
        ],
        [
            2561,
            2563,
            1
        ],
        [
            2620,
            2622,
            2
        ],
        [
            2623,
            2626,
            1
        ],
        [
            2631,
            2632,
            1
        ],
        [
            2635,
            2637,
            1
        ],
        [
            2641,
            2672,
            31
        ],
        [
            2673,
            2677,
            4
        ],
        [
            2689,
            2691,
            1
        ],
        [
            2748,
            2750,
            2
        ],
        [
            2751,
            2757,
            1
        ],
        [
            2759,
            2761,
            1
        ],
        [
            2763,
            2765,
            1
        ],
        [
            2786,
            2787,
            1
        ],
        [
            2810,
            2815,
            1
        ],
        [
            2817,
            2819,
            1
        ],
        [
            2876,
            2878,
            2
        ],
        [
            2879,
            2884,
            1
        ],
        [
            2887,
            2888,
            1
        ],
        [
            2891,
            2893,
            1
        ],
        [
            2901,
            2903,
            1
        ],
        [
            2914,
            2915,
            1
        ],
        [
            2946,
            3006,
            60
        ],
        [
            3007,
            3010,
            1
        ],
        [
            3014,
            3016,
            1
        ],
        [
            3018,
            3021,
            1
        ],
        [
            3031,
            3072,
            41
        ],
        [
            3073,
            3076,
            1
        ],
        [
            3132,
            3134,
            2
        ],
        [
            3135,
            3140,
            1
        ],
        [
            3142,
            3144,
            1
        ],
        [
            3146,
            3149,
            1
        ],
        [
            3157,
            3158,
            1
        ],
        [
            3170,
            3171,
            1
        ],
        [
            3201,
            3203,
            1
        ],
        [
            3260,
            3262,
            2
        ],
        [
            3263,
            3268,
            1
        ],
        [
            3270,
            3272,
            1
        ],
        [
            3274,
            3277,
            1
        ],
        [
            3285,
            3286,
            1
        ],
        [
            3298,
            3299,
            1
        ],
        [
            3315,
            3328,
            13
        ],
        [
            3329,
            3331,
            1
        ],
        [
            3387,
            3388,
            1
        ],
        [
            3390,
            3396,
            1
        ],
        [
            3398,
            3400,
            1
        ],
        [
            3402,
            3405,
            1
        ],
        [
            3415,
            3426,
            11
        ],
        [
            3427,
            3457,
            30
        ],
        [
            3458,
            3459,
            1
        ],
        [
            3530,
            3535,
            5
        ],
        [
            3536,
            3540,
            1
        ],
        [
            3542,
            3544,
            2
        ],
        [
            3545,
            3551,
            1
        ],
        [
            3570,
            3571,
            1
        ],
        [
            3633,
            3636,
            3
        ],
        [
            3637,
            3642,
            1
        ],
        [
            3655,
            3662,
            1
        ],
        [
            3761,
            3764,
            3
        ],
        [
            3765,
            3772,
            1
        ],
        [
            3784,
            3790,
            1
        ],
        [
            3864,
            3865,
            1
        ],
        [
            3893,
            3897,
            2
        ],
        [
            3902,
            3903,
            1
        ],
        [
            3953,
            3972,
            1
        ],
        [
            3974,
            3975,
            1
        ],
        [
            3981,
            3991,
            1
        ],
        [
            3993,
            4028,
            1
        ],
        [
            4038,
            4139,
            101
        ],
        [
            4140,
            4158,
            1
        ],
        [
            4182,
            4185,
            1
        ],
        [
            4190,
            4192,
            1
        ],
        [
            4194,
            4196,
            1
        ],
        [
            4199,
            4205,
            1
        ],
        [
            4209,
            4212,
            1
        ],
        [
            4226,
            4237,
            1
        ],
        [
            4239,
            4250,
            11
        ],
        [
            4251,
            4253,
            1
        ],
        [
            4957,
            4959,
            1
        ],
        [
            5906,
            5909,
            1
        ],
        [
            5938,
            5940,
            1
        ],
        [
            5970,
            5971,
            1
        ],
        [
            6002,
            6003,
            1
        ],
        [
            6068,
            6099,
            1
        ],
        [
            6109,
            6155,
            46
        ],
        [
            6156,
            6157,
            1
        ],
        [
            6159,
            6277,
            118
        ],
        [
            6278,
            6313,
            35
        ],
        [
            6432,
            6443,
            1
        ],
        [
            6448,
            6459,
            1
        ],
        [
            6679,
            6683,
            1
        ],
        [
            6741,
            6750,
            1
        ],
        [
            6752,
            6780,
            1
        ],
        [
            6783,
            6832,
            49
        ],
        [
            6833,
            6862,
            1
        ],
        [
            6912,
            6916,
            1
        ],
        [
            6964,
            6980,
            1
        ],
        [
            7019,
            7027,
            1
        ],
        [
            7040,
            7042,
            1
        ],
        [
            7073,
            7085,
            1
        ],
        [
            7142,
            7155,
            1
        ],
        [
            7204,
            7223,
            1
        ],
        [
            7376,
            7378,
            1
        ],
        [
            7380,
            7400,
            1
        ],
        [
            7405,
            7412,
            7
        ],
        [
            7415,
            7417,
            1
        ],
        [
            7616,
            7679,
            1
        ],
        [
            8400,
            8432,
            1
        ],
        [
            11503,
            11505,
            1
        ],
        [
            11647,
            11744,
            97
        ],
        [
            11745,
            11775,
            1
        ],
        [
            12330,
            12335,
            1
        ],
        [
            12441,
            12442,
            1
        ],
        [
            42607,
            42610,
            1
        ],
        [
            42612,
            42621,
            1
        ],
        [
            42654,
            42655,
            1
        ],
        [
            42736,
            42737,
            1
        ],
        [
            43010,
            43014,
            4
        ],
        [
            43019,
            43043,
            24
        ],
        [
            43044,
            43047,
            1
        ],
        [
            43052,
            43136,
            84
        ],
        [
            43137,
            43188,
            51
        ],
        [
            43189,
            43205,
            1
        ],
        [
            43232,
            43249,
            1
        ],
        [
            43263,
            43302,
            39
        ],
        [
            43303,
            43309,
            1
        ],
        [
            43335,
            43347,
            1
        ],
        [
            43392,
            43395,
            1
        ],
        [
            43443,
            43456,
            1
        ],
        [
            43493,
            43561,
            68
        ],
        [
            43562,
            43574,
            1
        ],
        [
            43587,
            43596,
            9
        ],
        [
            43597,
            43643,
            46
        ],
        [
            43644,
            43645,
            1
        ],
        [
            43696,
            43698,
            2
        ],
        [
            43699,
            43700,
            1
        ],
        [
            43703,
            43704,
            1
        ],
        [
            43710,
            43711,
            1
        ],
        [
            43713,
            43755,
            42
        ],
        [
            43756,
            43759,
            1
        ],
        [
            43765,
            43766,
            1
        ],
        [
            44003,
            44010,
            1
        ],
        [
            44012,
            44013,
            1
        ],
        [
            64286,
            65024,
            738
        ],
        [
            65025,
            65039,
            1
        ],
        [
            65056,
            65071,
            1
        ],
        [
            66045,
            66272,
            227
        ],
        [
            66422,
            66426,
            1
        ],
        [
            68097,
            68099,
            1
        ],
        [
            68101,
            68102,
            1
        ],
        [
            68108,
            68111,
            1
        ],
        [
            68152,
            68154,
            1
        ],
        [
            68159,
            68325,
            166
        ],
        [
            68326,
            68900,
            574
        ],
        [
            68901,
            68903,
            1
        ],
        [
            69291,
            69292,
            1
        ],
        [
            69373,
            69375,
            1
        ],
        [
            69446,
            69456,
            1
        ],
        [
            69506,
            69509,
            1
        ],
        [
            69632,
            69634,
            1
        ],
        [
            69688,
            69702,
            1
        ],
        [
            69744,
            69747,
            3
        ],
        [
            69748,
            69759,
            11
        ],
        [
            69760,
            69762,
            1
        ],
        [
            69808,
            69818,
            1
        ],
        [
            69826,
            69888,
            62
        ],
        [
            69889,
            69890,
            1
        ],
        [
            69927,
            69940,
            1
        ],
        [
            69957,
            69958,
            1
        ],
        [
            70003,
            70016,
            13
        ],
        [
            70017,
            70018,
            1
        ],
        [
            70067,
            70080,
            1
        ],
        [
            70089,
            70092,
            1
        ],
        [
            70094,
            70095,
            1
        ],
        [
            70188,
            70199,
            1
        ],
        [
            70206,
            70209,
            3
        ],
        [
            70367,
            70378,
            1
        ],
        [
            70400,
            70403,
            1
        ],
        [
            70459,
            70460,
            1
        ],
        [
            70462,
            70468,
            1
        ],
        [
            70471,
            70472,
            1
        ],
        [
            70475,
            70477,
            1
        ],
        [
            70487,
            70498,
            11
        ],
        [
            70499,
            70502,
            3
        ],
        [
            70503,
            70508,
            1
        ],
        [
            70512,
            70516,
            1
        ],
        [
            70709,
            70726,
            1
        ],
        [
            70750,
            70832,
            82
        ],
        [
            70833,
            70851,
            1
        ],
        [
            71087,
            71093,
            1
        ],
        [
            71096,
            71104,
            1
        ],
        [
            71132,
            71133,
            1
        ],
        [
            71216,
            71232,
            1
        ],
        [
            71339,
            71351,
            1
        ],
        [
            71453,
            71467,
            1
        ],
        [
            71724,
            71738,
            1
        ],
        [
            71984,
            71989,
            1
        ],
        [
            71991,
            71992,
            1
        ],
        [
            71995,
            71998,
            1
        ],
        [
            72000,
            72002,
            2
        ],
        [
            72003,
            72145,
            142
        ],
        [
            72146,
            72151,
            1
        ],
        [
            72154,
            72160,
            1
        ],
        [
            72164,
            72193,
            29
        ],
        [
            72194,
            72202,
            1
        ],
        [
            72243,
            72249,
            1
        ],
        [
            72251,
            72254,
            1
        ],
        [
            72263,
            72273,
            10
        ],
        [
            72274,
            72283,
            1
        ],
        [
            72330,
            72345,
            1
        ],
        [
            72751,
            72758,
            1
        ],
        [
            72760,
            72767,
            1
        ],
        [
            72850,
            72871,
            1
        ],
        [
            72873,
            72886,
            1
        ],
        [
            73009,
            73014,
            1
        ],
        [
            73018,
            73020,
            2
        ],
        [
            73021,
            73023,
            2
        ],
        [
            73024,
            73029,
            1
        ],
        [
            73031,
            73098,
            67
        ],
        [
            73099,
            73102,
            1
        ],
        [
            73104,
            73105,
            1
        ],
        [
            73107,
            73111,
            1
        ],
        [
            73459,
            73462,
            1
        ],
        [
            73472,
            73473,
            1
        ],
        [
            73475,
            73524,
            49
        ],
        [
            73525,
            73530,
            1
        ],
        [
            73534,
            73538,
            1
        ],
        [
            78912,
            78919,
            7
        ],
        [
            78920,
            78933,
            1
        ],
        [
            92912,
            92916,
            1
        ],
        [
            92976,
            92982,
            1
        ],
        [
            94031,
            94033,
            2
        ],
        [
            94034,
            94087,
            1
        ],
        [
            94095,
            94098,
            1
        ],
        [
            94180,
            94192,
            12
        ],
        [
            94193,
            113821,
            19628
        ],
        [
            113822,
            118528,
            4706
        ],
        [
            118529,
            118573,
            1
        ],
        [
            118576,
            118598,
            1
        ],
        [
            119141,
            119145,
            1
        ],
        [
            119149,
            119154,
            1
        ],
        [
            119163,
            119170,
            1
        ],
        [
            119173,
            119179,
            1
        ],
        [
            119210,
            119213,
            1
        ],
        [
            119362,
            119364,
            1
        ],
        [
            121344,
            121398,
            1
        ],
        [
            121403,
            121452,
            1
        ],
        [
            121461,
            121476,
            15
        ],
        [
            121499,
            121503,
            1
        ],
        [
            121505,
            121519,
            1
        ],
        [
            122880,
            122886,
            1
        ],
        [
            122888,
            122904,
            1
        ],
        [
            122907,
            122913,
            1
        ],
        [
            122915,
            122916,
            1
        ],
        [
            122918,
            122922,
            1
        ],
        [
            123023,
            123184,
            161
        ],
        [
            123185,
            123190,
            1
        ],
        [
            123566,
            123628,
            62
        ],
        [
            123629,
            123631,
            1
        ],
        [
            124140,
            124143,
            1
        ],
        [
            125136,
            125142,
            1
        ],
        [
            125252,
            125258,
            1
        ],
        [
            917760,
            917999,
            1
        ]
    ];
    static foldM = [
        [
            921,
            953,
            32
        ],
        [
            8126,
            8126,
            1
        ]
    ];
    static Mc = [
        [
            2307,
            2363,
            56
        ],
        [
            2366,
            2368,
            1
        ],
        [
            2377,
            2380,
            1
        ],
        [
            2382,
            2383,
            1
        ],
        [
            2434,
            2435,
            1
        ],
        [
            2494,
            2496,
            1
        ],
        [
            2503,
            2504,
            1
        ],
        [
            2507,
            2508,
            1
        ],
        [
            2519,
            2563,
            44
        ],
        [
            2622,
            2624,
            1
        ],
        [
            2691,
            2750,
            59
        ],
        [
            2751,
            2752,
            1
        ],
        [
            2761,
            2763,
            2
        ],
        [
            2764,
            2818,
            54
        ],
        [
            2819,
            2878,
            59
        ],
        [
            2880,
            2887,
            7
        ],
        [
            2888,
            2891,
            3
        ],
        [
            2892,
            2903,
            11
        ],
        [
            3006,
            3007,
            1
        ],
        [
            3009,
            3010,
            1
        ],
        [
            3014,
            3016,
            1
        ],
        [
            3018,
            3020,
            1
        ],
        [
            3031,
            3073,
            42
        ],
        [
            3074,
            3075,
            1
        ],
        [
            3137,
            3140,
            1
        ],
        [
            3202,
            3203,
            1
        ],
        [
            3262,
            3264,
            2
        ],
        [
            3265,
            3268,
            1
        ],
        [
            3271,
            3272,
            1
        ],
        [
            3274,
            3275,
            1
        ],
        [
            3285,
            3286,
            1
        ],
        [
            3315,
            3330,
            15
        ],
        [
            3331,
            3390,
            59
        ],
        [
            3391,
            3392,
            1
        ],
        [
            3398,
            3400,
            1
        ],
        [
            3402,
            3404,
            1
        ],
        [
            3415,
            3458,
            43
        ],
        [
            3459,
            3535,
            76
        ],
        [
            3536,
            3537,
            1
        ],
        [
            3544,
            3551,
            1
        ],
        [
            3570,
            3571,
            1
        ],
        [
            3902,
            3903,
            1
        ],
        [
            3967,
            4139,
            172
        ],
        [
            4140,
            4145,
            5
        ],
        [
            4152,
            4155,
            3
        ],
        [
            4156,
            4182,
            26
        ],
        [
            4183,
            4194,
            11
        ],
        [
            4195,
            4196,
            1
        ],
        [
            4199,
            4205,
            1
        ],
        [
            4227,
            4228,
            1
        ],
        [
            4231,
            4236,
            1
        ],
        [
            4239,
            4250,
            11
        ],
        [
            4251,
            4252,
            1
        ],
        [
            5909,
            5940,
            31
        ],
        [
            6070,
            6078,
            8
        ],
        [
            6079,
            6085,
            1
        ],
        [
            6087,
            6088,
            1
        ],
        [
            6435,
            6438,
            1
        ],
        [
            6441,
            6443,
            1
        ],
        [
            6448,
            6449,
            1
        ],
        [
            6451,
            6456,
            1
        ],
        [
            6681,
            6682,
            1
        ],
        [
            6741,
            6743,
            2
        ],
        [
            6753,
            6755,
            2
        ],
        [
            6756,
            6765,
            9
        ],
        [
            6766,
            6770,
            1
        ],
        [
            6916,
            6965,
            49
        ],
        [
            6971,
            6973,
            2
        ],
        [
            6974,
            6977,
            1
        ],
        [
            6979,
            6980,
            1
        ],
        [
            7042,
            7073,
            31
        ],
        [
            7078,
            7079,
            1
        ],
        [
            7082,
            7143,
            61
        ],
        [
            7146,
            7148,
            1
        ],
        [
            7150,
            7154,
            4
        ],
        [
            7155,
            7204,
            49
        ],
        [
            7205,
            7211,
            1
        ],
        [
            7220,
            7221,
            1
        ],
        [
            7393,
            7415,
            22
        ],
        [
            12334,
            12335,
            1
        ],
        [
            43043,
            43044,
            1
        ],
        [
            43047,
            43136,
            89
        ],
        [
            43137,
            43188,
            51
        ],
        [
            43189,
            43203,
            1
        ],
        [
            43346,
            43347,
            1
        ],
        [
            43395,
            43444,
            49
        ],
        [
            43445,
            43450,
            5
        ],
        [
            43451,
            43454,
            3
        ],
        [
            43455,
            43456,
            1
        ],
        [
            43567,
            43568,
            1
        ],
        [
            43571,
            43572,
            1
        ],
        [
            43597,
            43643,
            46
        ],
        [
            43645,
            43755,
            110
        ],
        [
            43758,
            43759,
            1
        ],
        [
            43765,
            44003,
            238
        ],
        [
            44004,
            44006,
            2
        ],
        [
            44007,
            44009,
            2
        ],
        [
            44010,
            44012,
            2
        ],
        [
            69632,
            69634,
            2
        ],
        [
            69762,
            69808,
            46
        ],
        [
            69809,
            69810,
            1
        ],
        [
            69815,
            69816,
            1
        ],
        [
            69932,
            69957,
            25
        ],
        [
            69958,
            70018,
            60
        ],
        [
            70067,
            70069,
            1
        ],
        [
            70079,
            70080,
            1
        ],
        [
            70094,
            70188,
            94
        ],
        [
            70189,
            70190,
            1
        ],
        [
            70194,
            70195,
            1
        ],
        [
            70197,
            70368,
            171
        ],
        [
            70369,
            70370,
            1
        ],
        [
            70402,
            70403,
            1
        ],
        [
            70462,
            70463,
            1
        ],
        [
            70465,
            70468,
            1
        ],
        [
            70471,
            70472,
            1
        ],
        [
            70475,
            70477,
            1
        ],
        [
            70487,
            70498,
            11
        ],
        [
            70499,
            70709,
            210
        ],
        [
            70710,
            70711,
            1
        ],
        [
            70720,
            70721,
            1
        ],
        [
            70725,
            70832,
            107
        ],
        [
            70833,
            70834,
            1
        ],
        [
            70841,
            70843,
            2
        ],
        [
            70844,
            70846,
            1
        ],
        [
            70849,
            71087,
            238
        ],
        [
            71088,
            71089,
            1
        ],
        [
            71096,
            71099,
            1
        ],
        [
            71102,
            71216,
            114
        ],
        [
            71217,
            71218,
            1
        ],
        [
            71227,
            71228,
            1
        ],
        [
            71230,
            71340,
            110
        ],
        [
            71342,
            71343,
            1
        ],
        [
            71350,
            71456,
            106
        ],
        [
            71457,
            71462,
            5
        ],
        [
            71724,
            71726,
            1
        ],
        [
            71736,
            71984,
            248
        ],
        [
            71985,
            71989,
            1
        ],
        [
            71991,
            71992,
            1
        ],
        [
            71997,
            72000,
            3
        ],
        [
            72002,
            72145,
            143
        ],
        [
            72146,
            72147,
            1
        ],
        [
            72156,
            72159,
            1
        ],
        [
            72164,
            72249,
            85
        ],
        [
            72279,
            72280,
            1
        ],
        [
            72343,
            72751,
            408
        ],
        [
            72766,
            72873,
            107
        ],
        [
            72881,
            72884,
            3
        ],
        [
            73098,
            73102,
            1
        ],
        [
            73107,
            73108,
            1
        ],
        [
            73110,
            73461,
            351
        ],
        [
            73462,
            73475,
            13
        ],
        [
            73524,
            73525,
            1
        ],
        [
            73534,
            73535,
            1
        ],
        [
            73537,
            94033,
            20496
        ],
        [
            94034,
            94087,
            1
        ],
        [
            94192,
            94193,
            1
        ],
        [
            119141,
            119142,
            1
        ],
        [
            119149,
            119154,
            1
        ]
    ];
    static Me = [
        [
            1160,
            1161,
            1
        ],
        [
            6846,
            8413,
            1567
        ],
        [
            8414,
            8416,
            1
        ],
        [
            8418,
            8420,
            1
        ],
        [
            42608,
            42610,
            1
        ]
    ];
    static Mn = [
        [
            768,
            879,
            1
        ],
        [
            1155,
            1159,
            1
        ],
        [
            1425,
            1469,
            1
        ],
        [
            1471,
            1473,
            2
        ],
        [
            1474,
            1476,
            2
        ],
        [
            1477,
            1479,
            2
        ],
        [
            1552,
            1562,
            1
        ],
        [
            1611,
            1631,
            1
        ],
        [
            1648,
            1750,
            102
        ],
        [
            1751,
            1756,
            1
        ],
        [
            1759,
            1764,
            1
        ],
        [
            1767,
            1768,
            1
        ],
        [
            1770,
            1773,
            1
        ],
        [
            1809,
            1840,
            31
        ],
        [
            1841,
            1866,
            1
        ],
        [
            1958,
            1968,
            1
        ],
        [
            2027,
            2035,
            1
        ],
        [
            2045,
            2070,
            25
        ],
        [
            2071,
            2073,
            1
        ],
        [
            2075,
            2083,
            1
        ],
        [
            2085,
            2087,
            1
        ],
        [
            2089,
            2093,
            1
        ],
        [
            2137,
            2139,
            1
        ],
        [
            2200,
            2207,
            1
        ],
        [
            2250,
            2273,
            1
        ],
        [
            2275,
            2306,
            1
        ],
        [
            2362,
            2364,
            2
        ],
        [
            2369,
            2376,
            1
        ],
        [
            2381,
            2385,
            4
        ],
        [
            2386,
            2391,
            1
        ],
        [
            2402,
            2403,
            1
        ],
        [
            2433,
            2492,
            59
        ],
        [
            2497,
            2500,
            1
        ],
        [
            2509,
            2530,
            21
        ],
        [
            2531,
            2558,
            27
        ],
        [
            2561,
            2562,
            1
        ],
        [
            2620,
            2625,
            5
        ],
        [
            2626,
            2631,
            5
        ],
        [
            2632,
            2635,
            3
        ],
        [
            2636,
            2637,
            1
        ],
        [
            2641,
            2672,
            31
        ],
        [
            2673,
            2677,
            4
        ],
        [
            2689,
            2690,
            1
        ],
        [
            2748,
            2753,
            5
        ],
        [
            2754,
            2757,
            1
        ],
        [
            2759,
            2760,
            1
        ],
        [
            2765,
            2786,
            21
        ],
        [
            2787,
            2810,
            23
        ],
        [
            2811,
            2815,
            1
        ],
        [
            2817,
            2876,
            59
        ],
        [
            2879,
            2881,
            2
        ],
        [
            2882,
            2884,
            1
        ],
        [
            2893,
            2901,
            8
        ],
        [
            2902,
            2914,
            12
        ],
        [
            2915,
            2946,
            31
        ],
        [
            3008,
            3021,
            13
        ],
        [
            3072,
            3076,
            4
        ],
        [
            3132,
            3134,
            2
        ],
        [
            3135,
            3136,
            1
        ],
        [
            3142,
            3144,
            1
        ],
        [
            3146,
            3149,
            1
        ],
        [
            3157,
            3158,
            1
        ],
        [
            3170,
            3171,
            1
        ],
        [
            3201,
            3260,
            59
        ],
        [
            3263,
            3270,
            7
        ],
        [
            3276,
            3277,
            1
        ],
        [
            3298,
            3299,
            1
        ],
        [
            3328,
            3329,
            1
        ],
        [
            3387,
            3388,
            1
        ],
        [
            3393,
            3396,
            1
        ],
        [
            3405,
            3426,
            21
        ],
        [
            3427,
            3457,
            30
        ],
        [
            3530,
            3538,
            8
        ],
        [
            3539,
            3540,
            1
        ],
        [
            3542,
            3633,
            91
        ],
        [
            3636,
            3642,
            1
        ],
        [
            3655,
            3662,
            1
        ],
        [
            3761,
            3764,
            3
        ],
        [
            3765,
            3772,
            1
        ],
        [
            3784,
            3790,
            1
        ],
        [
            3864,
            3865,
            1
        ],
        [
            3893,
            3897,
            2
        ],
        [
            3953,
            3966,
            1
        ],
        [
            3968,
            3972,
            1
        ],
        [
            3974,
            3975,
            1
        ],
        [
            3981,
            3991,
            1
        ],
        [
            3993,
            4028,
            1
        ],
        [
            4038,
            4141,
            103
        ],
        [
            4142,
            4144,
            1
        ],
        [
            4146,
            4151,
            1
        ],
        [
            4153,
            4154,
            1
        ],
        [
            4157,
            4158,
            1
        ],
        [
            4184,
            4185,
            1
        ],
        [
            4190,
            4192,
            1
        ],
        [
            4209,
            4212,
            1
        ],
        [
            4226,
            4229,
            3
        ],
        [
            4230,
            4237,
            7
        ],
        [
            4253,
            4957,
            704
        ],
        [
            4958,
            4959,
            1
        ],
        [
            5906,
            5908,
            1
        ],
        [
            5938,
            5939,
            1
        ],
        [
            5970,
            5971,
            1
        ],
        [
            6002,
            6003,
            1
        ],
        [
            6068,
            6069,
            1
        ],
        [
            6071,
            6077,
            1
        ],
        [
            6086,
            6089,
            3
        ],
        [
            6090,
            6099,
            1
        ],
        [
            6109,
            6155,
            46
        ],
        [
            6156,
            6157,
            1
        ],
        [
            6159,
            6277,
            118
        ],
        [
            6278,
            6313,
            35
        ],
        [
            6432,
            6434,
            1
        ],
        [
            6439,
            6440,
            1
        ],
        [
            6450,
            6457,
            7
        ],
        [
            6458,
            6459,
            1
        ],
        [
            6679,
            6680,
            1
        ],
        [
            6683,
            6742,
            59
        ],
        [
            6744,
            6750,
            1
        ],
        [
            6752,
            6754,
            2
        ],
        [
            6757,
            6764,
            1
        ],
        [
            6771,
            6780,
            1
        ],
        [
            6783,
            6832,
            49
        ],
        [
            6833,
            6845,
            1
        ],
        [
            6847,
            6862,
            1
        ],
        [
            6912,
            6915,
            1
        ],
        [
            6964,
            6966,
            2
        ],
        [
            6967,
            6970,
            1
        ],
        [
            6972,
            6978,
            6
        ],
        [
            7019,
            7027,
            1
        ],
        [
            7040,
            7041,
            1
        ],
        [
            7074,
            7077,
            1
        ],
        [
            7080,
            7081,
            1
        ],
        [
            7083,
            7085,
            1
        ],
        [
            7142,
            7144,
            2
        ],
        [
            7145,
            7149,
            4
        ],
        [
            7151,
            7153,
            1
        ],
        [
            7212,
            7219,
            1
        ],
        [
            7222,
            7223,
            1
        ],
        [
            7376,
            7378,
            1
        ],
        [
            7380,
            7392,
            1
        ],
        [
            7394,
            7400,
            1
        ],
        [
            7405,
            7412,
            7
        ],
        [
            7416,
            7417,
            1
        ],
        [
            7616,
            7679,
            1
        ],
        [
            8400,
            8412,
            1
        ],
        [
            8417,
            8421,
            4
        ],
        [
            8422,
            8432,
            1
        ],
        [
            11503,
            11505,
            1
        ],
        [
            11647,
            11744,
            97
        ],
        [
            11745,
            11775,
            1
        ],
        [
            12330,
            12333,
            1
        ],
        [
            12441,
            12442,
            1
        ],
        [
            42607,
            42612,
            5
        ],
        [
            42613,
            42621,
            1
        ],
        [
            42654,
            42655,
            1
        ],
        [
            42736,
            42737,
            1
        ],
        [
            43010,
            43014,
            4
        ],
        [
            43019,
            43045,
            26
        ],
        [
            43046,
            43052,
            6
        ],
        [
            43204,
            43205,
            1
        ],
        [
            43232,
            43249,
            1
        ],
        [
            43263,
            43302,
            39
        ],
        [
            43303,
            43309,
            1
        ],
        [
            43335,
            43345,
            1
        ],
        [
            43392,
            43394,
            1
        ],
        [
            43443,
            43446,
            3
        ],
        [
            43447,
            43449,
            1
        ],
        [
            43452,
            43453,
            1
        ],
        [
            43493,
            43561,
            68
        ],
        [
            43562,
            43566,
            1
        ],
        [
            43569,
            43570,
            1
        ],
        [
            43573,
            43574,
            1
        ],
        [
            43587,
            43596,
            9
        ],
        [
            43644,
            43696,
            52
        ],
        [
            43698,
            43700,
            1
        ],
        [
            43703,
            43704,
            1
        ],
        [
            43710,
            43711,
            1
        ],
        [
            43713,
            43756,
            43
        ],
        [
            43757,
            43766,
            9
        ],
        [
            44005,
            44008,
            3
        ],
        [
            44013,
            64286,
            20273
        ],
        [
            65024,
            65039,
            1
        ],
        [
            65056,
            65071,
            1
        ],
        [
            66045,
            66272,
            227
        ],
        [
            66422,
            66426,
            1
        ],
        [
            68097,
            68099,
            1
        ],
        [
            68101,
            68102,
            1
        ],
        [
            68108,
            68111,
            1
        ],
        [
            68152,
            68154,
            1
        ],
        [
            68159,
            68325,
            166
        ],
        [
            68326,
            68900,
            574
        ],
        [
            68901,
            68903,
            1
        ],
        [
            69291,
            69292,
            1
        ],
        [
            69373,
            69375,
            1
        ],
        [
            69446,
            69456,
            1
        ],
        [
            69506,
            69509,
            1
        ],
        [
            69633,
            69688,
            55
        ],
        [
            69689,
            69702,
            1
        ],
        [
            69744,
            69747,
            3
        ],
        [
            69748,
            69759,
            11
        ],
        [
            69760,
            69761,
            1
        ],
        [
            69811,
            69814,
            1
        ],
        [
            69817,
            69818,
            1
        ],
        [
            69826,
            69888,
            62
        ],
        [
            69889,
            69890,
            1
        ],
        [
            69927,
            69931,
            1
        ],
        [
            69933,
            69940,
            1
        ],
        [
            70003,
            70016,
            13
        ],
        [
            70017,
            70070,
            53
        ],
        [
            70071,
            70078,
            1
        ],
        [
            70089,
            70092,
            1
        ],
        [
            70095,
            70191,
            96
        ],
        [
            70192,
            70193,
            1
        ],
        [
            70196,
            70198,
            2
        ],
        [
            70199,
            70206,
            7
        ],
        [
            70209,
            70367,
            158
        ],
        [
            70371,
            70378,
            1
        ],
        [
            70400,
            70401,
            1
        ],
        [
            70459,
            70460,
            1
        ],
        [
            70464,
            70502,
            38
        ],
        [
            70503,
            70508,
            1
        ],
        [
            70512,
            70516,
            1
        ],
        [
            70712,
            70719,
            1
        ],
        [
            70722,
            70724,
            1
        ],
        [
            70726,
            70750,
            24
        ],
        [
            70835,
            70840,
            1
        ],
        [
            70842,
            70847,
            5
        ],
        [
            70848,
            70850,
            2
        ],
        [
            70851,
            71090,
            239
        ],
        [
            71091,
            71093,
            1
        ],
        [
            71100,
            71101,
            1
        ],
        [
            71103,
            71104,
            1
        ],
        [
            71132,
            71133,
            1
        ],
        [
            71219,
            71226,
            1
        ],
        [
            71229,
            71231,
            2
        ],
        [
            71232,
            71339,
            107
        ],
        [
            71341,
            71344,
            3
        ],
        [
            71345,
            71349,
            1
        ],
        [
            71351,
            71453,
            102
        ],
        [
            71454,
            71455,
            1
        ],
        [
            71458,
            71461,
            1
        ],
        [
            71463,
            71467,
            1
        ],
        [
            71727,
            71735,
            1
        ],
        [
            71737,
            71738,
            1
        ],
        [
            71995,
            71996,
            1
        ],
        [
            71998,
            72003,
            5
        ],
        [
            72148,
            72151,
            1
        ],
        [
            72154,
            72155,
            1
        ],
        [
            72160,
            72193,
            33
        ],
        [
            72194,
            72202,
            1
        ],
        [
            72243,
            72248,
            1
        ],
        [
            72251,
            72254,
            1
        ],
        [
            72263,
            72273,
            10
        ],
        [
            72274,
            72278,
            1
        ],
        [
            72281,
            72283,
            1
        ],
        [
            72330,
            72342,
            1
        ],
        [
            72344,
            72345,
            1
        ],
        [
            72752,
            72758,
            1
        ],
        [
            72760,
            72765,
            1
        ],
        [
            72767,
            72850,
            83
        ],
        [
            72851,
            72871,
            1
        ],
        [
            72874,
            72880,
            1
        ],
        [
            72882,
            72883,
            1
        ],
        [
            72885,
            72886,
            1
        ],
        [
            73009,
            73014,
            1
        ],
        [
            73018,
            73020,
            2
        ],
        [
            73021,
            73023,
            2
        ],
        [
            73024,
            73029,
            1
        ],
        [
            73031,
            73104,
            73
        ],
        [
            73105,
            73109,
            4
        ],
        [
            73111,
            73459,
            348
        ],
        [
            73460,
            73472,
            12
        ],
        [
            73473,
            73526,
            53
        ],
        [
            73527,
            73530,
            1
        ],
        [
            73536,
            73538,
            2
        ],
        [
            78912,
            78919,
            7
        ],
        [
            78920,
            78933,
            1
        ],
        [
            92912,
            92916,
            1
        ],
        [
            92976,
            92982,
            1
        ],
        [
            94031,
            94095,
            64
        ],
        [
            94096,
            94098,
            1
        ],
        [
            94180,
            113821,
            19641
        ],
        [
            113822,
            118528,
            4706
        ],
        [
            118529,
            118573,
            1
        ],
        [
            118576,
            118598,
            1
        ],
        [
            119143,
            119145,
            1
        ],
        [
            119163,
            119170,
            1
        ],
        [
            119173,
            119179,
            1
        ],
        [
            119210,
            119213,
            1
        ],
        [
            119362,
            119364,
            1
        ],
        [
            121344,
            121398,
            1
        ],
        [
            121403,
            121452,
            1
        ],
        [
            121461,
            121476,
            15
        ],
        [
            121499,
            121503,
            1
        ],
        [
            121505,
            121519,
            1
        ],
        [
            122880,
            122886,
            1
        ],
        [
            122888,
            122904,
            1
        ],
        [
            122907,
            122913,
            1
        ],
        [
            122915,
            122916,
            1
        ],
        [
            122918,
            122922,
            1
        ],
        [
            123023,
            123184,
            161
        ],
        [
            123185,
            123190,
            1
        ],
        [
            123566,
            123628,
            62
        ],
        [
            123629,
            123631,
            1
        ],
        [
            124140,
            124143,
            1
        ],
        [
            125136,
            125142,
            1
        ],
        [
            125252,
            125258,
            1
        ],
        [
            917760,
            917999,
            1
        ]
    ];
    static foldMn = [
        [
            921,
            953,
            32
        ],
        [
            8126,
            8126,
            1
        ]
    ];
    static N = [
        [
            48,
            57,
            1
        ],
        [
            178,
            179,
            1
        ],
        [
            185,
            188,
            3
        ],
        [
            189,
            190,
            1
        ],
        [
            1632,
            1641,
            1
        ],
        [
            1776,
            1785,
            1
        ],
        [
            1984,
            1993,
            1
        ],
        [
            2406,
            2415,
            1
        ],
        [
            2534,
            2543,
            1
        ],
        [
            2548,
            2553,
            1
        ],
        [
            2662,
            2671,
            1
        ],
        [
            2790,
            2799,
            1
        ],
        [
            2918,
            2927,
            1
        ],
        [
            2930,
            2935,
            1
        ],
        [
            3046,
            3058,
            1
        ],
        [
            3174,
            3183,
            1
        ],
        [
            3192,
            3198,
            1
        ],
        [
            3302,
            3311,
            1
        ],
        [
            3416,
            3422,
            1
        ],
        [
            3430,
            3448,
            1
        ],
        [
            3558,
            3567,
            1
        ],
        [
            3664,
            3673,
            1
        ],
        [
            3792,
            3801,
            1
        ],
        [
            3872,
            3891,
            1
        ],
        [
            4160,
            4169,
            1
        ],
        [
            4240,
            4249,
            1
        ],
        [
            4969,
            4988,
            1
        ],
        [
            5870,
            5872,
            1
        ],
        [
            6112,
            6121,
            1
        ],
        [
            6128,
            6137,
            1
        ],
        [
            6160,
            6169,
            1
        ],
        [
            6470,
            6479,
            1
        ],
        [
            6608,
            6618,
            1
        ],
        [
            6784,
            6793,
            1
        ],
        [
            6800,
            6809,
            1
        ],
        [
            6992,
            7001,
            1
        ],
        [
            7088,
            7097,
            1
        ],
        [
            7232,
            7241,
            1
        ],
        [
            7248,
            7257,
            1
        ],
        [
            8304,
            8308,
            4
        ],
        [
            8309,
            8313,
            1
        ],
        [
            8320,
            8329,
            1
        ],
        [
            8528,
            8578,
            1
        ],
        [
            8581,
            8585,
            1
        ],
        [
            9312,
            9371,
            1
        ],
        [
            9450,
            9471,
            1
        ],
        [
            10102,
            10131,
            1
        ],
        [
            11517,
            12295,
            778
        ],
        [
            12321,
            12329,
            1
        ],
        [
            12344,
            12346,
            1
        ],
        [
            12690,
            12693,
            1
        ],
        [
            12832,
            12841,
            1
        ],
        [
            12872,
            12879,
            1
        ],
        [
            12881,
            12895,
            1
        ],
        [
            12928,
            12937,
            1
        ],
        [
            12977,
            12991,
            1
        ],
        [
            42528,
            42537,
            1
        ],
        [
            42726,
            42735,
            1
        ],
        [
            43056,
            43061,
            1
        ],
        [
            43216,
            43225,
            1
        ],
        [
            43264,
            43273,
            1
        ],
        [
            43472,
            43481,
            1
        ],
        [
            43504,
            43513,
            1
        ],
        [
            43600,
            43609,
            1
        ],
        [
            44016,
            44025,
            1
        ],
        [
            65296,
            65305,
            1
        ],
        [
            65799,
            65843,
            1
        ],
        [
            65856,
            65912,
            1
        ],
        [
            65930,
            65931,
            1
        ],
        [
            66273,
            66299,
            1
        ],
        [
            66336,
            66339,
            1
        ],
        [
            66369,
            66378,
            9
        ],
        [
            66513,
            66517,
            1
        ],
        [
            66720,
            66729,
            1
        ],
        [
            67672,
            67679,
            1
        ],
        [
            67705,
            67711,
            1
        ],
        [
            67751,
            67759,
            1
        ],
        [
            67835,
            67839,
            1
        ],
        [
            67862,
            67867,
            1
        ],
        [
            68028,
            68029,
            1
        ],
        [
            68032,
            68047,
            1
        ],
        [
            68050,
            68095,
            1
        ],
        [
            68160,
            68168,
            1
        ],
        [
            68221,
            68222,
            1
        ],
        [
            68253,
            68255,
            1
        ],
        [
            68331,
            68335,
            1
        ],
        [
            68440,
            68447,
            1
        ],
        [
            68472,
            68479,
            1
        ],
        [
            68521,
            68527,
            1
        ],
        [
            68858,
            68863,
            1
        ],
        [
            68912,
            68921,
            1
        ],
        [
            69216,
            69246,
            1
        ],
        [
            69405,
            69414,
            1
        ],
        [
            69457,
            69460,
            1
        ],
        [
            69573,
            69579,
            1
        ],
        [
            69714,
            69743,
            1
        ],
        [
            69872,
            69881,
            1
        ],
        [
            69942,
            69951,
            1
        ],
        [
            70096,
            70105,
            1
        ],
        [
            70113,
            70132,
            1
        ],
        [
            70384,
            70393,
            1
        ],
        [
            70736,
            70745,
            1
        ],
        [
            70864,
            70873,
            1
        ],
        [
            71248,
            71257,
            1
        ],
        [
            71360,
            71369,
            1
        ],
        [
            71472,
            71483,
            1
        ],
        [
            71904,
            71922,
            1
        ],
        [
            72016,
            72025,
            1
        ],
        [
            72784,
            72812,
            1
        ],
        [
            73040,
            73049,
            1
        ],
        [
            73120,
            73129,
            1
        ],
        [
            73552,
            73561,
            1
        ],
        [
            73664,
            73684,
            1
        ],
        [
            74752,
            74862,
            1
        ],
        [
            92768,
            92777,
            1
        ],
        [
            92864,
            92873,
            1
        ],
        [
            93008,
            93017,
            1
        ],
        [
            93019,
            93025,
            1
        ],
        [
            93824,
            93846,
            1
        ],
        [
            119488,
            119507,
            1
        ],
        [
            119520,
            119539,
            1
        ],
        [
            119648,
            119672,
            1
        ],
        [
            120782,
            120831,
            1
        ],
        [
            123200,
            123209,
            1
        ],
        [
            123632,
            123641,
            1
        ],
        [
            124144,
            124153,
            1
        ],
        [
            125127,
            125135,
            1
        ],
        [
            125264,
            125273,
            1
        ],
        [
            126065,
            126123,
            1
        ],
        [
            126125,
            126127,
            1
        ],
        [
            126129,
            126132,
            1
        ],
        [
            126209,
            126253,
            1
        ],
        [
            126255,
            126269,
            1
        ],
        [
            127232,
            127244,
            1
        ],
        [
            130032,
            130041,
            1
        ]
    ];
    static Nd = [
        [
            48,
            57,
            1
        ],
        [
            1632,
            1641,
            1
        ],
        [
            1776,
            1785,
            1
        ],
        [
            1984,
            1993,
            1
        ],
        [
            2406,
            2415,
            1
        ],
        [
            2534,
            2543,
            1
        ],
        [
            2662,
            2671,
            1
        ],
        [
            2790,
            2799,
            1
        ],
        [
            2918,
            2927,
            1
        ],
        [
            3046,
            3055,
            1
        ],
        [
            3174,
            3183,
            1
        ],
        [
            3302,
            3311,
            1
        ],
        [
            3430,
            3439,
            1
        ],
        [
            3558,
            3567,
            1
        ],
        [
            3664,
            3673,
            1
        ],
        [
            3792,
            3801,
            1
        ],
        [
            3872,
            3881,
            1
        ],
        [
            4160,
            4169,
            1
        ],
        [
            4240,
            4249,
            1
        ],
        [
            6112,
            6121,
            1
        ],
        [
            6160,
            6169,
            1
        ],
        [
            6470,
            6479,
            1
        ],
        [
            6608,
            6617,
            1
        ],
        [
            6784,
            6793,
            1
        ],
        [
            6800,
            6809,
            1
        ],
        [
            6992,
            7001,
            1
        ],
        [
            7088,
            7097,
            1
        ],
        [
            7232,
            7241,
            1
        ],
        [
            7248,
            7257,
            1
        ],
        [
            42528,
            42537,
            1
        ],
        [
            43216,
            43225,
            1
        ],
        [
            43264,
            43273,
            1
        ],
        [
            43472,
            43481,
            1
        ],
        [
            43504,
            43513,
            1
        ],
        [
            43600,
            43609,
            1
        ],
        [
            44016,
            44025,
            1
        ],
        [
            65296,
            65305,
            1
        ],
        [
            66720,
            66729,
            1
        ],
        [
            68912,
            68921,
            1
        ],
        [
            69734,
            69743,
            1
        ],
        [
            69872,
            69881,
            1
        ],
        [
            69942,
            69951,
            1
        ],
        [
            70096,
            70105,
            1
        ],
        [
            70384,
            70393,
            1
        ],
        [
            70736,
            70745,
            1
        ],
        [
            70864,
            70873,
            1
        ],
        [
            71248,
            71257,
            1
        ],
        [
            71360,
            71369,
            1
        ],
        [
            71472,
            71481,
            1
        ],
        [
            71904,
            71913,
            1
        ],
        [
            72016,
            72025,
            1
        ],
        [
            72784,
            72793,
            1
        ],
        [
            73040,
            73049,
            1
        ],
        [
            73120,
            73129,
            1
        ],
        [
            73552,
            73561,
            1
        ],
        [
            92768,
            92777,
            1
        ],
        [
            92864,
            92873,
            1
        ],
        [
            93008,
            93017,
            1
        ],
        [
            120782,
            120831,
            1
        ],
        [
            123200,
            123209,
            1
        ],
        [
            123632,
            123641,
            1
        ],
        [
            124144,
            124153,
            1
        ],
        [
            125264,
            125273,
            1
        ],
        [
            130032,
            130041,
            1
        ]
    ];
    static Nl = [
        [
            5870,
            5872,
            1
        ],
        [
            8544,
            8578,
            1
        ],
        [
            8581,
            8584,
            1
        ],
        [
            12295,
            12321,
            26
        ],
        [
            12322,
            12329,
            1
        ],
        [
            12344,
            12346,
            1
        ],
        [
            42726,
            42735,
            1
        ],
        [
            65856,
            65908,
            1
        ],
        [
            66369,
            66378,
            9
        ],
        [
            66513,
            66517,
            1
        ],
        [
            74752,
            74862,
            1
        ]
    ];
    static No = [
        [
            178,
            179,
            1
        ],
        [
            185,
            188,
            3
        ],
        [
            189,
            190,
            1
        ],
        [
            2548,
            2553,
            1
        ],
        [
            2930,
            2935,
            1
        ],
        [
            3056,
            3058,
            1
        ],
        [
            3192,
            3198,
            1
        ],
        [
            3416,
            3422,
            1
        ],
        [
            3440,
            3448,
            1
        ],
        [
            3882,
            3891,
            1
        ],
        [
            4969,
            4988,
            1
        ],
        [
            6128,
            6137,
            1
        ],
        [
            6618,
            8304,
            1686
        ],
        [
            8308,
            8313,
            1
        ],
        [
            8320,
            8329,
            1
        ],
        [
            8528,
            8543,
            1
        ],
        [
            8585,
            9312,
            727
        ],
        [
            9313,
            9371,
            1
        ],
        [
            9450,
            9471,
            1
        ],
        [
            10102,
            10131,
            1
        ],
        [
            11517,
            12690,
            1173
        ],
        [
            12691,
            12693,
            1
        ],
        [
            12832,
            12841,
            1
        ],
        [
            12872,
            12879,
            1
        ],
        [
            12881,
            12895,
            1
        ],
        [
            12928,
            12937,
            1
        ],
        [
            12977,
            12991,
            1
        ],
        [
            43056,
            43061,
            1
        ],
        [
            65799,
            65843,
            1
        ],
        [
            65909,
            65912,
            1
        ],
        [
            65930,
            65931,
            1
        ],
        [
            66273,
            66299,
            1
        ],
        [
            66336,
            66339,
            1
        ],
        [
            67672,
            67679,
            1
        ],
        [
            67705,
            67711,
            1
        ],
        [
            67751,
            67759,
            1
        ],
        [
            67835,
            67839,
            1
        ],
        [
            67862,
            67867,
            1
        ],
        [
            68028,
            68029,
            1
        ],
        [
            68032,
            68047,
            1
        ],
        [
            68050,
            68095,
            1
        ],
        [
            68160,
            68168,
            1
        ],
        [
            68221,
            68222,
            1
        ],
        [
            68253,
            68255,
            1
        ],
        [
            68331,
            68335,
            1
        ],
        [
            68440,
            68447,
            1
        ],
        [
            68472,
            68479,
            1
        ],
        [
            68521,
            68527,
            1
        ],
        [
            68858,
            68863,
            1
        ],
        [
            69216,
            69246,
            1
        ],
        [
            69405,
            69414,
            1
        ],
        [
            69457,
            69460,
            1
        ],
        [
            69573,
            69579,
            1
        ],
        [
            69714,
            69733,
            1
        ],
        [
            70113,
            70132,
            1
        ],
        [
            71482,
            71483,
            1
        ],
        [
            71914,
            71922,
            1
        ],
        [
            72794,
            72812,
            1
        ],
        [
            73664,
            73684,
            1
        ],
        [
            93019,
            93025,
            1
        ],
        [
            93824,
            93846,
            1
        ],
        [
            119488,
            119507,
            1
        ],
        [
            119520,
            119539,
            1
        ],
        [
            119648,
            119672,
            1
        ],
        [
            125127,
            125135,
            1
        ],
        [
            126065,
            126123,
            1
        ],
        [
            126125,
            126127,
            1
        ],
        [
            126129,
            126132,
            1
        ],
        [
            126209,
            126253,
            1
        ],
        [
            126255,
            126269,
            1
        ],
        [
            127232,
            127244,
            1
        ]
    ];
    static P = [
        [
            33,
            35,
            1
        ],
        [
            37,
            42,
            1
        ],
        [
            44,
            47,
            1
        ],
        [
            58,
            59,
            1
        ],
        [
            63,
            64,
            1
        ],
        [
            91,
            93,
            1
        ],
        [
            95,
            123,
            28
        ],
        [
            125,
            161,
            36
        ],
        [
            167,
            171,
            4
        ],
        [
            182,
            183,
            1
        ],
        [
            187,
            191,
            4
        ],
        [
            894,
            903,
            9
        ],
        [
            1370,
            1375,
            1
        ],
        [
            1417,
            1418,
            1
        ],
        [
            1470,
            1472,
            2
        ],
        [
            1475,
            1478,
            3
        ],
        [
            1523,
            1524,
            1
        ],
        [
            1545,
            1546,
            1
        ],
        [
            1548,
            1549,
            1
        ],
        [
            1563,
            1565,
            2
        ],
        [
            1566,
            1567,
            1
        ],
        [
            1642,
            1645,
            1
        ],
        [
            1748,
            1792,
            44
        ],
        [
            1793,
            1805,
            1
        ],
        [
            2039,
            2041,
            1
        ],
        [
            2096,
            2110,
            1
        ],
        [
            2142,
            2404,
            262
        ],
        [
            2405,
            2416,
            11
        ],
        [
            2557,
            2678,
            121
        ],
        [
            2800,
            3191,
            391
        ],
        [
            3204,
            3572,
            368
        ],
        [
            3663,
            3674,
            11
        ],
        [
            3675,
            3844,
            169
        ],
        [
            3845,
            3858,
            1
        ],
        [
            3860,
            3898,
            38
        ],
        [
            3899,
            3901,
            1
        ],
        [
            3973,
            4048,
            75
        ],
        [
            4049,
            4052,
            1
        ],
        [
            4057,
            4058,
            1
        ],
        [
            4170,
            4175,
            1
        ],
        [
            4347,
            4960,
            613
        ],
        [
            4961,
            4968,
            1
        ],
        [
            5120,
            5742,
            622
        ],
        [
            5787,
            5788,
            1
        ],
        [
            5867,
            5869,
            1
        ],
        [
            5941,
            5942,
            1
        ],
        [
            6100,
            6102,
            1
        ],
        [
            6104,
            6106,
            1
        ],
        [
            6144,
            6154,
            1
        ],
        [
            6468,
            6469,
            1
        ],
        [
            6686,
            6687,
            1
        ],
        [
            6816,
            6822,
            1
        ],
        [
            6824,
            6829,
            1
        ],
        [
            7002,
            7008,
            1
        ],
        [
            7037,
            7038,
            1
        ],
        [
            7164,
            7167,
            1
        ],
        [
            7227,
            7231,
            1
        ],
        [
            7294,
            7295,
            1
        ],
        [
            7360,
            7367,
            1
        ],
        [
            7379,
            8208,
            829
        ],
        [
            8209,
            8231,
            1
        ],
        [
            8240,
            8259,
            1
        ],
        [
            8261,
            8273,
            1
        ],
        [
            8275,
            8286,
            1
        ],
        [
            8317,
            8318,
            1
        ],
        [
            8333,
            8334,
            1
        ],
        [
            8968,
            8971,
            1
        ],
        [
            9001,
            9002,
            1
        ],
        [
            10088,
            10101,
            1
        ],
        [
            10181,
            10182,
            1
        ],
        [
            10214,
            10223,
            1
        ],
        [
            10627,
            10648,
            1
        ],
        [
            10712,
            10715,
            1
        ],
        [
            10748,
            10749,
            1
        ],
        [
            11513,
            11516,
            1
        ],
        [
            11518,
            11519,
            1
        ],
        [
            11632,
            11776,
            144
        ],
        [
            11777,
            11822,
            1
        ],
        [
            11824,
            11855,
            1
        ],
        [
            11858,
            11869,
            1
        ],
        [
            12289,
            12291,
            1
        ],
        [
            12296,
            12305,
            1
        ],
        [
            12308,
            12319,
            1
        ],
        [
            12336,
            12349,
            13
        ],
        [
            12448,
            12539,
            91
        ],
        [
            42238,
            42239,
            1
        ],
        [
            42509,
            42511,
            1
        ],
        [
            42611,
            42622,
            11
        ],
        [
            42738,
            42743,
            1
        ],
        [
            43124,
            43127,
            1
        ],
        [
            43214,
            43215,
            1
        ],
        [
            43256,
            43258,
            1
        ],
        [
            43260,
            43310,
            50
        ],
        [
            43311,
            43359,
            48
        ],
        [
            43457,
            43469,
            1
        ],
        [
            43486,
            43487,
            1
        ],
        [
            43612,
            43615,
            1
        ],
        [
            43742,
            43743,
            1
        ],
        [
            43760,
            43761,
            1
        ],
        [
            44011,
            64830,
            20819
        ],
        [
            64831,
            65040,
            209
        ],
        [
            65041,
            65049,
            1
        ],
        [
            65072,
            65106,
            1
        ],
        [
            65108,
            65121,
            1
        ],
        [
            65123,
            65128,
            5
        ],
        [
            65130,
            65131,
            1
        ],
        [
            65281,
            65283,
            1
        ],
        [
            65285,
            65290,
            1
        ],
        [
            65292,
            65295,
            1
        ],
        [
            65306,
            65307,
            1
        ],
        [
            65311,
            65312,
            1
        ],
        [
            65339,
            65341,
            1
        ],
        [
            65343,
            65371,
            28
        ],
        [
            65373,
            65375,
            2
        ],
        [
            65376,
            65381,
            1
        ],
        [
            65792,
            65794,
            1
        ],
        [
            66463,
            66512,
            49
        ],
        [
            66927,
            67671,
            744
        ],
        [
            67871,
            67903,
            32
        ],
        [
            68176,
            68184,
            1
        ],
        [
            68223,
            68336,
            113
        ],
        [
            68337,
            68342,
            1
        ],
        [
            68409,
            68415,
            1
        ],
        [
            68505,
            68508,
            1
        ],
        [
            69293,
            69461,
            168
        ],
        [
            69462,
            69465,
            1
        ],
        [
            69510,
            69513,
            1
        ],
        [
            69703,
            69709,
            1
        ],
        [
            69819,
            69820,
            1
        ],
        [
            69822,
            69825,
            1
        ],
        [
            69952,
            69955,
            1
        ],
        [
            70004,
            70005,
            1
        ],
        [
            70085,
            70088,
            1
        ],
        [
            70093,
            70107,
            14
        ],
        [
            70109,
            70111,
            1
        ],
        [
            70200,
            70205,
            1
        ],
        [
            70313,
            70731,
            418
        ],
        [
            70732,
            70735,
            1
        ],
        [
            70746,
            70747,
            1
        ],
        [
            70749,
            70854,
            105
        ],
        [
            71105,
            71127,
            1
        ],
        [
            71233,
            71235,
            1
        ],
        [
            71264,
            71276,
            1
        ],
        [
            71353,
            71484,
            131
        ],
        [
            71485,
            71486,
            1
        ],
        [
            71739,
            72004,
            265
        ],
        [
            72005,
            72006,
            1
        ],
        [
            72162,
            72255,
            93
        ],
        [
            72256,
            72262,
            1
        ],
        [
            72346,
            72348,
            1
        ],
        [
            72350,
            72354,
            1
        ],
        [
            72448,
            72457,
            1
        ],
        [
            72769,
            72773,
            1
        ],
        [
            72816,
            72817,
            1
        ],
        [
            73463,
            73464,
            1
        ],
        [
            73539,
            73551,
            1
        ],
        [
            73727,
            74864,
            1137
        ],
        [
            74865,
            74868,
            1
        ],
        [
            77809,
            77810,
            1
        ],
        [
            92782,
            92783,
            1
        ],
        [
            92917,
            92983,
            66
        ],
        [
            92984,
            92987,
            1
        ],
        [
            92996,
            93847,
            851
        ],
        [
            93848,
            93850,
            1
        ],
        [
            94178,
            113823,
            19645
        ],
        [
            121479,
            121483,
            1
        ],
        [
            125278,
            125279,
            1
        ]
    ];
    static Pc = [
        [
            95,
            8255,
            8160
        ],
        [
            8256,
            8276,
            20
        ],
        [
            65075,
            65076,
            1
        ],
        [
            65101,
            65103,
            1
        ],
        [
            65343,
            65343,
            1
        ]
    ];
    static Pd = [
        [
            45,
            1418,
            1373
        ],
        [
            1470,
            5120,
            3650
        ],
        [
            6150,
            8208,
            2058
        ],
        [
            8209,
            8213,
            1
        ],
        [
            11799,
            11802,
            3
        ],
        [
            11834,
            11835,
            1
        ],
        [
            11840,
            11869,
            29
        ],
        [
            12316,
            12336,
            20
        ],
        [
            12448,
            65073,
            52625
        ],
        [
            65074,
            65112,
            38
        ],
        [
            65123,
            65293,
            170
        ],
        [
            69293,
            69293,
            1
        ]
    ];
    static Pe = [
        [
            41,
            93,
            52
        ],
        [
            125,
            3899,
            3774
        ],
        [
            3901,
            5788,
            1887
        ],
        [
            8262,
            8318,
            56
        ],
        [
            8334,
            8969,
            635
        ],
        [
            8971,
            9002,
            31
        ],
        [
            10089,
            10101,
            2
        ],
        [
            10182,
            10215,
            33
        ],
        [
            10217,
            10223,
            2
        ],
        [
            10628,
            10648,
            2
        ],
        [
            10713,
            10715,
            2
        ],
        [
            10749,
            11811,
            1062
        ],
        [
            11813,
            11817,
            2
        ],
        [
            11862,
            11868,
            2
        ],
        [
            12297,
            12305,
            2
        ],
        [
            12309,
            12315,
            2
        ],
        [
            12318,
            12319,
            1
        ],
        [
            64830,
            65048,
            218
        ],
        [
            65078,
            65092,
            2
        ],
        [
            65096,
            65114,
            18
        ],
        [
            65116,
            65118,
            2
        ],
        [
            65289,
            65341,
            52
        ],
        [
            65373,
            65379,
            3
        ]
    ];
    static Pf = [
        [
            187,
            8217,
            8030
        ],
        [
            8221,
            8250,
            29
        ],
        [
            11779,
            11781,
            2
        ],
        [
            11786,
            11789,
            3
        ],
        [
            11805,
            11809,
            4
        ]
    ];
    static Pi = [
        [
            171,
            8216,
            8045
        ],
        [
            8219,
            8220,
            1
        ],
        [
            8223,
            8249,
            26
        ],
        [
            11778,
            11780,
            2
        ],
        [
            11785,
            11788,
            3
        ],
        [
            11804,
            11808,
            4
        ]
    ];
    static Po = [
        [
            33,
            35,
            1
        ],
        [
            37,
            39,
            1
        ],
        [
            42,
            46,
            2
        ],
        [
            47,
            58,
            11
        ],
        [
            59,
            63,
            4
        ],
        [
            64,
            92,
            28
        ],
        [
            161,
            167,
            6
        ],
        [
            182,
            183,
            1
        ],
        [
            191,
            894,
            703
        ],
        [
            903,
            1370,
            467
        ],
        [
            1371,
            1375,
            1
        ],
        [
            1417,
            1472,
            55
        ],
        [
            1475,
            1478,
            3
        ],
        [
            1523,
            1524,
            1
        ],
        [
            1545,
            1546,
            1
        ],
        [
            1548,
            1549,
            1
        ],
        [
            1563,
            1565,
            2
        ],
        [
            1566,
            1567,
            1
        ],
        [
            1642,
            1645,
            1
        ],
        [
            1748,
            1792,
            44
        ],
        [
            1793,
            1805,
            1
        ],
        [
            2039,
            2041,
            1
        ],
        [
            2096,
            2110,
            1
        ],
        [
            2142,
            2404,
            262
        ],
        [
            2405,
            2416,
            11
        ],
        [
            2557,
            2678,
            121
        ],
        [
            2800,
            3191,
            391
        ],
        [
            3204,
            3572,
            368
        ],
        [
            3663,
            3674,
            11
        ],
        [
            3675,
            3844,
            169
        ],
        [
            3845,
            3858,
            1
        ],
        [
            3860,
            3973,
            113
        ],
        [
            4048,
            4052,
            1
        ],
        [
            4057,
            4058,
            1
        ],
        [
            4170,
            4175,
            1
        ],
        [
            4347,
            4960,
            613
        ],
        [
            4961,
            4968,
            1
        ],
        [
            5742,
            5867,
            125
        ],
        [
            5868,
            5869,
            1
        ],
        [
            5941,
            5942,
            1
        ],
        [
            6100,
            6102,
            1
        ],
        [
            6104,
            6106,
            1
        ],
        [
            6144,
            6149,
            1
        ],
        [
            6151,
            6154,
            1
        ],
        [
            6468,
            6469,
            1
        ],
        [
            6686,
            6687,
            1
        ],
        [
            6816,
            6822,
            1
        ],
        [
            6824,
            6829,
            1
        ],
        [
            7002,
            7008,
            1
        ],
        [
            7037,
            7038,
            1
        ],
        [
            7164,
            7167,
            1
        ],
        [
            7227,
            7231,
            1
        ],
        [
            7294,
            7295,
            1
        ],
        [
            7360,
            7367,
            1
        ],
        [
            7379,
            8214,
            835
        ],
        [
            8215,
            8224,
            9
        ],
        [
            8225,
            8231,
            1
        ],
        [
            8240,
            8248,
            1
        ],
        [
            8251,
            8254,
            1
        ],
        [
            8257,
            8259,
            1
        ],
        [
            8263,
            8273,
            1
        ],
        [
            8275,
            8277,
            2
        ],
        [
            8278,
            8286,
            1
        ],
        [
            11513,
            11516,
            1
        ],
        [
            11518,
            11519,
            1
        ],
        [
            11632,
            11776,
            144
        ],
        [
            11777,
            11782,
            5
        ],
        [
            11783,
            11784,
            1
        ],
        [
            11787,
            11790,
            3
        ],
        [
            11791,
            11798,
            1
        ],
        [
            11800,
            11801,
            1
        ],
        [
            11803,
            11806,
            3
        ],
        [
            11807,
            11818,
            11
        ],
        [
            11819,
            11822,
            1
        ],
        [
            11824,
            11833,
            1
        ],
        [
            11836,
            11839,
            1
        ],
        [
            11841,
            11843,
            2
        ],
        [
            11844,
            11855,
            1
        ],
        [
            11858,
            11860,
            1
        ],
        [
            12289,
            12291,
            1
        ],
        [
            12349,
            12539,
            190
        ],
        [
            42238,
            42239,
            1
        ],
        [
            42509,
            42511,
            1
        ],
        [
            42611,
            42622,
            11
        ],
        [
            42738,
            42743,
            1
        ],
        [
            43124,
            43127,
            1
        ],
        [
            43214,
            43215,
            1
        ],
        [
            43256,
            43258,
            1
        ],
        [
            43260,
            43310,
            50
        ],
        [
            43311,
            43359,
            48
        ],
        [
            43457,
            43469,
            1
        ],
        [
            43486,
            43487,
            1
        ],
        [
            43612,
            43615,
            1
        ],
        [
            43742,
            43743,
            1
        ],
        [
            43760,
            43761,
            1
        ],
        [
            44011,
            65040,
            21029
        ],
        [
            65041,
            65046,
            1
        ],
        [
            65049,
            65072,
            23
        ],
        [
            65093,
            65094,
            1
        ],
        [
            65097,
            65100,
            1
        ],
        [
            65104,
            65106,
            1
        ],
        [
            65108,
            65111,
            1
        ],
        [
            65119,
            65121,
            1
        ],
        [
            65128,
            65130,
            2
        ],
        [
            65131,
            65281,
            150
        ],
        [
            65282,
            65283,
            1
        ],
        [
            65285,
            65287,
            1
        ],
        [
            65290,
            65294,
            2
        ],
        [
            65295,
            65306,
            11
        ],
        [
            65307,
            65311,
            4
        ],
        [
            65312,
            65340,
            28
        ],
        [
            65377,
            65380,
            3
        ],
        [
            65381,
            65792,
            411
        ],
        [
            65793,
            65794,
            1
        ],
        [
            66463,
            66512,
            49
        ],
        [
            66927,
            67671,
            744
        ],
        [
            67871,
            67903,
            32
        ],
        [
            68176,
            68184,
            1
        ],
        [
            68223,
            68336,
            113
        ],
        [
            68337,
            68342,
            1
        ],
        [
            68409,
            68415,
            1
        ],
        [
            68505,
            68508,
            1
        ],
        [
            69461,
            69465,
            1
        ],
        [
            69510,
            69513,
            1
        ],
        [
            69703,
            69709,
            1
        ],
        [
            69819,
            69820,
            1
        ],
        [
            69822,
            69825,
            1
        ],
        [
            69952,
            69955,
            1
        ],
        [
            70004,
            70005,
            1
        ],
        [
            70085,
            70088,
            1
        ],
        [
            70093,
            70107,
            14
        ],
        [
            70109,
            70111,
            1
        ],
        [
            70200,
            70205,
            1
        ],
        [
            70313,
            70731,
            418
        ],
        [
            70732,
            70735,
            1
        ],
        [
            70746,
            70747,
            1
        ],
        [
            70749,
            70854,
            105
        ],
        [
            71105,
            71127,
            1
        ],
        [
            71233,
            71235,
            1
        ],
        [
            71264,
            71276,
            1
        ],
        [
            71353,
            71484,
            131
        ],
        [
            71485,
            71486,
            1
        ],
        [
            71739,
            72004,
            265
        ],
        [
            72005,
            72006,
            1
        ],
        [
            72162,
            72255,
            93
        ],
        [
            72256,
            72262,
            1
        ],
        [
            72346,
            72348,
            1
        ],
        [
            72350,
            72354,
            1
        ],
        [
            72448,
            72457,
            1
        ],
        [
            72769,
            72773,
            1
        ],
        [
            72816,
            72817,
            1
        ],
        [
            73463,
            73464,
            1
        ],
        [
            73539,
            73551,
            1
        ],
        [
            73727,
            74864,
            1137
        ],
        [
            74865,
            74868,
            1
        ],
        [
            77809,
            77810,
            1
        ],
        [
            92782,
            92783,
            1
        ],
        [
            92917,
            92983,
            66
        ],
        [
            92984,
            92987,
            1
        ],
        [
            92996,
            93847,
            851
        ],
        [
            93848,
            93850,
            1
        ],
        [
            94178,
            113823,
            19645
        ],
        [
            121479,
            121483,
            1
        ],
        [
            125278,
            125279,
            1
        ]
    ];
    static Ps = [
        [
            40,
            91,
            51
        ],
        [
            123,
            3898,
            3775
        ],
        [
            3900,
            5787,
            1887
        ],
        [
            8218,
            8222,
            4
        ],
        [
            8261,
            8317,
            56
        ],
        [
            8333,
            8968,
            635
        ],
        [
            8970,
            9001,
            31
        ],
        [
            10088,
            10100,
            2
        ],
        [
            10181,
            10214,
            33
        ],
        [
            10216,
            10222,
            2
        ],
        [
            10627,
            10647,
            2
        ],
        [
            10712,
            10714,
            2
        ],
        [
            10748,
            11810,
            1062
        ],
        [
            11812,
            11816,
            2
        ],
        [
            11842,
            11861,
            19
        ],
        [
            11863,
            11867,
            2
        ],
        [
            12296,
            12304,
            2
        ],
        [
            12308,
            12314,
            2
        ],
        [
            12317,
            64831,
            52514
        ],
        [
            65047,
            65077,
            30
        ],
        [
            65079,
            65091,
            2
        ],
        [
            65095,
            65113,
            18
        ],
        [
            65115,
            65117,
            2
        ],
        [
            65288,
            65339,
            51
        ],
        [
            65371,
            65375,
            4
        ],
        [
            65378,
            65378,
            1
        ]
    ];
    static S = [
        [
            36,
            43,
            7
        ],
        [
            60,
            62,
            1
        ],
        [
            94,
            96,
            2
        ],
        [
            124,
            126,
            2
        ],
        [
            162,
            166,
            1
        ],
        [
            168,
            169,
            1
        ],
        [
            172,
            174,
            2
        ],
        [
            175,
            177,
            1
        ],
        [
            180,
            184,
            4
        ],
        [
            215,
            247,
            32
        ],
        [
            706,
            709,
            1
        ],
        [
            722,
            735,
            1
        ],
        [
            741,
            747,
            1
        ],
        [
            749,
            751,
            2
        ],
        [
            752,
            767,
            1
        ],
        [
            885,
            900,
            15
        ],
        [
            901,
            1014,
            113
        ],
        [
            1154,
            1421,
            267
        ],
        [
            1422,
            1423,
            1
        ],
        [
            1542,
            1544,
            1
        ],
        [
            1547,
            1550,
            3
        ],
        [
            1551,
            1758,
            207
        ],
        [
            1769,
            1789,
            20
        ],
        [
            1790,
            2038,
            248
        ],
        [
            2046,
            2047,
            1
        ],
        [
            2184,
            2546,
            362
        ],
        [
            2547,
            2554,
            7
        ],
        [
            2555,
            2801,
            246
        ],
        [
            2928,
            3059,
            131
        ],
        [
            3060,
            3066,
            1
        ],
        [
            3199,
            3407,
            208
        ],
        [
            3449,
            3647,
            198
        ],
        [
            3841,
            3843,
            1
        ],
        [
            3859,
            3861,
            2
        ],
        [
            3862,
            3863,
            1
        ],
        [
            3866,
            3871,
            1
        ],
        [
            3892,
            3896,
            2
        ],
        [
            4030,
            4037,
            1
        ],
        [
            4039,
            4044,
            1
        ],
        [
            4046,
            4047,
            1
        ],
        [
            4053,
            4056,
            1
        ],
        [
            4254,
            4255,
            1
        ],
        [
            5008,
            5017,
            1
        ],
        [
            5741,
            6107,
            366
        ],
        [
            6464,
            6622,
            158
        ],
        [
            6623,
            6655,
            1
        ],
        [
            7009,
            7018,
            1
        ],
        [
            7028,
            7036,
            1
        ],
        [
            8125,
            8127,
            2
        ],
        [
            8128,
            8129,
            1
        ],
        [
            8141,
            8143,
            1
        ],
        [
            8157,
            8159,
            1
        ],
        [
            8173,
            8175,
            1
        ],
        [
            8189,
            8190,
            1
        ],
        [
            8260,
            8274,
            14
        ],
        [
            8314,
            8316,
            1
        ],
        [
            8330,
            8332,
            1
        ],
        [
            8352,
            8384,
            1
        ],
        [
            8448,
            8449,
            1
        ],
        [
            8451,
            8454,
            1
        ],
        [
            8456,
            8457,
            1
        ],
        [
            8468,
            8470,
            2
        ],
        [
            8471,
            8472,
            1
        ],
        [
            8478,
            8483,
            1
        ],
        [
            8485,
            8489,
            2
        ],
        [
            8494,
            8506,
            12
        ],
        [
            8507,
            8512,
            5
        ],
        [
            8513,
            8516,
            1
        ],
        [
            8522,
            8525,
            1
        ],
        [
            8527,
            8586,
            59
        ],
        [
            8587,
            8592,
            5
        ],
        [
            8593,
            8967,
            1
        ],
        [
            8972,
            9000,
            1
        ],
        [
            9003,
            9254,
            1
        ],
        [
            9280,
            9290,
            1
        ],
        [
            9372,
            9449,
            1
        ],
        [
            9472,
            10087,
            1
        ],
        [
            10132,
            10180,
            1
        ],
        [
            10183,
            10213,
            1
        ],
        [
            10224,
            10626,
            1
        ],
        [
            10649,
            10711,
            1
        ],
        [
            10716,
            10747,
            1
        ],
        [
            10750,
            11123,
            1
        ],
        [
            11126,
            11157,
            1
        ],
        [
            11159,
            11263,
            1
        ],
        [
            11493,
            11498,
            1
        ],
        [
            11856,
            11857,
            1
        ],
        [
            11904,
            11929,
            1
        ],
        [
            11931,
            12019,
            1
        ],
        [
            12032,
            12245,
            1
        ],
        [
            12272,
            12287,
            1
        ],
        [
            12292,
            12306,
            14
        ],
        [
            12307,
            12320,
            13
        ],
        [
            12342,
            12343,
            1
        ],
        [
            12350,
            12351,
            1
        ],
        [
            12443,
            12444,
            1
        ],
        [
            12688,
            12689,
            1
        ],
        [
            12694,
            12703,
            1
        ],
        [
            12736,
            12771,
            1
        ],
        [
            12783,
            12800,
            17
        ],
        [
            12801,
            12830,
            1
        ],
        [
            12842,
            12871,
            1
        ],
        [
            12880,
            12896,
            16
        ],
        [
            12897,
            12927,
            1
        ],
        [
            12938,
            12976,
            1
        ],
        [
            12992,
            13311,
            1
        ],
        [
            19904,
            19967,
            1
        ],
        [
            42128,
            42182,
            1
        ],
        [
            42752,
            42774,
            1
        ],
        [
            42784,
            42785,
            1
        ],
        [
            42889,
            42890,
            1
        ],
        [
            43048,
            43051,
            1
        ],
        [
            43062,
            43065,
            1
        ],
        [
            43639,
            43641,
            1
        ],
        [
            43867,
            43882,
            15
        ],
        [
            43883,
            64297,
            20414
        ],
        [
            64434,
            64450,
            1
        ],
        [
            64832,
            64847,
            1
        ],
        [
            64975,
            65020,
            45
        ],
        [
            65021,
            65023,
            1
        ],
        [
            65122,
            65124,
            2
        ],
        [
            65125,
            65126,
            1
        ],
        [
            65129,
            65284,
            155
        ],
        [
            65291,
            65308,
            17
        ],
        [
            65309,
            65310,
            1
        ],
        [
            65342,
            65344,
            2
        ],
        [
            65372,
            65374,
            2
        ],
        [
            65504,
            65510,
            1
        ],
        [
            65512,
            65518,
            1
        ],
        [
            65532,
            65533,
            1
        ],
        [
            65847,
            65855,
            1
        ],
        [
            65913,
            65929,
            1
        ],
        [
            65932,
            65934,
            1
        ],
        [
            65936,
            65948,
            1
        ],
        [
            65952,
            66000,
            48
        ],
        [
            66001,
            66044,
            1
        ],
        [
            67703,
            67704,
            1
        ],
        [
            68296,
            71487,
            3191
        ],
        [
            73685,
            73713,
            1
        ],
        [
            92988,
            92991,
            1
        ],
        [
            92997,
            113820,
            20823
        ],
        [
            118608,
            118723,
            1
        ],
        [
            118784,
            119029,
            1
        ],
        [
            119040,
            119078,
            1
        ],
        [
            119081,
            119140,
            1
        ],
        [
            119146,
            119148,
            1
        ],
        [
            119171,
            119172,
            1
        ],
        [
            119180,
            119209,
            1
        ],
        [
            119214,
            119274,
            1
        ],
        [
            119296,
            119361,
            1
        ],
        [
            119365,
            119552,
            187
        ],
        [
            119553,
            119638,
            1
        ],
        [
            120513,
            120539,
            26
        ],
        [
            120571,
            120597,
            26
        ],
        [
            120629,
            120655,
            26
        ],
        [
            120687,
            120713,
            26
        ],
        [
            120745,
            120771,
            26
        ],
        [
            120832,
            121343,
            1
        ],
        [
            121399,
            121402,
            1
        ],
        [
            121453,
            121460,
            1
        ],
        [
            121462,
            121475,
            1
        ],
        [
            121477,
            121478,
            1
        ],
        [
            123215,
            123647,
            432
        ],
        [
            126124,
            126128,
            4
        ],
        [
            126254,
            126704,
            450
        ],
        [
            126705,
            126976,
            271
        ],
        [
            126977,
            127019,
            1
        ],
        [
            127024,
            127123,
            1
        ],
        [
            127136,
            127150,
            1
        ],
        [
            127153,
            127167,
            1
        ],
        [
            127169,
            127183,
            1
        ],
        [
            127185,
            127221,
            1
        ],
        [
            127245,
            127405,
            1
        ],
        [
            127462,
            127490,
            1
        ],
        [
            127504,
            127547,
            1
        ],
        [
            127552,
            127560,
            1
        ],
        [
            127568,
            127569,
            1
        ],
        [
            127584,
            127589,
            1
        ],
        [
            127744,
            128727,
            1
        ],
        [
            128732,
            128748,
            1
        ],
        [
            128752,
            128764,
            1
        ],
        [
            128768,
            128886,
            1
        ],
        [
            128891,
            128985,
            1
        ],
        [
            128992,
            129003,
            1
        ],
        [
            129008,
            129024,
            16
        ],
        [
            129025,
            129035,
            1
        ],
        [
            129040,
            129095,
            1
        ],
        [
            129104,
            129113,
            1
        ],
        [
            129120,
            129159,
            1
        ],
        [
            129168,
            129197,
            1
        ],
        [
            129200,
            129201,
            1
        ],
        [
            129280,
            129619,
            1
        ],
        [
            129632,
            129645,
            1
        ],
        [
            129648,
            129660,
            1
        ],
        [
            129664,
            129672,
            1
        ],
        [
            129680,
            129725,
            1
        ],
        [
            129727,
            129733,
            1
        ],
        [
            129742,
            129755,
            1
        ],
        [
            129760,
            129768,
            1
        ],
        [
            129776,
            129784,
            1
        ],
        [
            129792,
            129938,
            1
        ],
        [
            129940,
            129994,
            1
        ]
    ];
    static Sc = [
        [
            36,
            162,
            126
        ],
        [
            163,
            165,
            1
        ],
        [
            1423,
            1547,
            124
        ],
        [
            2046,
            2047,
            1
        ],
        [
            2546,
            2547,
            1
        ],
        [
            2555,
            2801,
            246
        ],
        [
            3065,
            3647,
            582
        ],
        [
            6107,
            8352,
            2245
        ],
        [
            8353,
            8384,
            1
        ],
        [
            43064,
            65020,
            21956
        ],
        [
            65129,
            65284,
            155
        ],
        [
            65504,
            65505,
            1
        ],
        [
            65509,
            65510,
            1
        ],
        [
            73693,
            73696,
            1
        ],
        [
            123647,
            126128,
            2481
        ]
    ];
    static Sk = [
        [
            94,
            96,
            2
        ],
        [
            168,
            175,
            7
        ],
        [
            180,
            184,
            4
        ],
        [
            706,
            709,
            1
        ],
        [
            722,
            735,
            1
        ],
        [
            741,
            747,
            1
        ],
        [
            749,
            751,
            2
        ],
        [
            752,
            767,
            1
        ],
        [
            885,
            900,
            15
        ],
        [
            901,
            2184,
            1283
        ],
        [
            8125,
            8127,
            2
        ],
        [
            8128,
            8129,
            1
        ],
        [
            8141,
            8143,
            1
        ],
        [
            8157,
            8159,
            1
        ],
        [
            8173,
            8175,
            1
        ],
        [
            8189,
            8190,
            1
        ],
        [
            12443,
            12444,
            1
        ],
        [
            42752,
            42774,
            1
        ],
        [
            42784,
            42785,
            1
        ],
        [
            42889,
            42890,
            1
        ],
        [
            43867,
            43882,
            15
        ],
        [
            43883,
            64434,
            20551
        ],
        [
            64435,
            64450,
            1
        ],
        [
            65342,
            65344,
            2
        ],
        [
            65507,
            127995,
            62488
        ],
        [
            127996,
            127999,
            1
        ]
    ];
    static Sm = [
        [
            43,
            60,
            17
        ],
        [
            61,
            62,
            1
        ],
        [
            124,
            126,
            2
        ],
        [
            172,
            177,
            5
        ],
        [
            215,
            247,
            32
        ],
        [
            1014,
            1542,
            528
        ],
        [
            1543,
            1544,
            1
        ],
        [
            8260,
            8274,
            14
        ],
        [
            8314,
            8316,
            1
        ],
        [
            8330,
            8332,
            1
        ],
        [
            8472,
            8512,
            40
        ],
        [
            8513,
            8516,
            1
        ],
        [
            8523,
            8592,
            69
        ],
        [
            8593,
            8596,
            1
        ],
        [
            8602,
            8603,
            1
        ],
        [
            8608,
            8614,
            3
        ],
        [
            8622,
            8654,
            32
        ],
        [
            8655,
            8658,
            3
        ],
        [
            8660,
            8692,
            32
        ],
        [
            8693,
            8959,
            1
        ],
        [
            8992,
            8993,
            1
        ],
        [
            9084,
            9115,
            31
        ],
        [
            9116,
            9139,
            1
        ],
        [
            9180,
            9185,
            1
        ],
        [
            9655,
            9665,
            10
        ],
        [
            9720,
            9727,
            1
        ],
        [
            9839,
            10176,
            337
        ],
        [
            10177,
            10180,
            1
        ],
        [
            10183,
            10213,
            1
        ],
        [
            10224,
            10239,
            1
        ],
        [
            10496,
            10626,
            1
        ],
        [
            10649,
            10711,
            1
        ],
        [
            10716,
            10747,
            1
        ],
        [
            10750,
            11007,
            1
        ],
        [
            11056,
            11076,
            1
        ],
        [
            11079,
            11084,
            1
        ],
        [
            64297,
            65122,
            825
        ],
        [
            65124,
            65126,
            1
        ],
        [
            65291,
            65308,
            17
        ],
        [
            65309,
            65310,
            1
        ],
        [
            65372,
            65374,
            2
        ],
        [
            65506,
            65513,
            7
        ],
        [
            65514,
            65516,
            1
        ],
        [
            120513,
            120539,
            26
        ],
        [
            120571,
            120597,
            26
        ],
        [
            120629,
            120655,
            26
        ],
        [
            120687,
            120713,
            26
        ],
        [
            120745,
            120771,
            26
        ],
        [
            126704,
            126705,
            1
        ]
    ];
    static So = [
        [
            166,
            169,
            3
        ],
        [
            174,
            176,
            2
        ],
        [
            1154,
            1421,
            267
        ],
        [
            1422,
            1550,
            128
        ],
        [
            1551,
            1758,
            207
        ],
        [
            1769,
            1789,
            20
        ],
        [
            1790,
            2038,
            248
        ],
        [
            2554,
            2928,
            374
        ],
        [
            3059,
            3064,
            1
        ],
        [
            3066,
            3199,
            133
        ],
        [
            3407,
            3449,
            42
        ],
        [
            3841,
            3843,
            1
        ],
        [
            3859,
            3861,
            2
        ],
        [
            3862,
            3863,
            1
        ],
        [
            3866,
            3871,
            1
        ],
        [
            3892,
            3896,
            2
        ],
        [
            4030,
            4037,
            1
        ],
        [
            4039,
            4044,
            1
        ],
        [
            4046,
            4047,
            1
        ],
        [
            4053,
            4056,
            1
        ],
        [
            4254,
            4255,
            1
        ],
        [
            5008,
            5017,
            1
        ],
        [
            5741,
            6464,
            723
        ],
        [
            6622,
            6655,
            1
        ],
        [
            7009,
            7018,
            1
        ],
        [
            7028,
            7036,
            1
        ],
        [
            8448,
            8449,
            1
        ],
        [
            8451,
            8454,
            1
        ],
        [
            8456,
            8457,
            1
        ],
        [
            8468,
            8470,
            2
        ],
        [
            8471,
            8478,
            7
        ],
        [
            8479,
            8483,
            1
        ],
        [
            8485,
            8489,
            2
        ],
        [
            8494,
            8506,
            12
        ],
        [
            8507,
            8522,
            15
        ],
        [
            8524,
            8525,
            1
        ],
        [
            8527,
            8586,
            59
        ],
        [
            8587,
            8597,
            10
        ],
        [
            8598,
            8601,
            1
        ],
        [
            8604,
            8607,
            1
        ],
        [
            8609,
            8610,
            1
        ],
        [
            8612,
            8613,
            1
        ],
        [
            8615,
            8621,
            1
        ],
        [
            8623,
            8653,
            1
        ],
        [
            8656,
            8657,
            1
        ],
        [
            8659,
            8661,
            2
        ],
        [
            8662,
            8691,
            1
        ],
        [
            8960,
            8967,
            1
        ],
        [
            8972,
            8991,
            1
        ],
        [
            8994,
            9000,
            1
        ],
        [
            9003,
            9083,
            1
        ],
        [
            9085,
            9114,
            1
        ],
        [
            9140,
            9179,
            1
        ],
        [
            9186,
            9254,
            1
        ],
        [
            9280,
            9290,
            1
        ],
        [
            9372,
            9449,
            1
        ],
        [
            9472,
            9654,
            1
        ],
        [
            9656,
            9664,
            1
        ],
        [
            9666,
            9719,
            1
        ],
        [
            9728,
            9838,
            1
        ],
        [
            9840,
            10087,
            1
        ],
        [
            10132,
            10175,
            1
        ],
        [
            10240,
            10495,
            1
        ],
        [
            11008,
            11055,
            1
        ],
        [
            11077,
            11078,
            1
        ],
        [
            11085,
            11123,
            1
        ],
        [
            11126,
            11157,
            1
        ],
        [
            11159,
            11263,
            1
        ],
        [
            11493,
            11498,
            1
        ],
        [
            11856,
            11857,
            1
        ],
        [
            11904,
            11929,
            1
        ],
        [
            11931,
            12019,
            1
        ],
        [
            12032,
            12245,
            1
        ],
        [
            12272,
            12287,
            1
        ],
        [
            12292,
            12306,
            14
        ],
        [
            12307,
            12320,
            13
        ],
        [
            12342,
            12343,
            1
        ],
        [
            12350,
            12351,
            1
        ],
        [
            12688,
            12689,
            1
        ],
        [
            12694,
            12703,
            1
        ],
        [
            12736,
            12771,
            1
        ],
        [
            12783,
            12800,
            17
        ],
        [
            12801,
            12830,
            1
        ],
        [
            12842,
            12871,
            1
        ],
        [
            12880,
            12896,
            16
        ],
        [
            12897,
            12927,
            1
        ],
        [
            12938,
            12976,
            1
        ],
        [
            12992,
            13311,
            1
        ],
        [
            19904,
            19967,
            1
        ],
        [
            42128,
            42182,
            1
        ],
        [
            43048,
            43051,
            1
        ],
        [
            43062,
            43063,
            1
        ],
        [
            43065,
            43639,
            574
        ],
        [
            43640,
            43641,
            1
        ],
        [
            64832,
            64847,
            1
        ],
        [
            64975,
            65021,
            46
        ],
        [
            65022,
            65023,
            1
        ],
        [
            65508,
            65512,
            4
        ],
        [
            65517,
            65518,
            1
        ],
        [
            65532,
            65533,
            1
        ],
        [
            65847,
            65855,
            1
        ],
        [
            65913,
            65929,
            1
        ],
        [
            65932,
            65934,
            1
        ],
        [
            65936,
            65948,
            1
        ],
        [
            65952,
            66000,
            48
        ],
        [
            66001,
            66044,
            1
        ],
        [
            67703,
            67704,
            1
        ],
        [
            68296,
            71487,
            3191
        ],
        [
            73685,
            73692,
            1
        ],
        [
            73697,
            73713,
            1
        ],
        [
            92988,
            92991,
            1
        ],
        [
            92997,
            113820,
            20823
        ],
        [
            118608,
            118723,
            1
        ],
        [
            118784,
            119029,
            1
        ],
        [
            119040,
            119078,
            1
        ],
        [
            119081,
            119140,
            1
        ],
        [
            119146,
            119148,
            1
        ],
        [
            119171,
            119172,
            1
        ],
        [
            119180,
            119209,
            1
        ],
        [
            119214,
            119274,
            1
        ],
        [
            119296,
            119361,
            1
        ],
        [
            119365,
            119552,
            187
        ],
        [
            119553,
            119638,
            1
        ],
        [
            120832,
            121343,
            1
        ],
        [
            121399,
            121402,
            1
        ],
        [
            121453,
            121460,
            1
        ],
        [
            121462,
            121475,
            1
        ],
        [
            121477,
            121478,
            1
        ],
        [
            123215,
            126124,
            2909
        ],
        [
            126254,
            126976,
            722
        ],
        [
            126977,
            127019,
            1
        ],
        [
            127024,
            127123,
            1
        ],
        [
            127136,
            127150,
            1
        ],
        [
            127153,
            127167,
            1
        ],
        [
            127169,
            127183,
            1
        ],
        [
            127185,
            127221,
            1
        ],
        [
            127245,
            127405,
            1
        ],
        [
            127462,
            127490,
            1
        ],
        [
            127504,
            127547,
            1
        ],
        [
            127552,
            127560,
            1
        ],
        [
            127568,
            127569,
            1
        ],
        [
            127584,
            127589,
            1
        ],
        [
            127744,
            127994,
            1
        ],
        [
            128000,
            128727,
            1
        ],
        [
            128732,
            128748,
            1
        ],
        [
            128752,
            128764,
            1
        ],
        [
            128768,
            128886,
            1
        ],
        [
            128891,
            128985,
            1
        ],
        [
            128992,
            129003,
            1
        ],
        [
            129008,
            129024,
            16
        ],
        [
            129025,
            129035,
            1
        ],
        [
            129040,
            129095,
            1
        ],
        [
            129104,
            129113,
            1
        ],
        [
            129120,
            129159,
            1
        ],
        [
            129168,
            129197,
            1
        ],
        [
            129200,
            129201,
            1
        ],
        [
            129280,
            129619,
            1
        ],
        [
            129632,
            129645,
            1
        ],
        [
            129648,
            129660,
            1
        ],
        [
            129664,
            129672,
            1
        ],
        [
            129680,
            129725,
            1
        ],
        [
            129727,
            129733,
            1
        ],
        [
            129742,
            129755,
            1
        ],
        [
            129760,
            129768,
            1
        ],
        [
            129776,
            129784,
            1
        ],
        [
            129792,
            129938,
            1
        ],
        [
            129940,
            129994,
            1
        ]
    ];
    static Z = [
        [
            32,
            160,
            128
        ],
        [
            5760,
            8192,
            2432
        ],
        [
            8193,
            8202,
            1
        ],
        [
            8232,
            8233,
            1
        ],
        [
            8239,
            8287,
            48
        ],
        [
            12288,
            12288,
            1
        ]
    ];
    static Zl = [
        [
            8232,
            8232,
            1
        ]
    ];
    static Zp = [
        [
            8233,
            8233,
            1
        ]
    ];
    static Zs = [
        [
            32,
            160,
            128
        ],
        [
            5760,
            8192,
            2432
        ],
        [
            8193,
            8202,
            1
        ],
        [
            8239,
            8287,
            48
        ],
        [
            12288,
            12288,
            1
        ]
    ];
    static Adlam = [
        [
            125184,
            125259,
            1
        ],
        [
            125264,
            125273,
            1
        ],
        [
            125278,
            125279,
            1
        ]
    ];
    static Ahom = [
        [
            71424,
            71450,
            1
        ],
        [
            71453,
            71467,
            1
        ],
        [
            71472,
            71494,
            1
        ]
    ];
    static Anatolian_Hieroglyphs = [
        [
            82944,
            83526,
            1
        ]
    ];
    static Arabic = [
        [
            1536,
            1540,
            1
        ],
        [
            1542,
            1547,
            1
        ],
        [
            1549,
            1562,
            1
        ],
        [
            1564,
            1566,
            1
        ],
        [
            1568,
            1599,
            1
        ],
        [
            1601,
            1610,
            1
        ],
        [
            1622,
            1647,
            1
        ],
        [
            1649,
            1756,
            1
        ],
        [
            1758,
            1791,
            1
        ],
        [
            1872,
            1919,
            1
        ],
        [
            2160,
            2190,
            1
        ],
        [
            2192,
            2193,
            1
        ],
        [
            2200,
            2273,
            1
        ],
        [
            2275,
            2303,
            1
        ],
        [
            64336,
            64450,
            1
        ],
        [
            64467,
            64829,
            1
        ],
        [
            64832,
            64911,
            1
        ],
        [
            64914,
            64967,
            1
        ],
        [
            64975,
            65008,
            33
        ],
        [
            65009,
            65023,
            1
        ],
        [
            65136,
            65140,
            1
        ],
        [
            65142,
            65276,
            1
        ],
        [
            69216,
            69246,
            1
        ],
        [
            69373,
            69375,
            1
        ],
        [
            126464,
            126467,
            1
        ],
        [
            126469,
            126495,
            1
        ],
        [
            126497,
            126498,
            1
        ],
        [
            126500,
            126503,
            3
        ],
        [
            126505,
            126514,
            1
        ],
        [
            126516,
            126519,
            1
        ],
        [
            126521,
            126523,
            2
        ],
        [
            126530,
            126535,
            5
        ],
        [
            126537,
            126541,
            2
        ],
        [
            126542,
            126543,
            1
        ],
        [
            126545,
            126546,
            1
        ],
        [
            126548,
            126551,
            3
        ],
        [
            126553,
            126561,
            2
        ],
        [
            126562,
            126564,
            2
        ],
        [
            126567,
            126570,
            1
        ],
        [
            126572,
            126578,
            1
        ],
        [
            126580,
            126583,
            1
        ],
        [
            126585,
            126588,
            1
        ],
        [
            126590,
            126592,
            2
        ],
        [
            126593,
            126601,
            1
        ],
        [
            126603,
            126619,
            1
        ],
        [
            126625,
            126627,
            1
        ],
        [
            126629,
            126633,
            1
        ],
        [
            126635,
            126651,
            1
        ],
        [
            126704,
            126705,
            1
        ]
    ];
    static Armenian = [
        [
            1329,
            1366,
            1
        ],
        [
            1369,
            1418,
            1
        ],
        [
            1421,
            1423,
            1
        ],
        [
            64275,
            64279,
            1
        ]
    ];
    static Avestan = [
        [
            68352,
            68405,
            1
        ],
        [
            68409,
            68415,
            1
        ]
    ];
    static Balinese = [
        [
            6912,
            6988,
            1
        ],
        [
            6992,
            7038,
            1
        ]
    ];
    static Bamum = [
        [
            42656,
            42743,
            1
        ],
        [
            92160,
            92728,
            1
        ]
    ];
    static Bassa_Vah = [
        [
            92880,
            92909,
            1
        ],
        [
            92912,
            92917,
            1
        ]
    ];
    static Batak = [
        [
            7104,
            7155,
            1
        ],
        [
            7164,
            7167,
            1
        ]
    ];
    static Bengali = [
        [
            2432,
            2435,
            1
        ],
        [
            2437,
            2444,
            1
        ],
        [
            2447,
            2448,
            1
        ],
        [
            2451,
            2472,
            1
        ],
        [
            2474,
            2480,
            1
        ],
        [
            2482,
            2486,
            4
        ],
        [
            2487,
            2489,
            1
        ],
        [
            2492,
            2500,
            1
        ],
        [
            2503,
            2504,
            1
        ],
        [
            2507,
            2510,
            1
        ],
        [
            2519,
            2524,
            5
        ],
        [
            2525,
            2527,
            2
        ],
        [
            2528,
            2531,
            1
        ],
        [
            2534,
            2558,
            1
        ]
    ];
    static Bhaiksuki = [
        [
            72704,
            72712,
            1
        ],
        [
            72714,
            72758,
            1
        ],
        [
            72760,
            72773,
            1
        ],
        [
            72784,
            72812,
            1
        ]
    ];
    static Bopomofo = [
        [
            746,
            747,
            1
        ],
        [
            12549,
            12591,
            1
        ],
        [
            12704,
            12735,
            1
        ]
    ];
    static Brahmi = [
        [
            69632,
            69709,
            1
        ],
        [
            69714,
            69749,
            1
        ],
        [
            69759,
            69759,
            1
        ]
    ];
    static Braille = [
        [
            10240,
            10495,
            1
        ]
    ];
    static Buginese = [
        [
            6656,
            6683,
            1
        ],
        [
            6686,
            6687,
            1
        ]
    ];
    static Buhid = [
        [
            5952,
            5971,
            1
        ]
    ];
    static Canadian_Aboriginal = [
        [
            5120,
            5759,
            1
        ],
        [
            6320,
            6389,
            1
        ],
        [
            72368,
            72383,
            1
        ]
    ];
    static Carian = [
        [
            66208,
            66256,
            1
        ]
    ];
    static Caucasian_Albanian = [
        [
            66864,
            66915,
            1
        ],
        [
            66927,
            66927,
            1
        ]
    ];
    static Chakma = [
        [
            69888,
            69940,
            1
        ],
        [
            69942,
            69959,
            1
        ]
    ];
    static Cham = [
        [
            43520,
            43574,
            1
        ],
        [
            43584,
            43597,
            1
        ],
        [
            43600,
            43609,
            1
        ],
        [
            43612,
            43615,
            1
        ]
    ];
    static Cherokee = [
        [
            5024,
            5109,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            43888,
            43967,
            1
        ]
    ];
    static Chorasmian = [
        [
            69552,
            69579,
            1
        ]
    ];
    static Common = [
        [
            0,
            64,
            1
        ],
        [
            91,
            96,
            1
        ],
        [
            123,
            169,
            1
        ],
        [
            171,
            185,
            1
        ],
        [
            187,
            191,
            1
        ],
        [
            215,
            247,
            32
        ],
        [
            697,
            735,
            1
        ],
        [
            741,
            745,
            1
        ],
        [
            748,
            767,
            1
        ],
        [
            884,
            894,
            10
        ],
        [
            901,
            903,
            2
        ],
        [
            1541,
            1548,
            7
        ],
        [
            1563,
            1567,
            4
        ],
        [
            1600,
            1757,
            157
        ],
        [
            2274,
            2404,
            130
        ],
        [
            2405,
            3647,
            1242
        ],
        [
            4053,
            4056,
            1
        ],
        [
            4347,
            5867,
            1520
        ],
        [
            5868,
            5869,
            1
        ],
        [
            5941,
            5942,
            1
        ],
        [
            6146,
            6147,
            1
        ],
        [
            6149,
            7379,
            1230
        ],
        [
            7393,
            7401,
            8
        ],
        [
            7402,
            7404,
            1
        ],
        [
            7406,
            7411,
            1
        ],
        [
            7413,
            7415,
            1
        ],
        [
            7418,
            8192,
            774
        ],
        [
            8193,
            8203,
            1
        ],
        [
            8206,
            8292,
            1
        ],
        [
            8294,
            8304,
            1
        ],
        [
            8308,
            8318,
            1
        ],
        [
            8320,
            8334,
            1
        ],
        [
            8352,
            8384,
            1
        ],
        [
            8448,
            8485,
            1
        ],
        [
            8487,
            8489,
            1
        ],
        [
            8492,
            8497,
            1
        ],
        [
            8499,
            8525,
            1
        ],
        [
            8527,
            8543,
            1
        ],
        [
            8585,
            8587,
            1
        ],
        [
            8592,
            9254,
            1
        ],
        [
            9280,
            9290,
            1
        ],
        [
            9312,
            10239,
            1
        ],
        [
            10496,
            11123,
            1
        ],
        [
            11126,
            11157,
            1
        ],
        [
            11159,
            11263,
            1
        ],
        [
            11776,
            11869,
            1
        ],
        [
            12272,
            12292,
            1
        ],
        [
            12294,
            12296,
            2
        ],
        [
            12297,
            12320,
            1
        ],
        [
            12336,
            12343,
            1
        ],
        [
            12348,
            12351,
            1
        ],
        [
            12443,
            12444,
            1
        ],
        [
            12448,
            12539,
            91
        ],
        [
            12540,
            12688,
            148
        ],
        [
            12689,
            12703,
            1
        ],
        [
            12736,
            12771,
            1
        ],
        [
            12783,
            12832,
            49
        ],
        [
            12833,
            12895,
            1
        ],
        [
            12927,
            13007,
            1
        ],
        [
            13055,
            13144,
            89
        ],
        [
            13145,
            13311,
            1
        ],
        [
            19904,
            19967,
            1
        ],
        [
            42752,
            42785,
            1
        ],
        [
            42888,
            42890,
            1
        ],
        [
            43056,
            43065,
            1
        ],
        [
            43310,
            43471,
            161
        ],
        [
            43867,
            43882,
            15
        ],
        [
            43883,
            64830,
            20947
        ],
        [
            64831,
            65040,
            209
        ],
        [
            65041,
            65049,
            1
        ],
        [
            65072,
            65106,
            1
        ],
        [
            65108,
            65126,
            1
        ],
        [
            65128,
            65131,
            1
        ],
        [
            65279,
            65281,
            2
        ],
        [
            65282,
            65312,
            1
        ],
        [
            65339,
            65344,
            1
        ],
        [
            65371,
            65381,
            1
        ],
        [
            65392,
            65438,
            46
        ],
        [
            65439,
            65504,
            65
        ],
        [
            65505,
            65510,
            1
        ],
        [
            65512,
            65518,
            1
        ],
        [
            65529,
            65533,
            1
        ],
        [
            65792,
            65794,
            1
        ],
        [
            65799,
            65843,
            1
        ],
        [
            65847,
            65855,
            1
        ],
        [
            65936,
            65948,
            1
        ],
        [
            66000,
            66044,
            1
        ],
        [
            66273,
            66299,
            1
        ],
        [
            113824,
            113827,
            1
        ],
        [
            118608,
            118723,
            1
        ],
        [
            118784,
            119029,
            1
        ],
        [
            119040,
            119078,
            1
        ],
        [
            119081,
            119142,
            1
        ],
        [
            119146,
            119162,
            1
        ],
        [
            119171,
            119172,
            1
        ],
        [
            119180,
            119209,
            1
        ],
        [
            119214,
            119274,
            1
        ],
        [
            119488,
            119507,
            1
        ],
        [
            119520,
            119539,
            1
        ],
        [
            119552,
            119638,
            1
        ],
        [
            119648,
            119672,
            1
        ],
        [
            119808,
            119892,
            1
        ],
        [
            119894,
            119964,
            1
        ],
        [
            119966,
            119967,
            1
        ],
        [
            119970,
            119973,
            3
        ],
        [
            119974,
            119977,
            3
        ],
        [
            119978,
            119980,
            1
        ],
        [
            119982,
            119993,
            1
        ],
        [
            119995,
            119997,
            2
        ],
        [
            119998,
            120003,
            1
        ],
        [
            120005,
            120069,
            1
        ],
        [
            120071,
            120074,
            1
        ],
        [
            120077,
            120084,
            1
        ],
        [
            120086,
            120092,
            1
        ],
        [
            120094,
            120121,
            1
        ],
        [
            120123,
            120126,
            1
        ],
        [
            120128,
            120132,
            1
        ],
        [
            120134,
            120138,
            4
        ],
        [
            120139,
            120144,
            1
        ],
        [
            120146,
            120485,
            1
        ],
        [
            120488,
            120779,
            1
        ],
        [
            120782,
            120831,
            1
        ],
        [
            126065,
            126132,
            1
        ],
        [
            126209,
            126269,
            1
        ],
        [
            126976,
            127019,
            1
        ],
        [
            127024,
            127123,
            1
        ],
        [
            127136,
            127150,
            1
        ],
        [
            127153,
            127167,
            1
        ],
        [
            127169,
            127183,
            1
        ],
        [
            127185,
            127221,
            1
        ],
        [
            127232,
            127405,
            1
        ],
        [
            127462,
            127487,
            1
        ],
        [
            127489,
            127490,
            1
        ],
        [
            127504,
            127547,
            1
        ],
        [
            127552,
            127560,
            1
        ],
        [
            127568,
            127569,
            1
        ],
        [
            127584,
            127589,
            1
        ],
        [
            127744,
            128727,
            1
        ],
        [
            128732,
            128748,
            1
        ],
        [
            128752,
            128764,
            1
        ],
        [
            128768,
            128886,
            1
        ],
        [
            128891,
            128985,
            1
        ],
        [
            128992,
            129003,
            1
        ],
        [
            129008,
            129024,
            16
        ],
        [
            129025,
            129035,
            1
        ],
        [
            129040,
            129095,
            1
        ],
        [
            129104,
            129113,
            1
        ],
        [
            129120,
            129159,
            1
        ],
        [
            129168,
            129197,
            1
        ],
        [
            129200,
            129201,
            1
        ],
        [
            129280,
            129619,
            1
        ],
        [
            129632,
            129645,
            1
        ],
        [
            129648,
            129660,
            1
        ],
        [
            129664,
            129672,
            1
        ],
        [
            129680,
            129725,
            1
        ],
        [
            129727,
            129733,
            1
        ],
        [
            129742,
            129755,
            1
        ],
        [
            129760,
            129768,
            1
        ],
        [
            129776,
            129784,
            1
        ],
        [
            129792,
            129938,
            1
        ],
        [
            129940,
            129994,
            1
        ],
        [
            130032,
            130041,
            1
        ],
        [
            917505,
            917536,
            31
        ],
        [
            917537,
            917631,
            1
        ]
    ];
    static foldCommon = [
        [
            924,
            956,
            32
        ]
    ];
    static Coptic = [
        [
            994,
            1007,
            1
        ],
        [
            11392,
            11507,
            1
        ],
        [
            11513,
            11519,
            1
        ]
    ];
    static Cuneiform = [
        [
            73728,
            74649,
            1
        ],
        [
            74752,
            74862,
            1
        ],
        [
            74864,
            74868,
            1
        ],
        [
            74880,
            75075,
            1
        ]
    ];
    static Cypriot = [
        [
            67584,
            67589,
            1
        ],
        [
            67592,
            67594,
            2
        ],
        [
            67595,
            67637,
            1
        ],
        [
            67639,
            67640,
            1
        ],
        [
            67644,
            67647,
            3
        ]
    ];
    static Cypro_Minoan = [
        [
            77712,
            77810,
            1
        ]
    ];
    static Cyrillic = [
        [
            1024,
            1156,
            1
        ],
        [
            1159,
            1327,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7467,
            7544,
            77
        ],
        [
            11744,
            11775,
            1
        ],
        [
            42560,
            42655,
            1
        ],
        [
            65070,
            65071,
            1
        ],
        [
            122928,
            122989,
            1
        ],
        [
            123023,
            123023,
            1
        ]
    ];
    static Deseret = [
        [
            66560,
            66639,
            1
        ]
    ];
    static Devanagari = [
        [
            2304,
            2384,
            1
        ],
        [
            2389,
            2403,
            1
        ],
        [
            2406,
            2431,
            1
        ],
        [
            43232,
            43263,
            1
        ],
        [
            72448,
            72457,
            1
        ]
    ];
    static Dives_Akuru = [
        [
            71936,
            71942,
            1
        ],
        [
            71945,
            71948,
            3
        ],
        [
            71949,
            71955,
            1
        ],
        [
            71957,
            71958,
            1
        ],
        [
            71960,
            71989,
            1
        ],
        [
            71991,
            71992,
            1
        ],
        [
            71995,
            72006,
            1
        ],
        [
            72016,
            72025,
            1
        ]
    ];
    static Dogra = [
        [
            71680,
            71739,
            1
        ]
    ];
    static Duployan = [
        [
            113664,
            113770,
            1
        ],
        [
            113776,
            113788,
            1
        ],
        [
            113792,
            113800,
            1
        ],
        [
            113808,
            113817,
            1
        ],
        [
            113820,
            113823,
            1
        ]
    ];
    static Egyptian_Hieroglyphs = [
        [
            77824,
            78933,
            1
        ]
    ];
    static Elbasan = [
        [
            66816,
            66855,
            1
        ]
    ];
    static Elymaic = [
        [
            69600,
            69622,
            1
        ]
    ];
    static Ethiopic = [
        [
            4608,
            4680,
            1
        ],
        [
            4682,
            4685,
            1
        ],
        [
            4688,
            4694,
            1
        ],
        [
            4696,
            4698,
            2
        ],
        [
            4699,
            4701,
            1
        ],
        [
            4704,
            4744,
            1
        ],
        [
            4746,
            4749,
            1
        ],
        [
            4752,
            4784,
            1
        ],
        [
            4786,
            4789,
            1
        ],
        [
            4792,
            4798,
            1
        ],
        [
            4800,
            4802,
            2
        ],
        [
            4803,
            4805,
            1
        ],
        [
            4808,
            4822,
            1
        ],
        [
            4824,
            4880,
            1
        ],
        [
            4882,
            4885,
            1
        ],
        [
            4888,
            4954,
            1
        ],
        [
            4957,
            4988,
            1
        ],
        [
            4992,
            5017,
            1
        ],
        [
            11648,
            11670,
            1
        ],
        [
            11680,
            11686,
            1
        ],
        [
            11688,
            11694,
            1
        ],
        [
            11696,
            11702,
            1
        ],
        [
            11704,
            11710,
            1
        ],
        [
            11712,
            11718,
            1
        ],
        [
            11720,
            11726,
            1
        ],
        [
            11728,
            11734,
            1
        ],
        [
            11736,
            11742,
            1
        ],
        [
            43777,
            43782,
            1
        ],
        [
            43785,
            43790,
            1
        ],
        [
            43793,
            43798,
            1
        ],
        [
            43808,
            43814,
            1
        ],
        [
            43816,
            43822,
            1
        ],
        [
            124896,
            124902,
            1
        ],
        [
            124904,
            124907,
            1
        ],
        [
            124909,
            124910,
            1
        ],
        [
            124912,
            124926,
            1
        ]
    ];
    static Georgian = [
        [
            4256,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4348,
            4351,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            11520,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ]
    ];
    static Glagolitic = [
        [
            11264,
            11359,
            1
        ],
        [
            122880,
            122886,
            1
        ],
        [
            122888,
            122904,
            1
        ],
        [
            122907,
            122913,
            1
        ],
        [
            122915,
            122916,
            1
        ],
        [
            122918,
            122922,
            1
        ]
    ];
    static Gothic = [
        [
            66352,
            66378,
            1
        ]
    ];
    static Grantha = [
        [
            70400,
            70403,
            1
        ],
        [
            70405,
            70412,
            1
        ],
        [
            70415,
            70416,
            1
        ],
        [
            70419,
            70440,
            1
        ],
        [
            70442,
            70448,
            1
        ],
        [
            70450,
            70451,
            1
        ],
        [
            70453,
            70457,
            1
        ],
        [
            70460,
            70468,
            1
        ],
        [
            70471,
            70472,
            1
        ],
        [
            70475,
            70477,
            1
        ],
        [
            70480,
            70487,
            7
        ],
        [
            70493,
            70499,
            1
        ],
        [
            70502,
            70508,
            1
        ],
        [
            70512,
            70516,
            1
        ]
    ];
    static Greek = [
        [
            880,
            883,
            1
        ],
        [
            885,
            887,
            1
        ],
        [
            890,
            893,
            1
        ],
        [
            895,
            900,
            5
        ],
        [
            902,
            904,
            2
        ],
        [
            905,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            929,
            1
        ],
        [
            931,
            993,
            1
        ],
        [
            1008,
            1023,
            1
        ],
        [
            7462,
            7466,
            1
        ],
        [
            7517,
            7521,
            1
        ],
        [
            7526,
            7530,
            1
        ],
        [
            7615,
            7936,
            321
        ],
        [
            7937,
            7957,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7968,
            8005,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8016,
            8023,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8032,
            8061,
            1
        ],
        [
            8064,
            8116,
            1
        ],
        [
            8118,
            8132,
            1
        ],
        [
            8134,
            8147,
            1
        ],
        [
            8150,
            8155,
            1
        ],
        [
            8157,
            8175,
            1
        ],
        [
            8178,
            8180,
            1
        ],
        [
            8182,
            8190,
            1
        ],
        [
            8486,
            43877,
            35391
        ],
        [
            65856,
            65934,
            1
        ],
        [
            65952,
            119296,
            53344
        ],
        [
            119297,
            119365,
            1
        ]
    ];
    static foldGreek = [
        [
            181,
            837,
            656
        ]
    ];
    static Gujarati = [
        [
            2689,
            2691,
            1
        ],
        [
            2693,
            2701,
            1
        ],
        [
            2703,
            2705,
            1
        ],
        [
            2707,
            2728,
            1
        ],
        [
            2730,
            2736,
            1
        ],
        [
            2738,
            2739,
            1
        ],
        [
            2741,
            2745,
            1
        ],
        [
            2748,
            2757,
            1
        ],
        [
            2759,
            2761,
            1
        ],
        [
            2763,
            2765,
            1
        ],
        [
            2768,
            2784,
            16
        ],
        [
            2785,
            2787,
            1
        ],
        [
            2790,
            2801,
            1
        ],
        [
            2809,
            2815,
            1
        ]
    ];
    static Gunjala_Gondi = [
        [
            73056,
            73061,
            1
        ],
        [
            73063,
            73064,
            1
        ],
        [
            73066,
            73102,
            1
        ],
        [
            73104,
            73105,
            1
        ],
        [
            73107,
            73112,
            1
        ],
        [
            73120,
            73129,
            1
        ]
    ];
    static Gurmukhi = [
        [
            2561,
            2563,
            1
        ],
        [
            2565,
            2570,
            1
        ],
        [
            2575,
            2576,
            1
        ],
        [
            2579,
            2600,
            1
        ],
        [
            2602,
            2608,
            1
        ],
        [
            2610,
            2611,
            1
        ],
        [
            2613,
            2614,
            1
        ],
        [
            2616,
            2617,
            1
        ],
        [
            2620,
            2622,
            2
        ],
        [
            2623,
            2626,
            1
        ],
        [
            2631,
            2632,
            1
        ],
        [
            2635,
            2637,
            1
        ],
        [
            2641,
            2649,
            8
        ],
        [
            2650,
            2652,
            1
        ],
        [
            2654,
            2662,
            8
        ],
        [
            2663,
            2678,
            1
        ]
    ];
    static Han = [
        [
            11904,
            11929,
            1
        ],
        [
            11931,
            12019,
            1
        ],
        [
            12032,
            12245,
            1
        ],
        [
            12293,
            12295,
            2
        ],
        [
            12321,
            12329,
            1
        ],
        [
            12344,
            12347,
            1
        ],
        [
            13312,
            19903,
            1
        ],
        [
            19968,
            40959,
            1
        ],
        [
            63744,
            64109,
            1
        ],
        [
            64112,
            64217,
            1
        ],
        [
            94178,
            94179,
            1
        ],
        [
            94192,
            94193,
            1
        ],
        [
            131072,
            173791,
            1
        ],
        [
            173824,
            177977,
            1
        ],
        [
            177984,
            178205,
            1
        ],
        [
            178208,
            183969,
            1
        ],
        [
            183984,
            191456,
            1
        ],
        [
            191472,
            192093,
            1
        ],
        [
            194560,
            195101,
            1
        ],
        [
            196608,
            201546,
            1
        ],
        [
            201552,
            205743,
            1
        ]
    ];
    static Hangul = [
        [
            4352,
            4607,
            1
        ],
        [
            12334,
            12335,
            1
        ],
        [
            12593,
            12686,
            1
        ],
        [
            12800,
            12830,
            1
        ],
        [
            12896,
            12926,
            1
        ],
        [
            43360,
            43388,
            1
        ],
        [
            44032,
            55203,
            1
        ],
        [
            55216,
            55238,
            1
        ],
        [
            55243,
            55291,
            1
        ],
        [
            65440,
            65470,
            1
        ],
        [
            65474,
            65479,
            1
        ],
        [
            65482,
            65487,
            1
        ],
        [
            65490,
            65495,
            1
        ],
        [
            65498,
            65500,
            1
        ]
    ];
    static Hanifi_Rohingya = [
        [
            68864,
            68903,
            1
        ],
        [
            68912,
            68921,
            1
        ]
    ];
    static Hanunoo = [
        [
            5920,
            5940,
            1
        ]
    ];
    static Hatran = [
        [
            67808,
            67826,
            1
        ],
        [
            67828,
            67829,
            1
        ],
        [
            67835,
            67839,
            1
        ]
    ];
    static Hebrew = [
        [
            1425,
            1479,
            1
        ],
        [
            1488,
            1514,
            1
        ],
        [
            1519,
            1524,
            1
        ],
        [
            64285,
            64310,
            1
        ],
        [
            64312,
            64316,
            1
        ],
        [
            64318,
            64320,
            2
        ],
        [
            64321,
            64323,
            2
        ],
        [
            64324,
            64326,
            2
        ],
        [
            64327,
            64335,
            1
        ]
    ];
    static Hiragana = [
        [
            12353,
            12438,
            1
        ],
        [
            12445,
            12447,
            1
        ],
        [
            110593,
            110879,
            1
        ],
        [
            110898,
            110928,
            30
        ],
        [
            110929,
            110930,
            1
        ],
        [
            127488,
            127488,
            1
        ]
    ];
    static Imperial_Aramaic = [
        [
            67648,
            67669,
            1
        ],
        [
            67671,
            67679,
            1
        ]
    ];
    static Inherited = [
        [
            768,
            879,
            1
        ],
        [
            1157,
            1158,
            1
        ],
        [
            1611,
            1621,
            1
        ],
        [
            1648,
            2385,
            737
        ],
        [
            2386,
            2388,
            1
        ],
        [
            6832,
            6862,
            1
        ],
        [
            7376,
            7378,
            1
        ],
        [
            7380,
            7392,
            1
        ],
        [
            7394,
            7400,
            1
        ],
        [
            7405,
            7412,
            7
        ],
        [
            7416,
            7417,
            1
        ],
        [
            7616,
            7679,
            1
        ],
        [
            8204,
            8205,
            1
        ],
        [
            8400,
            8432,
            1
        ],
        [
            12330,
            12333,
            1
        ],
        [
            12441,
            12442,
            1
        ],
        [
            65024,
            65039,
            1
        ],
        [
            65056,
            65069,
            1
        ],
        [
            66045,
            66272,
            227
        ],
        [
            70459,
            118528,
            48069
        ],
        [
            118529,
            118573,
            1
        ],
        [
            118576,
            118598,
            1
        ],
        [
            119143,
            119145,
            1
        ],
        [
            119163,
            119170,
            1
        ],
        [
            119173,
            119179,
            1
        ],
        [
            119210,
            119213,
            1
        ],
        [
            917760,
            917999,
            1
        ]
    ];
    static foldInherited = [
        [
            921,
            953,
            32
        ],
        [
            8126,
            8126,
            1
        ]
    ];
    static Inscriptional_Pahlavi = [
        [
            68448,
            68466,
            1
        ],
        [
            68472,
            68479,
            1
        ]
    ];
    static Inscriptional_Parthian = [
        [
            68416,
            68437,
            1
        ],
        [
            68440,
            68447,
            1
        ]
    ];
    static Javanese = [
        [
            43392,
            43469,
            1
        ],
        [
            43472,
            43481,
            1
        ],
        [
            43486,
            43487,
            1
        ]
    ];
    static Kaithi = [
        [
            69760,
            69826,
            1
        ],
        [
            69837,
            69837,
            1
        ]
    ];
    static Kannada = [
        [
            3200,
            3212,
            1
        ],
        [
            3214,
            3216,
            1
        ],
        [
            3218,
            3240,
            1
        ],
        [
            3242,
            3251,
            1
        ],
        [
            3253,
            3257,
            1
        ],
        [
            3260,
            3268,
            1
        ],
        [
            3270,
            3272,
            1
        ],
        [
            3274,
            3277,
            1
        ],
        [
            3285,
            3286,
            1
        ],
        [
            3293,
            3294,
            1
        ],
        [
            3296,
            3299,
            1
        ],
        [
            3302,
            3311,
            1
        ],
        [
            3313,
            3315,
            1
        ]
    ];
    static Katakana = [
        [
            12449,
            12538,
            1
        ],
        [
            12541,
            12543,
            1
        ],
        [
            12784,
            12799,
            1
        ],
        [
            13008,
            13054,
            1
        ],
        [
            13056,
            13143,
            1
        ],
        [
            65382,
            65391,
            1
        ],
        [
            65393,
            65437,
            1
        ],
        [
            110576,
            110579,
            1
        ],
        [
            110581,
            110587,
            1
        ],
        [
            110589,
            110590,
            1
        ],
        [
            110592,
            110880,
            288
        ],
        [
            110881,
            110882,
            1
        ],
        [
            110933,
            110948,
            15
        ],
        [
            110949,
            110951,
            1
        ]
    ];
    static Kawi = [
        [
            73472,
            73488,
            1
        ],
        [
            73490,
            73530,
            1
        ],
        [
            73534,
            73561,
            1
        ]
    ];
    static Kayah_Li = [
        [
            43264,
            43309,
            1
        ],
        [
            43311,
            43311,
            1
        ]
    ];
    static Kharoshthi = [
        [
            68096,
            68099,
            1
        ],
        [
            68101,
            68102,
            1
        ],
        [
            68108,
            68115,
            1
        ],
        [
            68117,
            68119,
            1
        ],
        [
            68121,
            68149,
            1
        ],
        [
            68152,
            68154,
            1
        ],
        [
            68159,
            68168,
            1
        ],
        [
            68176,
            68184,
            1
        ]
    ];
    static Khitan_Small_Script = [
        [
            94180,
            101120,
            6940
        ],
        [
            101121,
            101589,
            1
        ]
    ];
    static Khmer = [
        [
            6016,
            6109,
            1
        ],
        [
            6112,
            6121,
            1
        ],
        [
            6128,
            6137,
            1
        ],
        [
            6624,
            6655,
            1
        ]
    ];
    static Khojki = [
        [
            70144,
            70161,
            1
        ],
        [
            70163,
            70209,
            1
        ]
    ];
    static Khudawadi = [
        [
            70320,
            70378,
            1
        ],
        [
            70384,
            70393,
            1
        ]
    ];
    static Lao = [
        [
            3713,
            3714,
            1
        ],
        [
            3716,
            3718,
            2
        ],
        [
            3719,
            3722,
            1
        ],
        [
            3724,
            3747,
            1
        ],
        [
            3749,
            3751,
            2
        ],
        [
            3752,
            3773,
            1
        ],
        [
            3776,
            3780,
            1
        ],
        [
            3782,
            3784,
            2
        ],
        [
            3785,
            3790,
            1
        ],
        [
            3792,
            3801,
            1
        ],
        [
            3804,
            3807,
            1
        ]
    ];
    static Latin = [
        [
            65,
            90,
            1
        ],
        [
            97,
            122,
            1
        ],
        [
            170,
            186,
            16
        ],
        [
            192,
            214,
            1
        ],
        [
            216,
            246,
            1
        ],
        [
            248,
            696,
            1
        ],
        [
            736,
            740,
            1
        ],
        [
            7424,
            7461,
            1
        ],
        [
            7468,
            7516,
            1
        ],
        [
            7522,
            7525,
            1
        ],
        [
            7531,
            7543,
            1
        ],
        [
            7545,
            7614,
            1
        ],
        [
            7680,
            7935,
            1
        ],
        [
            8305,
            8319,
            14
        ],
        [
            8336,
            8348,
            1
        ],
        [
            8490,
            8491,
            1
        ],
        [
            8498,
            8526,
            28
        ],
        [
            8544,
            8584,
            1
        ],
        [
            11360,
            11391,
            1
        ],
        [
            42786,
            42887,
            1
        ],
        [
            42891,
            42954,
            1
        ],
        [
            42960,
            42961,
            1
        ],
        [
            42963,
            42965,
            2
        ],
        [
            42966,
            42969,
            1
        ],
        [
            42994,
            43007,
            1
        ],
        [
            43824,
            43866,
            1
        ],
        [
            43868,
            43876,
            1
        ],
        [
            43878,
            43881,
            1
        ],
        [
            64256,
            64262,
            1
        ],
        [
            65313,
            65338,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            67456,
            67461,
            1
        ],
        [
            67463,
            67504,
            1
        ],
        [
            67506,
            67514,
            1
        ],
        [
            122624,
            122654,
            1
        ],
        [
            122661,
            122666,
            1
        ]
    ];
    static Lepcha = [
        [
            7168,
            7223,
            1
        ],
        [
            7227,
            7241,
            1
        ],
        [
            7245,
            7247,
            1
        ]
    ];
    static Limbu = [
        [
            6400,
            6430,
            1
        ],
        [
            6432,
            6443,
            1
        ],
        [
            6448,
            6459,
            1
        ],
        [
            6464,
            6468,
            4
        ],
        [
            6469,
            6479,
            1
        ]
    ];
    static Linear_A = [
        [
            67072,
            67382,
            1
        ],
        [
            67392,
            67413,
            1
        ],
        [
            67424,
            67431,
            1
        ]
    ];
    static Linear_B = [
        [
            65536,
            65547,
            1
        ],
        [
            65549,
            65574,
            1
        ],
        [
            65576,
            65594,
            1
        ],
        [
            65596,
            65597,
            1
        ],
        [
            65599,
            65613,
            1
        ],
        [
            65616,
            65629,
            1
        ],
        [
            65664,
            65786,
            1
        ]
    ];
    static Lisu = [
        [
            42192,
            42239,
            1
        ],
        [
            73648,
            73648,
            1
        ]
    ];
    static Lycian = [
        [
            66176,
            66204,
            1
        ]
    ];
    static Lydian = [
        [
            67872,
            67897,
            1
        ],
        [
            67903,
            67903,
            1
        ]
    ];
    static Mahajani = [
        [
            69968,
            70006,
            1
        ]
    ];
    static Makasar = [
        [
            73440,
            73464,
            1
        ]
    ];
    static Malayalam = [
        [
            3328,
            3340,
            1
        ],
        [
            3342,
            3344,
            1
        ],
        [
            3346,
            3396,
            1
        ],
        [
            3398,
            3400,
            1
        ],
        [
            3402,
            3407,
            1
        ],
        [
            3412,
            3427,
            1
        ],
        [
            3430,
            3455,
            1
        ]
    ];
    static Mandaic = [
        [
            2112,
            2139,
            1
        ],
        [
            2142,
            2142,
            1
        ]
    ];
    static Manichaean = [
        [
            68288,
            68326,
            1
        ],
        [
            68331,
            68342,
            1
        ]
    ];
    static Marchen = [
        [
            72816,
            72847,
            1
        ],
        [
            72850,
            72871,
            1
        ],
        [
            72873,
            72886,
            1
        ]
    ];
    static Masaram_Gondi = [
        [
            72960,
            72966,
            1
        ],
        [
            72968,
            72969,
            1
        ],
        [
            72971,
            73014,
            1
        ],
        [
            73018,
            73020,
            2
        ],
        [
            73021,
            73023,
            2
        ],
        [
            73024,
            73031,
            1
        ],
        [
            73040,
            73049,
            1
        ]
    ];
    static Medefaidrin = [
        [
            93760,
            93850,
            1
        ]
    ];
    static Meetei_Mayek = [
        [
            43744,
            43766,
            1
        ],
        [
            43968,
            44013,
            1
        ],
        [
            44016,
            44025,
            1
        ]
    ];
    static Mende_Kikakui = [
        [
            124928,
            125124,
            1
        ],
        [
            125127,
            125142,
            1
        ]
    ];
    static Meroitic_Cursive = [
        [
            68000,
            68023,
            1
        ],
        [
            68028,
            68047,
            1
        ],
        [
            68050,
            68095,
            1
        ]
    ];
    static Meroitic_Hieroglyphs = [
        [
            67968,
            67999,
            1
        ]
    ];
    static Miao = [
        [
            93952,
            94026,
            1
        ],
        [
            94031,
            94087,
            1
        ],
        [
            94095,
            94111,
            1
        ]
    ];
    static Modi = [
        [
            71168,
            71236,
            1
        ],
        [
            71248,
            71257,
            1
        ]
    ];
    static Mongolian = [
        [
            6144,
            6145,
            1
        ],
        [
            6148,
            6150,
            2
        ],
        [
            6151,
            6169,
            1
        ],
        [
            6176,
            6264,
            1
        ],
        [
            6272,
            6314,
            1
        ],
        [
            71264,
            71276,
            1
        ]
    ];
    static Mro = [
        [
            92736,
            92766,
            1
        ],
        [
            92768,
            92777,
            1
        ],
        [
            92782,
            92783,
            1
        ]
    ];
    static Multani = [
        [
            70272,
            70278,
            1
        ],
        [
            70280,
            70282,
            2
        ],
        [
            70283,
            70285,
            1
        ],
        [
            70287,
            70301,
            1
        ],
        [
            70303,
            70313,
            1
        ]
    ];
    static Myanmar = [
        [
            4096,
            4255,
            1
        ],
        [
            43488,
            43518,
            1
        ],
        [
            43616,
            43647,
            1
        ]
    ];
    static Nabataean = [
        [
            67712,
            67742,
            1
        ],
        [
            67751,
            67759,
            1
        ]
    ];
    static Nag_Mundari = [
        [
            124112,
            124153,
            1
        ]
    ];
    static Nandinagari = [
        [
            72096,
            72103,
            1
        ],
        [
            72106,
            72151,
            1
        ],
        [
            72154,
            72164,
            1
        ]
    ];
    static New_Tai_Lue = [
        [
            6528,
            6571,
            1
        ],
        [
            6576,
            6601,
            1
        ],
        [
            6608,
            6618,
            1
        ],
        [
            6622,
            6623,
            1
        ]
    ];
    static Newa = [
        [
            70656,
            70747,
            1
        ],
        [
            70749,
            70753,
            1
        ]
    ];
    static Nko = [
        [
            1984,
            2042,
            1
        ],
        [
            2045,
            2047,
            1
        ]
    ];
    static Nushu = [
        [
            94177,
            110960,
            16783
        ],
        [
            110961,
            111355,
            1
        ]
    ];
    static Nyiakeng_Puachue_Hmong = [
        [
            123136,
            123180,
            1
        ],
        [
            123184,
            123197,
            1
        ],
        [
            123200,
            123209,
            1
        ],
        [
            123214,
            123215,
            1
        ]
    ];
    static Ogham = [
        [
            5760,
            5788,
            1
        ]
    ];
    static Ol_Chiki = [
        [
            7248,
            7295,
            1
        ]
    ];
    static Old_Hungarian = [
        [
            68736,
            68786,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            68858,
            68863,
            1
        ]
    ];
    static Old_Italic = [
        [
            66304,
            66339,
            1
        ],
        [
            66349,
            66351,
            1
        ]
    ];
    static Old_North_Arabian = [
        [
            68224,
            68255,
            1
        ]
    ];
    static Old_Permic = [
        [
            66384,
            66426,
            1
        ]
    ];
    static Old_Persian = [
        [
            66464,
            66499,
            1
        ],
        [
            66504,
            66517,
            1
        ]
    ];
    static Old_Sogdian = [
        [
            69376,
            69415,
            1
        ]
    ];
    static Old_South_Arabian = [
        [
            68192,
            68223,
            1
        ]
    ];
    static Old_Turkic = [
        [
            68608,
            68680,
            1
        ]
    ];
    static Old_Uyghur = [
        [
            69488,
            69513,
            1
        ]
    ];
    static Oriya = [
        [
            2817,
            2819,
            1
        ],
        [
            2821,
            2828,
            1
        ],
        [
            2831,
            2832,
            1
        ],
        [
            2835,
            2856,
            1
        ],
        [
            2858,
            2864,
            1
        ],
        [
            2866,
            2867,
            1
        ],
        [
            2869,
            2873,
            1
        ],
        [
            2876,
            2884,
            1
        ],
        [
            2887,
            2888,
            1
        ],
        [
            2891,
            2893,
            1
        ],
        [
            2901,
            2903,
            1
        ],
        [
            2908,
            2909,
            1
        ],
        [
            2911,
            2915,
            1
        ],
        [
            2918,
            2935,
            1
        ]
    ];
    static Osage = [
        [
            66736,
            66771,
            1
        ],
        [
            66776,
            66811,
            1
        ]
    ];
    static Osmanya = [
        [
            66688,
            66717,
            1
        ],
        [
            66720,
            66729,
            1
        ]
    ];
    static Pahawh_Hmong = [
        [
            92928,
            92997,
            1
        ],
        [
            93008,
            93017,
            1
        ],
        [
            93019,
            93025,
            1
        ],
        [
            93027,
            93047,
            1
        ],
        [
            93053,
            93071,
            1
        ]
    ];
    static Palmyrene = [
        [
            67680,
            67711,
            1
        ]
    ];
    static Pau_Cin_Hau = [
        [
            72384,
            72440,
            1
        ]
    ];
    static Phags_Pa = [
        [
            43072,
            43127,
            1
        ]
    ];
    static Phoenician = [
        [
            67840,
            67867,
            1
        ],
        [
            67871,
            67871,
            1
        ]
    ];
    static Psalter_Pahlavi = [
        [
            68480,
            68497,
            1
        ],
        [
            68505,
            68508,
            1
        ],
        [
            68521,
            68527,
            1
        ]
    ];
    static Rejang = [
        [
            43312,
            43347,
            1
        ],
        [
            43359,
            43359,
            1
        ]
    ];
    static Runic = [
        [
            5792,
            5866,
            1
        ],
        [
            5870,
            5880,
            1
        ]
    ];
    static Samaritan = [
        [
            2048,
            2093,
            1
        ],
        [
            2096,
            2110,
            1
        ]
    ];
    static Saurashtra = [
        [
            43136,
            43205,
            1
        ],
        [
            43214,
            43225,
            1
        ]
    ];
    static Sharada = [
        [
            70016,
            70111,
            1
        ]
    ];
    static Shavian = [
        [
            66640,
            66687,
            1
        ]
    ];
    static Siddham = [
        [
            71040,
            71093,
            1
        ],
        [
            71096,
            71133,
            1
        ]
    ];
    static SignWriting = [
        [
            120832,
            121483,
            1
        ],
        [
            121499,
            121503,
            1
        ],
        [
            121505,
            121519,
            1
        ]
    ];
    static Sinhala = [
        [
            3457,
            3459,
            1
        ],
        [
            3461,
            3478,
            1
        ],
        [
            3482,
            3505,
            1
        ],
        [
            3507,
            3515,
            1
        ],
        [
            3517,
            3520,
            3
        ],
        [
            3521,
            3526,
            1
        ],
        [
            3530,
            3535,
            5
        ],
        [
            3536,
            3540,
            1
        ],
        [
            3542,
            3544,
            2
        ],
        [
            3545,
            3551,
            1
        ],
        [
            3558,
            3567,
            1
        ],
        [
            3570,
            3572,
            1
        ],
        [
            70113,
            70132,
            1
        ]
    ];
    static Sogdian = [
        [
            69424,
            69465,
            1
        ]
    ];
    static Sora_Sompeng = [
        [
            69840,
            69864,
            1
        ],
        [
            69872,
            69881,
            1
        ]
    ];
    static Soyombo = [
        [
            72272,
            72354,
            1
        ]
    ];
    static Sundanese = [
        [
            7040,
            7103,
            1
        ],
        [
            7360,
            7367,
            1
        ]
    ];
    static Syloti_Nagri = [
        [
            43008,
            43052,
            1
        ]
    ];
    static Syriac = [
        [
            1792,
            1805,
            1
        ],
        [
            1807,
            1866,
            1
        ],
        [
            1869,
            1871,
            1
        ],
        [
            2144,
            2154,
            1
        ]
    ];
    static Tagalog = [
        [
            5888,
            5909,
            1
        ],
        [
            5919,
            5919,
            1
        ]
    ];
    static Tagbanwa = [
        [
            5984,
            5996,
            1
        ],
        [
            5998,
            6000,
            1
        ],
        [
            6002,
            6003,
            1
        ]
    ];
    static Tai_Le = [
        [
            6480,
            6509,
            1
        ],
        [
            6512,
            6516,
            1
        ]
    ];
    static Tai_Tham = [
        [
            6688,
            6750,
            1
        ],
        [
            6752,
            6780,
            1
        ],
        [
            6783,
            6793,
            1
        ],
        [
            6800,
            6809,
            1
        ],
        [
            6816,
            6829,
            1
        ]
    ];
    static Tai_Viet = [
        [
            43648,
            43714,
            1
        ],
        [
            43739,
            43743,
            1
        ]
    ];
    static Takri = [
        [
            71296,
            71353,
            1
        ],
        [
            71360,
            71369,
            1
        ]
    ];
    static Tamil = [
        [
            2946,
            2947,
            1
        ],
        [
            2949,
            2954,
            1
        ],
        [
            2958,
            2960,
            1
        ],
        [
            2962,
            2965,
            1
        ],
        [
            2969,
            2970,
            1
        ],
        [
            2972,
            2974,
            2
        ],
        [
            2975,
            2979,
            4
        ],
        [
            2980,
            2984,
            4
        ],
        [
            2985,
            2986,
            1
        ],
        [
            2990,
            3001,
            1
        ],
        [
            3006,
            3010,
            1
        ],
        [
            3014,
            3016,
            1
        ],
        [
            3018,
            3021,
            1
        ],
        [
            3024,
            3031,
            7
        ],
        [
            3046,
            3066,
            1
        ],
        [
            73664,
            73713,
            1
        ],
        [
            73727,
            73727,
            1
        ]
    ];
    static Tangsa = [
        [
            92784,
            92862,
            1
        ],
        [
            92864,
            92873,
            1
        ]
    ];
    static Tangut = [
        [
            94176,
            94208,
            32
        ],
        [
            94209,
            100343,
            1
        ],
        [
            100352,
            101119,
            1
        ],
        [
            101632,
            101640,
            1
        ]
    ];
    static Telugu = [
        [
            3072,
            3084,
            1
        ],
        [
            3086,
            3088,
            1
        ],
        [
            3090,
            3112,
            1
        ],
        [
            3114,
            3129,
            1
        ],
        [
            3132,
            3140,
            1
        ],
        [
            3142,
            3144,
            1
        ],
        [
            3146,
            3149,
            1
        ],
        [
            3157,
            3158,
            1
        ],
        [
            3160,
            3162,
            1
        ],
        [
            3165,
            3168,
            3
        ],
        [
            3169,
            3171,
            1
        ],
        [
            3174,
            3183,
            1
        ],
        [
            3191,
            3199,
            1
        ]
    ];
    static Thaana = [
        [
            1920,
            1969,
            1
        ]
    ];
    static Thai = [
        [
            3585,
            3642,
            1
        ],
        [
            3648,
            3675,
            1
        ]
    ];
    static Tibetan = [
        [
            3840,
            3911,
            1
        ],
        [
            3913,
            3948,
            1
        ],
        [
            3953,
            3991,
            1
        ],
        [
            3993,
            4028,
            1
        ],
        [
            4030,
            4044,
            1
        ],
        [
            4046,
            4052,
            1
        ],
        [
            4057,
            4058,
            1
        ]
    ];
    static Tifinagh = [
        [
            11568,
            11623,
            1
        ],
        [
            11631,
            11632,
            1
        ],
        [
            11647,
            11647,
            1
        ]
    ];
    static Tirhuta = [
        [
            70784,
            70855,
            1
        ],
        [
            70864,
            70873,
            1
        ]
    ];
    static Toto = [
        [
            123536,
            123566,
            1
        ]
    ];
    static Ugaritic = [
        [
            66432,
            66461,
            1
        ],
        [
            66463,
            66463,
            1
        ]
    ];
    static Vai = [
        [
            42240,
            42539,
            1
        ]
    ];
    static Vithkuqi = [
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ]
    ];
    static Wancho = [
        [
            123584,
            123641,
            1
        ],
        [
            123647,
            123647,
            1
        ]
    ];
    static Warang_Citi = [
        [
            71840,
            71922,
            1
        ],
        [
            71935,
            71935,
            1
        ]
    ];
    static Yezidi = [
        [
            69248,
            69289,
            1
        ],
        [
            69291,
            69293,
            1
        ],
        [
            69296,
            69297,
            1
        ]
    ];
    static Yi = [
        [
            40960,
            42124,
            1
        ],
        [
            42128,
            42182,
            1
        ]
    ];
    static Zanabazar_Square = [
        [
            72192,
            72263,
            1
        ]
    ];
    static CATEGORIES = (()=>new Map([
            [
                'C',
                $4f6bfbff25a5c30c$var$UnicodeTables.C
            ],
            [
                'Cc',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cc
            ],
            [
                'Cf',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cf
            ],
            [
                'Co',
                $4f6bfbff25a5c30c$var$UnicodeTables.Co
            ],
            [
                'Cs',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cs
            ],
            [
                'L',
                $4f6bfbff25a5c30c$var$UnicodeTables.L
            ],
            [
                'Ll',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ll
            ],
            [
                'Lm',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lm
            ],
            [
                'Lo',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lo
            ],
            [
                'Lt',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lt
            ],
            [
                'Lu',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lu
            ],
            [
                'M',
                $4f6bfbff25a5c30c$var$UnicodeTables.M
            ],
            [
                'Mc',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mc
            ],
            [
                'Me',
                $4f6bfbff25a5c30c$var$UnicodeTables.Me
            ],
            [
                'Mn',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mn
            ],
            [
                'N',
                $4f6bfbff25a5c30c$var$UnicodeTables.N
            ],
            [
                'Nd',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nd
            ],
            [
                'Nl',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nl
            ],
            [
                'No',
                $4f6bfbff25a5c30c$var$UnicodeTables.No
            ],
            [
                'P',
                $4f6bfbff25a5c30c$var$UnicodeTables.P
            ],
            [
                'Pc',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pc
            ],
            [
                'Pd',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pd
            ],
            [
                'Pe',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pe
            ],
            [
                'Pf',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pf
            ],
            [
                'Pi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pi
            ],
            [
                'Po',
                $4f6bfbff25a5c30c$var$UnicodeTables.Po
            ],
            [
                'Ps',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ps
            ],
            [
                'S',
                $4f6bfbff25a5c30c$var$UnicodeTables.S
            ],
            [
                'Sc',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sc
            ],
            [
                'Sk',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sk
            ],
            [
                'Sm',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sm
            ],
            [
                'So',
                $4f6bfbff25a5c30c$var$UnicodeTables.So
            ],
            [
                'Z',
                $4f6bfbff25a5c30c$var$UnicodeTables.Z
            ],
            [
                'Zl',
                $4f6bfbff25a5c30c$var$UnicodeTables.Zl
            ],
            [
                'Zp',
                $4f6bfbff25a5c30c$var$UnicodeTables.Zp
            ],
            [
                'Zs',
                $4f6bfbff25a5c30c$var$UnicodeTables.Zs
            ]
        ]))();
    static SCRIPTS = (()=>new Map([
            [
                'Adlam',
                $4f6bfbff25a5c30c$var$UnicodeTables.Adlam
            ],
            [
                'Ahom',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ahom
            ],
            [
                'Anatolian_Hieroglyphs',
                $4f6bfbff25a5c30c$var$UnicodeTables.Anatolian_Hieroglyphs
            ],
            [
                'Arabic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Arabic
            ],
            [
                'Armenian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Armenian
            ],
            [
                'Avestan',
                $4f6bfbff25a5c30c$var$UnicodeTables.Avestan
            ],
            [
                'Balinese',
                $4f6bfbff25a5c30c$var$UnicodeTables.Balinese
            ],
            [
                'Bamum',
                $4f6bfbff25a5c30c$var$UnicodeTables.Bamum
            ],
            [
                'Bassa_Vah',
                $4f6bfbff25a5c30c$var$UnicodeTables.Bassa_Vah
            ],
            [
                'Batak',
                $4f6bfbff25a5c30c$var$UnicodeTables.Batak
            ],
            [
                'Bengali',
                $4f6bfbff25a5c30c$var$UnicodeTables.Bengali
            ],
            [
                'Bhaiksuki',
                $4f6bfbff25a5c30c$var$UnicodeTables.Bhaiksuki
            ],
            [
                'Bopomofo',
                $4f6bfbff25a5c30c$var$UnicodeTables.Bopomofo
            ],
            [
                'Brahmi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Brahmi
            ],
            [
                'Braille',
                $4f6bfbff25a5c30c$var$UnicodeTables.Braille
            ],
            [
                'Buginese',
                $4f6bfbff25a5c30c$var$UnicodeTables.Buginese
            ],
            [
                'Buhid',
                $4f6bfbff25a5c30c$var$UnicodeTables.Buhid
            ],
            [
                'Canadian_Aboriginal',
                $4f6bfbff25a5c30c$var$UnicodeTables.Canadian_Aboriginal
            ],
            [
                'Carian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Carian
            ],
            [
                'Caucasian_Albanian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Caucasian_Albanian
            ],
            [
                'Chakma',
                $4f6bfbff25a5c30c$var$UnicodeTables.Chakma
            ],
            [
                'Cham',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cham
            ],
            [
                'Cherokee',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cherokee
            ],
            [
                'Chorasmian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Chorasmian
            ],
            [
                'Common',
                $4f6bfbff25a5c30c$var$UnicodeTables.Common
            ],
            [
                'Coptic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Coptic
            ],
            [
                'Cuneiform',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cuneiform
            ],
            [
                'Cypriot',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cypriot
            ],
            [
                'Cypro_Minoan',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cypro_Minoan
            ],
            [
                'Cyrillic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Cyrillic
            ],
            [
                'Deseret',
                $4f6bfbff25a5c30c$var$UnicodeTables.Deseret
            ],
            [
                'Devanagari',
                $4f6bfbff25a5c30c$var$UnicodeTables.Devanagari
            ],
            [
                'Dives_Akuru',
                $4f6bfbff25a5c30c$var$UnicodeTables.Dives_Akuru
            ],
            [
                'Dogra',
                $4f6bfbff25a5c30c$var$UnicodeTables.Dogra
            ],
            [
                'Duployan',
                $4f6bfbff25a5c30c$var$UnicodeTables.Duployan
            ],
            [
                'Egyptian_Hieroglyphs',
                $4f6bfbff25a5c30c$var$UnicodeTables.Egyptian_Hieroglyphs
            ],
            [
                'Elbasan',
                $4f6bfbff25a5c30c$var$UnicodeTables.Elbasan
            ],
            [
                'Elymaic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Elymaic
            ],
            [
                'Ethiopic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ethiopic
            ],
            [
                'Georgian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Georgian
            ],
            [
                'Glagolitic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Glagolitic
            ],
            [
                'Gothic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Gothic
            ],
            [
                'Grantha',
                $4f6bfbff25a5c30c$var$UnicodeTables.Grantha
            ],
            [
                'Greek',
                $4f6bfbff25a5c30c$var$UnicodeTables.Greek
            ],
            [
                'Gujarati',
                $4f6bfbff25a5c30c$var$UnicodeTables.Gujarati
            ],
            [
                'Gunjala_Gondi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Gunjala_Gondi
            ],
            [
                'Gurmukhi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Gurmukhi
            ],
            [
                'Han',
                $4f6bfbff25a5c30c$var$UnicodeTables.Han
            ],
            [
                'Hangul',
                $4f6bfbff25a5c30c$var$UnicodeTables.Hangul
            ],
            [
                'Hanifi_Rohingya',
                $4f6bfbff25a5c30c$var$UnicodeTables.Hanifi_Rohingya
            ],
            [
                'Hanunoo',
                $4f6bfbff25a5c30c$var$UnicodeTables.Hanunoo
            ],
            [
                'Hatran',
                $4f6bfbff25a5c30c$var$UnicodeTables.Hatran
            ],
            [
                'Hebrew',
                $4f6bfbff25a5c30c$var$UnicodeTables.Hebrew
            ],
            [
                'Hiragana',
                $4f6bfbff25a5c30c$var$UnicodeTables.Hiragana
            ],
            [
                'Imperial_Aramaic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Imperial_Aramaic
            ],
            [
                'Inherited',
                $4f6bfbff25a5c30c$var$UnicodeTables.Inherited
            ],
            [
                'Inscriptional_Pahlavi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Inscriptional_Pahlavi
            ],
            [
                'Inscriptional_Parthian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Inscriptional_Parthian
            ],
            [
                'Javanese',
                $4f6bfbff25a5c30c$var$UnicodeTables.Javanese
            ],
            [
                'Kaithi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Kaithi
            ],
            [
                'Kannada',
                $4f6bfbff25a5c30c$var$UnicodeTables.Kannada
            ],
            [
                'Katakana',
                $4f6bfbff25a5c30c$var$UnicodeTables.Katakana
            ],
            [
                'Kawi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Kawi
            ],
            [
                'Kayah_Li',
                $4f6bfbff25a5c30c$var$UnicodeTables.Kayah_Li
            ],
            [
                'Kharoshthi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Kharoshthi
            ],
            [
                'Khitan_Small_Script',
                $4f6bfbff25a5c30c$var$UnicodeTables.Khitan_Small_Script
            ],
            [
                'Khmer',
                $4f6bfbff25a5c30c$var$UnicodeTables.Khmer
            ],
            [
                'Khojki',
                $4f6bfbff25a5c30c$var$UnicodeTables.Khojki
            ],
            [
                'Khudawadi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Khudawadi
            ],
            [
                'Lao',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lao
            ],
            [
                'Latin',
                $4f6bfbff25a5c30c$var$UnicodeTables.Latin
            ],
            [
                'Lepcha',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lepcha
            ],
            [
                'Limbu',
                $4f6bfbff25a5c30c$var$UnicodeTables.Limbu
            ],
            [
                'Linear_A',
                $4f6bfbff25a5c30c$var$UnicodeTables.Linear_A
            ],
            [
                'Linear_B',
                $4f6bfbff25a5c30c$var$UnicodeTables.Linear_B
            ],
            [
                'Lisu',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lisu
            ],
            [
                'Lycian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lycian
            ],
            [
                'Lydian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Lydian
            ],
            [
                'Mahajani',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mahajani
            ],
            [
                'Makasar',
                $4f6bfbff25a5c30c$var$UnicodeTables.Makasar
            ],
            [
                'Malayalam',
                $4f6bfbff25a5c30c$var$UnicodeTables.Malayalam
            ],
            [
                'Mandaic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mandaic
            ],
            [
                'Manichaean',
                $4f6bfbff25a5c30c$var$UnicodeTables.Manichaean
            ],
            [
                'Marchen',
                $4f6bfbff25a5c30c$var$UnicodeTables.Marchen
            ],
            [
                'Masaram_Gondi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Masaram_Gondi
            ],
            [
                'Medefaidrin',
                $4f6bfbff25a5c30c$var$UnicodeTables.Medefaidrin
            ],
            [
                'Meetei_Mayek',
                $4f6bfbff25a5c30c$var$UnicodeTables.Meetei_Mayek
            ],
            [
                'Mende_Kikakui',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mende_Kikakui
            ],
            [
                'Meroitic_Cursive',
                $4f6bfbff25a5c30c$var$UnicodeTables.Meroitic_Cursive
            ],
            [
                'Meroitic_Hieroglyphs',
                $4f6bfbff25a5c30c$var$UnicodeTables.Meroitic_Hieroglyphs
            ],
            [
                'Miao',
                $4f6bfbff25a5c30c$var$UnicodeTables.Miao
            ],
            [
                'Modi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Modi
            ],
            [
                'Mongolian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mongolian
            ],
            [
                'Mro',
                $4f6bfbff25a5c30c$var$UnicodeTables.Mro
            ],
            [
                'Multani',
                $4f6bfbff25a5c30c$var$UnicodeTables.Multani
            ],
            [
                'Myanmar',
                $4f6bfbff25a5c30c$var$UnicodeTables.Myanmar
            ],
            [
                'Nabataean',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nabataean
            ],
            [
                'Nag_Mundari',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nag_Mundari
            ],
            [
                'Nandinagari',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nandinagari
            ],
            [
                'New_Tai_Lue',
                $4f6bfbff25a5c30c$var$UnicodeTables.New_Tai_Lue
            ],
            [
                'Newa',
                $4f6bfbff25a5c30c$var$UnicodeTables.Newa
            ],
            [
                'Nko',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nko
            ],
            [
                'Nushu',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nushu
            ],
            [
                'Nyiakeng_Puachue_Hmong',
                $4f6bfbff25a5c30c$var$UnicodeTables.Nyiakeng_Puachue_Hmong
            ],
            [
                'Ogham',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ogham
            ],
            [
                'Ol_Chiki',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ol_Chiki
            ],
            [
                'Old_Hungarian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Hungarian
            ],
            [
                'Old_Italic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Italic
            ],
            [
                'Old_North_Arabian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_North_Arabian
            ],
            [
                'Old_Permic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Permic
            ],
            [
                'Old_Persian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Persian
            ],
            [
                'Old_Sogdian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Sogdian
            ],
            [
                'Old_South_Arabian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_South_Arabian
            ],
            [
                'Old_Turkic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Turkic
            ],
            [
                'Old_Uyghur',
                $4f6bfbff25a5c30c$var$UnicodeTables.Old_Uyghur
            ],
            [
                'Oriya',
                $4f6bfbff25a5c30c$var$UnicodeTables.Oriya
            ],
            [
                'Osage',
                $4f6bfbff25a5c30c$var$UnicodeTables.Osage
            ],
            [
                'Osmanya',
                $4f6bfbff25a5c30c$var$UnicodeTables.Osmanya
            ],
            [
                'Pahawh_Hmong',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pahawh_Hmong
            ],
            [
                'Palmyrene',
                $4f6bfbff25a5c30c$var$UnicodeTables.Palmyrene
            ],
            [
                'Pau_Cin_Hau',
                $4f6bfbff25a5c30c$var$UnicodeTables.Pau_Cin_Hau
            ],
            [
                'Phags_Pa',
                $4f6bfbff25a5c30c$var$UnicodeTables.Phags_Pa
            ],
            [
                'Phoenician',
                $4f6bfbff25a5c30c$var$UnicodeTables.Phoenician
            ],
            [
                'Psalter_Pahlavi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Psalter_Pahlavi
            ],
            [
                'Rejang',
                $4f6bfbff25a5c30c$var$UnicodeTables.Rejang
            ],
            [
                'Runic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Runic
            ],
            [
                'Samaritan',
                $4f6bfbff25a5c30c$var$UnicodeTables.Samaritan
            ],
            [
                'Saurashtra',
                $4f6bfbff25a5c30c$var$UnicodeTables.Saurashtra
            ],
            [
                'Sharada',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sharada
            ],
            [
                'Shavian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Shavian
            ],
            [
                'Siddham',
                $4f6bfbff25a5c30c$var$UnicodeTables.Siddham
            ],
            [
                'SignWriting',
                $4f6bfbff25a5c30c$var$UnicodeTables.SignWriting
            ],
            [
                'Sinhala',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sinhala
            ],
            [
                'Sogdian',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sogdian
            ],
            [
                'Sora_Sompeng',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sora_Sompeng
            ],
            [
                'Soyombo',
                $4f6bfbff25a5c30c$var$UnicodeTables.Soyombo
            ],
            [
                'Sundanese',
                $4f6bfbff25a5c30c$var$UnicodeTables.Sundanese
            ],
            [
                'Syloti_Nagri',
                $4f6bfbff25a5c30c$var$UnicodeTables.Syloti_Nagri
            ],
            [
                'Syriac',
                $4f6bfbff25a5c30c$var$UnicodeTables.Syriac
            ],
            [
                'Tagalog',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tagalog
            ],
            [
                'Tagbanwa',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tagbanwa
            ],
            [
                'Tai_Le',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tai_Le
            ],
            [
                'Tai_Tham',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tai_Tham
            ],
            [
                'Tai_Viet',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tai_Viet
            ],
            [
                'Takri',
                $4f6bfbff25a5c30c$var$UnicodeTables.Takri
            ],
            [
                'Tamil',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tamil
            ],
            [
                'Tangsa',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tangsa
            ],
            [
                'Tangut',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tangut
            ],
            [
                'Telugu',
                $4f6bfbff25a5c30c$var$UnicodeTables.Telugu
            ],
            [
                'Thaana',
                $4f6bfbff25a5c30c$var$UnicodeTables.Thaana
            ],
            [
                'Thai',
                $4f6bfbff25a5c30c$var$UnicodeTables.Thai
            ],
            [
                'Tibetan',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tibetan
            ],
            [
                'Tifinagh',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tifinagh
            ],
            [
                'Tirhuta',
                $4f6bfbff25a5c30c$var$UnicodeTables.Tirhuta
            ],
            [
                'Toto',
                $4f6bfbff25a5c30c$var$UnicodeTables.Toto
            ],
            [
                'Ugaritic',
                $4f6bfbff25a5c30c$var$UnicodeTables.Ugaritic
            ],
            [
                'Vai',
                $4f6bfbff25a5c30c$var$UnicodeTables.Vai
            ],
            [
                'Vithkuqi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Vithkuqi
            ],
            [
                'Wancho',
                $4f6bfbff25a5c30c$var$UnicodeTables.Wancho
            ],
            [
                'Warang_Citi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Warang_Citi
            ],
            [
                'Yezidi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Yezidi
            ],
            [
                'Yi',
                $4f6bfbff25a5c30c$var$UnicodeTables.Yi
            ],
            [
                'Zanabazar_Square',
                $4f6bfbff25a5c30c$var$UnicodeTables.Zanabazar_Square
            ]
        ]))();
    static FOLD_CATEGORIES = (()=>new Map([
            [
                'L',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldL
            ],
            [
                'Ll',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldLl
            ],
            [
                'Lt',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldLt
            ],
            [
                'Lu',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldLu
            ],
            [
                'M',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldM
            ],
            [
                'Mn',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldMn
            ]
        ]))();
    static FOLD_SCRIPT = (()=>new Map([
            [
                'Common',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldCommon
            ],
            [
                'Greek',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldGreek
            ],
            [
                'Inherited',
                $4f6bfbff25a5c30c$var$UnicodeTables.foldInherited
            ]
        ]))();
}
/**
 * Utilities for dealing with Unicode better than JS does.
 */ class $4f6bfbff25a5c30c$var$Unicode {
    // The highest legal rune value.
    static MAX_RUNE = 0x10ffff;
    // The highest legal ASCII value.
    static MAX_ASCII = 0x7f;
    // The highest legal Latin-1 value.
    static MAX_LATIN1 = 0xff;
    // The highest legal Basic Multilingual Plane (BMP) value.
    static MAX_BMP = 0xffff;
    // Minimum and maximum runes involved in folding.
    // Checked during test.
    static MIN_FOLD = 0x0041;
    static MAX_FOLD = 0x1e943;
    // is32 uses binary search to test whether rune is in the specified
    // slice of 32-bit ranges.
    static is32(ranges, r) {
        // binary search over ranges
        let lo = 0;
        let hi = ranges.length;
        while(lo < hi){
            let m = lo + Math.floor((hi - lo) / 2);
            let range = ranges[m];
            if (range[0] <= r && r <= range[1]) return (r - range[0]) % range[2] === 0;
            if (r < range[0]) hi = m;
            else lo = m + 1;
        }
        return false;
    }
    // is tests whether rune is in the specified table of ranges.
    static is(ranges, r) {
        // common case: rune is ASCII or Latin-1, so use linear search.
        if (r <= this.MAX_LATIN1) {
            for (let range of ranges){
                // range = [lo, hi, stride]
                if (r > range[1]) continue;
                if (r < range[0]) return false;
                return (r - range[0]) % range[2] === 0;
            }
            return false;
        }
        return ranges.length > 0 && r >= ranges[0][0] && this.is32(ranges, r);
    }
    // isUpper reports whether the rune is an upper case letter.
    static isUpper(r) {
        if (r <= this.MAX_LATIN1) {
            const s = String.fromCodePoint(r);
            return s.toUpperCase() === s && s.toLowerCase() !== s;
        }
        return this.is($4f6bfbff25a5c30c$var$UnicodeTables.Upper, r);
    }
    // isPrint reports whether the rune is printable (Unicode L/M/N/P/S or ' ').
    static isPrint(r) {
        if (r <= this.MAX_LATIN1) return r >= 0x20 && r < 0x7f || r >= 0xa1 && r !== 0xad;
        return this.is($4f6bfbff25a5c30c$var$UnicodeTables.L, r) || this.is($4f6bfbff25a5c30c$var$UnicodeTables.M, r) || this.is($4f6bfbff25a5c30c$var$UnicodeTables.N, r) || this.is($4f6bfbff25a5c30c$var$UnicodeTables.P, r) || this.is($4f6bfbff25a5c30c$var$UnicodeTables.S, r);
    }
    // simpleFold iterates over Unicode code points equivalent under
    // the Unicode-defined simple case folding.  Among the code points
    // equivalent to rune (including rune itself), SimpleFold returns the
    // smallest r >= rune if one exists, or else the smallest r >= 0.
    //
    // For example:
    //      SimpleFold('A') = 'a'
    //      SimpleFold('a') = 'A'
    //
    //      SimpleFold('K') = 'k'
    //      SimpleFold('k') = '\u212A' (Kelvin symbol, K)
    //      SimpleFold('\u212A') = 'K'
    //
    //      SimpleFold('1') = '1'
    //
    // Derived from Go's unicode.SimpleFold.
    //
    static simpleFold(r) {
        // Consult caseOrbit table for special cases.
        if ($4f6bfbff25a5c30c$var$UnicodeTables.CASE_ORBIT.has(r)) return $4f6bfbff25a5c30c$var$UnicodeTables.CASE_ORBIT.get(r);
        // No folding specified.  This is a one- or two-element
        // equivalence class containing rune and toLower(rune)
        // and toUpper(rune) if they are different from rune.
        const l = $4f6bfbff25a5c30c$var$Codepoint.toLowerCase(r);
        if (l !== r) return l;
        return $4f6bfbff25a5c30c$var$Codepoint.toUpperCase(r);
    }
    // equalsIgnoreCase performs case-insensitive equality comparison
    // on the given runes |r1| and |r2|, with special consideration
    // for the likely scenario where both runes are ASCII characters.
    // If non-ASCII, Unicode case folding will be performed on |r1|
    // to compare it to |r2|.
    // -1 is interpreted as the end-of-file mark.
    static equalsIgnoreCase(r1, r2) {
        // Runes already match, or one of them is EOF
        if (r1 < 0 || r2 < 0 || r1 === r2) return true;
        // Fast path for the common case where both runes are ASCII characters.
        // Coerces both runes to lowercase if applicable.
        if (r1 <= this.MAX_ASCII && r2 <= this.MAX_ASCII) {
            if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('A') <= r1 && r1 <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('Z')) r1 |= 0x20;
            if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('A') <= r2 && r2 <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('Z')) r2 |= 0x20;
            return r1 === r2;
        }
        // Fall back to full Unicode case folding otherwise.
        // Invariant: r1 must be non-negative
        for(let r = this.simpleFold(r1); r !== r1; r = this.simpleFold(r)){
            if (r === r2) return true;
        }
        return false;
    }
}
/**
 * Various constants and helper utilities.
 */ class $4f6bfbff25a5c30c$var$Utils {
    static METACHARACTERS = '\\.+*?()|[]{}^$';
    //// EMPTY_* flags
    static EMPTY_BEGIN_LINE = 0x01;
    static EMPTY_END_LINE = 0x02;
    static EMPTY_BEGIN_TEXT = 0x04;
    static EMPTY_END_TEXT = 0x08;
    static EMPTY_WORD_BOUNDARY = 0x10;
    static EMPTY_NO_WORD_BOUNDARY = 0x20;
    static EMPTY_ALL = (()=>-1)();
    static emptyInts() {
        return [];
    }
    // Returns true iff |c| is an ASCII letter or decimal digit.
    static isalnum(c) {
        return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9') || $4f6bfbff25a5c30c$var$Codepoint.CODES.get('a') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('z') || $4f6bfbff25a5c30c$var$Codepoint.CODES.get('A') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('Z');
    }
    // If |c| is an ASCII hex digit, returns its value, otherwise -1.
    static unhex(c) {
        if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9')) return c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
        if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('a') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('f')) return c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('a') + 10;
        if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('A') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('F')) return c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('A') + 10;
        return -1;
    }
    // Appends a RE2 literal to |out| for rune |rune|,
    // with regexp metacharacters escaped.
    static escapeRune(rune) {
        let out = '';
        if ($4f6bfbff25a5c30c$var$Unicode.isPrint(rune)) {
            if (this.METACHARACTERS.indexOf(String.fromCodePoint(rune)) >= 0) out += '\\';
            out += String.fromCodePoint(rune);
        } else switch(rune){
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('"'):
                // '"'
                out += '\\"';
                break;
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\\'):
                // '\\'
                out += '\\\\';
                break;
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\t'):
                // '\t'
                out += '\\t';
                break;
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n'):
                // '\n'
                out += '\\n';
                break;
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\r'):
                // '\r'
                out += '\\r';
                break;
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\b'):
                // '\b'
                out += '\\b';
                break;
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\f'):
                // '\f'
                out += '\\f';
                break;
            default:
                {
                    let s = rune.toString(16);
                    if (rune < 0x100) {
                        out += '\\x';
                        if (s.length === 1) out += '0';
                        out += s;
                    } else out += `\\x{${s}}`;
                    break;
                }
        }
        return out;
    }
    // Returns the array of runes in the specified Java UTF-16 string.
    static stringToRunes(str) {
        return String(str).split('').map((s)=>s.codePointAt(0));
    }
    // Returns the Java UTF-16 string containing the single rune |r|.
    static runeToString(r) {
        return String.fromCodePoint(r);
    }
    // isWordRune reports whether r is consider a ``word character''
    // during the evaluation of the \b and \B zero-width assertions.
    // These assertions are ASCII-only: the word characters are [A-Za-z0-9_].
    static isWordRune(r) {
        return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('a') <= r && r <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('z') || $4f6bfbff25a5c30c$var$Codepoint.CODES.get('A') <= r && r <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('Z') || $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') <= r && r <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9') || r === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('_');
    }
    // emptyOpContext returns the zero-width assertions satisfied at the position
    // between the runes r1 and r2, a bitmask of EMPTY_* flags.
    // Passing r1 == -1 indicates that the position is at the beginning of the
    // text.
    // Passing r2 == -1 indicates that the position is at the end of the text.
    // eslint-disable-next-line no-warning-comments
    // TODO(adonovan): move to Machine.
    static emptyOpContext(r1, r2) {
        let op = 0;
        if (r1 < 0) op |= this.EMPTY_BEGIN_TEXT | this.EMPTY_BEGIN_LINE;
        if (r1 === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n')) op |= this.EMPTY_BEGIN_LINE;
        if (r2 < 0) op |= this.EMPTY_END_TEXT | this.EMPTY_END_LINE;
        if (r2 === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n')) op |= this.EMPTY_END_LINE;
        if (this.isWordRune(r1) !== this.isWordRune(r2)) op |= this.EMPTY_WORD_BOUNDARY;
        else op |= this.EMPTY_NO_WORD_BOUNDARY;
        return op;
    }
    /**
   * Returns a string that quotes all regular expression metacharacters inside the argument text;
   * the returned string is a regular expression matching the literal text. For example,
   * {@code quoteMeta("[foo]").equals("\\[foo\\]")}.
   * @param {string} s
   * @returns {string}
   */ static quoteMeta(str) {
        return str.split('') // A char loop is correct because all metacharacters fit in one UTF-16 code.
        .map((s)=>{
            if (this.METACHARACTERS.indexOf(s) >= 0) return `\\${s}`;
            return s;
        }).join('');
    }
    static charCount(codePoint) {
        return codePoint > $4f6bfbff25a5c30c$var$Unicode.MAX_BMP ? 2 : 1;
    }
    static stringToUtf8ByteArray(str) {
        if (globalThis.TextEncoder) return Array.from(new TextEncoder().encode(str));
        else {
            // fallback, if no TextEncoder
            let out = [], p = 0;
            for(let i = 0; i < str.length; i++){
                let c = str.charCodeAt(i);
                if (c < 128) out[p++] = c;
                else if (c < 2048) {
                    out[p++] = c >> 6 | 192;
                    out[p++] = c & 63 | 128;
                } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
                    // Surrogate Pair
                    c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
                    out[p++] = c >> 18 | 240;
                    out[p++] = c >> 12 & 63 | 128;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                } else {
                    out[p++] = c >> 12 | 224;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                }
            }
            return out;
        }
    }
    static utf8ByteArrayToString(bytes) {
        if (globalThis.TextDecoder) return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
        else {
            // fallback, if no TextDecoder
            let out = [], pos = 0, c = 0;
            while(pos < bytes.length){
                let c1 = bytes[pos++];
                if (c1 < 128) out[c++] = String.fromCharCode(c1);
                else if (c1 > 191 && c1 < 224) {
                    let c2 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
                } else if (c1 > 239 && c1 < 365) {
                    // Surrogate Pair
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    let c4 = bytes[pos++];
                    let u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
                    out[c++] = String.fromCharCode(0xd800 + (u >> 10));
                    out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
                } else {
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                }
            }
            return out.join('');
        }
    }
}
// helper to create enums
// example
// Encoding[(Encoding['UTF_16'] = 0)] = 'UTF_16'
// Encoding[(Encoding['UTF_8'] = 1)] = 'UTF_8'
const $4f6bfbff25a5c30c$var$createEnum = (values = [], initNum = 0)=>{
    const enumObject = {};
    for(let i = 0; i < values.length; i++){
        const val = values[i];
        const keyVal = initNum + i;
        enumObject[val] = keyVal;
        enumObject[keyVal] = val;
    }
    return Object.freeze(enumObject);
};
/**
 * Abstract the representations of input text supplied to Matcher.
 */ class $4f6bfbff25a5c30c$var$MatcherInputBase {
    static Encoding = (()=>$4f6bfbff25a5c30c$var$createEnum([
            'UTF_16',
            'UTF_8'
        ]))();
    getEncoding() {
        throw Error('not implemented');
    }
    /**
   *
   * @returns {boolean}
   */ isUTF8Encoding() {
        return this.getEncoding() === $4f6bfbff25a5c30c$var$MatcherInputBase.Encoding.UTF_8;
    }
    /**
   *
   * @returns {boolean}
   */ isUTF16Encoding() {
        return this.getEncoding() === $4f6bfbff25a5c30c$var$MatcherInputBase.Encoding.UTF_16;
    }
}
class $4f6bfbff25a5c30c$var$Utf8MatcherInput extends $4f6bfbff25a5c30c$var$MatcherInputBase {
    constructor(bytes = null){
        super();
        this.bytes = bytes;
    }
    getEncoding() {
        return $4f6bfbff25a5c30c$var$MatcherInputBase.Encoding.UTF_8;
    }
    /**
   *
   * @returns {string}
   */ asCharSequence() {
        return $4f6bfbff25a5c30c$var$Utils.utf8ByteArrayToString(this.bytes);
    }
    /**
   *
   * @returns {number[]}
   */ asBytes() {
        return this.bytes;
    }
    /**
   *
   * @returns {number}
   */ length() {
        return this.bytes.length;
    }
}
class $4f6bfbff25a5c30c$var$Utf16MatcherInput extends $4f6bfbff25a5c30c$var$MatcherInputBase {
    constructor(charSequence = null){
        super();
        this.charSequence = charSequence;
    }
    getEncoding() {
        return $4f6bfbff25a5c30c$var$MatcherInputBase.Encoding.UTF_16;
    }
    /**
   *
   * @returns {string}
   */ asCharSequence() {
        return this.charSequence;
    }
    /**
   *
   * @returns {number[]}
   */ asBytes() {
        return this.charSequence.toString().split('').map((s)=>s.codePointAt(0));
    }
    /**
   *
   * @returns {number}
   */ length() {
        return this.charSequence.length;
    }
}
class $4f6bfbff25a5c30c$var$MatcherInput {
    /**
   * Return the MatcherInput for UTF_16 encoding.
   * @returns {Utf16MatcherInput}
   */ static utf16(charSequence) {
        return new $4f6bfbff25a5c30c$var$Utf16MatcherInput(charSequence);
    }
    /**
   * Return the MatcherInput for UTF_8 encoding.
   * @returns {Utf8MatcherInput}
   */ static utf8(input) {
        if (Array.isArray(input)) return new $4f6bfbff25a5c30c$var$Utf8MatcherInput(input);
        return new $4f6bfbff25a5c30c$var$Utf8MatcherInput($4f6bfbff25a5c30c$var$Utils.stringToUtf8ByteArray(input));
    }
}
class $4f6bfbff25a5c30c$export$54306bca8e0bffc2 extends Error {
    constructor(message){
        super(message);
        this.name = 'RE2JSException';
    }
}
/**
 * An exception thrown by the parser if the pattern was invalid.
 */ class $4f6bfbff25a5c30c$export$9c12d0c1e9bff151 extends $4f6bfbff25a5c30c$export$54306bca8e0bffc2 {
    constructor(error, input = null){
        let message = `error parsing regexp: ${error}`;
        if (input) message += `: \`${input}\``;
        super(message);
        this.name = 'RE2JSSyntaxException';
        this.message = message;
        this.error = error;
        this.input = input;
    }
    /**
   * Retrieves the description of the error.
   */ getDescription() {
        return this.error;
    }
    /**
   * Retrieves the erroneous regular-expression pattern.
   */ getPattern() {
        return this.input;
    }
}
/**
 * An exception thrown by the compiler
 */ class $4f6bfbff25a5c30c$export$457eacef9ada3821 extends $4f6bfbff25a5c30c$export$54306bca8e0bffc2 {
    constructor(message){
        super(message);
        this.name = 'RE2JSCompileException';
    }
}
/**
 * An exception thrown by using groups
 */ class $4f6bfbff25a5c30c$export$eab8e70da4919c35 extends $4f6bfbff25a5c30c$export$54306bca8e0bffc2 {
    constructor(message){
        super(message);
        this.name = 'RE2JSGroupException';
    }
}
/**
 * An exception thrown by flags
 */ class $4f6bfbff25a5c30c$export$fa1c64d63b2c22b1 extends $4f6bfbff25a5c30c$export$54306bca8e0bffc2 {
    constructor(message){
        super(message);
        this.name = 'RE2JSFlagsException';
    }
}
/**
 * A stateful iterator that interprets a regex {@code RE2JS} on a specific input.
 *
 * Conceptually, a Matcher consists of four parts:
 * <ol>
 * <li>A compiled regular expression {@code RE2JS}, set at construction and fixed for the lifetime
 * of the matcher.</li>
 *
 * <li>The remainder of the input string, set at construction or {@link #reset()} and advanced by
 * each match operation such as {@link #find}, {@link #matches} or {@link #lookingAt}.</li>
 *
 * <li>The current match information, accessible via {@link #start}, {@link #end}, and
 * {@link #group}, and updated by each match operation.</li>
 *
 * <li>The append position, used and advanced by {@link #appendReplacement} and {@link #appendTail}
 * if performing a search and replace from the input to an external {@code StringBuffer}.
 *
 * </ol>
 *
 *
 * @author rsc@google.com (Russ Cox)
 */ class $4f6bfbff25a5c30c$var$Matcher {
    /**
   * Quotes '\' and '$' in {@code s}, so that the returned string could be used in
   * {@link #appendReplacement} as a literal replacement of {@code s}.
   *
   * @param {string} str the string to be quoted
   * @returns {string} the quoted string
   */ static quoteReplacement(str) {
        if (str.indexOf('\\') < 0 && str.indexOf('$') < 0) return str;
        return str.split('').map((s)=>{
            const c = s.codePointAt(0);
            if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES['\\'] || c === $4f6bfbff25a5c30c$var$Codepoint.CODES['$']) return `\\${s}`;
            return s;
        }).join('');
    }
    /**
   *
   * @param {RE2JS} pattern
   * @param {Utf8MatcherInput|Utf16MatcherInput|number[]|string} input
   */ constructor(pattern, input){
        if (pattern === null) throw new Error('pattern is null');
        // The pattern being matched.
        this.patternInput = pattern;
        const re2 = this.patternInput.re2();
        // The number of submatches (groups) in the pattern.
        this.patternGroupCount = re2.numberOfCapturingGroups();
        // The group indexes, in [start, end) pairs.  Zeroth pair is overall match.
        this.groups = [];
        this.namedGroups = re2.namedGroups;
        if (input instanceof $4f6bfbff25a5c30c$var$MatcherInputBase) this.resetMatcherInput(input);
        else if (Array.isArray(input)) this.resetMatcherInput($4f6bfbff25a5c30c$var$MatcherInput.utf8(input));
        else this.resetMatcherInput($4f6bfbff25a5c30c$var$MatcherInput.utf16(input));
    }
    /**
   * Returns the {@code RE2JS} associated with this {@code Matcher}.
   * @returns {RE2JS}
   */ pattern() {
        return this.patternInput;
    }
    /**
   * Resets the {@code Matcher}, rewinding input and discarding any match information.
   *
   * @returns {Matcher} the {@code Matcher} itself, for chained method calls
   */ reset() {
        // The input length in UTF16 codes.
        this.matcherInputLength = this.matcherInput.length();
        // The append position: where the next append should start.
        this.appendPos = 0;
        // Is there a current match?
        this.hasMatch = false;
        // Have we found the submatches (groups) of the current match?
        // group[0], group[1] are set regardless.
        this.hasGroups = false;
        // The anchor flag to use when repeating the match to find subgroups.
        this.anchorFlag = 0;
        return this;
    }
    /**
   * Resets the {@code Matcher} and changes the input.
   * @returns {Matcher} the {@code Matcher} itself, for chained method calls
   */ resetMatcherInput(input) {
        if (input === null) throw new Error('input is null');
        this.matcherInput = input;
        this.reset();
        return this;
    }
    /**
   * Returns the start of the named group of the most recent match, or -1 if the group was not
   * matched.
   * @param {string|number} [group=0]
   * @returns {string}
   */ start(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group];
    }
    /**
   * Returns the end of the named group of the most recent match, or -1 if the group was not
   * matched.
   * @param {string|number} [group=0]
   * @returns {string}
   */ end(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group + 1];
    }
    /**
   * Returns the named group of the most recent match, or {@code null} if the group was not matched.
   * @param {string|number} [group=0]
   * @returns {string}
   */ group(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35(`group '${group}' not found`);
            group = groupInt;
        }
        const start = this.start(group);
        const end = this.end(group);
        if (start < 0 && end < 0) return null;
        return this.substring(start, end);
    }
    /**
   * Returns the number of subgroups in this pattern.
   *
   * @returns {number} the number of subgroups; the overall match (group 0) does not count
   */ groupCount() {
        return this.patternGroupCount;
    }
    /**
   * Helper: finds subgroup information if needed for group.
   * @param {number} group
   * @private
   */ loadGroup(group) {
        if (group < 0 || group > this.patternGroupCount) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35(`Group index out of bounds: ${group}`);
        if (!this.hasMatch) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35('perhaps no match attempted');
        if (group === 0 || this.hasGroups) return;
        let end = this.groups[1] + 1;
        if (end > this.matcherInputLength) end = this.matcherInputLength;
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], end, this.anchorFlag, 1 + this.patternGroupCount);
        const ok = res[0];
        if (!ok) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35('inconsistency in matching group data');
        this.groups = res[1];
        this.hasGroups = true;
    }
    /**
   * Matches the entire input against the pattern (anchored start and end). If there is a match,
   * {@code matches} sets the match state to describe it.
   *
   * @returns {boolean} true if the entire input matches the pattern
   */ matches() {
        return this.genMatch(0, $4f6bfbff25a5c30c$var$RE2Flags.ANCHOR_BOTH);
    }
    /**
   * Matches the beginning of input against the pattern (anchored start). If there is a match,
   * {@code lookingAt} sets the match state to describe it.
   *
   * @returns {boolean} true if the beginning of the input matches the pattern
   */ lookingAt() {
        return this.genMatch(0, $4f6bfbff25a5c30c$var$RE2Flags.ANCHOR_START);
    }
    /**
   * Matches the input against the pattern (unanchored), starting at a specified position. If there
   * is a match, {@code find} sets the match state to describe it.
   *
   * @param {string|number} [start=null] the input position where the search begins
   * @returns {boolean} if it finds a match
   * @throws IndexOutOfBoundsException if start is not a valid input position
   */ find(start = null) {
        if (start !== null) {
            if (start < 0 || start > this.matcherInputLength) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35(`start index out of bounds: ${start}`);
            this.reset();
            return this.genMatch(start, 0);
        }
        // no start
        start = 0;
        if (this.hasMatch) {
            start = this.groups[1];
            if (this.groups[0] === this.groups[1]) start++;
        }
        return this.genMatch(start, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED);
    }
    /**
   * Helper: does match starting at start, with RE2 anchor flag.
   * @param {number} startByte
   * @param {number} anchor
   * @returns {boolean}
   * @private
   */ genMatch(startByte, anchor) {
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, startByte, this.matcherInputLength, anchor, 1);
        const ok = res[0];
        if (!ok) return false;
        this.groups = res[1];
        this.hasMatch = true;
        this.hasGroups = false;
        this.anchorFlag = anchor;
        return true;
    }
    /**
   * Helper: return substring for [start, end).
   * @param {number} start
   * @param {number} end
   * @returns {string}
   */ substring(start, end) {
        if (this.matcherInput.isUTF8Encoding()) return $4f6bfbff25a5c30c$var$Utils.utf8ByteArrayToString(this.matcherInput.asBytes().slice(start, end));
        return this.matcherInput.asCharSequence().substring(start, end).toString();
    }
    /**
   * Helper for Pattern: return input length.
   * @returns {number}
   */ inputLength() {
        return this.matcherInputLength;
    }
    /**
   * Appends to result two strings: the text from the append position up to the beginning of the
   * most recent match, and then the replacement with submatch groups substituted for references of
   * the form {@code $n}, where {@code n} is the group number in decimal. It advances the append
   * position to where the most recent match ended.
   *
   * To embed a literal {@code $}, use \$ (actually {@code "\\$"} with string escapes). The escape
   * is only necessary when {@code $} is followed by a digit, but it is always allowed. Only
   * {@code $} and {@code \} need escaping, but any character can be escaped.
   *
   * The group number {@code n} in {@code $n} is always at least one digit and expands to use more
   * digits as long as the resulting number is a valid group number for this pattern. To cut it off
   * earlier, escape the first digit that should not be used.
   *
   * @param {string} replacement the replacement string
   * @param {boolean} [perlMode=false] activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string}
   * @throws IllegalStateException if there was no most recent match
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group
   * @private
   */ appendReplacement(replacement, perlMode = false) {
        let res = '';
        const s = this.start();
        const e = this.end();
        if (this.appendPos < s) res += this.substring(this.appendPos, s);
        this.appendPos = e;
        res += perlMode ? this.appendReplacementInternalPerl(replacement) : this.appendReplacementInternal(replacement);
        return res;
    }
    /**
   * @param {string} replacement - the replacement string
   * @returns {string}
   * @private
   */ appendReplacementInternal(replacement) {
        let res = '';
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++){
            if (replacement.codePointAt(i) === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\\')) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                last = i;
                continue;
            }
            if (replacement.codePointAt(i) === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('$')) {
                let c = replacement.codePointAt(i + 1);
                if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9')) {
                    let n = c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
                    if (last < i) res += replacement.substring(last, i);
                    for(i += 2; i < m; i++){
                        c = replacement.codePointAt(i);
                        if (c < $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') || c > $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9') || n * 10 + c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') > this.patternGroupCount) break;
                        n = n * 10 + c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
                    }
                    if (n > this.patternGroupCount) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35(`n > number of groups: ${n}`);
                    const group = this.group(n);
                    if (group !== null) res += group;
                    last = i;
                    i--;
                    continue;
                } else if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('{')) {
                    if (last < i) res += replacement.substring(last, i);
                    i++;
                    let j = i + 1;
                    while(j < replacement.length && replacement.codePointAt(j) !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('}') && replacement.codePointAt(j) !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get(' '))j++;
                    if (j === replacement.length || replacement.codePointAt(j) !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('}')) throw new $4f6bfbff25a5c30c$export$eab8e70da4919c35("named capture group is missing trailing '}'");
                    const groupName = replacement.substring(i + 1, j);
                    res += this.group(groupName);
                    last = j + 1;
                }
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
   * @param {string} replacement - the replacement string
   * @returns {string}
   * @private
   */ appendReplacementInternalPerl(replacement) {
        let res = '';
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++)if (replacement.codePointAt(i) === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('$')) {
            let c = replacement.codePointAt(i + 1);
            if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('$') === c) {
                if (last < i) res += replacement.substring(last, i);
                res += '$';
                i++;
                last = i + 1;
                continue;
            } else if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('&') === c) {
                if (last < i) res += replacement.substring(last, i);
                const group = this.group(0);
                if (group !== null) res += group;
                else res += '$&';
                i++;
                last = i + 1;
                continue;
            } else if ($4f6bfbff25a5c30c$var$Codepoint.CODES.get('1') <= c && c <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9')) {
                let n = c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
                if (last < i) res += replacement.substring(last, i);
                for(i += 2; i < m; i++){
                    c = replacement.codePointAt(i);
                    if (c < $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') || c > $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9') || n * 10 + c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') > this.patternGroupCount) break;
                    n = n * 10 + c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
                }
                if (n > this.patternGroupCount) {
                    res += `$${n}`;
                    last = i;
                    i--;
                    continue;
                }
                const group = this.group(n);
                if (group !== null) res += group;
                last = i;
                i--;
                continue;
            } else if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('<')) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                let j = i + 1;
                while(j < replacement.length && replacement.codePointAt(j) !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('>') && replacement.codePointAt(j) !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get(' '))j++;
                if (j === replacement.length || replacement.codePointAt(j) !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('>')) {
                    res += replacement.substring(i - 1, j + 1);
                    last = j + 1;
                    continue;
                }
                const groupName = replacement.substring(i + 1, j);
                if (Object.prototype.hasOwnProperty.call(this.namedGroups, groupName)) res += this.group(groupName);
                else res += `$<${groupName}>`;
                last = j + 1;
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
   * Return the substring of the input from the append position to the end of the
   * input.
   * @returns {string}
   */ appendTail() {
        return this.substring(this.appendPos, this.matcherInputLength);
    }
    /**
   * Returns the input with all matches replaced by {@code replacement}, interpreted as for
   * {@code appendReplacement}.
   *
   * @param {string} replacement - the replacement string
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string} the input string with the matches replaced
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group and perlMode is false
   */ replaceAll(replacement, perlMode = false) {
        return this.replace(replacement, true, perlMode);
    }
    /**
   * Returns the input with the first match replaced by {@code replacement}, interpreted as for
   * {@code appendReplacement}.
   *
   * @param {string} replacement - the replacement string
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string} the input string with the first match replaced
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group and perlMode is false
   */ replaceFirst(replacement, perlMode = false) {
        return this.replace(replacement, false, perlMode);
    }
    /**
   * Helper: replaceAll/replaceFirst hybrid.
   * @param {string} replacement - the replacement string
   * @param {boolean} [all=true] - replace all matches
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string}
   * @private
   */ replace(replacement, all = true, perlMode = false) {
        let res = '';
        this.reset();
        while(this.find()){
            res += this.appendReplacement(replacement, perlMode);
            if (!all) break;
        }
        res += this.appendTail();
        return res;
    }
}
/**
 * MachineInput abstracts different representations of the input text supplied to the Machine. It
 * provides one-character lookahead.
 */ class $4f6bfbff25a5c30c$var$MachineInputBase {
    static EOF() {
        return -8;
    }
    // can we look ahead without losing info?
    canCheckPrefix() {
        return true;
    }
    // Returns the end position in the same units as step().
    endPos() {
        return this.end;
    }
}
// An implementation of MachineInput for UTF-8 byte arrays.
// |pos| and |width| are byte indices.
class $4f6bfbff25a5c30c$var$MachineUTF8Input extends $4f6bfbff25a5c30c$var$MachineInputBase {
    constructor(bytes, start = 0, end = bytes.length){
        super();
        this.bytes = bytes;
        this.start = start;
        this.end = end;
    }
    // Returns the rune at the specified index; the units are
    // unspecified, but could be UTF-8 byte, UTF-16 char, or rune
    // indices.  Returns the width (in the same units) of the rune in
    // the lower 3 bits, and the rune (Unicode code point) in the high
    // bits.  Never negative, except for EOF which is represented as -1
    // << 3 | 0.
    step(i) {
        i += this.start;
        if (i >= this.end) return $4f6bfbff25a5c30c$var$MachineInputBase.EOF();
        let x = this.bytes[i++] & 255;
        if ((x & 128) === 0) return x << 3 | 1;
        else if ((x & 224) === 192) {
            x = x & 31;
            if (i >= this.end) return $4f6bfbff25a5c30c$var$MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 2;
        } else if ((x & 240) === 224) {
            x = x & 15;
            if (i + 1 >= this.end) return $4f6bfbff25a5c30c$var$MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 3;
        } else {
            x = x & 7;
            if (i + 2 >= this.end) return $4f6bfbff25a5c30c$var$MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 4;
        }
    }
    // Returns the index relative to |pos| at which |re2.prefix| is found
    // in this input stream, or a negative value if not found.
    index(re2, pos) {
        pos += this.start;
        const i = this.indexOf(this.bytes, re2.prefixUTF8, pos);
        return i < 0 ? i : i - pos;
    }
    // Returns a bitmask of EMPTY_* flags.
    context(pos) {
        pos += this.start;
        let r1 = -1;
        if (pos > this.start && pos <= this.end) {
            let start = pos - 1;
            r1 = this.bytes[start--];
            if (r1 >= 128) {
                let lim = pos - 4;
                if (lim < this.start) lim = this.start;
                while(start >= lim && (this.bytes[start] & 192) === 128)start--;
                if (start < this.start) start = this.start;
                r1 = this.step(start) >> 3;
            }
        }
        const r2 = pos < this.end ? this.step(pos) >> 3 : -1;
        return $4f6bfbff25a5c30c$var$Utils.emptyOpContext(r1, r2);
    }
    // Returns the index of the first occurrence of array |target| within
    // array |source| after |fromIndex|, or -1 if not found.
    indexOf(source, target, fromIndex = 0) {
        let targetLength = target.length;
        if (targetLength === 0) return -1;
        let sourceLength = source.length;
        for(let i = fromIndex; i <= sourceLength - targetLength; i++)for(let j = 0; j < targetLength; j++){
            if (source[i + j] !== target[j]) break;
            else if (j === targetLength - 1) return i;
        }
        return -1;
    }
}
// |pos| and |width| are in JS "char" units.
class $4f6bfbff25a5c30c$var$MachineUTF16Input extends $4f6bfbff25a5c30c$var$MachineInputBase {
    constructor(charSequence, start = 0, end = charSequence.length){
        super();
        this.charSequence = charSequence;
        this.start = start;
        this.end = end;
    }
    // Returns the rune at the specified index; the units are
    // unspecified, but could be UTF-8 byte, UTF-16 char, or rune
    // indices.  Returns the width (in the same units) of the rune in
    // the lower 3 bits, and the rune (Unicode code point) in the high
    // bits.  Never negative, except for EOF which is represented as -1
    // << 3 | 0.
    step(pos) {
        pos += this.start;
        if (pos < this.end) {
            const rune = this.charSequence.codePointAt(pos);
            return rune << 3 | $4f6bfbff25a5c30c$var$Utils.charCount(rune);
        } else return $4f6bfbff25a5c30c$var$MachineInputBase.EOF();
    }
    // Returns the index relative to |pos| at which |re2.prefix| is found
    // in this input stream, or a negative value if not found.
    index(re2, pos) {
        pos += this.start;
        const i = this.charSequence.indexOf(re2.prefix, pos);
        return i < 0 ? i : i - pos;
    }
    // Returns a bitmask of EMPTY_* flags.
    context(pos) {
        pos += this.start;
        const r1 = pos > 0 && pos <= this.charSequence.length ? this.charSequence.codePointAt(pos - 1) : -1;
        const r2 = pos < this.charSequence.length ? this.charSequence.codePointAt(pos) : -1;
        return $4f6bfbff25a5c30c$var$Utils.emptyOpContext(r1, r2);
    }
}
class $4f6bfbff25a5c30c$var$MachineInput {
    static fromUTF8(bytes, start = 0, end = bytes.length) {
        return new $4f6bfbff25a5c30c$var$MachineUTF8Input(bytes, start, end);
    }
    static fromUTF16(charSequence, start = 0, end = charSequence.length) {
        return new $4f6bfbff25a5c30c$var$MachineUTF16Input(charSequence, start, end);
    }
}
/**
 * Regular expression abstract syntax tree. Produced by parser, used by compiler. NB, this
 * corresponds to {@code syntax.regexp} in the Go implementation; Go's {@code regexp} is called
 * {@code RE2} in Java.
 */ class $4f6bfbff25a5c30c$var$Regexp {
    static Op = (()=>$4f6bfbff25a5c30c$var$createEnum([
            'NO_MATCH',
            // Matches no strings.
            'EMPTY_MATCH',
            // Matches empty string.
            'LITERAL',
            // Matches runes[] sequence
            'CHAR_CLASS',
            // Matches Runes interpreted as range pair list
            'ANY_CHAR_NOT_NL',
            // Matches any character except '\n'
            'ANY_CHAR',
            // Matches any character
            'BEGIN_LINE',
            // Matches empty string at end of line
            'END_LINE',
            // Matches empty string at end of line
            'BEGIN_TEXT',
            // Matches empty string at beginning of text
            'END_TEXT',
            // Matches empty string at end of text
            'WORD_BOUNDARY',
            // Matches word boundary `\b`
            'NO_WORD_BOUNDARY',
            // Matches word non-boundary `\B`
            'CAPTURE',
            // Capturing subexpr with index cap, optional name name
            'STAR',
            // Matches subs[0] zero or more times.
            'PLUS',
            // Matches subs[0] one or more times.
            'QUEST',
            // Matches subs[0] zero or one times.
            'REPEAT',
            // Matches subs[0] [min, max] times; max=-1 => no limit.
            'CONCAT',
            // Matches concatenation of subs[]
            'ALTERNATE',
            // Matches union of subs[]
            // Pseudo ops, used internally by Parser for parsing stack:
            'LEFT_PAREN',
            'VERTICAL_BAR'
        ]))();
    static isPseudoOp(op) {
        return op >= $4f6bfbff25a5c30c$var$Regexp.Op.LEFT_PAREN;
    }
    static emptySubs() {
        return [];
    }
    static quoteIfHyphen(rune) {
        if (rune === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('-')) return '\\';
        return '';
    }
    static fromRegexp(re) {
        const regex = new $4f6bfbff25a5c30c$var$Regexp(re.op);
        regex.flags = re.flags;
        regex.subs = re.subs;
        regex.runes = re.runes;
        regex.cap = re.cap;
        regex.min = re.min;
        regex.max = re.max;
        regex.name = re.name;
        regex.namedGroups = re.namedGroups;
        return regex;
    }
    constructor(op){
        this.op = op; // operator
        this.flags = 0; // bitmap of parse flags
        // subexpressions, if any.  Never null.
        // subs[0] is used as the freelist.
        this.subs = $4f6bfbff25a5c30c$var$Regexp.emptySubs();
        this.runes = null; // matched runes, for LITERAL, CHAR_CLASS
        this.min = 0; // min for REPEAT
        this.max = 0; // max for REPEAT
        this.cap = 0; // capturing index, for CAPTURE
        this.name = null; // capturing name, for CAPTURE
        this.namedGroups = {}; // map of group name -> capturing index
    }
    reinit() {
        this.flags = 0;
        this.subs = $4f6bfbff25a5c30c$var$Regexp.emptySubs();
        this.runes = null;
        this.cap = 0;
        this.min = 0;
        this.max = 0;
        this.name = null;
        this.namedGroups = {};
    }
    toString() {
        return this.appendTo();
    }
    // appendTo() appends the Perl syntax for |this| regular expression to out
    appendTo() {
        let out = '';
        switch(this.op){
            case $4f6bfbff25a5c30c$var$Regexp.Op.NO_MATCH:
                out += '[^\\x00-\\x{10FFFF}]';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH:
                out += '(?:)';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.STAR:
            case $4f6bfbff25a5c30c$var$Regexp.Op.PLUS:
            case $4f6bfbff25a5c30c$var$Regexp.Op.QUEST:
            case $4f6bfbff25a5c30c$var$Regexp.Op.REPEAT:
                {
                    const sub = this.subs[0];
                    if (sub.op > $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE || sub.op === $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL && sub.runes.length > 1) out += `(?:${sub.appendTo()})`;
                    else out += sub.appendTo();
                    switch(this.op){
                        case $4f6bfbff25a5c30c$var$Regexp.Op.STAR:
                            out += '*';
                            break;
                        case $4f6bfbff25a5c30c$var$Regexp.Op.PLUS:
                            out += '+';
                            break;
                        case $4f6bfbff25a5c30c$var$Regexp.Op.QUEST:
                            out += '?';
                            break;
                        case $4f6bfbff25a5c30c$var$Regexp.Op.REPEAT:
                            out += `{${this.min}`;
                            if (this.min !== this.max) {
                                out += ',';
                                if (this.max >= 0) out += this.max;
                            }
                            out += '}';
                            break;
                    }
                    if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) !== 0) out += '?';
                    break;
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT:
                for (let sub of this.subs)if (sub.op === $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE) out += `(?:${sub.appendTo()})`;
                else out += sub.appendTo();
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE:
                {
                    let sep = '';
                    for (let sub of this.subs){
                        out += sep;
                        sep = '|';
                        out += sub.appendTo();
                    }
                    break;
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL:
                if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0) out += '(?i:';
                for (let rune of this.runes)out += $4f6bfbff25a5c30c$var$Utils.escapeRune(rune);
                if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0) out += ')';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL:
                out += '(?-s:.)';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR:
                out += '(?s:.)';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE:
                if (this.name === null || this.name.length === 0) out += '(';
                else out += `(?P<${this.name}>`;
                if (this.subs[0].op !== $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH) out += this.subs[0].appendTo();
                out += ')';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_TEXT:
                out += '\\A';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.END_TEXT:
                if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.WAS_DOLLAR) !== 0) out += '(?-m:$)';
                else out += '\\z';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_LINE:
                out += '^';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.END_LINE:
                out += '$';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.WORD_BOUNDARY:
                out += '\\b';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.NO_WORD_BOUNDARY:
                out += '\\B';
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS:
                if (this.runes.length % 2 !== 0) {
                    out += '[invalid char class]';
                    break;
                }
                out += '[';
                if (this.runes.length === 0) out += '^\\x00-\\x{10FFFF}';
                else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) {
                    out += '^';
                    for(let i = 1; i < this.runes.length - 1; i += 2){
                        const lo = this.runes[i] + 1;
                        const hi = this.runes[i + 1] - 1;
                        out += $4f6bfbff25a5c30c$var$Regexp.quoteIfHyphen(lo);
                        out += $4f6bfbff25a5c30c$var$Utils.escapeRune(lo);
                        if (lo !== hi) {
                            out += '-';
                            out += $4f6bfbff25a5c30c$var$Regexp.quoteIfHyphen(hi);
                            out += $4f6bfbff25a5c30c$var$Utils.escapeRune(hi);
                        }
                    }
                } else for(let i = 0; i < this.runes.length; i += 2){
                    const lo = this.runes[i];
                    const hi = this.runes[i + 1];
                    out += $4f6bfbff25a5c30c$var$Regexp.quoteIfHyphen(lo);
                    out += $4f6bfbff25a5c30c$var$Utils.escapeRune(lo);
                    if (lo !== hi) {
                        out += '-';
                        out += $4f6bfbff25a5c30c$var$Regexp.quoteIfHyphen(hi);
                        out += $4f6bfbff25a5c30c$var$Utils.escapeRune(hi);
                    }
                }
                out += ']';
                break;
            default:
                out += this.op;
                break;
        }
        return out;
    }
    // maxCap() walks the regexp to find the maximum capture index.
    maxCap() {
        let m = 0;
        if (this.op === $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE) m = this.cap;
        if (this.subs !== null) for (let sub of this.subs){
            const n = sub.maxCap();
            if (m < n) m = n;
        }
        return m;
    }
    // equals() returns true if this and that have identical structure.
    equals(that) {
        if (!(that !== null && that instanceof $4f6bfbff25a5c30c$var$Regexp)) return false;
        if (this.op !== that.op) return false;
        switch(this.op){
            case $4f6bfbff25a5c30c$var$Regexp.Op.END_TEXT:
                if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.WAS_DOLLAR) !== (that.flags & $4f6bfbff25a5c30c$var$RE2Flags.WAS_DOLLAR)) return false;
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL:
            case $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS:
                if (this.runes === null && that.runes === null) break;
                if (this.runes === null || that.runes === null) return false;
                if (this.runes.length !== that.runes.length) return false;
                for(let i = 0; i < this.runes.length; i++){
                    if (this.runes[i] !== that.runes[i]) return false;
                }
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE:
            case $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT:
                if (this.subs.length !== that.subs.length) return false;
                for(let i = 0; i < this.subs.length; ++i){
                    if (!this.subs[i].equals(that.subs[i])) return false;
                }
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.STAR:
            case $4f6bfbff25a5c30c$var$Regexp.Op.PLUS:
            case $4f6bfbff25a5c30c$var$Regexp.Op.QUEST:
                if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) !== (that.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.REPEAT:
                if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) !== (that.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) || this.min !== that.min || this.max !== that.max || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE:
                if (this.cap !== that.cap || (this.name === null ? that.name !== null : this.name !== that.name) || !this.subs[0].equals(that.subs[0])) return false;
                break;
        }
        return true;
    }
}
/**
 * A single instruction in the regular expression virtual machine.
 *
 * @see http://swtch.com/~rsc/regexp/regexp2.html
 */ class $4f6bfbff25a5c30c$var$Inst {
    static ALT = 1;
    static ALT_MATCH = 2;
    static CAPTURE = 3;
    static EMPTY_WIDTH = 4;
    static FAIL = 5;
    static MATCH = 6;
    static NOP = 7;
    static RUNE = 8;
    static RUNE1 = 9;
    static RUNE_ANY = 10;
    static RUNE_ANY_NOT_NL = 11;
    static isRuneOp(op) {
        return $4f6bfbff25a5c30c$var$Inst.RUNE <= op && op <= $4f6bfbff25a5c30c$var$Inst.RUNE_ANY_NOT_NL;
    }
    // Returns an RE2 expression matching exactly |runes|.
    static escapeRunes(runes) {
        let out = '"';
        for (let rune of runes)out += $4f6bfbff25a5c30c$var$Utils.escapeRune(rune);
        out += '"';
        return out;
    }
    constructor(op){
        this.op = op;
        this.out = 0; // all but MATCH, FAIL
        this.arg = 0; // ALT, ALT_MATCH, CAPTURE, EMPTY_WIDTH
        // length==1 => exact match
        // otherwise a list of [lo,hi] pairs.  hi is *inclusive*.
        this.runes = null;
    }
    // MatchRune returns true if the instruction matches (and consumes) r.
    // It should only be called when op == InstRune.
    matchRune(r) {
        // Special case: single-rune slice is from literal string, not char
        // class.
        if (this.runes.length === 1) {
            const r0 = this.runes[0];
            // If this pattern is case-insensitive, apply Unicode case folding to compare the two runes.
            // Note that this may result in a case-folding loop when executed,
            // so attempt to reduce the chance of that occurring
            // by performing case folding on |r0| from the pattern rather than |r| from the input.
            if ((this.arg & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0) return $4f6bfbff25a5c30c$var$Unicode.equalsIgnoreCase(r0, r);
            return r === r0;
        }
        // Peek at the first few pairs.
        // Should handle ASCII well.
        for(let j = 0; j < this.runes.length && j <= 8; j += 2){
            if (r < this.runes[j]) return false;
            if (r <= this.runes[j + 1]) return true;
        }
        // Otherwise binary search.
        let lo = 0;
        let hi = this.runes.length / 2 | 0;
        while(lo < hi){
            const m = lo + ((hi - lo) / 2 | 0);
            const c = this.runes[2 * m];
            if (c <= r) {
                if (r <= this.runes[2 * m + 1]) return true;
                lo = m + 1;
            } else hi = m;
        }
        return false;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        switch(this.op){
            case $4f6bfbff25a5c30c$var$Inst.ALT:
                return `alt -> ${this.out}, ${this.arg}`;
            case $4f6bfbff25a5c30c$var$Inst.ALT_MATCH:
                return `altmatch -> ${this.out}, ${this.arg}`;
            case $4f6bfbff25a5c30c$var$Inst.CAPTURE:
                return `cap ${this.arg} -> ${this.out}`;
            case $4f6bfbff25a5c30c$var$Inst.EMPTY_WIDTH:
                return `empty ${this.arg} -> ${this.out}`;
            case $4f6bfbff25a5c30c$var$Inst.MATCH:
                return 'match';
            case $4f6bfbff25a5c30c$var$Inst.FAIL:
                return 'fail';
            case $4f6bfbff25a5c30c$var$Inst.NOP:
                return `nop -> ${this.out}`;
            case $4f6bfbff25a5c30c$var$Inst.RUNE:
                if (this.runes === null) return 'rune <null>';
                return [
                    'rune ',
                    $4f6bfbff25a5c30c$var$Inst.escapeRunes(this.runes),
                    (this.arg & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0 ? '/i' : '',
                    ' -> ',
                    this.out
                ].join('');
            case $4f6bfbff25a5c30c$var$Inst.RUNE1:
                return `rune1 ${$4f6bfbff25a5c30c$var$Inst.escapeRunes(this.runes)} -> ${this.out}`;
            case $4f6bfbff25a5c30c$var$Inst.RUNE_ANY:
                return `any -> ${this.out}`;
            case $4f6bfbff25a5c30c$var$Inst.RUNE_ANY_NOT_NL:
                return `anynotnl -> ${this.out}`;
            default:
                throw new Error('unhandled case in Inst.toString');
        }
    }
}
/**
 * A Prog is a compiled regular expression program.
 */ class $4f6bfbff25a5c30c$var$Prog {
    constructor(){
        this.inst = [];
        this.start = 0; // index of start instruction
        // number of CAPTURE insts in re
        // 2 => implicit ( and ) for whole match $0
        this.numCap = 2;
    }
    // Returns the instruction at the specified pc.
    // Precondition: pc > 0 && pc < numInst().
    getInst(pc) {
        return this.inst[pc];
    }
    // Returns the number of instructions in this program.
    numInst() {
        return this.inst.length;
    }
    // Adds a new instruction to this program, with operator |op| and |pc| equal
    // to |numInst()|.
    addInst(op) {
        this.inst.push(new $4f6bfbff25a5c30c$var$Inst(op));
    }
    // skipNop() follows any no-op or capturing instructions and returns the
    // resulting instruction.
    skipNop(pc) {
        let i = this.inst[pc];
        while(i.op === $4f6bfbff25a5c30c$var$Inst.NOP || i.op === $4f6bfbff25a5c30c$var$Inst.CAPTURE){
            i = this.inst[pc];
            pc = i.out;
        }
        return i;
    }
    // prefix() returns a pair of a literal string that all matches for the
    // regexp must start with, and a boolean which is true if the prefix is the
    // entire match.  The string is returned by appending to |prefix|.
    prefix() {
        let prefix = '';
        let i = this.skipNop(this.start);
        if (!$4f6bfbff25a5c30c$var$Inst.isRuneOp(i.op) || i.runes.length !== 1) return [
            i.op === $4f6bfbff25a5c30c$var$Inst.MATCH,
            prefix
        ];
        while($4f6bfbff25a5c30c$var$Inst.isRuneOp(i.op) && i.runes.length === 1 && (i.arg & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) === 0){
            prefix += String.fromCodePoint(i.runes[0]);
            i = this.skipNop(i.out);
        }
        return [
            i.op === $4f6bfbff25a5c30c$var$Inst.MATCH,
            prefix
        ];
    }
    // startCond() returns the leading empty-width conditions that must be true
    // in any match.  It returns -1 (all bits set) if no matches are possible.
    startCond() {
        let flag = 0;
        let pc = this.start;
        loop: for(;;){
            const i = this.inst[pc];
            switch(i.op){
                case $4f6bfbff25a5c30c$var$Inst.EMPTY_WIDTH:
                    flag |= i.arg;
                    break;
                case $4f6bfbff25a5c30c$var$Inst.FAIL:
                    return -1;
                case $4f6bfbff25a5c30c$var$Inst.CAPTURE:
                case $4f6bfbff25a5c30c$var$Inst.NOP:
                    break;
                default:
                    break loop;
            }
            pc = i.out;
        }
        return flag;
    }
    // --- Patch list ---
    // A patchlist is a list of instruction pointers that need to be filled in
    // (patched).  Because the pointers haven't been filled in yet, we can reuse
    // their storage to hold the list.  It's kind of sleazy, but works well in
    // practice.  See http://swtch.com/~rsc/regexp/regexp1.html for inspiration.
    // These aren't really pointers: they're integers, so we can reinterpret them
    // this way without using package unsafe.  A value l denotes p.inst[l>>1].out
    // (l&1==0) or .arg (l&1==1).  l == 0 denotes the empty list, okay because we
    // start every program with a fail instruction, so we'll never want to point
    // at its output link.
    next(l) {
        const i = this.inst[l >> 1];
        if ((l & 1) === 0) return i.out;
        return i.arg;
    }
    patch(l, val) {
        while(l !== 0){
            const i = this.inst[l >> 1];
            if ((l & 1) === 0) {
                l = i.out;
                i.out = val;
            } else {
                l = i.arg;
                i.arg = val;
            }
        }
    }
    append(l1, l2) {
        if (l1 === 0) return l2;
        if (l2 === 0) return l1;
        let last = l1;
        for(;;){
            const next = this.next(last);
            if (next === 0) break;
            last = next;
        }
        const i = this.inst[last >> 1];
        if ((last & 1) === 0) i.out = l2;
        else i.arg = l2;
        return l1;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        let out = '';
        for(let pc = 0; pc < this.inst.length; pc++){
            const len = out.length;
            out += pc;
            if (pc === this.start) out += '*';
            out += '        '.substring(out.length - len);
            out += this.inst[pc];
            out += '\n';
        }
        return out;
    }
}
/**
 * A fragment of a compiled regular expression program.
 *
 * @see http://swtch.com/~rsc/regexp/regexp1.html
 * @class
 */ class $4f6bfbff25a5c30c$var$Frag {
    constructor(i = 0, out = 0, nullable = false){
        this.i = i; // an instruction address (pc).
        this.out = out; // a patch list; see explanation in Prog.js
        this.nullable = nullable; // whether the fragment can match the empty string
    }
}
/**
 * Compiler from {@code Regexp} (RE2 abstract syntax) to {@code RE2} (compiled regular expression).
 *
 * The only entry point is {@link #compileRegexp}.
 */ class $4f6bfbff25a5c30c$var$Compiler {
    static ANY_RUNE_NOT_NL() {
        return [
            0,
            $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n') - 1,
            $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n') + 1,
            $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE
        ];
    }
    static ANY_RUNE() {
        return [
            0,
            $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE
        ];
    }
    static compileRegexp(re) {
        const c = new $4f6bfbff25a5c30c$var$Compiler();
        const f = c.compile(re);
        c.prog.patch(f.out, c.newInst($4f6bfbff25a5c30c$var$Inst.MATCH).i);
        c.prog.start = f.i;
        return c.prog;
    }
    constructor(){
        this.prog = new $4f6bfbff25a5c30c$var$Prog();
        this.newInst($4f6bfbff25a5c30c$var$Inst.FAIL);
    }
    newInst(op) {
        this.prog.addInst(op);
        return new $4f6bfbff25a5c30c$var$Frag(this.prog.numInst() - 1, 0, true);
    }
    // Returns a no-op fragment.  Sometimes unavoidable.
    nop() {
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.NOP);
        f.out = f.i << 1;
        return f;
    }
    fail() {
        return new $4f6bfbff25a5c30c$var$Frag();
    }
    // Given fragment a, returns (a) capturing as \n.
    // Given a fragment a, returns a fragment with capturing parens around a.
    cap(arg) {
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.CAPTURE);
        f.out = f.i << 1;
        this.prog.getInst(f.i).arg = arg;
        if (this.prog.numCap < arg + 1) this.prog.numCap = arg + 1;
        return f;
    }
    // Given fragments a and b, returns ab; a|b
    cat(f1, f2) {
        // concat of failure is failure
        if (f1.i === 0 || f2.i === 0) return this.fail();
        // eslint-disable-next-line no-warning-comments
        // TODO(rsc): elide nop
        this.prog.patch(f1.out, f2.i);
        return new $4f6bfbff25a5c30c$var$Frag(f1.i, f2.out, f1.nullable && f2.nullable);
    }
    // Given fragments for a and b, returns fragment for a|b.
    alt(f1, f2) {
        // alt of failure is other
        if (f1.i === 0) return f2;
        if (f2.i === 0) return f1;
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        i.out = f1.i;
        i.arg = f2.i;
        f.out = this.prog.append(f1.out, f2.out);
        f.nullable = f1.nullable || f2.nullable;
        return f;
    }
    // loop returns the fragment for the main loop of a plus or star.
    // For plus, it can be used directly. with f1.i as the entry.
    // For star, it can be used directly when f1 can't match an empty string.
    // (When f1 can match an empty string, f1* must be implemented as (f1+)?
    // to get the priority match order correct.)
    loop(f1, nongreedy) {
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = f.i << 1;
        } else {
            i.out = f1.i;
            f.out = f.i << 1 | 1;
        }
        this.prog.patch(f1.out, f.i);
        return f;
    }
    // Given a fragment for a, returns a fragment for a? or a?? (if nongreedy)
    quest(f1, nongreedy) {
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = f.i << 1;
        } else {
            i.out = f1.i;
            f.out = f.i << 1 | 1;
        }
        f.out = this.prog.append(f.out, f1.out);
        return f;
    }
    // Given a fragment a, returns a fragment for a* or a*? (if nongreedy)
    star(f1, nongreedy) {
        if (f1.nullable) return this.quest(this.plus(f1, nongreedy), nongreedy);
        return this.loop(f1, nongreedy);
    }
    // Given a fragment for a, returns a fragment for a+ or a+? (if nongreedy)
    plus(f1, nongreedy) {
        return new $4f6bfbff25a5c30c$var$Frag(f1.i, this.loop(f1, nongreedy).out, f1.nullable);
    }
    // op is a bitmask of EMPTY_* flags.
    empty(op) {
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.EMPTY_WIDTH);
        this.prog.getInst(f.i).arg = op;
        f.out = f.i << 1;
        return f;
    }
    // flags : parser flags
    rune(runes, flags) {
        const f = this.newInst($4f6bfbff25a5c30c$var$Inst.RUNE);
        f.nullable = false;
        const i = this.prog.getInst(f.i);
        i.runes = runes;
        flags &= $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE;
        if (runes.length !== 1 || $4f6bfbff25a5c30c$var$Unicode.simpleFold(runes[0]) === runes[0]) flags &= ~$4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE;
        i.arg = flags;
        f.out = f.i << 1;
        if ((flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) === 0 && runes.length === 1 || runes.length === 2 && runes[0] === runes[1]) i.op = $4f6bfbff25a5c30c$var$Inst.RUNE1;
        else if (runes.length === 2 && runes[0] === 0 && runes[1] === $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) i.op = $4f6bfbff25a5c30c$var$Inst.RUNE_ANY;
        else if (runes.length === 4 && runes[0] === 0 && runes[1] === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n') - 1 && runes[2] === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n') + 1 && runes[3] === $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) i.op = $4f6bfbff25a5c30c$var$Inst.RUNE_ANY_NOT_NL;
        return f;
    }
    compile(re) {
        switch(re.op){
            case $4f6bfbff25a5c30c$var$Regexp.Op.NO_MATCH:
                return this.fail();
            case $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH:
                return this.nop();
            case $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL:
                if (re.runes.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let r of re.runes){
                        const f1 = this.rune([
                            r
                        ], re.flags);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS:
                return this.rune(re.runes, re.flags);
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL:
                return this.rune($4f6bfbff25a5c30c$var$Compiler.ANY_RUNE_NOT_NL(), 0);
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR:
                return this.rune($4f6bfbff25a5c30c$var$Compiler.ANY_RUNE(), 0);
            case $4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_LINE:
                return this.empty($4f6bfbff25a5c30c$var$Utils.EMPTY_BEGIN_LINE);
            case $4f6bfbff25a5c30c$var$Regexp.Op.END_LINE:
                return this.empty($4f6bfbff25a5c30c$var$Utils.EMPTY_END_LINE);
            case $4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_TEXT:
                return this.empty($4f6bfbff25a5c30c$var$Utils.EMPTY_BEGIN_TEXT);
            case $4f6bfbff25a5c30c$var$Regexp.Op.END_TEXT:
                return this.empty($4f6bfbff25a5c30c$var$Utils.EMPTY_END_TEXT);
            case $4f6bfbff25a5c30c$var$Regexp.Op.WORD_BOUNDARY:
                return this.empty($4f6bfbff25a5c30c$var$Utils.EMPTY_WORD_BOUNDARY);
            case $4f6bfbff25a5c30c$var$Regexp.Op.NO_WORD_BOUNDARY:
                return this.empty($4f6bfbff25a5c30c$var$Utils.EMPTY_NO_WORD_BOUNDARY);
            case $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE:
                {
                    const bra = this.cap(re.cap << 1);
                    const sub = this.compile(re.subs[0]);
                    const ket = this.cap(re.cap << 1 | 1);
                    return this.cat(this.cat(bra, sub), ket);
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.STAR:
                return this.star(this.compile(re.subs[0]), (re.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) !== 0);
            case $4f6bfbff25a5c30c$var$Regexp.Op.PLUS:
                return this.plus(this.compile(re.subs[0]), (re.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) !== 0);
            case $4f6bfbff25a5c30c$var$Regexp.Op.QUEST:
                return this.quest(this.compile(re.subs[0]), (re.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) !== 0);
            case $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.alt(f, f1);
                    }
                    return f;
                }
            default:
                throw new $4f6bfbff25a5c30c$export$457eacef9ada3821('regexp: unhandled case in compile');
        }
    }
}
class $4f6bfbff25a5c30c$var$Simplify {
    // Simplify returns a regexp equivalent to re but without counted
    // repetitions and with various other simplifications, such as
    // rewriting /(?:a+)+/ to /a+/.  The resulting regexp will execute
    // correctly but its string representation will not produce the same
    // parse tree, because capturing parentheses may have been duplicated
    // or removed.  For example, the simplified form for /(x){1,2}/ is
    // /(x)(x)?/ but both parentheses capture as $1.  The returned regexp
    // may share structure with or be the original.
    static simplify(re) {
        if (re === null) return null;
        switch(re.op){
            case $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE:
            case $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT:
            case $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE:
                {
                    let nre = re;
                    for(let i = 0; i < re.subs.length; i++){
                        const sub = re.subs[i];
                        const nsub = $4f6bfbff25a5c30c$var$Simplify.simplify(sub);
                        if (nre === re && nsub !== sub) {
                            nre = $4f6bfbff25a5c30c$var$Regexp.fromRegexp(re);
                            nre.runes = null;
                            nre.subs = re.subs.slice(0, re.subs.length);
                        }
                        if (nre !== re) nre.subs[i] = nsub;
                    }
                    return nre;
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.STAR:
            case $4f6bfbff25a5c30c$var$Regexp.Op.PLUS:
            case $4f6bfbff25a5c30c$var$Regexp.Op.QUEST:
                {
                    const sub = $4f6bfbff25a5c30c$var$Simplify.simplify(re.subs[0]);
                    return $4f6bfbff25a5c30c$var$Simplify.simplify1(re.op, re.flags, sub, re);
                }
            case $4f6bfbff25a5c30c$var$Regexp.Op.REPEAT:
                {
                    // Special special case: x{0} matches the empty string
                    // and doesn't even need to consider x.
                    if (re.min === 0 && re.max === 0) return new $4f6bfbff25a5c30c$var$Regexp($4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH);
                    // The fun begins.
                    const sub = $4f6bfbff25a5c30c$var$Simplify.simplify(re.subs[0]);
                    // x{n,} means at least n matches of x.
                    if (re.max === -1) {
                        // Special case: x{0,} is x*.
                        if (re.min === 0) return $4f6bfbff25a5c30c$var$Simplify.simplify1($4f6bfbff25a5c30c$var$Regexp.Op.STAR, re.flags, sub, null);
                        // Special case: x{1,} is x+.
                        if (re.min === 1) return $4f6bfbff25a5c30c$var$Simplify.simplify1($4f6bfbff25a5c30c$var$Regexp.Op.PLUS, re.flags, sub, null);
                        // General case: x{4,} is xxxx+.
                        const nre = new $4f6bfbff25a5c30c$var$Regexp($4f6bfbff25a5c30c$var$Regexp.Op.CONCAT);
                        const subs = [];
                        for(let i = 0; i < re.min - 1; i++)subs.push(sub);
                        subs.push($4f6bfbff25a5c30c$var$Simplify.simplify1($4f6bfbff25a5c30c$var$Regexp.Op.PLUS, re.flags, sub, null));
                        nre.subs = subs.slice(0);
                        return nre;
                    }
                    // Special case x{0} handled above.
                    // Special case: x{1} is just x.
                    if (re.min === 1 && re.max === 1) return sub;
                    // General case: x{n,m} means n copies of x and m copies of x?
                    // The machine will do less work if we nest the final m copies,
                    // so that x{2,5} = xx(x(x(x)?)?)?
                    // Build leading prefix: xx.
                    let prefixSubs = null;
                    if (re.min > 0) {
                        prefixSubs = [];
                        for(let i = 0; i < re.min; i++)prefixSubs.push(sub);
                    }
                    // Build and attach suffix: (x(x(x)?)?)?
                    if (re.max > re.min) {
                        let suffix = $4f6bfbff25a5c30c$var$Simplify.simplify1($4f6bfbff25a5c30c$var$Regexp.Op.QUEST, re.flags, sub, null);
                        for(let i = re.min + 1; i < re.max; i++){
                            const nre2 = new $4f6bfbff25a5c30c$var$Regexp($4f6bfbff25a5c30c$var$Regexp.Op.CONCAT);
                            nre2.subs = [
                                sub,
                                suffix
                            ];
                            suffix = $4f6bfbff25a5c30c$var$Simplify.simplify1($4f6bfbff25a5c30c$var$Regexp.Op.QUEST, re.flags, nre2, null);
                        }
                        if (prefixSubs === null) return suffix;
                        prefixSubs.push(suffix);
                    }
                    if (prefixSubs !== null) {
                        const prefix = new $4f6bfbff25a5c30c$var$Regexp($4f6bfbff25a5c30c$var$Regexp.Op.CONCAT);
                        prefix.subs = prefixSubs.slice(0);
                        return prefix;
                    }
                    // Some degenerate case like min > max or min < max < 0.
                    // Handle as impossible match.
                    return new $4f6bfbff25a5c30c$var$Regexp($4f6bfbff25a5c30c$var$Regexp.Op.NO_MATCH);
                }
        }
        return re;
    }
    // simplify1 implements Simplify for the unary OpStar,
    // OpPlus, and OpQuest operators.  It returns the simple regexp
    // equivalent to
    //
    //      Regexp{Op: op, Flags: flags, Sub: {sub}}
    //
    // under the assumption that sub is already simple, and
    // without first allocating that structure.  If the regexp
    // to be returned turns out to be equivalent to re, simplify1
    // returns re instead.
    //
    // simplify1 is factored out of Simplify because the implementation
    // for other operators generates these unary expressions.
    // Letting them call simplify1 makes sure the expressions they
    // generate are simple.
    static simplify1(op, flags, sub, re) {
        // Special case: repeat the empty string as much as
        // you want, but it's still the empty string.
        if (sub.op === $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH) return sub;
        // The operators are idempotent if the flags match.
        if (op === sub.op && (flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) === (sub.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY)) return sub;
        if (re !== null && re.op === op && (re.flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) === (flags & $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY) && sub === re.subs[0]) return re;
        re = new $4f6bfbff25a5c30c$var$Regexp(op);
        re.flags = flags;
        re.subs = [
            sub
        ];
        return re;
    }
}
// GENERATED BY tools/scripts/make_perl_groups.pl; DO NOT EDIT.
// ./tools/scripts/make_perl_groups.pl  > src/CharGroup.js
class $4f6bfbff25a5c30c$var$CharGroup {
    constructor(sign, cls){
        this.sign = sign;
        this.cls = cls;
    }
}
const $4f6bfbff25a5c30c$var$code1 = [
    0x30,
    0x39
];
const $4f6bfbff25a5c30c$var$code2 = [
    0x9,
    0xa,
    0xc,
    0xd,
    0x20,
    0x20
];
const $4f6bfbff25a5c30c$var$code3 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x5f,
    0x5f,
    0x61,
    0x7a
];
const $4f6bfbff25a5c30c$var$PERL_GROUPS = new Map([
    [
        '\\d',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code1)
    ],
    [
        '\\D',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code1)
    ],
    [
        '\\s',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code2)
    ],
    [
        '\\S',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code2)
    ],
    [
        '\\w',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code3)
    ],
    [
        '\\W',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code3)
    ]
]);
const $4f6bfbff25a5c30c$var$code4 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x61,
    0x7a
];
const $4f6bfbff25a5c30c$var$code5 = [
    0x41,
    0x5a,
    0x61,
    0x7a
];
const $4f6bfbff25a5c30c$var$code6 = [
    0x0,
    0x7f
];
const $4f6bfbff25a5c30c$var$code7 = [
    0x9,
    0x9,
    0x20,
    0x20
];
const $4f6bfbff25a5c30c$var$code8 = [
    0x0,
    0x1f,
    0x7f,
    0x7f
];
const $4f6bfbff25a5c30c$var$code9 = [
    0x30,
    0x39
];
const $4f6bfbff25a5c30c$var$code10 = [
    0x21,
    0x7e
];
const $4f6bfbff25a5c30c$var$code11 = [
    0x61,
    0x7a
];
const $4f6bfbff25a5c30c$var$code12 = [
    0x20,
    0x7e
];
const $4f6bfbff25a5c30c$var$code13 = [
    0x21,
    0x2f,
    0x3a,
    0x40,
    0x5b,
    0x60,
    0x7b,
    0x7e
];
const $4f6bfbff25a5c30c$var$code14 = [
    0x9,
    0xd,
    0x20,
    0x20
];
const $4f6bfbff25a5c30c$var$code15 = [
    0x41,
    0x5a
];
const $4f6bfbff25a5c30c$var$code16 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x5f,
    0x5f,
    0x61,
    0x7a
];
const $4f6bfbff25a5c30c$var$code17 = [
    0x30,
    0x39,
    0x41,
    0x46,
    0x61,
    0x66
];
const $4f6bfbff25a5c30c$var$POSIX_GROUPS = new Map([
    [
        '[:alnum:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code4)
    ],
    [
        '[:^alnum:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code4)
    ],
    [
        '[:alpha:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code5)
    ],
    [
        '[:^alpha:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code5)
    ],
    [
        '[:ascii:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code6)
    ],
    [
        '[:^ascii:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code6)
    ],
    [
        '[:blank:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code7)
    ],
    [
        '[:^blank:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code7)
    ],
    [
        '[:cntrl:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code8)
    ],
    [
        '[:^cntrl:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code8)
    ],
    [
        '[:digit:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code9)
    ],
    [
        '[:^digit:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code9)
    ],
    [
        '[:graph:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code10)
    ],
    [
        '[:^graph:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code10)
    ],
    [
        '[:lower:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code11)
    ],
    [
        '[:^lower:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code11)
    ],
    [
        '[:print:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code12)
    ],
    [
        '[:^print:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code12)
    ],
    [
        '[:punct:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code13)
    ],
    [
        '[:^punct:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code13)
    ],
    [
        '[:space:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code14)
    ],
    [
        '[:^space:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code14)
    ],
    [
        '[:upper:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code15)
    ],
    [
        '[:^upper:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code15)
    ],
    [
        '[:word:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code16)
    ],
    [
        '[:^word:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code16)
    ],
    [
        '[:xdigit:]',
        new $4f6bfbff25a5c30c$var$CharGroup(1, $4f6bfbff25a5c30c$var$code17)
    ],
    [
        '[:^xdigit:]',
        new $4f6bfbff25a5c30c$var$CharGroup(-1, $4f6bfbff25a5c30c$var$code17)
    ]
]);
/**
 * A "builder"-style helper class for manipulating character classes represented as an array of
 * pairs of runes [lo, hi], each denoting an inclusive interval.
 *
 * All methods mutate the internal state and return {@code this}, allowing operations to be chained.
 */ class $4f6bfbff25a5c30c$var$CharClass {
    // Exposed, since useful for debugging CharGroups too.
    static charClassToString(r, len) {
        let result = '[';
        for(let i = 0; i < len; i += 2){
            if (i > 0) result += ' ';
            const lo = r[i];
            const hi = r[i + 1];
            if (lo === hi) result += `0x${lo.toString(16)}`;
            else result += `0x${lo.toString(16)}-0x${hi.toString(16)}`;
        }
        result += ']';
        return result;
    }
    // cmp() returns the ordering of the pair (a[i], a[i+1]) relative to
    // (pivotFrom, pivotTo), where the first component of the pair (lo) is
    // ordered naturally and the second component (hi) is in reverse order.
    static cmp(array, i, pivotFrom, pivotTo) {
        const cmp = array[i] - pivotFrom;
        return cmp !== 0 ? cmp : pivotTo - array[i + 1];
    }
    // qsortIntPair() quicksorts pairs of ints in |array| according to lt().
    // Precondition: |left|, |right|, |this.len| must all be even; |this.len > 1|.
    static qsortIntPair(array, left, right) {
        const pivotIndex = ((left + right) / 2 | 0) & -2;
        const pivotFrom = array[pivotIndex];
        const pivotTo = array[pivotIndex + 1];
        let i = left;
        let j = right;
        while(i <= j){
            while(i < right && $4f6bfbff25a5c30c$var$CharClass.cmp(array, i, pivotFrom, pivotTo) < 0)i += 2;
            while(j > left && $4f6bfbff25a5c30c$var$CharClass.cmp(array, j, pivotFrom, pivotTo) > 0)j -= 2;
            if (i <= j) {
                if (i !== j) {
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                    temp = array[i + 1];
                    array[i + 1] = array[j + 1];
                    array[j + 1] = temp;
                }
                i += 2;
                j -= 2;
            }
        }
        if (left < j) $4f6bfbff25a5c30c$var$CharClass.qsortIntPair(array, left, j);
        if (i < right) $4f6bfbff25a5c30c$var$CharClass.qsortIntPair(array, i, right);
    }
    constructor(r = $4f6bfbff25a5c30c$var$Utils.emptyInts()){
        this.r = r; // inclusive ranges, pairs of [lo,hi].  r.length is even.
        this.len = r.length; // prefix of |r| that is defined.  Even.
    }
    // Returns the character class as an int array.  Subsequent CharClass
    // operations may mutate this array, so typically this is the last operation
    // performed on a given CharClass instance.
    toArray() {
        if (this.len === this.r.length) return this.r;
        else return this.r.slice(0, this.len);
    }
    // cleanClass() sorts the ranges (pairs of elements) of this CharClass,
    // merges them, and eliminates duplicates.
    cleanClass() {
        if (this.len < 4) return this;
        // Sort by lo increasing, hi decreasing to break ties.
        $4f6bfbff25a5c30c$var$CharClass.qsortIntPair(this.r, 0, this.len - 2);
        // Merge abutting, overlapping.
        let w = 2; // write index
        for(let i = 2; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (lo <= this.r[w - 1] + 1) {
                // merge with previous range
                if (hi > this.r[w - 1]) this.r[w - 1] = hi;
                continue;
            }
            // new disjoint range
            this.r[w] = lo;
            this.r[w + 1] = hi;
            w += 2;
        }
        this.len = w;
        return this;
    }
    // appendLiteral() appends the literal |x| to this CharClass.
    appendLiteral(x, flags) {
        return (flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0 ? this.appendFoldedRange(x, x) : this.appendRange(x, x);
    }
    // appendRange() appends the range [lo-hi] (inclusive) to this CharClass.
    appendRange(lo, hi) {
        // Expand last range or next to last range if it overlaps or abuts.
        // Checking two ranges helps when appending case-folded
        // alphabets, so that one range can be expanding A-Z and the
        // other expanding a-z.
        if (this.len > 0) {
            for(let i = 2; i <= 4; i += 2)// twice, using i=2, i=4
            if (this.len >= i) {
                const rlo = this.r[this.len - i];
                const rhi = this.r[this.len - i + 1];
                if (lo <= rhi + 1 && rlo <= hi + 1) {
                    if (lo < rlo) this.r[this.len - i] = lo;
                    if (hi > rhi) this.r[this.len - i + 1] = hi;
                    return this;
                }
            }
        }
        this.r[this.len++] = lo;
        this.r[this.len++] = hi;
        return this;
    }
    // appendFoldedRange() appends the range [lo-hi] and its case
    // folding-equivalent runes to this CharClass.
    appendFoldedRange(lo, hi) {
        // Optimizations.
        if (lo <= $4f6bfbff25a5c30c$var$Unicode.MIN_FOLD && hi >= $4f6bfbff25a5c30c$var$Unicode.MAX_FOLD) // Range is full: folding can't add more.
        return this.appendRange(lo, hi);
        if (hi < $4f6bfbff25a5c30c$var$Unicode.MIN_FOLD || lo > $4f6bfbff25a5c30c$var$Unicode.MAX_FOLD) // Range is outside folding possibilities.
        return this.appendRange(lo, hi);
        if (lo < $4f6bfbff25a5c30c$var$Unicode.MIN_FOLD) {
            // [lo, minFold-1] needs no folding.
            this.appendRange(lo, $4f6bfbff25a5c30c$var$Unicode.MIN_FOLD - 1);
            lo = $4f6bfbff25a5c30c$var$Unicode.MIN_FOLD;
        }
        if (hi > $4f6bfbff25a5c30c$var$Unicode.MAX_FOLD) {
            // [maxFold+1, hi] needs no folding.
            this.appendRange($4f6bfbff25a5c30c$var$Unicode.MAX_FOLD + 1, hi);
            hi = $4f6bfbff25a5c30c$var$Unicode.MAX_FOLD;
        }
        // Brute force.  Depend on appendRange to coalesce ranges on the fly.
        for(let c = lo; c <= hi; c++){
            this.appendRange(c, c);
            for(let f = $4f6bfbff25a5c30c$var$Unicode.simpleFold(c); f !== c; f = $4f6bfbff25a5c30c$var$Unicode.simpleFold(f))this.appendRange(f, f);
        }
        return this;
    }
    // appendClass() appends the class |x| to this CharClass.
    // It assumes |x| is clean.  Does not mutate |x|.
    appendClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendRange(x[i], x[i + 1]);
        return this;
    }
    // appendFoldedClass() appends the case folding of the class |x| to this
    // CharClass.  Does not mutate |x|.
    appendFoldedClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendFoldedRange(x[i], x[i + 1]);
        return this;
    }
    // appendNegatedClass() append the negation of the class |x| to this
    // CharClass.  It assumes |x| is clean.  Does not mutate |x|.
    appendNegatedClass(x) {
        let nextLo = 0;
        for(let i = 0; i < x.length; i += 2){
            const lo = x[i];
            const hi = x[i + 1];
            if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
            nextLo = hi + 1;
        }
        if (nextLo <= $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE);
        return this;
    }
    // appendTable() appends the Unicode range table |table| to this CharClass.
    // Does not mutate |table|.
    appendTable(table) {
        for (let triple of table){
            const lo = triple[0];
            const hi = triple[1];
            const stride = triple[2];
            if (stride === 1) {
                this.appendRange(lo, hi);
                continue;
            }
            for(let c = lo; c <= hi; c += stride)this.appendRange(c, c);
        }
        return this;
    }
    // appendNegatedTable() returns the result of appending the negation of range
    // table |table| to this CharClass.  Does not mutate |table|.
    appendNegatedTable(table) {
        let nextLo = 0;
        for (let triple of table){
            const lo = triple[0];
            const hi = triple[1];
            const stride = triple[2];
            if (stride === 1) {
                if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
                nextLo = hi + 1;
                continue;
            }
            for(let c = lo; c <= hi; c += stride){
                if (nextLo <= c - 1) this.appendRange(nextLo, c - 1);
                nextLo = c + 1;
            }
        }
        if (nextLo <= $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) this.appendRange(nextLo, $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE);
        return this;
    }
    // appendTableWithSign() calls append{,Negated}Table depending on sign.
    // Does not mutate |table|.
    appendTableWithSign(table, sign) {
        return sign < 0 ? this.appendNegatedTable(table) : this.appendTable(table);
    }
    // negateClass() negates this CharClass, which must already be clean.
    negateClass() {
        let nextLo = 0; // lo end of next class to add
        let w = 0; // write index
        for(let i = 0; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (nextLo <= lo - 1) {
                this.r[w] = nextLo;
                this.r[w + 1] = lo - 1;
                w += 2;
            }
            nextLo = hi + 1;
        }
        this.len = w;
        if (nextLo <= $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) {
            this.r[this.len++] = nextLo;
            this.r[this.len++] = $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE;
        }
        return this;
    }
    // appendClassWithSign() calls appendClass() if sign is +1 or
    // appendNegatedClass if sign is -1.  Does not mutate |x|.
    appendClassWithSign(x, sign) {
        return sign < 0 ? this.appendNegatedClass(x) : this.appendClass(x);
    }
    // appendGroup() appends CharGroup |g| to this CharClass, folding iff
    // |foldCase|.  Does not mutate |g|.
    appendGroup(g, foldCase) {
        let cls = g.cls;
        if (foldCase) cls = new $4f6bfbff25a5c30c$var$CharClass().appendFoldedClass(cls).cleanClass().toArray();
        return this.appendClassWithSign(cls, g.sign);
    }
    toString() {
        return $4f6bfbff25a5c30c$var$CharClass.charClassToString(this.r, this.len);
    }
}
class $4f6bfbff25a5c30c$var$Pair {
    static of(first, second) {
        return new $4f6bfbff25a5c30c$var$Pair(first, second);
    }
    constructor(first, second){
        this.first = first;
        this.second = second;
    }
}
// StringIterator: a stream of runes with an opaque cursor, permitting
// rewinding.  The units of the cursor are not specified beyond the
// fact that ASCII characters are single width.  (Cursor positions
// could be UTF-8 byte indices, UTF-16 code indices or rune indices.)
//
// In particular, be careful with:
// - skip: only use this to advance over ASCII characters
//   since these always have a width of 1.
// - skipString: only use this to advance over strings which are
//   known to be at the current position, e.g. due to prior call to
//   lookingAt().
// Only use pop() to advance over possibly non-ASCII runes.
class $4f6bfbff25a5c30c$var$StringIterator {
    constructor(str){
        this.str = str;
        this.position = 0;
    }
    // Returns the cursor position.  Do not interpret the result!
    pos() {
        return this.position;
    }
    // Resets the cursor position to a previous value returned by pos().
    rewindTo(pos) {
        this.position = pos;
    }
    // Returns true unless the stream is exhausted.
    more() {
        return this.position < this.str.length;
    }
    // Returns the rune at the cursor position.
    // Precondition: |more()|.
    peek() {
        return this.str.codePointAt(this.position);
    }
    // Advances the cursor by |n| positions, which must be ASCII runes.
    //
    // (In practise, this is only ever used to skip over regexp
    // metacharacters that are ASCII, so there is no numeric difference
    // between indices into  UTF-8 bytes, UTF-16 codes and runes.)
    skip(n) {
        this.position += n;
    }
    // Advances the cursor by the number of cursor positions in |s|.
    skipString(s) {
        this.position += s.length;
    }
    // Returns the rune at the cursor position, and advances the cursor
    // past it.  Precondition: |more()|.
    pop() {
        const r = this.str.codePointAt(this.position);
        this.position += $4f6bfbff25a5c30c$var$Utils.charCount(r);
        return r;
    }
    lookingAt(s) {
        return this.rest().startsWith(s);
    }
    // Returns the rest of the pattern as a Java UTF-16 string.
    rest() {
        return this.str.substring(this.position);
    }
    // Returns the substring from |beforePos| to the current position.
    // |beforePos| must have been previously returned by |pos()|.
    from(beforePos) {
        return this.str.substring(beforePos, this.position);
    }
    toString() {
        return this.rest();
    }
}
/**
 * A parser of regular expression patterns.
 *
 * The only public entry point is {@link #parse(String pattern, int flags)}.
 */ class $4f6bfbff25a5c30c$var$Parser {
    // Unexpected error
    static ERR_INTERNAL_ERROR = 'regexp/syntax: internal error';
    // Parse errors
    static ERR_INVALID_CHAR_RANGE = 'invalid character class range';
    static ERR_INVALID_ESCAPE = 'invalid escape sequence';
    static ERR_INVALID_NAMED_CAPTURE = 'invalid named capture';
    static ERR_INVALID_PERL_OP = 'invalid or unsupported Perl syntax';
    static ERR_INVALID_REPEAT_OP = 'invalid nested repetition operator';
    static ERR_INVALID_REPEAT_SIZE = 'invalid repeat count';
    static ERR_MISSING_BRACKET = 'missing closing ]';
    static ERR_MISSING_PAREN = 'missing closing )';
    static ERR_MISSING_REPEAT_ARGUMENT = 'missing argument to repetition operator';
    static ERR_TRAILING_BACKSLASH = 'trailing backslash at end of expression';
    static ERR_DUPLICATE_NAMED_CAPTURE = 'duplicate capture group name';
    // RangeTables are represented as int[][], a list of triples (start, end,
    // stride).
    static ANY_TABLE() {
        return [
            [
                0,
                $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE,
                1
            ]
        ];
    }
    // unicodeTable() returns the Unicode RangeTable identified by name
    // and the table of additional fold-equivalent code points.
    // Returns null if |name| does not identify a Unicode character range.
    static unicodeTable(name) {
        if (name === 'Any') return $4f6bfbff25a5c30c$var$Pair.of($4f6bfbff25a5c30c$var$Parser.ANY_TABLE(), $4f6bfbff25a5c30c$var$Parser.ANY_TABLE());
        if ($4f6bfbff25a5c30c$var$UnicodeTables.CATEGORIES.has(name)) return $4f6bfbff25a5c30c$var$Pair.of($4f6bfbff25a5c30c$var$UnicodeTables.CATEGORIES.get(name), $4f6bfbff25a5c30c$var$UnicodeTables.FOLD_CATEGORIES.get(name));
        if ($4f6bfbff25a5c30c$var$UnicodeTables.SCRIPTS.has(name)) return $4f6bfbff25a5c30c$var$Pair.of($4f6bfbff25a5c30c$var$UnicodeTables.SCRIPTS.get(name), $4f6bfbff25a5c30c$var$UnicodeTables.FOLD_SCRIPT.get(name));
        return null;
    }
    // minFoldRune returns the minimum rune fold-equivalent to r.
    static minFoldRune(r) {
        if (r < $4f6bfbff25a5c30c$var$Unicode.MIN_FOLD || r > $4f6bfbff25a5c30c$var$Unicode.MAX_FOLD) return r;
        let min = r;
        const r0 = r;
        for(r = $4f6bfbff25a5c30c$var$Unicode.simpleFold(r); r !== r0; r = $4f6bfbff25a5c30c$var$Unicode.simpleFold(r))if (min > r) min = r;
        return min;
    }
    // leadingRegexp returns the leading regexp that re begins with.
    // The regexp refers to storage in re or its children.
    static leadingRegexp(re) {
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH) return null;
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            const sub = re.subs[0];
            if (sub.op === $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH) return null;
            return sub;
        }
        return re;
    }
    static literalRegexp(s, flags) {
        const re = new $4f6bfbff25a5c30c$var$Regexp($4f6bfbff25a5c30c$var$Regexp.Op.LITERAL);
        re.flags = flags;
        re.runes = $4f6bfbff25a5c30c$var$Utils.stringToRunes(s);
        return re;
    }
    /**
   * Parse regular expression pattern {@code pattern} with mode flags {@code flags}.
   * @param {string} pattern
   * @param {number} flags
   */ static parse(pattern, flags) {
        return new $4f6bfbff25a5c30c$var$Parser(pattern, flags).parseInternal();
    }
    // parseRepeat parses {min} (max=min) or {min,} (max=-1) or {min,max}.
    // If |t| is not of that form, it returns -1.
    // If |t| has the right form but the values are negative or too big,
    // it returns -2.
    // On success, returns a nonnegative number encoding min/max in the
    // high/low signed halfwords of the result.  (Note: min >= 0; max may
    // be -1.)
    //
    // On success, advances |t| beyond the repeat; otherwise |t.pos()| is
    // undefined.
    static parseRepeat(t) {
        const start = t.pos();
        if (!t.more() || !t.lookingAt('{')) return -1;
        t.skip(1);
        const min = $4f6bfbff25a5c30c$var$Parser.parseInt(t);
        if (min === -1) return -1;
        if (!t.more()) return -1;
        let max;
        if (!t.lookingAt(',')) max = min;
        else {
            t.skip(1);
            if (!t.more()) return -1;
            if (t.lookingAt('}')) max = -1;
            else if ((max = $4f6bfbff25a5c30c$var$Parser.parseInt(t)) === -1) return -1;
        }
        if (!t.more() || !t.lookingAt('}')) return -1;
        t.skip(1);
        if (min < 0 || min > 1000 || max === -2 || max > 1000 || max >= 0 && min > max) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_REPEAT_SIZE, t.from(start));
        return min << 16 | max & $4f6bfbff25a5c30c$var$Unicode.MAX_BMP;
    }
    // isValidCaptureName reports whether name
    // is a valid capture name: [A-Za-z0-9_]+.
    // PCRE limits names to 32 bytes.
    // Python rejects names starting with digits.
    // We don't enforce either of those.
    static isValidCaptureName(name) {
        if (name.length === 0) return false;
        for(let i = 0; i < name.length; i++){
            const c = name.codePointAt(i);
            if (c !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('_') && !$4f6bfbff25a5c30c$var$Utils.isalnum(c)) return false;
        }
        return true;
    }
    // parseInt parses a nonnegative decimal integer.
    // -1 => bad format.  -2 => format ok, but integer overflow.
    static parseInt(t) {
        const start = t.pos();
        while(t.more() && t.peek() >= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') && t.peek() <= $4f6bfbff25a5c30c$var$Codepoint.CODES.get('9'))t.skip(1);
        const n = t.from(start);
        if (n.length === 0 || n.length > 1 && n.codePointAt(0) === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0')) return -1;
        if (n.length > 8) return -2;
        return parseFloat(n, 10);
    }
    // can this be represented as a character class?
    // single-rune literal string, char class, ., and .|\n.
    static isCharClass(re) {
        return re.op === $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL && re.runes.length === 1 || re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS || re.op === $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL || re.op === $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR;
    }
    // does re match r?
    static matchRune(re, r) {
        switch(re.op){
            case $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL:
                return re.runes.length === 1 && re.runes[0] === r;
            case $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS:
                for(let i = 0; i < re.runes.length; i += 2){
                    if (re.runes[i] <= r && r <= re.runes[i + 1]) return true;
                }
                return false;
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL:
                return r !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n');
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR:
                return true;
        }
        return false;
    }
    // mergeCharClass makes dst = dst|src.
    // The caller must ensure that dst.Op >= src.Op,
    // to reduce the amount of copying.
    static mergeCharClass(dst, src) {
        switch(dst.op){
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR:
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL:
                if ($4f6bfbff25a5c30c$var$Parser.matchRune(src, $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n'))) dst.op = $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR;
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS:
                if (src.op === $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL) dst.runes = new $4f6bfbff25a5c30c$var$CharClass(dst.runes).appendLiteral(src.runes[0], src.flags).toArray();
                else dst.runes = new $4f6bfbff25a5c30c$var$CharClass(dst.runes).appendClass(src.runes).toArray();
                break;
            case $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL:
                if (src.runes[0] === dst.runes[0] && src.flags === dst.flags) break;
                dst.op = $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS;
                dst.runes = new $4f6bfbff25a5c30c$var$CharClass().appendLiteral(dst.runes[0], dst.flags).appendLiteral(src.runes[0], src.flags).toArray();
                break;
        }
    }
    // parseEscape parses an escape sequence at the beginning of s
    // and returns the rune.
    // Pre: t at '\\'.  Post: after escape.
    static parseEscape(t) {
        const startPos = t.pos();
        t.skip(1); // '\\'
        if (!t.more()) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_TRAILING_BACKSLASH);
        let c = t.pop();
        bigswitch: switch(c){
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('1'):
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('2'):
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('3'):
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('4'):
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('5'):
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('6'):
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('7'):
                if (!t.more() || t.peek() < $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') || t.peek() > $4f6bfbff25a5c30c$var$Codepoint.CODES.get('7')) break;
            // eslint-disable-next-line no-fallthrough
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0'):
                {
                    let r = c - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
                    for(let i = 1; i < 3; i++){
                        if (!t.more() || t.peek() < $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0') || t.peek() > $4f6bfbff25a5c30c$var$Codepoint.CODES.get('7')) break;
                        r = r * 8 + t.peek() - $4f6bfbff25a5c30c$var$Codepoint.CODES.get('0');
                        t.skip(1);
                    }
                    return r;
                }
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('x'):
                {
                    if (!t.more()) break;
                    c = t.pop();
                    if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('{')) {
                        let nhex = 0;
                        let r = 0;
                        // eslint-disable-next-line no-constant-condition
                        while(true){
                            if (!t.more()) break bigswitch;
                            c = t.pop();
                            if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('}')) break;
                            const v = $4f6bfbff25a5c30c$var$Utils.unhex(c);
                            if (v < 0) break bigswitch;
                            r = r * 16 + v;
                            if (r > $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) break bigswitch;
                            nhex++;
                        }
                        if (nhex === 0) break bigswitch;
                        return r;
                    }
                    const x = $4f6bfbff25a5c30c$var$Utils.unhex(c);
                    if (!t.more()) break;
                    c = t.pop();
                    const y = $4f6bfbff25a5c30c$var$Utils.unhex(c);
                    if (x < 0 || y < 0) break;
                    return x * 16 + y;
                }
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('a'):
                return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\x07');
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('f'):
                return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\f');
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('n'):
                return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n');
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('r'):
                return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\r');
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('t'):
                return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\t');
            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('v'):
                return $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\v');
            default:
                if (!$4f6bfbff25a5c30c$var$Utils.isalnum(c)) return c;
                break;
        }
        throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_ESCAPE, t.from(startPos));
    }
    // parseClassChar parses a character class character and returns it.
    // wholeClassPos is the position of the start of the entire class "[...".
    // Pre: t at class char; Post: t after it.
    static parseClassChar(t, wholeClassPos) {
        if (!t.more()) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_MISSING_BRACKET, t.from(wholeClassPos));
        if (t.lookingAt('\\')) return $4f6bfbff25a5c30c$var$Parser.parseEscape(t);
        return t.pop();
    }
    static concatRunes(x, y) {
        return [
            ...x,
            ...y
        ];
    }
    constructor(wholeRegexp, flags = 0){
        this.wholeRegexp = wholeRegexp;
        // Flags control the behavior of the parser and record information about
        // regexp context.
        this.flags = flags;
        // number of capturing groups seen
        this.numCap = 0;
        this.namedGroups = {};
        // Stack of parsed expressions.
        this.stack = [];
        this.free = null;
    }
    // Allocate a Regexp, from the free list if possible.
    newRegexp(op) {
        let re = this.free;
        if (re !== null && re.subs !== null && re.subs.length > 0) {
            this.free = re.subs[0];
            re.reinit();
            re.op = op;
        } else re = new $4f6bfbff25a5c30c$var$Regexp(op);
        return re;
    }
    reuse(re) {
        if (re.subs !== null && re.subs.length > 0) re.subs[0] = this.free;
        this.free = re;
    }
    // Parse stack manipulation.
    pop() {
        return this.stack.pop();
    }
    popToPseudo() {
        const n = this.stack.length;
        let i = n;
        while(i > 0 && !$4f6bfbff25a5c30c$var$Regexp.isPseudoOp(this.stack[i - 1].op))i--;
        const r = this.stack.slice(i, n);
        this.stack = this.stack.slice(0, i);
        return r;
    }
    // push pushes the regexp re onto the parse stack and returns the regexp.
    // Returns null for a CHAR_CLASS that can be merged with the top-of-stack.
    push(re) {
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] === re.runes[1]) {
            if (this.maybeConcat(re.runes[0], this.flags & ~$4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE)) return null;
            re.op = $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags & ~$4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE;
        } else if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS && re.runes.length === 4 && re.runes[0] === re.runes[1] && re.runes[2] === re.runes[3] && $4f6bfbff25a5c30c$var$Unicode.simpleFold(re.runes[0]) === re.runes[2] && $4f6bfbff25a5c30c$var$Unicode.simpleFold(re.runes[2]) === re.runes[0] || re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] + 1 === re.runes[1] && $4f6bfbff25a5c30c$var$Unicode.simpleFold(re.runes[0]) === re.runes[1] && $4f6bfbff25a5c30c$var$Unicode.simpleFold(re.runes[1]) === re.runes[0]) {
            // Case-insensitive rune like [Aa] or [Δδ].
            if (this.maybeConcat(re.runes[0], this.flags | $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE)) return null;
            // Rewrite as (case-insensitive) literal.
            re.op = $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags | $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE;
        } else // Incremental concatenation.
        this.maybeConcat(-1, 0);
        this.stack.push(re);
        return re;
    }
    // maybeConcat implements incremental concatenation
    // of literal runes into string nodes.  The parser calls this
    // before each push, so only the top fragment of the stack
    // might need processing.  Since this is called before a push,
    // the topmost literal is no longer subject to operators like *
    // (Otherwise ab* would turn into (ab)*.)
    // If (r >= 0 and there's a node left over, maybeConcat uses it
    // to push r with the given flags.
    // maybeConcat reports whether r was pushed.
    maybeConcat(r, flags) {
        const n = this.stack.length;
        if (n < 2) return false;
        const re1 = this.stack[n - 1];
        const re2 = this.stack[n - 2];
        if (re1.op !== $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL || re2.op !== $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL || (re1.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== (re2.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE)) return false;
        // Push re1 into re2.
        re2.runes = $4f6bfbff25a5c30c$var$Parser.concatRunes(re2.runes, re1.runes);
        // Reuse re1 if possible.
        if (r >= 0) {
            re1.runes = [
                r
            ];
            re1.flags = flags;
            return true;
        }
        this.pop();
        this.reuse(re1);
        return false; // did not push r
    }
    // newLiteral returns a new LITERAL Regexp with the given flags
    newLiteral(r, flags) {
        const re = this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.LITERAL);
        re.flags = flags;
        if ((flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0) r = $4f6bfbff25a5c30c$var$Parser.minFoldRune(r);
        re.runes = [
            r
        ];
        return re;
    }
    // literal pushes a literal regexp for the rune r on the stack
    // and returns that regexp.
    literal(r) {
        this.push(this.newLiteral(r, this.flags));
    }
    // op pushes a regexp with the given op onto the stack
    // and returns that regexp.
    op(op) {
        const re = this.newRegexp(op);
        re.flags = this.flags;
        return this.push(re);
    }
    // repeat replaces the top stack element with itself repeated according to
    // op, min, max.  beforePos is the start position of the repetition operator.
    // Pre: t is positioned after the initial repetition operator.
    // Post: t advances past an optional perl-mode '?', or stays put.
    //       Or, it fails with RE2JSSyntaxException.
    repeat(op, min, max, beforePos, t, lastRepeatPos) {
        let flags = this.flags;
        if ((flags & $4f6bfbff25a5c30c$var$RE2Flags.PERL_X) !== 0) {
            if (t.more() && t.lookingAt('?')) {
                t.skip(1);
                flags ^= $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY;
            }
            if (lastRepeatPos !== -1) // In Perl it is not allowed to stack repetition operators:
            // a** is a syntax error, not a doubled star, and a++ means
            // something else entirely, which we don't support!
            throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_REPEAT_OP, t.from(lastRepeatPos));
        }
        const n = this.stack.length;
        if (n === 0) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const sub = this.stack[n - 1];
        if ($4f6bfbff25a5c30c$var$Regexp.isPseudoOp(sub.op)) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const re = this.newRegexp(op);
        re.min = min;
        re.max = max;
        re.flags = flags;
        re.subs = [
            sub
        ];
        this.stack[n - 1] = re;
    }
    // concat replaces the top of the stack (above the topmost '|' or '(') with
    // its concatenation.
    concat() {
        this.maybeConcat(-1, 0);
        const subs = this.popToPseudo();
        if (subs.length === 0) return this.push(this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH));
        return this.push(this.collapse(subs, $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT));
    }
    // alternate replaces the top of the stack (above the topmost '(') with its
    // alternation.
    alternate() {
        // Scan down to find pseudo-operator (.
        // There are no | above (.
        const subs = this.popToPseudo();
        // Make sure top class is clean.
        // All the others already are (see swapVerticalBar).
        if (subs.length > 0) this.cleanAlt(subs[subs.length - 1]);
        // Empty alternate is special case
        // (shouldn't happen but easy to handle).
        if (subs.length === 0) return this.push(this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.NO_MATCH));
        return this.push(this.collapse(subs, $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE));
    }
    // cleanAlt cleans re for eventual inclusion in an alternation.
    cleanAlt(re) {
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS) {
            re.runes = new $4f6bfbff25a5c30c$var$CharClass(re.runes).cleanClass().toArray();
            if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) {
                re.runes = null;
                re.op = $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR;
            } else if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n') - 1 && re.runes[2] === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n') + 1 && re.runes[3] === $4f6bfbff25a5c30c$var$Unicode.MAX_RUNE) {
                re.runes = null;
                re.op = $4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL;
            }
        }
    }
    // collapse returns the result of applying op to subs[start:end].
    // If (sub contains op nodes, they all get hoisted up
    // so that there is never a concat of a concat or an
    // alternate of an alternate.
    collapse(subs, op) {
        if (subs.length === 1) return subs[0];
        // Concatenate subs iff op is same.
        // Compute length in first pass.
        let len = 0;
        for (let sub of subs)len += sub.op === op ? sub.subs.length : 1;
        let newsubs = new Array(len).fill(null);
        let i = 0;
        for (let sub of subs)if (sub.op === op) {
            newsubs.splice(i, sub.subs.length, ...sub.subs);
            i += sub.subs.length;
            this.reuse(sub);
        } else newsubs[i++] = sub;
        let re = this.newRegexp(op);
        re.subs = newsubs;
        if (op === $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE) {
            // re.subs = this.factor(re.subs, re.flags)
            re.subs = this.factor(re.subs);
            if (re.subs.length === 1) {
                const old = re;
                re = re.subs[0];
                this.reuse(old);
            }
        }
        return re;
    }
    // factor factors common prefixes from the alternation list sub.  It
    // returns a replacement list that reuses the same storage and frees
    // (passes to p.reuse) any removed *Regexps.
    //
    // For example,
    //     ABC|ABD|AEF|BCX|BCY
    // simplifies by literal prefix extraction to
    //     A(B(C|D)|EF)|BC(X|Y)
    // which simplifies by character class introduction to
    //     A(B[CD]|EF)|BC[XY]
    //
    factor(array) {
        if (array.length < 2) return array;
        // The following code is subtle, because it's a literal JS
        // translation of code that makes clever use of Go "slices".
        // A slice is a triple (array, offset, length), and the Go
        // implementation uses two slices, |sub| and |out| backed by the
        // same array.  In JS, we have to be explicit about all of these
        // variables, so:
        //
        // Go    JS
        // sub   (array, s, lensub)
        // out   (array, 0, lenout)   // (always a prefix of |array|)
        //
        // In the comments we'll use the logical notation of go slices, e.g. sub[i]
        // even though the JS code will read array[s + i].
        let s = 0; // offset of first |sub| within array.
        let lensub = array.length; // = len(sub)
        let lenout = 0; // = len(out)
        // Round 1: Factor out common literal prefixes.
        // Note: (str, strlen) and (istr, istrlen) are like Go slices
        // onto a prefix of some Regexp's runes array (hence offset=0).
        let str = null;
        let strlen = 0;
        let strflags = 0;
        let start = 0;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (len <= start).
            //
            // Invariant: sub[start:i] consists of regexps that all begin
            // with str as modified by strflags.
            let istr = null;
            let istrlen = 0;
            let iflags = 0;
            if (i < lensub) {
                // NB, we inlined Go's leadingString() since Java has no pair return.
                let re = array[s + i];
                if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT && re.subs.length > 0) re = re.subs[0];
                if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL) {
                    istr = re.runes;
                    istrlen = re.runes.length;
                    iflags = re.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE;
                }
                // istr is the leading literal string that re begins with.
                // The string refers to storage in re or its children.
                if (iflags === strflags) {
                    let same = 0;
                    while(same < strlen && same < istrlen && str[same] === istr[same])same++;
                    if (same > 0) {
                        // Matches at least one rune in current range.
                        // Keep going around.
                        strlen = same;
                        continue;
                    }
                }
            }
            // Found end of a run with common leading literal string:
            // sub[start:i] all begin with str[0:strlen], but sub[i]
            // does not even begin with str[0].
            //
            // Factor out common string and append factored expression to out.
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Construct factored form: prefix(suffix1|suffix2|...)
                const prefix = this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.LITERAL);
                prefix.flags = strflags;
                prefix.runes = str.slice(0, strlen);
                for(let j = start; j < i; j++)array[s + j] = this.removeLeadingString(array[s + j], strlen);
                // Recurse.
                const suffix = this.collapse(array.slice(s + start, s + i), $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE);
                const re = this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            // Prepare for next iteration.
            start = i;
            str = istr;
            strlen = istrlen;
            strflags = iflags;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 2: Factor out common complex prefixes,
        // just the first piece of each concatenation,
        // whatever it is.  This is good enough a lot of the time.
        start = 0;
        lenout = 0;
        let first = null;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (lenout <= start).
            //
            // Invariant: sub[start:i] consists of regexps that all begin with
            // ifirst.
            let ifirst = null;
            if (i < lensub) {
                ifirst = $4f6bfbff25a5c30c$var$Parser.leadingRegexp(array[s + i]);
                if (first !== null && first.equals(ifirst) && ($4f6bfbff25a5c30c$var$Parser.isCharClass(first) || first.op === $4f6bfbff25a5c30c$var$Regexp.Op.REPEAT && first.min === first.max && $4f6bfbff25a5c30c$var$Parser.isCharClass(first.subs[0]))) continue;
            }
            // Found end of a run with common leading regexp:
            // sub[start:i] all begin with first but sub[i] does not.
            //
            // Factor out common regexp and append factored expression to out.
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Construct factored form: prefix(suffix1|suffix2|...)
                const prefix = first;
                for(let j = start; j < i; j++){
                    const reuse = j !== start; // prefix came from sub[start]
                    array[s + j] = this.removeLeadingRegexp(array[s + j], reuse);
                }
                // recurse
                const suffix = this.collapse(array.slice(s + start, s + i), $4f6bfbff25a5c30c$var$Regexp.Op.ALTERNATE);
                const re = this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            // Prepare for next iteration.
            start = i;
            first = ifirst;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 3: Collapse runs of single literals into character classes.
        start = 0;
        lenout = 0;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (lenout <= start).
            //
            // Invariant: sub[start:i] consists of regexps that are either
            // literal runes or character classes.
            if (i < lensub && $4f6bfbff25a5c30c$var$Parser.isCharClass(array[s + i])) continue;
            // sub[i] is not a char or char class;
            // emit char class for sub[start:i]...
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Make new char class.
                // Start with most complex regexp in sub[start].
                let max = start;
                for(let j = start + 1; j < i; j++){
                    const subMax = array[s + max];
                    const subJ = array[s + j];
                    if (subMax.op < subJ.op || subMax.op === subJ.op && (subMax.runes !== null ? subMax.runes.length : 0) < (subJ.runes !== null ? subJ.runes.length : 0)) max = j;
                }
                // swap sub[start], sub[max].
                const tmp = array[s + start];
                array[s + start] = array[s + max];
                array[s + max] = tmp;
                for(let j = start + 1; j < i; j++){
                    $4f6bfbff25a5c30c$var$Parser.mergeCharClass(array[s + start], array[s + j]);
                    this.reuse(array[s + j]);
                }
                this.cleanAlt(array[s + start]);
                array[lenout++] = array[s + start];
            }
            // ... and then emit sub[i].
            if (i < lensub) array[lenout++] = array[s + i];
            start = i + 1;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 4: Collapse runs of empty matches into a single empty match.
        start = 0;
        lenout = 0;
        for(let i = 0; i < lensub; ++i){
            if (i + 1 < lensub && array[s + i].op === $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH && array[s + i + 1].op === $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH) continue;
            array[lenout++] = array[s + i];
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        return array.slice(s, lensub);
    }
    // removeLeadingString removes the first n leading runes
    // from the beginning of re.  It returns the replacement for re.
    removeLeadingString(re, n) {
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            // Removing a leading string in a concatenation
            // might simplify the concatenation.
            const sub = this.removeLeadingString(re.subs[0], n);
            re.subs[0] = sub;
            if (sub.op === $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH) {
                this.reuse(sub);
                switch(re.subs.length){
                    case 0:
                    case 1:
                        // Impossible but handle.
                        re.op = $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH;
                        re.subs = null;
                        break;
                    case 2:
                        {
                            const old = re;
                            re = re.subs[1];
                            this.reuse(old);
                            break;
                        }
                    default:
                        re.subs = re.subs.slice(1, re.subs.length);
                        break;
                }
            }
            return re;
        }
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.LITERAL) {
            re.runes = re.runes.slice(n, re.runes.length);
            if (re.runes.length === 0) re.op = $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH;
        }
        return re;
    }
    // removeLeadingRegexp removes the leading regexp in re.
    // It returns the replacement for re.
    // If reuse is true, it passes the removed regexp (if no longer needed) to
    // reuse.
    removeLeadingRegexp(re, reuse) {
        if (re.op === $4f6bfbff25a5c30c$var$Regexp.Op.CONCAT && re.subs.length > 0) {
            if (reuse) this.reuse(re.subs[0]);
            re.subs = re.subs.slice(1, re.subs.length);
            switch(re.subs.length){
                case 0:
                    re.op = $4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH;
                    re.subs = $4f6bfbff25a5c30c$var$Regexp.emptySubs();
                    break;
                case 1:
                    {
                        const old = re;
                        re = re.subs[0];
                        this.reuse(old);
                        break;
                    }
            }
            return re;
        }
        if (reuse) this.reuse(re);
        return this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.EMPTY_MATCH);
    }
    parseInternal() {
        if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.LITERAL) !== 0) // Trivial parser for literal string.
        return $4f6bfbff25a5c30c$var$Parser.literalRegexp(this.wholeRegexp, this.flags);
        // Otherwise, must do real work.
        let lastRepeatPos = -1;
        let min = -1;
        let max = -1;
        const t = new $4f6bfbff25a5c30c$var$StringIterator(this.wholeRegexp);
        while(t.more()){
            let repeatPos = -1;
            bigswitch: switch(t.peek()){
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('('):
                    if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.PERL_X) !== 0 && t.lookingAt('(?')) {
                        // Flag changes and non-capturing groups.
                        this.parsePerlFlags(t);
                        break;
                    }
                    this.op($4f6bfbff25a5c30c$var$Regexp.Op.LEFT_PAREN).cap = ++this.numCap;
                    t.skip(1); // '('
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('|'):
                    this.parseVerticalBar(); // '|'
                    t.skip(1); // '|'
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get(')'):
                    this.parseRightParen();
                    t.skip(1); // ')'
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('^'):
                    if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.ONE_LINE) !== 0) this.op($4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_TEXT);
                    else this.op($4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_LINE);
                    t.skip(1); // '^'
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('$'):
                    if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.ONE_LINE) !== 0) this.op($4f6bfbff25a5c30c$var$Regexp.Op.END_TEXT).flags |= $4f6bfbff25a5c30c$var$RE2Flags.WAS_DOLLAR;
                    else this.op($4f6bfbff25a5c30c$var$Regexp.Op.END_LINE);
                    t.skip(1); // '$'
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('.'):
                    if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.DOT_NL) !== 0) this.op($4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR);
                    else this.op($4f6bfbff25a5c30c$var$Regexp.Op.ANY_CHAR_NOT_NL);
                    t.skip(1); // '.'
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('['):
                    this.parseClass(t);
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('*'):
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('+'):
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('?'):
                    {
                        repeatPos = t.pos();
                        let op = null;
                        switch(t.pop()){
                            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('*'):
                                op = $4f6bfbff25a5c30c$var$Regexp.Op.STAR;
                                break;
                            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('+'):
                                op = $4f6bfbff25a5c30c$var$Regexp.Op.PLUS;
                                break;
                            case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('?'):
                                op = $4f6bfbff25a5c30c$var$Regexp.Op.QUEST;
                                break;
                        }
                        this.repeat(op, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('{'):
                    {
                        repeatPos = t.pos();
                        const minMax = $4f6bfbff25a5c30c$var$Parser.parseRepeat(t);
                        if (minMax < 0) {
                            // If the repeat cannot be parsed, { is a literal.
                            t.rewindTo(repeatPos);
                            this.literal(t.pop()); // '{'
                            break;
                        }
                        min = minMax >> 16;
                        max = (minMax & $4f6bfbff25a5c30c$var$Unicode.MAX_BMP) << 16 >> 16;
                        this.repeat($4f6bfbff25a5c30c$var$Regexp.Op.REPEAT, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\\'):
                    {
                        const savedPos = t.pos();
                        t.skip(1); // '\\'
                        if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.PERL_X) !== 0 && t.more()) {
                            const c = t.pop();
                            switch(c){
                                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('A'):
                                    this.op($4f6bfbff25a5c30c$var$Regexp.Op.BEGIN_TEXT);
                                    break bigswitch;
                                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('b'):
                                    this.op($4f6bfbff25a5c30c$var$Regexp.Op.WORD_BOUNDARY);
                                    break bigswitch;
                                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('B'):
                                    this.op($4f6bfbff25a5c30c$var$Regexp.Op.NO_WORD_BOUNDARY);
                                    break bigswitch;
                                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('C'):
                                    // any byte; not supported
                                    throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_ESCAPE, '\\C');
                                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('Q'):
                                    {
                                        // \Q ... \E: the ... is always literals
                                        let lit = t.rest();
                                        const i = lit.indexOf('\\E');
                                        if (i >= 0) lit = lit.substring(0, i);
                                        t.skipString(lit);
                                        t.skipString('\\E');
                                        let j = 0;
                                        while(j < lit.length){
                                            const codepoint = lit.codePointAt(j);
                                            this.literal(codepoint);
                                            j += $4f6bfbff25a5c30c$var$Utils.charCount(codepoint);
                                        }
                                        break bigswitch;
                                    }
                                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('z'):
                                    this.op($4f6bfbff25a5c30c$var$Regexp.Op.END_TEXT);
                                    break bigswitch;
                                default:
                                    t.rewindTo(savedPos);
                                    break;
                            }
                        }
                        const re = this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS);
                        re.flags = this.flags;
                        // Look for Unicode character group like \p{Han}
                        if (t.lookingAt('\\p') || t.lookingAt('\\P')) {
                            const cc = new $4f6bfbff25a5c30c$var$CharClass();
                            if (this.parseUnicodeClass(t, cc)) {
                                re.runes = cc.toArray();
                                this.push(re);
                                break bigswitch;
                            }
                        }
                        // Perl character class escape.
                        const cc = new $4f6bfbff25a5c30c$var$CharClass();
                        if (this.parsePerlClassEscape(t, cc)) {
                            re.runes = cc.toArray();
                            this.push(re);
                            break bigswitch;
                        }
                        t.rewindTo(savedPos);
                        this.reuse(re);
                        // Ordinary single-character escape.
                        this.literal($4f6bfbff25a5c30c$var$Parser.parseEscape(t));
                        break;
                    }
                default:
                    this.literal(t.pop());
                    break;
            }
            lastRepeatPos = repeatPos;
        }
        this.concat();
        if (this.swapVerticalBar()) this.pop(); // pop vertical bar
        this.alternate();
        const n = this.stack.length;
        if (n !== 1) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_MISSING_PAREN, this.wholeRegexp);
        this.stack[0].namedGroups = this.namedGroups;
        return this.stack[0];
    }
    // parsePerlFlags parses a Perl flag setting or non-capturing group or both,
    // like (?i) or (?: or (?i:.
    // Pre: t at "(?".  Post: t after ")".
    // Sets numCap.
    parsePerlFlags(t) {
        const startPos = t.pos();
        // Check for named captures, first introduced in Python's regexp library.
        // As usual, there are three slightly different syntaxes:
        //
        //   (?P<name>expr)   the original, introduced by Python
        //   (?<name>expr)    the .NET alteration, adopted by Perl 5.10
        //   (?'name'expr)    another .NET alteration, adopted by Perl 5.10
        //
        // Perl 5.10 gave in and implemented the Python version too,
        // but they claim that the last two are the preferred forms.
        // PCRE and languages based on it (specifically, PHP and Ruby)
        // support all three as well.  EcmaScript 4 uses only the Python form.
        //
        // In both the open source world (via Code Search) and the
        // Google source tree, (?P<name>expr) and (?<name>expr) are the
        // dominant forms of named captures and both are supported.
        const s = t.rest();
        if (s.startsWith('(?P<') || s.startsWith('(?<')) {
            // Pull out name.
            const begin = s.charAt(2) === 'P' ? 4 : 3;
            const end = s.indexOf('>');
            if (end < 0) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_NAMED_CAPTURE, s);
            const name = s.substring(begin, end); // "name"
            t.skipString(name);
            t.skip(begin + 1); // "(?P<>" or "(?<>"
            if (!$4f6bfbff25a5c30c$var$Parser.isValidCaptureName(name)) // "(?P<name>"
            throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_NAMED_CAPTURE, s.substring(0, end + 1)); // "(?P<name>" or "(?<name>"
            // Like ordinary capture, but named.
            const re = this.op($4f6bfbff25a5c30c$var$Regexp.Op.LEFT_PAREN);
            re.cap = ++this.numCap;
            if (this.namedGroups[name]) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_DUPLICATE_NAMED_CAPTURE, name);
            this.namedGroups[name] = this.numCap;
            re.name = name;
            return;
        }
        // Non-capturing group.  Might also twiddle Perl flags.
        t.skip(2); // "(?"
        let flags = this.flags;
        let sign = 1;
        let sawFlag = false;
        loop: while(t.more()){
            const c = t.pop();
            switch(c){
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('i'):
                    flags |= $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE;
                    sawFlag = true;
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('m'):
                    flags &= ~$4f6bfbff25a5c30c$var$RE2Flags.ONE_LINE;
                    sawFlag = true;
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('s'):
                    flags |= $4f6bfbff25a5c30c$var$RE2Flags.DOT_NL;
                    sawFlag = true;
                    break;
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('U'):
                    flags |= $4f6bfbff25a5c30c$var$RE2Flags.NON_GREEDY;
                    sawFlag = true;
                    break;
                // Switch to negation.
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get('-'):
                    if (sign < 0) break loop;
                    sign = -1;
                    // Invert flags so that | above turn into &~ and vice versa.
                    // We'll invert flags again before using it below.
                    flags = ~flags;
                    sawFlag = false;
                    break;
                // End of flags, starting group or not.
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get(':'):
                case $4f6bfbff25a5c30c$var$Codepoint.CODES.get(')'):
                    if (sign < 0) {
                        if (!sawFlag) break loop;
                        flags = ~flags;
                    }
                    if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES.get(':')) // Open new group
                    this.op($4f6bfbff25a5c30c$var$Regexp.Op.LEFT_PAREN);
                    this.flags = flags;
                    return;
                default:
                    break loop;
            }
        }
        throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_PERL_OP, t.from(startPos));
    }
    // parseVerticalBar handles a | in the input.
    parseVerticalBar() {
        this.concat();
        // The concatenation we just parsed is on top of the stack.
        // If it sits above an opVerticalBar, swap it below
        // (things below an opVerticalBar become an alternation).
        // Otherwise, push a new vertical bar.
        if (!this.swapVerticalBar()) this.op($4f6bfbff25a5c30c$var$Regexp.Op.VERTICAL_BAR);
    }
    // If the top of the stack is an element followed by an opVerticalBar
    // swapVerticalBar swaps the two and returns true.
    // Otherwise it returns false.
    swapVerticalBar() {
        const n = this.stack.length;
        // If above and below vertical bar are literal or char class,
        // can merge into a single char class.
        if (n >= 3 && this.stack[n - 2].op === $4f6bfbff25a5c30c$var$Regexp.Op.VERTICAL_BAR && $4f6bfbff25a5c30c$var$Parser.isCharClass(this.stack[n - 1]) && $4f6bfbff25a5c30c$var$Parser.isCharClass(this.stack[n - 3])) {
            let re1 = this.stack[n - 1];
            let re3 = this.stack[n - 3];
            // Make re3 the more complex of the two.
            if (re1.op > re3.op) {
                const tmp = re3;
                re3 = re1;
                re1 = tmp;
                this.stack[n - 3] = re3;
            }
            $4f6bfbff25a5c30c$var$Parser.mergeCharClass(re3, re1);
            this.reuse(re1);
            this.pop();
            return true;
        }
        if (n >= 2) {
            const re1 = this.stack[n - 1];
            const re2 = this.stack[n - 2];
            if (re2.op === $4f6bfbff25a5c30c$var$Regexp.Op.VERTICAL_BAR) {
                if (n >= 3) // Now out of reach.
                // Clean opportunistically.
                this.cleanAlt(this.stack[n - 3]);
                this.stack[n - 2] = re1;
                this.stack[n - 1] = re2;
                return true;
            }
        }
        return false;
    }
    // parseRightParen handles a ')' in the input.
    parseRightParen() {
        this.concat();
        if (this.swapVerticalBar()) this.pop(); // pop vertical bar
        this.alternate();
        const n = this.stack.length;
        if (n < 2) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INTERNAL_ERROR, 'stack underflow');
        const re1 = this.pop();
        const re2 = this.pop();
        if (re2.op !== $4f6bfbff25a5c30c$var$Regexp.Op.LEFT_PAREN) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_MISSING_PAREN, this.wholeRegexp);
        // Restore flags at time of paren.
        this.flags = re2.flags;
        if (re2.cap === 0) // Just for grouping.
        this.push(re1);
        else {
            re2.op = $4f6bfbff25a5c30c$var$Regexp.Op.CAPTURE;
            re2.subs = [
                re1
            ];
            this.push(re2);
        }
    }
    // parsePerlClassEscape parses a leading Perl character class escape like \d
    // from the beginning of |t|.  If one is present, it appends the characters
    // to cc and returns true.  The iterator is advanced past the escape
    // on success, undefined on failure, in which case false is returned.
    parsePerlClassEscape(t, cc) {
        const beforePos = t.pos();
        if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.PERL_X) === 0 || !t.more() || t.pop() !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\\') || !t.more()) return false;
        t.pop(); // e.g. advance past 'd' in "\\d"
        const p = t.from(beforePos);
        const g = $4f6bfbff25a5c30c$var$PERL_GROUPS.has(p) ? $4f6bfbff25a5c30c$var$PERL_GROUPS.get(p) : null;
        if (g === null) return false;
        cc.appendGroup(g, (this.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    // parseNamedClass parses a leading POSIX named character class like
    // [:alnum:] from the beginning of t.  If one is present, it appends the
    // characters to cc, advances the iterator, and returns true.
    // Pre: t at "[:".  Post: t after ":]".
    // On failure (no class of than name), throws RE2JSSyntaxException.
    // On misparse, returns false; t.pos() is undefined.
    parseNamedClass(t, cc) {
        // (Go precondition check deleted.)
        const cls = t.rest();
        const i = cls.indexOf(':]');
        if (i < 0) return false;
        const name = cls.substring(0, i + 2); // "[:alnum:]"
        t.skipString(name);
        const g = $4f6bfbff25a5c30c$var$POSIX_GROUPS.has(name) ? $4f6bfbff25a5c30c$var$POSIX_GROUPS.get(name) : null;
        if (g === null) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_CHAR_RANGE, name);
        cc.appendGroup(g, (this.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    // parseUnicodeClass() parses a leading Unicode character class like \p{Han}
    // from the beginning of t.  If one is present, it appends the characters to
    // to |cc|, advances |t| and returns true.
    //
    // Returns false if such a pattern is not present or UNICODE_GROUPS
    // flag is not enabled; |t.pos()| is not advanced in this case.
    // Indicates error by throwing RE2JSSyntaxException.
    parseUnicodeClass(t, cc) {
        const startPos = t.pos();
        if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.UNICODE_GROUPS) === 0 || !t.lookingAt('\\p') && !t.lookingAt('\\P')) return false;
        t.skip(1); // '\\'
        // Committed to parse or throw exception.
        let sign = 1;
        let c = t.pop(); // 'p' or 'P'
        if (c === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('P')) sign = -1;
        if (!t.more()) {
            t.rewindTo(startPos);
            throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_CHAR_RANGE, t.rest());
        }
        c = t.pop();
        let name;
        if (c !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('{')) // Single-letter name.
        name = $4f6bfbff25a5c30c$var$Utils.runeToString(c);
        else {
            // Name is in braces.
            const rest = t.rest();
            const end = rest.indexOf('}');
            if (end < 0) {
                t.rewindTo(startPos);
                throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_CHAR_RANGE, t.rest());
            }
            name = rest.substring(0, end); // e.g. "Han"
            t.skipString(name);
            t.skip(1);
        // Don't use skip(end) because it assumes UTF-16 coding, and
        // StringIterator doesn't guarantee that.
        }
        // Group can have leading negation too.
        //  \p{^Han} == \P{Han}, \P{^Han} == \p{Han}.
        if (!(name.length === 0) && name.codePointAt(0) === $4f6bfbff25a5c30c$var$Codepoint.CODES.get('^')) {
            sign = 0 - sign; // -sign
            name = name.substring(1);
        }
        const pair = $4f6bfbff25a5c30c$var$Parser.unicodeTable(name);
        if (pair === null) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_CHAR_RANGE, t.from(startPos));
        const tab = pair.first;
        const fold = pair.second; // fold-equivalent table
        // Variation of CharClass.appendGroup() for tables.
        if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) === 0 || fold === null) cc.appendTableWithSign(tab, sign);
        else {
            // Merge and clean tab and fold in a temporary buffer.
            // This is necessary for the negative case and just tidy
            // for the positive case.
            const tmp = new $4f6bfbff25a5c30c$var$CharClass().appendTable(tab).appendTable(fold).cleanClass().toArray();
            cc.appendClassWithSign(tmp, sign);
        }
        return true;
    }
    // parseClass parses a character class and pushes it onto the parse stack.
    //
    // NOTES:
    // Pre: at '['; Post: after ']'.
    // Mutates stack.  Advances iterator.  May throw.
    parseClass(t) {
        const startPos = t.pos();
        t.skip(1); // '['
        const re = this.newRegexp($4f6bfbff25a5c30c$var$Regexp.Op.CHAR_CLASS);
        re.flags = this.flags;
        const cc = new $4f6bfbff25a5c30c$var$CharClass();
        let sign = 1;
        if (t.more() && t.lookingAt('^')) {
            sign = -1;
            t.skip(1); // '^'
            // If character class does not match \n, add it here,
            // so that negation later will do the right thing.
            if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.CLASS_NL) === 0) cc.appendRange($4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n'), $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n'));
        }
        let first = true; // ']' and '-' are okay as first char in class
        while(!t.more() || t.peek() !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get(']') || first){
            // POSIX: - is only okay unescaped as first or last in class.
            // Perl: - is okay anywhere.
            if (t.more() && t.lookingAt('-') && (this.flags & $4f6bfbff25a5c30c$var$RE2Flags.PERL_X) === 0 && !first) {
                const s = t.rest();
                if (s === '-' || !s.startsWith('-]')) {
                    t.rewindTo(startPos);
                    throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                }
            }
            first = false;
            const beforePos = t.pos();
            // Look for POSIX [:alnum:] etc.
            if (t.lookingAt('[:')) {
                if (this.parseNamedClass(t, cc)) continue;
                t.rewindTo(beforePos);
            }
            // Look for Unicode character group like \p{Han}.
            if (this.parseUnicodeClass(t, cc)) continue;
            // Look for Perl character class symbols (extension).
            if (this.parsePerlClassEscape(t, cc)) continue;
            t.rewindTo(beforePos);
            // Single character or simple range.
            const lo = $4f6bfbff25a5c30c$var$Parser.parseClassChar(t, startPos);
            let hi = lo;
            if (t.more() && t.lookingAt('-')) {
                t.skip(1);
                if (t.more() && t.lookingAt(']')) // [a-] means (a|-) so check for final ].
                t.skip(-1);
                else {
                    hi = $4f6bfbff25a5c30c$var$Parser.parseClassChar(t, startPos);
                    if (hi < lo) throw new $4f6bfbff25a5c30c$export$9c12d0c1e9bff151($4f6bfbff25a5c30c$var$Parser.ERR_INVALID_CHAR_RANGE, t.from(beforePos));
                }
            }
            if ((this.flags & $4f6bfbff25a5c30c$var$RE2Flags.FOLD_CASE) === 0) cc.appendRange(lo, hi);
            else cc.appendFoldedRange(lo, hi);
        }
        t.skip(1); // ']'
        cc.cleanClass();
        if (sign < 0) cc.negateClass();
        re.runes = cc.toArray();
        this.push(re);
    }
}
// A logical thread in the NFA.
class $4f6bfbff25a5c30c$var$Thread {
    constructor(){
        this.inst = null;
        this.cap = [];
    }
}
// A queue is a 'sparse array' holding pending threads of execution.  See:
// research.swtch.com/2008/03/using-uninitialized-memory-for-fun-and.html
class $4f6bfbff25a5c30c$var$Queue {
    constructor(){
        this.sparse = []; // may contain stale but in-bounds values.
        this.densePcs = []; // may contain stale pc in slots >= size
        this.denseThreads = []; // may contain stale Thread in slots >= size
        this.size = 0;
    }
    contains(pc) {
        const j = this.sparse[pc];
        return j < this.size && this.densePcs[j] === pc;
    }
    isEmpty() {
        return this.size === 0;
    }
    add(pc) {
        const j = this.size++;
        this.sparse[pc] = j;
        this.denseThreads[j] = null;
        this.densePcs[j] = pc;
        return j;
    }
    clear() {
        this.sparse = [];
        this.densePcs = [];
        this.denseThreads = [];
        this.size = 0;
    }
    toString() {
        let out = '{';
        for(let i = 0; i < this.size; i++){
            if (i !== 0) out += ', ';
            out += this.densePcs[i];
        }
        out += '}';
        return out;
    }
}
// A Machine matches an input string of Unicode characters against an
// RE2 instance using a simple NFA.
//
// Called by RE2.doExecute.
class $4f6bfbff25a5c30c$var$Machine {
    static fromRE2(re2) {
        const m = new $4f6bfbff25a5c30c$var$Machine();
        m.prog = re2.prog;
        m.re2 = re2;
        m.q0 = new $4f6bfbff25a5c30c$var$Queue(m.prog.numInst());
        m.q1 = new $4f6bfbff25a5c30c$var$Queue(m.prog.numInst());
        m.pool = [];
        m.poolSize = 0;
        m.matched = false;
        m.matchcap = Array(m.prog.numCap < 2 ? 2 : m.prog.numCap).fill(0);
        m.ncap = 0;
        return m;
    }
    static fromMachine(machine) {
        const m = new $4f6bfbff25a5c30c$var$Machine();
        m.re2 = machine.re2;
        m.prog = machine.prog;
        m.q0 = machine.q0;
        m.q1 = machine.q1;
        m.pool = machine.pool;
        m.poolSize = machine.poolSize;
        m.matched = machine.matched;
        m.matchcap = machine.matchcap;
        m.ncap = machine.ncap;
        return m;
    }
    // init() reinitializes an existing Machine for re-use on a new input.
    init(ncap) {
        this.ncap = ncap;
        if (ncap > this.matchcap.length) this.initNewCap(ncap);
        else this.resetCap(ncap);
    }
    resetCap(ncap) {
        for(let i = 0; i < this.poolSize; i++){
            const t = this.pool[i];
            t.cap = Array(ncap).fill(0);
        }
    }
    initNewCap(ncap) {
        for(let i = 0; i < this.poolSize; i++){
            const t = this.pool[i];
            t.cap = Array(ncap).fill(0);
        }
        this.matchcap = Array(ncap).fill(0);
    }
    submatches() {
        if (this.ncap === 0) return $4f6bfbff25a5c30c$var$Utils.emptyInts();
        return this.matchcap.slice(0, this.ncap);
    }
    // alloc() allocates a new thread with the given instruction.
    // It uses the free pool if possible.
    alloc(inst) {
        let t;
        if (this.poolSize > 0) {
            this.poolSize--;
            t = this.pool[this.poolSize];
        } else t = new $4f6bfbff25a5c30c$var$Thread();
        t.inst = inst;
        return t;
    }
    // Frees all threads on the thread queue, returning them to the free pool.
    freeQueue(queue, from = 0) {
        const numberOfThread = queue.size - from;
        const requiredPoolLength = this.poolSize + numberOfThread;
        if (this.pool.length < requiredPoolLength) this.pool = this.pool.slice(0, Math.max(this.pool.length * 2, requiredPoolLength));
        for(let i = from; i < queue.size; i++){
            const t = queue.denseThreads[i];
            if (t !== null) {
                this.pool[this.poolSize] = t;
                this.poolSize++;
            }
        }
        queue.clear();
    }
    // freeThread() returns t to the free pool.
    freeThread(t) {
        if (this.pool.length <= this.poolSize) this.pool = this.pool.slice(0, this.pool.length * 2);
        this.pool[this.poolSize] = t;
        this.poolSize++;
    }
    match(input, pos, anchor) {
        const startCond = this.re2.cond;
        if (startCond === $4f6bfbff25a5c30c$var$Utils.EMPTY_ALL) return false;
        if ((anchor === $4f6bfbff25a5c30c$var$RE2Flags.ANCHOR_START || anchor === $4f6bfbff25a5c30c$var$RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
        this.matched = false;
        this.matchcap = Array(this.prog.numCap).fill(-1);
        let runq = this.q0;
        let nextq = this.q1;
        let r = input.step(pos);
        let rune = r >> 3;
        let width = r & 7;
        let rune1 = -1;
        let width1 = 0;
        if (r !== $4f6bfbff25a5c30c$var$MachineInputBase.EOF()) {
            r = input.step(pos + width);
            rune1 = r >> 3;
            width1 = r & 7;
        }
        let flag;
        if (pos === 0) flag = $4f6bfbff25a5c30c$var$Utils.emptyOpContext(-1, rune);
        else flag = input.context(pos);
        // eslint-disable-next-line no-constant-condition
        while(true){
            if (runq.isEmpty()) {
                if ((startCond & $4f6bfbff25a5c30c$var$Utils.EMPTY_BEGIN_TEXT) !== 0 && pos !== 0) break;
                if (this.matched) break;
                if (!(this.re2.prefix.length === 0) && rune1 !== this.re2.prefixRune && input.canCheckPrefix()) {
                    const advance = input.index(this.re2, pos);
                    if (advance < 0) break;
                    pos += advance;
                    r = input.step(pos);
                    rune = r >> 3;
                    width = r & 7;
                    r = input.step(pos + width);
                    rune1 = r >> 3;
                    width1 = r & 7;
                }
            }
            if (!this.matched && (pos === 0 || anchor === $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED)) {
                if (this.ncap > 0) this.matchcap[0] = pos;
                this.add(runq, this.prog.start, pos, this.matchcap, flag, null);
            }
            const nextPos = pos + width;
            flag = input.context(nextPos);
            this.step(runq, nextq, pos, nextPos, rune, flag, anchor, pos === input.endPos());
            if (width === 0) break;
            if (this.ncap === 0 && this.matched) break;
            pos += width;
            rune = rune1;
            width = width1;
            if (rune !== -1) {
                r = input.step(pos + width);
                rune1 = r >> 3;
                width1 = r & 7;
            }
            const tmpq = runq;
            runq = nextq;
            nextq = tmpq;
        }
        this.freeQueue(nextq);
        return this.matched;
    }
    step(runq, nextq, pos, nextPos, c, nextCond, anchor, atEnd) {
        const longest = this.re2.longest;
        for(let j = 0; j < runq.size; j++){
            let t = runq.denseThreads[j];
            if (t === null) continue;
            if (longest && this.matched && this.ncap > 0 && this.matchcap[0] < t.cap[0]) {
                this.freeThread(t);
                continue;
            }
            const i = t.inst;
            let add = false;
            switch(i.op){
                case $4f6bfbff25a5c30c$var$Inst.MATCH:
                    if (anchor === $4f6bfbff25a5c30c$var$RE2Flags.ANCHOR_BOTH && !atEnd) break;
                    if (this.ncap > 0 && (!longest || !this.matched || this.matchcap[1] < pos)) {
                        t.cap[1] = pos;
                        this.matchcap = t.cap.slice(0, this.ncap);
                    }
                    if (!longest) this.freeQueue(runq, j + 1);
                    this.matched = true;
                    break;
                case $4f6bfbff25a5c30c$var$Inst.RUNE:
                    add = i.matchRune(c);
                    break;
                case $4f6bfbff25a5c30c$var$Inst.RUNE1:
                    add = c === i.runes[0];
                    break;
                case $4f6bfbff25a5c30c$var$Inst.RUNE_ANY:
                    add = true;
                    break;
                case $4f6bfbff25a5c30c$var$Inst.RUNE_ANY_NOT_NL:
                    add = c !== $4f6bfbff25a5c30c$var$Codepoint.CODES.get('\n');
                    break;
                default:
                    throw new Error('bad inst');
            }
            if (add) t = this.add(nextq, i.out, nextPos, t.cap, nextCond, t);
            if (t !== null) {
                this.freeThread(t);
                runq.denseThreads[j] = null;
            }
        }
        runq.clear();
    }
    add(q, pc, pos, cap, cond, t) {
        if (pc === 0) return t;
        if (q.contains(pc)) return t;
        const d = q.add(pc);
        const inst = this.prog.inst[pc];
        switch(inst.op){
            case $4f6bfbff25a5c30c$var$Inst.FAIL:
                break;
            case $4f6bfbff25a5c30c$var$Inst.ALT:
            case $4f6bfbff25a5c30c$var$Inst.ALT_MATCH:
                t = this.add(q, inst.out, pos, cap, cond, t);
                t = this.add(q, inst.arg, pos, cap, cond, t);
                break;
            case $4f6bfbff25a5c30c$var$Inst.EMPTY_WIDTH:
                if ((inst.arg & ~cond) === 0) t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case $4f6bfbff25a5c30c$var$Inst.NOP:
                t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case $4f6bfbff25a5c30c$var$Inst.CAPTURE:
                if (inst.arg < this.ncap) {
                    const opos = cap[inst.arg];
                    cap[inst.arg] = pos;
                    this.add(q, inst.out, pos, cap, cond, null);
                    cap[inst.arg] = opos;
                } else t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case $4f6bfbff25a5c30c$var$Inst.MATCH:
            case $4f6bfbff25a5c30c$var$Inst.RUNE:
            case $4f6bfbff25a5c30c$var$Inst.RUNE1:
            case $4f6bfbff25a5c30c$var$Inst.RUNE_ANY:
            case $4f6bfbff25a5c30c$var$Inst.RUNE_ANY_NOT_NL:
                if (t === null) t = this.alloc(inst);
                else t.inst = inst;
                if (this.ncap > 0 && t.cap !== cap) t.cap = cap.slice(0, this.ncap);
                q.denseThreads[d] = t;
                t = null;
                break;
            default:
                throw new Error('unhandled');
        }
        return t;
    }
}
class $4f6bfbff25a5c30c$var$AtomicReference {
    constructor(initialValue){
        this.value = initialValue;
    }
    // Returns the current value
    get() {
        return this.value;
    }
    // Sets to the given value
    set(newValue) {
        this.value = newValue;
    }
    // Atomically sets to the given value and returns true if the current value == the expected value
    compareAndSet(expect, update) {
        if (this.value === expect) {
            this.value = update;
            return true;
        }
        return false;
    }
}
/**
 * An RE2 class instance is a compiled representation of an RE2 regular expression, independent of
 * the public Java-like Pattern/Matcher API.
 *
 * This class also contains various implementation helpers for RE2 regular expressions.
 *
 * Use the {@link #quoteMeta(String)} utility function to quote all regular expression
 * metacharacters in an arbitrary string.
 *
 */ class $4f6bfbff25a5c30c$var$RE2 {
    // This is visible for testing.
    static initTest(expr) {
        const re2 = $4f6bfbff25a5c30c$var$RE2.compile(expr);
        const res = new $4f6bfbff25a5c30c$var$RE2(re2.expr, re2.prog, re2.numSubexp, re2.longest);
        res.cond = re2.cond;
        res.prefix = re2.prefix;
        res.prefixUTF8 = re2.prefixUTF8;
        res.prefixComplete = re2.prefixComplete;
        res.prefixRune = re2.prefixRune;
        return res;
    }
    /**
   * Parses a regular expression and returns, if successful, an {@code RE2} instance that can be
   * used to match against text.
   *
   * When matching against text, the regexp returns a match that begins as early as possible in the
   * input (leftmost), and among those it chooses the one that a backtracking search would have
   * found first. This so-called leftmost-first matching is the same semantics that Perl, Python,
   * and other implementations use, although this package implements it without the expense of
   * backtracking. For POSIX leftmost-longest matching, see {@link #compilePOSIX}.
   */ static compile(expr) {
        return $4f6bfbff25a5c30c$var$RE2.compileImpl(expr, $4f6bfbff25a5c30c$var$RE2Flags.PERL, false);
    }
    /**
   * {@code compilePOSIX} is like {@link #compile} but restricts the regular expression to POSIX ERE
   * (egrep) syntax and changes the match semantics to leftmost-longest.
   *
   * That is, when matching against text, the regexp returns a match that begins as early as
   * possible in the input (leftmost), and among those it chooses a match that is as long as
   * possible. This so-called leftmost-longest matching is the same semantics that early regular
   * expression implementations used and that POSIX specifies.
   *
   * However, there can be multiple leftmost-longest matches, with different submatch choices, and
   * here this package diverges from POSIX. Among the possible leftmost-longest matches, this
   * package chooses the one that a backtracking search would have found first, while POSIX
   * specifies that the match be chosen to maximize the length of the first subexpression, then the
   * second, and so on from left to right. The POSIX rule is computationally prohibitive and not
   * even well-defined. See http://swtch.com/~rsc/regexp/regexp2.html#posix
   */ static compilePOSIX(expr) {
        return $4f6bfbff25a5c30c$var$RE2.compileImpl(expr, $4f6bfbff25a5c30c$var$RE2Flags.POSIX, true);
    }
    // Exposed to ExecTests.
    static compileImpl(expr, mode, longest) {
        let re = $4f6bfbff25a5c30c$var$Parser.parse(expr, mode);
        const maxCap = re.maxCap();
        re = $4f6bfbff25a5c30c$var$Simplify.simplify(re);
        const prog = $4f6bfbff25a5c30c$var$Compiler.compileRegexp(re);
        const re2 = new $4f6bfbff25a5c30c$var$RE2(expr, prog, maxCap, longest);
        const [prefixCompl, prefixStr] = prog.prefix();
        re2.prefixComplete = prefixCompl;
        re2.prefix = prefixStr;
        re2.prefixUTF8 = $4f6bfbff25a5c30c$var$Utils.stringToUtf8ByteArray(re2.prefix);
        if (re2.prefix.length > 0) re2.prefixRune = re2.prefix.codePointAt(0);
        re2.namedGroups = re.namedGroups;
        return re2;
    }
    /**
   * Returns true iff textual regular expression {@code pattern} matches string {@code s}.
   *
   * More complicated queries need to use {@link #compile} and the full {@code RE2} interface.
   */ // This is visible for testing.
    static match(pattern, s) {
        return $4f6bfbff25a5c30c$var$RE2.compile(pattern).match(s);
    }
    constructor(expr, prog, numSubexp = 0, longest = 0){
        this.expr = expr; // as passed to Compile
        this.prog = prog; // compiled program
        this.numSubexp = numSubexp;
        this.longest = longest;
        this.cond = prog.startCond(); // EMPTY_* bitmask: empty-width conditions
        this.prefix = null; // required UTF-16 prefix in unanchored matches
        this.prefixUTF8 = null; // required UTF-8 prefix in unanchored matches
        this.prefixComplete = false; // true if prefix is the entire regexp
        this.prefixRune = 0; // first rune in prefix
        this.pooled = new $4f6bfbff25a5c30c$var$AtomicReference(); // Cache of machines for running regexp. Forms a Treiber stack.
    }
    /**
   * Returns the number of parenthesized subexpressions in this regular expression.
   */ numberOfCapturingGroups() {
        return this.numSubexp;
    }
    // get() returns a machine to use for matching |this|.  It uses |this|'s
    // machine cache if possible, to avoid unnecessary allocation.
    get() {
        // Pop a machine off the stack if available.
        let head;
        do head = this.pooled.get();
        while (head && !this.pooled.compareAndSet(head, head.next));
        return head;
    }
    // Clears the memory associated with this machine.
    reset() {
        this.pooled.set(null);
    }
    // put() returns a machine to |this|'s machine cache.  There is no attempt to
    // limit the size of the cache, so it will grow to the maximum number of
    // simultaneous matches run using |this|.  (The cache empties when |this|
    // gets garbage collected or reset is called.)
    put(m, isNew) {
        // To avoid allocation in the single-thread or uncontended case, reuse a node only if
        // it was the only element in the stack when it was popped, and it's the only element
        // in the stack when it's pushed back after use.
        let head = this.pooled.get();
        do {
            head = this.pooled.get();
            if (!isNew && head) {
                // If an element had a null next pointer and it was previously in the stack, another thread
                // might be trying to pop it out right now, and if it sees the same node now in the
                // stack the pop will succeed, but the new top of the stack will be the stale (null) value
                // of next. Allocate a new Machine so that the CAS will not succeed if this node has been
                // popped and re-pushed.
                m = $4f6bfbff25a5c30c$var$Machine.fromMachine(m);
                isNew = true;
            }
            // Without this comparison, TSAN will complain about a race condition:
            // Thread A, B, and C all attempt to do a match on the same pattern.
            //
            // A: Allocates Machine 1; executes match; put machine 1. State is now:
            //
            // pooled -> machine 1 -> null
            //
            // B reads pooled, sees machine 1
            //
            // C reads pooled, sees machine 1
            //
            // B successfully CASes pooled to null
            //
            // B executes match; put machine 1, which involves setting machine1.next to
            // null (even though it's already null); preempted before CAS
            //
            // C resumes, and reads machine1.next in order to execute cas(head, head.next)
            //
            // There is no happens-before relationship between B's redundant null write
            // and C's read, thus triggering TSAN.
            //
            // Not needed for JS code
            if (m.next !== head) m.next = head;
        }while (!this.pooled.compareAndSet(head, m));
    }
    toString() {
        return this.expr;
    }
    // doExecute() finds the leftmost match in the input and returns
    // the position of its subexpressions.
    // Derived from exec.go.
    doExecute(input, pos, anchor, ncap) {
        let m = this.get();
        // The Treiber stack cannot reuse nodes, unless the node to be reused has only ever been at
        // the bottom of the stack (i.e., next == null).
        let isNew = false;
        if (!m) {
            m = $4f6bfbff25a5c30c$var$Machine.fromRE2(this);
            isNew = true;
        } else if (m.next !== null) {
            m = $4f6bfbff25a5c30c$var$Machine.fromMachine(m);
            isNew = true;
        }
        m.init(ncap);
        const cap = m.match(input, pos, anchor) ? m.submatches() : null;
        this.put(m, isNew);
        return cap;
    }
    match(s) {
        return this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
   * Matches the regular expression against input starting at position start and ending at position
   * end, with the given anchoring. Records the submatch boundaries in group, which is [start, end)
   * pairs of byte offsets. The number of boundaries needed is inferred from the size of the group
   * array. It is most efficient not to ask for submatch boundaries.
   *
   * @param input the input byte array
   * @param start the beginning position in the input
   * @param end the end position in the input
   * @param anchor the anchoring flag (UNANCHORED, ANCHOR_START, ANCHOR_BOTH)
   * @param group the array to fill with submatch positions
   * @param ngroup the number of array pairs to fill in
   * @returns true if a match was found
   */ matchWithGroup(input, start, end, anchor, ngroup) {
        if (!(input instanceof $4f6bfbff25a5c30c$var$MatcherInputBase)) input = $4f6bfbff25a5c30c$var$MatcherInput.utf16(input);
        return this.matchMachineInput(input, start, end, anchor, ngroup);
    }
    matchMachineInput(input, start, end, anchor, ngroup) {
        if (start > end) return [
            false,
            null
        ];
        const machineInput = input.isUTF16Encoding() ? $4f6bfbff25a5c30c$var$MachineInput.fromUTF16(input.asCharSequence(), 0, end) : $4f6bfbff25a5c30c$var$MachineInput.fromUTF8(input.asBytes(), 0, end);
        const groupMatch = this.doExecute(machineInput, start, anchor, 2 * ngroup);
        if (groupMatch === null) return [
            false,
            null
        ];
        return [
            true,
            groupMatch
        ];
    }
    /**
   * Returns true iff this regexp matches the UTF-8 byte array {@code b}.
   */ // This is visible for testing.
    matchUTF8(b) {
        return this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
   * Returns a copy of {@code src} in which all matches for this regexp have been replaced by
   * {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceAll(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 2 * src.length + 1);
    }
    /**
   * Returns a copy of {@code src} in which only the first match for this regexp has been replaced
   * by {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceFirst(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 1);
    }
    /**
   * Returns a copy of {@code src} in which at most {@code maxReplaces} matches for this regexp have
   * been replaced by the return value of of function {@code repl} (whose first argument is the
   * matched string). No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceAllFunc(src, replFunc, maxReplaces) {
        let lastMatchEnd = 0;
        let searchPos = 0;
        let out = '';
        const input = $4f6bfbff25a5c30c$var$MachineInput.fromUTF16(src);
        let numReplaces = 0;
        while(searchPos <= src.length){
            const a = this.doExecute(input, searchPos, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 2);
            if (a === null || a.length === 0) break;
            out += src.substring(lastMatchEnd, a[0]);
            if (a[1] > lastMatchEnd || a[0] === 0) {
                out += replFunc(src.substring(a[0], a[1]));
                numReplaces++;
            }
            lastMatchEnd = a[1];
            const width = input.step(searchPos) & 7;
            if (searchPos + width > a[1]) searchPos += width;
            else if (searchPos + 1 > a[1]) searchPos++;
            else searchPos = a[1];
            if (numReplaces >= maxReplaces) break;
        }
        out += src.substring(lastMatchEnd);
        return out;
    }
    // The number of capture values in the program may correspond
    // to fewer capturing expressions than are in the regexp.
    // For example, "(a){0}" turns into an empty program, so the
    // maximum capture in the program is 0 but we need to return
    // an expression for \1.  Pad returns a with -1s appended as needed;
    // the result may alias a.
    pad(a) {
        if (a === null) return null;
        let n = (1 + this.numSubexp) * 2;
        if (a.length < n) {
            let a2 = new Array(n).fill(-1);
            for(let i = 0; i < a.length; i++)a2[i] = a[i];
            a = a2;
        }
        return a;
    }
    // Find matches in input.
    allMatches(input, n, deliverFun = (v)=>v) {
        let result = [];
        const end = input.endPos();
        if (n < 0) n = end + 1;
        let pos = 0;
        let i = 0;
        let prevMatchEnd = -1;
        while(i < n && pos <= end){
            const matches = this.doExecute(input, pos, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, this.prog.numCap);
            if (matches === null || matches.length === 0) break;
            let accept = true;
            if (matches[1] === pos) {
                if (matches[0] === prevMatchEnd) accept = false;
                const r = input.step(pos);
                if (r < 0) pos = end + 1;
                else pos += r & 7;
            } else pos = matches[1];
            prevMatchEnd = matches[1];
            if (accept) {
                result.push(deliverFun(this.pad(matches)));
                i++;
            }
        }
        return result;
    }
    // Legacy Go-style interface; preserved (package-private) for better
    // test coverage.
    //
    // There are 16 methods of RE2 that match a regular expression and
    // identify the matched text.  Their names are matched by this regular
    // expression:
    //
    //    find(All)?(UTF8)?(Submatch)?(Index)?
    //
    // If 'All' is present, the routine matches successive non-overlapping
    // matches of the entire expression.  Empty matches abutting a
    // preceding match are ignored.  The return value is an array
    // containing the successive return values of the corresponding
    // non-All routine.  These routines take an extra integer argument, n;
    // if n >= 0, the function returns at most n matches/submatches.
    //
    // If 'UTF8' is present, the argument is a UTF-8 encoded byte[] array;
    // otherwise it is a UTF-16 encoded js string; return values
    // are adjusted as appropriate.
    //
    // If 'Submatch' is present, the return value is an list identifying
    // the successive submatches of the expression.  Submatches are
    // matches of parenthesized subexpressions within the regular
    // expression, numbered from left to right in order of opening
    // parenthesis.  Submatch 0 is the match of the entire expression,
    // submatch 1 the match of the first parenthesized subexpression, and
    // so on.
    //
    // If 'Index' is present, matches and submatches are identified by
    // byte index pairs within the input string: result[2*n:2*n+1]
    // identifies the indexes of the nth submatch.  The pair for n==0
    // identifies the match of the entire expression.  If 'Index' is not
    // present, the match is identified by the text of the match/submatch.
    // If an index is negative, it means that subexpression did not match
    // any string in the input.
    /**
   * Returns an array holding the text of the leftmost match in {@code b} of this regular
   * expression.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8(b) {
        const a = this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return b.slice(a[0], a[1]);
    }
    /**
   * Returns a two-element array of integers defining the location of the leftmost match in
   * {@code b} of this regular expression. The match itself is at {@code b[loc[0]...loc[1]]}.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8Index(b) {
        const a = this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return a.slice(0, 2);
    }
    /**
   * Returns a string holding the text of the leftmost match in {@code s} of this regular
   * expression.
   *
   * If there is no match, the return value is an empty string, but it will also be empty if the
   * regular expression successfully matches an empty string. Use {@link #findIndex} or
   * {@link #findSubmatch} if it is necessary to distinguish these cases.
   */ // This is visible for testing.
    find(s) {
        const a = this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 2);
        if (a === null) return '';
        return s.substring(a[0], a[1]);
    }
    /**
   * Returns a two-element array of integers defining the location of the leftmost match in
   * {@code s} of this regular expression. The match itself is at
   * {@code s.substring(loc[0], loc[1])}.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findIndex(s) {
        return this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, 2);
    }
    /**
   * Returns an array of arrays the text of the leftmost match of the regular expression in
   * {@code b} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8Submatch(b) {
        const a = this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = b.slice(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
   * Returns an array holding the index pairs identifying the leftmost match of this regular
   * expression in {@code b} and the matches, if any, of its subexpressions, as defined by the the
   * <a href='#submatch'>Submatch</a> and <a href='#index'>Index</a> descriptions above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8SubmatchIndex(b) {
        return this.pad(this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
   * Returns an array of strings holding the text of the leftmost match of the regular expression in
   * {@code s} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findSubmatch(s) {
        const a = this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = s.substring(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
   * Returns an array holding the index pairs identifying the leftmost match of this regular
   * expression in {@code s} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findSubmatchIndex(s) {
        return this.pad(this.doExecute($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), 0, $4f6bfbff25a5c30c$var$RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
   * {@code findAllUTF8()} is the <a href='#all'>All</a> version of {@link #findUTF8}; it returns a
   * list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   *
   * TODO(adonovan): think about defining a byte slice view class, like a read-only Go slice backed
   * by |b|.
   */ // This is visible for testing.
    findAllUTF8(b, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), n, (match)=>b.slice(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8Index} is the <a href='#all'>All</a> version of {@link #findUTF8Index}; it
   * returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8Index(b, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAll} is the <a href='#all'>All</a> version of {@link #find}; it returns a list of up
   * to {@code n} successive matches of the expression, as defined by the <a href='#all'>All</a>
   * description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAll(s, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), n, (match)=>s.substring(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllIndex} is the <a href='#all'>All</a> version of {@link #findIndex}; it returns a
   * list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllIndex(s, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8Submatch} is the <a href='#all'>All</a> version of {@link #findUTF8Submatch};
   * it returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8Submatch(b, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = b.slice(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8SubmatchIndex} is the <a href='#all'>All</a> version of
   * {@link #findUTF8SubmatchIndex}; it returns a list of up to {@code n} successive matches of the
   * expression, as defined by the <a href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8SubmatchIndex(b, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF8(b), n);
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllSubmatch} is the <a href='#all'>All</a> version of {@link #findSubmatch}; it
   * returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllSubmatch(s, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = s.substring(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllSubmatchIndex} is the <a href='#all'>All</a> version of
   * {@link #findSubmatchIndex}; it returns a list of up to {@code n} successive matches of the
   * expression, as defined by the <a href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllSubmatchIndex(s, n) {
        const result = this.allMatches($4f6bfbff25a5c30c$var$MachineInput.fromUTF16(s), n);
        if (result.length === 0) return null;
        return result;
    }
}
/**
 * A compiled representation of an RE2 regular expression
 *
 * The matching functions take {@code String} arguments instead of the more general Java
 * {@code CharSequence} since the latter doesn't provide UTF-16 decoding.
 *
 *
 * @author rsc@google.com (Russ Cox)
 * @class
 */ class $4f6bfbff25a5c30c$export$e46efc5f33420715 {
    /**
   * Flag: case insensitive matching.
   */ static CASE_INSENSITIVE = 1;
    /**
   * Flag: dot ({@code .}) matches all characters, including newline.
   */ static DOTALL = 2;
    /**
   * Flag: multiline matching: {@code ^} and {@code $} match at beginning and end of line, not just
   * beginning and end of input.
   */ static MULTILINE = 4;
    /**
   * Flag: Unicode groups (e.g. {@code \p\ Greek\} ) will be syntax errors.
   */ static DISABLE_UNICODE_GROUPS = 8;
    /**
   * Flag: matches longest possible string.
   */ static LONGEST_MATCH = 16;
    /**
   * Returns a literal pattern string for the specified string.
   *
   * This method produces a string that can be used to create a <code>RE2JS</code> that would
   * match the string <code>s</code> as if it were a literal pattern.
   *
   * Metacharacters or escape sequences in the input sequence will be given no special meaning.
   *
   * @param {string} str The string to be literalized
   * @returns {string} A literal string replacement
   */ static quote(str) {
        return $4f6bfbff25a5c30c$var$Utils.quoteMeta(str);
    }
    /**
   * Helper: create new RE2JS with given regex and flags. Flregex is the regex with flags applied.
   * @param {string} regex
   * @param {number} [flags=0]
   * @returns {RE2JS}
   */ static compile(regex, flags = 0) {
        let fregex = regex;
        if ((flags & $4f6bfbff25a5c30c$export$e46efc5f33420715.CASE_INSENSITIVE) !== 0) fregex = `(?i)${fregex}`;
        if ((flags & $4f6bfbff25a5c30c$export$e46efc5f33420715.DOTALL) !== 0) fregex = `(?s)${fregex}`;
        if ((flags & $4f6bfbff25a5c30c$export$e46efc5f33420715.MULTILINE) !== 0) fregex = `(?m)${fregex}`;
        if ((flags & ~($4f6bfbff25a5c30c$export$e46efc5f33420715.MULTILINE | $4f6bfbff25a5c30c$export$e46efc5f33420715.DOTALL | $4f6bfbff25a5c30c$export$e46efc5f33420715.CASE_INSENSITIVE | $4f6bfbff25a5c30c$export$e46efc5f33420715.DISABLE_UNICODE_GROUPS | $4f6bfbff25a5c30c$export$e46efc5f33420715.LONGEST_MATCH)) !== 0) throw new $4f6bfbff25a5c30c$export$fa1c64d63b2c22b1('Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH');
        let re2Flags = $4f6bfbff25a5c30c$var$RE2Flags.PERL;
        if ((flags & $4f6bfbff25a5c30c$export$e46efc5f33420715.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= ~$4f6bfbff25a5c30c$var$RE2Flags.UNICODE_GROUPS;
        const p = new $4f6bfbff25a5c30c$export$e46efc5f33420715(regex, flags);
        // The compiled RE2 regexp.
        p.re2Input = $4f6bfbff25a5c30c$var$RE2.compileImpl(fregex, re2Flags, (flags & $4f6bfbff25a5c30c$export$e46efc5f33420715.LONGEST_MATCH) !== 0);
        return p;
    }
    /**
   * Matches a string against a regular expression.
   *
   * @param {string} regex the regular expression
   * @param {string|number[]} input the input
   * @returns {boolean} true if the regular expression matches the entire input
   * @throws RE2JSSyntaxException if the regular expression is malformed
   */ static matches(regex, input) {
        return $4f6bfbff25a5c30c$export$e46efc5f33420715.compile(regex).matcher(input).matches();
    }
    /**
   * This is visible for testing.
   * @private
   */ static initTest(pattern, flags, re2) {
        if (pattern == null) throw new Error('pattern is null');
        if (re2 == null) throw new Error('re2 is null');
        const p = new $4f6bfbff25a5c30c$export$e46efc5f33420715(pattern, flags);
        // The compiled RE2 regexp.
        p.re2Input = re2;
        return p;
    }
    /**
   *
   * @param {string} pattern
   * @param {number} flags
   */ constructor(pattern, flags){
        // The pattern string at construction time.
        this.patternInput = pattern;
        // The flags at construction time.
        this.flagsInput = flags;
    }
    /**
   * Releases memory used by internal caches associated with this pattern. Does not change the
   * observable behaviour. Useful for tests that detect memory leaks via allocation tracking.
   */ reset() {
        this.re2Input.reset();
    }
    /**
   * Returns the flags used in the constructor.
   * @returns {number}
   */ flags() {
        return this.flagsInput;
    }
    /**
   * Returns the pattern used in the constructor.
   * @returns {string}
   */ pattern() {
        return this.patternInput;
    }
    re2() {
        return this.re2Input;
    }
    /**
   * Matches a string against a regular expression.
   *
   * @param {string|number[]} input the input
   * @returns {boolean} true if the regular expression matches the entire input
   */ matches(input) {
        return this.matcher(input).matches();
    }
    /**
   * Creates a new {@code Matcher} matching the pattern against the input.
   *
   * @param {string|number[]} input the input string
   * @returns {Matcher}
   */ matcher(input) {
        if (Array.isArray(input)) input = $4f6bfbff25a5c30c$var$MatcherInput.utf8(input);
        return new $4f6bfbff25a5c30c$var$Matcher(this, input);
    }
    /**
   * Splits input around instances of the regular expression. It returns an array giving the strings
   * that occur before, between, and after instances of the regular expression.
   *
   * If {@code limit <= 0}, there is no limit on the size of the returned array. If
   * {@code limit == 0}, empty strings that would occur at the end of the array are omitted. If
   * {@code limit > 0}, at most limit strings are returned. The final string contains the remainder
   * of the input, possibly including additional matches of the pattern.
   *
   * @param {string} input the input string to be split
   * @param {number} [limit=0] the limit
   * @returns {string[]} the split strings
   */ split(input, limit = 0) {
        const m = this.matcher(input);
        const result = [];
        let emptiesSkipped = 0;
        let last = 0;
        while(m.find()){
            if (last === 0 && m.end() === 0) {
                // Zero-width match at the beginning, skip
                last = m.end();
                continue;
            }
            if (limit > 0 && result.length === limit - 1) break;
            if (last === m.start()) // Empty match, may or may not be trailing.
            {
                if (limit === 0) {
                    emptiesSkipped += 1;
                    last = m.end();
                    continue;
                }
            } else // If emptiesSkipped > 0 then limit == 0 and we have non-trailing empty matches to add before
            // this non-empty match.
            while(emptiesSkipped > 0){
                result.push('');
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.start()));
            last = m.end();
        }
        if (limit === 0 && last !== m.inputLength()) {
            // Unlimited match, no more delimiters but we have a non-empty input at the end. Catch up any skipped empty
            // matches, then emit the final match.
            while(emptiesSkipped > 0){
                result.push('');
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.inputLength()));
        }
        if (limit !== 0 || result.length === 0) result.push(m.substring(last, m.inputLength()));
        return result;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        return this.patternInput;
    }
    /**
   * Returns the number of capturing groups in this matcher's pattern. Group zero denotes the entire
   * pattern and is excluded from this count.
   *
   * @returns {number} the number of capturing groups in this pattern
   */ groupCount() {
        return this.re2Input.numberOfCapturingGroups();
    }
    /**
   * Return a map of the capturing groups in this matcher's pattern, where key is the name and value
   * is the index of the group in the pattern.
   * @returns {*}
   */ namedGroups() {
        return this.re2Input.namedGroups;
    }
    /**
   *
   * @param {*} other
   * @returns {boolean}
   */ equals(other) {
        if (this === other) return true;
        if (other === null || this.constructor !== other.constructor) return false;
        return this.flagsInput === other.flagsInput && this.patternInput === other.patternInput;
    }
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $b1c6e3a850a3c735$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class $b1c6e3a850a3c735$var$User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ $b1c6e3a850a3c735$var$User.UNAUTHENTICATED = new $b1c6e3a850a3c735$var$User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
$b1c6e3a850a3c735$var$User.GOOGLE_CREDENTIALS = new $b1c6e3a850a3c735$var$User("google-credentials-uid"), $b1c6e3a850a3c735$var$User.FIRST_PARTY = new $b1c6e3a850a3c735$var$User("first-party-uid"), $b1c6e3a850a3c735$var$User.MOCK_USER = new $b1c6e3a850a3c735$var$User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $b1c6e3a850a3c735$var$v = "12.15.0";
function $b1c6e3a850a3c735$export$71511d61b312f219(e) {
    $b1c6e3a850a3c735$var$v = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$S = new (0, $59d1e3b150b2f36d$export$efa9a398d6368992)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function $b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() {
    return $b1c6e3a850a3c735$var$S.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function $b1c6e3a850a3c735$export$7a0bdf7d4a91ea88(e) {
    $b1c6e3a850a3c735$var$S.setLogLevel(e);
}
function $b1c6e3a850a3c735$export$306ddfe3a8403e2(e, ...t) {
    if ($b1c6e3a850a3c735$var$S.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) {
        const n = t.map($b1c6e3a850a3c735$var$__PRIVATE_argToString);
        $b1c6e3a850a3c735$var$S.debug(`Firestore (${$b1c6e3a850a3c735$var$v}): ${e}`, ...n);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_logError(e, ...t) {
    if ($b1c6e3a850a3c735$var$S.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).ERROR) {
        const n = t.map($b1c6e3a850a3c735$var$__PRIVATE_argToString);
        $b1c6e3a850a3c735$var$S.error(`Firestore (${$b1c6e3a850a3c735$var$v}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(e, ...t) {
    if ($b1c6e3a850a3c735$var$S.logLevel <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).WARN) {
        const n = t.map($b1c6e3a850a3c735$var$__PRIVATE_argToString);
        $b1c6e3a850a3c735$var$S.warn(`Firestore (${$b1c6e3a850a3c735$var$v}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1c6e3a850a3c735$export$8743009a87fcb00f(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, $b1c6e3a850a3c735$var$__PRIVATE__fail(e, r, n);
}
function $b1c6e3a850a3c735$var$__PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${$b1c6e3a850a3c735$var$v}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw $b1c6e3a850a3c735$var$__PRIVATE_logError(r), new Error(r);
}
function $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || $b1c6e3a850a3c735$var$__PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function $b1c6e3a850a3c735$export$a05254e7c3aeba6e(e, t) {
    e || $b1c6e3a850a3c735$export$8743009a87fcb00f(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$export$f1e1789686576879 = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class $b1c6e3a850a3c735$export$4368d992c4eafac0 extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class $b1c6e3a850a3c735$export$a33b77bbdbb8366c {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t($b1c6e3a850a3c735$var$User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class $b1c6e3a850a3c735$export$407448d2b89b1813 {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = $b1c6e3a850a3c735$var$User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            $b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                ($b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                l: t
            }), new $b1c6e3a850a3c735$var$__PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
            h: e
        }), new $b1c6e3a850a3c735$var$User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.T = e, this.P = t, this.R = n, this.type = "FirstParty", this.user = $b1c6e3a850a3c735$var$User.FIRST_PARTY, this.I = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ A() {
        return this.R ? this.R() : null;
    }
    get headers() {
        this.I.set("X-Goog-AuthUser", this.T);
        // Use array notation to prevent minification
        const e = this.A();
        return e && this.I.set("Authorization", e), this.P && this.I.set("X-Goog-Iam-Authorization-Token", this.P), this.I;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.T = e, this.P = t, this.R = n;
    }
    getToken() {
        return Promise.resolve(new $b1c6e3a850a3c735$var$__PRIVATE_FirstPartyToken(this.T, this.P, this.R));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t($b1c6e3a850a3c735$var$User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class $b1c6e3a850a3c735$var$AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class $b1c6e3a850a3c735$export$8b22cf2602fb60ce {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && $b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, $b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            $b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                $b1c6e3a850a3c735$export$306ddfe3a8403e2("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new $b1c6e3a850a3c735$var$AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new $b1c6e3a850a3c735$var$AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class $b1c6e3a850a3c735$export$53a70dd1ebbae346 {
    getToken() {
        return Promise.resolve(new $b1c6e3a850a3c735$var$AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class $b1c6e3a850a3c735$export$971d5caa766a69d7 {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = $b1c6e3a850a3c735$var$__PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function $b1c6e3a850a3c735$var$__PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return $b1c6e3a850a3c735$var$__PRIVATE_isSurrogate(n) === $b1c6e3a850a3c735$var$__PRIVATE_isSurrogate(i) ? $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n, i) : $b1c6e3a850a3c735$var$__PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.length, t.length);
}
const $b1c6e3a850a3c735$var$x = 55296, $b1c6e3a850a3c735$var$C = 57343;
function $b1c6e3a850a3c735$var$__PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= $b1c6e3a850a3c735$var$x && t <= $b1c6e3a850a3c735$var$C;
}
/** Helper to compare arrays using isEqual(). */ function $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Verifies equality for an optional value.
 */ function $b1c6e3a850a3c735$export$7060da4b5db56fb9(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$F = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class $b1c6e3a850a3c735$var$BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && $b1c6e3a850a3c735$export$8743009a87fcb00f(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && $b1c6e3a850a3c735$export$8743009a87fcb00f(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === $b1c6e3a850a3c735$var$BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof $b1c6e3a850a3c735$var$BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = $b1c6e3a850a3c735$var$BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = $b1c6e3a850a3c735$var$BasePath.isNumericId(e), r = $b1c6e3a850a3c735$var$BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? $b1c6e3a850a3c735$var$BasePath.extractNumericId(e).compare($b1c6e3a850a3c735$var$BasePath.extractNumericId(t)) : $b1c6e3a850a3c735$var$__PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, $906344b47e605252$export$70ffa26850098d01).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class $b1c6e3a850a3c735$export$db202ddc8be9136 extends $b1c6e3a850a3c735$var$BasePath {
    construct(e, t, n) {
        return new $b1c6e3a850a3c735$export$db202ddc8be9136(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    toStringWithLeadingSlash() {
        return `/${this.canonicalString()}`;
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new $b1c6e3a850a3c735$export$db202ddc8be9136(t);
    }
    static emptyPath() {
        return new $b1c6e3a850a3c735$export$db202ddc8be9136([]);
    }
}
const $b1c6e3a850a3c735$var$O = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class $b1c6e3a850a3c735$export$b9a6b53f9be3734 extends $b1c6e3a850a3c735$var$BasePath {
    construct(e, t, n) {
        return new $b1c6e3a850a3c735$export$b9a6b53f9be3734(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return $b1c6e3a850a3c735$var$O.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), $b1c6e3a850a3c735$export$b9a6b53f9be3734.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === $b1c6e3a850a3c735$var$F;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new $b1c6e3a850a3c735$export$b9a6b53f9be3734([
            $b1c6e3a850a3c735$var$F
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new $b1c6e3a850a3c735$export$b9a6b53f9be3734(t);
    }
    static emptyPath() {
        return new $b1c6e3a850a3c735$export$b9a6b53f9be3734([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class $b1c6e3a850a3c735$export$90a7f3efeed30595 {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(e));
    }
    static fromName(e) {
        return new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(e).popFirst(5));
    }
    static empty() {
        return new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === $b1c6e3a850a3c735$export$db202ddc8be9136.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return $b1c6e3a850a3c735$export$db202ddc8be9136.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new $b1c6e3a850a3c735$export$90a7f3efeed30595(new $b1c6e3a850a3c735$export$db202ddc8be9136(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function $b1c6e3a850a3c735$export$faec65b429be379(e, t, n, r) {
    if (!0 === t && !0 === r) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_validateDocumentPath(e) {
    if (!$b1c6e3a850a3c735$export$90a7f3efeed30595.isDocumentKey(e)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_validateCollectionPath(e) {
    if ($b1c6e3a850a3c735$export$90a7f3efeed30595.isDocumentKey(e)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function $b1c6e3a850a3c735$export$2538633961795d6b(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function $b1c6e3a850a3c735$export$efccba1c4a2ef57b(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : $b1c6e3a850a3c735$export$8743009a87fcb00f(12329, {
        type: typeof e
    });
}
function $b1c6e3a850a3c735$export$4a5767248b18ef41(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = $b1c6e3a850a3c735$export$efccba1c4a2ef57b(e);
            throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function $b1c6e3a850a3c735$export$953cecd6e717a553(e, t) {
    if (t <= 0) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function $b1c6e3a850a3c735$export$ffb5f4729a158638(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function $b1c6e3a850a3c735$export$9bb611d729802a56(e, t) {
    if (!$b1c6e3a850a3c735$export$2538633961795d6b(e)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _ = e[r];
        if (i && typeof _ !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && _ !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const $b1c6e3a850a3c735$var$M = -62135596800, $b1c6e3a850a3c735$var$N = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class $b1c6e3a850a3c735$export$890c4ad488842ce7 {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return $b1c6e3a850a3c735$export$890c4ad488842ce7.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return $b1c6e3a850a3c735$export$890c4ad488842ce7.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * $b1c6e3a850a3c735$var$N);
        return new $b1c6e3a850a3c735$export$890c4ad488842ce7(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < $b1c6e3a850a3c735$var$M) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / $b1c6e3a850a3c735$var$N;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: $b1c6e3a850a3c735$export$890c4ad488842ce7._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if ($b1c6e3a850a3c735$export$9bb611d729802a56(e, $b1c6e3a850a3c735$export$890c4ad488842ce7._jsonSchema)) return new $b1c6e3a850a3c735$export$890c4ad488842ce7(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - $b1c6e3a850a3c735$var$M;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
$b1c6e3a850a3c735$export$890c4ad488842ce7._jsonSchemaVersion = "firestore/timestamp/1.0", $b1c6e3a850a3c735$export$890c4ad488842ce7._jsonSchema = {
    type: $b1c6e3a850a3c735$export$ffb5f4729a158638("string", $b1c6e3a850a3c735$export$890c4ad488842ce7._jsonSchemaVersion),
    seconds: $b1c6e3a850a3c735$export$ffb5f4729a158638("number"),
    nanoseconds: $b1c6e3a850a3c735$export$ffb5f4729a158638("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class $b1c6e3a850a3c735$var$SnapshotVersion {
    static fromTimestamp(e) {
        return new $b1c6e3a850a3c735$var$SnapshotVersion(e);
    }
    static min() {
        return new $b1c6e3a850a3c735$var$SnapshotVersion(new $b1c6e3a850a3c735$export$890c4ad488842ce7(0, 0));
    }
    static max() {
        return new $b1c6e3a850a3c735$var$SnapshotVersion(new $b1c6e3a850a3c735$export$890c4ad488842ce7(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const $b1c6e3a850a3c735$var$L = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class $b1c6e3a850a3c735$export$3b513254972cfc9c {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = $b1c6e3a850a3c735$var$__PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ $b1c6e3a850a3c735$export$3b513254972cfc9c.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class $b1c6e3a850a3c735$export$f38c853ae54ed474 {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_indexSegmentComparator(e, t) {
    const n = $b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class $b1c6e3a850a3c735$export$21579262ef46735b {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new $b1c6e3a850a3c735$export$21579262ef46735b(0, $b1c6e3a850a3c735$var$IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = $b1c6e3a850a3c735$var$SnapshotVersion.fromTimestamp(1e9 === r ? new $b1c6e3a850a3c735$export$890c4ad488842ce7(n + 1, 0) : new $b1c6e3a850a3c735$export$890c4ad488842ce7(n, r));
    return new $b1c6e3a850a3c735$var$IndexOffset(i, $b1c6e3a850a3c735$export$90a7f3efeed30595.empty(), t);
}
/** Creates a new offset based on the provided document. */ function $b1c6e3a850a3c735$var$__PRIVATE_newIndexOffsetFromDocument(e) {
    return new $b1c6e3a850a3c735$var$IndexOffset(e.readTime, e.key, $b1c6e3a850a3c735$var$L);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class $b1c6e3a850a3c735$var$IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new $b1c6e3a850a3c735$var$IndexOffset($b1c6e3a850a3c735$var$SnapshotVersion.min(), $b1c6e3a850a3c735$export$90a7f3efeed30595.empty(), $b1c6e3a850a3c735$var$L);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new $b1c6e3a850a3c735$var$IndexOffset($b1c6e3a850a3c735$var$SnapshotVersion.max(), $b1c6e3a850a3c735$export$90a7f3efeed30595.empty(), $b1c6e3a850a3c735$var$L);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.documentKey, t.documentKey), 0 !== n ? n : $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$B = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class $b1c6e3a850a3c735$var$PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== $b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION || e.message !== $b1c6e3a850a3c735$var$B) throw e;
    $b1c6e3a850a3c735$export$306ddfe3a8403e2("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class $b1c6e3a850a3c735$var$PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && $b1c6e3a850a3c735$export$8743009a87fcb00f(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new $b1c6e3a850a3c735$var$PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof $b1c6e3a850a3c735$var$PersistencePromise ? t : $b1c6e3a850a3c735$var$PersistencePromise.resolve(t);
        } catch (e) {
            return $b1c6e3a850a3c735$var$PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $b1c6e3a850a3c735$var$PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : $b1c6e3a850a3c735$var$PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new $b1c6e3a850a3c735$var$PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new $b1c6e3a850a3c735$var$PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new $b1c6e3a850a3c735$var$PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = $b1c6e3a850a3c735$var$PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new $b1c6e3a850a3c735$var$PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let _ = 0;
            for(let o = 0; o < i; o++){
                const a = o;
                t(e[a]).next((e)=>{
                    s[a] = e, ++_, _ === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new $b1c6e3a850a3c735$var$PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const $b1c6e3a850a3c735$var$U = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new $b1c6e3a850a3c735$var$__PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.v = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.v.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.v.reject(new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransactionError(e, t.error)) : this.v.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = $b1c6e3a850a3c735$var$__PRIVATE_checkForAndReportiOSError(t.target.error);
            this.v.reject(new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get S() {
        return this.v.promise;
    }
    abort(e) {
        e && this.v.reject(e), this.aborted || ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    D() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new $b1c6e3a850a3c735$var$__PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "Removing database:", e);
        return $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest((0, $029952e65115eee5$export$a4e55266d2135a7f)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static C() {
        if (!(0, $029952e65115eee5$export$3865db50535c2055)()) return !1;
        if ($b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, $029952e65115eee5$export$c36915b22ce77c19)(), t = $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.O(e), n = 0 < t && t < 10, r = $b1c6e3a850a3c735$var$__PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static M(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static O(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.N = n, this.L = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.O((0, $029952e65115eee5$export$c36915b22ce77c19)()) && $b1c6e3a850a3c735$var$__PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async B(e) {
        return this.db || ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.N.U(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.k && (this.db.onversionchange = (e)=>this.k(e)), this.db;
    }
    q(e) {
        this.k = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.B(e);
                const t = $b1c6e3a850a3c735$var$__PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.D(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), $b1c6e3a850a3c735$var$PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.S, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function $b1c6e3a850a3c735$var$__PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IterationController {
    constructor(e){
        this.$ = e, this.K = !1, this.W = null;
    }
    get isDone() {
        return this.K;
    }
    get G() {
        return this.W;
    }
    set cursor(e) {
        this.$ = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.K = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ j(e) {
        this.W = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(this.$.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransactionError extends $b1c6e3a850a3c735$export$4368d992c4eafac0 {
    constructor(e, t){
        super($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function $b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "ADD", this.store.name, e, e);
        return $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "DELETE", this.store.name, e);
        return $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "COUNT", this.store.name);
        return $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(this.store.count());
    }
    H(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new $b1c6e3a850a3c735$var$PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.J(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Y(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new $b1c6e3a850a3c735$var$PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    Z(e, t) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$U, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.X = !1;
        const r = this.cursor(n);
        return this.J(r, (e, t, n)=>n.delete());
    }
    ee(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.J(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ te(e) {
        const t = this.cursor({});
        return new $b1c6e3a850a3c735$var$PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = $b1c6e3a850a3c735$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    J(e, t) {
        const n = [];
        return new $b1c6e3a850a3c735$var$PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new $b1c6e3a850a3c735$var$__PRIVATE_IterationController(i), _ = t(i.primaryKey, i.value, s);
                if (_ instanceof $b1c6e3a850a3c735$var$PersistencePromise) {
                    const e = _.catch((e)=>(s.done(), $b1c6e3a850a3c735$var$PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.G ? i.continue() : i.continue(s.G);
            };
        }).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.X ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_wrapRequest(e) {
    return new $b1c6e3a850a3c735$var$PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = $b1c6e3a850a3c735$var$__PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let $b1c6e3a850a3c735$var$k = !1;
function $b1c6e3a850a3c735$var$__PRIVATE_checkForAndReportiOSError(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.O((0, $029952e65115eee5$export$c36915b22ce77c19)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new $b1c6e3a850a3c735$export$4368d992c4eafac0("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return $b1c6e3a850a3c735$var$k || ($b1c6e3a850a3c735$var$k = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const $b1c6e3a850a3c735$var$q = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ne = t, this.task = null;
    }
    start() {
        this.re(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    re(e) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$q, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ne.ie();
                $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$q, `Documents written: ${e}`);
            } catch (e) {
                $b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e) ? $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$q, "Ignoring IndexedDB error during index backfill: ", e) : await $b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.re(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ie(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.se(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ se(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return $b1c6e3a850a3c735$var$PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$q, `Processing collection: ${t}`), this._e(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ _e(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.oe(r, n)).next((n)=>($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$q, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ oe(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = $b1c6e3a850a3c735$var$__PRIVATE_newIndexOffsetFromDocument(t);
            $b1c6e3a850a3c735$var$__PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new $b1c6e3a850a3c735$var$IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ae(e), this.ue = (e)=>t.writeSequenceNumber(e));
    }
    ae(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ue && this.ue(e), e;
    }
}
$b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $b1c6e3a850a3c735$var$$ = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function $b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function $b1c6e3a850a3c735$export$56350196709588fc(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function $b1c6e3a850a3c735$var$isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !$b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function $b1c6e3a850a3c735$export$c5d1328b37d47994(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$K = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = $b1c6e3a850a3c735$var$__PRIVATE_encodeSeparator(t)), t = $b1c6e3a850a3c735$var$__PRIVATE_encodeSegment(e.get(n), t);
    return $b1c6e3a850a3c735$var$__PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function $b1c6e3a850a3c735$var$__PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case $b1c6e3a850a3c735$var$K:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function $b1c6e3a850a3c735$var$__PRIVATE_encodeSeparator(e) {
    return e + $b1c6e3a850a3c735$var$K + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.charAt(0) === $b1c6e3a850a3c735$var$K && "" === e.charAt(1), 56145, {
        path: e
    }), $b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf($b1c6e3a850a3c735$var$K, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && $b1c6e3a850a3c735$export$8743009a87fcb00f(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let _;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                _ = s : (r += s, _ = r, r = ""), n.push(_);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                $b1c6e3a850a3c735$export$8743009a87fcb00f(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new $b1c6e3a850a3c735$export$db202ddc8be9136(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$W = "remoteDocuments", $b1c6e3a850a3c735$var$Q = "owner", $b1c6e3a850a3c735$var$G = "owner", $b1c6e3a850a3c735$var$z = "mutationQueues", $b1c6e3a850a3c735$var$j = "userId", $b1c6e3a850a3c735$var$H = "mutations", $b1c6e3a850a3c735$var$J = "batchId", $b1c6e3a850a3c735$var$Y = "userMutationsIndex", $b1c6e3a850a3c735$var$Z = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const $b1c6e3a850a3c735$var$X = {}, $b1c6e3a850a3c735$var$ee = "documentMutations", $b1c6e3a850a3c735$var$te = "remoteDocumentsV14", $b1c6e3a850a3c735$var$ne = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], $b1c6e3a850a3c735$var$re = "documentKeyIndex", $b1c6e3a850a3c735$var$ie = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], $b1c6e3a850a3c735$var$se = "collectionGroupIndex", $b1c6e3a850a3c735$var$_e = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], $b1c6e3a850a3c735$var$oe = "remoteDocumentGlobal", $b1c6e3a850a3c735$var$ae = "remoteDocumentGlobalKey", $b1c6e3a850a3c735$var$ue = "targets", $b1c6e3a850a3c735$var$ce = "queryTargetsIndex", $b1c6e3a850a3c735$var$le = [
    "canonicalId",
    "targetId"
], $b1c6e3a850a3c735$var$Ee = "targetDocuments", $b1c6e3a850a3c735$var$he = [
    "targetId",
    "path"
], $b1c6e3a850a3c735$var$Te = "documentTargetsIndex", $b1c6e3a850a3c735$var$Pe = [
    "path",
    "targetId"
], $b1c6e3a850a3c735$var$Re = "targetGlobalKey", $b1c6e3a850a3c735$var$Ie = "targetGlobal", $b1c6e3a850a3c735$var$Ae = "collectionParents", $b1c6e3a850a3c735$var$Ve = [
    "collectionId",
    "parent"
], $b1c6e3a850a3c735$var$de = "clientMetadata", $b1c6e3a850a3c735$var$fe = "clientId", $b1c6e3a850a3c735$var$me = "bundles", $b1c6e3a850a3c735$var$pe = "bundleId", $b1c6e3a850a3c735$var$ge = "namedQueries", $b1c6e3a850a3c735$var$ye = "name", $b1c6e3a850a3c735$var$we = "indexConfiguration", $b1c6e3a850a3c735$var$be = "indexId", $b1c6e3a850a3c735$var$ve = "collectionGroupIndex", $b1c6e3a850a3c735$var$Se = "collectionGroup", $b1c6e3a850a3c735$var$De = "indexState", $b1c6e3a850a3c735$var$xe = [
    "indexId",
    "uid"
], $b1c6e3a850a3c735$var$Ce = "sequenceNumberIndex", $b1c6e3a850a3c735$var$Fe = [
    "uid",
    "sequenceNumber"
], $b1c6e3a850a3c735$var$Oe = "indexEntries", $b1c6e3a850a3c735$var$Me = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], $b1c6e3a850a3c735$var$Ne = "documentKeyIndex", $b1c6e3a850a3c735$var$Le = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], $b1c6e3a850a3c735$var$Be = "documentOverlays", $b1c6e3a850a3c735$var$Ue = [
    "userId",
    "collectionPath",
    "documentId"
], $b1c6e3a850a3c735$var$ke = "collectionPathOverlayIndex", $b1c6e3a850a3c735$var$qe = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $b1c6e3a850a3c735$var$$e = "collectionGroupOverlayIndex", $b1c6e3a850a3c735$var$Ke = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], $b1c6e3a850a3c735$var$We = "globals", $b1c6e3a850a3c735$var$Qe = "name", $b1c6e3a850a3c735$var$Ge = [
    $b1c6e3a850a3c735$var$z,
    $b1c6e3a850a3c735$var$H,
    $b1c6e3a850a3c735$var$ee,
    $b1c6e3a850a3c735$var$W,
    $b1c6e3a850a3c735$var$ue,
    $b1c6e3a850a3c735$var$Q,
    $b1c6e3a850a3c735$var$Ie,
    $b1c6e3a850a3c735$var$Ee,
    $b1c6e3a850a3c735$var$de,
    $b1c6e3a850a3c735$var$oe,
    $b1c6e3a850a3c735$var$Ae,
    $b1c6e3a850a3c735$var$me,
    $b1c6e3a850a3c735$var$ge
], $b1c6e3a850a3c735$var$ze = [
    ...$b1c6e3a850a3c735$var$Ge,
    $b1c6e3a850a3c735$var$Be
], $b1c6e3a850a3c735$var$je = [
    $b1c6e3a850a3c735$var$z,
    $b1c6e3a850a3c735$var$H,
    $b1c6e3a850a3c735$var$ee,
    $b1c6e3a850a3c735$var$te,
    $b1c6e3a850a3c735$var$ue,
    $b1c6e3a850a3c735$var$Q,
    $b1c6e3a850a3c735$var$Ie,
    $b1c6e3a850a3c735$var$Ee,
    $b1c6e3a850a3c735$var$de,
    $b1c6e3a850a3c735$var$oe,
    $b1c6e3a850a3c735$var$Ae,
    $b1c6e3a850a3c735$var$me,
    $b1c6e3a850a3c735$var$ge,
    $b1c6e3a850a3c735$var$Be
], $b1c6e3a850a3c735$var$He = $b1c6e3a850a3c735$var$je, $b1c6e3a850a3c735$var$Je = [
    ...$b1c6e3a850a3c735$var$He,
    $b1c6e3a850a3c735$var$we,
    $b1c6e3a850a3c735$var$De,
    $b1c6e3a850a3c735$var$Oe
], $b1c6e3a850a3c735$var$Ye = $b1c6e3a850a3c735$var$Je, $b1c6e3a850a3c735$var$Ze = [
    ...$b1c6e3a850a3c735$var$Je,
    $b1c6e3a850a3c735$var$We
], $b1c6e3a850a3c735$var$Xe = $b1c6e3a850a3c735$var$Ze;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransaction extends $b1c6e3a850a3c735$var$PersistenceTransaction {
    constructor(e, t){
        super(), this.le = e, this.currentSequenceNumber = t;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.M(n.le, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class $b1c6e3a850a3c735$var$SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || $b1c6e3a850a3c735$var$LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new $b1c6e3a850a3c735$var$SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, $b1c6e3a850a3c735$var$LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new $b1c6e3a850a3c735$var$SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, $b1c6e3a850a3c735$var$LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new $b1c6e3a850a3c735$var$SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new $b1c6e3a850a3c735$var$SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new $b1c6e3a850a3c735$var$SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new $b1c6e3a850a3c735$var$SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class $b1c6e3a850a3c735$var$SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class $b1c6e3a850a3c735$var$LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : $b1c6e3a850a3c735$var$LLRBNode.RED, this.left = null != r ? r : $b1c6e3a850a3c735$var$LLRBNode.EMPTY, this.right = null != i ? i : $b1c6e3a850a3c735$var$LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new $b1c6e3a850a3c735$var$LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return $b1c6e3a850a3c735$var$LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return $b1c6e3a850a3c735$var$LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, $b1c6e3a850a3c735$var$LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, $b1c6e3a850a3c735$var$LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$b1c6e3a850a3c735$var$LLRBNode.EMPTY = null, $b1c6e3a850a3c735$var$LLRBNode.RED = !0, $b1c6e3a850a3c735$var$LLRBNode.BLACK = !1;
// end LLRBEmptyNode
$b1c6e3a850a3c735$var$LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw $b1c6e3a850a3c735$export$8743009a87fcb00f(57766);
    }
    get value() {
        throw $b1c6e3a850a3c735$export$8743009a87fcb00f(16141);
    }
    get color() {
        throw $b1c6e3a850a3c735$export$8743009a87fcb00f(16727);
    }
    get left() {
        throw $b1c6e3a850a3c735$export$8743009a87fcb00f(29726);
    }
    get right() {
        throw $b1c6e3a850a3c735$export$8743009a87fcb00f(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new $b1c6e3a850a3c735$var$LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class $b1c6e3a850a3c735$var$SortedSet {
    constructor(e){
        this.comparator = e, this.data = new $b1c6e3a850a3c735$var$SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new $b1c6e3a850a3c735$var$SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new $b1c6e3a850a3c735$var$SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof $b1c6e3a850a3c735$var$SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new $b1c6e3a850a3c735$var$SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class $b1c6e3a850a3c735$var$SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class $b1c6e3a850a3c735$var$FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort($b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator);
    }
    static empty() {
        return new $b1c6e3a850a3c735$var$FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new $b1c6e3a850a3c735$var$FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function $b1c6e3a850a3c735$var$forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function $b1c6e3a850a3c735$export$a9c23c6ac3fc3eca(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function $b1c6e3a850a3c735$var$isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function $b1c6e3a850a3c735$export$9f4f30ee63539e24() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class $b1c6e3a850a3c735$export$158acd800e1ef08b {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new $b1c6e3a850a3c735$var$__PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new $b1c6e3a850a3c735$export$158acd800e1ef08b(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new $b1c6e3a850a3c735$export$158acd800e1ef08b(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
$b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING = new $b1c6e3a850a3c735$export$158acd800e1ef08b("");
const $b1c6e3a850a3c735$var$et = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = $b1c6e3a850a3c735$var$et.exec(e);
        if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.seconds),
        nanos: $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? $b1c6e3a850a3c735$export$158acd800e1ef08b.fromBase64String(e) : $b1c6e3a850a3c735$export$158acd800e1ef08b.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const $b1c6e3a850a3c735$var$tt = "server_timestamp", $b1c6e3a850a3c735$var$nt = "__type__", $b1c6e3a850a3c735$var$rt = "__previous_value__", $b1c6e3a850a3c735$var$it = "__local_write_time__";
function $b1c6e3a850a3c735$export$2408f22a0fab9ae5(e) {
    const t = (e?.mapValue?.fields || {})[$b1c6e3a850a3c735$var$nt]?.stringValue;
    return t === $b1c6e3a850a3c735$var$tt;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[$b1c6e3a850a3c735$var$rt];
    return $b1c6e3a850a3c735$export$2408f22a0fab9ae5(t) ? $b1c6e3a850a3c735$var$__PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e.mapValue.fields[$b1c6e3a850a3c735$var$it].timestampValue);
    return new $b1c6e3a850a3c735$export$890c4ad488842ce7(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions - Options that configure long-polling.
     * @param useFetchStreams - Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, _, o, a, u, c){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = _, this.longPollingOptions = o, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c;
    }
}
/** The default database name for a project. */ const $b1c6e3a850a3c735$var$st = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class $b1c6e3a850a3c735$export$cf2f7c5792f80b46 {
    constructor(e, t){
        this.projectId = e, this.database = t || $b1c6e3a850a3c735$var$st;
    }
    static empty() {
        return new $b1c6e3a850a3c735$export$cf2f7c5792f80b46("", "");
    }
    get isDefaultDatabase() {
        return this.database === $b1c6e3a850a3c735$var$st;
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$export$cf2f7c5792f80b46 && e.projectId === this.projectId && e.database === this.database;
    }
}
function $b1c6e3a850a3c735$export$db3b6bfb95261072(e, t) {
    if (!Object.prototype.hasOwnProperty.apply(e.options, [
        "projectId"
    ])) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new $b1c6e3a850a3c735$export$cf2f7c5792f80b46(e.options.projectId, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$_t = "__type__", $b1c6e3a850a3c735$var$ot = "__max__", $b1c6e3a850a3c735$var$at = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: $b1c6e3a850a3c735$var$ot
            }
        }
    }
}, $b1c6e3a850a3c735$var$ut = "__vector__", $b1c6e3a850a3c735$var$ct = "value", $b1c6e3a850a3c735$var$lt = {
    nullValue: "NULL_VALUE"
}, $b1c6e3a850a3c735$var$Et = {
    booleanValue: !0
}, $b1c6e3a850a3c735$var$ht = {
    booleanValue: !1
};
/** Extracts the backend's type order for the provided value. */ function $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? $b1c6e3a850a3c735$export$2408f22a0fab9ae5(e) ? 4 /* TypeOrder.ServerTimestampValue */  : $b1c6e3a850a3c735$var$__PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : $b1c6e3a850a3c735$export$8743009a87fcb00f(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e, t, n) {
    if (e === t) return !0;
    const r = $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e);
    if (r !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t)) return !1;
    switch(r){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(e).isEqual($b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e.timestampValue), r = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e.bytesValue).isEqual($b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.geoPointValue.latitude) === $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.geoPointValue.latitude) && $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.geoPointValue.longitude) === $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t, n) {
                if ("integerValue" in e && "integerValue" in t) return $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.integerValue) === $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.integerValue);
                let r, i;
                if ("doubleValue" in e && "doubleValue" in t) r = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.doubleValue), i = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.doubleValue);
                else {
                    if (!n?.Ee) return !1;
                    r = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.integerValue ?? e.doubleValue), i = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.integerValue ?? t.doubleValue);
                }
                if (r === i) return !!n?.he || $b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(r) === $b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(i);
                return !!(void 0 === n || n.Te) && isNaN(r) && isNaN(i);
            }(e, t, n);
        case 9 /* TypeOrder.ArrayValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], (e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e, t, n));
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t, n) {
                const r = e.mapValue.fields || {}, i = t.mapValue.fields || {};
                if ($b1c6e3a850a3c735$var$__PRIVATE_objectSize(r) !== $b1c6e3a850a3c735$var$__PRIVATE_objectSize(i)) return !1;
                for(const e in r)if (r.hasOwnProperty(e) && (void 0 === i[e] || !$b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(r[e], i[e], n))) return !1;
                return !0;
            }(e, t, n);
        default:
            return $b1c6e3a850a3c735$export$8743009a87fcb00f(52216, {
                left: e
            });
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e, t));
}
function $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e), r = $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t);
    if (n !== r) return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_compareTimestamps($b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(e), $b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e), r = $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator($b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.latitude), $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator($b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.longitude), $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[$b1c6e3a850a3c735$var$ct]?.arrayValue, s = r[$b1c6e3a850a3c735$var$ct]?.arrayValue, _ = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== _) return _;
                return $b1c6e3a850a3c735$var$__PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === $b1c6e3a850a3c735$var$at.mapValue && t === $b1c6e3a850a3c735$var$at.mapValue) return 0;
                if (e === $b1c6e3a850a3c735$var$at.mapValue) return 1;
                if (t === $b1c6e3a850a3c735$var$at.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = $b1c6e3a850a3c735$var$__PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const _ = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== _) return _;
                }
                return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw $b1c6e3a850a3c735$export$8743009a87fcb00f(23264, {
                Pe: n
            });
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e, t);
    const n = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e), r = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(t), i = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function $b1c6e3a850a3c735$var$__PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(n[e], r[e]);
        if (void 0 !== t && 0 !== t) return t;
    }
    return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n.length, r.length);
}
function $b1c6e3a850a3c735$var$canonicalId(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_canonifyValue(e);
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return $b1c6e3a850a3c735$export$90a7f3efeed30595.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += $b1c6e3a850a3c735$var$__PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${$b1c6e3a850a3c735$var$__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : $b1c6e3a850a3c735$export$8743009a87fcb00f(61005, {
        value: e
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_estimateByteSize(e) {
    switch($b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = $b1c6e3a850a3c735$var$__PRIVATE_getPreviousValue(e);
            return t ? 16 + $b1c6e3a850a3c735$var$__PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + $b1c6e3a850a3c735$var$__PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return $b1c6e3a850a3c735$var$forEach(e.fields, (e, n)=>{
                    t += e.length + $b1c6e3a850a3c735$var$__PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw $b1c6e3a850a3c735$export$8743009a87fcb00f(13486, {
                value: e
            });
    }
}
function $b1c6e3a850a3c735$export$43caf9889c228507(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an BooleanValue . */ /** Returns true if `value` is an IntegerValue . */ function $b1c6e3a850a3c735$var$isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ function $b1c6e3a850a3c735$var$__PRIVATE_isDouble(e) {
    return !!e && "doubleValue" in e;
}
/** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function $b1c6e3a850a3c735$var$__PRIVATE_isNumber(e) {
    return $b1c6e3a850a3c735$var$isInteger(e) || $b1c6e3a850a3c735$var$__PRIVATE_isDouble(e);
}
/** Returns true if `value` is an ArrayValue. */ function $b1c6e3a850a3c735$var$isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is an ArrayValue. */ /** Returns true if `value` is a NullValue. */ function $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is Timestamp. */ /** Returns true if `value` is a MapValue. */ function $b1c6e3a850a3c735$var$__PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[$b1c6e3a850a3c735$var$_t]?.stringValue;
    return t === $b1c6e3a850a3c735$var$ut;
}
/** Returns true if `value` is a VetorValue. */ function $b1c6e3a850a3c735$var$__PRIVATE_getVectorValue(e) {
    return (e?.mapValue?.fields || {})[$b1c6e3a850a3c735$var$ct]?.arrayValue;
}
/** Creates a deep copy of `source`. */ function $b1c6e3a850a3c735$var$__PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return $b1c6e3a850a3c735$var$forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = $b1c6e3a850a3c735$var$__PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = $b1c6e3a850a3c735$var$__PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function $b1c6e3a850a3c735$var$__PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === $b1c6e3a850a3c735$var$ot;
}
const $b1c6e3a850a3c735$var$Tt = {
    mapValue: {
        fields: {
            [$b1c6e3a850a3c735$var$_t]: {
                stringValue: $b1c6e3a850a3c735$var$ut
            },
            [$b1c6e3a850a3c735$var$ct]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function $b1c6e3a850a3c735$var$__PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? $b1c6e3a850a3c735$var$lt : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? $b1c6e3a850a3c735$export$43caf9889c228507($b1c6e3a850a3c735$export$cf2f7c5792f80b46.empty(), $b1c6e3a850a3c735$export$90a7f3efeed30595.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) ? $b1c6e3a850a3c735$var$Tt : {
        mapValue: {}
    } : $b1c6e3a850a3c735$export$8743009a87fcb00f(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function $b1c6e3a850a3c735$var$__PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? $b1c6e3a850a3c735$export$43caf9889c228507($b1c6e3a850a3c735$export$cf2f7c5792f80b46.empty(), $b1c6e3a850a3c735$export$90a7f3efeed30595.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? $b1c6e3a850a3c735$var$Tt : "mapValue" in e ? $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : $b1c6e3a850a3c735$var$at : $b1c6e3a850a3c735$export$8743009a87fcb00f(61959, {
        value: e
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_lowerBoundCompare(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function $b1c6e3a850a3c735$var$__PRIVATE_upperBoundCompare(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class $b1c6e3a850a3c735$export$c4ce752e73470fba {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new $b1c6e3a850a3c735$export$c4ce752e73470fba({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !$b1c6e3a850a3c735$var$__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = $b1c6e3a850a3c735$var$__PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = $b1c6e3a850a3c735$export$b9a6b53f9be3734.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = $b1c6e3a850a3c735$var$__PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        $b1c6e3a850a3c735$var$__PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            $b1c6e3a850a3c735$var$__PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        $b1c6e3a850a3c735$var$forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new $b1c6e3a850a3c735$export$c4ce752e73470fba($b1c6e3a850a3c735$var$__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_extractFieldMask(e) {
    const t = [];
    return $b1c6e3a850a3c735$var$forEach(e.fields, (e, n)=>{
        const r = new $b1c6e3a850a3c735$export$b9a6b53f9be3734([
            e
        ]);
        if ($b1c6e3a850a3c735$var$__PRIVATE_isMapValue(n)) {
            const e = $b1c6e3a850a3c735$var$__PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new $b1c6e3a850a3c735$var$FieldMask(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function $b1c6e3a850a3c735$var$toNumber(e, t, n) {
    return Number.isInteger(t) && n?.preferIntegers || $b1c6e3a850a3c735$var$isSafeInteger(t) ? $b1c6e3a850a3c735$var$__PRIVATE_toInteger(t) : $b1c6e3a850a3c735$var$__PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class $b1c6e3a850a3c735$var$TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [$b1c6e3a850a3c735$var$nt]: {
                    stringValue: $b1c6e3a850a3c735$var$tt
                },
                [$b1c6e3a850a3c735$var$it]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && $b1c6e3a850a3c735$export$2408f22a0fab9ae5(t) && (t = $b1c6e3a850a3c735$var$__PRIVATE_getPreviousValue(t)), t && (n.fields[$b1c6e3a850a3c735$var$rt] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation ? function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = $b1c6e3a850a3c735$var$__PRIVATE_computeTransformOperationBaseValue(e, t), r = $b1c6e3a850a3c735$var$asNumber(n) + $b1c6e3a850a3c735$var$asNumber(e.Re);
        return $b1c6e3a850a3c735$var$isInteger(n) && $b1c6e3a850a3c735$var$isInteger(e.Re) ? $b1c6e3a850a3c735$var$__PRIVATE_toInteger(r) : $b1c6e3a850a3c735$var$__PRIVATE_toDouble(e.serializer, r);
    }(e, t) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation ? function __PRIVATE_applyNumericMinimumTransformOperationToLocalView(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.min);
    }(e, t) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation ? function __PRIVATE_applyNumericMaximumTransformOperationToLocalView(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.max);
    }(e, t) : void 0;
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_isNumber(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform extends $b1c6e3a850a3c735$var$TransformOperation {
}
/** Transforms an array value via a union operation. */ class $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation extends $b1c6e3a850a3c735$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation extends $b1c6e3a850a3c735$var$TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = $b1c6e3a850a3c735$var$__PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!$b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_NumericTransformOperation extends $b1c6e3a850a3c735$var$TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Re = t;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation extends $b1c6e3a850a3c735$var$__PRIVATE_NumericTransformOperation {
}
class $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation extends $b1c6e3a850a3c735$var$__PRIVATE_NumericTransformOperation {
}
class $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation extends $b1c6e3a850a3c735$var$__PRIVATE_NumericTransformOperation {
}
function $b1c6e3a850a3c735$var$__PRIVATE_applyNumericTransformOperationToLocalView(e, t, n) {
    if (!$b1c6e3a850a3c735$var$__PRIVATE_isNumber(t)) return e.Re;
    const r = n($b1c6e3a850a3c735$var$asNumber(t), $b1c6e3a850a3c735$var$asNumber(e.Re));
    return $b1c6e3a850a3c735$var$isInteger(t) && $b1c6e3a850a3c735$var$isInteger(e.Re) ? $b1c6e3a850a3c735$var$__PRIVATE_toInteger(r) : $b1c6e3a850a3c735$var$__PRIVATE_toDouble(e.serializer, r);
}
function $b1c6e3a850a3c735$var$asNumber(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function $b1c6e3a850a3c735$var$__PRIVATE_coercedFieldValuesArray(e) {
    return $b1c6e3a850a3c735$var$isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class $b1c6e3a850a3c735$var$FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation && t instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation || e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation && t instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(e.elements, t.elements, $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation && t instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation || e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation && t instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation || e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation && t instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation ? $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e.Re, t.Re) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform && t instanceof $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class $b1c6e3a850a3c735$var$MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9 {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function $b1c6e3a850a3c735$var$__PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class $b1c6e3a850a3c735$var$Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new $b1c6e3a850a3c735$export$6559d589eb85fbb6(e.key, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.none()) : new $b1c6e3a850a3c735$var$__PRIVATE_SetMutation(e.key, e.data, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.none());
    {
        const n = e.data, r = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty();
        let i = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation(e.key, r, new $b1c6e3a850a3c735$var$FieldMask(i.toArray()), $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof $b1c6e3a850a3c735$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = $b1c6e3a850a3c735$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = $b1c6e3a850a3c735$var$__PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll($b1c6e3a850a3c735$var$__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = $b1c6e3a850a3c735$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = $b1c6e3a850a3c735$var$__PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll($b1c6e3a850a3c735$var$__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if ($b1c6e3a850a3c735$var$__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = $b1c6e3a850a3c735$var$__PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty()), n.set(r.field, i));
    }
    return n || null;
}
function $b1c6e3a850a3c735$var$__PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(e, t, (e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SetMutation extends $b1c6e3a850a3c735$var$Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation extends $b1c6e3a850a3c735$var$Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.length === n.length, 32656, {
        Ie: n.length,
        Ae: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], _ = s.transform, o = t.data.field(s.field);
        r.set(s.field, $b1c6e3a850a3c735$var$__PRIVATE_applyTransformOperationToRemoteDocument(_, o, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, $b1c6e3a850a3c735$var$__PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class $b1c6e3a850a3c735$export$6559d589eb85fbb6 extends $b1c6e3a850a3c735$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_VerifyMutation extends $b1c6e3a850a3c735$var$Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class $b1c6e3a850a3c735$export$d24c54395ce0c509 {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class $b1c6e3a850a3c735$export$625550452a3fa3ec {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], _ = e.position[i];
        if (s.field.isKeyField()) r = $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator($b1c6e3a850a3c735$export$90a7f3efeed30595.fromName(_.referenceValue), n.key);
        else r = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(_, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!$b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$Filter {
}
class $b1c6e3a850a3c735$export$23f2a1d2818174ef extends $b1c6e3a850a3c735$var$Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new $b1c6e3a850a3c735$var$__PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new $b1c6e3a850a3c735$var$__PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new $b1c6e3a850a3c735$var$__PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new $b1c6e3a850a3c735$var$__PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new $b1c6e3a850a3c735$var$__PRIVATE_ArrayContainsAnyFilter(e, n) : new $b1c6e3a850a3c735$export$23f2a1d2818174ef(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new $b1c6e3a850a3c735$var$__PRIVATE_KeyFieldInFilter(e, n) : new $b1c6e3a850a3c735$var$__PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison($b1c6e3a850a3c735$var$__PRIVATE_valueCompare(t, this.value)) : null !== t && $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(this.value) === $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t) && this.matchesComparison($b1c6e3a850a3c735$var$__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return $b1c6e3a850a3c735$export$8743009a87fcb00f(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class $b1c6e3a850a3c735$export$e7094788287c5e9b extends $b1c6e3a850a3c735$var$Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.Ve = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new $b1c6e3a850a3c735$export$e7094788287c5e9b(e, t);
    }
    matches(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.Ve || (this.Ve = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.Ve;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlatConjunction(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlat(e) && $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b) return !1;
    return !0;
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyFilter(e) {
    if (e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + $b1c6e3a850a3c735$var$canonicalId(e.value);
    if ($b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_filterEquals(e, t) {
    return e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef && e.op === t.op && e.field.isEqual(t.field) && $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e.value, t.value);
    }(e, t) : e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && $b1c6e3a850a3c735$var$__PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void $b1c6e3a850a3c735$export$8743009a87fcb00f(19439);
}
function $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return $b1c6e3a850a3c735$export$e7094788287c5e9b.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function $b1c6e3a850a3c735$var$__PRIVATE_stringifyFilter(e) {
    return e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${$b1c6e3a850a3c735$var$canonicalId(e.value)}`;
    }(e) : e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map($b1c6e3a850a3c735$var$__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class $b1c6e3a850a3c735$var$__PRIVATE_KeyFieldFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t, n){
        super(e, t, n), this.key = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromName(n.referenceValue);
    }
    matches(e) {
        const t = $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class $b1c6e3a850a3c735$var$__PRIVATE_KeyFieldInFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = $b1c6e3a850a3c735$var$__PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class $b1c6e3a850a3c735$var$__PRIVATE_KeyFieldNotInFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = $b1c6e3a850a3c735$var$__PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>$b1c6e3a850a3c735$export$90a7f3efeed30595.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class $b1c6e3a850a3c735$var$__PRIVATE_ArrayContainsFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return $b1c6e3a850a3c735$var$isArray(t) && $b1c6e3a850a3c735$var$__PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class $b1c6e3a850a3c735$var$__PRIVATE_InFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && $b1c6e3a850a3c735$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class $b1c6e3a850a3c735$var$__PRIVATE_NotInFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if ($b1c6e3a850a3c735$var$__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !$b1c6e3a850a3c735$var$__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class $b1c6e3a850a3c735$var$__PRIVATE_ArrayContainsAnyFilter extends $b1c6e3a850a3c735$export$23f2a1d2818174ef {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!$b1c6e3a850a3c735$var$isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>$b1c6e3a850a3c735$var$__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class $b1c6e3a850a3c735$export$8a5498727ef6be21 {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class $b1c6e3a850a3c735$var$MutableDocument {
    constructor(e, t, n, r, i, s, _){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = _;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new $b1c6e3a850a3c735$var$MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), /* readTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), /* createTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), $b1c6e3a850a3c735$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new $b1c6e3a850a3c735$var$MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new $b1c6e3a850a3c735$var$MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), /* createTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), $b1c6e3a850a3c735$export$c4ce752e73470fba.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new $b1c6e3a850a3c735$var$MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), /* createTime */ $b1c6e3a850a3c735$var$SnapshotVersion.min(), $b1c6e3a850a3c735$export$c4ce752e73470fba.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = $b1c6e3a850a3c735$var$SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new $b1c6e3a850a3c735$var$MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class $b1c6e3a850a3c735$var$__PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, _ = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = _, this.de = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, _ = null) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_TargetImpl(e, t, n, r, i, s, _);
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyTarget(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    if (null === t.de) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), $b1c6e3a850a3c735$var$__PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>$b1c6e3a850a3c735$var$canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>$b1c6e3a850a3c735$var$canonicalId(e)).join(",")), t.de = e;
    }
    return t.de;
}
function $b1c6e3a850a3c735$var$__PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!$b1c6e3a850a3c735$var$__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!$b1c6e3a850a3c735$var$__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!$b1c6e3a850a3c735$var$__PRIVATE_boundEquals(e.startAt, t.startAt) && $b1c6e3a850a3c735$var$__PRIVATE_boundEquals(e.endAt, t.endAt);
}
function $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(e) {
    // Workaround for circular dependency
    return !!e.isCorePipeline;
}
function $b1c6e3a850a3c735$var$__PRIVATE_targetIsDocumentTarget(e) {
    return !!e.path && $b1c6e3a850a3c735$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function $b1c6e3a850a3c735$var$__PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = $b1c6e3a850a3c735$var$lt, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $b1c6e3a850a3c735$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $b1c6e3a850a3c735$var$lt, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = $b1c6e3a850a3c735$var$__PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $b1c6e3a850a3c735$var$lt;
        }
        $b1c6e3a850a3c735$var$__PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $b1c6e3a850a3c735$var$__PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = $b1c6e3a850a3c735$var$at, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of $b1c6e3a850a3c735$var$__PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = $b1c6e3a850a3c735$var$at, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = $b1c6e3a850a3c735$var$__PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = $b1c6e3a850a3c735$var$at;
        }
        $b1c6e3a850a3c735$var$__PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            $b1c6e3a850a3c735$var$__PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , _ = null, o = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = _, this.endAt = o, this.fe = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.me = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.pe = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function $b1c6e3a850a3c735$var$__PRIVATE_newQuery(e, t, n, r, i, s, _, o) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e, t, n, r, i, s, _, o);
}
/** Creates a new Query for a query that matches all documents at `path` */ function $b1c6e3a850a3c735$export$7910e0436ed8d1de(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_isDocumentQuery$1(e) {
    return $b1c6e3a850a3c735$export$90a7f3efeed30595.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function $b1c6e3a850a3c735$export$3b14a55fb2447963(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function $b1c6e3a850a3c735$export$9e5f44173e64f162(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    if (null === t.fe) {
        t.fe = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.fe.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.fe.push(new $b1c6e3a850a3c735$export$8a5498727ef6be21(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has($b1c6e3a850a3c735$export$b9a6b53f9be3734.keyField().canonicalString()) || t.fe.push(new $b1c6e3a850a3c735$export$8a5498727ef6be21($b1c6e3a850a3c735$export$b9a6b53f9be3734.keyField(), n));
    }
    return t.fe;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return t.me || (t.me = $b1c6e3a850a3c735$var$__PRIVATE__queryToTarget(t, $b1c6e3a850a3c735$export$9e5f44173e64f162(e))), t.me;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_queryToAggregateTarget(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return t.pe || // Do not include implicit order-bys for aggregate queries.
    (t.pe = $b1c6e3a850a3c735$var$__PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.pe;
}
function $b1c6e3a850a3c735$var$__PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return $b1c6e3a850a3c735$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new $b1c6e3a850a3c735$export$8a5498727ef6be21(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new $b1c6e3a850a3c735$export$625550452a3fa3ec(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new $b1c6e3a850a3c735$export$625550452a3fa3ec(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return $b1c6e3a850a3c735$var$__PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function $b1c6e3a850a3c735$export$2d1720544b23b823(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function $b1c6e3a850a3c735$export$342063e11d6c3cad(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    const n = e.explicitOrderBy.concat([
        t
    ]);
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function $b1c6e3a850a3c735$export$882b5998b3b9117c(e, t, n) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function $b1c6e3a850a3c735$export$7ccc53e8f1e7dfc5(e, t) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function $b1c6e3a850a3c735$export$ae1af26003f05816(e, t) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_queryEquals(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_targetEquals($b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(e), $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function $b1c6e3a850a3c735$var$__PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_stringifyFilter(e)).join(", ")}]`), $b1c6e3a850a3c735$var$__PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>$b1c6e3a850a3c735$var$canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>$b1c6e3a850a3c735$var$canonicalId(e)).join(",")), `Target(${t})`;
    }($b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function $b1c6e3a850a3c735$var$__PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : $b1c6e3a850a3c735$export$90a7f3efeed30595.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of $b1c6e3a850a3c735$export$9e5f44173e64f162(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = $b1c6e3a850a3c735$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, $b1c6e3a850a3c735$export$9e5f44173e64f162(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = $b1c6e3a850a3c735$var$__PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, $b1c6e3a850a3c735$export$9e5f44173e64f162(e), t)) return !1;
        return !0;
    }(e, t);
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function $b1c6e3a850a3c735$export$25ce5a424b770e84(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of $b1c6e3a850a3c735$export$9e5f44173e64f162(e)){
            const e = $b1c6e3a850a3c735$var$__PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(r, i) : $b1c6e3a850a3c735$export$8743009a87fcb00f(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return $b1c6e3a850a3c735$export$8743009a87fcb00f(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var $b1c6e3a850a3c735$var$Pt, $b1c6e3a850a3c735$var$Rt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_isPermanentError(e) {
    switch(e){
        case $b1c6e3a850a3c735$export$f1e1789686576879.OK:
            return $b1c6e3a850a3c735$export$8743009a87fcb00f(64938);
        case $b1c6e3a850a3c735$export$f1e1789686576879.CANCELLED:
        case $b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN:
        case $b1c6e3a850a3c735$export$f1e1789686576879.DEADLINE_EXCEEDED:
        case $b1c6e3a850a3c735$export$f1e1789686576879.RESOURCE_EXHAUSTED:
        case $b1c6e3a850a3c735$export$f1e1789686576879.INTERNAL:
        case $b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case $b1c6e3a850a3c735$export$f1e1789686576879.UNAUTHENTICATED:
            return !1;
        case $b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT:
        case $b1c6e3a850a3c735$export$f1e1789686576879.NOT_FOUND:
        case $b1c6e3a850a3c735$export$f1e1789686576879.ALREADY_EXISTS:
        case $b1c6e3a850a3c735$export$f1e1789686576879.PERMISSION_DENIED:
        case $b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case $b1c6e3a850a3c735$export$f1e1789686576879.ABORTED:
        case $b1c6e3a850a3c735$export$f1e1789686576879.OUT_OF_RANGE:
        case $b1c6e3a850a3c735$export$f1e1789686576879.UNIMPLEMENTED:
        case $b1c6e3a850a3c735$export$f1e1789686576879.DATA_LOSS:
            return !0;
        default:
            return $b1c6e3a850a3c735$export$8743009a87fcb00f(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return $b1c6e3a850a3c735$var$__PRIVATE_logError("GRPC error has no .code"), $b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN;
    switch(e){
        case $b1c6e3a850a3c735$var$Pt.OK:
            return $b1c6e3a850a3c735$export$f1e1789686576879.OK;
        case $b1c6e3a850a3c735$var$Pt.CANCELLED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.CANCELLED;
        case $b1c6e3a850a3c735$var$Pt.UNKNOWN:
            return $b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN;
        case $b1c6e3a850a3c735$var$Pt.DEADLINE_EXCEEDED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.DEADLINE_EXCEEDED;
        case $b1c6e3a850a3c735$var$Pt.RESOURCE_EXHAUSTED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.RESOURCE_EXHAUSTED;
        case $b1c6e3a850a3c735$var$Pt.INTERNAL:
            return $b1c6e3a850a3c735$export$f1e1789686576879.INTERNAL;
        case $b1c6e3a850a3c735$var$Pt.UNAVAILABLE:
            return $b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE;
        case $b1c6e3a850a3c735$var$Pt.UNAUTHENTICATED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.UNAUTHENTICATED;
        case $b1c6e3a850a3c735$var$Pt.INVALID_ARGUMENT:
            return $b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT;
        case $b1c6e3a850a3c735$var$Pt.NOT_FOUND:
            return $b1c6e3a850a3c735$export$f1e1789686576879.NOT_FOUND;
        case $b1c6e3a850a3c735$var$Pt.ALREADY_EXISTS:
            return $b1c6e3a850a3c735$export$f1e1789686576879.ALREADY_EXISTS;
        case $b1c6e3a850a3c735$var$Pt.PERMISSION_DENIED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.PERMISSION_DENIED;
        case $b1c6e3a850a3c735$var$Pt.FAILED_PRECONDITION:
            return $b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION;
        case $b1c6e3a850a3c735$var$Pt.ABORTED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.ABORTED;
        case $b1c6e3a850a3c735$var$Pt.OUT_OF_RANGE:
            return $b1c6e3a850a3c735$export$f1e1789686576879.OUT_OF_RANGE;
        case $b1c6e3a850a3c735$var$Pt.UNIMPLEMENTED:
            return $b1c6e3a850a3c735$export$f1e1789686576879.UNIMPLEMENTED;
        case $b1c6e3a850a3c735$var$Pt.DATA_LOSS:
            return $b1c6e3a850a3c735$export$f1e1789686576879.DATA_LOSS;
        default:
            return $b1c6e3a850a3c735$export$8743009a87fcb00f(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ ($b1c6e3a850a3c735$var$Rt = $b1c6e3a850a3c735$var$Pt || ($b1c6e3a850a3c735$var$Pt = {}))[$b1c6e3a850a3c735$var$Rt.OK = 0] = "OK", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.CANCELLED = 1] = "CANCELLED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.UNKNOWN = 2] = "UNKNOWN", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.NOT_FOUND = 5] = "NOT_FOUND", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.ABORTED = 10] = "ABORTED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.INTERNAL = 13] = "INTERNAL", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.UNAVAILABLE = 14] = "UNAVAILABLE", $b1c6e3a850a3c735$var$Rt[$b1c6e3a850a3c735$var$Rt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class $b1c6e3a850a3c735$var$ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        $b1c6e3a850a3c735$var$forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return $b1c6e3a850a3c735$var$isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$It = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
function $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap() {
    return $b1c6e3a850a3c735$var$It;
}
const $b1c6e3a850a3c735$var$At = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
function $b1c6e3a850a3c735$var$documentMap(...e) {
    let t = $b1c6e3a850a3c735$var$At;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function $b1c6e3a850a3c735$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = $b1c6e3a850a3c735$var$At;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap() {
    return $b1c6e3a850a3c735$var$__PRIVATE_newDocumentKeyMap();
}
function $b1c6e3a850a3c735$var$__PRIVATE_newMutationMap() {
    return $b1c6e3a850a3c735$var$__PRIVATE_newDocumentKeyMap();
}
function $b1c6e3a850a3c735$var$__PRIVATE_newDocumentKeyMap() {
    return new $b1c6e3a850a3c735$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const $b1c6e3a850a3c735$var$Vt = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
const $b1c6e3a850a3c735$var$dt = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
function $b1c6e3a850a3c735$export$78acf4525d8a74c4(...e) {
    let t = $b1c6e3a850a3c735$var$dt;
    for (const n of e)t = t.add(n);
    return t;
}
const $b1c6e3a850a3c735$var$ft = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
function $b1c6e3a850a3c735$var$__PRIVATE_targetIdSet() {
    return $b1c6e3a850a3c735$var$ft;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let $b1c6e3a850a3c735$var$mt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function $b1c6e3a850a3c735$export$2f6ca3d3b1f80bf5(e) {
    if ($b1c6e3a850a3c735$var$mt) throw new Error("a TestingHooksSpi instance is already set");
    $b1c6e3a850a3c735$var$mt = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$pt = new (0, $906344b47e605252$export$70ffa26850098d01)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function $b1c6e3a850a3c735$var$__PRIVATE_getMd5HashValue(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_newTextEncoder().encode(e), n = new (0, $906344b47e605252$export$9f5a3dfc7a9f5dd);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function $b1c6e3a850a3c735$var$__PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            n,
            r
        ], 0),
        new (0, $906344b47e605252$export$70ffa26850098d01)([
            i,
            s
        ], 0)
    ];
}
class $b1c6e3a850a3c735$var$BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new $b1c6e3a850a3c735$var$__PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new $b1c6e3a850a3c735$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new $b1c6e3a850a3c735$var$__PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new $b1c6e3a850a3c735$var$__PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.ge = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.ye = (0, $906344b47e605252$export$70ffa26850098d01).fromNumber(this.ge);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    we(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, $906344b47e605252$export$70ffa26850098d01).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare($b1c6e3a850a3c735$var$pt) && (r = new (0, $906344b47e605252$export$70ffa26850098d01)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.ye).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    be(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.ge) return !1;
        const t = $b1c6e3a850a3c735$var$__PRIVATE_getMd5HashValue(e), [n, r] = $b1c6e3a850a3c735$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.we(n, r, e);
            if (!this.be(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new $b1c6e3a850a3c735$var$BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.ge) return;
        const t = $b1c6e3a850a3c735$var$__PRIVATE_getMd5HashValue(e), [n, r] = $b1c6e3a850a3c735$var$__PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.we(n, r, e);
            this.ve(t);
        }
    }
    ve(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class $b1c6e3a850a3c735$var$RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which augmented documents (pipeline) have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ i, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ s){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.augmentedDocumentUpdates = i, this.resolvedLimboDocuments = s;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, $b1c6e3a850a3c735$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new $b1c6e3a850a3c735$var$RemoteEvent($b1c6e3a850a3c735$var$SnapshotVersion.min(), r, new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), $b1c6e3a850a3c735$export$78acf4525d8a74c4());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class $b1c6e3a850a3c735$var$TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new $b1c6e3a850a3c735$var$TargetChange(n, t, $b1c6e3a850a3c735$export$78acf4525d8a74c4(), $b1c6e3a850a3c735$export$78acf4525d8a74c4(), $b1c6e3a850a3c735$export$78acf4525d8a74c4());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Se = e, this.removedTargetIds = t, this.key = n, this.De = r;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.xe = t;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = $b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class $b1c6e3a850a3c735$var$__PRIVATE_TargetState {
    /**
     * Track the targetId for logging.
     */ constructor(e){
        this.targetId = e, /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.Ce = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Fe = $b1c6e3a850a3c735$var$__PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Oe = $b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING, this.Me = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Ne = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Me;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Oe;
    }
    /** Whether this target has pending target adds or target removes. */ get Le() {
        return 0 !== this.Ce;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Be() {
        return this.Ne;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Ue(e) {
        e.approximateByteSize() > 0 && (this.Ne = !0, this.Oe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ke() {
        let e = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), t = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), n = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        return this.Fe.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    $b1c6e3a850a3c735$export$8743009a87fcb00f(38017, {
                        changeType: i
                    });
            }
        }), new $b1c6e3a850a3c735$var$TargetChange(this.Oe, this.Me, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ qe() {
        this.Ne = !1, this.Fe = $b1c6e3a850a3c735$var$__PRIVATE_snapshotChangesMap();
    }
    $e(e, t) {
        this.Ne = !0, this.Fe = this.Fe.insert(e, t);
    }
    Ke(e) {
        this.Ne = !0, this.Fe = this.Fe.remove(e);
    }
    We() {
        this.Ce += 1;
    }
    Qe() {
        this.Ce -= 1, $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(this.Ce >= 0, 3241, {
            Ce: this.Ce,
            targetId: this.targetId
        });
    }
    Ge() {
        this.Ne = !0, this.Me = !0;
    }
}
const $b1c6e3a850a3c735$var$gt = "WatchChangeAggregator";
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.ze = e, /**
         * The internal state of all tracked targets.
         *
         * Targets have the following lifecycle of [states] within the WatchChangeAggregator:
         * [unknown] -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Added)
         *           -> [added / !pending]
         *           -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Removed)
         *           -> [unknown]
         *
         * A reset on an [added] target leaves the target in an [added] state.
         * [added / !pending] -> handleTargetChange(t, Reset)
         *                    -> [added / !pending]
         *
         * [active]: is a substate of [added], where also `remoteStore.listenTargets.has(t) === true`.
         *           Generally it is expected that when a target is [active / !pending]
         *           then it is also [active], but the implementation does not guarantee
         *           this will always be true.
         *
         */ this.je = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.He = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), this.Je = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetMap(), /** Keeps track of the augmented documents to update since the last raised snapshot. */ this.Ye = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.Ze = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Xe = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ et(e) {
        for (const t of e.Se)e.De && e.De.isFoundDocument() ? this.tt(t, e.De) : this.nt(t, e.key, e.De);
        for (const t of e.removedTargetIds)this.nt(t, e.key, e.De);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ rt(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.je.get(t);
            // skip unknown target state, this indicates the target change is for
            // an old target
            if (n) switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.it(t) && n.Ue(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Qe(), n.Le || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.qe(), n.Ue(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Qe(), n.Le || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.it(t) && (n.Ge(), n.Ue(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.it(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.st(t), n.Ue(e.resumeToken));
                    break;
                default:
                    $b1c6e3a850a3c735$export$8743009a87fcb00f(56790, {
                        state: e.state
                    });
            }
            else $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$gt, `handleTargetChange received targetChange for untracked target ID (${t}) with state (${e.state})`);
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.je.forEach((e, n)=>{
            this.it(n) && t(n);
        });
    }
    _t(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(e) ? "documents" === e.getPipelineSourceType() && 1 === e.getPipelineDocuments()?.length : $b1c6e3a850a3c735$var$__PRIVATE_targetIsDocumentTarget(e);
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ ot(e) {
        const t = e.targetId, n = e.xe.count, r = this.ut(t);
        if (r) {
            const i = r.target;
            if (this._t(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(i) ? $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(i.getPipelineDocuments()[0]) : i.path);
                    this.nt(t, e, $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(e, $b1c6e3a850a3c735$var$SnapshotVersion.min()));
                } else $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === n, 20013, "Single document existence filter with count: " + n);
            } else {
                const r = this.ct(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.lt(e), i = n ? this.Et(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.st(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Xe = this.Xe.insert(t, e);
                    }
                    $b1c6e3a850a3c735$var$mt?.u(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, _ = t.unchangedNames;
                        _ && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: _?.hashCount ?? 0,
                            bitmapLength: _?.bits?.bitmap?.length ?? 0,
                            padding: _?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? !1
                        });
                        return s;
                    }(r, e.xe, this.ze.Tt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ lt(e) {
        const t = e.xe.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, _;
        try {
            s = $b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof $b1c6e3a850a3c735$var$__PRIVATE_Base64DecodeError) return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            _ = new $b1c6e3a850a3c735$var$BloomFilter(s, r, i);
        } catch (e) {
            return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(e instanceof $b1c6e3a850a3c735$var$__PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === _.ge ? null : _;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ Et(e, t, n) {
        return t.xe.count === n - this.Pt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Pt(e, t) {
        const n = this.ze.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.ze.Tt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.nt(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Rt(e) {
        const t = new Map;
        this.je.forEach((n, r)=>{
            const i = this.ut(r);
            if (i) {
                if (n.current && this._t(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(i.target) ? $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(i.target.getPipelineDocuments()[0]) : i.target.path, n = new $b1c6e3a850a3c735$export$90a7f3efeed30595(t);
                    this.It(n).has(r) || this.At(r, n) || this.nt(r, n, $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(n, e));
                }
                n.Be && (t.set(r, n.ke()), n.qe());
            }
        });
        let n = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Ze.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.ut(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.He.forEach((t, n)=>n.setReadTime(e)), this.Ye.forEach((t, n)=>n.setReadTime(e));
        const r = new $b1c6e3a850a3c735$var$RemoteEvent(e, t, this.Xe, this.He, this.Ye, n);
        return this.He = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), this.Je = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetMap(), this.Ye = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), this.Ze = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetMap(), this.Xe = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    tt(e, t) {
        const n = this.je.get(e);
        // skip unknown or inactive targets
        if (!n || !this.it(e)) return void $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$gt, `addDocumentToTarget received document for unknown inactive target (${e})`);
        const r = this.At(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        n.$e(t.key, r), $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(this.ut(e).target) && "exact" !== this.ut(e).target.getPipelineFlavor() ? this.Ye = this.Ye.insert(t.key, t) : this.He = this.He.insert(t.key, t), this.Je = this.Je.insert(t.key, this.It(t.key).add(e)), this.Ze = this.Ze.insert(t.key, this.Vt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    nt(e, t, n) {
        const r = this.je.get(e);
        // skip unknown target state, this indicates the target change is for
        // an old target
        r && this.it(e) ? (this.At(e, t) ? r.$e(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Ke(t), this.Ze = this.Ze.insert(t, this.Vt(t).delete(e)), this.Ze = this.Ze.insert(t, this.Vt(t).add(e)), n && ($b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(this.ut(e).target) && "exact" !== this.ut(e).target.getPipelineFlavor() ? this.Ye = this.Ye.insert(t, n) : this.He = this.He.insert(t, n))) : $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$gt, `removeDocumentFromTarget received document for unknown or inactive target (${e})`);
    }
    removeTarget(e) {
        this.je.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ ct(e) {
        const t = this.je.get(e);
        // skip unknown target state
        if (!t) return 0;
        const n = t.ke();
        return this.ze.getRemoteKeysForTarget(e).size + n.addedDocuments.size - n.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ We(e) {
        // For each request we get we need to record we need a response for it.
        let t = this.je.get(e);
        t || ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$gt, `recordPendingTargetRequest set up tracking for target ID ${e}`), t = new $b1c6e3a850a3c735$var$__PRIVATE_TargetState(e), this.je.set(e, t)), t.We();
    }
    Vt(e) {
        let t = this.Ze.get(e);
        return t || (t = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), this.Ze = this.Ze.insert(e, t)), t;
    }
    It(e) {
        let t = this.Je.get(e);
        return t || (t = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ it(e) {
        const t = null !== this.ut(e);
        return t || $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$gt, "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ ut(e) {
        const t = this.je.get(e);
        return void 0 === t || t.Le ? null : this.ze.dt(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ st(e) {
        this.je.set(e, new $b1c6e3a850a3c735$var$__PRIVATE_TargetState(e));
        this.ze.getRemoteKeysForTarget(e).forEach((t)=>{
            this.nt(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ At(e, t) {
        return this.ze.getRemoteKeysForTarget(e).has(t);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_documentTargetMap() {
    return new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
}
function $b1c6e3a850a3c735$var$__PRIVATE_snapshotChangesMap() {
    return new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
}
const $b1c6e3a850a3c735$var$yt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), $b1c6e3a850a3c735$var$wt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), $b1c6e3a850a3c735$var$bt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class $b1c6e3a850a3c735$var$JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || $b1c6e3a850a3c735$var$__PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function $b1c6e3a850a3c735$var$toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ function $b1c6e3a850a3c735$var$fromTimestamp(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e);
    return new $b1c6e3a850a3c735$export$890c4ad488842ce7(t.seconds, t.nanos);
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toVersion(e, t) {
    return $b1c6e3a850a3c735$var$toTimestamp(e, t.toTimestamp());
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!e, 49232), $b1c6e3a850a3c735$var$SnapshotVersion.fromTimestamp($b1c6e3a850a3c735$var$fromTimestamp(e));
}
function $b1c6e3a850a3c735$var$__PRIVATE_toResourceName(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_toResourcePath(e, t).canonicalString();
}
function $b1c6e3a850a3c735$var$__PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new $b1c6e3a850a3c735$export$db202ddc8be9136([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromResourceName(e) {
    const t = $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(e);
    return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert($b1c6e3a850a3c735$var$__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function $b1c6e3a850a3c735$var$__PRIVATE_toName(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_toResourceName(e.databaseId, t.path);
}
function $b1c6e3a850a3c735$var$fromName(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$var$__PRIVATE_extractLocalPathFromResourceName(n));
}
function $b1c6e3a850a3c735$var$__PRIVATE_toQueryPath(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_toResourceName(e.databaseId, t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromQueryPath(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? $b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath() : $b1c6e3a850a3c735$var$__PRIVATE_extractLocalPathFromResourceName(t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_getEncodedDatabaseId(e) {
    return new $b1c6e3a850a3c735$export$db202ddc8be9136([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function $b1c6e3a850a3c735$var$__PRIVATE_extractLocalPathFromResourceName(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function $b1c6e3a850a3c735$var$__PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: $b1c6e3a850a3c735$var$__PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromPipelineResponse(e, t, n) {
    const r = {};
    t.transaction?.length && (r.transaction = t.transaction);
    const i = t.executionTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? $b1c6e3a850a3c735$var$fromName(e, n.name) : void 0, r.fields = new $b1c6e3a850a3c735$export$c4ce752e73470fba({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function $b1c6e3a850a3c735$export$3a1a48c8f6ef640e(e, t, n) {
    const r = $b1c6e3a850a3c735$var$fromName(e, t.name), i = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.updateTime), s = t.createTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.createTime) : $b1c6e3a850a3c735$var$SnapshotVersion.min(), _ = new $b1c6e3a850a3c735$export$c4ce752e73470fba({
        mapValue: {
            fields: t.fields
        }
    }), o = $b1c6e3a850a3c735$var$MutableDocument.newFoundDocument(r, i, s, _);
    return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = $b1c6e3a850a3c735$var$fromName(e, t.found.name), r = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.found.createTime) : $b1c6e3a850a3c735$var$SnapshotVersion.min(), s = new $b1c6e3a850a3c735$export$c4ce752e73470fba({
            mapValue: {
                fields: t.found.fields
            }
        });
        return $b1c6e3a850a3c735$var$MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!t.missing, 3894), $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!t.readTime, 22933);
        const n = $b1c6e3a850a3c735$var$fromName(e, t.missing), r = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.readTime);
        return $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(n, r);
    }(e, t) : $b1c6e3a850a3c735$export$8743009a87fcb00f(7234, {
        result: t
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : $b1c6e3a850a3c735$export$8743009a87fcb00f(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), $b1c6e3a850a3c735$export$158acd800e1ef08b.fromBase64String(t || "")) : ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof $b1c6e3a850a3c735$require$Buffer || t instanceof Uint8Array, 16193), $b1c6e3a850a3c735$export$158acd800e1ef08b.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), _ = t.targetChange.cause, o = _ && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? $b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN : $b1c6e3a850a3c735$var$__PRIVATE_mapCodeFromRpcCode(e.code);
            return new $b1c6e3a850a3c735$export$4368d992c4eafac0(t, e.message || "");
        }(_);
        n = new $b1c6e3a850a3c735$var$__PRIVATE_WatchTargetChange(r, i, s, o || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = $b1c6e3a850a3c735$var$fromName(e, r.document.name), s = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(r.document.updateTime), _ = r.document.createTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(r.document.createTime) : $b1c6e3a850a3c735$var$SnapshotVersion.min(), o = new $b1c6e3a850a3c735$export$c4ce752e73470fba({
            mapValue: {
                fields: r.document.fields
            }
        }), a = $b1c6e3a850a3c735$var$MutableDocument.newFoundDocument(i, s, _, o), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new $b1c6e3a850a3c735$var$__PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = $b1c6e3a850a3c735$var$fromName(e, r.document), s = r.readTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(r.readTime) : $b1c6e3a850a3c735$var$SnapshotVersion.min(), _ = $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(i, s), o = r.removedTargetIds || [];
        n = new $b1c6e3a850a3c735$var$__PRIVATE_DocumentWatchChange([], o, _.key, _);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = $b1c6e3a850a3c735$var$fromName(e, r.document), s = r.removedTargetIds || [];
        n = new $b1c6e3a850a3c735$var$__PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return $b1c6e3a850a3c735$export$8743009a87fcb00f(11601, {
            ft: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new $b1c6e3a850a3c735$var$ExistenceFilter(r, i), _ = e.targetId;
            n = new $b1c6e3a850a3c735$var$__PRIVATE_ExistenceFilterChange(_, s);
        }
    }
    return n;
}
function $b1c6e3a850a3c735$var$toMutation(e, t) {
    let n;
    if (t instanceof $b1c6e3a850a3c735$var$__PRIVATE_SetMutation) n = {
        update: $b1c6e3a850a3c735$var$__PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof $b1c6e3a850a3c735$export$6559d589eb85fbb6) n = {
        delete: $b1c6e3a850a3c735$var$__PRIVATE_toName(e, t.key)
    };
    else if (t instanceof $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation) n = {
        update: $b1c6e3a850a3c735$var$__PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: $b1c6e3a850a3c735$var$__PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof $b1c6e3a850a3c735$var$__PRIVATE_VerifyMutation)) return $b1c6e3a850a3c735$export$8743009a87fcb00f(16599, {
            gt: t.type
        });
        n = {
            verify: $b1c6e3a850a3c735$var$__PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Re
            };
            if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                minimum: n.Re
            };
            if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                maximum: n.Re
            };
            throw $b1c6e3a850a3c735$export$8743009a87fcb00f(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: $b1c6e3a850a3c735$var$__PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : $b1c6e3a850a3c735$export$8743009a87fcb00f(27497);
    }(e, t.precondition)), n;
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.updateTime($b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.exists(e.exists) : $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.none();
    }(t.currentDocument) : $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) $b1c6e3a850a3c735$var$__PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation(e, t.increment) : "minimum" in t ? n = new $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation(e, t.minimum) : "maximum" in t ? n = new $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation(e, t.maximum) : $b1c6e3a850a3c735$export$8743009a87fcb00f(16584, {
                proto: t
            });
            const r = $b1c6e3a850a3c735$export$b9a6b53f9be3734.fromServerFormat(t.fieldPath);
            return new $b1c6e3a850a3c735$var$FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = $b1c6e3a850a3c735$var$fromName(e, t.update.name), s = new $b1c6e3a850a3c735$export$c4ce752e73470fba({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new $b1c6e3a850a3c735$var$FieldMask(t.map((e)=>$b1c6e3a850a3c735$export$b9a6b53f9be3734.fromServerFormat(e)));
            }(t.updateMask);
            return new $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new $b1c6e3a850a3c735$var$__PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = $b1c6e3a850a3c735$var$fromName(e, t.delete);
        return new $b1c6e3a850a3c735$export$6559d589eb85fbb6(r, n);
    }
    if (t.verify) {
        const r = $b1c6e3a850a3c735$var$fromName(e, t.verify);
        return new $b1c6e3a850a3c735$var$__PRIVATE_VerifyMutation(r, n);
    }
    return $b1c6e3a850a3c735$export$8743009a87fcb00f(1463, {
        proto: t
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.updateTime) : $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t);
            return n.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t)), new $b1c6e3a850a3c735$var$MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function $b1c6e3a850a3c735$var$__PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            $b1c6e3a850a3c735$var$__PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = $b1c6e3a850a3c735$var$__PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return $b1c6e3a850a3c735$var$__PRIVATE_toFilter($b1c6e3a850a3c735$export$e7094788287c5e9b.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const _ = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.field),
                    direction: $b1c6e3a850a3c735$var$__PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    _ && (n.structuredQuery.orderBy = _);
    const o = $b1c6e3a850a3c735$var$__PRIVATE_toInt32Proto(e, t.limit);
    return null !== o && (n.structuredQuery.limit = o), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        yt: n,
        parent: i
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { yt: i, parent: s } = $b1c6e3a850a3c735$var$__PRIVATE_toQueryTarget(e, t), _ = {}, o = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        _[t] = e.alias, "count" === e.aggregateType ? o.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? o.push({
            alias: t,
            avg: {
                field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && o.push({
            alias: t,
            sum: {
                field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: o,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        wt: _,
        parent: s
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_convertQueryTargetToQuery(e) {
    let t = $b1c6e3a850a3c735$var$__PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_fromFilter(e);
        if (t instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b && $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let _ = [];
    n.orderBy && (_ = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new $b1c6e3a850a3c735$export$8a5498727ef6be21($b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let o = null;
    n.limit && (o = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, $b1c6e3a850a3c735$var$__PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new $b1c6e3a850a3c735$export$625550452a3fa3ec(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new $b1c6e3a850a3c735$export$625550452a3fa3ec(n, t);
    }(n.endAt)), $b1c6e3a850a3c735$var$__PRIVATE_newQuery(t, i, _, s, o, "F" /* LimitType.First */ , a, u);
}
function $b1c6e3a850a3c735$var$__PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return $b1c6e3a850a3c735$export$8743009a87fcb00f(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_toPipelineTarget(e, t) {
    return {
        structuredPipeline: {
            pipeline: {
                stages: t.stages.map((t)=>t._toProto(e))
            }
        }
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = $b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $b1c6e3a850a3c735$export$23f2a1d2818174ef.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = $b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $b1c6e3a850a3c735$export$23f2a1d2818174ef.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = $b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $b1c6e3a850a3c735$export$23f2a1d2818174ef.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = $b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return $b1c6e3a850a3c735$export$23f2a1d2818174ef.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return $b1c6e3a850a3c735$export$8743009a87fcb00f(61313);
            default:
                return $b1c6e3a850a3c735$export$8743009a87fcb00f(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return $b1c6e3a850a3c735$export$23f2a1d2818174ef.create($b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return $b1c6e3a850a3c735$export$8743009a87fcb00f(58110);
                default:
                    return $b1c6e3a850a3c735$export$8743009a87fcb00f(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return $b1c6e3a850a3c735$export$e7094788287c5e9b.create(e.compositeFilter.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return $b1c6e3a850a3c735$export$8743009a87fcb00f(1026);
            }
        }(e.compositeFilter.op));
    }(e) : $b1c6e3a850a3c735$export$8743009a87fcb00f(30097, {
        filter: e
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_toDirection(e) {
    return $b1c6e3a850a3c735$var$yt[e];
}
function $b1c6e3a850a3c735$var$__PRIVATE_toOperatorName(e) {
    return $b1c6e3a850a3c735$var$wt[e];
}
function $b1c6e3a850a3c735$var$__PRIVATE_toCompositeOperatorName(e) {
    return $b1c6e3a850a3c735$var$bt[e];
}
function $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromFieldPathReference(e) {
    return $b1c6e3a850a3c735$export$b9a6b53f9be3734.fromServerFormat(e.fieldPath);
}
function $b1c6e3a850a3c735$var$__PRIVATE_toFilter(e) {
    return e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if ($b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if ($b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if ($b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if ($b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: $b1c6e3a850a3c735$var$__PRIVATE_toFieldPathReference(e.field),
                op: $b1c6e3a850a3c735$var$__PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: $b1c6e3a850a3c735$var$__PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : $b1c6e3a850a3c735$export$8743009a87fcb00f(54877, {
        filter: e
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function $b1c6e3a850a3c735$var$__PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function $b1c6e3a850a3c735$var$toMapValue(e, t) {
    const n = {
        fields: {}
    };
    return t.forEach((t, r)=>{
        if ("string" != typeof r) throw new Error(`Cannot encode map with non-string key: ${r}`);
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_toStringValue(e) {
    return {
        stringValue: e
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_toPipelineValue(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1c6e3a850a3c735$export$b4171a6734a65d42(e) {
    return new $b1c6e3a850a3c735$var$JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class $b1c6e3a850a3c735$export$ef35774e6d314e91 {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new $b1c6e3a850a3c735$export$ef35774e6d314e91($b1c6e3a850a3c735$export$158acd800e1ef08b.fromBase64String(e));
        } catch (e) {
            throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new $b1c6e3a850a3c735$export$ef35774e6d314e91($b1c6e3a850a3c735$export$158acd800e1ef08b.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $b1c6e3a850a3c735$export$ef35774e6d314e91._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($b1c6e3a850a3c735$export$9bb611d729802a56(e, $b1c6e3a850a3c735$export$ef35774e6d314e91._jsonSchema)) return $b1c6e3a850a3c735$export$ef35774e6d314e91.fromBase64String(e.bytes);
    }
}
$b1c6e3a850a3c735$export$ef35774e6d314e91._jsonSchemaVersion = "firestore/bytes/1.0", $b1c6e3a850a3c735$export$ef35774e6d314e91._jsonSchema = {
    type: $b1c6e3a850a3c735$export$ffb5f4729a158638("string", $b1c6e3a850a3c735$export$ef35774e6d314e91._jsonSchemaVersion),
    bytes: $b1c6e3a850a3c735$export$ffb5f4729a158638("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class $b1c6e3a850a3c735$export$34aec0b863436764 {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new $b1c6e3a850a3c735$export$b9a6b53f9be3734(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function $b1c6e3a850a3c735$export$9d0e2d13d04f7070() {
    return new $b1c6e3a850a3c735$export$34aec0b863436764($b1c6e3a850a3c735$var$F);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class $b1c6e3a850a3c735$export$91c6e00c14e7e6fd {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(this._lat, e._lat) || $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: $b1c6e3a850a3c735$export$91c6e00c14e7e6fd._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($b1c6e3a850a3c735$export$9bb611d729802a56(e, $b1c6e3a850a3c735$export$91c6e00c14e7e6fd._jsonSchema)) return new $b1c6e3a850a3c735$export$91c6e00c14e7e6fd(e.latitude, e.longitude);
    }
}
/**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $b1c6e3a850a3c735$export$91c6e00c14e7e6fd._jsonSchemaVersion = "firestore/geoPoint/1.0", $b1c6e3a850a3c735$export$91c6e00c14e7e6fd._jsonSchema = {
    type: $b1c6e3a850a3c735$export$ffb5f4729a158638("string", $b1c6e3a850a3c735$export$91c6e00c14e7e6fd._jsonSchemaVersion),
    latitude: $b1c6e3a850a3c735$export$ffb5f4729a158638("number"),
    longitude: $b1c6e3a850a3c735$export$ffb5f4729a158638("number")
};
class $b1c6e3a850a3c735$var$__PRIVATE_NoopConnectivityMonitor {
    bt(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const $b1c6e3a850a3c735$var$vt = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.vt = ()=>this.St(), this.Dt = ()=>this.xt(), this.Ct = [], this.Ft();
    }
    bt(e) {
        this.Ct.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.vt), window.removeEventListener("offline", this.Dt);
    }
    Ft() {
        window.addEventListener("online", this.vt), window.addEventListener("offline", this.Dt);
    }
    St() {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$vt, "Network connectivity changed: AVAILABLE");
        for (const e of this.Ct)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    xt() {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$vt, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.Ct)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static C() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let $b1c6e3a850a3c735$var$St = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function $b1c6e3a850a3c735$var$__PRIVATE_generateUniqueDebugId() {
    return null === $b1c6e3a850a3c735$var$St ? $b1c6e3a850a3c735$var$St = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : $b1c6e3a850a3c735$var$St++, "0x" + $b1c6e3a850a3c735$var$St.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Dt = "RestConnection", $b1c6e3a850a3c735$var$xt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class $b1c6e3a850a3c735$var$__PRIVATE_RestConnection {
    get Ot() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Mt = t + "://" + e.host, this.Nt = `projects/${n}/databases/${r}`, this.Lt = this.databaseId.database === $b1c6e3a850a3c735$var$st ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Bt(e, t, n, r, i) {
        const s = $b1c6e3a850a3c735$var$__PRIVATE_generateUniqueDebugId(), _ = this.Ut(e, t.toUriEncodedString());
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Dt, `Sending RPC '${e}' ${s}:`, _, n);
        const a = {
            "google-cloud-resource-prefix": this.Nt,
            "x-goog-request-params": this.Lt
        };
        this.kt(a, r, i);
        const { host: u } = new URL(_), c = (0, $029952e65115eee5$export$5b4d24b45140ad90)(u);
        return this.qt(e, _, a, n, c).then((t)=>($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Dt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw $b1c6e3a850a3c735$export$ee7c8ad385a60b7b($b1c6e3a850a3c735$var$Dt, `RPC '${e}' ${s} failed with error: `, t, "url: ", _, "request:", n), t;
        });
    }
    $t(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Bt(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ kt(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + $b1c6e3a850a3c735$var$v;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Ut(e, t) {
        const n = $b1c6e3a850a3c735$var$xt[e];
        let r = `${this.Mt}/v1/${t}:${n}`;
        return this.databaseInfo.apiKey && (r = `${r}?key=${encodeURIComponent(this.databaseInfo.apiKey)}`), r;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_StreamBridge {
    constructor(e){
        this.Kt = e.Kt, this.Wt = e.Wt;
    }
    Qt(e) {
        this.Gt = e;
    }
    zt(e) {
        this.jt = e;
    }
    Ht(e) {
        this.Jt = e;
    }
    onMessage(e) {
        this.Yt = e;
    }
    close() {
        this.Wt();
    }
    send(e) {
        this.Kt(e);
    }
    Zt() {
        this.Gt();
    }
    Xt() {
        this.jt();
    }
    en(e) {
        this.Jt(e);
    }
    tn(e) {
        this.Yt(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Ct = "WebChannelConnection", $b1c6e3a850a3c735$var$__PRIVATE_unguardedEventListen = (e, t, n)=>{
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, (e)=>{
        try {
            n(e);
        } catch (e) {
            setTimeout(()=>{
                throw e;
            }, 0);
        }
    });
};
class $b1c6e3a850a3c735$var$__PRIVATE_WebChannelConnection extends $b1c6e3a850a3c735$var$__PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.nn = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ static rn() {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_WebChannelConnection.sn) {
            const e = (0, $33cb313d667e3306$export$888d0d9ab79d08fc)();
            $b1c6e3a850a3c735$var$__PRIVATE_unguardedEventListen(e, (0, $33cb313d667e3306$export$d61e24a684f9e51).STAT_EVENT, (e)=>{
                e.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).PROXY ? $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, "STAT_EVENT: detected buffering proxy") : e.stat === (0, $33cb313d667e3306$export$cbbc350c1dfc80cb).NOPROXY && $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, "STAT_EVENT: detected no buffering proxy");
            }), $b1c6e3a850a3c735$var$__PRIVATE_WebChannelConnection.sn = !0;
        }
    }
    qt(e, t, n, r, i) {
        const s = $b1c6e3a850a3c735$var$__PRIVATE_generateUniqueDebugId();
        return new Promise((i, _)=>{
            const o = new (0, $33cb313d667e3306$export$26404658cda3ee02);
            o.setWithCredentials(!0), o.listenOnce((0, $33cb313d667e3306$export$3d7865934588d77e).COMPLETE, ()=>{
                try {
                    switch(o.getLastErrorCode()){
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).NO_ERROR:
                            const t = o.getResponseJson();
                            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).TIMEOUT:
                            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' ${s} timed out`), _(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, $33cb313d667e3306$export$d4e71bc0b80dc0fb).HTTP_ERROR:
                            const n = o.getStatus();
                            if ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' ${s} failed with status:`, n, "response text:", o.getResponseText()), n > 0) {
                                let e = o.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values($b1c6e3a850a3c735$export$f1e1789686576879).indexOf(t) >= 0 ? t : $b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN;
                                    }(t.status);
                                    _(new $b1c6e3a850a3c735$export$4368d992c4eafac0(e, t.message));
                                } else _(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN, "Server responded with status " + o.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            _(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            $b1c6e3a850a3c735$export$8743009a87fcb00f(9055, {
                                _n: e,
                                streamId: s,
                                an: o.getLastErrorCode(),
                                un: o.getLastError()
                            });
                    }
                } finally{
                    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' ${s} sending request:`, r), o.send(t, "POST", a, n, 15);
        });
    }
    cn(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_generateUniqueDebugId(), i = [
            this.Mt,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = this.createWebChannelTransport(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, o = this.longPollingOptions.timeoutSeconds;
        void 0 !== o && (_.longPollingTimeout = Math.round(1e3 * o)), this.useFetchStreams && (_.useFetchStreams = !0), this.kt(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const a = i.join("");
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `Creating RPC '${e}' stream ${r}: ${a}`, _);
        const u = s.createWebChannel(a, _);
        this.En(u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let c = !1, l = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const E = new $b1c6e3a850a3c735$var$__PRIVATE_StreamBridge({
            Kt: (t)=>{
                l ? $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (c || ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `Opening RPC '${e}' stream ${r} transport.`), u.open(), c = !0), $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
            },
            Wt: ()=>u.close()
        });
        return $b1c6e3a850a3c735$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.OPEN, ()=>{
            l || ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' stream ${r} transport opened.`), E.Zt());
        }), $b1c6e3a850a3c735$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.CLOSE, ()=>{
            l || (l = !0, $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' stream ${r} transport closed`), E.en(), this.hn(u));
        }), $b1c6e3a850a3c735$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.ERROR, (t)=>{
            l || (l = !0, $b1c6e3a850a3c735$export$ee7c8ad385a60b7b($b1c6e3a850a3c735$var$Ct, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), E.en(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, "The operation could not be completed")));
        }), $b1c6e3a850a3c735$var$__PRIVATE_unguardedEventListen(u, (0, $33cb313d667e3306$export$aa726fb96ad3e039).EventType.MESSAGE, (t)=>{
            if (!l) {
                const n = t.data[0];
                $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, s = i?.error || i[0]?.error;
                if (s) {
                    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' stream ${r} received error:`, s);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = s.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = $b1c6e3a850a3c735$var$Pt[e];
                        if (void 0 !== t) return $b1c6e3a850a3c735$var$__PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = s.message;
                    "NOT_FOUND" === t && i.includes("database") && i.includes("does not exist") && i.includes(this.databaseId.database) && $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(`Database '${this.databaseId.database}' not found. Please check your project configuration.`), void 0 === n && (n = $b1c6e3a850a3c735$export$f1e1789686576879.INTERNAL, i = "Unknown error status: " + t + " with message " + s.message), // Mark closed so no further events are propagated
                    l = !0, E.en(new $b1c6e3a850a3c735$export$4368d992c4eafac0(n, i)), u.close();
                } else $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ct, `RPC '${e}' stream ${r} received:`, n), E.tn(n);
            }
        }), // Ensure that event listeners are configured for STAT_EVENTs.
        $b1c6e3a850a3c735$var$__PRIVATE_WebChannelConnection.rn(), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            E.Xt();
        }, 0), E;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.nn.forEach((e)=>e.close()), this.nn = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ En(e) {
        this.nn.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ hn(e) {
        this.nn = this.nn.filter((t)=>t === e);
    }
    /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ kt(e, t, n) {
        super.kt(e, t, n), // For web channel streams, we want to send the api key in the headers.
        this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
    }
    /**
     * Wrapped for mocking.
     * @protected
     */ createWebChannelTransport() {
        return (0, $33cb313d667e3306$export$66869136fc133c3a)();
    }
}
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function $b1c6e3a850a3c735$var$__PRIVATE_newConnection(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ $b1c6e3a850a3c735$var$__PRIVATE_WebChannelConnection.sn = !1;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Tn = e, this.timerId = t, this.Pn = n, this.Rn = r, this.In = i, this.An = 0, this.Vn = null, /** The last backoff attempt, as epoch milliseconds. */ this.dn = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.An = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ fn() {
        this.An = this.In;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ mn(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.An + this.pn()), n = Math.max(0, Date.now() - this.dn), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && $b1c6e3a850a3c735$export$306ddfe3a8403e2("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.An} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.Vn = this.Tn.enqueueAfterDelay(this.timerId, r, ()=>(this.dn = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.An *= this.Rn, this.An < this.Pn && (this.An = this.Pn), this.An > this.In && (this.An = this.In);
    }
    gn() {
        null !== this.Vn && (this.Vn.skipDelay(), this.Vn = null);
    }
    cancel() {
        null !== this.Vn && (this.Vn.cancel(), this.Vn = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ pn() {
        return (Math.random() - .5) * this.An;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Ft = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class $b1c6e3a850a3c735$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, _, o){
        this.Tn = e, this.yn = n, this.wn = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = _, this.listener = o, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.bn = 0, this.vn = null, this.Sn = null, this.stream = null, /**
         * Count of response messages received.
         */ this.Dn = 0, this.xn = new $b1c6e3a850a3c735$var$__PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Cn() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Fn();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Fn() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.Dn = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.On();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Cn() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ Mn() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.xn.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ Nn() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Fn() && null === this.vn && (this.vn = this.Tn.enqueueAfterDelay(this.yn, 6e4, ()=>this.Ln()));
    }
    /** Sends a message to the underlying stream. */ Bn(e) {
        this.Un(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async Ln() {
        if (this.Fn()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ Un() {
        this.vn && (this.vn.cancel(), this.vn = null);
    }
    /** Cancels the health check delayed operation. */ kn() {
        this.Sn && (this.Sn.cancel(), this.Sn = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Un(), this.kn(), this.xn.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.bn++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.xn.reset() : t && t.code === $b1c6e3a850a3c735$export$f1e1789686576879.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        ($b1c6e3a850a3c735$var$__PRIVATE_logError(t.toString()), $b1c6e3a850a3c735$var$__PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.xn.fn()) : t && t.code === $b1c6e3a850a3c735$export$f1e1789686576879.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.qn(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.Ht(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ qn() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.$n(this.bn), t = this.bn;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.bn === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.Kn(e, n);
        }, (t)=>{
            e(()=>{
                const e = new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.Wn(e);
            });
        });
    }
    Kn(e, t) {
        const n = this.$n(this.bn);
        this.stream = this.Qn(e, t), this.stream.Qt(()=>{
            n(()=>this.listener.Qt());
        }), this.stream.zt(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Sn = this.Tn.enqueueAfterDelay(this.wn, 1e4, ()=>(this.Fn() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.zt()));
        }), this.stream.Ht((e)=>{
            n(()=>this.Wn(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.Dn ? this.Gn(e) : this.onNext(e));
        });
    }
    On() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.xn.mn(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    Wn(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ft, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ $n(e) {
        return (t)=>{
            this.Tn.enqueueAndForget(()=>this.bn === e ? t() : ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ft, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_PersistentListenStream extends $b1c6e3a850a3c735$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    Qn(e, t) {
        return this.connection.cn("Listen", e, t);
    }
    Gn(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.xn.reset();
        const t = $b1c6e3a850a3c735$var$__PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return $b1c6e3a850a3c735$var$SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? $b1c6e3a850a3c735$var$SnapshotVersion.min() : t.readTime ? $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.readTime) : $b1c6e3a850a3c735$var$SnapshotVersion.min();
        }(e);
        return this.listener.zn(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ jn(e) {
        const t = {};
        t.database = $b1c6e3a850a3c735$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(r) ? {
                pipelineQuery: $b1c6e3a850a3c735$var$__PRIVATE_toPipelineTarget(e, r)
            } : $b1c6e3a850a3c735$var$__PRIVATE_targetIsDocumentTarget(r) ? {
                documents: $b1c6e3a850a3c735$var$__PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: $b1c6e3a850a3c735$var$__PRIVATE_toQueryTarget(e, r).yt
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = $b1c6e3a850a3c735$var$__PRIVATE_toBytes(e, t.resumeToken);
                const r = $b1c6e3a850a3c735$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo($b1c6e3a850a3c735$var$SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = $b1c6e3a850a3c735$var$toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = $b1c6e3a850a3c735$var$__PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.Bn(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ Hn(e) {
        const t = {};
        t.database = $b1c6e3a850a3c735$var$__PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.Bn(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class $b1c6e3a850a3c735$var$__PRIVATE_PersistentWriteStream extends $b1c6e3a850a3c735$var$__PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Jn() {
        return this.Dn > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    qn() {
        this.Jn && this.Yn([]);
    }
    Qn(e, t) {
        return this.connection.cn("Write", e, t);
    }
    Gn(e) {
        // Always capture the last stream token.
        return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.Zn();
    }
    onNext(e) {
        // Always capture the last stream token.
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.xn.reset();
        const t = $b1c6e3a850a3c735$var$__PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.commitTime);
        return this.listener.Xn(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ er() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = $b1c6e3a850a3c735$var$__PRIVATE_getEncodedDatabaseId(this.serializer), this.Bn(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ Yn(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>$b1c6e3a850a3c735$var$toMutation(this.serializer, e))
        };
        this.Bn(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class $b1c6e3a850a3c735$var$Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_DatastoreImpl extends $b1c6e3a850a3c735$var$Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.tr = !1;
    }
    nr() {
        if (this.tr) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Bt(e, t, n, r) {
        return this.nr(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Bt(e, $b1c6e3a850a3c735$var$__PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $b1c6e3a850a3c735$export$f1e1789686576879.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ $t(e, t, n, r, i) {
        return this.nr(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, _])=>this.connection.$t(e, $b1c6e3a850a3c735$var$__PRIVATE_toResourcePath(t, n), r, s, _, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === $b1c6e3a850a3c735$export$f1e1789686576879.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.tr = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function $b1c6e3a850a3c735$var$__PRIVATE_newDatastore(e, t, n, r) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Ot = "ComponentProvider", $b1c6e3a850a3c735$var$Mt = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new $b1c6e3a850a3c735$var$DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, $b1c6e3a850a3c735$var$__PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Nt = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, $b1c6e3a850a3c735$var$Lt = 41943040;
class $b1c6e3a850a3c735$var$LruParams {
    static withCacheSize(e) {
        return new $b1c6e3a850a3c735$var$LruParams(e, $b1c6e3a850a3c735$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $b1c6e3a850a3c735$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
$b1c6e3a850a3c735$var$LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, $b1c6e3a850a3c735$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, $b1c6e3a850a3c735$var$LruParams.DEFAULT = new $b1c6e3a850a3c735$var$LruParams($b1c6e3a850a3c735$var$Lt, $b1c6e3a850a3c735$var$LruParams.DEFAULT_COLLECTION_PERCENTILE, $b1c6e3a850a3c735$var$LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), $b1c6e3a850a3c735$var$LruParams.DISABLED = new $b1c6e3a850a3c735$var$LruParams(-1, 0, 0);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Bt = "LruGarbageCollector", $b1c6e3a850a3c735$var$Ut = 1048576;
function $b1c6e3a850a3c735$var$__PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e, n);
    return 0 === i ? $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.rr = e, this.buffer = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_bufferEntryComparator), this.ir = 0;
    }
    sr() {
        return ++this.ir;
    }
    _r(e) {
        const t = [
            e,
            this.sr()
        ];
        if (this.buffer.size < this.rr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            $b1c6e3a850a3c735$var$__PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.ar = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.ur(6e4);
    }
    stop() {
        this.ar && (this.ar.cancel(), this.ar = null);
    }
    get started() {
        return null !== this.ar;
    }
    ur(e) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Bt, `Garbage collection scheduled in ${e}ms`), this.ar = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.ar = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                $b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e) ? $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Bt, "Ignoring IndexedDB error during garbage collection: ", e) : await $b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.ur(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.cr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.cr.lr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return $b1c6e3a850a3c735$var$PersistencePromise.resolve($b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce);
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_RollingSequenceNumberBuffer(t);
        return this.cr.forEachTarget(e, (e)=>n._r(e.sequenceNumber)).next(()=>this.cr.Er(e, (e)=>n._r(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.cr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.cr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2("LruGarbageCollector", "Garbage collection skipped; disabled"), $b1c6e3a850a3c735$var$PersistencePromise.resolve($b1c6e3a850a3c735$var$Nt)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), $b1c6e3a850a3c735$var$Nt) : this.hr(e, t));
    }
    getCacheSize(e) {
        return this.cr.getCacheSize(e);
    }
    hr(e, t) {
        let n, r, i, s, _, o, a;
        const u = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, _ = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, o = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (a = Date.now(), $b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG) $b1c6e3a850a3c735$export$306ddfe3a8403e2("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - u}ms\n\tDetermined least recently used ${r} in ` + (_ - s) + "ms\n" + `\tRemoved ${i} targets in ` + (o - _) + "ms\n" + `\tRemoved ${e} documents in ` + (a - o) + "ms\n" + `Total Duration: ${a - u}ms`);
            return $b1c6e3a850a3c735$var$PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_newLruGarbageCollector(e, t) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const $b1c6e3a850a3c735$var$kt = "firestore.googleapis.com", $b1c6e3a850a3c735$var$qt = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class $b1c6e3a850a3c735$var$FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = $b1c6e3a850a3c735$var$kt, this.ssl = $b1c6e3a850a3c735$var$qt;
        } else this.host = e.host, this.ssl = e.ssl ?? $b1c6e3a850a3c735$var$qt;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = $b1c6e3a850a3c735$var$Lt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < $b1c6e3a850a3c735$var$Ut) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        $b1c6e3a850a3c735$export$faec65b429be379("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = $b1c6e3a850a3c735$var$__PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class $b1c6e3a850a3c735$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new $b1c6e3a850a3c735$var$FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new $b1c6e3a850a3c735$var$FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new $b1c6e3a850a3c735$export$a33b77bbdbb8366c;
            switch(e.type){
                case "firstParty":
                    return new $b1c6e3a850a3c735$var$__PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = $b1c6e3a850a3c735$var$Mt.get(e);
            t && ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ot, "Removing Datastore"), $b1c6e3a850a3c735$var$Mt.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function $b1c6e3a850a3c735$export$667d3bf0c5f83305(e, t, n, r = {}) {
    e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$var$Firestore$1);
    const i = (0, $029952e65115eee5$export$5b4d24b45140ad90)(t), s = e._getSettings(), _ = {
        ...s,
        emulatorOptions: e._getEmulatorOptions()
    }, l = `${t}:${n}`;
    i && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`https://${l}`), s.host !== $b1c6e3a850a3c735$var$kt && s.host !== l && $b1c6e3a850a3c735$export$ee7c8ad385a60b7b("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const E = {
        ...s,
        host: l,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, $029952e65115eee5$export$9cb4719e2e525b7a)(E, _) && (e._setSettings(E), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = $b1c6e3a850a3c735$var$User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, $029952e65115eee5$export$367bf224123348f1)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new $b1c6e3a850a3c735$var$User(i);
        }
        e._authCredentials = new $b1c6e3a850a3c735$var$__PRIVATE_EmulatorAuthCredentialsProvider(new $b1c6e3a850a3c735$var$__PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class $b1c6e3a850a3c735$export$3722cfe417b6ed86 {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new $b1c6e3a850a3c735$export$3722cfe417b6ed86(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class $b1c6e3a850a3c735$export$96f57966bedc81b4 {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new $b1c6e3a850a3c735$export$28f7fcd39efa255(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new $b1c6e3a850a3c735$export$96f57966bedc81b4(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $b1c6e3a850a3c735$export$96f57966bedc81b4._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if ($b1c6e3a850a3c735$export$9bb611d729802a56(t, $b1c6e3a850a3c735$export$96f57966bedc81b4._jsonSchema)) return new $b1c6e3a850a3c735$export$96f57966bedc81b4(e, n || null, new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(t.referencePath)));
    }
}
$b1c6e3a850a3c735$export$96f57966bedc81b4._jsonSchemaVersion = "firestore/documentReference/1.0", $b1c6e3a850a3c735$export$96f57966bedc81b4._jsonSchema = {
    type: $b1c6e3a850a3c735$export$ffb5f4729a158638("string", $b1c6e3a850a3c735$export$96f57966bedc81b4._jsonSchemaVersion),
    referencePath: $b1c6e3a850a3c735$export$ffb5f4729a158638("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class $b1c6e3a850a3c735$export$28f7fcd39efa255 extends $b1c6e3a850a3c735$export$3722cfe417b6ed86 {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, $b1c6e3a850a3c735$export$7910e0436ed8d1de(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new $b1c6e3a850a3c735$export$96f57966bedc81b4(this.firestore, /* converter= */ null, new $b1c6e3a850a3c735$export$90a7f3efeed30595(e));
    }
    withConverter(e) {
        return new $b1c6e3a850a3c735$export$28f7fcd39efa255(this.firestore, e, this._path);
    }
}
function $b1c6e3a850a3c735$export$d22783b3c2400a3a(e) {
    return e instanceof $b1c6e3a850a3c735$export$28f7fcd39efa255;
}
function $b1c6e3a850a3c735$export$738ab4df8bf92ae9(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), $b1c6e3a850a3c735$var$__PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof $b1c6e3a850a3c735$var$Firestore$1) {
        const r = $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(t, ...n);
        return $b1c6e3a850a3c735$var$__PRIVATE_validateCollectionPath(r), new $b1c6e3a850a3c735$export$28f7fcd39efa255(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4 || e instanceof $b1c6e3a850a3c735$export$28f7fcd39efa255)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(t, ...n));
        return $b1c6e3a850a3c735$var$__PRIVATE_validateCollectionPath(r), new $b1c6e3a850a3c735$export$28f7fcd39efa255(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function $b1c6e3a850a3c735$export$d377dcb2b61d6c4e(e, t) {
    if (e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$var$Firestore$1), $b1c6e3a850a3c735$var$__PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new $b1c6e3a850a3c735$export$3722cfe417b6ed86(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl($b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath(), e);
    }(t));
}
function $b1c6e3a850a3c735$export$a9c996f45e5784d0(e, t, ...n) {
    if (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = $b1c6e3a850a3c735$export$971d5caa766a69d7.newId()), $b1c6e3a850a3c735$var$__PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof $b1c6e3a850a3c735$var$Firestore$1) {
        const r = $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(t, ...n);
        return $b1c6e3a850a3c735$var$__PRIVATE_validateDocumentPath(r), new $b1c6e3a850a3c735$export$96f57966bedc81b4(e, /* converter= */ null, new $b1c6e3a850a3c735$export$90a7f3efeed30595(r));
    }
    {
        if (!(e instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4 || e instanceof $b1c6e3a850a3c735$export$28f7fcd39efa255)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(t, ...n));
        return $b1c6e3a850a3c735$var$__PRIVATE_validateDocumentPath(r), new $b1c6e3a850a3c735$export$96f57966bedc81b4(e.firestore, e instanceof $b1c6e3a850a3c735$export$28f7fcd39efa255 ? e.converter : null, new $b1c6e3a850a3c735$export$90a7f3efeed30595(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $b1c6e3a850a3c735$export$53c86fa97d611818(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), (e instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4 || e instanceof $b1c6e3a850a3c735$export$28f7fcd39efa255) && (t instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4 || t instanceof $b1c6e3a850a3c735$export$28f7fcd39efa255) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function $b1c6e3a850a3c735$export$d141bba7fdc215a3(e, t) {
    return e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e), t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), e instanceof $b1c6e3a850a3c735$export$3722cfe417b6ed86 && t instanceof $b1c6e3a850a3c735$export$3722cfe417b6ed86 && e.firestore === t.firestore && $b1c6e3a850a3c735$var$__PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ class $b1c6e3a850a3c735$export$24baa2b76016ce0e {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        /**
 * Verifies equality for an array of primitives.
 *
 * @private
 * @internal
 * @param left - Array of primitives.
 * @param right - Array of primitives.
 * @returns True if arrays are equal.
 */ return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: $b1c6e3a850a3c735$export$24baa2b76016ce0e._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if ($b1c6e3a850a3c735$export$9bb611d729802a56(e, $b1c6e3a850a3c735$export$24baa2b76016ce0e._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new $b1c6e3a850a3c735$export$24baa2b76016ce0e(e.vectorValues);
            throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
$b1c6e3a850a3c735$export$24baa2b76016ce0e._jsonSchemaVersion = "firestore/vectorValue/1.0", $b1c6e3a850a3c735$export$24baa2b76016ce0e._jsonSchema = {
    type: $b1c6e3a850a3c735$export$ffb5f4729a158638("string", $b1c6e3a850a3c735$export$24baa2b76016ce0e._jsonSchemaVersion),
    vectorValues: $b1c6e3a850a3c735$export$ffb5f4729a158638("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$$t = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class $b1c6e3a850a3c735$var$ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new $b1c6e3a850a3c735$var$__PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class $b1c6e3a850a3c735$var$ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw $b1c6e3a850a3c735$export$8743009a87fcb00f(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class $b1c6e3a850a3c735$var$ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.validatePath(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get dataSource() {
        return this.settings.dataSource;
    }
    /** Returns a new context with the specified settings overwritten. */ contextWith(e) {
        return new $b1c6e3a850a3c735$var$ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    childContextForField(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePathSegment(e), n;
    }
    childContextForFieldPath(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePath(), n;
    }
    childContextForArray(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.contextWith({
            path: void 0,
            arrayElement: !0
        });
    }
    createError(e) {
        return $b1c6e3a850a3c735$var$createError(e, this.settings.methodName, this.settings.hasConverter || !1, this.path, this.settings.targetDoc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    validatePath() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.validatePathSegment(this.path.get(e));
    }
    validatePathSegment(e) {
        if (0 === e.length) throw this.createError("Document fields must not be empty");
        if ($b1c6e3a850a3c735$var$__PRIVATE_isWrite(this.dataSource) && $b1c6e3a850a3c735$var$$t.test(e)) throw this.createError('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class $b1c6e3a850a3c735$var$UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || $b1c6e3a850a3c735$export$b4171a6734a65d42(e);
    }
    /** Creates a new top-level parse context. */ createContext(e, t, n, r = !1) {
        return new $b1c6e3a850a3c735$var$ParseContextImpl({
            dataSource: e,
            methodName: t,
            targetDoc: n,
            path: $b1c6e3a850a3c735$export$b9a6b53f9be3734.emptyPath(),
            arrayElement: !1,
            hasConverter: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function $b1c6e3a850a3c735$export$39b482c5e57630a8(e) {
    const t = e._freezeSettings(), n = $b1c6e3a850a3c735$export$b4171a6734a65d42(e._databaseId);
    return new $b1c6e3a850a3c735$var$UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function $b1c6e3a850a3c735$export$dc98b0b04f4c7758(e, t, n, r, i, s = {}) {
    const _ = e.createContext(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    $b1c6e3a850a3c735$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", _, r);
    const o = $b1c6e3a850a3c735$var$__PRIVATE_parseObject(r, _);
    let a, u;
    if (s.merge) a = new $b1c6e3a850a3c735$var$FieldMask(_.fieldMask), u = _.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = $b1c6e3a850a3c735$export$35e795649ee09318(t, r, n);
            if (!_.contains(i)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            $b1c6e3a850a3c735$var$__PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new $b1c6e3a850a3c735$var$FieldMask(e), u = _.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = _.fieldTransforms;
    return new $b1c6e3a850a3c735$var$ParsedSetData(new $b1c6e3a850a3c735$export$c4ce752e73470fba(o), a, u);
}
class $b1c6e3a850a3c735$var$__PRIVATE_DeleteFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.createError(`${this._methodName}() can only appear at the top level of your update data`) : e.createError(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_createSentinelChildContext(e, t, n) {
    return new $b1c6e3a850a3c735$var$ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    _toFieldTransform(e) {
        return new $b1c6e3a850a3c735$var$FieldTransform(e.path, new $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.Tr = t;
    }
    _toFieldTransform(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Tr.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_parseData(e, t)), r = new $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionTransformOperation(n);
        return new $b1c6e3a850a3c735$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this.Tr, e.Tr);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.Tr = t;
    }
    _toFieldTransform(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Tr.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_parseData(e, t)), r = new $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveTransformOperation(n);
        return new $b1c6e3a850a3c735$var$FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveFieldValueImpl && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(this.Tr, e.Tr);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.Pr = t;
    }
    _toFieldTransform(e) {
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementTransformOperation(e.serializer, $b1c6e3a850a3c735$var$toNumber(e.serializer, this.Pr));
        return new $b1c6e3a850a3c735$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementFieldValueImpl && (this.Pr === e.Pr || Number.isNaN(this.Pr) && Number.isNaN(e.Pr));
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.Pr = t;
    }
    _toFieldTransform(e) {
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumTransformOperation(e.serializer, $b1c6e3a850a3c735$var$toNumber(e.serializer, this.Pr));
        return new $b1c6e3a850a3c735$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumFieldValueImpl && (this.Pr === e.Pr || Number.isNaN(this.Pr) && Number.isNaN(e.Pr));
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumFieldValueImpl extends $b1c6e3a850a3c735$export$3d12bd131bb975d1 {
    constructor(e, t){
        super(e), this.Pr = t;
    }
    _toFieldTransform(e) {
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumTransformOperation(e.serializer, $b1c6e3a850a3c735$var$toNumber(e.serializer, this.Pr));
        return new $b1c6e3a850a3c735$var$FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumFieldValueImpl && (this.Pr === e.Pr || Number.isNaN(this.Pr) && Number.isNaN(e.Pr));
    }
}
/** Parse update data from an update() call. */ function $b1c6e3a850a3c735$export$ce26c07117d59d6a(e, t, n, r) {
    const i = e.createContext(1 /* UserDataSource.Update */ , t, n);
    $b1c6e3a850a3c735$var$__PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], _ = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty();
    $b1c6e3a850a3c735$var$forEach(r, (e, r)=>{
        const o = $b1c6e3a850a3c735$export$995eb9fca571757(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(r);
        const a = i.childContextForFieldPath(o);
        if (r instanceof $b1c6e3a850a3c735$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(o);
        else {
            const e = $b1c6e3a850a3c735$var$__PRIVATE_parseData(r, a);
            null != e && (s.push(o), _.set(o, e));
        }
    });
    const o = new $b1c6e3a850a3c735$var$FieldMask(s);
    return new $b1c6e3a850a3c735$var$ParsedUpdateData(_, o, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function $b1c6e3a850a3c735$export$3c2fa207a37baaea(e, t, n, r, i, s) {
    const _ = e.createContext(1 /* UserDataSource.Update */ , t, n), o = [
        $b1c6e3a850a3c735$export$35e795649ee09318(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)o.push($b1c6e3a850a3c735$export$35e795649ee09318(t, s[e])), a.push(s[e + 1]);
    const u = [], c = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = o.length - 1; e >= 0; --e)if (!$b1c6e3a850a3c735$var$__PRIVATE_fieldMaskContains(u, o[e])) {
        const t = o[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n);
        const r = _.childContextForFieldPath(t);
        if (n instanceof $b1c6e3a850a3c735$var$__PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = $b1c6e3a850a3c735$var$__PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const E = new $b1c6e3a850a3c735$var$FieldMask(u);
    return new $b1c6e3a850a3c735$var$ParsedUpdateData(c, E, _.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function $b1c6e3a850a3c735$export$dda1d9f60106f0e9(e, t, n, r = !1) {
    return $b1c6e3a850a3c735$var$__PRIVATE_parseData(n, e.createContext(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_parseData(e, t, n) {
    if ($b1c6e3a850a3c735$var$__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return $b1c6e3a850a3c735$var$__PRIVATE_validatePlainObject("Unsupported field value:", t, e), $b1c6e3a850a3c735$var$__PRIVATE_parseObject(e, t);
    if (e instanceof $b1c6e3a850a3c735$export$3d12bd131bb975d1) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isWrite(t.dataSource)) throw t.createError(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.createError(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.createError("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = $b1c6e3a850a3c735$var$__PRIVATE_parseData(i, t.childContextForArray(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t, n) {
        if (null === (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return $b1c6e3a850a3c735$var$toNumber(t.serializer, e, n);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = $b1c6e3a850a3c735$export$890c4ad488842ce7.fromDate(e);
            return {
                timestampValue: $b1c6e3a850a3c735$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $b1c6e3a850a3c735$export$890c4ad488842ce7) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new $b1c6e3a850a3c735$export$890c4ad488842ce7(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: $b1c6e3a850a3c735$var$toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof $b1c6e3a850a3c735$export$91c6e00c14e7e6fd) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof $b1c6e3a850a3c735$export$ef35774e6d314e91) return {
            bytesValue: $b1c6e3a850a3c735$var$__PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.createError(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: $b1c6e3a850a3c735$var$__PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof $b1c6e3a850a3c735$export$24baa2b76016ce0e) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = e instanceof $b1c6e3a850a3c735$export$24baa2b76016ce0e ? e.toArray() : e, r = {
                fields: {
                    [$b1c6e3a850a3c735$var$_t]: {
                        stringValue: $b1c6e3a850a3c735$var$ut
                    },
                    [$b1c6e3a850a3c735$var$ct]: {
                        arrayValue: {
                            values: n.map((e)=>{
                                if ("number" != typeof e) throw t.createError("VectorValues must only contain numeric values.");
                                return $b1c6e3a850a3c735$var$__PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: r
            };
        }(e, t);
        if ($b1c6e3a850a3c735$var$__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.createError(`Unsupported field value: ${$b1c6e3a850a3c735$export$efccba1c4a2ef57b(e)}`);
    }(e, t, n);
}
function $b1c6e3a850a3c735$var$__PRIVATE_parseObject(e, t) {
    const n = {};
    return $b1c6e3a850a3c735$var$isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : $b1c6e3a850a3c735$var$forEach(e, (e, r)=>{
        const i = $b1c6e3a850a3c735$var$__PRIVATE_parseData(r, t.childContextForField(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof $b1c6e3a850a3c735$export$890c4ad488842ce7 || e instanceof $b1c6e3a850a3c735$export$91c6e00c14e7e6fd || e instanceof $b1c6e3a850a3c735$export$ef35774e6d314e91 || e instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4 || e instanceof $b1c6e3a850a3c735$export$3d12bd131bb975d1 || e instanceof $b1c6e3a850a3c735$export$24baa2b76016ce0e || $b1c6e3a850a3c735$var$__PRIVATE_isProtoValueSerializable(e));
}
function $b1c6e3a850a3c735$var$__PRIVATE_validatePlainObject(e, t, n) {
    if (!$b1c6e3a850a3c735$var$__PRIVATE_looksLikeJsonObject(n) || !$b1c6e3a850a3c735$export$2538633961795d6b(n)) {
        const r = $b1c6e3a850a3c735$export$efccba1c4a2ef57b(n);
        throw "an object" === r ? t.createError(e + " a custom object") : t.createError(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function $b1c6e3a850a3c735$export$35e795649ee09318(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)) instanceof $b1c6e3a850a3c735$export$34aec0b863436764) return t._internalPath;
    if ("string" == typeof t) return $b1c6e3a850a3c735$export$995eb9fca571757(e, t);
    throw $b1c6e3a850a3c735$var$createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const $b1c6e3a850a3c735$var$Kt = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function $b1c6e3a850a3c735$export$995eb9fca571757(e, t, n) {
    if (t.search($b1c6e3a850a3c735$var$Kt) >= 0) throw $b1c6e3a850a3c735$var$createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new $b1c6e3a850a3c735$export$34aec0b863436764(...t.split("."))._internalPath;
    } catch (r) {
        throw $b1c6e3a850a3c735$var$createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function $b1c6e3a850a3c735$var$createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), _ = void 0 !== i;
    let o = `Function ${t}() called with invalid data`;
    n && (o += " (via `toFirestore()`)"), o += ". ";
    let a = "";
    return (s || _) && (a += " (found", s && (a += ` in field ${r}`), _ && (a += ` in document ${i}`), a += ")"), new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, o + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function $b1c6e3a850a3c735$var$__PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
function $b1c6e3a850a3c735$var$__PRIVATE_isUserData(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$OptionsUtil {
    constructor(e){
        this.optionDefinitions = e;
    }
    _getKnownOptions(e, t) {
        const n = $b1c6e3a850a3c735$export$c4ce752e73470fba.empty();
        // SERIALIZE KNOWN OPTIONS
        for(const r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
            const i = this.optionDefinitions[r];
            if (r in e) {
                const s = e[r];
                let _;
                if (i.nestedOptions && $b1c6e3a850a3c735$export$2538633961795d6b(s)) _ = {
                    mapValue: {
                        fields: new $b1c6e3a850a3c735$var$OptionsUtil(i.nestedOptions).getOptionsProto(t, s)
                    }
                };
                else s && (_ = $b1c6e3a850a3c735$var$__PRIVATE_parseData(s, t) ?? void 0);
                _ && n.set($b1c6e3a850a3c735$export$b9a6b53f9be3734.fromServerFormat(i.serverName), _);
            }
        }
        return n;
    }
    getOptionsProto(e, t, n) {
        const r = this._getKnownOptions(t, e);
        // APPLY OPTIONS OVERRIDES
        if (n) {
            const t = new Map($b1c6e3a850a3c735$export$a9c23c6ac3fc3eca(n, (t, n)=>[
                    $b1c6e3a850a3c735$export$b9a6b53f9be3734.fromServerFormat(n),
                    void 0 !== t ? $b1c6e3a850a3c735$var$__PRIVATE_parseData(t, e) : null
                ]));
            r.setAll(t);
        }
        // Return MapValue from `result` or empty map value
        return r.value.mapValue.fields ?? {};
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function $b1c6e3a850a3c735$export$6b179bb11f7fd3a0(e) {
    return "object" == typeof e && null !== e && !!("nullValue" in e && (null === e.nullValue || "NULL_VALUE" === e.nullValue) || "booleanValue" in e && (null === e.booleanValue || "boolean" == typeof e.booleanValue) || "integerValue" in e && (null === e.integerValue || "number" == typeof e.integerValue || "string" == typeof e.integerValue) || "doubleValue" in e && (null === e.doubleValue || "number" == typeof e.doubleValue) || "timestampValue" in e && (null === e.timestampValue || function __PRIVATE_isITimestamp(e) {
        return "object" == typeof e && null !== e && "seconds" in e && (null === e.seconds || "number" == typeof e.seconds || "string" == typeof e.seconds) && "nanos" in e && (null === e.nanos || "number" == typeof e.nanos);
    }(e.timestampValue)) || "stringValue" in e && (null === e.stringValue || "string" == typeof e.stringValue) || "bytesValue" in e && (null === e.bytesValue || e.bytesValue instanceof Uint8Array) || "referenceValue" in e && (null === e.referenceValue || "string" == typeof e.referenceValue) || "geoPointValue" in e && (null === e.geoPointValue || function __PRIVATE_isILatLng(e) {
        return "object" == typeof e && null !== e && "latitude" in e && (null === e.latitude || "number" == typeof e.latitude) && "longitude" in e && (null === e.longitude || "number" == typeof e.longitude);
    }(e.geoPointValue)) || "arrayValue" in e && (null === e.arrayValue || function __PRIVATE_isIArrayValue(e) {
        return "object" == typeof e && null !== e && !(!("values" in e) || null !== e.values && !Array.isArray(e.values));
    }(e.arrayValue)) || "mapValue" in e && (null === e.mapValue || function __PRIVATE_isIMapValue(e) {
        return "object" == typeof e && null !== e && !(!("fields" in e) || null !== e.fields && !$b1c6e3a850a3c735$export$2538633961795d6b(e.fields));
    }(e.mapValue)) || "fieldReferenceValue" in e && (null === e.fieldReferenceValue || "string" == typeof e.fieldReferenceValue) || "functionValue" in e && (null === e.functionValue || function __PRIVATE_isIFunction(e) {
        return "object" == typeof e && null !== e && !(!("name" in e) || null !== e.name && "string" != typeof e.name || !("args" in e) || null !== e.args && !Array.isArray(e.args));
    }(e.functionValue)) || "pipelineValue" in e && (null === e.pipelineValue || function __PRIVATE_isIPipeline(e) {
        return "object" == typeof e && null !== e && !(!("stages" in e) || null !== e.stages && !Array.isArray(e.stages));
    }(e.pipelineValue)));
// Check optional properties and their types
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function $b1c6e3a850a3c735$export$317a3d46287192d8() {
    return new $b1c6e3a850a3c735$var$__PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function $b1c6e3a850a3c735$export$39c1cc7c062529d4() {
    return new $b1c6e3a850a3c735$var$__PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function $b1c6e3a850a3c735$export$2ed0fc6709e59212(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $b1c6e3a850a3c735$var$__PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $b1c6e3a850a3c735$export$c03999cb2f36933f(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new $b1c6e3a850a3c735$var$__PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $b1c6e3a850a3c735$export$fef3dfd9bad05307(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric minimum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $b1c6e3a850a3c735$export$2ec5befb9e6c97d4(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_NumericMinimumFieldValueImpl("minimum", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric maximum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function $b1c6e3a850a3c735$export$d29e374196577086(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_NumericMaximumFieldValueImpl("maximum", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function $b1c6e3a850a3c735$export$f074adc9fbd50943(e) {
    return new $b1c6e3a850a3c735$export$24baa2b76016ce0e(e);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e) {
    let t;
    return e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : (t = $b1c6e3a850a3c735$export$2538633961795d6b(e) ? $b1c6e3a850a3c735$var$__PRIVATE__map(e) : e instanceof Array ? $b1c6e3a850a3c735$export$545a72cc0d3f00b0(e) : $b1c6e3a850a3c735$export$993a080e5cb62d74(e, void 0), t);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(e) {
    if (e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b) return e;
    if (e instanceof $b1c6e3a850a3c735$export$24baa2b76016ce0e) return $b1c6e3a850a3c735$export$eb84e45a33f6ba7c(e);
    if (Array.isArray(e)) return $b1c6e3a850a3c735$export$eb84e45a33f6ba7c($b1c6e3a850a3c735$export$f074adc9fbd50943(e));
    throw new Error("Unsupported value: " + typeof e);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 * If the input is a string, it is assumed to be a field name, and a
 * field(value) is returned.
 *
 * @private
 * @internal
 * @param value
 */ function $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e) {
    if ($b1c6e3a850a3c735$export$c5d1328b37d47994(e)) return $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e);
    return $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e);
}
/**
 *
 * Represents an expression that can be evaluated to a value within the execution of a {@link
 * @firebase/firestore/pipelines#Pipeline}.
 *
 * Expressions are the building blocks for creating complex queries and transformations in
 * Firestore pipelines. They can represent:
 *
 * - **Field references:** Access values from document fields.
 * - **Literals:** Represent constant values (strings, numbers, booleans).
 * - **Function calls:** Apply functions to one or more expressions.
 *
 * The `Expression` class provides a fluent API for building expressions. You can chain together
 * method calls to create complex expressions.
 */ class $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    constructor(){
        this._protoValueType = "ProtoValue";
    }
    /**
     * Creates an expression that adds this expression to another expression.
     *
     * @example
     * ```typescript
     * // Add the value of the 'quantity' field and the 'reserve' field.
     * field("quantity").add(field("reserve"));
     * ```
     *
     * @param second - The expression or literal to add to this expression.
     * @param others - Optional additional expressions or literals to add to this expression.
     * @returns A new `Expression` representing the addition operation.
     */ add(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("add", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "add");
    }
    /**
     * Wraps the expression in a [BooleanExpression].
     *
     * @returns A [BooleanExpression] representing the same expression.
     */ asBoolean() {
        if (this instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79) return this;
        if (this instanceof $b1c6e3a850a3c735$var$Constant) return new $b1c6e3a850a3c735$var$__PRIVATE_BooleanConstant(this);
        if (this instanceof $b1c6e3a850a3c735$export$e0c3a065614c6254) return new $b1c6e3a850a3c735$var$__PRIVATE_BooleanField(this);
        if (this instanceof $b1c6e3a850a3c735$export$b169257caa88022a) return new $b1c6e3a850a3c735$var$__PRIVATE_BooleanFunctionExpression(this);
        throw new $b1c6e3a850a3c735$export$4368d992c4eafac0("invalid-argument", `Conversion of type ${typeof this} to BooleanExpression not supported.`);
    }
    subtract(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("subtract", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "subtract");
    }
    /**
     * Creates an expression that multiplies this expression by another expression.
     *
     * @example
     * ```typescript
     * // Multiply the 'quantity' field by the 'price' field
     * field("quantity").multiply(field("price"));
     * ```
     *
     * @param second - The second expression or literal to multiply by.
     * @param others - Optional additional expressions or literals to multiply by.
     * @returns A new `Expression` representing the multiplication operation.
     */ multiply(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("multiply", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "multiply");
    }
    divide(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("divide", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "divide");
    }
    mod(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("mod", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "mod");
    }
    equal(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("equal", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "equal").asBoolean();
    }
    notEqual(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("not_equal", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "notEqual").asBoolean();
    }
    lessThan(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("less_than", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "lessThan").asBoolean();
    }
    lessThanOrEqual(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("less_than_or_equal", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "lessThanOrEqual").asBoolean();
    }
    greaterThan(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("greater_than", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "greaterThan").asBoolean();
    }
    greaterThanOrEqual(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("greater_than_or_equal", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "greaterThanOrEqual").asBoolean();
    }
    /**
     * Creates an expression that concatenates an array expression with one or more other arrays.
     *
     * @example
     * ```typescript
     * // Combine the 'items' array with another array field.
     * field("items").arrayConcat(field("otherItems"));
     * ```
     * @param secondArray - Second array expression or array literal to concatenate.
     * @param otherArrays - Optional additional array expressions or array literals to concatenate.
     * @returns A new `Expression` representing the concatenated array.
     */ arrayConcat(e, ...t) {
        const n = [
            e,
            ...t
        ].map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e));
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_concat", [
            this,
            ...n
        ], "arrayConcat");
    }
    arrayContains(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_contains", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayContains").asBoolean();
    }
    arrayContainsAll(e) {
        const t = Array.isArray(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_ListOfExprs(e.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr), "arrayContainsAll") : e;
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_contains_all", [
            this,
            t
        ], "arrayContainsAll").asBoolean();
    }
    arrayContainsAny(e) {
        const t = Array.isArray(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_ListOfExprs(e.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr), "arrayContainsAny") : e;
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_contains_any", [
            this,
            t
        ], "arrayContainsAny").asBoolean();
    }
    /**
     * Creates an expression that reverses an array.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myArray' field.
     * field("myArray").arrayReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed array.
     */ arrayReverse() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_reverse", [
            this
        ]);
    }
    /**
     * Creates an expression that calculates the length of an array.
     *
     * @example
     * ```typescript
     * // Get the number of items in the 'cart' array
     * field("cart").arrayLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the array.
     */ arrayLength() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_length", [
            this
        ], "arrayLength");
    }
    equalAny(e) {
        const t = Array.isArray(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_ListOfExprs(e.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr), "equalAny") : e;
        return new $b1c6e3a850a3c735$export$b169257caa88022a("equal_any", [
            this,
            t
        ], "equalAny").asBoolean();
    }
    notEqualAny(e) {
        const t = Array.isArray(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_ListOfExprs(e.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr), "notEqualAny") : e;
        return new $b1c6e3a850a3c735$export$b169257caa88022a("not_equal_any", [
            this,
            t
        ], "notEqualAny").asBoolean();
    }
    /**
     * Creates an expression that checks if a field exists in the document.
     *
     * @example
     * ```typescript
     * // Check if the document has a field named "phoneNumber"
     * field("phoneNumber").exists();
     * ```
     *
     * @returns A new `Expression` representing the 'exists' check.
     */ exists() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("exists", [
            this
        ], "exists").asBoolean();
    }
    /**
     * Creates an expression that calculates the character length of a string in UTF-8.
     *
     * @example
     * ```typescript
     * // Get the character length of the 'name' field in its UTF-8 form.
     * field("name").charLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the string.
     */ charLength() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("char_length", [
            this
        ], "charLength");
    }
    like(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("like", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "like").asBoolean();
    }
    regexContains(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("regex_contains", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexContains").asBoolean();
    }
    regexFind(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("regex_find", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexFind");
    }
    regexFindAll(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("regex_find_all", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexFindAll");
    }
    regexMatch(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("regex_match", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "regexMatch").asBoolean();
    }
    stringContains(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_contains", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "stringContains").asBoolean();
    }
    startsWith(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("starts_with", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "startsWith").asBoolean();
    }
    endsWith(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("ends_with", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "endsWith").asBoolean();
    }
    /**
     * Creates an expression that converts a string to lowercase.
     *
     * @example
     * ```typescript
     * // Convert the 'name' field to lowercase
     * field("name").toLower();
     * ```
     *
     * @returns A new `Expression` representing the lowercase string.
     */ toLower() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("to_lower", [
            this
        ], "toLower");
    }
    /**
     * Creates an expression that converts a string to uppercase.
     *
     * @example
     * ```typescript
     * // Convert the 'title' field to uppercase
     * field("title").toUpper();
     * ```
     *
     * @returns A new `Expression` representing the uppercase string.
     */ toUpper() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("to_upper", [
            this
        ], "toUpper");
    }
    /**
     * Creates an expression that removes leading and trailing characters from a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the 'userInput' field
     * field("userInput").trim();
     *
     * // Trim quotes from the 'userInput' field
     * field("userInput").trim('"');
     * ```
     * @param valueToTrim - Optional This parameter is treated as a set of characters or bytes that will be
     * trimmed from the input. If not specified, then whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ trim(e) {
        const t = [
            this
        ];
        return e && t.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)), new $b1c6e3a850a3c735$export$b169257caa88022a("trim", t, "trim");
    }
    /**
     * Trims whitespace or a specified set of characters/bytes from the beginning of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the beginning of the 'userInput' field
     * field("userInput").ltrim();
     *
     * // Trim quotes from the beginning of the 'userInput' field
     * field("userInput").ltrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string.
     */ ltrim(e) {
        const t = [
            this
        ];
        return e && t.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)), new $b1c6e3a850a3c735$export$b169257caa88022a("ltrim", t, "ltrim");
    }
    /**
     * Trims whitespace or a specified set of characters/bytes from the end of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the end of the 'userInput' field
     * field("userInput").rtrim();
     *
     * // Trim quotes from the end of the 'userInput' field
     * field("userInput").rtrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ rtrim(e) {
        const t = [
            this
        ];
        return e && t.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)), new $b1c6e3a850a3c735$export$b169257caa88022a("rtrim", t, "rtrim");
    }
    /**
     * Creates an expression that returns the data type of this expression's result, as a string.
     *
     * @remarks
     * This is evaluated on the backend. This means:
     * 1. Generic typed elements (like `array<string>`) evaluate strictly to the primitive `'array'`.
     * 2. Any custom `FirestoreDataConverter` mappings are ignored.
     * 3. For numeric values, the backend does not yield the JavaScript `"number"` type; it evaluates
     *    precisely as `"int64"` or `"float64"`.
     * 4. For date or timestamp objects, the backend evaluates to `"timestamp"`.
     *
     * @example
     * ```typescript
     * // Get the data type of the value in field 'title'
     * field('title').type()
     * ```
     *
     * @returns A new `Expression` representing the data type.
     */ type() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("type", [
            this
        ]);
    }
    /**
     * Creates an expression that checks if the result of this expression is of the given type.
     *
     * @remarks Null or undefined fields evaluate to skip/error. Use `ifAbsent()` / `isAbsent()` to evaluate missing data.
     * Supported values for `type` are:
     * `'null'`, `'array'`, `'boolean'`, `'bytes'`, `'timestamp'`, `'geo_point'`, `'number'`,
     * `'int32'`, `'int64'`, `'float64'`, `'decimal128'`, `'map'`, `'reference'`, `'string'`,
     * `'vector'`, `'max_key'`, `'min_key'`, `'object_id'`, `'regex'`, `'request_timestamp'`.
     *
     * @example
     * ```typescript
     * // Check if the 'price' field is specifically an integer (not just 'number')
     * field('price').isType('int64');
     * ```
     *
     * @param type - The type to check for.
     * @returns A new `BooleanExpression` that evaluates to true if the expression's result is of the given type, false otherwise.
     */ isType(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("is_type", [
            this,
            $b1c6e3a850a3c735$export$eb84e45a33f6ba7c(e)
        ], "isType").asBoolean();
    }
    /**
     * Creates an expression that concatenates string expressions together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', " ", and 'lastName' fields into a single string
     * field("firstName").stringConcat(constant(" "), field("lastName"));
     * ```
     *
     * @param secondString - The additional expression or string literal to concatenate.
     * @param otherStrings - Optional additional expressions or string literals to concatenate.
     * @returns A new `Expression` representing the concatenated string.
     */ stringConcat(e, ...t) {
        const n = [
            e,
            ...t
        ].map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr);
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_concat", [
            this,
            ...n
        ], "stringConcat");
    }
    /**
     * Creates an expression that finds the index of the first occurrence of a substring or byte sequence.
     *
     * @example
     * ```typescript
     * // Find the index of "foo" in the 'text' field
     * field("text").stringIndexOf("foo");
     * ```
     *
     * @param search - The substring or byte sequence to search for.
     * @returns A new `Expression` representing the index of the first occurrence.
     */ stringIndexOf(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_index_of", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "stringIndexOf");
    }
    /**
     * Creates an expression that repeats a string or byte array a specified number of times.
     *
     * @example
     * ```typescript
     * // Repeat the 'label' field 3 times
     * field("label").stringRepeat(3);
     * ```
     *
     * @param repetitions - The number of times to repeat the string or byte array.
     * @returns A new `Expression` representing the repeated string or byte array.
     */ stringRepeat(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_repeat", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "stringRepeat");
    }
    /**
     * Creates an expression that replaces all occurrences of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace all occurrences of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceAll("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with replacements.
     */ stringReplaceAll(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_replace_all", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
        ], "stringReplaceAll");
    }
    /**
     * Creates an expression that replaces the first occurrence of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace the first occurrence of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceOne("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with the replacement.
     */ stringReplaceOne(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_replace_one", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
        ], "stringReplaceOne");
    }
    /**
     * Creates an expression that concatenates expression results together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', ' ', and 'lastName' fields into a single value.
     * field("firstName").concat(constant(" "), field("lastName"));
     * ```
     *
     * @param second - The additional expression or literal to concatenate.
     * @param others - Optional additional expressions or literals to concatenate.
     * @returns A new `Expression` representing the concatenated value.
     */ concat(e, ...t) {
        const n = [
            e,
            ...t
        ].map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr);
        return new $b1c6e3a850a3c735$export$b169257caa88022a("concat", [
            this,
            ...n
        ], "concat");
    }
    /**
     * Creates an expression that reverses this string expression.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").reverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ reverse() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("reverse", [
            this
        ], "reverse");
    }
    /**
     * Filters the array using a provided alias and predicate expression.
     *
     * @example
     * ```typescript
     * // Filter the 'items' array to only include those where the 'price' is greater than 10
     * field("items").arrayFilter('item', greaterThan(variable('item.price'), 10));
     * ```
     *
     * @param alias - The variable name to use for each element.
     * @param filter - The predicate boolean expression to filter by.
     * @returns A new `Expression` representing the filtered array.
     */ arrayFilter(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_filter", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            t
        ], "arrayFilter");
    }
    /**
     * Creates an expression that applies a provided transformation to each element in an array.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by multiplying each score by 10
     * field("scores").arrayTransform("score", multiply(variable("score"), 10));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransform operation.
     */ arrayTransform(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_transform", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            t
        ], "arrayTransform");
    }
    /**
     * Creates an expression that applies a provided transformation to each element in an array, providing the element's index to the transformation expression.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by adding the index to each score
     * field("scores").arrayTransformWithIndex("score", "i", add(variable("score"), variable("i")));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param indexAlias - The variable name to use for the current index.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransformWithIndex operation.
     */ arrayTransformWithIndex(e, t, n) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_transform", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t),
            n
        ], "arrayTransformWithIndex");
    }
    /**
     * Returns a subset of the array.
     *
     * @example
     * ```typescript
     * // Get 5 elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, 5);
     *
     * // Get n number of elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, field("count"));
     * ```
     *
     * @param offset - The starting offset.
     * @param length - The optional length of the slice.
     * @returns A new `Expression` representing the sliced array.
     */ arraySlice(e, t) {
        const n = [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ];
        return void 0 !== t && n.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)), new $b1c6e3a850a3c735$export$b169257caa88022a("array_slice", n, "arraySlice");
    }
    /**
     * Returns the first element of the array.
     *
     * @example
     * ```typescript
     * // Get the first element of the 'myArray' field.
     * field("myArray").arrayFirst();
     * ```
     *
     * @returns A new `Expression` representing the first element.
     */ arrayFirst() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_first", [
            this
        ], "arrayFirst");
    }
    arrayFirstN(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_first_n", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayFirstN");
    }
    /**
     * Returns the last element of the array.
     *
     * @example
     * ```typescript
     * // Get the last element of the 'myArray' field.
     * field("myArray").arrayLast();
     * ```
     *
     * @returns A new `Expression` representing the last element.
     */ arrayLast() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_last", [
            this
        ], "arrayLast");
    }
    arrayLastN(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_last_n", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayLastN");
    }
    /**
     * Returns the maximum value in the array.
     *
     * @example
     * ```typescript
     * // Get the maximum value of the 'myArray' field.
     * field("myArray").arrayMaximum();
     * ```
     *
     * @returns A new `Expression` representing the maximum value.
     */ arrayMaximum() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("maximum", [
            this
        ], "arrayMaximum");
    }
    arrayMaximumN(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("maximum_n", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayMaximumN");
    }
    /**
     * Returns the minimum value in the array.
     *
     * @example
     * ```typescript
     * // Get the minimum value of the 'myArray' field.
     * field("myArray").arrayMinimum();
     * ```
     *
     * @returns A new `Expression` representing the minimum value.
     */ arrayMinimum() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("minimum", [
            this
        ], "arrayMinimum");
    }
    arrayMinimumN(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("minimum_n", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayMinimumN");
    }
    arrayIndexOf(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_index_of", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr("first")
        ], "arrayIndexOf");
    }
    arrayLastIndexOf(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_index_of", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr("last")
        ], "arrayLastIndexOf");
    }
    arrayIndexOfAll(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_index_of_all", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayIndexOfAll");
    }
    /**
     * Creates an expression that calculates the length of this string expression in bytes.
     *
     * @example
     * ```typescript
     * // Calculate the length of the 'myString' field in bytes.
     * field("myString").byteLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the string in bytes.
     */ byteLength() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("byte_length", [
            this
        ], "byteLength");
    }
    /**
     * Creates an expression that computes the ceiling of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the ceiling of the 'price' field.
     * field("price").ceil();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the ceiling of the numeric value.
     */ ceil() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("ceil", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the floor of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the floor of the 'price' field.
     * field("price").floor();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the floor of the numeric value.
     */ floor() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("floor", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the absolute value of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the absolute value of the 'price' field.
     * field("price").abs();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the absolute value of the numeric value.
     */ abs() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("abs", [
            this
        ]);
    }
    /**
     * Creates an expression that computes e to the power of this expression.
     *
     * @example
     * ```typescript
     * // Compute e to the power of the 'value' field.
     * field("value").exp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the exp of the numeric value.
     */ exp() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("exp", [
            this
        ]);
    }
    /**
     * Accesses a value from a map (object) field using the provided key.
     *
     * @example
     * ```typescript
     * // Get the 'city' value from the 'address' map field
     * field("address").mapGet("city");
     * ```
     *
     * @param subfield - The key to access in the map.
     * @returns A new `Expression` representing the value associated with the given key in the map.
     */ mapGet(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_get", [
            this,
            $b1c6e3a850a3c735$export$eb84e45a33f6ba7c(e)
        ], "mapGet");
    }
    /**
     * Creates an expression that returns a new map with the specified entries added or updated.
     *
     * @remarks
     * Note that `mapSet` only performs shallow updates to the map. Setting a value to `null`
     * will retain the key with a `null` value. To remove a key entirely, use `mapRemove`.
     *
     * @example
     * ```typescript
     * // Set the 'city' to "San Francisco" in the 'address' map
     * field("address").mapSet("city", "San Francisco");
     * ```
     *
     * @param key - The key to set. Must be a string or a constant string expression.
     * @param value - The value to set.
     * @param moreKeyValues - Additional key-value pairs to set.
     * @returns A new `Expression` representing the map with the entries set.
     */ mapSet(e, t, ...n) {
        const r = [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t),
            ...n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr)
        ];
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_set", r, "mapSet");
    }
    /**
     * Creates an expression that returns the keys of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the keys of the 'address' map
     * field("address").mapKeys();
     * ```
     *
     * @returns A new `Expression` representing the keys of the map.
     */ mapKeys() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_keys", [
            this
        ], "mapKeys");
    }
    /**
     * Creates an expression that returns the values of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the values of the 'address' map
     * field("address").mapValues();
     * ```
     *
     * @returns A new `Expression` representing the values of the map.
     */ mapValues() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_values", [
            this
        ], "mapValues");
    }
    /**
     * Creates an expression that returns the entries of a map as an array of maps,
     * where each map contains a `"k"` property for the key and a `"v"` property for the value.
     * For example: `[{ k: "key1", v: "value1" }, ...]`.
     *
     * @example
     * ```typescript
     * // Get the entries of the 'address' map
     * field("address").mapEntries();
     * ```
     *
     * @returns A new `Expression` representing the entries of the map.
     */ mapEntries() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_entries", [
            this
        ], "mapEntries");
    }
    /**
     * @public
     * Creates an expression that returns the value of a field from the document that results from the evaluation of this expression.
     *
     * @example
     * ```typescript
     * // Get the value of the "city" field in the "address" document.
     * field("address").getField("city")
     * ```
     *
     * @param key The field to access in the document.
     * @returns A new `Expression` representing the value of the field in the document.
     */ getField(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("get_field", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "get_field");
    }
    /**
     * Creates an aggregation that counts the number of stage inputs with valid evaluations of the
     * expression or field.
     *
     * @example
     * ```typescript
     * // Count the total number of products
     * field("productId").count().as("totalProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count' aggregation.
     */ count() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("count", [
            this
        ], "count");
    }
    /**
     * Creates an aggregation that calculates the sum of a numeric field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the total revenue from a set of orders
     * field("orderAmount").sum().as("totalRevenue");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'sum' aggregation.
     */ sum() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("sum", [
            this
        ], "sum");
    }
    /**
     * Creates an aggregation that calculates the average (mean) of a numeric field across multiple
     * stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the average age of users
     * field("age").average().as("averageAge");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'average' aggregation.
     */ average() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("average", [
            this
        ], "average");
    }
    /**
     * Creates an aggregation that finds the minimum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the lowest price of all products
     * field("price").minimum().as("lowestPrice");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'minimum' aggregation.
     */ minimum() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("minimum", [
            this
        ], "minimum");
    }
    /**
     * Creates an aggregation that finds the maximum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the highest score in a leaderboard
     * field("score").maximum().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'maximum' aggregation.
     */ maximum() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("maximum", [
            this
        ], "maximum");
    }
    /**
     * Creates an aggregation that finds the first value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the first value of the 'rating' field
     * field("rating").first().as("firstRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'first' aggregation.
     */ first() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("first", [
            this
        ], "first");
    }
    /**
     * Creates an aggregation that finds the last value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the last value of the 'rating' field
     * field("rating").last().as("lastRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'last' aggregation.
     */ last() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("last", [
            this
        ], "last");
    }
    /**
     * Creates an aggregation that collects all values of an expression across multiple stage inputs
     * into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all tags from books into an array
     * field("tags").arrayAgg().as("allTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg' aggregation.
     */ arrayAgg() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("array_agg", [
            this
        ], "arrayAgg");
    }
    /**
     * Creates an aggregation that collects all distinct values of an expression across multiple stage
     * inputs into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all distinct tags from books into an array
     * field("tags").arrayAggDistinct().as("allDistinctTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg_distinct' aggregation.
     */ arrayAggDistinct() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("array_agg_distinct", [
            this
        ], "arrayAggDistinct");
    }
    /**
     * Creates an aggregation that counts the number of distinct values of the expression or field.
     *
     * @example
     * ```typescript
     * // Count the distinct number of products
     * field("productId").countDistinct().as("distinctProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
     */ countDistinct() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("count_distinct", [
            this
        ], "countDistinct");
    }
    /**
     * Creates an expression that returns the larger value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the larger value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMaximum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical maximum operation.
     */ logicalMaximum(e, ...t) {
        const n = [
            e,
            ...t
        ];
        return new $b1c6e3a850a3c735$export$b169257caa88022a("maximum", [
            this,
            ...n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr)
        ], "logicalMaximum");
    }
    /**
     * Creates an expression that returns the smaller value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the smaller value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMinimum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical minimum operation.
     */ logicalMinimum(e, ...t) {
        const n = [
            e,
            ...t
        ];
        return new $b1c6e3a850a3c735$export$b169257caa88022a("minimum", [
            this,
            ...n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr)
        ], "minimum");
    }
    /**
     * Creates an expression that calculates the length (number of dimensions) of this Firestore Vector expression.
     *
     * @example
     * ```typescript
     * // Get the vector length (dimension) of the field 'embedding'.
     * field("embedding").vectorLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the vector.
     */ vectorLength() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("vector_length", [
            this
        ], "vectorLength");
    }
    cosineDistance(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("cosine_distance", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(e)
        ], "cosineDistance");
    }
    dotProduct(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("dot_product", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(e)
        ], "dotProduct");
    }
    euclideanDistance(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("euclidean_distance", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(e)
        ], "euclideanDistance");
    }
    /**
     * Creates an expression that interprets this expression as the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'microseconds' field as microseconds since epoch.
     * field("microseconds").unixMicrosToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixMicrosToTimestamp() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("unix_micros_to_timestamp", [
            this
        ], "unixMicrosToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to microseconds since epoch.
     * field("timestamp").timestampToUnixMicros();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of microseconds since epoch.
     */ timestampToUnixMicros() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_to_unix_micros", [
            this
        ], "timestampToUnixMicros");
    }
    /**
     * Creates an expression that interprets this expression as the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'milliseconds' field as milliseconds since epoch.
     * field("milliseconds").unixMillisToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixMillisToTimestamp() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("unix_millis_to_timestamp", [
            this
        ], "unixMillisToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to milliseconds since epoch.
     * field("timestamp").timestampToUnixMillis();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of milliseconds since epoch.
     */ timestampToUnixMillis() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_to_unix_millis", [
            this
        ], "timestampToUnixMillis");
    }
    /**
     * Creates an expression that interprets this expression as the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'seconds' field as seconds since epoch.
     * field("seconds").unixSecondsToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixSecondsToTimestamp() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("unix_seconds_to_timestamp", [
            this
        ], "unixSecondsToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to seconds since epoch.
     * field("timestamp").timestampToUnixSeconds();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of seconds since epoch.
     */ timestampToUnixSeconds() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_to_unix_seconds", [
            this
        ], "timestampToUnixSeconds");
    }
    timestampAdd(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_add", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
        ], "timestampAdd");
    }
    timestampSubtract(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_subtract", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
        ], "timestampSubtract");
    }
    timestampDiff(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_diff", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e),
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
        ], "timestampDiff");
    }
    timestampExtract(e, t) {
        const n = [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ];
        return t && n.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)), new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_extract", n, "timestampExtract");
    }
    /**
     *
     * Creates an expression that returns the document ID from a path.
     *
     * @example
     * ```typescript
     * // Get the document ID from a path.
     * field("__path__").documentId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the documentId operation.
     */ documentId() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("document_id", [
            this
        ], "documentId");
    }
    /**
     *
     * Creates an expression that returns the parent document reference of a document reference.
     *
     * @example
     * ```typescript
     * // Get the parent document reference of a document reference.
     * field("__path__").parent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the parent operation.
     */ parent() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("parent", [
            this
        ], "parent");
    }
    substring(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e);
        return new $b1c6e3a850a3c735$export$b169257caa88022a("substring", void 0 === t ? [
            this,
            n
        ] : [
            this,
            n,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
        ], "substring");
    }
    arrayGet(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array_get", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "arrayGet");
    }
    /**
     *
     * Creates an expression that checks if a given expression produces an error.
     *
     * @example
     * ```typescript
     * // Check if the result of a calculation is an error
     * field("title").arrayContains(1).isError();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isError' check.
     */ isError() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("is_error", [
            this
        ], "isError").asBoolean();
    }
    ifError(e) {
        const t = new $b1c6e3a850a3c735$export$b169257caa88022a("if_error", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "ifError");
        return e instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79 ? t.asBoolean() : t;
    }
    /**
     *
     * Creates an expression that returns `true` if the result of this expression
     * is absent. Otherwise, returns `false` even if the value is `null`.
     *
     * @example
     * ```typescript
     * // Check if the field `value` is absent.
     * field("value").isAbsent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isAbsent' check.
     */ isAbsent() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("is_absent", [
            this
        ], "isAbsent").asBoolean();
    }
    mapRemove(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_remove", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "mapRemove");
    }
    /**
     *
     * Creates an expression that merges multiple map values.
     *
     * @example
     * ```
     * // Merges the map in the settings field with, a map literal, and a map in
     * // that is conditionally returned by another expression
     * field('settings').mapMerge({ enabled: true }, conditional(field('isAdmin'), { admin: true}, {})
     * ```
     *
     * @param secondMap - A required second map to merge. Represented as a literal or
     * an expression that returns a map.
     * @param otherMaps - Optional additional maps to merge. Each map is represented
     * as a literal or an expression that returns a map.
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'mapMerge' operation.
     */ mapMerge(e, ...t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e), r = t.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr);
        return new $b1c6e3a850a3c735$export$b169257caa88022a("map_merge", [
            this,
            n,
            ...r
        ], "mapMerge");
    }
    pow(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("pow", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ]);
    }
    trunc(e) {
        return void 0 === e ? new $b1c6e3a850a3c735$export$b169257caa88022a("trunc", [
            this
        ]) : new $b1c6e3a850a3c735$export$b169257caa88022a("trunc", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "trunc");
    }
    round(e) {
        return void 0 === e ? new $b1c6e3a850a3c735$export$b169257caa88022a("round", [
            this
        ]) : new $b1c6e3a850a3c735$export$b169257caa88022a("round", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "round");
    }
    /**
     * Creates an expression that returns the collection ID from a path.
     *
     * @example
     * ```typescript
     * // Get the collection ID from a path.
     * field("__path__").collectionId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the collectionId operation.
     */ collectionId() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("collection_id", [
            this
        ]);
    }
    /**
     * Creates an expression that calculates the length of a string, array, map, vector, or bytes.
     *
     * @example
     * ```typescript
     * // Get the length of the 'name' field.
     * field("name").length();
     *
     * // Get the number of items in the 'cart' array.
     * field("cart").length();
     * ```
     *
     * @returns A new `Expression` representing the length of the string, array, map, vector, or bytes.
     */ length() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("length", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the natural logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the natural logarithm of the 'value' field.
     * field("value").ln();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the natural logarithm of the numeric value.
     */ ln() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("ln", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the square root of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the square root of the 'value' field.
     * field("value").sqrt();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the square root of the numeric value.
     */ sqrt() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("sqrt", [
            this
        ]);
    }
    /**
     * Creates an expression that reverses a string.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").stringReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ stringReverse() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("string_reverse", [
            this
        ]);
    }
    ifAbsent(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("if_absent", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "ifAbsent");
    }
    ifNull(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("if_null", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "ifNull");
    }
    /**
     * Creates an expression that returns the first non-null, non-absent argument, without evaluating
     * the rest of the arguments. When all arguments are null or absent, returns the last argument.
     *
     * @example
     * ```typescript
     * // Returns the value of the first non-null, non-absent field among 'preferredName', 'fullName',
     * // or the last argument if all previous fields are null.
     * field("preferredName").coalesce(field("fullName"), "Anonymous");
     * ```
     *
     * @param replacement - The value to use if this expression evaluates to null.
     * @param others - Optional additional values to check if previous values are null.
     * @returns A new `Expression` representing the coalesce operation.
     */ coalesce(e, ...t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("coalesce", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
            ...t.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr)
        ], "coalesce");
    }
    join(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("join", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "join");
    }
    /**
     * Creates an expression that computes the base-10 logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the base-10 logarithm of the 'value' field.
     * field("value").log10();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the base-10 logarithm of the numeric value.
     */ log10() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("log10", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the sum of the elements in an array.
     *
     * @example
     * ```typescript
     * // Compute the sum of the elements in the 'scores' field.
     * field("scores").arraySum();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the sum of the elements in the array.
     */ arraySum() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("sum", [
            this
        ]);
    }
    split(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("split", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ]);
    }
    timestampTruncate(e, t) {
        const n = [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ];
        return t && n.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)), new $b1c6e3a850a3c735$export$b169257caa88022a("timestamp_trunc", n);
    }
    // TODO(search) enable with backend support
    // /**
    //  * Evaluates if the result of this `expression` is between
    //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
    //  *
    //  * @example
    //  * ```
    //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
    //  * field('tireWidth').between(constant(2.2), constant(2.4))
    //  *
    //  * // This is functionally equivalent to
    //  * and(field('tireWidth').greaterThanOrEqual(contant(2.2)), field('tireWidth').lessThanOrEqual(constant(2.4)))
    //  * ```
    //  *
    //  * @param lowerBound - Lower bound (inclusive) of the range.
    //  * @param upperBound - Upper bound (inclusive) of the range.
    //  */
    // between(lowerBound: Expression, upperBound: Expression): BooleanExpression;
    // /**
    //  * Evaluates if the result of this `expression` is between
    //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
    //  *
    //  * @example
    //  * ```
    //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
    //  * field('tireWidth').between(2.2, 2.4)
    //  *
    //  * // This is functionally equivalent to
    //  * and(field('tireWidth').greaterThanOrEqual(2.2), field('tireWidth').lessThanOrEqual(2.4))
    //  * ```
    //  *
    //  * @param lowerBound - Lower bound (inclusive) of the range.
    //  * @param upperBound - Upper bound (inclusive) of the range.
    //  */
    // between(lowerBound: unknown, upperBound: unknown): BooleanExpression;
    // between(lowerBound: unknown, upperBound: unknown): BooleanExpression {
    //   return new FunctionExpression('between', [
    //     this,
    //     valueToDefaultExpr(lowerBound),
    //     valueToDefaultExpr(upperBound)
    //   ]).asBoolean();
    // }
    // TODO(search) enable with backend support
    // /**
    //  * Evaluates to an HTML-formatted text snippet that renders terms matching
    //  * the search query in `<b>bold</b>`.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param rquery Define the search query using the search domain-specific language (DSL).
    //  */
    // snippet(rquery: string): Expression;
    // /**
    //  * Evaluates to an HTML-formatted text snippet that renders terms matching
    //  * the search query in `<b>bold</b>`.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param options Define how snippeting behaves.
    //  */
    // snippet(options: SnippetOptions): Expression;
    // snippet(queryOrOptions: string | SnippetOptions): Expression {
    //   const options: SnippetOptions = isString(queryOrOptions)
    //     ? { rquery: queryOrOptions }
    //     : queryOrOptions;
    //   const rquery = options.rquery;
    //   const internalOptions = {
    //     maxSnippetWidth: options.maxSnippetWidth,
    //     maxSnippets: options.maxSnippets,
    //     separator: options.separator
    //   };
    //   return new SnippetExpression([this, constant(rquery)], internalOptions);
    // }
    // TODO(new-expression): Add new expression method definitions above this line
    /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in ascending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'name' field in ascending order
     * firestore.pipeline().collection("users")
     *   .sort(field("name").ascending());
     * ```
     *
     * @returns A new `Ordering` for ascending sorting.
     */ ascending() {
        return $b1c6e3a850a3c735$export$9ddbdd0bfc5623a(this);
    }
    /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in descending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'createdAt' field in descending order
     * firestore.pipeline().collection("users")
     *   .sort(field("createdAt").descending());
     * ```
     *
     * @returns A new `Ordering` for descending sorting.
     */ descending() {
        return $b1c6e3a850a3c735$export$b37556a6cf1be916(this);
    }
    /**
     * Assigns an alias to this expression.
     *
     * Aliases are useful for renaming fields in the output of a stage or for giving meaningful
     * names to calculated values.
     *
     * @example
     * ```typescript
     * // Calculate the total price and assign it the alias "totalPrice" and add it to the output.
     * firestore.pipeline().collection("items")
     *   .addFields(field("price").multiply(field("quantity")).as("totalPrice"));
     * ```
     *
     * @param name - The alias to assign to this expression.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedExpression} that wraps this
     *     expression and associates it with the provided alias.
     */ as(e) {
        return new $b1c6e3a850a3c735$export$dabba94403d45c8e(this, e, "as");
    }
}
/**
 *
 * A class that represents an aggregate function.
 */ class $b1c6e3a850a3c735$export$45aabb5431c2d04f {
    constructor(e, t){
        this.name = e, this.params = t, this.exprType = "AggregateFunction", this._protoValueType = "ProtoValue";
    }
    /**
     * @internal
     * @private
     */ static _create(e, t, n) {
        const r = new $b1c6e3a850a3c735$export$45aabb5431c2d04f(e, t);
        return r._methodName = n, r;
    }
    /**
     * Assigns an alias to this AggregateFunction. The alias specifies the name that
     * the aggregated value will have in the output document.
     *
     * @example
     * ```typescript
     * // Calculate the average price of all items and assign it the alias "averagePrice".
     * firestore.pipeline().collection("items")
     *   .aggregate(field("price").average().as("averagePrice"));
     * ```
     *
     * @param name - The alias to assign to this AggregateFunction.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedAggregate} that wraps this
     *     AggregateFunction and associates it with the provided alias.
     */ as(e) {
        return new $b1c6e3a850a3c735$export$add49c223b9ce4ea(this, e, "as");
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            functionValue: {
                name: this.name,
                args: this.params.map((t)=>t._toProto(e))
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.params.forEach((t)=>t._readUserData(e));
    }
}
/**
 *
 * An AggregateFunction with alias.
 */ class $b1c6e3a850a3c735$export$add49c223b9ce4ea {
    constructor(e, t, n){
        this.aggregate = e, this.alias = t, this._methodName = n;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.aggregate._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$dabba94403d45c8e {
    constructor(e, t, n){
        this.expr = e, this.alias = t, this._methodName = n, this.exprType = "AliasedExpression", this.selectable = !0;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.expr._readUserData(e);
    }
}
/**
 * @internal
 */ class $b1c6e3a850a3c735$var$__PRIVATE_ListOfExprs extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    constructor(e, t){
        super(), this.Rr = e, this._methodName = t, this.expressionType = "ListOfExpressions";
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            arrayValue: {
                values: this.Rr.map((t)=>t._toProto(e))
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.Rr.forEach((t)=>t._readUserData(e));
    }
}
/**
 *
 * Represents a reference to a field in a Firestore document, or outputs of a {@link @firebase/firestore/pipelines#Pipeline} stage.
 *
 * <p>Field references are used to access document field values in expressions and to specify fields
 * for sorting, filtering, and projecting data in Firestore pipelines.
 *
 * <p>You can create a `Field` instance using the static {@link @firebase/firestore/pipelines#field} method:
 *
 * @example
 * ```typescript
 * // Create a Field instance for the 'name' field
 * const nameField = field("name");
 *
 * // Create a Field instance for a nested field 'address.city'
 * const cityField = field("address.city");
 * ```
 */ class $b1c6e3a850a3c735$export$e0c3a065614c6254 extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    /**
     * @internal
     * @private
     * @hideconstructor
     * @param fieldPath
     */ constructor(e, t){
        super(), this.fieldPath = e, this._methodName = t, this.expressionType = "Field", this.selectable = !0;
    }
    get _fieldPath() {
        return this.fieldPath;
    }
    get fieldName() {
        return this.fieldPath.canonicalString();
    }
    get alias() {
        return this.fieldName;
    }
    get expr() {
        return this;
    }
    // TODO(search) enable with backend support
    // /**
    //  * Perform a full-text search on this field.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param rquery Define the search query using the search domain-specific language (DSL).
    //  */
    // matches(rquery: string | Expression): BooleanExpression {
    //   return new FunctionExpression(
    //     'matches',
    //     [this, valueToDefaultExpr(rquery)],
    //     'matches'
    //   ).asBoolean();
    // }
    /**
     * @beta
     * Evaluates to the distance in meters between the location specified
     * by this field and the query location.
     *
     * @remarks This Expression can only be used within a `search` stage.
     *
     * @param location - Compute distance to this GeoPoint.
     */ geoDistance(e) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("geo_distance", [
            this,
            $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
        ], "geoDistance");
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            fieldReferenceValue: this.fieldPath.canonicalString()
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {}
}
function $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e) {
    return $b1c6e3a850a3c735$export$1ddf2d01943a3512(e, "field");
}
function $b1c6e3a850a3c735$export$1ddf2d01943a3512(e, t) {
    return new $b1c6e3a850a3c735$export$e0c3a065614c6254("string" == typeof e ? $b1c6e3a850a3c735$var$F === e ? $b1c6e3a850a3c735$export$9d0e2d13d04f7070()._internalPath : $b1c6e3a850a3c735$export$35e795649ee09318("field", e) : e._internalPath, t);
}
/**
 * @internal
 *
 * Represents a constant value that can be used in a Firestore pipeline expression.
 *
 * You can create a `Constant` instance using the static {@link @firebase/firestore/pipelines#field} method:
 *
 * @example
 * ```typescript
 * // Create a Constant instance for the number 10
 * const ten = constant(10);
 *
 * // Create a Constant instance for the string "hello"
 * const hello = constant("hello");
 * ```
 */ class $b1c6e3a850a3c735$var$Constant extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    /**
     * @private
     * @internal
     * @hideconstructor
     * @param value - The value of the constant.
     */ constructor(e, t){
        super(), this.value = e, this._methodName = t, this.expressionType = "Constant";
    }
    /**
     * @private
     * @internal
     */ static _fromProto(e) {
        const t = new $b1c6e3a850a3c735$var$Constant(e, void 0);
        return t._protoValue = e, t;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(void 0 !== this._protoValue, 237), this._protoValue;
    }
    _getValue() {
        return this._protoValue;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, $b1c6e3a850a3c735$export$6b179bb11f7fd3a0(this._protoValue) || (this._protoValue = $b1c6e3a850a3c735$var$__PRIVATE_parseData(this.value, e));
    }
}
function $b1c6e3a850a3c735$export$eb84e45a33f6ba7c(e, t) {
    return $b1c6e3a850a3c735$export$993a080e5cb62d74(e, "constant");
}
/**
 * @internal
 * @private
 * @param value
 * @param methodName
 */ function $b1c6e3a850a3c735$export$993a080e5cb62d74(e, t) {
    const n = new $b1c6e3a850a3c735$var$Constant(e, t);
    return "boolean" == typeof e ? new $b1c6e3a850a3c735$var$__PRIVATE_BooleanConstant(n) : n;
}
/**
 * Internal only
 * @internal
 * @private
 */ class $b1c6e3a850a3c735$var$MapValue extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    constructor(e, t){
        super(), this.Ir = e, this._methodName = t, this.expressionType = "Constant";
    }
    _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.Ir.forEach((t)=>{
            t._readUserData(e);
        });
    }
    _toProto(e) {
        return $b1c6e3a850a3c735$var$toMapValue(e, this.Ir);
    }
}
/**
 *
 * This class defines the base class for Firestore {@link @firebase/firestore/pipelines#Pipeline} functions, which can be evaluated within pipeline
 * execution.
 *
 * Typically, you would not use this class or its children directly. Use either the functions like {@link @firebase/firestore/pipelines#and}, {@link @firebase/firestore/pipelines#(equal:1)},
 * or the methods on {@link @firebase/firestore/pipelines#Expression} ({@link @firebase/firestore/pipelines#Expression.(equal:1)}, {@link @firebase/firestore/pipelines#Expression.(lessThan:1)}, etc.) to construct new Function instances.
 */ class $b1c6e3a850a3c735$export$b169257caa88022a extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    /**
     * @hideconstructor
     */ constructor(e, t, n, r){
        super(), this.name = e, this.params = t, this.expressionType = "Function", /**
         * @private
         * @internal
         */ this._optionsProto = void 0, void 0 !== n && (this._methodName = n), void 0 !== r && (this._options = r);
    }
    /**
     * @private
     * @internal
     */ get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        const t = {
            functionValue: {
                name: this.name,
                args: this.params.map((t)=>t._toProto(e))
            }
        };
        return this._optionsProto && (t.functionValue.options = this._optionsProto), t;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.params.forEach((t)=>t._readUserData(e)), this._options && (this._optionsProto = this._optionsUtil.getOptionsProto(e, this._options));
    }
}
/**
 *
 * An interface that represents a filter condition.
 */ class $b1c6e3a850a3c735$export$65ab0ebced932b79 extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    get _methodName() {
        return this._expr._methodName;
    }
    /**
     * Creates an aggregation that finds the count of input documents satisfying
     * this boolean expression.
     *
     * @example
     * ```typescript
     * // Find the count of documents with a score greater than 90
     * field("score").greaterThan(90).countIf().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
     */ countIf() {
        return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("count_if", [
            this
        ], "countIf");
    }
    /**
     * Creates an expression that negates this boolean expression.
     *
     * @example
     * ```typescript
     * // Find documents where the 'tags' field does not contain 'completed'
     * field("tags").arrayContains("completed").not();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
     */ not() {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("not", [
            this
        ], "not").asBoolean();
    }
    /**
     * Creates a conditional expression that evaluates to the 'then' expression
     * if `this` expression evaluates to `true`,
     * or evaluates to the 'else' expression if `this` expressions evaluates `false`.
     *
     * @example
     * ```typescript
     * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
     * field("age").greaterThanOrEqual(18).conditional(constant("Adult"), constant("Minor"));
     * ```
     *
     * @param thenExpr - The expression to evaluate if the condition is true.
     * @param elseExpr - The expression to evaluate if the condition is false.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
     */ conditional(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("conditional", [
            this,
            e,
            t
        ], "conditional");
    }
    ifError(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e), n = new $b1c6e3a850a3c735$export$b169257caa88022a("if_error", [
            this,
            t
        ], "ifError");
        return t instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79 ? n.asBoolean() : n;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return this._expr._toProto(e);
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this._expr._readUserData(e);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_BooleanFunctionExpression extends $b1c6e3a850a3c735$export$65ab0ebced932b79 {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Function";
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_BooleanConstant extends $b1c6e3a850a3c735$export$65ab0ebced932b79 {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Constant";
    }
    _getValue() {
        return this._expr._getValue();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_BooleanField extends $b1c6e3a850a3c735$export$65ab0ebced932b79 {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Field";
    }
}
/**
 * Creates an aggregation that counts the number of stage inputs where the provided
 * boolean expression evaluates to true.
 *
 * @example
 * ```typescript
 * // Count the number of documents where 'is_active' field equals true
 * countIf(field("is_active").equal(true)).as("numActiveDocuments");
 * ```
 *
 * @param booleanExpr - The boolean expression to evaluate on each input.
 * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
 */ function $b1c6e3a850a3c735$export$cac96592272af85b(e) {
    return e.countIf();
}
function $b1c6e3a850a3c735$export$49e6ee724f7f1ace(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayGet($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
/**
 *
 * Creates an expression that checks if a given expression produces an error.
 *
 * @example
 * ```typescript
 * // Check if the result of a calculation is an error
 * isError(field("title").arrayContains(1));
 * ```
 *
 * @param value - The expression to check.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'isError' check.
 */ function $b1c6e3a850a3c735$export$5ff0b879ab65d0b0(e) {
    return e.isError().asBoolean();
}
function $b1c6e3a850a3c735$export$bd7cbab8c073cd83(e, t) {
    return e instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79 && t instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79 ? e.ifError(t).asBoolean() : e.ifError($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$61c0af74ec47d243(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).isAbsent();
}
function $b1c6e3a850a3c735$export$e5e9f924d040c2f1(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapRemove($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$479d1ccc5f2ab701(e, t, ...n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), i = n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr);
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapMerge(r, ...i);
}
function $b1c6e3a850a3c735$export$442d269b0886b975(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e).documentId();
}
function $b1c6e3a850a3c735$export$f089288e53d0d132(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e).parent();
}
function $b1c6e3a850a3c735$export$89d219c4c965baa6(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), i = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), s = void 0 === n ? void 0 : $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(n);
    return r.substring(i, s);
}
function $b1c6e3a850a3c735$export$4f33f238a5c1ad77(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).add($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$7ff026c33490f1d6(e, t) {
    const n = "string" == typeof e ? $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e) : e, r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.subtract(r);
}
function $b1c6e3a850a3c735$export$4113de5c72f4637b(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).multiply($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$14e06f865fe2f186(e, t) {
    const n = "string" == typeof e ? $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e) : e, r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.divide(r);
}
function $b1c6e3a850a3c735$export$b09e910f6bc5792f(e, t) {
    const n = "string" == typeof e ? $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e) : e, r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.mod(r);
}
/**
 *
 * Creates an expression that creates a Firestore map value from an input object.
 *
 * @example
 * ```typescript
 * // Create a map from the input object and reference the 'baz' field value from the input document.
 * map({foo: 'bar', baz: field('baz')}).as('data');
 * ```
 *
 * @param elements - The input map to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the map function.
 */ function $b1c6e3a850a3c735$export$6d1e945284085e64(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE__map(e);
}
function $b1c6e3a850a3c735$var$__PRIVATE__map(e, t) {
    const n = [];
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) {
        const r = e[t];
        n.push($b1c6e3a850a3c735$export$eb84e45a33f6ba7c(t)), n.push($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(r));
    }
    return new $b1c6e3a850a3c735$export$b169257caa88022a("map", n, "map");
}
/**
 * Internal use only
 * Converts a plainObject to a mapValue in the proto representation,
 * rather than a functionValue+map that is the result of the map(...) function.
 * This behaves different from constant(plainObject) because it
 * traverses the input object, converts values in the object to expressions,
 * and calls _readUserData on each of these expressions.
 * @private
 * @internal
 * @param plainObject
 */ function $b1c6e3a850a3c735$export$a91cd623adc48128(e) {
    const t = new Map;
    for(const n in e)if (Object.prototype.hasOwnProperty.call(e, n)) {
        const r = e[n];
        t.set(n, $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(r));
    }
    return new $b1c6e3a850a3c735$var$MapValue(t, void 0);
}
/**
 *
 * Creates an expression that creates a Firestore array value from an input array.
 *
 * @example
 * ```typescript
 * // Create an array value from the input array and reference the 'baz' field value from the input document.
 * array(['bar', field('baz')]).as('foo');
 * ```
 *
 * @param elements - The input array to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the array function.
 */ function $b1c6e3a850a3c735$export$545a72cc0d3f00b0(e) {
    return function __PRIVATE__array(e, t) {
        return new $b1c6e3a850a3c735$export$b169257caa88022a("array", e.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)), t);
    }(e, "array");
}
function $b1c6e3a850a3c735$export$9d2f55df59533b05(e, t) {
    const n = e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.equal(r);
}
function $b1c6e3a850a3c735$export$9198f9466fc833e(e, t) {
    const n = e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.notEqual(r);
}
function $b1c6e3a850a3c735$export$3dfa6803f1a6c839(e, t) {
    const n = e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.lessThan(r);
}
function $b1c6e3a850a3c735$export$ceef9c3fcdc11035(e, t) {
    const n = e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.lessThanOrEqual(r);
}
function $b1c6e3a850a3c735$export$27df29599c06edba(e, t) {
    const n = e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.greaterThan(r);
}
function $b1c6e3a850a3c735$export$9afebd5b903c9b2(e, t) {
    const n = e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b ? e : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.greaterThanOrEqual(r);
}
function $b1c6e3a850a3c735$export$1ec7a8278ebd1290(e, t, ...n) {
    const r = n.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e));
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayConcat($b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(t), ...r);
}
function $b1c6e3a850a3c735$export$4ad369a19af21c23(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.arrayContains(r);
}
function $b1c6e3a850a3c735$export$54c4fabc2291e9c0(e, t) {
    // @ts-ignore implementation accepts both types
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayContainsAny(t);
}
function $b1c6e3a850a3c735$export$89e9012e902952b6(e, t) {
    // @ts-ignore implementation accepts both types
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayContainsAll(t);
}
function $b1c6e3a850a3c735$export$b975d55abac2bbe3(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayLength();
}
function $b1c6e3a850a3c735$export$f4df619f1753fd48(e, t) {
    // @ts-ignore implementation accepts both types
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).equalAny(t);
}
function $b1c6e3a850a3c735$export$979127a300539e02(e, t) {
    // @ts-ignore implementation accepts both types
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).notEqualAny(t);
}
/**
 *
 * Creates an expression that performs a logical 'XOR' (exclusive OR) operation on multiple BooleanExpressions.
 *
 * @example
 * ```typescript
 * // Check if only one of the conditions is true: 'age' greater than 18, 'city' is "London",
 * // or 'status' is "active".
 * const condition = xor(
 *     greaterThan("age", 18),
 *     equal("city", "London"),
 *     equal("status", "active"));
 * ```
 *
 * @param first - The first condition.
 * @param second - The second condition.
 * @param additionalConditions - Additional conditions to 'XOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'XOR' operation.
 */ function $b1c6e3a850a3c735$export$b6568c80b9b0b3bb(e, t, ...n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("xor", [
        e,
        t,
        ...n
    ], "xor").asBoolean();
}
/**
 *
 * Creates a conditional expression that evaluates to a 'then' expression if a condition is true
 * and an 'else' expression if the condition is false.
 *
 * @example
 * ```typescript
 * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
 * conditional(
 *     greaterThan("age", 18), constant("Adult"), constant("Minor"));
 * ```
 *
 * @param condition - The condition to evaluate.
 * @param thenExpr - The expression to evaluate if the condition is true.
 * @param elseExpr - The expression to evaluate if the condition is false.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
 */ function $b1c6e3a850a3c735$export$e2c5c0657668816f(e, t, n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("conditional", [
        e,
        t,
        n
    ], "conditional");
}
/**
 *
 * Creates an expression that negates a filter condition.
 *
 * @example
 * ```typescript
 * // Find documents where the 'completed' field is NOT true
 * not(equal("completed", true));
 * ```
 *
 * @param booleanExpr - The filter condition to negate.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
 */ function $b1c6e3a850a3c735$export$6c6581d59e81d1b9(e) {
    return e.not();
}
function $b1c6e3a850a3c735$export$72f39d47420ee910(e, t, ...n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).logicalMaximum($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), ...n.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)));
}
function $b1c6e3a850a3c735$export$eaaeafa904fe3ddf(e, t, ...n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).logicalMinimum($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), ...n.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)));
}
function $b1c6e3a850a3c735$export$b8423798394d5395(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).exists();
}
function $b1c6e3a850a3c735$export$cca44b2176b5b24(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).reverse();
}
function $b1c6e3a850a3c735$export$c373adc892eb6355(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).byteLength();
}
function $b1c6e3a850a3c735$export$a6a89e41033eb1f5(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).exp();
}
function $b1c6e3a850a3c735$export$a274e22fb40f762e(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).ceil();
}
function $b1c6e3a850a3c735$export$1b08679bee270a7(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).floor();
}
/**
 * Creates an aggregation that counts the number of distinct values of a field.
 *
 * @param expr - The expression or field to count distinct values of.
 * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
 */ function $b1c6e3a850a3c735$export$c26ed9b31334b7c5(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).countDistinct();
}
function $b1c6e3a850a3c735$export$aea64bc1b6f8f415(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).charLength();
}
function $b1c6e3a850a3c735$export$18981f2c53519bdb(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.like(r);
}
function $b1c6e3a850a3c735$export$4c9c5bd3cb5071b3(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexContains(r);
}
function $b1c6e3a850a3c735$export$a1edd97dd51cd48d(e, t, n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayFilter(t, n);
}
function $b1c6e3a850a3c735$export$bde1ed0f60b38f2f(e, t, n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayTransform(t, n);
}
function $b1c6e3a850a3c735$export$e9316ff9106cdb75(e, t, n, r) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayTransformWithIndex(t, n, r);
}
function $b1c6e3a850a3c735$export$a3c9165b94390bcd(e, t, n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arraySlice(t, n);
}
function $b1c6e3a850a3c735$export$807f1ba34db587c7(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayFirst();
}
function $b1c6e3a850a3c735$export$c7ca7e4bc4f8a16e(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayFirstN($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$c5d7c1ac98841e53(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayLast();
}
function $b1c6e3a850a3c735$export$c1df809846363ebe(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayLastN($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$b02498c06ddfef28(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayMaximum();
}
function $b1c6e3a850a3c735$export$1343a74baacb0543(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayMaximumN($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$87b6ab1c2cb8b955(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayMinimum();
}
function $b1c6e3a850a3c735$export$cd571ca6d1702b73(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayMinimumN($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$6735ce526161c7bd(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayIndexOf($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$d92db8a7dc823bb0(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayLastIndexOf($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$6e4b1d19c6e2e012(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayIndexOfAll($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$877f099d45b93781(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexFind(r);
}
function $b1c6e3a850a3c735$export$35ed09b180ef97ea(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexFindAll(r);
}
function $b1c6e3a850a3c735$export$2b8fb79170dd2867(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.regexMatch(r);
}
function $b1c6e3a850a3c735$export$f856ea2695751642(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t);
    return n.stringContains(r);
}
function $b1c6e3a850a3c735$export$67f43c86699e7942(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).startsWith($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$dfbc9f8d49064aaa(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).endsWith($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$8cf43619936b7867(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).toLower();
}
function $b1c6e3a850a3c735$export$5c585649956053b(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).toUpper();
}
function $b1c6e3a850a3c735$export$e6142e6054105de8(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).trim(t);
}
function $b1c6e3a850a3c735$export$2fa162a495d26869(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).ltrim(t);
}
function $b1c6e3a850a3c735$export$4057e2e08e752e42(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).rtrim(t);
}
function $b1c6e3a850a3c735$export$3e0e4217c1341b05(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).type();
}
function $b1c6e3a850a3c735$export$8ba20c7a218ff803(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).isType(t);
}
function $b1c6e3a850a3c735$export$f4ac706686bb6b94(e, t, ...n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).stringConcat($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), ...n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr));
}
function $b1c6e3a850a3c735$export$9eb7d68b803f333e(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).stringIndexOf(t);
}
function $b1c6e3a850a3c735$export$d006832d466f7288(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).stringRepeat(t);
}
function $b1c6e3a850a3c735$export$780222aa087431a(e, t, n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).stringReplaceAll(t, n);
}
function $b1c6e3a850a3c735$export$8f88bf9884346f21(e, t, n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).stringReplaceOne(t, n);
}
function $b1c6e3a850a3c735$export$2aa5a0e309f2893e(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapGet(t);
}
function $b1c6e3a850a3c735$export$b4f27e0fc616e2cc(e, t, n, ...r) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapSet(t, n, ...r);
}
function $b1c6e3a850a3c735$export$28bdf2a38ef37818(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapKeys();
}
function $b1c6e3a850a3c735$export$53d26b7a9a23d594(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapValues();
}
function $b1c6e3a850a3c735$export$2055d1a955f03d83(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).mapEntries();
}
/**
 * Creates an aggregation that counts the total number of stage inputs.
 *
 * @example
 * ```typescript
 * // Count the total number of input documents
 * countAll().as("totalDocument");
 * ```
 *
 * @returns A new {@link @firebase/firestore/pipelines#AggregateFunction} representing the 'countAll' aggregation.
 */ function $b1c6e3a850a3c735$export$e856a6a9bfd75991() {
    return $b1c6e3a850a3c735$export$45aabb5431c2d04f._create("count", [], "count");
}
function $b1c6e3a850a3c735$export$d0b8fd51f345f3c4(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).count();
}
function $b1c6e3a850a3c735$export$a71af22d6b7f045f(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).sum();
}
function $b1c6e3a850a3c735$export$1776704b6532a19a(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).average();
}
function $b1c6e3a850a3c735$export$1ec27080ebb34cc5(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).minimum();
}
function $b1c6e3a850a3c735$export$dac0feeddfa6e7d(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).maximum();
}
function $b1c6e3a850a3c735$export$c866f24f04caecda(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).first();
}
function $b1c6e3a850a3c735$export$75f09c6dff6140e4(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).last();
}
function $b1c6e3a850a3c735$export$df7c425476ed4f2(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayAgg();
}
function $b1c6e3a850a3c735$export$f5339a28e56d1baf(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arrayAggDistinct();
}
function $b1c6e3a850a3c735$export$5f39619cda7ef666(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(t);
    return n.cosineDistance(r);
}
function $b1c6e3a850a3c735$export$8b5c9fc32300301a(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(t);
    return n.dotProduct(r);
}
function $b1c6e3a850a3c735$export$5cd0acb7e4618351(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), r = $b1c6e3a850a3c735$var$__PRIVATE_vectorToExpr(t);
    return n.euclideanDistance(r);
}
function $b1c6e3a850a3c735$export$f2e0ce65e7cf9b72(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).vectorLength();
}
function $b1c6e3a850a3c735$export$386ba9289b75caa8(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).unixMicrosToTimestamp();
}
function $b1c6e3a850a3c735$export$b626a1a623cddf9c(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).timestampToUnixMicros();
}
function $b1c6e3a850a3c735$export$ecf3680988977892(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).unixMillisToTimestamp();
}
function $b1c6e3a850a3c735$export$10967c44ee7a7824(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).timestampToUnixMillis();
}
function $b1c6e3a850a3c735$export$430a2249591529d3(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).unixSecondsToTimestamp();
}
function $b1c6e3a850a3c735$export$e78fd51b94b96331(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).timestampToUnixSeconds();
}
function $b1c6e3a850a3c735$export$76c46b74e9079f74(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), i = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), s = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(n);
    return r.timestampAdd(i, s);
}
function $b1c6e3a850a3c735$export$7ab585746576f734(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), i = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), s = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(n);
    return r.timestampSubtract(i, s);
}
/**
 *
 * Creates an expression that evaluates to the current server timestamp.
 *
 * @example
 * ```typescript
 * // Get the current server timestamp
 * currentTimestamp()
 * ```
 *
 * @returns A new Expression representing the current server timestamp.
 */ function $b1c6e3a850a3c735$export$e574dd6aa004e569() {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("current_timestamp", [], "currentTimestamp");
}
/**
 *
 * Creates an expression that performs a logical 'AND' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 AND the 'city' field is "London" AND
 * // the 'status' field is "active"
 * const condition = and(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'AND' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'AND' operation.
 */ function $b1c6e3a850a3c735$export$7fe88b5920ffddd2(e, t, ...n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("and", [
        e,
        t,
        ...n
    ], "and").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'OR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 OR the 'city' field is "London" OR
 * // the 'status' field is "active"
 * const condition = or(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'OR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'OR' operation.
 */ function $b1c6e3a850a3c735$export$2b548b2e30e1dd12(e, t, ...n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("or", [
        e,
        t,
        ...n
    ], "xor").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'NOR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if neither the 'age' field is greater than 18 nor the 'city' field is "London"
 * const condition = nor(
 *   greaterThan("age", 18),
 *   equal("city", "London")
 * );
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'NOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the logical 'NOR' operation.
 */ function $b1c6e3a850a3c735$export$7c49ce7c630afad5(e, t, ...n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("nor", [
        e,
        t,
        ...n
    ], "nor").asBoolean();
}
function $b1c6e3a850a3c735$export$dfa1698a1e9944f5(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).pow(t);
}
/**
 *
 * Creates an expression that generates a random number between 0.0 and 1.0 but not including 1.0.
 *
 * @example
 * ```typescript
 * // Generate a random number between 0.0 and 1.0.
 * rand();
 * ```
 *
 * @returns A new `Expression` representing the rand operation.
 */ function $b1c6e3a850a3c735$export$df8cac1947751fe2() {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("rand", [], "rand");
}
function $b1c6e3a850a3c735$export$1fdf989998e04586(e, t) {
    return void 0 === t ? $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).round() : $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).round($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$bee557efb6b6e(e, t) {
    return void 0 === t ? $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).trunc() : $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).trunc($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$afbe48a4a4275937(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).collectionId();
}
function $b1c6e3a850a3c735$export$5889bd2d81e52552(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).length();
}
function $b1c6e3a850a3c735$export$94202a6a16ecfef9(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).ln();
}
function $b1c6e3a850a3c735$export$8c8450b83b664ba4(e, t) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("log", [
        $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e),
        $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t)
    ]);
}
function $b1c6e3a850a3c735$export$382baae81601348e(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).sqrt();
}
function $b1c6e3a850a3c735$export$4b4160c0c582e338(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).stringReverse();
}
function $b1c6e3a850a3c735$export$f572e3cd01c21b80(e, t, ...n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("concat", [
        $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e),
        $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t),
        ...n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr)
    ]);
}
function $b1c6e3a850a3c735$export$df838d0240c938cf(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).abs();
}
function $b1c6e3a850a3c735$export$f4d17792a1948a63(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).ifAbsent($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$68488251523c02c0(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).ifNull(t);
}
function $b1c6e3a850a3c735$export$67ff43e65e668f2b(e, t, ...n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).coalesce(t, ...n);
}
/**
 * Creates an expression that evaluates to the result corresponding to the first true condition.
 *
 * @remarks
 * This function behaves like a `switch` statement. It accepts an alternating sequence of conditions
 * and their corresponding results.
 * If an odd number of arguments is provided, the final argument serves as a default fallback result.
 * If no default is provided and no condition evaluates to true, it throws an error.
 *
 * @example
 * ```typescript
 * // Return "Active" if field "status" is 1, "Pending" if field "status" is 2,
 * // and default to "Unknown" if none of the conditions are true.
 * switchOn(
 *   equal(field("status"), 1), constant("Active"),
 *   equal(field("status"), 2), constant("Pending"),
 *   constant("Unknown")
 * )
 * ```
 *
 * @param condition - The first condition to check.
 * @param result - The result if the first condition is true.
 * @param others - Additional conditions and results, and optionally a default value.
 * @returns A new Expression representing the switch operation.
 */ function $b1c6e3a850a3c735$export$ed5ad63bb4971148(e, t, ...n) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("switch_on", [
        $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e),
        $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t),
        ...n.map($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr)
    ], "switchOn");
}
function $b1c6e3a850a3c735$export$4707f455a0e6a485(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).join($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$f932f06c7eb6abeb(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).log10();
}
function $b1c6e3a850a3c735$export$cbfbec548517f2b6(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).arraySum();
}
function $b1c6e3a850a3c735$export$127e440b727e338f(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).split($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t));
}
function $b1c6e3a850a3c735$export$a191827a7c796803(e, t, n) {
    const r = $b1c6e3a850a3c735$export$c5d1328b37d47994(t) ? $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t) : t;
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).timestampTruncate(r, n);
}
/**
 * @public
 * Creates an expression that retrieves the value of a variable bound via `define()`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection("products")
 *   .define(
 *     field("price").multiply(0.9).as("discountedPrice"),
 *     field("stock").add(10).as("newStock")
 *   )
 *   .where(variable("discountedPrice").lessThan(100))
 *   .select(field("name"), variable("newStock"));
 * ```
 *
 * @param name - The name of the variable to retrieve.
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the variable's value.
 */ function $b1c6e3a850a3c735$export$76377e288772571c(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_VariableExpression(e);
}
/**
 * @internal
 *
 * Expression representing a variable reference. This evaluates to the value of a variable
 * defined in a pipeline.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_VariableExpression extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    /**
     * @hideconstructor
     */ constructor(e){
        super(), this.name = e, this.expressionType = "Variable";
    }
    /**
     * @internal
     */ _toProto(e) {
        return {
            variableReferenceValue: this.name
        };
    }
    /**
     * @internal
     */ _readUserData(e) {}
}
/**
 * @public
 * Creates an expression that represents the current document being processed.
 *
 * @example
 * ```typescript
 * // Define the current document as a variable "doc"
 * firestore.pipeline().collection("books")
 *     .define(currentDocument().as("doc"))
 *     // Access a field from the defined document variable
 *     .select(variable("doc").mapGet("title"));
 * ```
 *
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the current document.
 */ function $b1c6e3a850a3c735$export$1dfcf732dfa226de() {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("current_document", []);
}
/**
 * @internal
 */ function $b1c6e3a850a3c735$export$c667925124dac624(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_PipelineValueExpression(e);
}
/**
 * @internal
 */ class $b1c6e3a850a3c735$var$__PRIVATE_PipelineValueExpression extends $b1c6e3a850a3c735$export$2e63b696b2c9441b {
    /**
     * @hideconstructor
     */ constructor(e){
        super(), this.pipeline = e, this.expressionType = "PipelineValue";
    }
    /**
     * @internal
     */ _toProto(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_toPipelineValue(this.pipeline._toProto(e));
    }
    /**
     * @internal
     */ _readUserData(e) {
        this.pipeline._readUserData(e);
    }
}
function $b1c6e3a850a3c735$export$2dd707df679de14f(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), i = $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(t), s = $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(n);
    return r.timestampDiff(i, s);
}
function $b1c6e3a850a3c735$export$ac4ac9092d127df3(e, t, n) {
    return $b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e).timestampExtract($b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(t), n);
}
// TODO(search) enable with backend support
// /**
//  * Perform a full-text search on the specified field.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: matches('menu', 'waffles')
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function matches(
//   searchField: string | Field,
//   rquery: string | Expression
// ): BooleanExpression {
//   return toField(searchField).matches(rquery);
// }
/**
 * @beta
 * Perform a full-text search on all indexed search fields in the document.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: documentMatches('waffles OR pancakes')
 * })
 * ```
 *
 * @param rquery Define the search query using the search domain-specific language (DSL).
 */ function $b1c6e3a850a3c735$export$381353cf1dd55255(e) {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("document_matches", [
        $b1c6e3a850a3c735$var$__PRIVATE_valueToDefaultExpr(e)
    ], "documentMatches").asBoolean();
}
/**
 * @beta
 *
 * Evaluates to the search score that reflects the topicality of the document
 * to all of the text predicates (for example: `documentMatches`)
 * in the search query. If `SearchOptions.query` is not set or does not contain
 * any text predicates, then this topicality score will always be `0`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: score().descending()
 * })
 * ```
 *
 * @remarks This Expression can only be used within a `search` stage.
 */ function $b1c6e3a850a3c735$export$da8061bacc7a8f46() {
    return new $b1c6e3a850a3c735$export$b169257caa88022a("score", [], "score");
}
// TODO(search) enable with backend support
// /**
//  * Options defining how a snippet expression is evaluated.
//  */
// export interface SnippetOptions {
//   /**
//    * Define the search query using the search domain-specific language (DSL).
//    */
//   rquery: string;
//   /**
//    * The maximum width of the string estimated for a variable width font. The
//    * unit is tenths of ems. The default is `160`.
//    */
//   maxSnippetWidth?: number;
//   /**
//    * The maximum number of non-contiguous pieces of text in the returned snippet.
//    * The default is `1`.
//    */
//   maxSnippets?: number;
//   /**
//    * The string to join the pieces. The default value is '\n'
//    */
//   separator?: string;
// }
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: 'waffles',
//  *   addFields: { snippet: snippet('menu', 'waffles') }
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   rquery: string
// ): Expression;
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param options Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   options: SnippetOptions
// ): Expression;
// export function snippet(
//   field: string | Field,
//   queryOrOptions: string | SnippetOptions
// ): Expression {
//   return toField(field).snippet(
//     isString(queryOrOptions) ? { rquery: queryOrOptions } : queryOrOptions
//   );
// }
/**
 * @beta
 * Evaluates to the distance in meters between the location in the specified
 * field and the query location.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: geoDistance('location', new GeoPoint(37.0, -122.0)).ascending()
 * })
 * ```
 *
 * @param fieldName - Specifies the field in the document which contains
 * the first GeoPoint for distance computation.
 * @param location - Compute distance to this GeoPoint.
 */ function $b1c6e3a850a3c735$export$42bcab07638ec4d7(e, t) {
    return $b1c6e3a850a3c735$export$674f8f4247a5112e(e).geoDistance(t);
}
function $b1c6e3a850a3c735$export$9ddbdd0bfc5623a(e) {
    return new $b1c6e3a850a3c735$export$101619b11a34a0bd($b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), "ascending", "ascending");
}
function $b1c6e3a850a3c735$export$b37556a6cf1be916(e) {
    return new $b1c6e3a850a3c735$export$101619b11a34a0bd($b1c6e3a850a3c735$var$__PRIVATE_fieldOrExpression(e), "descending", "descending");
}
/**
 *
 * Represents an ordering criterion for sorting documents in a Firestore pipeline.
 *
 * You create `Ordering` instances using the `ascending` and `descending` helper functions.
 */ class $b1c6e3a850a3c735$export$101619b11a34a0bd {
    constructor(e, t, n){
        this.expr = e, this.direction = t, this._methodName = n, this._protoValueType = "ProtoValue";
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            mapValue: {
                fields: {
                    direction: $b1c6e3a850a3c735$var$__PRIVATE_toStringValue(this.direction),
                    expression: this.expr._toProto(e)
                }
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.expr._readUserData(e);
    }
}
function $b1c6e3a850a3c735$export$b4d5ecaefe2b27f3(e) {
    const t = e;
    return t.selectable && $b1c6e3a850a3c735$export$c5d1328b37d47994(t.alias) && $b1c6e3a850a3c735$export$b0165a7e514844(t.expr);
}
function $b1c6e3a850a3c735$export$b2bcef12bcefba04(e) {
    const t = e;
    return null != t && $b1c6e3a850a3c735$export$b0165a7e514844(t.expr) && ("ascending" === t.direction || "descending" === t.direction);
}
function $b1c6e3a850a3c735$export$26a0a7676ca7aa04(e) {
    const t = e;
    return $b1c6e3a850a3c735$export$c5d1328b37d47994(t.alias) && t.aggregate instanceof $b1c6e3a850a3c735$export$45aabb5431c2d04f;
}
function $b1c6e3a850a3c735$export$b0165a7e514844(e) {
    return e instanceof $b1c6e3a850a3c735$export$2e63b696b2c9441b;
}
function $b1c6e3a850a3c735$export$479ac0420f53ed26(e) {
    return e instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79;
}
function $b1c6e3a850a3c735$export$acf3ba20e47771d(e) {
    return e instanceof $b1c6e3a850a3c735$export$dabba94403d45c8e;
}
function $b1c6e3a850a3c735$export$4ae495d48253603d(e) {
    return e instanceof $b1c6e3a850a3c735$export$e0c3a065614c6254;
}
function $b1c6e3a850a3c735$export$674f8f4247a5112e(e) {
    if ($b1c6e3a850a3c735$export$c5d1328b37d47994(e)) return $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e);
    return e;
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$Stage {
    constructor(e){
        /**
         * Store _optionsProto parsed by _readUserData.
         * @private
         * @internal
         * @protected
         */ this.optionsProto = void 0, { rawOptions: this.rawOptions, ...this.knownOptions } = e;
    }
    _readUserData(e) {
        this.optionsProto = this._optionsUtil.getOptionsProto(e, this.knownOptions, this.rawOptions);
    }
    _toProto(e) {
        return {
            name: this._name,
            options: this.optionsProto
        };
    }
}
class $b1c6e3a850a3c735$export$5521614468b862fb extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "add_fields";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.fields = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toMapValue(e, this.fields)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.fields, e);
    }
}
class $b1c6e3a850a3c735$export$55ff3cc1821e8445 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "remove_fields";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.fields = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.fields.map((t)=>t._toProto(e))
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.fields, e);
    }
}
/**
 * @public
 */ class $b1c6e3a850a3c735$export$847533e5bf524f5f extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "let";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.Ar = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toMapValue(e, this.Ar)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.Ar, e);
    }
}
class $b1c6e3a850a3c735$export$766bf7dcfb630b6c extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "aggregate";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t, n){
        super(n), this.groups = e, this.accumulators = t;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toMapValue(e, this.accumulators),
                $b1c6e3a850a3c735$var$toMapValue(e, this.groups)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.groups, e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.accumulators, e);
    }
}
class $b1c6e3a850a3c735$export$45d219bdcd8ac53c extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "distinct";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.groups = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toMapValue(e, this.groups)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.groups, e);
    }
}
class $b1c6e3a850a3c735$export$7f557e5eb95176c2 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "collection";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({
            forceIndex: {
                serverName: "force_index"
            }
        });
    }
    constructor(e, t){
        super(t), // prepend slash to collection string
        this.Vr = e.startsWith("/") ? e : "/" + e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    referenceValue: this.Vr
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$51b138e5a065c2bb extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "collection_group";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({
            forceIndex: {
                serverName: "force_index"
            }
        });
    }
    constructor(e, t){
        super(t), this.collectionId = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    referenceValue: ""
                },
                {
                    stringValue: this.collectionId
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$31e67cf12fc9668 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "subcollection";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.path = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    stringValue: this.path
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$6dabbe08653f866f extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "database";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e)
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$151db275011178c4 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "documents";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        if (super(t), !e || 0 === e.length) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Empty document paths are not allowed in DocumentsSource");
        const n = e.map((e)=>e.startsWith("/") ? e : "/" + e), r = new Set(n);
        if (r.size !== n.length) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Duplicate document paths are not allowed in DocumentsSource");
        this.dr = n, this.mr = r;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.dr.map((e)=>({
                    referenceValue: e
                }))
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$4e222d082f82ee97 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "where";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.condition = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.condition._toProto(e)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.condition, e);
    }
}
class $b1c6e3a850a3c735$export$d76842aa27385215 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "find_nearest";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({
            limit: {
                serverName: "limit"
            },
            distanceField: {
                serverName: "distance_field"
            }
        });
    }
    constructor(e, t, n, r){
        super(r), this.vectorValue = e, this.field = t, this.distanceMeasure = n;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.field._toProto(e),
                this.vectorValue._toProto(e),
                $b1c6e3a850a3c735$var$__PRIVATE_toStringValue(this.distanceMeasure)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.vectorValue, e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.field, e);
    }
}
class $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "limit";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!isNaN(e) && e !== 1 / 0 && e !== -1 / 0, 34860), super(t), this.limit = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toNumber(e, this.limit)
            ]
        };
    }
}
class $b1c6e3a850a3c735$export$f438b12253c2b499 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "offset";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.offset = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toNumber(e, this.offset)
            ]
        };
    }
}
class $b1c6e3a850a3c735$export$4b170465d7badfa1 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "select";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.selections = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toMapValue(e, this.selections)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.selections, e);
    }
}
class $b1c6e3a850a3c735$export$60bb826a6acf3081 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "sort";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.orderings = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.orderings.map((t)=>t._toProto(e))
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.orderings, e);
    }
}
class $b1c6e3a850a3c735$export$1abb261478089fe6 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "sample";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t, n){
        super(n), this.rate = e, this.mode = t;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$toNumber(e, this.rate),
                $b1c6e3a850a3c735$var$__PRIVATE_toStringValue(this.mode)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$ebc5e65867841cbe extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "union";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.other = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                $b1c6e3a850a3c735$var$__PRIVATE_toPipelineValue(this.other._toProto(e))
            ]
        };
    }
    _readUserData(e) {
        this.other._readUserData(e), super._readUserData(e);
    }
}
class $b1c6e3a850a3c735$export$ebb8f7cd71856fb9 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "unnest";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({
            indexField: {
                serverName: "index_field"
            }
        });
    }
    constructor(e, t, n){
        super(n), this.alias = e, this.expr = t;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.expr._toProto(e),
                $b1c6e3a850a3c735$export$a36fb7d24305ed9d(this.alias)._toProto(e)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.expr, e);
    }
}
class $b1c6e3a850a3c735$export$27d1aff6bea49709 extends $b1c6e3a850a3c735$var$Stage {
    get _name() {
        return "replace_with";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.map = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.map._toProto(e),
                $b1c6e3a850a3c735$var$__PRIVATE_toStringValue($b1c6e3a850a3c735$export$27d1aff6bea49709.pr)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.map, e);
    }
}
$b1c6e3a850a3c735$export$27d1aff6bea49709.pr = "full_replace";
/**
 * @beta
 */ class $b1c6e3a850a3c735$export$aff10ba49ece4b91 extends $b1c6e3a850a3c735$var$Stage {
    constructor(e){
        super(e), this.gr = e;
    }
    get _name() {
        return "search";
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({
            query: {
                serverName: "query"
            },
            limit: {
                serverName: "limit"
            },
            retrievalDepth: {
                serverName: "retrieval_depth"
            },
            sort: {
                serverName: "sort"
            },
            addFields: {
                serverName: "add_fields"
            },
            select: {
                serverName: "select"
            },
            offset: {
                serverName: "offset"
            },
            yr: {
                serverName: "query_enhancement"
            },
            languageCode: {
                serverName: "language_code"
            }
        });
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: []
        };
    }
    _readUserData(e) {
        $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.gr.query, e), this.gr.addFields && $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.gr.addFields, e), this.gr.select && $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.gr.select, e), this.gr.sort && $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.gr.sort, e), super._readUserData(e);
    }
}
/**
 * @beta
 */ class $b1c6e3a850a3c735$export$4d522598b426bb73 extends $b1c6e3a850a3c735$var$Stage {
    /**
     * @private
     * @internal
     */ constructor(e, t, n){
        super({
            rawOptions: n
        }), this.name = e, this.params = t;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            name: this.name,
            args: this.params.map((t)=>t._toProto(e)),
            options: this.optionsProto
        };
    }
    _readUserData(e) {
        super._readUserData(e), $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(this.params, e);
    }
    get _name() {
        return this.name;
    }
    get _optionsUtil() {
        return new $b1c6e3a850a3c735$var$OptionsUtil({});
    }
}
/**
 * Helper to read user data across a number of different formats.
 * @param name - Name of the calling function. Used for error messages when invalid user data is encountered.
 * @param expressionMap
 * @returns the expressionMap argument.
 * @private
 */ function $b1c6e3a850a3c735$var$__PRIVATE_readUserDataHelper(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_isUserData(e) ? e._readUserData(t) : Array.isArray(e) ? e.forEach((e)=>e._readUserData(t)) : e instanceof Map ? e.forEach((e)=>e._readUserData(t)) : Object.values(e).forEach((e)=>e._readUserData(t)), e;
}
// Copyright 2024 Google LLC* @license
class $b1c6e3a850a3c735$var$CorePipeline {
    constructor(e, t, n){
        this.serializer = e, this.stages = t, this.listenOptions = n, this.isCorePipeline = !0;
    }
    getPipelineCollection() {
        return $b1c6e3a850a3c735$var$getPipelineCollection(this);
    }
    getPipelineCollectionGroup() {
        return $b1c6e3a850a3c735$var$getPipelineCollectionGroup(this);
    }
    getPipelineCollectionId() {
        return $b1c6e3a850a3c735$var$getPipelineCollectionId(this);
    }
    getPipelineDocuments() {
        return $b1c6e3a850a3c735$var$getPipelineDocuments(this);
    }
    getPipelineFlavor() {
        return function getPipelineFlavor(e) {
            let t = "exact";
            return e.stages.forEach((n, r)=>{
                n._name !== $b1c6e3a850a3c735$export$45d219bdcd8ac53c.name && n._name !== $b1c6e3a850a3c735$export$766bf7dcfb630b6c.name || (t = "keyless"), n._name === $b1c6e3a850a3c735$export$4b170465d7badfa1.name && "exact" === t && (t = "augmented"), // TODO(pipeline): verify the last stage is addFields, and it is added by the SDK.
                n._name === $b1c6e3a850a3c735$export$5521614468b862fb.name && r < e.stages.length - 1 && "exact" === t && (t = "augmented");
            }), t;
        }(this);
    }
    getPipelineSourceType() {
        return $b1c6e3a850a3c735$var$getPipelineSourceType(this);
    }
}
function $b1c6e3a850a3c735$var$getPipelineSourceType(e) {
    const t = e.stages[0];
    return t instanceof $b1c6e3a850a3c735$export$7f557e5eb95176c2 || t instanceof $b1c6e3a850a3c735$export$51b138e5a065c2bb || t instanceof $b1c6e3a850a3c735$export$6dabbe08653f866f || t instanceof $b1c6e3a850a3c735$export$151db275011178c4 ? t._name : "unknown";
}
function $b1c6e3a850a3c735$var$getPipelineCollection(e) {
    if ("collection" === $b1c6e3a850a3c735$var$getPipelineSourceType(e)) return e.stages[0].Vr;
}
function $b1c6e3a850a3c735$var$getPipelineCollectionGroup(e) {
    if ("collection_group" === $b1c6e3a850a3c735$var$getPipelineSourceType(e)) return e.stages[0].collectionId;
}
function $b1c6e3a850a3c735$var$getPipelineCollectionId(e) {
    switch($b1c6e3a850a3c735$var$getPipelineSourceType(e)){
        case "collection":
            return $b1c6e3a850a3c735$export$db202ddc8be9136.fromString($b1c6e3a850a3c735$var$getPipelineCollection(e)).lastSegment();
        case "collection_group":
            return $b1c6e3a850a3c735$var$getPipelineCollectionGroup(e);
        default:
            return;
    }
}
function $b1c6e3a850a3c735$var$getPipelineDocuments(e) {
    if ("documents" === $b1c6e3a850a3c735$var$getPipelineSourceType(e)) return e.stages[0].dr;
}
class $b1c6e3a850a3c735$var$__PRIVATE_RealtimePipeline {
    /**
     * @internal
     * @private
     * @param _db
     * @param userDataReader
     * @param _userDataWriter
     * @param _documentReferenceFactory
     * @param stages
     */ constructor(/**
     * @internal
     * @private
     */ e, /**
     * @internal
     * @private
     */ t, /**
     * @internal
     * @private
     */ n, r){
        this._db = e, this.userDataReader = t, this._userDataWriter = n, this.stages = r;
    }
    /**
     * Reads user data for each expression in the expressionMap.
     * @param name Name of the calling function. Used for error messages when invalid user data is encountered.
     * @param expressionMap
     * @return the expressionMap argument.
     * @private
     * @internal
     */ wr(e, t) {
        const n = this.userDataReader.createContext(3 /* UserDataSource.Argument */ , e);
        return $b1c6e3a850a3c735$var$__PRIVATE_isUserData(t) ? t._readUserData(n) : Array.isArray(t) ? t.forEach((e)=>e._readUserData(n)) : t.forEach((e)=>e._readUserData(n)), t;
    }
    where(e) {
        const t = this.stages.map((e)=>e);
        return this.wr("where", e), t.push(new $b1c6e3a850a3c735$export$4e222d082f82ee97(e, {})), new $b1c6e3a850a3c735$var$__PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
    }
    limit(e) {
        const t = this.stages.map((e)=>e);
        return t.push(new $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb(e, {})), new $b1c6e3a850a3c735$var$__PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
    }
    sort(e, ...t) {
        const n = this.stages.map((e)=>e);
        // Option object
        return "orderings" in e ? n.push(new $b1c6e3a850a3c735$export$60bb826a6acf3081(this.wr("sort", e.orderings), {})) : // Ordering object
        n.push(new $b1c6e3a850a3c735$export$60bb826a6acf3081(this.wr("sort", [
            e,
            ...t
        ]), {})), new $b1c6e3a850a3c735$var$__PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, n);
    }
    /**
     * @internal
     * @private
     */ br(e) {
        return {
            pipeline: {
                stages: this.stages.map((t)=>t._toProto(e))
            }
        };
    }
}
// Copyright 2024 Google LLC* @license
class $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult {
    constructor(e, t){
        this.type = e, this.value = t;
    }
    static vr() {
        return new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("ERROR", void 0);
    }
    static Sr() {
        return new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("UNSET", void 0);
    }
    static Dr() {
        return new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("NULL", $b1c6e3a850a3c735$var$lt);
    }
    static newValue(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("NULL", $b1c6e3a850a3c735$var$lt) : function __PRIVATE_isBoolean(e) {
            return !!e && "booleanValue" in e;
        }(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("BOOLEAN", e) : $b1c6e3a850a3c735$var$isInteger(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("INT", e) : $b1c6e3a850a3c735$var$__PRIVATE_isDouble(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("DOUBLE", e) : function __PRIVATE_isTimestampValue(e) {
            return !!e && "timestampValue" in e && !!e.timestampValue;
        }(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("TIMESTAMP", e) : function __PRIVATE_isString(e) {
            return !!e && "stringValue" in e;
        }(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("STRING", e) : function __PRIVATE_isBytes(e) {
            return !!e && "bytesValue" in e;
        }(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("BYTES", e) : e.referenceValue ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("REFERENCE", e) : e.geoPointValue ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("GEO_POINT", e) : $b1c6e3a850a3c735$var$isArray(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("ARRAY", e) : $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("VECTOR", e) : $b1c6e3a850a3c735$var$__PRIVATE_isMapValue(e) ? new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("MAP", e) : new $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult("ERROR", void 0);
    }
    Cr() {
        return "ERROR" === this.type || "UNSET" === this.type;
    }
    Fr() {
        return "NULL" === this.type;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_valueOrUndefined(e) {
    if (!e.Cr()) return e.value;
}
function $b1c6e3a850a3c735$var$__PRIVATE_unwrapExpression(e) {
    return e instanceof $b1c6e3a850a3c735$export$65ab0ebced932b79 ? e._expr : e;
}
function $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(e) {
    if ((e = $b1c6e3a850a3c735$var$__PRIVATE_unwrapExpression(e)) instanceof $b1c6e3a850a3c735$export$e0c3a065614c6254) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreField(e);
    if (e instanceof $b1c6e3a850a3c735$var$Constant) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreConstant(e);
    if (e instanceof $b1c6e3a850a3c735$var$__PRIVATE_ListOfExprs) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreListOfExprs(e);
    if (e instanceof $b1c6e3a850a3c735$export$b169257caa88022a) {
        // TODO(pipeline): We should define all supported function names as constants somewhere instead of magic strings.
        if ("add" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreAdd(e);
        if ("subtract" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreSubtract(e);
        if ("multiply" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreMultiply(e);
        if ("divide" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreDivide(e);
        if ("mod" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreMod(e);
        if ("and" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreAnd(e);
        if ("equal" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreEq(e);
        if ("not_equal" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreNeq(e);
        if ("less_than" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreLt(e);
        if ("less_than_or_equal" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreLte(e);
        if ("greater_than" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreGt(e);
        if ("greater_than_or_equal" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreGte(e);
        if ("array_concat" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayConcat(e);
        if ("array_reverse" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayReverse(e);
        if ("array_contains" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayContains(e);
        if ("array_contains_all" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayContainsAll(e);
        if ("array_contains_any" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayContainsAny(e);
        if ("array_length" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayLength(e);
        if ("array_element" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayElement(e);
        if ("equal_any" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreEqAny(e);
        if ("not_equal_any" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreNotEqAny(e);
        if ("is_nan" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNan(e);
        if ("is_not_nan" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNotNan(e);
        if ("is_null" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNull(e);
        if ("is_not_null" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNotNull(e);
        if ("is_error" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreIsError(e);
        if ("exists" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreExists(e);
        if ("not" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreNot(e);
        if ("or" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreOr(e);
        if ("xor" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreXor(e);
        if ("conditional" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreCond(e);
        if ("maximum" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreLogicalMaximum(e);
        if ("minimum" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreLogicalMinimum(e);
        if ("reverse" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreReverse(e);
        if ("replace_first" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreReplaceFirst(e);
        if ("replace_all" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreReplaceAll(e);
        if ("char_length" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreCharLength(e);
        if ("byte_length" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreByteLength(e);
        if ("like" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreLike(e);
        if ("regex_contains" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreRegexContains(e);
        if ("regex_match" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreRegexMatch(e);
        if ("string_contains" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreStrContains(e);
        if ("starts_with" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreStartsWith(e);
        if ("ends_with" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreEndsWith(e);
        if ("to_lower" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreToLower(e);
        if ("to_upper" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreToUpper(e);
        if ("trim" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreTrim(e);
        if ("string_concat" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreStrConcat(e);
        if ("map_get" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreMapGet(e);
        if ("cosine_distance" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreCosineDistance(e);
        if ("dot_product" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreDotProduct(e);
        if ("euclidean_distance" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreEuclideanDistance(e);
        if ("vector_length" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreVectorLength(e);
        if ("unix_micros_to_timestamp" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreUnixMicrosToTimestamp(e);
        if ("timestamp_to_unix_micros" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampToUnixMicros(e);
        if ("unix_millis_to_timestamp" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreUnixMillisToTimestamp(e);
        if ("timestamp_to_unix_millis" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampToUnixMillis(e);
        if ("unix_seconds_to_timestamp" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreUnixSecondsToTimestamp(e);
        if ("timestamp_to_unix_seconds" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampToUnixSeconds(e);
        if ("timestamp_add" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampAdd(e);
        if ("timestamp_subtract" === e.name) return new $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampSub(e);
    }
    throw new Error(`Unknown Expr : ${e}`);
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreField {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        if (this.expr.fieldName === $b1c6e3a850a3c735$var$F) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            referenceValue: $b1c6e3a850a3c735$var$__PRIVATE_toName(e.serializer, t.key)
        });
        if ("__update_time__" === this.expr.fieldName) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: $b1c6e3a850a3c735$var$__PRIVATE_toVersion(e.serializer, t.version)
        });
        if ("__create_time__" === this.expr.fieldName) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: $b1c6e3a850a3c735$var$__PRIVATE_toVersion(e.serializer, t.createTime)
        });
        // Return 'UNSET' if the field doesn't exist, otherwise the Value.
        const n = t.data.field(this.expr._fieldPath);
        return n ? $b1c6e3a850a3c735$export$2408f22a0fab9ae5(n) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue(function __PRIVATE_getServerTimestampValue(e, t) {
            if ("estimate" === e.serverTimestampBehavior) return {
                timestampValue: $b1c6e3a850a3c735$var$__PRIVATE_toVersion(e.serializer, $b1c6e3a850a3c735$var$SnapshotVersion.fromTimestamp($b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(t)))
            };
            if ("previous" === e.serverTimestampBehavior) {
                const e = $b1c6e3a850a3c735$var$__PRIVATE_getPreviousValue(t);
                if (e) return e;
            }
            return {
                nullValue: "NULL_VALUE"
            };
        }(e, n)) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue(n) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Sr();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreConstant {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue(this.expr._getValue());
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreListOfExprs {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.Rr.map((n)=>$b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        // If any sub-expression resulted in error or was unset, the list evaluation fails.
        return n.some((e)=>e.Cr()) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            arrayValue: {
                values: n.map((e)=>e.value)
            }
        });
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_asDouble(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_isDouble(e) ? Number(e.doubleValue) : Number(e.integerValue);
}
function $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(e) {
    return BigInt(e.integerValue);
}
const $b1c6e3a850a3c735$var$Wt = BigInt("0x7fffffffffffffff"), $b1c6e3a850a3c735$var$Qt = -BigInt("0x8000000000000000");
class $b1c6e3a850a3c735$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(this.expr.params.length >= 2, 24778);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t), r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        let i = this.Or(n, r);
        for (const n of this.expr.params.slice(2)){
            const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(n).evaluate(e, t);
            i = this.Or(i, r);
        }
        return i;
    }
    Or(e, t) {
        // If any operand is error or unset, the result is error.
        if (e.Cr() || t.Cr()) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        if (e.Fr() || t.Fr()) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
        // Type check: Both must be numbers (integer or double).
        // We know left and right are Value here due to the check above.
        const n = e.value, r = t.value;
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isDouble(n) && !$b1c6e3a850a3c735$var$isInteger(n) || !$b1c6e3a850a3c735$var$__PRIVATE_isDouble(r) && !$b1c6e3a850a3c735$var$isInteger(r)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr(); // Type error
        // Perform arithmetic based on types.
        if ($b1c6e3a850a3c735$var$__PRIVATE_isDouble(n) || $b1c6e3a850a3c735$var$__PRIVATE_isDouble(r)) {
            const e = this.Mr(n, r);
            return e ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue(e) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        if ($b1c6e3a850a3c735$var$isInteger(n) && $b1c6e3a850a3c735$var$isInteger(r)) {
            // Pass the narrowed Value types
            const e = this.Nr(n, r);
            return void 0 === e ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : "number" == typeof e ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                doubleValue: e
            }) : e < $b1c6e3a850a3c735$var$Qt || e > $b1c6e3a850a3c735$var$Wt ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                integerValue: `${e}`
            });
        }
        // Should not be reached due to initial type checks
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e) !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t) ? "TYPE_MISMATCH" : $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(t) ? "NOT_EQ" : $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) && $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(t) ? "EQ" : $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) || $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(t) ? "NULL" : $b1c6e3a850a3c735$var$isArray(e) && $b1c6e3a850a3c735$var$isArray(t) ? function __PRIVATE_strictArrayValueEquals(e, t) {
        if (e.values?.length !== t.values?.length) return "NOT_EQ";
        let n = !1;
        for(let r = 0; r < (e.values?.length ?? 0); r++){
            const i = e.values[r], s = t.values[r];
            switch($b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(i, s)){
                case "EQ":
                    break;
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    n = !0;
                    break;
                default:
                    $b1c6e3a850a3c735$export$8743009a87fcb00f(44609, {
                        Lr: i,
                        Br: s
                    });
            }
        }
        if (n) return "NULL";
        return "EQ";
    }(e.arrayValue, t.arrayValue) : $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) && $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(t) || $b1c6e3a850a3c735$var$__PRIVATE_isMapValue(e) && $b1c6e3a850a3c735$var$__PRIVATE_isMapValue(t) ? function __PRIVATE_strictObjectValueEquals(e, t) {
        const n = e.fields || {}, r = t.fields || {};
        if ($b1c6e3a850a3c735$var$__PRIVATE_objectSize(n) !== $b1c6e3a850a3c735$var$__PRIVATE_objectSize(r)) return "NOT_EQ";
        let i = !1;
        for(const e in n)if (n.hasOwnProperty(e)) {
            if (void 0 === r[e]) return "NOT_EQ";
            switch($b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(n[e], r[e])){
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    i = !0;
            }
        }
        if (i) return "NULL";
        return "EQ";
    }(e.mapValue, t.mapValue) : function __PRIVATE_valueEquals(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(e, t, {
            Te: !1,
            Ee: !0,
            he: !0
        });
    }(e, t) ? "EQ" : "NOT_EQ";
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreAdd extends $b1c6e3a850a3c735$var$__PRIVATE_BigIntOrDoubleArithmetics {
    Nr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(e) + $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(t);
    }
    Mr(e, t) {
        return {
            doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_asDouble(e) + $b1c6e3a850a3c735$var$__PRIVATE_asDouble(t)
        };
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreSubtract extends $b1c6e3a850a3c735$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(e) - $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(t);
    }
    Mr(e, t) {
        return {
            doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_asDouble(e) - $b1c6e3a850a3c735$var$__PRIVATE_asDouble(t)
        };
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreMultiply extends $b1c6e3a850a3c735$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(e) * $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(t);
    }
    Mr(e, t) {
        return {
            doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_asDouble(e) * $b1c6e3a850a3c735$var$__PRIVATE_asDouble(t)
        };
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreDivide extends $b1c6e3a850a3c735$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(t);
        if (n !== BigInt(0)) return $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(e) / n;
    }
    Mr(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_asDouble(t);
        return 0 === n ? {
            doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(n) ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY
        } : {
            doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_asDouble(e) / n
        };
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreMod extends $b1c6e3a850a3c735$var$__PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(t);
        if (n !== BigInt(0)) return $b1c6e3a850a3c735$var$__PRIVATE_asBigInt(e) % n;
    }
    Mr(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_asDouble(t);
        if (0 !== n) return {
            doubleValue: $b1c6e3a850a3c735$var$__PRIVATE_asDouble(e) % n
        };
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreAnd {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = !1, r = !1;
        for (const i of this.expr.params){
            const s = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    if (!s.value?.booleanValue) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
                    break;
                case "NULL":
                    r = !0;
                    break;
                default:
                    n = !0;
            }
        }
        return n ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : r ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreNot {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 9634);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BOOLEAN":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                    booleanValue: !n.value?.booleanValue
                });
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreOr {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = !1, r = !1;
        for (const i of this.expr.params){
            const s = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    if (s.value?.booleanValue) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
                    break;
                case "NULL":
                    r = !0;
                    break;
                default:
                    n = !0;
            }
        }
        return n ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : r ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreXor {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = !1, r = !1;
        for (const i of this.expr.params){
            const s = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    n = $b1c6e3a850a3c735$var$__PRIVATE_CoreXor.xor(n, !!s.value?.booleanValue);
                    break;
                case "NULL":
                    r = !0;
                    break;
                default:
                    return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
            }
        }
        return r ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: n
        });
    }
    // XOR(a, b) is equivalent to (a OR b) AND NOT(a AND b)
    // It is required to evaluate all arguments to ensure that the correct error semantics are
    // applied.
    static xor(e, t) {
        return (e || t) && !(e && t);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreEqAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 55094);
        let n = !1;
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "NULL":
                n = !0;
                break;
            case "ERROR":
            case "UNSET":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const i = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        if (n) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
        for (const e of i.value?.arrayValue?.values ?? [])switch($b1c6e3a850a3c735$var$__PRIVATE_isNullValue(r.value) && $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) ? "EQ" : $b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(r.value, e)){
            case "EQ":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                $b1c6e3a850a3c735$export$8743009a87fcb00f(44608, {
                    value: r.value,
                    candidate: e
                });
        }
        return n ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreNotEqAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_CoreNot(new $b1c6e3a850a3c735$export$b169257caa88022a("not", [
            new $b1c6e3a850a3c735$export$b169257caa88022a("equal_any", this.expr.params)
        ])).evaluate(e, t);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNan {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 23322);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "INT":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
            case "DOUBLE":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                    booleanValue: isNaN($b1c6e3a850a3c735$var$__PRIVATE_asDouble(n.value))
                });
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNotNan {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 50406);
        return new $b1c6e3a850a3c735$var$__PRIVATE_CoreNot(new $b1c6e3a850a3c735$export$b169257caa88022a("not", [
            new $b1c6e3a850a3c735$export$b169257caa88022a("is_nan", this.expr.params)
        ])).evaluate(e, t);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNull {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 23123);
        switch($b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
            case "UNSET":
            case "ERROR":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreIsNotNull {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 23167);
        return new $b1c6e3a850a3c735$var$__PRIVATE_CoreNot(new $b1c6e3a850a3c735$export$b169257caa88022a("not", [
            new $b1c6e3a850a3c735$export$b169257caa88022a("is_null", this.expr.params)
        ])).evaluate(e, t);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreIsError {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 5228);
        return "ERROR" === $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreExists {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 6877);
        switch($b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
            case "ERROR":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
            case "UNSET":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreCond {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(3 === this.expr.params.length, 11706);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BOOLEAN":
                return n.value?.booleanValue ? $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t) : $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreLogicalMaximum {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>$b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        let r;
        for (const e of n)switch(e.type){
            case "ERROR":
            case "UNSET":
            case "NULL":
                continue;
            default:
                r = void 0 === r || $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, r.value) > 0 ? e : r;
        }
        return void 0 === r ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : r;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreLogicalMinimum {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>$b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        let r;
        for (const e of n)switch(e.type){
            case "ERROR":
            case "UNSET":
            case "NULL":
                continue;
            default:
                r = void 0 === r || $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, r.value) < 0 ? e : r;
        }
        return void 0 === r ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : r;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 31033, `${this.expr.name}() function should have exactly 2 params`);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "ERROR":
            case "UNSET":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(r.type){
            case "ERROR":
            case "UNSET":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        return this.Ur(n, r);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreEq extends $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        if (e.Fr() && t.Fr()) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
        if (e.Fr() || t.Fr()) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
        if ($b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(t.value)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
        if ($b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e.value) !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t.value)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
        switch($b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e.value, t.value)){
            case "EQ":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
            case "NOT_EQ":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                $b1c6e3a850a3c735$export$8743009a87fcb00f(44615, {
                    left: e,
                    right: t
                });
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreNeq extends $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        switch($b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e.value, t.value)){
            case "EQ":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                $b1c6e3a850a3c735$export$8743009a87fcb00f(44614, {
                    left: e,
                    right: t
                });
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreLt extends $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e.value) !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(t.value) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, t.value) < 0
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreLte extends $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e.value) !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(t.value) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht) : "EQ" === $b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e.value, t.value) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, t.value) < 0
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreGt extends $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e.value) !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(t.value) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, t.value) > 0
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreGte extends $b1c6e3a850a3c735$var$__PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e.value) !== $b1c6e3a850a3c735$var$__PRIVATE_typeOrder(t.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(e.value) || $b1c6e3a850a3c735$var$__PRIVATE_isNanValue(t.value) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht) : "EQ" === $b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e.value, t.value) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(e.value, t.value) > 0
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayConcat {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayReverse {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 216);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            case "ARRAY":
                {
                    const e = n.value.arrayValue?.values ?? [];
                    return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        arrayValue: {
                            values: [
                                ...e
                            ].reverse()
                        }
                    });
                }
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayContains {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 52884), new $b1c6e3a850a3c735$var$__PRIVATE_CoreEqAny(new $b1c6e3a850a3c735$export$b169257caa88022a("eq_any", [
            this.expr.params[1],
            this.expr.params[0]
        ])).evaluate(e, t);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayContainsAll {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 1392);
        let n = !1;
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const i = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        if (n) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
        const s = i.value?.arrayValue?.values ?? [], _ = r.value?.arrayValue?.values ?? [];
        for (const e of s){
            let t = !1;
            n = !1;
            for (const r of _){
                switch($b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) && $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(r) ? "EQ" : $b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e, r)){
                    case "EQ":
                        t = !0;
                        break;
                    case "NOT_EQ":
                    case "TYPE_MISMATCH":
                        break;
                    case "NULL":
                        n = !0;
                        break;
                    default:
                        $b1c6e3a850a3c735$export$8743009a87fcb00f(44613, {
                            value: r,
                            search: e
                        });
                }
                if (t) break;
            }
            if (!t) // false case - we didn't find a match, short circuit
            return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
        }
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayContainsAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 2680);
        let n = !1;
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const i = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        if (n) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
        const s = i.value?.arrayValue?.values ?? [], _ = r.value?.arrayValue?.values ?? [];
        for (const e of _)for (const t of s)switch($b1c6e3a850a3c735$var$__PRIVATE_isNullValue(e) && $b1c6e3a850a3c735$var$__PRIVATE_isNullValue(t) ? "EQ" : $b1c6e3a850a3c735$var$__PRIVATE_strictValueEquals(e, t)){
            case "EQ":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$Et);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                $b1c6e3a850a3c735$export$8743009a87fcb00f(44608, {
                    value: e,
                    search: t
                });
        }
        return n ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue($b1c6e3a850a3c735$var$ht);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 38605);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            case "ARRAY":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                    integerValue: `${n.value?.arrayValue?.values?.length ?? 0}`
                });
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreArrayElement {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreReverse {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 1508);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            case "BYTES":
                {
                    const e = n.value?.bytesValue;
                    if ("string" == typeof e) {
                        const t = $b1c6e3a850a3c735$export$158acd800e1ef08b.fromBase64String(e).toUint8Array();
                        return t.reverse(), $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                            bytesValue: $b1c6e3a850a3c735$export$158acd800e1ef08b.fromUint8Array(t).toBase64()
                        });
                    }
                    return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        bytesValue: new Uint8Array(e).reverse()
                    });
                }
            case "STRING":
                {
                    const e = n.value?.stringValue, t = new Intl.__PRIVATE_Segmenter(void 0, {
                        granularity: "grapheme"
                    }).segment(e), r = Array.from(t, (e)=>e.segment).reverse();
                    return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        stringValue: r.join("")
                    });
                }
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreReplaceFirst {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreReplaceAll {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreCharLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 19400);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            case "STRING":
                {
                    const e = function __PRIVATE_getUnicodePointCount(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++){
                            const r = e.codePointAt(n);
                            if (void 0 === r) return; // Should not happen with valid JS strings
                            // BMP character (including lone surrogates, which count as 1)
                            if (r <= 65535) {
                                // Check specifically for lone surrogates which are invalid UTF-16 sequences
                                if (r >= 55296 && r <= 57343) {
                                    // High surrogate: check if followed by low surrogate
                                    if (r <= 56319) {
                                        const r = e.codePointAt(n + 1);
                                        void 0 !== r && r >= 56320 && r <= 57343 ? // Valid surrogate pair (counts as one character)
                                        (t += 1, n++) : // Lone high surrogate - treat as one character for length, but invalid for byte length
                                        t += 1;
                                    } else // Lone low surrogate - treat as one character
                                    t += 1;
                                } else // Regular BMP character
                                t += 1;
                            } else {
                                if (!(r <= 1114111)) return;
                                // Invalid code point
                                t += 1, n++;
                            }
                        }
                        return t;
                    }(n.value.stringValue);
                    // If counting failed (e.g., invalid sequence), return error
                    return void 0 === e ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: e
                    });
                }
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreByteLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 8486);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BYTES":
                {
                    const e = n.value?.bytesValue;
                    return "string" == typeof e ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: $b1c6e3a850a3c735$export$158acd800e1ef08b.fromBase64String(e).toUint8Array().length
                    }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: new Uint8Array(e).length
                    });
                }
            case "STRING":
                {
                    // return the number of bytes in the string
                    const e = function __PRIVATE_getUtf8ByteLength(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++){
                            const r = e.codePointAt(n);
                            // Check for out of range of lone surrogate
                            if (void 0 === r) return;
                            if (r >= 55296 && r <= 57343) {
                                // If it is a high surrogate, check if a low surrogate follows
                                if (!(r <= 56319)) return;
                                // Lone low surrogate
                                {
                                    const r = e.codePointAt(n + 1);
                                    if (void 0 === r || !(r >= 56320 && r <= 57343)) return; // Lone high surrogate
                                    // Valid surrogate pair
                                    t += 4, n++;
                                }
                            } else if (r <= 127) t += 1;
                            else if (r <= 2047) t += 2;
                            else if (r <= 65535) t += 3;
                            else {
                                if (!(r <= 1114111)) return;
                                // Invalid code point (should not normally happen)
                                t += 4, n++;
                            }
                        }
                        return t;
                    }(n.value?.stringValue);
                    return void 0 === e ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: e
                    });
                }
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 39773, `${this.expr.name}() function should have exactly two parameters`);
        let n = !1;
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "STRING":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const i = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "STRING":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        return n ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : this.kr(r.value?.stringValue, i.value?.stringValue);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreLike extends $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        try {
            const n = function __PRIVATE_likeToRegex(e) {
                let t = "";
                for(let n = 0; n < e.length; n++){
                    const r = e.charAt(n);
                    switch(r){
                        case "_":
                            t += ".";
                            break;
                        case "%":
                            t += ".*";
                            break;
                        // Escape regex special characters
                        case "\\":
                        // Need to escape backslash itself
                        case ".":
                        case "*":
                        case "?":
                        case "+":
                        case "^":
                        case "$":
                        case "|":
                        case "(":
                        case ")":
                        case "[":
                        case "]":
                        case "{":
                        case "}":
                            t += "\\" + r;
                            break;
                        default:
                            t += r;
                    }
                }
                // Anchor the regex to match the entire string
                return "^" + t + "$";
            }(t), r = (0, $4f6bfbff25a5c30c$export$e46efc5f33420715).compile(n);
            return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                booleanValue: r.matches(e)
            });
        } catch (e) {
            return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(`Invalid LIKE pattern converted to regex: ${t}, returning error. Error: ${e}`), $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreRegexContains extends $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        try {
            const n = (0, $4f6bfbff25a5c30c$export$e46efc5f33420715).compile(t);
            return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                booleanValue: n.matcher(e).find()
            });
        } catch (e) {
            return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(`Invalid regex pattern found in regex_contains: ${t}, returning error`), $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreRegexMatch extends $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        try {
            // Use matches() for full string match semantics
            return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                booleanValue: (0, $4f6bfbff25a5c30c$export$e46efc5f33420715).compile(t).matches(e)
            });
        } catch (e) {
            return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(`Invalid regex pattern found in regex_match: ${t}, returning error`), $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreStrContains extends $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: e.includes(t)
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreStartsWith extends $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: e.startsWith(t)
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreEndsWith extends $b1c6e3a850a3c735$var$__PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            booleanValue: e.endsWith(t)
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreToLower {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 29079);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.toLowerCase()
                });
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreToUpper {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 60487);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.toUpperCase()
                });
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreTrim {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 28544);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.trim()
                });
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreStrConcat {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>$b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(n).evaluate(e, t));
        // If any part is error or unset, or not a string (and not null), result is error
        // If any part is null, result is null
        let r = "", i = !1;
        for (const e of n)switch(e.type){
            case "STRING":
                r += e.value.stringValue;
                break;
            case "NULL":
                i = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        return i ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            stringValue: r
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreMapGet {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 4483);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "UNSET":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Sr();
            case "MAP":
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        if ("STRING" !== r.type) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        const i = n.value?.mapValue?.fields?.[r.value?.stringValue];
        return void 0 === i ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Sr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue(i);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_DistanceBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(2 === this.expr.params.length, 25231, `${this.expr.name}() function should have exactly 2 params`);
        let n = !1;
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "VECTOR":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const i = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "VECTOR":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        if (n) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
        const s = $b1c6e3a850a3c735$var$__PRIVATE_getVectorValue(r.value), _ = $b1c6e3a850a3c735$var$__PRIVATE_getVectorValue(i.value);
        // Mismatched lengths or undefined vectors result in error
        if (void 0 === s || void 0 === _ || s.values?.length !== _.values?.length) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        const o = this.qr(s, _);
        // NaN or undefined distance calculation results in error
        return void 0 === o || isNaN(o) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr() : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            doubleValue: o
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreCosineDistance extends $b1c6e3a850a3c735$var$__PRIVATE_DistanceBase {
    qr(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return;
        // Distance undefined for empty vectors
        let i = 0, s = 0, _ = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!$b1c6e3a850a3c735$var$__PRIVATE_isNumber(n[e]) || !$b1c6e3a850a3c735$var$__PRIVATE_isNumber(r[e])) return;
            const t = $b1c6e3a850a3c735$var$__PRIVATE_asDouble(n[e]), o = $b1c6e3a850a3c735$var$__PRIVATE_asDouble(r[e]);
            i += t * o, s += t * t, _ += o * o;
        }
        const o = Math.sqrt(s) * Math.sqrt(_);
        // Distance undefined if either vector has zero magnitude
        if (0 === o) return;
        // Clamp cosine similarity to [-1, 1] due to potential floating point inaccuracies
        return 1 - Math.max(-1, Math.min(1, i / o));
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreDotProduct extends $b1c6e3a850a3c735$var$__PRIVATE_DistanceBase {
    qr(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return 0;
        // Dot product of empty vectors is 0
        let i = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!$b1c6e3a850a3c735$var$__PRIVATE_isNumber(n[e]) || !$b1c6e3a850a3c735$var$__PRIVATE_isNumber(r[e])) return;
            i += $b1c6e3a850a3c735$var$__PRIVATE_asDouble(n[e]) * $b1c6e3a850a3c735$var$__PRIVATE_asDouble(r[e]);
        }
        return i;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreEuclideanDistance extends $b1c6e3a850a3c735$var$__PRIVATE_DistanceBase {
    qr(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return 0;
        // Distance between empty vectors is 0
        let i = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!$b1c6e3a850a3c735$var$__PRIVATE_isNumber(n[e]) || !$b1c6e3a850a3c735$var$__PRIVATE_isNumber(r[e])) return;
            const t = $b1c6e3a850a3c735$var$__PRIVATE_asDouble(n[e]), s = $b1c6e3a850a3c735$var$__PRIVATE_asDouble(r[e]);
            i += Math.pow(t - s, 2);
        }
        return Math.sqrt(i);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreVectorLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 39044);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "VECTOR":
                {
                    const e = $b1c6e3a850a3c735$var$__PRIVATE_getVectorValue(n.value);
                    return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
                        integerValue: e?.values?.length ?? 0
                    });
                }
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
// 0001-01-01T00:00:00Z
const $b1c6e3a850a3c735$var$Gt = BigInt(-62135596800), $b1c6e3a850a3c735$var$zt = BigInt(253402300799), $b1c6e3a850a3c735$var$jt = BigInt(1e3), $b1c6e3a850a3c735$var$Ht = BigInt(1e6), $b1c6e3a850a3c735$var$Jt = $b1c6e3a850a3c735$var$Gt * $b1c6e3a850a3c735$var$jt, $b1c6e3a850a3c735$var$Yt = $b1c6e3a850a3c735$var$zt * $b1c6e3a850a3c735$var$jt + BigInt(999), $b1c6e3a850a3c735$var$Zt = $b1c6e3a850a3c735$var$Gt * $b1c6e3a850a3c735$var$Ht, $b1c6e3a850a3c735$var$Xt = $b1c6e3a850a3c735$var$zt * $b1c6e3a850a3c735$var$Ht + BigInt(999999);
// 9999-12-31T23:59:59Z - but the max timestamp has 999,999,999 nanoseconds
// Max sub-second micros
function $b1c6e3a850a3c735$var$__PRIVATE_isMicrosInBounds(e) {
    return e >= $b1c6e3a850a3c735$var$Zt && e <= $b1c6e3a850a3c735$var$Xt;
}
function $b1c6e3a850a3c735$var$__PRIVATE_isSecondsInBounds(e) {
    return e >= $b1c6e3a850a3c735$var$Gt && e <= $b1c6e3a850a3c735$var$zt;
}
function $b1c6e3a850a3c735$var$__PRIVATE_isTimestampInBounds(e, t) {
    const n = BigInt(e);
    return !(n < $b1c6e3a850a3c735$var$Gt || n > $b1c6e3a850a3c735$var$zt) && // Nanos must be non-negative and less than 1 second
    !(t < 0 || t >= 1e9) && // Additional check for min/max boundaries
    (n !== $b1c6e3a850a3c735$var$Gt || 0 === t) && !(n === $b1c6e3a850a3c735$var$zt && t > 999999999);
}
// Helper function to adjust timestamp for negative nanoseconds
function $b1c6e3a850a3c735$var$__PRIVATE_adjustTimestamp(e, t) {
    return t < 0 ? {
        seconds: e - 1,
        nanos: t + 1e9
    } : {
        seconds: e,
        nanos: t
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_timestampToMicros(e) {
    return BigInt(e.seconds) * $b1c6e3a850a3c735$var$Ht + // Integer division truncates towards zero
    BigInt(Math.trunc(e.nanoseconds / 1e3));
}
class $b1c6e3a850a3c735$var$__PRIVATE_UnixToTimestamp {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 49262, `${this.expr.name}() function should have exactly one parameter`);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "INT":
                return this.toTimestamp(BigInt(n.value.integerValue));
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreUnixMicrosToTimestamp extends $b1c6e3a850a3c735$var$__PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isMicrosInBounds(e)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        let t = Number(e / $b1c6e3a850a3c735$var$Ht), n = Number(e % $b1c6e3a850a3c735$var$Ht * BigInt(1e3));
        // Note: BigInt modulo can result in negative values if the dividend is negative.
        // Adjust for negative nanoseconds
        const r = $b1c6e3a850a3c735$var$__PRIVATE_adjustTimestamp(t, n);
        // Final bounds check after adjustment
        return t = r.seconds, n = r.nanos, $b1c6e3a850a3c735$var$__PRIVATE_isTimestampInBounds(t, n) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: n
            }
        }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreUnixMillisToTimestamp extends $b1c6e3a850a3c735$var$__PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!function __PRIVATE_isMillisInBounds(e) {
            return e >= $b1c6e3a850a3c735$var$Jt && e <= $b1c6e3a850a3c735$var$Yt;
        }(e)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        let t = Number(e / $b1c6e3a850a3c735$var$jt), n = Number(e % $b1c6e3a850a3c735$var$jt * BigInt(1e6));
        // Adjust for negative nanoseconds
        const r = $b1c6e3a850a3c735$var$__PRIVATE_adjustTimestamp(t, n);
        // Final bounds check after adjustment
        return t = r.seconds, n = r.nanos, $b1c6e3a850a3c735$var$__PRIVATE_isTimestampInBounds(t, n) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: n
            }
        }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreUnixSecondsToTimestamp extends $b1c6e3a850a3c735$var$__PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isSecondsInBounds(e)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        const t = Number(e);
        return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: 0
            }
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_TimestampToUnix {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === this.expr.params.length, 1265, `${this.expr.name}() function should have exactly one parameter`);
        const n = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "TIMESTAMP":
                break;
            case "NULL":
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const r = $b1c6e3a850a3c735$var$fromTimestamp(n.value.timestampValue);
        // Check if the input timestamp is within valid bounds
        return $b1c6e3a850a3c735$var$__PRIVATE_isTimestampInBounds(r.seconds, r.nanoseconds) ? this.$r(r) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampToUnixMicros extends $b1c6e3a850a3c735$var$__PRIVATE_TimestampToUnix {
    $r(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_timestampToMicros(e);
        // Check if the resulting micros are within representable bounds
        return $b1c6e3a850a3c735$var$__PRIVATE_isMicrosInBounds(t) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: `${t.toString()}`
        }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampToUnixMillis extends $b1c6e3a850a3c735$var$__PRIVATE_TimestampToUnix {
    $r(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_timestampToMicros(e), n = t / BigInt(1e3), r = t % BigInt(1e3);
        // Perform division, truncating towards zero (default JS BigInt division)
        return n > BigInt(0) || r === BigInt(0) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: n.toString()
        }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: (n - BigInt(1)).toString()
        });
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampToUnixSeconds extends $b1c6e3a850a3c735$var$__PRIVATE_TimestampToUnix {
    $r(e) {
        // Seconds are directly available
        const t = BigInt(e.seconds);
        // Check if the resulting seconds are within representable bounds
        return $b1c6e3a850a3c735$var$__PRIVATE_isSecondsInBounds(t) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            integerValue: t.toString()
        }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_TimestampArithmetic {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(3 === this.expr.params.length, 2775, `${this.expr.name}() function should have exactly 3 parameters`);
        let n = !1;
        const r = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "TIMESTAMP":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const i = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        let s;
        switch(i.type){
            case "STRING":
                if (s = function __PRIVATE_asTimeUnit(e) {
                    switch(e){
                        case "microsecond":
                            return "microsecond";
                        case "millisecond":
                            return "millisecond";
                        case "second":
                            return "second";
                        case "minute":
                            return "minute";
                        case "hour":
                            return "hour";
                        case "day":
                            return "day";
                        default:
                            return;
                    }
                }(i.value.stringValue), void 0 === s) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const _ = $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
        switch(_.type){
            case "INT":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        if (n) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.Dr();
        const o = BigInt(_.value.integerValue);
        let a;
        try {
            switch(s){
                case "microsecond":
                    a = o;
                    break;
                case "millisecond":
                    a = o * BigInt(1e3);
                    break;
                case "second":
                    a = o * BigInt(1e6);
                    break;
                case "minute":
                    a = o * BigInt(6e7);
                    break;
                case "hour":
                    a = o * BigInt(36e8);
                    break;
                case "day":
                    a = o * BigInt(864e8);
                    break;
                default:
                    return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
            }
            // Check for potential overflow during multiplication
            if ("microsecond" !== s && o !== BigInt(0) && a / o !== BigInt(this.Kr(s))) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        } catch (e) {
            // Catch potential BigInt errors (though unlikely with isInteger check)
            return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(`Error during timestamp arithmetic: ${e}`), $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        }
        const u = $b1c6e3a850a3c735$var$fromTimestamp(r.value.timestampValue);
        // Check initial timestamp bounds
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isTimestampInBounds(u.seconds, u.nanoseconds)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        const c = $b1c6e3a850a3c735$var$__PRIVATE_timestampToMicros(u), l = this.Wr(c, a);
        // Check final microsecond bounds
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isMicrosInBounds(l)) return $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
        // Convert back to seconds and nanos
        const E = Number(l / $b1c6e3a850a3c735$var$Ht), h = l % $b1c6e3a850a3c735$var$Ht, T = Number((h < 0 ? h + $b1c6e3a850a3c735$var$Ht : h) * BigInt(1e3)), P = h < 0 ? E - 1 : E;
        // Final check on calculated timestamp bounds
        return $b1c6e3a850a3c735$var$__PRIVATE_isTimestampInBounds(P, T) ? $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: P,
                nanos: T
            }
        }) : $b1c6e3a850a3c735$var$__PRIVATE_EvaluateResult.vr();
    }
    Kr(e) {
        switch(e){
            case "millisecond":
                return 1e3;
            case "second":
                return 1e6;
            case "minute":
                return 6e7;
            case "hour":
                return 36e8;
            case "day":
                return 864e8;
            default:
                return 1;
        }
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampAdd extends $b1c6e3a850a3c735$var$__PRIVATE_TimestampArithmetic {
    Wr(e, t) {
        return e + t;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_CoreTimestampSub extends $b1c6e3a850a3c735$var$__PRIVATE_TimestampArithmetic {
    Wr(e, t) {
        return e - t;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function $b1c6e3a850a3c735$var$__PRIVATE_toPipelineBooleanExpr(e) {
    if (e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef) {
        const t = $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e.field.toString()), n = e.value;
        // Comparison filters
        switch(e.op){
            case "<" /* Operator.LESS_THAN */ :
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.lessThan($b1c6e3a850a3c735$var$Constant._fromProto(n)));
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.lessThanOrEqual($b1c6e3a850a3c735$var$Constant._fromProto(n)));
            case ">" /* Operator.GREATER_THAN */ :
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.greaterThan($b1c6e3a850a3c735$var$Constant._fromProto(n)));
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.greaterThanOrEqual($b1c6e3a850a3c735$var$Constant._fromProto(n)));
            case "==" /* Operator.EQUAL */ :
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.equal($b1c6e3a850a3c735$var$Constant._fromProto(n)));
            case "!=" /* Operator.NOT_EQUAL */ :
                return t.notEqual($b1c6e3a850a3c735$var$Constant._fromProto(n));
            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.arrayContains($b1c6e3a850a3c735$var$Constant._fromProto(n)));
            case "in" /* Operator.IN */ :
                {
                    const e = n?.arrayValue?.values?.map((e)=>$b1c6e3a850a3c735$var$Constant._fromProto(e));
                    return e ? 1 === e.length ? $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.equal(e[0])) : $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.equalAny(e)) : $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.equalAny([]));
                }
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                {
                    const e = n?.arrayValue?.values?.map((e)=>$b1c6e3a850a3c735$var$Constant._fromProto(e));
                    return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t.exists(), t.arrayContainsAny(e));
                }
            case "not-in" /* Operator.NOT_IN */ :
                {
                    const e = n?.arrayValue?.values?.map((e)=>$b1c6e3a850a3c735$var$Constant._fromProto(e));
                    return e ? 1 === e.length ? t.notEqual(e[0]) : t.notEqualAny(e) : t.notEqualAny([]);
                }
            default:
                $b1c6e3a850a3c735$export$8743009a87fcb00f(36935);
        }
    } else if (e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b) switch(e.op){
        case "and" /* CompositeOperator.AND */ :
            {
                const t = e.getFilters().map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_toPipelineBooleanExpr(e));
                return $b1c6e3a850a3c735$export$7fe88b5920ffddd2(t[0], t[1], ...t.slice(2));
            }
        case "or" /* CompositeOperator.OR */ :
            {
                const t = e.getFilters().map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_toPipelineBooleanExpr(e));
                return $b1c6e3a850a3c735$export$2b548b2e30e1dd12(t[0], t[1], ...t.slice(2));
            }
        default:
            $b1c6e3a850a3c735$export$8743009a87fcb00f(35306);
    }
    throw new Error(`Failed to convert filter to pipeline conditions: ${e}`);
}
function $b1c6e3a850a3c735$export$136fd86de524d3c2(e, t) {
    let n;
    n = $b1c6e3a850a3c735$export$3b14a55fb2447963(e) ? t.pipeline().collectionGroup(e.collectionGroup) : $b1c6e3a850a3c735$var$__PRIVATE_isDocumentQuery$1(e) ? t.pipeline().documents([
        $b1c6e3a850a3c735$export$a9c996f45e5784d0(t, e.path.canonicalString())
    ]) : t.pipeline().collection(e.path.canonicalString());
    // filters
    for (const t of e.filters)n = n.where($b1c6e3a850a3c735$var$__PRIVATE_toPipelineBooleanExpr(t));
    // orders
    const r = $b1c6e3a850a3c735$export$9e5f44173e64f162(e), i = r.map((e)=>$b1c6e3a850a3c735$export$a36fb7d24305ed9d(e.field.canonicalString()).exists());
    n = i.length > 1 ? n.where($b1c6e3a850a3c735$export$7fe88b5920ffddd2(i[0], i[1], ...i.slice(2))) : n.where(i[0]);
    const s = r.map((e)=>"asc" /* Direction.ASCENDING */  === e.dir ? $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e.field.canonicalString()).ascending() : $b1c6e3a850a3c735$export$a36fb7d24305ed9d(e.field.canonicalString()).descending());
    if (s.length > 0) {
        if ("L" /* LimitType.Last */  === e.limitType) {
            const t = function __PRIVATE_reverseOrderings(e) {
                return e.map((e)=>new $b1c6e3a850a3c735$export$101619b11a34a0bd(e.expr, "ascending" === e.direction ? "descending" : "ascending", void 0));
            }(s);
            n = n.sort(t[0], ...t.slice(1)), // cursors
            null !== e.startAt && (n = n.where($b1c6e3a850a3c735$var$__PRIVATE_whereConditionsFromCursor(e.startAt, s, "after"))), null !== e.endAt && (n = n.where($b1c6e3a850a3c735$var$__PRIVATE_whereConditionsFromCursor(e.endAt, s, "before"))), n = n.limit(e.limit), n = n.sort(s[0], ...s.slice(1));
        } else n = n.sort(s[0], ...s.slice(1)), null !== e.startAt && (n = n.where($b1c6e3a850a3c735$var$__PRIVATE_whereConditionsFromCursor(e.startAt, s, "after"))), null !== e.endAt && (n = n.where($b1c6e3a850a3c735$var$__PRIVATE_whereConditionsFromCursor(e.endAt, s, "before"))), null !== e.limit && (n = n.limit(e.limit));
    }
    return n.stages;
}
function $b1c6e3a850a3c735$var$__PRIVATE_whereConditionsFromCursor(e, t, n) {
    // The filterFunc is either greater than or less than
    const r = "before" === n ? $b1c6e3a850a3c735$export$3dfa6803f1a6c839 : $b1c6e3a850a3c735$export$27df29599c06edba, i = e.position.map((e)=>$b1c6e3a850a3c735$var$Constant._fromProto(e)), s = i.length;
    let _ = t[s - 1].expr, o = i[s - 1], a = r(_, o);
    e.inclusive && // When the cursor bound is inclusive, then the last bound
    // can be equal to the value, otherwise it's not equal
    (a = $b1c6e3a850a3c735$export$2b548b2e30e1dd12(a, _.equal(o)));
    // Iterate backwards over the remaining bounds, adding
    // a condition for each one
    for(let e = s - 2; e >= 0; e--)_ = t[e].expr, o = i[e], // For each field in the orderings, the condition is either
    // a) lt|gt the cursor value,
    // b) or equal the cursor value and lt|gt the cursor values for other fields
    a = $b1c6e3a850a3c735$export$2b548b2e30e1dd12(r(_, o), $b1c6e3a850a3c735$export$7fe88b5920ffddd2(_.equal(o), a));
    return a;
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyExpr(e) {
    if ((e = $b1c6e3a850a3c735$var$__PRIVATE_unwrapExpression(e)) instanceof $b1c6e3a850a3c735$export$e0c3a065614c6254) return `fld(${e.fieldName})`;
    if (e instanceof $b1c6e3a850a3c735$var$Constant) return `cst(${function __PRIVATE_canonifyConstantValue(e) {
        return null === e ? "null" : "number" == typeof e ? e.toString() : "string" == typeof e ? `"${e}"` : e instanceof $b1c6e3a850a3c735$export$96f57966bedc81b4 ? `ref(${e.path})` : e instanceof $b1c6e3a850a3c735$export$24baa2b76016ce0e ? `vec(${JSON.stringify(e)})` : JSON.stringify(e);
    }(e.value)})`;
    if (e instanceof $b1c6e3a850a3c735$export$b169257caa88022a) return `fn(${e.name},[${e.params.map($b1c6e3a850a3c735$var$__PRIVATE_canonifyExpr).join(",")}])`;
    if ("ListOfExpressions" === e.expressionType) return `list([${e.Rr.map($b1c6e3a850a3c735$var$__PRIVATE_canonifyExpr).join(",")}])`;
    throw new Error(`Unrecognized expr ${JSON.stringify(e, null, 2)}`);
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyStage(e) {
    if (e instanceof $b1c6e3a850a3c735$export$5521614468b862fb) return `${e._name}(${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExprMap(e.fields)})`;
    if (e instanceof $b1c6e3a850a3c735$export$766bf7dcfb630b6c) {
        let t = `${e._name}(${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExprMap(e.accumulators)})`;
        return e.groups.size > 0 && (t += `grouping(${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExprMap(e.groups)})`), t;
    }
    if (e instanceof $b1c6e3a850a3c735$export$45d219bdcd8ac53c) return `${e._name}(${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExprMap(e.groups)})`;
    if (e instanceof $b1c6e3a850a3c735$export$7f557e5eb95176c2) return `${e._name}(${e.Vr})`;
    if (e instanceof $b1c6e3a850a3c735$export$51b138e5a065c2bb) return `${e._name}(${e.collectionId})`;
    if (e instanceof $b1c6e3a850a3c735$export$6dabbe08653f866f) return `${e._name}()`;
    if (e instanceof $b1c6e3a850a3c735$export$151db275011178c4) return `${e._name}(${e.dr.sort()})`;
    if (e instanceof $b1c6e3a850a3c735$export$4e222d082f82ee97) return `${e._name}(${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExpr(e.condition)})`;
    if (e instanceof $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb) return `${e._name}(${e.limit})`;
    if (e instanceof $b1c6e3a850a3c735$export$60bb826a6acf3081) return `${e._name}(${function __PRIVATE_canonifySortOrderings(e) {
        return e.map((e)=>`${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExpr(e.expr)}${e.direction}`).join(",");
    }(e.orderings)})`;
    throw new Error(`Unrecognized stage ${e._name}`);
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyExprMap(e) {
    return `${Array.from(e.entries()).sort().map(([e, t])=>`${e}=${$b1c6e3a850a3c735$var$__PRIVATE_canonifyExpr(t)}`).join(",")}`;
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(e) {
    return e.stages.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyStage(e)).join("|");
}
// TODO(pipeline): do a proper implementation for eq.
function $b1c6e3a850a3c735$var$__PRIVATE_pipelineEq(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(e) === $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(t);
}
function $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) {
    return e instanceof $b1c6e3a850a3c735$var$CorePipeline;
}
function $b1c6e3a850a3c735$var$__PRIVATE_stringifyQueryOrPipeline(e) {
    return $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) ? $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(e) : $b1c6e3a850a3c735$var$__PRIVATE_stringifyQuery(e);
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyQueryOrPipeline(e) {
    return $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) ? $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(e) : function __PRIVATE_canonifyQuery(e) {
        return `${$b1c6e3a850a3c735$var$__PRIVATE_canonifyTarget($b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
    }(e);
}
function $b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineEqual(e, t) {
    return e instanceof $b1c6e3a850a3c735$var$CorePipeline && t instanceof $b1c6e3a850a3c735$var$CorePipeline ? $b1c6e3a850a3c735$var$__PRIVATE_pipelineEq(e, t) : !(e instanceof $b1c6e3a850a3c735$var$CorePipeline && !(t instanceof $b1c6e3a850a3c735$var$CorePipeline) || !(e instanceof $b1c6e3a850a3c735$var$CorePipeline) && t instanceof $b1c6e3a850a3c735$var$CorePipeline) && $b1c6e3a850a3c735$var$__PRIVATE_queryEquals(e, t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_canonifyTargetOrPipeline(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(e) ? $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(e) : $b1c6e3a850a3c735$var$__PRIVATE_canonifyTarget(e);
}
function $b1c6e3a850a3c735$var$__PRIVATE_targetOrPipelineEqual(e, t) {
    return e instanceof $b1c6e3a850a3c735$var$CorePipeline && t instanceof $b1c6e3a850a3c735$var$CorePipeline ? $b1c6e3a850a3c735$var$__PRIVATE_pipelineEq(e, t) : !(e instanceof $b1c6e3a850a3c735$var$CorePipeline && !(t instanceof $b1c6e3a850a3c735$var$CorePipeline) || !(e instanceof $b1c6e3a850a3c735$var$CorePipeline) && t instanceof $b1c6e3a850a3c735$var$CorePipeline) && $b1c6e3a850a3c735$var$__PRIVATE_targetEquals(e, t);
}
// function addSystemFields(
//   fields: Map<string, Expression>
// ): Map<string, Expression> {
//   const newFields = new Map<string, Expression>(fields);
//   newFields.set(DOCUMENT_KEY_NAME, field(DOCUMENT_KEY_NAME));
//   newFields.set(CREATE_TIME_NAME, field(CREATE_TIME_NAME));
//   newFields.set(UPDATE_TIME_NAME, field(UPDATE_TIME_NAME));
//   return newFields;
// }
function $b1c6e3a850a3c735$var$__PRIVATE_toCorePipeline(e, t) {
    const n = function __PRIVATE_rewriteStages(e) {
        let t = !1;
        const n = [];
        for (const r of e)// For stages that provide ordering semantics
        if (r instanceof $b1c6e3a850a3c735$export$60bb826a6acf3081) {
            // Ensure we have a stable ordering
            if (t = !0, r.orderings.some((e)=>e.expr instanceof $b1c6e3a850a3c735$export$e0c3a065614c6254 && e.expr.fieldName === $b1c6e3a850a3c735$var$F)) n.push(r);
            else {
                const e = r.orderings.map((e)=>e);
                e.push($b1c6e3a850a3c735$export$a36fb7d24305ed9d($b1c6e3a850a3c735$var$F).ascending()), n.push(new $b1c6e3a850a3c735$export$60bb826a6acf3081(e, {}));
            }
        } else r instanceof $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb ? (t || (n.push(new $b1c6e3a850a3c735$export$60bb826a6acf3081([
            $b1c6e3a850a3c735$export$a36fb7d24305ed9d($b1c6e3a850a3c735$var$F).ascending()
        ], {})), t = !0), n.push(r)) : n.push(r);
        return t || n.push(new $b1c6e3a850a3c735$export$60bb826a6acf3081([
            $b1c6e3a850a3c735$export$a36fb7d24305ed9d($b1c6e3a850a3c735$var$F).ascending()
        ], {})), n;
    }(e.stages);
    if (e.userDataReader) {
        const t = e.userDataReader.createContext(3 /* UserDataSource.Argument */ , "toCorePipeline");
        n.forEach((e)=>e._readUserData(t));
    }
    return new $b1c6e3a850a3c735$var$CorePipeline(e.userDataReader.serializer, n, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class $b1c6e3a850a3c735$var$MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let _ = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            _ = t.has(r.key) ? null : _;
            const o = $b1c6e3a850a3c735$var$__PRIVATE_calculateOverlayMutation(s, _);
            null !== o && n.set(r.key, o), s.isValidDocument() || s.convertToNoDocument($b1c6e3a850a3c735$var$SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), $b1c6e3a850a3c735$export$78acf4525d8a74c4());
    }
    isEqual(e) {
        return this.batchId === e.batchId && $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_mutationEquals(e, t)) && $b1c6e3a850a3c735$var$__PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class $b1c6e3a850a3c735$var$MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
            Qr: e.mutations.length,
            Gr: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return $b1c6e3a850a3c735$var$Vt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new $b1c6e3a850a3c735$var$MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class $b1c6e3a850a3c735$var$Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class $b1c6e3a850a3c735$var$TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = $b1c6e3a850a3c735$var$SnapshotVersion.min(), s = $b1c6e3a850a3c735$var$SnapshotVersion.min(), _ = $b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING, o = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = _, this.expectedCount = o;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new $b1c6e3a850a3c735$var$TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new $b1c6e3a850a3c735$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new $b1c6e3a850a3c735$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new $b1c6e3a850a3c735$var$TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class $b1c6e3a850a3c735$var$__PRIVATE_LocalSerializer {
    constructor(e){
        this.zr = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function $b1c6e3a850a3c735$var$__PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = $b1c6e3a850a3c735$export$3a1a48c8f6ef640e(e.zr, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(t.noDocument.path), r = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return $b1c6e3a850a3c735$export$8743009a87fcb00f(56709);
        {
            const e = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(t.unknownDocument.path), r = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = $b1c6e3a850a3c735$var$MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new $b1c6e3a850a3c735$export$890c4ad488842ce7(e[0], e[1]);
        return $b1c6e3a850a3c735$var$SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function $b1c6e3a850a3c735$var$__PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: $b1c6e3a850a3c735$var$__PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: $b1c6e3a850a3c735$var$toTimestamp(e, t.version.toTimestamp()),
            createTime: $b1c6e3a850a3c735$var$toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.zr, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return $b1c6e3a850a3c735$export$8743009a87fcb00f(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(e) {
    const t = new $b1c6e3a850a3c735$export$890c4ad488842ce7(e.seconds, e.nanoseconds);
    return $b1c6e3a850a3c735$var$SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function $b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>$b1c6e3a850a3c735$var$__PRIVATE_fromMutation(e.zr, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>$b1c6e3a850a3c735$var$__PRIVATE_fromMutation(e.zr, t)), i = $b1c6e3a850a3c735$export$890c4ad488842ce7.fromMillis(t.localWriteTimeMs);
    return new $b1c6e3a850a3c735$var$MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function $b1c6e3a850a3c735$var$__PRIVATE_fromDbTarget(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(t.readTime), r = void 0 !== t.lastLimboFreeSnapshotVersion ? $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(t.lastLimboFreeSnapshotVersion) : $b1c6e3a850a3c735$var$SnapshotVersion.min();
    let i;
    return i = function __PRIVATE_isPipelineQueryTarget(e) {
        return void 0 !== e.structuredPipeline;
    }(t.query) ? function __PRIVATE_fromPipelineTarget(e, t) {
        const n = e.structuredPipeline;
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert((n?.pipeline?.stages ?? []).length > 0, 1845);
        const r = n?.pipeline?.stages.map($b1c6e3a850a3c735$var$__PRIVATE_stageFromProto);
        return new $b1c6e3a850a3c735$var$CorePipeline(t, r);
    }(t.query, e.zr) : function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(t.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === t, 1966, {
            count: t
        }), $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget($b1c6e3a850a3c735$export$7910e0436ed8d1de($b1c6e3a850a3c735$var$__PRIVATE_fromQueryPath(e.documents[0])));
    }(t.query) : function __PRIVATE_fromQueryTarget(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget($b1c6e3a850a3c735$var$__PRIVATE_convertQueryTargetToQuery(e));
    }(t.query), new $b1c6e3a850a3c735$var$TargetData(i, t.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.lastListenSequenceNumber, n, r, $b1c6e3a850a3c735$export$158acd800e1ef08b.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function $b1c6e3a850a3c735$var$__PRIVATE_toDbTarget(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp(t.snapshotVersion), r = $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(t.target) ? $b1c6e3a850a3c735$var$__PRIVATE_toPipelineTarget(e.zr, t.target) : $b1c6e3a850a3c735$var$__PRIVATE_targetIsDocumentTarget(t.target) ? $b1c6e3a850a3c735$var$__PRIVATE_toDocumentsTarget(e.zr, t.target) : $b1c6e3a850a3c735$var$__PRIVATE_toQueryTarget(e.zr, t.target).yt;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: $b1c6e3a850a3c735$var$__PRIVATE_canonifyTargetOrPipeline(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function $b1c6e3a850a3c735$export$3a6d5c9ae78a2c08(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? $b1c6e3a850a3c735$export$882b5998b3b9117c(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function $b1c6e3a850a3c735$var$__PRIVATE_fromDbDocumentOverlay(e, t) {
    return new $b1c6e3a850a3c735$var$Overlay(t.largestBatchId, $b1c6e3a850a3c735$var$__PRIVATE_fromMutation(e.zr, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function $b1c6e3a850a3c735$var$__PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp(r.readTime),
        documentKey: $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_stageFromProto(e) {
    switch(e.name){
        case "collection":
            return new $b1c6e3a850a3c735$export$7f557e5eb95176c2(e.args[0].referenceValue, {});
        case "collection_group":
            return new $b1c6e3a850a3c735$export$51b138e5a065c2bb(e.args[1].stringValue, {});
        case "database":
            return new $b1c6e3a850a3c735$export$6dabbe08653f866f({});
        case "documents":
            return new $b1c6e3a850a3c735$export$151db275011178c4(e.args.map((e)=>e.referenceValue), {});
        case "where":
            return new $b1c6e3a850a3c735$export$4e222d082f82ee97($b1c6e3a850a3c735$var$__PRIVATE_exprFromProto(e.args[0]), {});
        case "limit":
            {
                const t = e.args[0].integerValue ?? e.args[0].doubleValue;
                return new $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb("number" == typeof t ? t : Number(t), {});
            }
        case "sort":
            return new $b1c6e3a850a3c735$export$60bb826a6acf3081(e.args.map((e)=>(function __PRIVATE_orderingFromProto(e) {
                    const t = e.mapValue?.fields;
                    return new $b1c6e3a850a3c735$export$101619b11a34a0bd($b1c6e3a850a3c735$var$__PRIVATE_exprFromProto(t.expression), t.direction?.stringValue, "orderingFromProto");
                })(e)), {});
        default:
            throw new Error(`Stage type: ${e.name} not supported.`);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_exprFromProto(e) {
    return e.fieldReferenceValue ? new $b1c6e3a850a3c735$export$e0c3a065614c6254($b1c6e3a850a3c735$export$35e795649ee09318("_exprFromProto", e.fieldReferenceValue), "_exprFromProto") : e.functionValue ? function __PRIVATE_functionFromProto(e) {
        // TODO(pipeline): When aggregation is supported, we need to return AggregateFunction for the functions
        // with aggregate names (sum, count, etc).
        return new $b1c6e3a850a3c735$export$b169257caa88022a(e.functionValue.name, e.functionValue.args?.map($b1c6e3a850a3c735$var$__PRIVATE_exprFromProto) || []);
    }(e) : $b1c6e3a850a3c735$var$Constant._fromProto(e);
}
class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp($b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: $b1c6e3a850a3c735$export$3a6d5c9ae78a2c08(e.bundledQuery),
                    readTime: $b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestamp($b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_bundlesStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$me);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_namedQueriesStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$ge);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static jr(e, t) {
        const n = t.uid || "";
        return new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e).get($b1c6e3a850a3c735$var$__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? $b1c6e3a850a3c735$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    getAllOverlays(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        // TODO(pipeline): should we create an index for this? But how often people really expect
        // querying entire database to be fast?
        return $b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e).ee((e, r)=>{
            const i = $b1c6e3a850a3c735$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, r);
            i.largestBatchId > t && n.set(i.getKey(), i);
        }).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new $b1c6e3a850a3c735$var$Overlay(t, i);
            r.push(this.Hr(e, s));
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add($b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push($b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e).Z($b1c6e3a850a3c735$var$ke, r));
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap(), i = $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e).H($b1c6e3a850a3c735$var$ke, s).next((e)=>{
            for (const t of e){
                const e = $b1c6e3a850a3c735$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const _ = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return $b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e).ee({
            index: $b1c6e3a850a3c735$var$$e,
            range: _
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const _ = $b1c6e3a850a3c735$var$__PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || _.largestBatchId === s ? (i.set(_.getKey(), _), s = _.largestBatchId) : n.done();
        }).next(()=>i);
    }
    Hr(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = $b1c6e3a850a3c735$var$__PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: $b1c6e3a850a3c735$var$toMutation(e.zr, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_documentOverlayStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$Be);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbGlobalsCache {
    Jr(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$We);
    }
    getSessionToken(e) {
        return this.Jr(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? $b1c6e3a850a3c735$export$158acd800e1ef08b.fromUint8Array(t) : $b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.Jr(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Yr(e, t) {
        this.Zr(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.Xr();
    }
    Zr(e, t) {
        if ("nullValue" in e) this.ei(t, 5);
        else if ("booleanValue" in e) this.ei(t, 10), t.ti(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.ei(t, 15), t.ti($b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.ei(t, 13) : (this.ei(t, 15), $b1c6e3a850a3c735$var$__PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.ti(0) : t.ti(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.ei(t, 20), "string" == typeof n && (n = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(n)), t.ni(`${n.seconds || ""}`), t.ti(n.nanos || 0);
        } else if ("stringValue" in e) this.ri(e.stringValue, t), this.ii(t);
        else if ("bytesValue" in e) this.ei(t, 30), t.si($b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e.bytesValue)), this.ii(t);
        else if ("referenceValue" in e) this._i(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.ei(t, 45), t.ti(n.latitude || 0), t.ti(n.longitude || 0);
        } else "mapValue" in e ? $b1c6e3a850a3c735$var$__PRIVATE_isMaxValue(e) ? this.ei(t, Number.MAX_SAFE_INTEGER) : $b1c6e3a850a3c735$var$__PRIVATE_isVectorValue(e) ? this.oi(e.mapValue, t) : (this.ai(e.mapValue, t), this.ii(t)) : "arrayValue" in e ? (this.ui(e.arrayValue, t), this.ii(t)) : $b1c6e3a850a3c735$export$8743009a87fcb00f(19022, {
            ci: e
        });
    }
    ri(e, t) {
        this.ei(t, 25), this.li(e, t);
    }
    li(e, t) {
        t.ni(e);
    }
    ai(e, t) {
        const n = e.fields || {};
        this.ei(t, 55);
        for (const e of Object.keys(n))this.ri(e, t), this.Zr(n[e], t);
    }
    oi(e, t) {
        const n = e.fields || {};
        this.ei(t, 53);
        // Vectors sort first by length
        const r = $b1c6e3a850a3c735$var$ct, i = n[r].arrayValue?.values?.length || 0;
        this.ei(t, 15), t.ti($b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.ri(r, t), this.Zr(n[r], t);
    }
    ui(e, t) {
        const n = e.values || [];
        this.ei(t, 50);
        for (const e of n)this.Zr(e, t);
    }
    _i(e, t) {
        this.ei(t, 37);
        $b1c6e3a850a3c735$export$90a7f3efeed30595.fromName(e).path.forEach((e)=>{
            this.ei(t, 60), this.li(e, t);
        });
    }
    ei(e, t) {
        e.ti(t);
    }
    ii(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.ti(2);
    }
}
$b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter.Ei = new $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const $b1c6e3a850a3c735$var$en = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = $b1c6e3a850a3c735$var$__PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    hi(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ti(n.value), n = t.next();
        this.Pi();
    }
    Ri(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ii(n.value), n = t.next();
        this.Ai();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Vi(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ti(e);
            else if (e < 2048) this.Ti(960 | e >>> 6), this.Ti(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ti(480 | e >>> 12), this.Ti(128 | 63 & e >>> 6), this.Ti(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ti(240 | e >>> 18), this.Ti(128 | 63 & e >>> 12), this.Ti(128 | 63 & e >>> 6), this.Ti(128 | 63 & e);
            }
        }
        this.Pi();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ di(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ii(e);
            else if (e < 2048) this.Ii(960 | e >>> 6), this.Ii(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ii(480 | e >>> 12), this.Ii(128 | 63 & e >>> 6), this.Ii(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ii(240 | e >>> 18), this.Ii(128 | 63 & e >>> 12), this.Ii(128 | 63 & e >>> 6), this.Ii(128 | 63 & e);
            }
        }
        this.Ai();
    }
    fi(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.mi(e), n = $b1c6e3a850a3c735$var$__PRIVATE_unsignedNumLength(t);
        this.pi(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    gi(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.mi(e), n = $b1c6e3a850a3c735$var$__PRIVATE_unsignedNumLength(t);
        this.pi(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ yi() {
        this.wi($b1c6e3a850a3c735$var$en), this.wi(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ bi() {
        this.Si($b1c6e3a850a3c735$var$en), this.Si(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.pi(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Di() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ mi(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Ti(e) {
        const t = 255 & e;
        0 === t ? (this.wi(0), this.wi(255)) : t === $b1c6e3a850a3c735$var$en ? (this.wi($b1c6e3a850a3c735$var$en), this.wi(0)) : this.wi(t);
    }
    /** Writes a single byte descending to the buffer.  */ Ii(e) {
        const t = 255 & e;
        0 === t ? (this.Si(0), this.Si(255)) : t === $b1c6e3a850a3c735$var$en ? (this.Si($b1c6e3a850a3c735$var$en), this.Si(0)) : this.Si(e);
    }
    Pi() {
        this.wi(0), this.wi(1);
    }
    Ai() {
        this.Si(0), this.Si(1);
    }
    wi(e) {
        this.pi(1), this.buffer[this.position++] = e;
    }
    Si(e) {
        this.pi(1), this.buffer[this.position++] = ~e;
    }
    pi(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.xi = e;
    }
    si(e) {
        this.xi.hi(e);
    }
    ni(e) {
        this.xi.Vi(e);
    }
    ti(e) {
        this.xi.fi(e);
    }
    Xr() {
        this.xi.yi();
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.xi = e;
    }
    si(e) {
        this.xi.Ri(e);
    }
    ni(e) {
        this.xi.di(e);
    }
    ti(e) {
        this.xi.gi(e);
    }
    Xr() {
        this.xi.bi();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexByteEncoder {
    constructor(){
        this.xi = new $b1c6e3a850a3c735$var$__PRIVATE_OrderedCodeWriter, this.ascending = new $b1c6e3a850a3c735$var$__PRIVATE_AscendingIndexByteEncoder(this.xi), this.descending = new $b1c6e3a850a3c735$var$__PRIVATE_DescendingIndexByteEncoder(this.xi);
    }
    seed(e) {
        this.xi.seed(e);
    }
    Ci(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
    }
    Di() {
        return this.xi.Di();
    }
    reset() {
        this.xi.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.Fi = e, this.Oi = t, this.Mi = n, this.Ni = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Li() {
        const e = this.Ni.length, t = 0 === e || 255 === this.Ni[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.Ni, 0), t !== e ? n.set([
            0
        ], this.Ni.length) : ++n[n.length - 1], new $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry(this.Fi, this.Oi, this.Mi, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    Bi(e, t, n) {
        return {
            indexId: this.Fi,
            uid: e,
            arrayValue: $b1c6e3a850a3c735$var$__PRIVATE_encodeKeySafeBytes(this.Mi),
            directionalValue: $b1c6e3a850a3c735$var$__PRIVATE_encodeKeySafeBytes(this.Ni),
            orderedDocumentKey: $b1c6e3a850a3c735$var$__PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    Ui(e, t, n) {
        const r = this.Bi(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator(e, t) {
    let n = e.Fi - t.Fi;
    return 0 !== n ? n : (n = $b1c6e3a850a3c735$var$__PRIVATE_compareByteArrays(e.Mi, t.Mi), 0 !== n ? n : (n = $b1c6e3a850a3c735$var$__PRIVATE_compareByteArrays(e.Ni, t.Ni), 0 !== n ? n : $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.Oi, t.Oi)));
}
function $b1c6e3a850a3c735$var$__PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_encodeKeySafeBytes(e) {
    return (0, $029952e65115eee5$export$ef10bcfb06572016)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class $b1c6e3a850a3c735$var$__PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.ki = new $b1c6e3a850a3c735$var$SortedSet((e, t)=>$b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.qi = e.orderBy, this.$i = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.ki = this.ki.add(e) : this.$i.push(e);
        }
    }
    get Ki() {
        return this.ki.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ Wi(e) {
        if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.Ki) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.Qi(t)) return !1;
        const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.Qi(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.ki.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.ki.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.Gi(e, t) || !this.zi(this.qi[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.qi.length || !this.zi(this.qi[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ ji() {
        if (this.Ki) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator);
        const t = [];
        for (const n of this.$i){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new $b1c6e3a850a3c735$export$f38c853ae54ed474(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new $b1c6e3a850a3c735$export$f38c853ae54ed474(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.qi)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new $b1c6e3a850a3c735$export$f38c853ae54ed474(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new $b1c6e3a850a3c735$export$3b513254972cfc9c($b1c6e3a850a3c735$export$3b513254972cfc9c.UNKNOWN_ID, this.collectionId, t, $b1c6e3a850a3c735$export$21579262ef46735b.empty());
    }
    Qi(e) {
        for (const t of this.$i)if (this.Gi(t, e)) return !0;
        return !1;
    }
    Gi(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    zi(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_computeInExpansion(e) {
    if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef || e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b, 20012), e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef) {
        if (e instanceof $b1c6e3a850a3c735$var$__PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>$b1c6e3a850a3c735$export$23f2a1d2818174ef.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return $b1c6e3a850a3c735$export$e7094788287c5e9b.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_computeInExpansion(e));
    return $b1c6e3a850a3c735$export$e7094788287c5e9b.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = $b1c6e3a850a3c735$var$__PRIVATE_computeDistributedNormalForm($b1c6e3a850a3c735$var$__PRIVATE_computeInExpansion(e));
    return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert($b1c6e3a850a3c735$var$__PRIVATE_isDisjunctiveNormalForm(t), 7391), $b1c6e3a850a3c735$var$__PRIVATE_isSingleFieldFilter(t) || $b1c6e3a850a3c735$var$__PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function $b1c6e3a850a3c735$var$__PRIVATE_isSingleFieldFilter(e) {
    return e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function $b1c6e3a850a3c735$var$__PRIVATE_isFlatConjunction(e) {
    return e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b && $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function $b1c6e3a850a3c735$var$__PRIVATE_isDisjunctiveNormalForm(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_isSingleFieldFilter(e) || $b1c6e3a850a3c735$var$__PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b && $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!$b1c6e3a850a3c735$var$__PRIVATE_isSingleFieldFilter(t) && !$b1c6e3a850a3c735$var$__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function $b1c6e3a850a3c735$var$__PRIVATE_computeDistributedNormalForm(e) {
    if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef || e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b, 34018), e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef) return e;
    if (1 === e.filters.length) return $b1c6e3a850a3c735$var$__PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_computeDistributedNormalForm(e));
    let n = $b1c6e3a850a3c735$export$e7094788287c5e9b.create(t, e.op);
    return n = $b1c6e3a850a3c735$var$__PRIVATE_applyAssociation(n), $b1c6e3a850a3c735$var$__PRIVATE_isDisjunctiveNormalForm(n) ? n : ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(n instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b, 64498), $b1c6e3a850a3c735$var$__PRIVATE_hardAssert($b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(n), 40251), $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_applyDistribution(e, t)));
}
function $b1c6e3a850a3c735$var$__PRIVATE_applyDistribution(e, t) {
    let n;
    return $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef || e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b, 38388), $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(t instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef || t instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b, 25473), // FieldFilter FieldFilter
    n = e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? t instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return $b1c6e3a850a3c735$export$e7094788287c5e9b.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : $b1c6e3a850a3c735$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? $b1c6e3a850a3c735$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(e) && $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(t)) return $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_applyDistribution(e, r));
        return $b1c6e3a850a3c735$export$e7094788287c5e9b.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), $b1c6e3a850a3c735$var$__PRIVATE_applyAssociation(n);
}
function $b1c6e3a850a3c735$var$__PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if ($b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return $b1c6e3a850a3c735$var$__PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>$b1c6e3a850a3c735$var$__PRIVATE_applyDistribution(e, t));
        return $b1c6e3a850a3c735$export$e7094788287c5e9b.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function $b1c6e3a850a3c735$var$__PRIVATE_applyAssociation(e) {
    if ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef || e instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b, 11850), e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return $b1c6e3a850a3c735$var$__PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if ($b1c6e3a850a3c735$var$__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef ? r.push(t) : t instanceof $b1c6e3a850a3c735$export$e7094788287c5e9b && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : $b1c6e3a850a3c735$export$e7094788287c5e9b.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryIndexManager {
    constructor(){
        this.Hi = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Hi.add(t), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.Hi.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve($b1c6e3a850a3c735$var$IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve($b1c6e3a850a3c735$var$IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$db202ddc8be9136.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$db202ddc8be9136.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$tn = "IndexedDbIndexManager", $b1c6e3a850a3c735$var$nn = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Ji = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Yi = new $b1c6e3a850a3c735$var$ObjectMap((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyTarget(e), (e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.Ji.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.Ji.add(t);
            });
            const i = {
                collectionId: n,
                parent: $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(r)
            };
            return $b1c6e3a850a3c735$var$__PRIVATE_collectionParentsStore(e).put(i);
        }
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            $b1c6e3a850a3c735$var$__PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return $b1c6e3a850a3c735$var$__PRIVATE_collectionParentsStore(e).H(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push($b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = $b1c6e3a850a3c735$var$__PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put($b1c6e3a850a3c735$var$__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_indexConfigurationStore(e), r = $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e), i = $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_indexConfigurationStore(e), n = $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e), r = $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e);
        return t.Z().next(()=>n.Z()).next(()=>r.Z());
    }
    createTargetIndexes(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(this.Zi(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new $b1c6e3a850a3c735$var$__PRIVATE_TargetIndexMatcher(t).ji();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(this.Zi(t), (t)=>this.Xi(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
                const r = [];
                return $b1c6e3a850a3c735$var$PersistencePromise.forEach(i, (i, s)=>{
                    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$tn, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${$b1c6e3a850a3c735$var$__PRIVATE_canonifyTarget(t)}`);
                    const _ = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of $b1c6e3a850a3c735$var$__PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), o = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of $b1c6e3a850a3c735$var$__PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $b1c6e3a850a3c735$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : $b1c6e3a850a3c735$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $b1c6e3a850a3c735$export$625550452a3fa3ec(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? $b1c6e3a850a3c735$var$__PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : $b1c6e3a850a3c735$var$__PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new $b1c6e3a850a3c735$export$625550452a3fa3ec(n, r);
                    }(s, i), c = this.es(i, s, a), l = this.es(i, s, u), E = this.ts(i, s, o), h = this.ns(i.indexId, _, c, a.inclusive, l, u.inclusive, E);
                    return $b1c6e3a850a3c735$var$PersistencePromise.forEach(h, (i)=>n.Y(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return $b1c6e3a850a3c735$var$PersistencePromise.resolve(null);
        });
    }
    Zi(e) {
        let t = this.Yi.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = $b1c6e3a850a3c735$var$__PRIVATE_getDnfTerms($b1c6e3a850a3c735$export$e7094788287c5e9b.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>$b1c6e3a850a3c735$var$__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Yi.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ ns(e, t, n, r, i, s, _) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const o = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = o / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < o; ++c){
            const o = t ? this.rs(t[c / a]) : $b1c6e3a850a3c735$var$nn, l = this.ss(e, o, n[c % a], r), E = this._s(e, o, i[c % a], s), h = _.map((t)=>this.ss(e, o, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, E, h));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ ss(e, t, n, r) {
        const i = new $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry(e, $b1c6e3a850a3c735$export$90a7f3efeed30595.empty(), t, n);
        return r ? i : i.Li();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ _s(e, t, n, r) {
        const i = new $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry(e, $b1c6e3a850a3c735$export$90a7f3efeed30595.empty(), t, n);
        return r ? i.Li() : i;
    }
    Xi(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.Wi(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.Zi(t);
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(r, (t)=>this.Xi(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$b9a6b53f9be3734.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ us(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_IndexByteEncoder;
        for (const r of $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Ci(r.kind);
            $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, i);
        }
        return n.Di();
    }
    /** Encodes a single value to the ascending index format. */ rs(e) {
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_IndexByteEncoder;
        return $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, t.Ci(0 /* IndexKind.ASCENDING */ )), t.Di();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ cs(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_IndexByteEncoder;
        return $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter.Ei.Yr($b1c6e3a850a3c735$export$43caf9889c228507(this.databaseId, t), n.Ci(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Di();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ ts(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new $b1c6e3a850a3c735$var$__PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.ls(t, s.fieldPath) && $b1c6e3a850a3c735$var$isArray(e)) r = this.Es(r, s, e);
            else {
                const t = n.Ci(s.kind);
                $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, t);
            }
        }
        return this.hs(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ es(e, t, n) {
        return this.ts(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ hs(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Di();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Es(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new $b1c6e3a850a3c735$var$__PRIVATE_IndexByteEncoder;
            r.seed(n.Di()), $b1c6e3a850a3c735$var$__PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, r.Ci(t.kind)), i.push(r);
        }
        return i;
    }
    ls(e, t) {
        return !!e.filters.find((e)=>e instanceof $b1c6e3a850a3c735$export$23f2a1d2818174ef && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_indexConfigurationStore(e), r = $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e);
        return (t ? n.H($b1c6e3a850a3c735$var$ve, IDBKeyRange.bound(t, t)) : n.H()).next((e)=>{
            const t = [];
            return $b1c6e3a850a3c735$var$PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new $b1c6e3a850a3c735$export$21579262ef46735b(t.sequenceNumber, new $b1c6e3a850a3c735$var$IndexOffset($b1c6e3a850a3c735$var$__PRIVATE_fromDbTimestamp(t.readTime), new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : $b1c6e3a850a3c735$export$21579262ef46735b.empty(), r = e.fields.map(([e, t])=>new $b1c6e3a850a3c735$export$f38c853ae54ed474($b1c6e3a850a3c735$export$b9a6b53f9be3734.fromServerFormat(e), t));
                        return new $b1c6e3a850a3c735$export$3b513254972cfc9c(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_indexConfigurationStore(e), i = $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e);
        return this.Ts(e).next((e)=>r.H($b1c6e3a850a3c735$var$ve, IDBKeyRange.bound(t, t)).next((t)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t)=>i.put($b1c6e3a850a3c735$var$__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), $b1c6e3a850a3c735$var$PersistencePromise.forEach(i, (n)=>this.Ps(e, t, n).next((t)=>{
                        const i = this.Rs(r, n);
                        return t.isEqual(i) ? $b1c6e3a850a3c735$var$PersistencePromise.resolve() : this.Is(e, r, n, t, i);
                    }))));
        });
    }
    As(e, t, n, r) {
        return $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e).put(r.Bi(this.uid, this.cs(n, t.key), t.key));
    }
    Vs(e, t, n, r) {
        return $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e).delete(r.Ui(this.uid, this.cs(n, t.key), t.key));
    }
    Ps(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e);
        let i = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator);
        return r.ee({
            index: $b1c6e3a850a3c735$var$Ne,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                $b1c6e3a850a3c735$var$__PRIVATE_encodeKeySafeBytes(this.cs(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry(n.indexId, t, $b1c6e3a850a3c735$var$__PRIVATE_decodeKeySafeBytes(r.arrayValue), $b1c6e3a850a3c735$var$__PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Rs(e, t) {
        let n = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator);
        const r = this.us(t, e);
        if (null == r) return n;
        const i = $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if ($b1c6e3a850a3c735$var$isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry(t.indexId, e.key, this.rs(i), r));
        } else n = n.add(new $b1c6e3a850a3c735$var$__PRIVATE_IndexEntry(t.indexId, e.key, $b1c6e3a850a3c735$var$nn, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ Is(e, t, n, r, i) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$tn, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), _ = t.getIterator();
            let o = $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(s), a = $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(_);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; o || a;){
                let e = !1, t = !1;
                if (o && a) {
                    const r = n(o, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != o ? t = !0 : e = !0;
                e ? (r(a), a = $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(_)) : t ? (i(o), o = $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(s)) : (o = $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(s), a = $b1c6e3a850a3c735$var$__PRIVATE_advanceIterator(_));
            }
        }(r, i, $b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.As(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Vs(e, t, n, r));
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(s);
    }
    Ts(e) {
        let t = 1;
        return $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e).ee({
            index: $b1c6e3a850a3c735$var$Ce,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== $b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = $b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator(i, e), s = $b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.Li();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.Li());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.ds(r[e], r[e + 1])) return [];
            const t = r[e].Ui(this.uid, $b1c6e3a850a3c735$var$nn, $b1c6e3a850a3c735$export$90a7f3efeed30595.empty()), n = r[e + 1].Ui(this.uid, $b1c6e3a850a3c735$var$nn, $b1c6e3a850a3c735$export$90a7f3efeed30595.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    ds(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return $b1c6e3a850a3c735$var$__PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next($b1c6e3a850a3c735$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.mapArray(this.Zi(t), (t)=>this.Xi(e, t).next((e)=>e || $b1c6e3a850a3c735$export$8743009a87fcb00f(44426))).next($b1c6e3a850a3c735$var$__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_collectionParentsStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$Ae);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_indexEntriesStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$Oe);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_indexConfigurationStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$we);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_indexStateStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$De);
}
function $b1c6e3a850a3c735$var$__PRIVATE_getMinOffsetFromFieldIndexes(e) {
    $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        $b1c6e3a850a3c735$var$__PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new $b1c6e3a850a3c735$var$IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function $b1c6e3a850a3c735$var$removeMutationBatch(e, t, n) {
    const r = e.store($b1c6e3a850a3c735$var$H), i = e.store($b1c6e3a850a3c735$var$ee), s = [], _ = IDBKeyRange.only(n.batchId);
    let o = 0;
    const a = r.ee({
        range: _
    }, (e, t, n)=>(o++, n.delete()));
    s.push(a.next(()=>{
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === o, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return $b1c6e3a850a3c735$var$PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.fs = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static jr(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).ee({
            index: $b1c6e3a850a3c735$var$Y,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e), s = $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((_)=>{
            $b1c6e3a850a3c735$var$__PRIVATE_hardAssert("number" == typeof _, 49019);
            const o = new $b1c6e3a850a3c735$var$MutationBatch(_, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>$b1c6e3a850a3c735$var$toMutation(e.zr, t)), i = n.mutations.map((t)=>$b1c6e3a850a3c735$var$toMutation(e.zr, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, o), u = [];
            let c = new $b1c6e3a850a3c735$var$SortedSet((e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, _);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, $b1c6e3a850a3c735$var$X));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.fs[_] = o.keys();
            }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(u).next(()=>o);
        });
    }
    lookupMutationBatch(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>e ? ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), $b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    ps(e, t) {
        return this.fs[t] ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.fs[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.fs[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).ee({
            index: $b1c6e3a850a3c735$var$Y,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                gs: n
            }), i = $b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $b1c6e3a850a3c735$var$$;
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).ee({
            index: $b1c6e3a850a3c735$var$Y,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $b1c6e3a850a3c735$var$$
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).H($b1c6e3a850a3c735$var$Y, t).next((e)=>e.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e).ee({
            range: r
        }, (n, r, s)=>{
            const [_, o, a] = n, u = $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(o);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (_ === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(61480, {
                    ys: n,
                    batchId: a
                });
                $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push($b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), _ = $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e).ee({
                range: s
            }, (e, r, i)=>{
                const [s, _, o] = e, a = $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(_);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(o) : i.done();
            });
            r.push(_);
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(r).next(()=>this.ws(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let _ = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
        return $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e).ee({
            range: s
        }, (e, t, i)=>{
            const [s, o, a] = e, u = $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(o);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (_ = _.add(a)) : i.done();
        }).next(()=>this.ws(e, _));
    }
    ws(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push($b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(35274, {
                    batchId: t
                });
                $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push($b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return $b1c6e3a850a3c735$var$removeMutationBatch(e.le, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.bs(t.batchId);
            }), $b1c6e3a850a3c735$var$PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    bs(e) {
        delete this.fs[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e).ee({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(0 === r.length, 56720, {
                    vs: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Ss(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $b1c6e3a850a3c735$var$$,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let _ = !1;
    return $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e).ee({
        range: s,
        X: !0
    }, (e, n, r)=>{
        const [s, o, /*batchID*/ a] = e;
        s === t && o === i && (_ = !0), r.done();
    }).next(()=>_);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mutationsStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$H);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_documentMutationsStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$ee);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_mutationQueuesStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$z);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator {
    constructor(e){
        this.Ds = e;
    }
    next() {
        return this.Ds += 2, this.Ds;
    }
    static xs() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator(0);
    }
    static Cs() {
        // Sync engine assigns target IDs for limbo document detection.
        return new $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Fs(e).next((t)=>{
            const n = new $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.Os(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Fs(e).next((e)=>$b1c6e3a850a3c735$var$SnapshotVersion.fromTimestamp(new $b1c6e3a850a3c735$export$890c4ad488842ce7(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.Fs(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.Fs(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.Os(e, r)));
    }
    addTargetData(e, t) {
        return this.Ms(e, t).next(()=>this.Fs(e).next((n)=>(n.targetCount += 1, this.Ns(t, n), this.Os(e, n))));
    }
    updateTargetData(e, t) {
        return this.Ms(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>$b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.Fs(e)).next((t)=>($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, this.Os(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return $b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e).ee((s, _)=>{
            const o = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTarget(this.serializer, _);
            o.sequenceNumber <= t && null === n.get(o.targetId) && (r++, i.push(this.removeTargetData(e, o)));
        }).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e).ee((e, n)=>{
            const r = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTarget(this.serializer, n);
            t(r);
        });
    }
    Fs(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_globalTargetStore(e).get($b1c6e3a850a3c735$var$Re).next((e)=>($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(null !== e, 2888), e));
    }
    Os(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_globalTargetStore(e).put($b1c6e3a850a3c735$var$Re, t);
    }
    Ms(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e).put($b1c6e3a850a3c735$var$__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Ns(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.Fs(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = $b1c6e3a850a3c735$var$__PRIVATE_canonifyTargetOrPipeline(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return $b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e).ee({
            range: r,
            index: $b1c6e3a850a3c735$var$ce
        }, (e, n, r)=>{
            const s = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTarget(this.serializer, n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            $b1c6e3a850a3c735$var$__PRIVATE_targetOrPipelineEqual(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e);
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t)=>{
            const i = $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t.path);
            return $b1c6e3a850a3c735$var$PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e);
        let i = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        return r.ee({
            range: n,
            X: !0
        }, (e, t, n)=>{
            const r = $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(e[1]), s = new $b1c6e3a850a3c735$export$90a7f3efeed30595(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            $b1c6e3a850a3c735$var$__PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e).ee({
            index: $b1c6e3a850a3c735$var$Te,
            X: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    dt(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e).get(t).next((e)=>e ? $b1c6e3a850a3c735$var$__PRIVATE_fromDbTarget(this.serializer, e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_targetsStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$ue);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_globalTargetStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$Ie);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$Ee);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = $b1c6e3a850a3c735$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    lr(e) {
        const t = this.Ls(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Ls(e) {
        let t = 0;
        return this.Er(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    Er(e, t) {
        return this.Bs(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return $b1c6e3a850a3c735$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return $b1c6e3a850a3c735$var$__PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Us(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return $b1c6e3a850a3c735$var$__PRIVATE_mutationQueuesStore(e).te((r)=>$b1c6e3a850a3c735$var$__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), $b1c6e3a850a3c735$var$PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.Bs(e, (s, _)=>{
            if (_ <= t) {
                const t = this.Us(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, $b1c6e3a850a3c735$var$SnapshotVersion.min()), $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Bs(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e);
        let r, i = $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce;
        return n.ee({
            index: $b1c6e3a850a3c735$var$Te
        }, ([e, n], { path: s, sequenceNumber: _ })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce && t(new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = _, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce && t(new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_writeSentinelKey(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
// Copyright 2024 Google LLC* @license
function $b1c6e3a850a3c735$var$__PRIVATE_runPipeline(e, t) {
    let n = t;
    for (const t of e.stages)n = $b1c6e3a850a3c735$var$evaluate({
        serializer: e.serializer,
        serverTimestampBehavior: e.listenOptions?.serverTimestampBehavior
    }, t, n);
    return n;
}
function $b1c6e3a850a3c735$var$__PRIVATE_pipelineMatches(e, t) {
    // TODO(pipeline): this is not true for aggregations, and we need to examine if there are other
    // stages that will not work this way.
    return $b1c6e3a850a3c735$var$__PRIVATE_runPipeline(e, [
        t
    ]).length > 0;
}
function $b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineMatches(e, t) {
    return $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) ? $b1c6e3a850a3c735$var$__PRIVATE_pipelineMatches(e, t) : $b1c6e3a850a3c735$var$__PRIVATE_queryMatches(e, t);
}
function $b1c6e3a850a3c735$var$evaluate(e, t, n) {
    if (t instanceof $b1c6e3a850a3c735$export$7f557e5eb95176c2) return function __PRIVATE_evaluateCollection(e, t, n) {
        return n.filter((e)=>e.isFoundDocument() && `/${e.key.getCollectionPath().canonicalString()}` === t.Vr);
    }(0, t, n);
    if (t instanceof $b1c6e3a850a3c735$export$4e222d082f82ee97) return function __PRIVATE_evaluateWhere(e, t, n) {
        return n.filter((n)=>{
            const r = $b1c6e3a850a3c735$var$__PRIVATE_valueOrUndefined($b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(t.condition).evaluate(e, n));
            return void 0 !== r && $b1c6e3a850a3c735$var$__PRIVATE_valueEquals$1(r, $b1c6e3a850a3c735$var$Et);
        });
    }(e, t, n);
    if (t instanceof $b1c6e3a850a3c735$export$51b138e5a065c2bb) return function __PRIVATE_evaluateCollectionGroup(e, t, n) {
        // return those records in input whose collection id is stage.collectionId
        return n.filter((e)=>e.isFoundDocument() && e.key.getCollectionPath().lastSegment() === t.collectionId);
    }(0, t, n);
    if (t instanceof $b1c6e3a850a3c735$export$6dabbe08653f866f) return function __PRIVATE_evaluateDatabase(e, t, n) {
        return n.filter((e)=>e.isFoundDocument());
    }(0, 0, n);
    if (t instanceof $b1c6e3a850a3c735$export$151db275011178c4) return function __PRIVATE_evaluateDocuments(e, t, n) {
        return n.filter((e)=>e.isFoundDocument() && t.mr.has(e.key.path.toStringWithLeadingSlash()));
    }(0, t, n);
    if (t instanceof $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb) return function __PRIVATE_evaluateLimit(e, t, n) {
        return n.slice(0, t.limit);
    }(0, t, n);
    if (t instanceof $b1c6e3a850a3c735$export$60bb826a6acf3081) return function __PRIVATE_evaluateSort(e, t, n) {
        const r = t.orderings.map((e)=>({
                ks: $b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(e.expr),
                direction: e.direction
            }));
        return [
            ...n
        ].sort((t, n)=>{
            // Evaluate expressions in stage.orderings against left and right, and use them to compare
            // the documents
            for (const { ks: i, direction: s } of r){
                const r = $b1c6e3a850a3c735$var$__PRIVATE_valueOrUndefined(i.evaluate(e, t)), _ = $b1c6e3a850a3c735$var$__PRIVATE_valueOrUndefined(i.evaluate(e, n)), o = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(r ?? $b1c6e3a850a3c735$var$lt, _ ?? $b1c6e3a850a3c735$var$lt);
                if (0 !== o) // Return the comparison result if documents are not equal
                return "ascending" === s ? o : -o;
            }
            return 0;
        });
    }(e, t, n);
    throw new Error(`Unknown stage: ${t._name}`);
}
function $b1c6e3a850a3c735$export$56c0d5a1e737357d(e) {
    const t = function __PRIVATE_lastEffectiveSort(e) {
        // return the last sort stage, throws exception if it doesn't exist
        // TODO(pipeline): this implementation is wrong, there are stages that can invalidate
        // the orderings later. The proper way to manipulate the pipeline so that last Sort
        // always has effects.
        for(let t = e.stages.length - 1; t >= 0; t--){
            const n = e.stages[t];
            if (n instanceof $b1c6e3a850a3c735$export$60bb826a6acf3081) return n.orderings;
        }
        throw new Error("Pipeline must contain at least one Sort stage");
    }(e);
    return (n, r)=>{
        for (const i of t){
            // TODO(pipeline): consider the possibility of memoizing the evaluation
            const t = $b1c6e3a850a3c735$var$__PRIVATE_valueOrUndefined($b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(i.expr).evaluate({
                serializer: e.serializer
            }, n)), s = $b1c6e3a850a3c735$var$__PRIVATE_valueOrUndefined($b1c6e3a850a3c735$var$__PRIVATE_toEvaluable(i.expr).evaluate({
                serializer: e.serializer
            }, r)), _ = $b1c6e3a850a3c735$var$__PRIVATE_valueCompare(t || $b1c6e3a850a3c735$var$lt, s || $b1c6e3a850a3c735$var$lt);
            if (0 !== _) return "ascending" === i.direction ? _ : -_;
        }
        return 0;
    };
}
function $b1c6e3a850a3c735$var$__PRIVATE_getLastEffectiveLimit(e) {
    // TODO(pipeline): Consider other stages that might imply a limit,
    // e.g., FindNearestStage, once they are implemented.
    for(let t = e.stages.length - 1; t >= 0; t--){
        const n = e.stages[t];
        if (n instanceof $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb) return {
            limit: n.limit
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class $b1c6e3a850a3c735$var$RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new $b1c6e3a850a3c735$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.qs(e, n)));
    }
    getEntry(e, t) {
        let n = $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(t);
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $b1c6e3a850a3c735$var$re,
            range: IDBKeyRange.only($b1c6e3a850a3c735$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.$s(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Ks(e, t) {
        let n = {
            size: 0,
            document: $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(t)
        };
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $b1c6e3a850a3c735$var$re,
            range: IDBKeyRange.only($b1c6e3a850a3c735$var$__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.$s(t, r),
                size: $b1c6e3a850a3c735$var$__PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        return this.Ws(e, t, (e, t)=>{
            const r = this.$s(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    getAllEntries(e) {
        let t = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).ee((e, n)=>{
            const r = this.$s($b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(n.prefixPath.concat(n.collectionGroup, n.documentId)), n);
            t = t.insert(r.key, r);
        }).next(()=>t);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Qs(e, t) {
        let n = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), r = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
        return this.Ws(e, t, (e, t)=>{
            const i = this.$s(e, t);
            n = n.insert(e, i), r = r.insert(e, $b1c6e3a850a3c735$var$__PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Gs: r
            }));
    }
    Ws(e, t, n) {
        if (t.isEmpty()) return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
        let r = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound($b1c6e3a850a3c735$var$__PRIVATE_dbKey(r.first()), $b1c6e3a850a3c735$var$__PRIVATE_dbKey(r.last())), s = r.getIterator();
        let _ = s.getNext();
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $b1c6e3a850a3c735$var$re,
            range: i
        }, (e, t, r)=>{
            const i = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; _ && $b1c6e3a850a3c735$var$__PRIVATE_dbKeyComparator(_, i) < 0;)n(_, null), _ = s.getNext();
            _ && _.isEqual(i) && // Key found in cache.
            (n(_, t), _ = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            _ ? r.j($b1c6e3a850a3c735$var$__PRIVATE_dbKey(_)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; _;)n(_, null), _ = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = $b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? $b1c6e3a850a3c735$export$db202ddc8be9136.fromString($b1c6e3a850a3c735$var$getPipelineCollection(t)) : t.path, _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], o = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).H(IDBKeyRange.bound(_, o, !0)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.$s($b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && ($b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        const s = $b1c6e3a850a3c735$var$__PRIVATE_dbCollectionGroupKey(t, n), _ = $b1c6e3a850a3c735$var$__PRIVATE_dbCollectionGroupKey(t, $b1c6e3a850a3c735$var$IndexOffset.max());
        return $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e).ee({
            index: $b1c6e3a850a3c735$var$se,
            range: IDBKeyRange.bound(s, _, !0)
        }, (e, t, n)=>{
            const s = this.$s($b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_documentGlobalStore(e).get($b1c6e3a850a3c735$var$ae).next((e)=>($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!e, 20021), e));
    }
    qs(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_documentGlobalStore(e).put($b1c6e3a850a3c735$var$ae, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ $s(e, t) {
        if (t) {
            const e = $b1c6e3a850a3c735$var$__PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min()))) return e;
        }
        return $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function $b1c6e3a850a3c735$var$__PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends $b1c6e3a850a3c735$var$RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.zs = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.js = new $b1c6e3a850a3c735$var$ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new $b1c6e3a850a3c735$var$SortedSet((e, t)=>$b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const _ = this.js.get(i);
            if (t.push(this.zs.removeEntry(e, i, _.readTime)), s.isValidDocument()) {
                const o = $b1c6e3a850a3c735$var$__PRIVATE_toDbRemoteDocument(this.zs.serializer, s);
                r = r.add(i.path.popLast());
                const a = $b1c6e3a850a3c735$var$__PRIVATE_dbDocumentSize(o);
                n += a - _.size, t.push(this.zs.addEntry(e, i, o));
            } else if (n -= _.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = $b1c6e3a850a3c735$var$__PRIVATE_toDbRemoteDocument(this.zs.serializer, s.convertToNoDocument($b1c6e3a850a3c735$var$SnapshotVersion.min()));
                t.push(this.zs.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.zs.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.zs.updateMetadata(e, n)), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.zs.Ks(e, t).next((e)=>(this.js.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.zs.Qs(e, t).next(({ documents: e, Gs: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.js.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_documentGlobalStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$oe);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_remoteDocumentsStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$te);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function $b1c6e3a850a3c735$var$__PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        $b1c6e3a850a3c735$var$__PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n.length, r.length), i || (i = $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class $b1c6e3a850a3c735$var$OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class $b1c6e3a850a3c735$var$LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToLocalView(n.mutation, e, $b1c6e3a850a3c735$var$FieldMask.empty(), $b1c6e3a850a3c735$export$890c4ad488842ce7.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, $b1c6e3a850a3c735$export$78acf4525d8a74c4()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = $b1c6e3a850a3c735$export$78acf4525d8a74c4()) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = $b1c6e3a850a3c735$var$documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, $b1c6e3a850a3c735$export$78acf4525d8a74c4()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        const s = $b1c6e3a850a3c735$var$__PRIVATE_newDocumentKeyMap(), _ = function __PRIVATE_newOverlayedDocumentMap() {
            return $b1c6e3a850a3c735$var$__PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const _ = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === _ || _.mutation instanceof $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== _ ? (s.set(t.key, _.mutation.getFieldMask()), $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToLocalView(_.mutation, t, _.mutation.getFieldMask(), $b1c6e3a850a3c735$export$890c4ad488842ce7.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, $b1c6e3a850a3c735$var$FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>_.set(e, new $b1c6e3a850a3c735$var$OverlayedDocument(t, s.get(e) ?? null))), _));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new $b1c6e3a850a3c735$var$SortedMap((e, t)=>e - t), i = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let _ = n.get(e) || $b1c6e3a850a3c735$var$FieldMask.empty();
                _ = i.applyToLocalView(s, _), n.set(e, _);
                const o = (r.get(i.batchId) || $b1c6e3a850a3c735$export$78acf4525d8a74c4()).add(e);
                r = r.insert(i.batchId, o);
            });
        }).next(()=>{
            const s = [], _ = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; _.hasNext();){
                const r = _.getNext(), o = r.key, a = r.value, u = $b1c6e3a850a3c735$var$__PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = $b1c6e3a850a3c735$var$__PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, o, u));
            }
            return $b1c6e3a850a3c735$var$PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        return $b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? this.getDocumentsMatchingPipeline(e, t, n, r) : $b1c6e3a850a3c735$var$__PRIVATE_isDocumentQuery$1(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : $b1c6e3a850a3c735$export$3b14a55fb2447963(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : $b1c6e3a850a3c735$var$PersistencePromise.resolve($b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let _ = $b1c6e3a850a3c735$var$L, o = i;
            return s.next((t)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t, n)=>(_ < n.largestBatchId && (_ = n.largestBatchId), i.get(t) ? $b1c6e3a850a3c735$var$PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        o = o.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, o, t, $b1c6e3a850a3c735$export$78acf4525d8a74c4())).next((e)=>({
                        batchId: _,
                        changes: $b1c6e3a850a3c735$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new $b1c6e3a850a3c735$export$90a7f3efeed30595(t)).next((e)=>{
            let t = $b1c6e3a850a3c735$var$documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = $b1c6e3a850a3c735$var$documentMap();
        return this.indexManager.getCollectionParents(e, i).next((_)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(_, (_)=>{
                const o = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new $b1c6e3a850a3c735$var$__PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, _.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, o, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>this.retrieveMatchingLocalDocuments(i, e, (e)=>$b1c6e3a850a3c735$var$__PRIVATE_queryMatches(t, e)));
    }
    getDocumentsMatchingPipeline(e, t, n, r) {
        if ("collection_group" === $b1c6e3a850a3c735$var$getPipelineSourceType(t)) {
            const i = $b1c6e3a850a3c735$var$getPipelineCollectionGroup(t);
            let s = $b1c6e3a850a3c735$var$documentMap();
            return this.indexManager.getCollectionParents(e, i).next((_)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(_, (_)=>{
                    const o = function __PRIVATE_asCollectionPipelineAtPath(e, t) {
                        const n = e.stages.map((e)=>e instanceof $b1c6e3a850a3c735$export$51b138e5a065c2bb ? new $b1c6e3a850a3c735$export$7f557e5eb95176c2(t.canonicalString(), {}) : e);
                        return new $b1c6e3a850a3c735$var$CorePipeline(e.serializer, n);
                    }(t, _.child(i));
                    return this.getDocumentsMatchingPipeline(e, o, n, r).next((e)=>{
                        e.forEach((e, t)=>{
                            s = s.insert(e, t);
                        });
                    });
                }).next(()=>s));
        }
        {
            // Query the remote documents and overlay mutations.
            let i;
            return this.getOverlaysForPipeline(e, t, n.largestBatchId).next((s)=>{
                switch(i = s, $b1c6e3a850a3c735$var$getPipelineSourceType(t)){
                    case "collection":
                        return this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r);
                    case "documents":
                        let s1 = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
                        for (const e of $b1c6e3a850a3c735$var$getPipelineDocuments(t))s1 = s1.add($b1c6e3a850a3c735$export$90a7f3efeed30595.fromPath(e));
                        return this.remoteDocumentCache.getEntries(e, s1);
                    case "database":
                        return this.remoteDocumentCache.getAllEntries(e);
                    default:
                        throw new $b1c6e3a850a3c735$export$4368d992c4eafac0("invalid-argument", `Invalid pipeline source to execute offline: ${$b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(t)}`);
                }
            }).next((e)=>this.retrieveMatchingLocalDocuments(i, e, (e)=>$b1c6e3a850a3c735$var$__PRIVATE_pipelineMatches(t, e)));
        }
    }
    retrieveMatchingLocalDocuments(e, t, n) {
        // As documents might match the query because of their overlay we need to
        // include documents for all overlays in the initial document set.
        e.forEach((e, n)=>{
            const r = n.getKey();
            null === t.get(r) && (t = t.insert(r, $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(r)));
        });
        // Apply the overlays and match against the query.
        let r = $b1c6e3a850a3c735$var$documentMap();
        return t.forEach((t, i)=>{
            const s = e.get(t);
            void 0 !== s && $b1c6e3a850a3c735$var$__PRIVATE_mutationApplyToLocalView(s.mutation, i, $b1c6e3a850a3c735$var$FieldMask.empty(), $b1c6e3a850a3c735$export$890c4ad488842ce7.now()), // Finally, insert the documents that still match the query
            n(i) && (r = r.insert(t, i));
        }), r;
    }
    getOverlaysForPipeline(e, t, n) {
        switch($b1c6e3a850a3c735$var$getPipelineSourceType(t)){
            case "collection":
                return this.documentOverlayCache.getOverlaysForCollection(e, $b1c6e3a850a3c735$export$db202ddc8be9136.fromString($b1c6e3a850a3c735$var$getPipelineCollection(t)), n);
            case "collection_group":
                throw new $b1c6e3a850a3c735$export$4368d992c4eafac0("invalid-argument", `Unexpected collection group pipeline: ${$b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(t)}`);
            case "documents":
                return this.documentOverlayCache.getOverlays(e, $b1c6e3a850a3c735$var$getPipelineDocuments(t).map((e)=>$b1c6e3a850a3c735$export$90a7f3efeed30595.fromPath(e)));
            case "database":
                return this.documentOverlayCache.getAllOverlays(e, n);
            default:
                throw new $b1c6e3a850a3c735$export$4368d992c4eafac0("invalid-argument", `Failed to get overlays for pipeline: ${$b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(t)}`);
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Hs = new Map, this.Js = new Map;
    }
    getBundleMetadata(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.Hs.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Hs.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.createTime)
            };
        }(t)), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.Js.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Js.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: $b1c6e3a850a3c735$export$3a6d5c9ae78a2c08(e.bundledQuery),
                readTime: $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e.readTime)
            };
        }(t)), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator), this.Ys = new Map;
    }
    getOverlay(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    getAllOverlays(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap();
        return this.overlays.forEach((e, r)=>{
            r.largestBatchId > t && n.set(e, r);
        }), $b1c6e3a850a3c735$var$PersistencePromise.resolve(n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.Hr(e, t, r);
        }), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Ys.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Ys.delete(n)), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap(), i = t.length + 1, s = new $b1c6e3a850a3c735$export$90a7f3efeed30595(t.child("")), _ = this.overlays.getIteratorFrom(s);
        for(; _.hasNext();){
            const e = _.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new $b1c6e3a850a3c735$var$SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const _ = $b1c6e3a850a3c735$var$__PRIVATE_newOverlayMap(), o = i.getIterator();
        for(; o.hasNext();){
            if (o.getNext().value.forEach((e, t)=>_.set(e, t)), _.size() >= r) break;
        }
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(_);
    }
    Hr(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Ys.get(r.largestBatchId).delete(n.key);
            this.Ys.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new $b1c6e3a850a3c735$var$Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Ys.get(t);
        void 0 === i && (i = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), this.Ys.set(t, i)), this.Ys.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = $b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Zs = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_DocReference.Xs), // A set of outstanding references to a document sorted by target id.
        this.e_ = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_DocReference.t_);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Zs.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(e, t);
        this.Zs = this.Zs.add(n), this.e_ = this.e_.add(n);
    }
    /** Add references to the given document keys for the given ID. */ n_(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.r_(new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(e, t));
    }
    i_(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ s_(e) {
        const t = new $b1c6e3a850a3c735$export$90a7f3efeed30595(new $b1c6e3a850a3c735$export$db202ddc8be9136([])), n = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, e), r = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, e + 1), i = [];
        return this.e_.forEachInRange([
            n,
            r
        ], (e)=>{
            this.r_(e), i.push(e.key);
        }), i;
    }
    __() {
        this.Zs.forEach((e)=>this.r_(e));
    }
    r_(e) {
        this.Zs = this.Zs.delete(e), this.e_ = this.e_.delete(e);
    }
    o_(e) {
        const t = new $b1c6e3a850a3c735$export$90a7f3efeed30595(new $b1c6e3a850a3c735$export$db202ddc8be9136([])), n = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, e), r = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, e + 1);
        let i = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        return this.e_.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(e, 0), n = this.Zs.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.a_ = t;
    }
    /** Compare by key then by ID */ static Xs(e, t) {
        return $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.key, t.key) || $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.a_, t.a_);
    }
    /** Compare by ID then by key */ static t_(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator(e.a_, t.a_) || $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.gs = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.u_ = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_DocReference.Xs);
    }
    checkEmpty(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.gs;
        this.gs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new $b1c6e3a850a3c735$var$MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.u_ = this.u_.add(new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.c_(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.l_(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(0 === this.mutationQueue.length ? $b1c6e3a850a3c735$var$$ : this.gs - 1);
    }
    getAllMutationBatches(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, 0), r = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.u_.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.c_(e.a_);
            i.push(t);
        }), $b1c6e3a850a3c735$var$PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(e, 0), r = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.u_.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.a_);
            });
        }), $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.E_(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        $b1c6e3a850a3c735$export$90a7f3efeed30595.isDocumentKey(i) || (i = i.child(""));
        const s = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(new $b1c6e3a850a3c735$export$90a7f3efeed30595(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let _ = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
        return this.u_.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (_ = _.add(e.a_)), !0);
        }, s), $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.E_(_));
    }
    E_(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.c_(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(0 === this.h_(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.u_;
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.u_ = n;
        });
    }
    bs(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_DocReference(t, 0), r = this.u_.firstAfterOrEqual(n);
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ h_(e, t) {
        return this.l_(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ l_(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ c_(e) {
        const t = this.l_(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.T_ = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.T_(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(n ? n.document.mutableCopy() : $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : $b1c6e3a850a3c735$var$MutableDocument.newInvalidDocument(e));
        }), $b1c6e3a850a3c735$var$PersistencePromise.resolve(n);
    }
    getAllEntries(e) {
        let t = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        return this.docs.forEach((e, n)=>{
            t = t.insert(e, n.document);
        }), $b1c6e3a850a3c735$var$PersistencePromise.resolve(t);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        let i, s;
        $b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        (i = $b1c6e3a850a3c735$export$db202ddc8be9136.fromString($b1c6e3a850a3c735$var$getPipelineCollection(t)), s = (e)=>$b1c6e3a850a3c735$var$__PRIVATE_pipelineMatches(t, e)) : // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        (i = t.path, s = (e)=>$b1c6e3a850a3c735$var$__PRIVATE_queryMatches(t, e));
        let _ = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        const o = new $b1c6e3a850a3c735$export$90a7f3efeed30595(i.child("__id-9223372036854775808__")), a = this.docs.getIteratorFrom(o);
        for(; a.hasNext();){
            const { key: e, value: { document: t } } = a.getNext();
            if (!i.isPrefixOf(e.path)) break;
            e.path.length > i.length + 1 || $b1c6e3a850a3c735$var$__PRIVATE_indexOffsetComparator($b1c6e3a850a3c735$var$__PRIVATE_newIndexOffsetFromDocument(t), n) <= 0 || (r.has(t.key) || s(t)) && (_ = _.insert(t.key, t.mutableCopy()));
        }
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(_);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        $b1c6e3a850a3c735$export$8743009a87fcb00f(9500);
    }
    P_(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryRemoteDocumentChangeBuffer extends $b1c6e3a850a3c735$var$RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.zs = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.zs.addEntry(e, r)) : this.zs.removeEntry(n);
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.zs.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.zs.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.R_ = new $b1c6e3a850a3c735$var$ObjectMap((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyTargetOrPipeline(e), $b1c6e3a850a3c735$var$__PRIVATE_targetOrPipelineEqual), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = $b1c6e3a850a3c735$var$SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.I_ = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.A_ = new $b1c6e3a850a3c735$var$__PRIVATE_ReferenceSet, this.targetCount = 0, this.V_ = $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator.xs();
    }
    forEachTarget(e, t) {
        return this.R_.forEach((e, n)=>t(n)), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.I_);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.V_.next(), $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.I_ && (this.I_ = t), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    Ms(e) {
        this.R_.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.V_ = new $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.I_ && (this.I_ = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Ms(t), this.targetCount += 1, $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Ms(t), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.R_.delete(t.target), this.A_.s_(t.targetId), this.targetCount -= 1, $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.R_.forEach((s, _)=>{
            _.sequenceNumber <= t && null === n.get(_.targetId) && (this.R_.delete(s), i.push(this.removeMatchingKeysForTargetId(e, _.targetId)), r++);
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.R_.get(t) || null;
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.A_.n_(t, n), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.A_.i_(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), $b1c6e3a850a3c735$var$PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.A_.s_(t), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.A_.o_(t);
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(this.A_.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.d_ = {}, this.overlays = {}, this.f_ = new $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence(0), this.m_ = !1, this.m_ = !0, this.p_ = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.g_ = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryTargetCache(this);
        this.indexManager = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new $b1c6e3a850a3c735$var$__PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.y_(e)), this.serializer = new $b1c6e3a850a3c735$var$__PRIVATE_LocalSerializer(t), this.w_ = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.m_ = !1, Promise.resolve();
    }
    get started() {
        return this.m_;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.d_[e.toKey()];
        return n || (n = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.d_[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.p_;
    }
    getTargetCache() {
        return this.g_;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.w_;
    }
    runTransaction(e, t, n) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2("MemoryPersistence", "Starting transaction:", e);
        const r = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryTransaction(this.f_.next());
        return this.referenceDelegate.b_(), n(r).next((e)=>this.referenceDelegate.v_(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    S_(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.or(Object.values(this.d_).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_MemoryTransaction extends $b1c6e3a850a3c735$var$PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.D_ = new $b1c6e3a850a3c735$var$__PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.x_ = null;
    }
    static C_(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemoryEagerDelegate(e);
    }
    get F_() {
        if (this.x_) return this.x_;
        throw $b1c6e3a850a3c735$export$8743009a87fcb00f(60996);
    }
    addReference(e, t, n) {
        return this.D_.addReference(n, t), this.F_.delete(n.toString()), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.D_.removeReference(n, t), this.F_.add(n.toString()), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.F_.add(t.toString()), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.D_.s_(t.targetId).forEach((e)=>this.F_.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.F_.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    b_() {
        this.x_ = new Set;
    }
    v_(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(this.F_, (n)=>{
            const r = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromPath(n);
            return this.O_(e, r).next((e)=>{
                e || t.removeEntry(r, $b1c6e3a850a3c735$var$SnapshotVersion.min());
            });
        }).next(()=>(this.x_ = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.O_(e, t).next((e)=>{
            e ? this.F_.delete(t.toString()) : this.F_.add(t.toString());
        });
    }
    y_(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    O_(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.or([
            ()=>$b1c6e3a850a3c735$var$PersistencePromise.resolve(this.D_.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.S_(e, t)
        ]);
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.M_ = new $b1c6e3a850a3c735$var$ObjectMap((e)=>$b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = $b1c6e3a850a3c735$var$__PRIVATE_newLruGarbageCollector(this, t);
    }
    static C_(e, t) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    b_() {}
    v_(e) {
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    lr(e) {
        const t = this.Ls(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Ls(e) {
        let t = 0;
        return this.Er(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    Er(e, t) {
        return $b1c6e3a850a3c735$var$PersistencePromise.forEach(this.M_, (n, r)=>this.Us(e, n, r).next((e)=>e ? $b1c6e3a850a3c735$var$PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.P_(e, (r)=>this.Us(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, $b1c6e3a850a3c735$var$SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.M_.set(t, e.currentSequenceNumber), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.M_.set(n, e.currentSequenceNumber), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.M_.set(n, e.currentSequenceNumber), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.M_.set(t, e.currentSequenceNumber), $b1c6e3a850a3c735$var$PersistencePromise.resolve();
    }
    y_(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += $b1c6e3a850a3c735$var$__PRIVATE_estimateByteSize(e.data.value)), t;
    }
    Us(e, t, n) {
        return $b1c6e3a850a3c735$var$PersistencePromise.or([
            ()=>this.persistence.S_(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.M_.get(t);
                return $b1c6e3a850a3c735$var$PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class $b1c6e3a850a3c735$var$__PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ U(e, t, n, r) {
        const i = new $b1c6e3a850a3c735$var$__PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore($b1c6e3a850a3c735$var$Q);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore($b1c6e3a850a3c735$var$z, {
                keyPath: $b1c6e3a850a3c735$var$j
            });
            const t = e.createObjectStore($b1c6e3a850a3c735$var$H, {
                keyPath: $b1c6e3a850a3c735$var$J,
                autoIncrement: !0
            });
            t.createIndex($b1c6e3a850a3c735$var$Y, $b1c6e3a850a3c735$var$Z, {
                unique: !0
            }), e.createObjectStore($b1c6e3a850a3c735$var$ee);
        }(e), $b1c6e3a850a3c735$var$__PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore($b1c6e3a850a3c735$var$W);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = $b1c6e3a850a3c735$var$PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore($b1c6e3a850a3c735$var$Ee), e.deleteObjectStore($b1c6e3a850a3c735$var$ue), e.deleteObjectStore($b1c6e3a850a3c735$var$Ie);
        }(e), $b1c6e3a850a3c735$var$__PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store($b1c6e3a850a3c735$var$Ie), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: $b1c6e3a850a3c735$var$SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put($b1c6e3a850a3c735$var$Re, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store($b1c6e3a850a3c735$var$H);
                return n.H().next((n)=>{
                    e.deleteObjectStore($b1c6e3a850a3c735$var$H);
                    e.createObjectStore($b1c6e3a850a3c735$var$H, {
                        keyPath: $b1c6e3a850a3c735$var$J,
                        autoIncrement: !0
                    }).createIndex($b1c6e3a850a3c735$var$Y, $b1c6e3a850a3c735$var$Z, {
                        unique: !0
                    });
                    const r = t.store($b1c6e3a850a3c735$var$H), i = n.map((e)=>r.put(e));
                    return $b1c6e3a850a3c735$var$PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore($b1c6e3a850a3c735$var$de, {
                    keyPath: $b1c6e3a850a3c735$var$fe
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.N_(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore($b1c6e3a850a3c735$var$oe);
            })(e), this.L_(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.B_(i))), n < 8 && r >= 8 && (s = s.next(()=>this.U_(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.k_(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore($b1c6e3a850a3c735$var$me, {
                    keyPath: $b1c6e3a850a3c735$var$pe
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore($b1c6e3a850a3c735$var$ge, {
                    keyPath: $b1c6e3a850a3c735$var$ye
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore($b1c6e3a850a3c735$var$Be, {
                    keyPath: $b1c6e3a850a3c735$var$Ue
                });
                t.createIndex($b1c6e3a850a3c735$var$ke, $b1c6e3a850a3c735$var$qe, {
                    unique: !1
                }), t.createIndex($b1c6e3a850a3c735$var$$e, $b1c6e3a850a3c735$var$Ke, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore($b1c6e3a850a3c735$var$te, {
                    keyPath: $b1c6e3a850a3c735$var$ne
                });
                t.createIndex($b1c6e3a850a3c735$var$re, $b1c6e3a850a3c735$var$ie), t.createIndex($b1c6e3a850a3c735$var$se, $b1c6e3a850a3c735$var$_e);
            })(e)).next(()=>this.q_(e, i)).next(()=>e.deleteObjectStore($b1c6e3a850a3c735$var$W))), n < 14 && r >= 14 && (s = s.next(()=>this.K_(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore($b1c6e3a850a3c735$var$we, {
                    keyPath: $b1c6e3a850a3c735$var$be,
                    autoIncrement: !0
                });
                t.createIndex($b1c6e3a850a3c735$var$ve, $b1c6e3a850a3c735$var$Se, {
                    unique: !1
                });
                const n = e.createObjectStore($b1c6e3a850a3c735$var$De, {
                    keyPath: $b1c6e3a850a3c735$var$xe
                });
                n.createIndex($b1c6e3a850a3c735$var$Ce, $b1c6e3a850a3c735$var$Fe, {
                    unique: !1
                });
                const r = e.createObjectStore($b1c6e3a850a3c735$var$Oe, {
                    keyPath: $b1c6e3a850a3c735$var$Me
                });
                r.createIndex($b1c6e3a850a3c735$var$Ne, $b1c6e3a850a3c735$var$Le, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore($b1c6e3a850a3c735$var$De).clear();
        }).next(()=>{
            t.objectStore($b1c6e3a850a3c735$var$Oe).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore($b1c6e3a850a3c735$var$We, {
                    keyPath: $b1c6e3a850a3c735$var$Qe
                });
            }(e);
        })), n < 18 && r >= 18 && (0, $029952e65115eee5$export$ef10bcfb06572016)() && (s = s.next(()=>{
            t.objectStore($b1c6e3a850a3c735$var$De).clear();
        }).next(()=>{
            t.objectStore($b1c6e3a850a3c735$var$Oe).clear();
        })), s;
    }
    L_(e) {
        let t = 0;
        return e.store($b1c6e3a850a3c735$var$W).ee((e, n)=>{
            t += $b1c6e3a850a3c735$var$__PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store($b1c6e3a850a3c735$var$oe).put($b1c6e3a850a3c735$var$ae, n);
        });
    }
    N_(e) {
        const t = e.store($b1c6e3a850a3c735$var$z), n = e.store($b1c6e3a850a3c735$var$H);
        return t.H().next((t)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $b1c6e3a850a3c735$var$$
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.H($b1c6e3a850a3c735$var$Y, r).next((n)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(n, (n)=>{
                        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = $b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return $b1c6e3a850a3c735$var$removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ B_(e) {
        const t = e.store($b1c6e3a850a3c735$var$Ee), n = e.store($b1c6e3a850a3c735$var$W);
        return e.store($b1c6e3a850a3c735$var$Ie).get($b1c6e3a850a3c735$var$Re).next((e)=>{
            const r = [];
            return n.ee((n, i)=>{
                const s = new $b1c6e3a850a3c735$export$db202ddc8be9136(n), _ = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(_).next((n)=>n ? $b1c6e3a850a3c735$var$PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.waitFor(r));
        });
    }
    U_(e, t) {
        // Create the index.
        e.createObjectStore($b1c6e3a850a3c735$var$Ae, {
            keyPath: $b1c6e3a850a3c735$var$Ve
        });
        const n = t.store($b1c6e3a850a3c735$var$Ae), r = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: $b1c6e3a850a3c735$var$__PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store($b1c6e3a850a3c735$var$W).ee({
            X: !0
        }, (e, t)=>{
            const n = new $b1c6e3a850a3c735$export$db202ddc8be9136(e);
            return addEntry(n.popLast());
        }).next(()=>t.store($b1c6e3a850a3c735$var$ee).ee({
                X: !0
            }, ([e, t, n], r)=>{
                const i = $b1c6e3a850a3c735$var$__PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    k_(e) {
        const t = e.store($b1c6e3a850a3c735$var$ue);
        return t.ee((e, n)=>{
            const r = $b1c6e3a850a3c735$var$__PRIVATE_fromDbTarget(this.serializer, n), i = $b1c6e3a850a3c735$var$__PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    q_(e, t) {
        const n = t.store($b1c6e3a850a3c735$var$W), r = [];
        return n.ee((e, n)=>{
            const i = t.store($b1c6e3a850a3c735$var$te), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(e.document.name).popFirst(5)) : e.noDocument ? $b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(e.noDocument.path) : e.unknownDocument ? $b1c6e3a850a3c735$export$90a7f3efeed30595.fromSegments(e.unknownDocument.path) : $b1c6e3a850a3c735$export$8743009a87fcb00f(36783);
            })(n).path.toArray(), _ = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(_));
        }).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.waitFor(r));
    }
    K_(e, t) {
        const n = t.store($b1c6e3a850a3c735$var$H), r = $b1c6e3a850a3c735$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new $b1c6e3a850a3c735$var$__PRIVATE_MemoryPersistence($b1c6e3a850a3c735$var$__PRIVATE_MemoryEagerDelegate.C_, this.serializer.zr);
        return n.H().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? $b1c6e3a850a3c735$export$78acf4525d8a74c4();
                $b1c6e3a850a3c735$var$__PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), $b1c6e3a850a3c735$var$PersistencePromise.forEach(n, (e, n)=>{
                const s = new $b1c6e3a850a3c735$var$User(n), _ = $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbDocumentOverlayCache.jr(this.serializer, s), o = i.getIndexManager(s), a = $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbMutationQueue.jr(s, this.serializer, o, i.referenceDelegate);
                return new $b1c6e3a850a3c735$var$LocalDocumentsView(r, a, _, o).recalculateAndSaveOverlaysForDocumentKeys(new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransaction(t, $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce), e).next();
            });
        });
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_createQueryCache(e) {
    e.createObjectStore($b1c6e3a850a3c735$var$Ee, {
        keyPath: $b1c6e3a850a3c735$var$he
    }).createIndex($b1c6e3a850a3c735$var$Te, $b1c6e3a850a3c735$var$Pe, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore($b1c6e3a850a3c735$var$ue, {
        keyPath: "targetId"
    }).createIndex($b1c6e3a850a3c735$var$ce, $b1c6e3a850a3c735$var$le, {
        unique: !0
    }), e.createObjectStore($b1c6e3a850a3c735$var$Ie);
}
const $b1c6e3a850a3c735$var$rn = "IndexedDbPersistence", $b1c6e3a850a3c735$var$sn = 18e5, $b1c6e3a850a3c735$var$_n = 5e3, $b1c6e3a850a3c735$var$on = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", $b1c6e3a850a3c735$var$an = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, _, o, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Tn = i, this.window = s, this.document = _, this.W_ = a, this.Q_ = u, this.G_ = c, this.f_ = null, this.m_ = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.z_ = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.j_ = null, /** The client metadata refresh task. */ this.H_ = null, /** The last time we garbage collected the client metadata object store. */ this.J_ = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Y_ = (e)=>Promise.resolve(), !$b1c6e3a850a3c735$var$__PRIVATE_IndexedDbPersistence.C()) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Z_ = t + $b1c6e3a850a3c735$var$an, this.serializer = new $b1c6e3a850a3c735$var$__PRIVATE_LocalSerializer(o), this.X_ = new $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb(this.Z_, this.G_, new $b1c6e3a850a3c735$var$__PRIVATE_SchemaConverter(this.serializer)), this.p_ = new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbGlobalsCache, this.g_ = new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = $b1c6e3a850a3c735$var$__PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.w_ = new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.eo = this.window.localStorage : (this.eo = null, !1 === u && $b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$rn, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.no().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, $b1c6e3a850a3c735$var$on);
            return this.ro(), this.io(), this.so(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.g_.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.f_ = new $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence(e, this.W_);
        }).then(()=>{
            this.m_ = !0;
        }).catch((e)=>(this.X_ && this.X_.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ _o(e) {
        return this.Y_ = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.X_.q(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Tn.enqueueAndForget(async ()=>{
            this.started && await this.no();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ no() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>$b1c6e3a850a3c735$var$__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.oo(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Tn.enqueueRetryable(()=>this.Y_(!1)));
                });
            }).next(()=>this.ao(e)).next((t)=>this.isPrimary && !t ? this.uo(e).next(()=>!1) : !!t && this.co(e).next(()=>!0))).catch((e)=>{
            if ($b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$rn, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$rn, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Tn.enqueueRetryable(()=>this.Y_(e)), this.isPrimary = e;
        });
    }
    oo(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_primaryClientStore(e).get($b1c6e3a850a3c735$var$G).next((e)=>$b1c6e3a850a3c735$var$PersistencePromise.resolve(this.lo(e)));
    }
    Eo(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async ho() {
        if (this.isPrimary && !this.To(this.J_, $b1c6e3a850a3c735$var$sn)) {
            this.J_ = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$de);
                return t.H().next((e)=>{
                    const n = this.Po(e, $b1c6e3a850a3c735$var$sn), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return $b1c6e3a850a3c735$var$PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.eo) for (const t of e)this.eo.removeItem(this.Ro(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ so() {
        this.H_ = this.Tn.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.no().then(()=>this.ho()).then(()=>this.so()));
    }
    /** Checks whether `client` is the local client. */ lo(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ ao(e) {
        if (this.Q_) return $b1c6e3a850a3c735$var$PersistencePromise.resolve(!0);
        return $b1c6e3a850a3c735$var$__PRIVATE_primaryClientStore(e).get($b1c6e3a850a3c735$var$G).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.To(t.leaseTimestampMs, $b1c6e3a850a3c735$var$_n) && !this.Io(t.ownerId)) {
                if (this.lo(t) && this.networkEnabled) return !0;
                if (!this.lo(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, $b1c6e3a850a3c735$var$on);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || $b1c6e3a850a3c735$var$__PRIVATE_clientMetadataStore(e).H().next((e)=>void 0 === this.Po(e, $b1c6e3a850a3c735$var$_n).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$rn, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.m_ = !1, this.Ao(), this.H_ && (this.H_.cancel(), this.H_ = null), this.Vo(), this.fo(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.X_.runTransaction("shutdown", "readwrite", [
            $b1c6e3a850a3c735$var$Q,
            $b1c6e3a850a3c735$var$de
        ], (e)=>{
            const t = new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransaction(e, $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce);
            return this.uo(t).next(()=>this.Eo(t));
        }), this.X_.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.mo();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ Po(e, t) {
        return e.filter((e)=>this.To(e.updateTimeMs, t) && !this.Io(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ po() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>$b1c6e3a850a3c735$var$__PRIVATE_clientMetadataStore(e).H().next((e)=>this.Po(e, $b1c6e3a850a3c735$var$sn).map((e)=>e.clientId)));
    }
    get started() {
        return this.m_;
    }
    getGlobalsCache() {
        return this.p_;
    }
    getMutationQueue(e, t) {
        return $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbMutationQueue.jr(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.g_;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbIndexManager(e, this.serializer.zr.databaseId);
    }
    getDocumentOverlayCache(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbDocumentOverlayCache.jr(this.serializer, e);
    }
    getBundleCache() {
        return this.w_;
    }
    runTransaction(e, t, n) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$rn, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? $b1c6e3a850a3c735$var$Xe : 17 === e ? $b1c6e3a850a3c735$var$Ze : 16 === e ? $b1c6e3a850a3c735$var$Ye : 15 === e ? $b1c6e3a850a3c735$var$Je : 14 === e ? $b1c6e3a850a3c735$var$He : 13 === e ? $b1c6e3a850a3c735$var$je : 12 === e ? $b1c6e3a850a3c735$var$ze : 11 === e ? $b1c6e3a850a3c735$var$Ge : void $b1c6e3a850a3c735$export$8743009a87fcb00f(60245);
        }(this.G_);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.X_.runTransaction(e, r, i, (r)=>(s = new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbTransaction(r, this.f_ ? this.f_.next() : $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce), "readwrite-primary" === t ? this.oo(s).next((e)=>!!e || this.ao(s)).next((t)=>{
                if (!t) throw $b1c6e3a850a3c735$var$__PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Tn.enqueueRetryable(()=>this.Y_(!1)), new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, $b1c6e3a850a3c735$var$B);
                return n(s);
            }).next((e)=>this.co(s).next(()=>e)) : this.yo(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    yo(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_primaryClientStore(e).get($b1c6e3a850a3c735$var$G).next((e)=>{
            if (null !== e && this.To(e.leaseTimestampMs, $b1c6e3a850a3c735$var$_n) && !this.Io(e.ownerId) && !this.lo(e) && !(this.Q_ || this.allowTabSynchronization && e.allowTabSynchronization)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, $b1c6e3a850a3c735$var$on);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ co(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return $b1c6e3a850a3c735$var$__PRIVATE_primaryClientStore(e).put($b1c6e3a850a3c735$var$G, t);
    }
    static C() {
        return $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.C();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ uo(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_primaryClientStore(e);
        return t.get($b1c6e3a850a3c735$var$G).next((e)=>this.lo(e) ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$rn, "Releasing primary lease."), t.delete($b1c6e3a850a3c735$var$G)) : $b1c6e3a850a3c735$var$PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ To(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || ($b1c6e3a850a3c735$var$__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    ro() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.j_ = ()=>{
            this.Tn.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.no()));
        }, this.document.addEventListener("visibilitychange", this.j_), this.inForeground = "visible" === this.document.visibilityState);
    }
    Vo() {
        this.j_ && (this.document.removeEventListener("visibilitychange", this.j_), this.j_ = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ io() {
        "function" == typeof this.window?.addEventListener && (this.z_ = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Ao();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, $029952e65115eee5$export$95df08bae54cb4df)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Tn.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Tn.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.z_));
    }
    fo() {
        this.z_ && (this.window.removeEventListener("pagehide", this.z_), this.z_ = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Io(e) {
        try {
            const t = null !== this.eo?.getItem(this.Ro(e));
            return $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$rn, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return $b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$rn, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Ao() {
        if (this.eo) try {
            this.eo.setItem(this.Ro(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            $b1c6e3a850a3c735$var$__PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ mo() {
        if (this.eo) try {
            this.eo.removeItem(this.Ro(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    Ro(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_primaryClientStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$Q);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_clientMetadataStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_getStore(e, $b1c6e3a850a3c735$var$de);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.wo = n, this.bo = r;
    }
    static vo(e, t) {
        let n = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), r = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new $b1c6e3a850a3c735$var$__PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_compareByKey(e, t) {
    return $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.key, t.key);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class $b1c6e3a850a3c735$var$QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_QueryEngine {
    constructor(){
        this.So = !1, this.Do = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.xo = 100, this.Co = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, $029952e65115eee5$export$95df08bae54cb4df)() ? 8 : $b1c6e3a850a3c735$var$__PRIVATE_getAndroidVersion((0, $029952e65115eee5$export$c36915b22ce77c19)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.Fo = e, this.indexManager = t, this.So = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.Oo(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.Mo(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new $b1c6e3a850a3c735$var$QueryContext;
            return this.No(e, t, n).next((r)=>{
                if (i.result = r, this.Do) return this.Lo(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    Lo(e, t, n, r) {
        return $b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? $b1c6e3a850a3c735$var$PersistencePromise.resolve() : n.documentReadCount < this.xo ? ($b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $b1c6e3a850a3c735$export$306ddfe3a8403e2("QueryEngine", "SDK will not create cache indexes for query:", $b1c6e3a850a3c735$var$__PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.xo, "documents"), $b1c6e3a850a3c735$var$PersistencePromise.resolve()) : ($b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $b1c6e3a850a3c735$export$306ddfe3a8403e2("QueryEngine", "Query:", $b1c6e3a850a3c735$var$__PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Co * r ? ($b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $b1c6e3a850a3c735$export$306ddfe3a8403e2("QueryEngine", "The SDK decides to create cache indexes for query:", $b1c6e3a850a3c735$var$__PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(t))) : $b1c6e3a850a3c735$var$PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Oo(e, t) {
        if ($b1c6e3a850a3c735$export$a07804094c3ecf2d(t)) return $b1c6e3a850a3c735$var$PersistencePromise.resolve(null);
        let n = t;
        if ($b1c6e3a850a3c735$var$__PRIVATE_queryMatchesAllDocuments(n)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return $b1c6e3a850a3c735$var$PersistencePromise.resolve(null);
        let r = $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(n);
        return this.indexManager.getIndexType(e, r).next((t)=>0 /* IndexType.NONE */  === t ? null : (null !== n.limit && 1 /* IndexType.PARTIAL */  === t && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (n = $b1c6e3a850a3c735$export$882b5998b3b9117c(n, null, "F" /* LimitType.First */ ), r = $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(n)), this.indexManager.getDocumentsMatchingTarget(e, r).next((t)=>{
                const i = $b1c6e3a850a3c735$export$78acf4525d8a74c4(...t);
                return this.Fo.getDocuments(e, i).next((t)=>this.indexManager.getMinOffset(e, r).next((r)=>{
                        const s = this.Bo(n, t);
                        return this.Uo(n, s, i, r.readTime) ? this.Oo(e, $b1c6e3a850a3c735$export$882b5998b3b9117c(n, null, "F" /* LimitType.First */ )) : this.ko(e, s, n, r);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Mo(e, t, n, r) {
        return ($b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? function __PRIVATE_pipelineMatchesAllDocuments(e) {
            for (const t of e.stages){
                if (t instanceof $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb || t instanceof $b1c6e3a850a3c735$export$f438b12253c2b499) return !1;
                // Check if it's the special 'exists(__name__)' case
                if (t instanceof $b1c6e3a850a3c735$export$4e222d082f82ee97) {
                    if (t.condition instanceof $b1c6e3a850a3c735$var$__PRIVATE_BooleanFunctionExpression && "exists" === t.condition._expr.name && t.condition._expr.params[0] instanceof $b1c6e3a850a3c735$export$e0c3a065614c6254 && t.condition._expr.params[0].fieldName === $b1c6e3a850a3c735$var$F) continue;
                    return !1;
                }
            }
            return !0;
        }(t) : $b1c6e3a850a3c735$var$__PRIVATE_queryMatchesAllDocuments(t)) || r.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min()) ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(null) : this.Fo.getDocuments(e, n).next((i)=>{
            const s = this.Bo(t, i);
            return this.Uo(t, s, n, r) ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(null) : ($b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $b1c6e3a850a3c735$export$306ddfe3a8403e2("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), $b1c6e3a850a3c735$var$__PRIVATE_stringifyQueryOrPipeline(t)), this.ko(e, s, t, $b1c6e3a850a3c735$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $b1c6e3a850a3c735$var$L)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Bo(e, t) {
        let n, r;
        return $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) ? // TODO(pipeline): the order here does not actually matter, not until we implement
        // refill logic for pipelines as well.
        (n = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$var$__PRIVATE_compareByKey), r = (t)=>$b1c6e3a850a3c735$var$__PRIVATE_pipelineMatches(e, t)) : // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        (n = new $b1c6e3a850a3c735$var$SortedSet($b1c6e3a850a3c735$export$25ce5a424b770e84(e)), r = (t)=>$b1c6e3a850a3c735$var$__PRIVATE_queryMatches(e, t)), t.forEach((e, t)=>{
            r(t) && (n = n.add(t));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Uo(e, t, n, r) {
        // TODO(pipeline): For pipelines it is simple for now, we refill for all limit/offset.
        // we should implement a similar approach for query at some point.
        if ($b1c6e3a850a3c735$export$a07804094c3ecf2d(e)) return function __PRIVATE_pipelineHasRanges(e) {
            return e.stages.some((e)=>e instanceof $b1c6e3a850a3c735$export$5dbe06c6d8c68cfb || e instanceof $b1c6e3a850a3c735$export$f438b12253c2b499);
        }(e);
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    No(e, t, n) {
        return $b1c6e3a850a3c735$var$__PRIVATE_getLogLevel() <= (0, $59d1e3b150b2f36d$export$243e62d78d3b544d).DEBUG && $b1c6e3a850a3c735$export$306ddfe3a8403e2("QueryEngine", "Using full collection scan to execute query:", $b1c6e3a850a3c735$var$__PRIVATE_stringifyQueryOrPipeline(t)), this.Fo.getDocumentsMatchingQuery(e, t, $b1c6e3a850a3c735$var$IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ ko(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Fo.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$un = "LocalStore", $b1c6e3a850a3c735$var$cn = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.qo = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.$o = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Ko = new $b1c6e3a850a3c735$var$ObjectMap((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyTargetOrPipeline(e), $b1c6e3a850a3c735$var$__PRIVATE_targetOrPipelineEqual), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Wo = new Map, this.Qo = e.getRemoteDocumentCache(), this.g_ = e.getTargetCache(), this.w_ = e.getBundleCache(), this.Go(n);
    }
    Go(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new $b1c6e3a850a3c735$var$LocalDocumentsView(this.Qo, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Qo.setIndexManager(this.indexManager), this.qo.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.$o));
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new $b1c6e3a850a3c735$var$__PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function $b1c6e3a850a3c735$var$__PRIVATE_localStoreHandleUserChange(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Go(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let _ = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)_ = _.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)_ = _.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, _).next((e)=>({
                    zo: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Qo.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let _ = $b1c6e3a850a3c735$var$PersistencePromise.resolve();
            return s.forEach((e)=>{
                _ = _.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), _.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.g_.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.$o;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Qo.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.$o;
        const _ = [];
        t.targetChanges.forEach((s, o)=>{
            const a = i.get(o);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            _.push(n.g_.removeMatchingKeys(e, s.removedDocuments, o).next(()=>n.g_.addMatchingKeys(e, s.addedDocuments, o)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(o) ? u = u.withResumeToken($b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING, $b1c6e3a850a3c735$var$SnapshotVersion.min()).withLastLimboFreeSnapshotVersion($b1c6e3a850a3c735$var$SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(o, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= $b1c6e3a850a3c735$var$cn) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && _.push(n.g_.updateTargetData(e, u));
        });
        let o = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), a = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && _.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        _.push($b1c6e3a850a3c735$var$__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            o = e.jo, a = e.Ho;
        })), !r.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min())) {
            const t = n.g_.getLastRemoteSnapshotVersion(e).next((t)=>n.g_.setTargetsMetadata(e, e.currentSequenceNumber, r));
            _.push(t);
        }
        return $b1c6e3a850a3c735$var$PersistencePromise.waitFor(_).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, o, a)).next(()=>o);
    }).then((e)=>(n.$o = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), i = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const _ = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== _.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !_.isValidDocument() || s.version.compareTo(_.version) > 0 || 0 === s.version.compareTo(_.version) && _.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$un, "Ignoring outdated watch update for ", n, ". Current version:", _.version, " Watch version:", s.version);
        }), {
            jo: r,
            Ho: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $b1c6e3a850a3c735$var$$), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.g_.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, $b1c6e3a850a3c735$var$PersistencePromise.resolve(r)) : n.g_.allocateTargetId(e).next((i)=>(r = new $b1c6e3a850a3c735$var$TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.g_.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.$o.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.$o = n.$o.insert(e.targetId, e), n.Ko.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), i = r.$o.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!$b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$un, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.$o = r.$o.remove(t), // TODO(pipeline): This needs to handle pipeline properly.
    r.Ko.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    let i = $b1c6e3a850a3c735$var$SnapshotVersion.min(), s = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), i = r.Ko.get(n);
            return void 0 !== i ? $b1c6e3a850a3c735$var$PersistencePromise.resolve(r.$o.get(i)) : r.g_.getTargetData(t, n);
        })(r, e, $b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? t : $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.g_.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.qo.getDocumentsMatchingQuery(e, t, n ? i : $b1c6e3a850a3c735$var$SnapshotVersion.min(), n ? s : $b1c6e3a850a3c735$export$78acf4525d8a74c4())).next((e)=>// TODO(pipeline): this needs to be adapted to support other pipeline flavors.
            // For now, only 'exact' flavor is supported and it is enough.
            ($b1c6e3a850a3c735$var$__PRIVATE_setMaxReadTime(r, e), {
                documents: e,
                Jo: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(n.g_), i = n.$o.get(t);
    return i ? Promise.resolve(i.target ?? null) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.dt(e, t).next((e)=>e?.target ?? null));
}
// PORTING NOTE: Multi-Tab only.
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = n.Wo.get(t) || $b1c6e3a850a3c735$var$SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Qo.getAllFromCollectionGroup(e, t, $b1c6e3a850a3c735$var$__PRIVATE_newIndexOffsetSuccessorFromReadTime(r, $b1c6e3a850a3c735$var$L), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>($b1c6e3a850a3c735$var$__PRIVATE_setMaxReadTime(n, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function $b1c6e3a850a3c735$var$__PRIVATE_setMaxReadTime(e, t) {
    t.forEach((t, n)=>{
        const r = n.key.getCollectionGroup(), i = e.Wo.get(r) || $b1c6e3a850a3c735$var$SnapshotVersion.min();
        n.readTime.compareTo(i) > 0 && e.Wo.set(r, n.readTime);
    });
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    let s = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), _ = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Yo(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Zo(e);
        r.setReadTime(t.Xo(e.metadata.readTime)), _ = _.insert(n, r);
    }
    const o = i.Qo.newChangeBuffer({
        trackRemovals: !0
    }), a = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget($b1c6e3a850a3c735$export$7910e0436ed8d1de($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>$b1c6e3a850a3c735$var$__PRIVATE_populateDocumentChangeBuffer(e, o, _).next((t)=>(o.apply(e), t)).next((t)=>i.g_.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.g_.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.jo, t.Ho)).next(()=>t.jo)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n = $b1c6e3a850a3c735$export$78acf4525d8a74c4()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(e, $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget($b1c6e3a850a3c735$export$3a6d5c9ae78a2c08(t.bundledQuery))), i = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.w_.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const _ = r.withResumeToken($b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING, s);
        return i.$o = i.$o.insert(_.targetId, _), i.g_.updateTargetData(e, _).next(()=>i.g_.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.g_.addMatchingKeys(e, n, r.targetId)).next(()=>i.w_.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const $b1c6e3a850a3c735$var$En = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function $b1c6e3a850a3c735$var$createWebStorageClientStateKey(e, t) {
    return `${$b1c6e3a850a3c735$var$En}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const $b1c6e3a850a3c735$var$hn = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function $b1c6e3a850a3c735$var$createWebStorageMutationBatchKey(e, t, n) {
    let r = `${$b1c6e3a850a3c735$var$hn}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const $b1c6e3a850a3c735$var$Tn = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function $b1c6e3a850a3c735$var$createWebStorageQueryTargetMetadataKey(e, t) {
    return `${$b1c6e3a850a3c735$var$Tn}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Pn = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class $b1c6e3a850a3c735$var$__PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new $b1c6e3a850a3c735$export$4368d992c4eafac0(r.error.code, r.error.message))), s ? new $b1c6e3a850a3c735$var$__PRIVATE_MutationMetadata(e, t, r.state, i) : ($b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$Pn, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    ta() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class $b1c6e3a850a3c735$var$__PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new $b1c6e3a850a3c735$export$4368d992c4eafac0(n.error.code, n.error.message))), i ? new $b1c6e3a850a3c735$var$__PRIVATE_QueryTargetMetadata(e, n.state, r) : ($b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$Pn, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    ta() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = $b1c6e3a850a3c735$var$__PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = $b1c6e3a850a3c735$var$isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new $b1c6e3a850a3c735$var$__PRIVATE_RemoteClientState(e, i) : ($b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$Pn, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new $b1c6e3a850a3c735$var$__PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : ($b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$Pn, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class $b1c6e3a850a3c735$var$__PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = $b1c6e3a850a3c735$var$__PRIVATE_targetIdSet();
    }
    na(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    ra(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ ta() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Tn = t, this.persistenceKey = n, this.ia = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.sa = this._a.bind(this), this.oa = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.aa = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.ua = $b1c6e3a850a3c735$var$createWebStorageClientStateKey(this.persistenceKey, this.ia), this.ca = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.oa = this.oa.insert(this.ia, new $b1c6e3a850a3c735$var$__PRIVATE_LocalClientState), this.la = new RegExp(`^${$b1c6e3a850a3c735$var$En}_${s}_([^_]*)$`), this.Ea = new RegExp(`^${$b1c6e3a850a3c735$var$hn}_${s}_(\\d+)(?:_(.*))?$`), this.ha = new RegExp(`^${$b1c6e3a850a3c735$var$Tn}_${s}_(\\d+)$`), this.Ta = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.Pa = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.sa);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static C(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.po();
        for (const t of e){
            if (t === this.ia) continue;
            const e = this.getItem($b1c6e3a850a3c735$var$createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_RemoteClientState.ea(t, e);
                n && (this.oa = this.oa.insert(n.clientId, n));
            }
        }
        this.Ra();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.Ta);
        if (t) {
            const e = this.Ia(t);
            e && this.Aa(e);
        }
        for (const e of this.aa)this._a(e);
        this.aa = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.ca, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.Va(this.oa);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.oa.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.da(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.da(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.fa(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem($b1c6e3a850a3c735$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = $b1c6e3a850a3c735$var$__PRIVATE_QueryTargetMetadata.ea(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.ma.na(e), this.Ra(), n;
    }
    removeLocalQueryTarget(e) {
        this.ma.ra(e), this.Ra();
    }
    isLocalQueryTarget(e) {
        return this.ma.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem($b1c6e3a850a3c735$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.pa(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.fa(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.ga(e);
    }
    notifyBundleLoaded(e) {
        this.ya(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.sa), this.removeItem(this.ua), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Pn, "READ", e, t), t;
    }
    setItem(e, t) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Pn, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Pn, "REMOVE", e), this.storage.removeItem(e);
    }
    _a(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Pn, "EVENT", t.key, t.newValue), t.key === this.ua) return void $b1c6e3a850a3c735$var$__PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Tn.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.la.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.wa(t.key);
                                return this.ba(e, null);
                            }
                            {
                                const e = this.va(t.key, t.newValue);
                                if (e) return this.ba(e.clientId, e);
                            }
                        } else if (this.Ea.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Sa(t.key, t.newValue);
                                if (e) return this.Da(e);
                            }
                        } else if (this.ha.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.xa(t.key, t.newValue);
                                if (e) return this.Ca(e);
                            }
                        } else if (t.key === this.Ta) {
                            if (null !== t.newValue) {
                                const e = this.Ia(t.newValue);
                                if (e) return this.Aa(e);
                            }
                        } else if (t.key === this.ca) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    $b1c6e3a850a3c735$var$__PRIVATE_hardAssert("number" == typeof n, 30636, {
                                        Fa: e
                                    }), t = n;
                                } catch (e) {
                                    $b1c6e3a850a3c735$var$__PRIVATE_logError($b1c6e3a850a3c735$var$Pn, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce && this.sequenceNumberHandler(e);
                        } else if (t.key === this.Pa) {
                            const e = this.Oa(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.Ma(e)));
                        }
                    }
                } else this.aa.push(t);
            });
        }
    }
    get ma() {
        return this.oa.get(this.ia);
    }
    Ra() {
        this.setItem(this.ua, this.ma.ta());
    }
    da(e, t, n) {
        const r = new $b1c6e3a850a3c735$var$__PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = $b1c6e3a850a3c735$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.ta());
    }
    fa(e) {
        const t = $b1c6e3a850a3c735$var$createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    ga(e) {
        const t = {
            clientId: this.ia,
            onlineState: e
        };
        this.storage.setItem(this.Ta, JSON.stringify(t));
    }
    pa(e, t, n) {
        const r = $b1c6e3a850a3c735$var$createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new $b1c6e3a850a3c735$var$__PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.ta());
    }
    ya(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Pa, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ wa(e) {
        const t = this.la.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ va(e, t) {
        const n = this.wa(e);
        return $b1c6e3a850a3c735$var$__PRIVATE_RemoteClientState.ea(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Sa(e, t) {
        const n = this.Ea.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return $b1c6e3a850a3c735$var$__PRIVATE_MutationMetadata.ea(new $b1c6e3a850a3c735$var$User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ xa(e, t) {
        const n = this.ha.exec(e), r = Number(n[1]);
        return $b1c6e3a850a3c735$var$__PRIVATE_QueryTargetMetadata.ea(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ia(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_SharedOnlineState.ea(e);
    }
    Oa(e) {
        return JSON.parse(e);
    }
    async Da(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Na(e.batchId, e.state, e.error);
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Pn, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    Ca(e) {
        return this.syncEngine.La(e.targetId, e.state, e.error);
    }
    ba(e, t) {
        const n = t ? this.oa.insert(e, t) : this.oa.remove(e), r = this.Va(this.oa), i = this.Va(n), s = [], _ = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || _.push(e);
        }), this.syncEngine.Ba(s, _).then(()=>{
            this.oa = n;
        });
    }
    Aa(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.oa.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    Va(e) {
        let t = $b1c6e3a850a3c735$var$__PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_MemorySharedClientState {
    constructor(){
        this.Ua = new $b1c6e3a850a3c735$var$__PRIVATE_LocalClientState, this.ka = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.Ua.na(e), this.ka[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.ka[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.Ua.ra(e);
    }
    isLocalQueryTarget(e) {
        return this.Ua.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.ka[e];
    }
    getAllActiveQueryTargets() {
        return this.Ua.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.Ua.activeTargetIds.has(e);
    }
    start() {
        return this.Ua = new $b1c6e3a850a3c735$var$__PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function $b1c6e3a850a3c735$var$__PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function $b1c6e3a850a3c735$var$getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class $b1c6e3a850a3c735$var$__PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.qa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.$a = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.Ka = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ Wa() {
        0 === this.qa && (this.Qa("Unknown" /* OnlineState.Unknown */ ), this.$a = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.$a = null, this.Ga("Backend didn't respond within 10 seconds."), this.Qa("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ za(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.Qa("Unknown" /* OnlineState.Unknown */ ) : (this.qa++, this.qa >= 1 && (this.ja(), this.Ga(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.Qa("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.ja(), this.qa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.Ka = !1), this.Qa(e);
    }
    Qa(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    Ga(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.Ka ? ($b1c6e3a850a3c735$var$__PRIVATE_logError(t), this.Ka = !1) : $b1c6e3a850a3c735$export$306ddfe3a8403e2("OnlineStateTracker", t);
    }
    ja() {
        null !== this.$a && (this.$a.cancel(), this.$a = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Rn = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class $b1c6e3a850a3c735$var$__PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Ha = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ja = new Map, this.Ya = new Map, this.Za = new Map, this.Xa = new $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator(1e3), this.eu = new $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator(1001), /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.tu = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.nu = [], this.ru = i, this.ru.bt((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(this) && ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
                    t.tu.add(4 /* OfflineCause.ConnectivityChange */ ), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(t), t.iu.set("Unknown" /* OnlineState.Unknown */ ), t.tu.delete(4 /* OfflineCause.ConnectivityChange */ ), await $b1c6e3a850a3c735$var$__PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.iu = new $b1c6e3a850a3c735$var$__PRIVATE_OnlineStateTracker(n, r);
    }
}
async function $b1c6e3a850a3c735$var$__PRIVATE_enableNetworkInternal(e) {
    if ($b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(e)) for (const t of e.nu)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(e) {
    for (const t of e.nu)await t(/* enabled= */ !1);
}
/**
 * Returns the remote target ID currently mapped to this
 * sdkTargetId. Or returns `0` if the SDK target ID
 * is not currently mapped.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ function $b1c6e3a850a3c735$var$__PRIVATE_getRemoteTargetId(e, t) {
    return e.Ya.get(t) || void 0;
}
/**
 * Generates a new remote target ID that is acceptable
 * to map to the given SDK target ID.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ /**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreListen(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$var$__PRIVATE_getRemoteTargetId(n, t.targetId);
    // Get any remote target ID currently mapped to the targetData
    // If remote store is still listening for this remote target ID, this is a no-op.
    if (void 0 !== r && n.Ja.has(r)) return;
    // Generate and map a new remote ID to the SDK target ID
    const i = /**
 * Generate a new remote target ID for the given SDK target ID.
 * Re-map the given SDK to the new remote ID.
 * Delete any mapping of the old remote ID, if given.
 * @param remoteStoreImpl
 * @param sdkTargetId
 * @return The new remote ID.
 */ function __PRIVATE_allocateRemoteTargetId(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_getRemoteTargetId(e, t);
        void 0 !== n && // If there was an existing remote target ID mapped to that SDK target ID, forget about the old remote ID.
        e.Za.delete(n);
        // Generate a new unique remote target ID
        const r = function __PRIVATE_generateRemoteTargetId(e, t) {
            // If the given sdkTargetId is odd, map it to an odd (sync engine) target ID
            return t % 2 != 0 ? e.eu.next() : e.Xa.next();
        }(e, t);
        return e.Ya.set(t, r), e.Za.set(r, t), r;
    }(n, t.targetId);
    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "remoteStoreListen mapping SDK target ID to remote", t.targetId, i);
    // Create a new TargetData for remote use, which uses
    // the remote TargetID.
    const s = new $b1c6e3a850a3c735$var$TargetData(t.target, i, t.purpose, t.sequenceNumber, t.snapshotVersion, t.lastLimboFreeSnapshotVersion, t.resumeToken);
    // Mark this as something the client is currently listening for.
    n.Ja.set(i, s), $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    $b1c6e3a850a3c735$var$__PRIVATE_startWatchStream(n) : $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(n).Fn() && $b1c6e3a850a3c735$var$__PRIVATE_sendWatchRequest(n, s);
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(n), i = $b1c6e3a850a3c735$var$__PRIVATE_getRemoteTargetId(n, t);
    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "remoteStoreUnlisten removing mapping of SDK target ID to remote", t, i), n.Ja.delete(i), n.Ya.delete(t), n.Za.delete(i), r.Fn() && $b1c6e3a850a3c735$var$__PRIVATE_sendUnwatchRequest(n, i), 0 === n.Ja.size && (r.Fn() ? r.Nn() : $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.iu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_sendWatchRequest(e, t) {
    if (e.su.We(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo($b1c6e3a850a3c735$var$SnapshotVersion.min()) > 0) {
        const n = e.Za.get(t.targetId);
        if (void 0 === n) // There's already a new remoteStoreListen request for the original
        // target, so ignore this.
        return void $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "SDK target ID not found for remote ID: " + t.targetId);
        const r = e.remoteSyncer.getRemoteKeysForTarget(n).size;
        t = t.withExpectedCount(r);
    }
    $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(e).jn(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_sendUnwatchRequest(e, t) {
    e.su.We(t), $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(e).Hn(t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_startWatchStream(e) {
    e.su = new $b1c6e3a850a3c735$var$__PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>{
            // Remote syncer uses SDK target IDs, so we need to map the remote
            // id to external id
            const n = e.Za.get(t);
            // If no sdkTargetId is mapped, return an empty key set
            return void 0 !== n ? e.remoteSyncer.getRemoteKeysForTarget(n) : $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        },
        dt: (t)=>e.Ja.get(t) || null,
        Tt: ()=>e.datastore.serializer.databaseId
    }), $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(e).start(), e.iu.Wa();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWatchStream(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(e) && !$b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(e).Cn() && e.Ja.size > 0;
}
function $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(e) {
    return 0 === $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).tu.size;
}
function $b1c6e3a850a3c735$var$__PRIVATE_cleanUpWatchStreamState(e) {
    e.su = void 0;
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.iu.set("Online" /* OnlineState.Online */ );
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamOpen(e) {
    e.Ja.forEach((t, n)=>{
        $b1c6e3a850a3c735$var$__PRIVATE_sendWatchRequest(e, t);
    });
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamClose(e, t) {
    $b1c6e3a850a3c735$var$__PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWatchStream(e) ? (e.iu.za(t), $b1c6e3a850a3c735$var$__PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.iu.set("Unknown" /* OnlineState.Unknown */ );
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.iu.set("Online" /* OnlineState.Online */ ), t instanceof $b1c6e3a850a3c735$var$__PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds){
                // A watched target might have been removed already.
                if (e.Ja.has(r)) {
                    const t = e.Za.get(r);
                    // If we still track the remote target ID, then notify the remoteSyncer
                    // of the error and then free up the remote ID.
                    void 0 !== t && (await e.remoteSyncer.rejectListen(t, n), e.Ya.delete(t), e.Za.delete(r)), e.Ja.delete(r);
                }
                e.su.removeTarget(r);
            }
        }(e, t);
    } catch (n) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof $b1c6e3a850a3c735$var$__PRIVATE_DocumentWatchChange ? e.su.et(t) : t instanceof $b1c6e3a850a3c735$var$__PRIVATE_ExistenceFilterChange ? e.su.ot(t) : e.su.rt(t), !n.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min())) try {
        const t = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.su.Rt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ja.get(r);
                    // A watched target might have been removed already.
                    i && e.Ja.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            // TODO ideally this would use a new remote target ID
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ja.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ja.set(t, r.withResumeToken($b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                $b1c6e3a850a3c735$var$__PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new $b1c6e3a850a3c735$var$TargetData(r.target, t, n, r.sequenceNumber);
                $b1c6e3a850a3c735$var$__PRIVATE_sendWatchRequest(e, i);
            });
            const r = /**
 * Convert a RemoteEvent with remote IDs to a RemoteEvent with
 * SDK IDs and dropped updates
 * for any targets we no longer track.
 *
 * @param remoteStoreImpl
 * @param remoteEvent
 * @return a new RemoteEvent with SDK IDs and dropped updates
 * for any targets we no longer track.
 */ function __PRIVATE_toSdkRemoteEvent(e, t) {
                // Map TargetChanges to TargetChanges with SDK ID
                const n = new Map;
                t.targetChanges.forEach((t, r)=>{
                    // If we no longer track the remote ID, then drop the TargetChange
                    // otherwise propagate the TargetChange
                    const i = e.Za.get(r);
                    void 0 !== i && n.set(i, t);
                });
                // Map target mismatches to target mismatches with SDK ID
                let r = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator);
                return t.targetMismatches.forEach((t, n)=>{
                    // If we no longer track the remote ID, then drop the target mismatch
                    // otherwise propagate the target mismatch
                    const i = e.Za.get(t);
                    void 0 !== i && (r = r.insert(i, n));
                }), new $b1c6e3a850a3c735$var$RemoteEvent(t.snapshotVersion, n, r, t.documentUpdates, t.augmentedDocumentUpdates, t.resolvedLimboDocuments);
            }(e, n);
            return e.remoteSyncer.applyRemoteEvent(r);
        }(e, n);
    } catch (t) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "Failed to raise snapshot:", t), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!$b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.tu.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(e), e.iu.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>$b1c6e3a850a3c735$var$__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "Retrying IndexedDB access"), await n(), e.tu.delete(1 /* OfflineCause.IndexedDbFailed */ ), await $b1c6e3a850a3c735$var$__PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>$b1c6e3a850a3c735$var$__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), n = $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(t);
    let r = t.Ha.length > 0 ? t.Ha[t.Ha.length - 1].batchId : $b1c6e3a850a3c735$var$$;
    for(; $b1c6e3a850a3c735$var$__PRIVATE_canAddToWritePipeline(t);)try {
        const e = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Ha.length && n.Nn();
            break;
        }
        r = e.batchId, $b1c6e3a850a3c735$var$__PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWriteStream(t) && $b1c6e3a850a3c735$var$__PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function $b1c6e3a850a3c735$var$__PRIVATE_canAddToWritePipeline(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(e) && e.Ha.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_addToWritePipeline(e, t) {
    e.Ha.push(t);
    const n = $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e);
    n.Fn() && n.Jn && n.Yn(t.mutations);
}
function $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWriteStream(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(e) && !$b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e).Cn() && e.Ha.length > 0;
}
function $b1c6e3a850a3c735$var$__PRIVATE_startWriteStream(e) {
    $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e).start();
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWriteStreamOpen(e) {
    $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e).er();
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWriteHandshakeComplete(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Ha)t.Yn(n.mutations);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onMutationResult(e, t, n) {
    const r = e.Ha.shift(), i = $b1c6e3a850a3c735$var$MutationBatchResult.from(r, t, n);
    await $b1c6e3a850a3c735$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(e);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e).Jn && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return $b1c6e3a850a3c735$var$__PRIVATE_isPermanentError(e) && e !== $b1c6e3a850a3c735$export$f1e1789686576879.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Ha.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e).Mn(), await $b1c6e3a850a3c735$var$__PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWriteStream(e) && $b1c6e3a850a3c735$var$__PRIVATE_startWriteStream(e);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "RemoteStore received new credentials");
    const r = $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.tu.add(3 /* OfflineCause.CredentialChange */ ), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.iu.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.tu.delete(3 /* OfflineCause.CredentialChange */ ), await $b1c6e3a850a3c735$var$__PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    t ? (n.tu.delete(2 /* OfflineCause.IsSecondary */ ), await $b1c6e3a850a3c735$var$__PRIVATE_enableNetworkInternal(n)) : t || (n.tu.add(2 /* OfflineCause.IsSecondary */ ), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(n), n.iu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchStream(e) {
    return e._u || // Create stream (but note that it is not started yet).
    (e._u = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
        return r.nr(), new $b1c6e3a850a3c735$var$__PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Qt: $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamConnected.bind(null, e),
        zt: $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamOpen.bind(null, e),
        Ht: $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamClose.bind(null, e),
        zn: $b1c6e3a850a3c735$var$__PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.nu.push(async (t)=>{
        t ? (e._u.Mn(), $b1c6e3a850a3c735$var$__PRIVATE_shouldStartWatchStream(e) ? $b1c6e3a850a3c735$var$__PRIVATE_startWatchStream(e) : e.iu.set("Unknown" /* OnlineState.Unknown */ )) : (await e._u.stop(), $b1c6e3a850a3c735$var$__PRIVATE_cleanUpWatchStreamState(e));
    })), e._u;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_ensureWriteStream(e) {
    return e.ou || // Create stream (but note that it is not started yet).
    (e.ou = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
        return r.nr(), new $b1c6e3a850a3c735$var$__PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Qt: ()=>Promise.resolve(),
        zt: $b1c6e3a850a3c735$var$__PRIVATE_onWriteStreamOpen.bind(null, e),
        Ht: $b1c6e3a850a3c735$var$__PRIVATE_onWriteStreamClose.bind(null, e),
        Zn: $b1c6e3a850a3c735$var$__PRIVATE_onWriteHandshakeComplete.bind(null, e),
        Xn: $b1c6e3a850a3c735$var$__PRIVATE_onMutationResult.bind(null, e)
    }), e.nu.push(async (t)=>{
        t ? (e.ou.Mn(), // This will start the write stream if necessary.
        await $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(e)) : (await e.ou.stop(), e.Ha.length > 0 && ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, `Stopping write stream with ${e.Ha.length} pending writes`), e.Ha = []));
    })), e.ou;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class $b1c6e3a850a3c735$var$DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, _ = new $b1c6e3a850a3c735$var$DelayedOperation(e, t, s, r, i);
        return _.start(n), _;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if ($b1c6e3a850a3c735$var$__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), $b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e)) return new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class $b1c6e3a850a3c735$export$e7c866399fa523f5 {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new $b1c6e3a850a3c735$export$e7c866399fa523f5(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || $b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(t.key, n.key) : (e, t)=>$b1c6e3a850a3c735$export$90a7f3efeed30595.comparator(e.key, t.key), this.keyedMap = $b1c6e3a850a3c735$var$documentMap(), this.sortedSet = new $b1c6e3a850a3c735$var$SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof $b1c6e3a850a3c735$export$e7c866399fa523f5)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new $b1c6e3a850a3c735$export$e7c866399fa523f5;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_DocumentChangeSet {
    constructor(){
        this.au = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.au.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.au = this.au.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.au = this.au.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.au = this.au.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.au = this.au.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.au = this.au.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.au = this.au.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.au = this.au.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        $b1c6e3a850a3c735$export$8743009a87fcb00f(63341, {
            ft: e,
            uu: n
        }) : this.au = this.au.insert(t, e);
    }
    cu() {
        const e = [];
        return this.au.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class $b1c6e3a850a3c735$export$71cec2538cb2c617 {
    constructor(e, t, n, r, i, s, _, o, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = _, this.excludesMetadataChanges = o, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new $b1c6e3a850a3c735$export$71cec2538cb2c617(e, t, $b1c6e3a850a3c735$export$e7c866399fa523f5.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && $b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineEqual(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_QueryListenersInfo {
    constructor(){
        this.lu = void 0, this.Eu = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    hu() {
        return this.Eu.some((e)=>e.Tu());
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = $b1c6e3a850a3c735$var$__PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Pu = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = $b1c6e3a850a3c735$var$__PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.Eu)e.onError(t);
            });
        }(this, new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.ABORTED, "Firestore shutting down"));
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_newQueriesObjectMap() {
    return new $b1c6e3a850a3c735$var$ObjectMap((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyQueryOrPipeline(e), $b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineEqual);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_eventManagerListen(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.hu() && t.Tu() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new $b1c6e3a850a3c735$var$__PRIVATE_QueryListenersInfo, r = t.Tu() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.lu = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.lu = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${$b1c6e3a850a3c735$export$a07804094c3ecf2d(t.query) ? $b1c6e3a850a3c735$var$__PRIVATE_canonifyPipeline(t.query) : $b1c6e3a850a3c735$var$__PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.Eu.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.Ru(n.onlineState), s.lu) t.Iu(s.lu) && $b1c6e3a850a3c735$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_eventManagerUnlisten(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.Eu.indexOf(t);
        e >= 0 && (s.Eu.splice(e, 1), 0 === s.Eu.length ? i = t.Tu() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.hu() && t.Tu() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.Eu)t.Iu(e) && (r = !0);
            i.lu = e;
        }
    }
    r && $b1c6e3a850a3c735$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function $b1c6e3a850a3c735$var$__PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.Eu)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function $b1c6e3a850a3c735$var$__PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Pu.forEach((e)=>{
        e.next();
    });
}
var $b1c6e3a850a3c735$var$In;
!function(e) {
    /** Listen to both cache and server changes */ e.Default = "default", /** Listen to changes in cache only */ e.Cache = "cache";
}($b1c6e3a850a3c735$var$In || ($b1c6e3a850a3c735$var$In = {}));
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.Au = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Vu = !1, this.du = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Iu(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new $b1c6e3a850a3c735$export$71cec2538cb2c617(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.Vu ? this.fu(e) && (this.Au.next(e), t = !0) : this.mu(e, this.onlineState) && (this.pu(e), t = !0), this.du = e, t;
    }
    onError(e) {
        this.Au.error(e);
    }
    /** Returns whether a snapshot was raised. */ Ru(e) {
        this.onlineState = e;
        let t = !1;
        return this.du && !this.Vu && this.mu(this.du, e) && (this.pu(this.du), t = !0), t;
    }
    mu(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Tu()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.waitForSyncWhenOnline || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    fu(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.du && this.du.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    pu(e) {
        e = $b1c6e3a850a3c735$export$71cec2538cb2c617.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Vu = !0, this.Au.next(e);
    }
    Tu() {
        return this.options.source !== $b1c6e3a850a3c735$var$In.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.gu = e, this.byteLength = t;
    }
    yu() {
        return "metadata" in this.gu;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Yo(e) {
        return $b1c6e3a850a3c735$var$fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ Zo(e) {
        return e.metadata.exists ? $b1c6e3a850a3c735$export$3a1a48c8f6ef640e(this.serializer, e.document, !1) : $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(this.Yo(e.metadata.name), this.Xo(e.metadata.readTime));
    }
    Xo(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class $b1c6e3a850a3c735$export$61196ced6d74a310 {
    constructor(e, t){
        this.wu = e, this.serializer = t, /** Batched queries to be saved into storage */ this.bu = [], /** Batched documents to be saved into storage */ this.vu = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = $b1c6e3a850a3c735$var$__PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.bu;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.vu;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ o(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.gu.namedQuery) this.bu.push(e.gu.namedQuery);
        else if (e.gu.documentMetadata) {
            this.vu.push({
                metadata: e.gu.documentMetadata
            }), e.gu.documentMetadata.exists || ++t;
            const n = $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(e.gu.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.gu.document && (this.vu[this.vu.length - 1].document = e.gu.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    Du(e) {
        const t = new Map, n = new $b1c6e3a850a3c735$var$__PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Yo(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || $b1c6e3a850a3c735$export$78acf4525d8a74c4()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async xu(e) {
        const t = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreApplyBundledDocuments(e, new $b1c6e3a850a3c735$var$__PRIVATE_BundleConverterImpl(this.serializer), this.vu, this.wu.id), n = this.Du(this.documents);
        for (const t of this.bu)await $b1c6e3a850a3c735$var$__PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Cu: this.collectionGroups,
            Fu: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class $b1c6e3a850a3c735$var$__PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Ou = t, this.Mu = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Nu = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), /** Document Keys that have local changes */ this.mutatedKeys = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), this.Lu = $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) ? $b1c6e3a850a3c735$export$56c0d5a1e737357d(e) : $b1c6e3a850a3c735$export$25ce5a424b770e84(e), this.Bu = new $b1c6e3a850a3c735$export$e7c866399fa523f5(this.Lu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get Uu() {
        return this.Ou;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ku(e, t) {
        const n = t ? t.qu : new $b1c6e3a850a3c735$var$__PRIVATE_DocumentChangeSet, r = t ? t.Bu : this.Bu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, _ = !1;
        const [o, a] = this.$u(this.query, r);
        e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = $b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), E = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let h = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== E && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), h = !0) : this.Ku(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), h = !0, (o && this.Lu(c, o) > 0 || a && this.Lu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (_ = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), h = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), h = !0, (o || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (_ = !0));
            h && (c ? (s = s.add(c), i = E ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        });
        // Drop documents out to meet limit/limitToLast requirement.
        const u = this.Wu(this.query);
        if (u) {
            if ($b1c6e3a850a3c735$export$a07804094c3ecf2d(this.query)) {
                // TODO(pipeline): Not very efficient obviously, but should be fine for now.
                // Longer term, limit queries should be evaluated from query engine as well.
                const e = [];
                s.forEach((t)=>e.push(t));
                const t = $b1c6e3a850a3c735$var$__PRIVATE_runPipeline(this.query, e);
                let r = new $b1c6e3a850a3c735$export$e7c866399fa523f5($b1c6e3a850a3c735$export$56c0d5a1e737357d(this.query));
                for (const e of t)r = r.add(e);
                s.forEach((e)=>{
                    r.has(e.key) || (i = i.delete(e.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: e
                    }));
                }), s = r;
            } else {
                const e = this.Qu(this.query);
                for(; s.size > u;){
                    const t = "F" /* LimitType.First */  === e ? s.last() : s.first();
                    s = s.delete(t.key), i = i.delete(t.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: t
                    });
                }
            }
        }
        return {
            Bu: s,
            qu: n,
            Uo: _,
            mutatedKeys: i
        };
    }
    Wu(e) {
        return $b1c6e3a850a3c735$export$a07804094c3ecf2d(e) ? $b1c6e3a850a3c735$var$__PRIVATE_getLastEffectiveLimit(e)?.limit : e.limit || void 0;
    }
    Qu(e) {
        if ($b1c6e3a850a3c735$export$a07804094c3ecf2d(e)) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_getLastEffectiveLimit(e);
            return t && t.limit < 0 ? "L" /* LimitType.Last */  : "F" /* LimitType.First */ ;
        }
        return e.limitType;
    }
    $u(e, t) {
        if ($b1c6e3a850a3c735$export$a07804094c3ecf2d(e)) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_getLastEffectiveLimit(e)?.limit;
            return [
                t.size === n ? t.last() : null,
                null
            ];
        }
        return [
            "F" /* LimitType.First */  === e.limitType && t.size === this.Wu(this.query) ? t.last() : null,
            "L" /* LimitType.Last */  === e.limitType && t.size === this.Wu(this.query) ? t.first() : null
        ];
    }
    Ku(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.Bu;
        this.Bu = e.Bu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.qu.cu();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return $b1c6e3a850a3c735$export$8743009a87fcb00f(20277, {
                                ft: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Lu(e.doc, t.doc)), this.Gu(n), r = r ?? !1;
        const _ = t && !r ? this.zu() : [], o = 0 === this.Nu.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = o !== this.Mu;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Mu = o, 0 !== s.length || a) return {
            snapshot: new $b1c6e3a850a3c735$export$71cec2538cb2c617(this.query, e.Bu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === o, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            ju: _
        };
        // no changes
        return {
            ju: _
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Ru(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            Bu: this.Bu,
            qu: new $b1c6e3a850a3c735$var$__PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Uo: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            ju: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Hu(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Ou.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Bu.has(e) && !this.Bu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ Gu(e) {
        e && (e.addedDocuments.forEach((e)=>this.Ou = this.Ou.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Ou = this.Ou.delete(e)), this.current = e.current);
    }
    zu() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Nu;
        this.Nu = $b1c6e3a850a3c735$export$78acf4525d8a74c4(), this.Bu.forEach((e)=>{
            this.Hu(e.key) && (this.Nu = this.Nu.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Nu.has(e) || t.push(new $b1c6e3a850a3c735$var$__PRIVATE_RemovedLimboDocument(e));
        }), this.Nu.forEach((n)=>{
            e.has(n) || t.push(new $b1c6e3a850a3c735$var$__PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    Ju(e) {
        this.Ou = e.Jo, this.Nu = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        const t = this.ku(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Yu() {
        return $b1c6e3a850a3c735$export$71cec2538cb2c617.fromInitialDocuments(this.query, this.Bu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Mu, this.hasCachedResults);
    }
}
const $b1c6e3a850a3c735$var$An = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class $b1c6e3a850a3c735$var$LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Zu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Xu = {}, this.ec = new $b1c6e3a850a3c735$var$ObjectMap((e)=>$b1c6e3a850a3c735$var$__PRIVATE_canonifyQueryOrPipeline(e), $b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineEqual), this.tc = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.nc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.rc = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.sc = new Map, this._c = new $b1c6e3a850a3c735$var$__PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.oc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.ac = new Map, this.uc = $b1c6e3a850a3c735$var$__PRIVATE_TargetIdGenerator.Cs(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.cc = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.cc;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.ec.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Yu()) : i = await $b1c6e3a850a3c735$var$__PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function $b1c6e3a850a3c735$var$__PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchCallbacks(e);
    await $b1c6e3a850a3c735$var$__PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(e.localStore, $b1c6e3a850a3c735$export$a07804094c3ecf2d(t) ? t : $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(t)), s = i.targetId, _ = e.sharedClientState.addLocalQueryTarget(s, n);
    let o;
    return r && (o = await $b1c6e3a850a3c735$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === _, i.resumeToken)), e.isPrimaryClient && n && $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreListen(e.remoteStore, i), o;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.lc = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ku(n);
            i.Uo && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ku(e, i)));
            const s = r && r.targetChanges.get(t.targetId), _ = r && null != r.targetMismatches.get(t.targetId), o = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, _);
            return $b1c6e3a850a3c735$var$__PRIVATE_updateTrackedLimbos(e, t.targetId, o.ju), o.snapshot;
        })(e, t, n, r);
    const s = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), _ = new $b1c6e3a850a3c735$var$__PRIVATE_View(t, s.Jo), o = _.ku(s.documents), a = $b1c6e3a850a3c735$var$TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = _.applyChanges(o, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    $b1c6e3a850a3c735$var$__PRIVATE_updateTrackedLimbos(e, n, u.ju);
    const c = new $b1c6e3a850a3c735$var$__PRIVATE_QueryView(t, n, _);
    return e.ec.set(t, c), e.tc.has(n) ? e.tc.get(n).push(t) : e.tc.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), i = r.ec.get(t), s = r.tc.get(i.targetId);
    if (s.length > 1) return r.tc.set(i.targetId, s.filter((e)=>!$b1c6e3a850a3c735$var$__PRIVATE_queryOrPipelineEqual(e, t))), void r.ec.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), $b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch($b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else $b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(r, i.targetId), await $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function $b1c6e3a850a3c735$var$__PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = n.ec.get(t), i = n.tc.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineWrite(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$export$890c4ad488842ce7.now(), i = t.reduce((e, t)=>e.add(t.key), $b1c6e3a850a3c735$export$78acf4525d8a74c4());
            let s, _;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let o = $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), a = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
                return n.Qo.getEntries(e, i).next((e)=>{
                    o = e, o.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, o)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const _ = [];
                    for (const e of t){
                        const t = $b1c6e3a850a3c735$var$__PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        _.push(new $b1c6e3a850a3c735$var$__PRIVATE_PatchMutation(e.key, t, $b1c6e3a850a3c735$var$__PRIVATE_extractFieldMask(t.value.mapValue), $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, _, t);
                }).next((t)=>{
                    _ = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: _.batchId,
                    changes: $b1c6e3a850a3c735$var$__PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.oc[e.currentUser.toKey()];
            r || (r = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.oc[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    try {
        const e = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.sc.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.Zu = !0 : e.modifiedDocuments.size > 0 ? $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(r.Zu, 14607) : e.removedDocuments.size > 0 && ($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(r.Zu, 42227), r.Zu = !1));
        }), await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await $b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.ec.forEach((n, r)=>{
            const i = r.view.Ru(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.Eu)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.Ru(t) && (r = !0);
            }), r && $b1c6e3a850a3c735$var$__PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Xu.zn(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.sc.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, $b1c6e3a850a3c735$var$MutableDocument.newNoDocument(s, $b1c6e3a850a3c735$var$SnapshotVersion.min()));
        const n = $b1c6e3a850a3c735$export$78acf4525d8a74c4().add(s), i = new $b1c6e3a850a3c735$var$RemoteEvent($b1c6e3a850a3c735$var$SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$var$__PRIVATE_primitiveComparator), e, $b1c6e3a850a3c735$var$__PRIVATE_mutableDocumentMap(), n);
        await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.rc = r.rc.remove(s), r.sc.delete(t), $b1c6e3a850a3c735$var$__PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>$b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(r, t, n)).catch($b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        $b1c6e3a850a3c735$var$__PRIVATE_processUserCallback(n, r, /*error=*/ null), $b1c6e3a850a3c735$var$__PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await $b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>($b1c6e3a850a3c735$var$__PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        $b1c6e3a850a3c735$var$__PRIVATE_processUserCallback(r, t, n), $b1c6e3a850a3c735$var$__PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await $b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    $b1c6e3a850a3c735$var$__PRIVATE_canUseNetwork(n.remoteStore) || $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $b1c6e3a850a3c735$var$$) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.ac.get(e) || [];
        r.push(t), n.ac.set(e, r);
    } catch (e) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.ac.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.ac.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function $b1c6e3a850a3c735$var$__PRIVATE_processUserCallback(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    let i = r.oc[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.oc[r.currentUser.toKey()] = i;
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.tc.get(t))e.ec.delete(r), n && e.Xu.Ec(r, n);
    if (e.tc.delete(t), e.isPrimaryClient) e._c.s_(t).forEach((t)=>{
        e._c.containsKey(t) || // We removed the last reference for this key
        $b1c6e3a850a3c735$var$__PRIVATE_removeLimboTarget(e, t);
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_removeLimboTarget(e, t) {
    e.nc.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.rc.get(t);
    null !== n && ($b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.rc = e.rc.remove(t), e.sc.delete(n), $b1c6e3a850a3c735$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function $b1c6e3a850a3c735$var$__PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof $b1c6e3a850a3c735$var$__PRIVATE_AddedLimboDocument) e._c.addReference(r.key, t), $b1c6e3a850a3c735$var$__PRIVATE_trackLimboChange(e, r);
    else if (r instanceof $b1c6e3a850a3c735$var$__PRIVATE_RemovedLimboDocument) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "Document no longer in limbo: " + r.key), e._c.removeReference(r.key, t);
        e._c.containsKey(r.key) || // We removed the last reference for this key
        $b1c6e3a850a3c735$var$__PRIVATE_removeLimboTarget(e, r.key);
    } else $b1c6e3a850a3c735$export$8743009a87fcb00f(19791, {
        hc: r
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.rc.get(n) || e.nc.has(r) || ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "New document in limbo: " + n), e.nc.add(r), $b1c6e3a850a3c735$var$__PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.nc.size > 0 && e.rc.size < e.maxConcurrentLimboResolutions;){
        const t = e.nc.values().next().value;
        e.nc.delete(t);
        const n = new $b1c6e3a850a3c735$export$90a7f3efeed30595($b1c6e3a850a3c735$export$db202ddc8be9136.fromString(t)), r = e.uc.next();
        e.sc.set(r, new $b1c6e3a850a3c735$var$LimboResolution(n)), e.rc = e.rc.insert(n, r), $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreListen(e.remoteStore, new $b1c6e3a850a3c735$var$TargetData($b1c6e3a850a3c735$var$__PRIVATE_queryToTarget($b1c6e3a850a3c735$export$7910e0436ed8d1de(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , $b1c6e3a850a3c735$var$__PRIVATE_ListenSequence.ce));
    }
}
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), i = [], s = [], _ = [];
    r.ec.isEmpty() || (r.ec.forEach((e, o)=>{
        _.push(r.lc(o, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(o.targetId)?.current;
                r.sharedClientState.updateQueryState(o.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = $b1c6e3a850a3c735$var$__PRIVATE_LocalViewChanges.vo(o.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(_), r.Xu.zn(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(t, (t)=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(t.wo, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.forEach(t.bo, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!$b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$un, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.$o.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.$o = n.$o.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "User change. New user:", t.toKey());
        const e = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.ac.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.CANCELLED, t));
                });
            }), e.ac.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.zo);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = n.sc.get(t);
    if (r && r.Zu) return $b1c6e3a850a3c735$export$78acf4525d8a74c4().add(r.key);
    {
        let e = $b1c6e3a850a3c735$export$78acf4525d8a74c4();
        const r = n.tc.get(t);
        if (!r) return e;
        for (const t of r ?? []){
            const r = n.ec.get(t);
            e = e.unionWith(r.view.Uu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.Ju(r);
    return n.isPrimaryClient && $b1c6e3a850a3c735$var$__PRIVATE_updateTrackedLimbos(n, t.targetId, i.ju), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>$b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.ps(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : $b1c6e3a850a3c735$var$PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    ($b1c6e3a850a3c735$var$__PRIVATE_processUserCallback(i, t, r || null), $b1c6e3a850a3c735$var$__PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_debugCast($b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).mutationQueue).bs(t);
    }(i.localStore, t)) : $b1c6e3a850a3c735$export$8743009a87fcb00f(6720, "Unknown batchState", {
        Tc: n
    }), await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    if ($b1c6e3a850a3c735$var$__PRIVATE_ensureWatchCallbacks(n), $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.cc) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await $b1c6e3a850a3c735$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.cc = !0, await $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)$b1c6e3a850a3c735$var$__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.cc) {
        const e = [];
        let t = Promise.resolve();
        n.tc.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>($b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(n, i), $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await $b1c6e3a850a3c735$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            t.sc.forEach((e, n)=>{
                $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t._c.__(), t.sc = new Map, t.rc = new $b1c6e3a850a3c735$var$SortedMap($b1c6e3a850a3c735$export$90a7f3efeed30595.comparator);
        }(n), n.cc = !1, await $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function $b1c6e3a850a3c735$var$__PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.tc.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(r.localStore, $b1c6e3a850a3c735$export$a07804094c3ecf2d(n[0]) ? n[0] : $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.ec.get(e), n = await $b1c6e3a850a3c735$var$__PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(r.localStore, n), await $b1c6e3a850a3c735$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $b1c6e3a850a3c735$var$__PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Xu.zn(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function $b1c6e3a850a3c735$var$__PRIVATE_synthesizeTargetToQuery(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_targetIsPipelineTarget(e) ? e : $b1c6e3a850a3c735$var$__PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_debugCast($b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).persistence).po();
    }($b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    if (i.cc) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "Ignoring unexpected query state notification.");
    const s = i.tc.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                let e;
                if ($b1c6e3a850a3c735$export$a07804094c3ecf2d(s[0])) switch($b1c6e3a850a3c735$var$getPipelineSourceType(s[0])){
                    case "collection_group":
                    case "collection":
                        e = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, $b1c6e3a850a3c735$var$getPipelineCollectionId(s[0]));
                        break;
                    case "documents":
                        e = await function __PRIVATE_localStoreGetDocuments(e, t) {
                            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$export$78acf4525d8a74c4(...$b1c6e3a850a3c735$var$getPipelineDocuments(t).map((e)=>$b1c6e3a850a3c735$export$90a7f3efeed30595.fromPath(e)));
                            return n.persistence.runTransaction("Get documents for pipeline", "readonly", (e)=>n.Qo.getEntries(e, r)).then((e)=>e);
                        }(i.localStore, s[0]);
                        break;
                    default:
                        $b1c6e3a850a3c735$export$ee7c8ad385a60b7b(""), e = $b1c6e3a850a3c735$var$documentMap();
                }
                else e = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetNewDocumentChanges(i.localStore, function __PRIVATE_queryCollectionGroup(e) {
                    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
                }(s[0]));
                const r = $b1c6e3a850a3c735$var$RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, $b1c6e3a850a3c735$export$158acd800e1ef08b.EMPTY_BYTE_STRING);
                await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), $b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            $b1c6e3a850a3c735$export$8743009a87fcb00f(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchCallbacks(e);
    if (r.cc) {
        for (const e of t){
            if (r.tc.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$An, "Adding an already active target " + e);
                continue;
            }
            const t = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await $b1c6e3a850a3c735$var$__PRIVATE_initializeViewAndComputeSnapshot(r, $b1c6e3a850a3c735$var$__PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.tc.has(e) && // Release queries that are still active.
        await $b1c6e3a850a3c735$var$__PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreUnlisten(r.remoteStore, e), $b1c6e3a850a3c735$var$__PRIVATE_removeAndCleanupTarget(r, e);
        }).catch($b1c6e3a850a3c735$var$__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function $b1c6e3a850a3c735$var$__PRIVATE_ensureWatchCallbacks(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineRejectListen.bind(null, t), t.Xu.zn = $b1c6e3a850a3c735$var$__PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Xu.Ec = $b1c6e3a850a3c735$var$__PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = $b1c6e3a850a3c735$var$__PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.w_.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress($b1c6e3a850a3c735$var$__PRIVATE_bundleInitialProgress(r));
            const i = new $b1c6e3a850a3c735$export$61196ced6d74a310(r, t.serializer);
            let s = await t.Pc();
            for(; s;){
                const e = await i.o(s);
                e && n._updateProgress(e), s = await t.Pc();
            }
            const _ = await i.xu(e.localStore);
            return await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, _.Fu, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.w_.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(_.progress), Promise.resolve(_.Cu);
        } catch (e) {
            return $b1c6e3a850a3c735$export$ee7c8ad385a60b7b($b1c6e3a850a3c735$var$An, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class $b1c6e3a850a3c735$export$1fbe638ecf81657e {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = $b1c6e3a850a3c735$export$b4171a6734a65d42(e.databaseInfo.databaseId), this.sharedClientState = this.Rc(e), this.persistence = this.Ic(e), await this.persistence.start(), this.localStore = this.Ac(e), this.gcScheduler = this.Vc(e, this.localStore), this.indexBackfillerScheduler = this.dc(e, this.localStore);
    }
    Vc(e, t) {
        return null;
    }
    dc(e, t) {
        return null;
    }
    Ac(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_newLocalStore(this.persistence, new $b1c6e3a850a3c735$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Ic(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemoryPersistence($b1c6e3a850a3c735$var$__PRIVATE_MemoryEagerDelegate.C_, this.serializer);
    }
    Rc(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
$b1c6e3a850a3c735$export$1fbe638ecf81657e.provider = {
    build: ()=>new $b1c6e3a850a3c735$export$1fbe638ecf81657e
};
class $b1c6e3a850a3c735$export$493d36ec626b6698 extends $b1c6e3a850a3c735$export$1fbe638ecf81657e {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Vc(e, t) {
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof $b1c6e3a850a3c735$var$__PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $b1c6e3a850a3c735$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Ic(e) {
        const t = void 0 !== this.cacheSizeBytes ? $b1c6e3a850a3c735$var$LruParams.withCacheSize(this.cacheSizeBytes) : $b1c6e3a850a3c735$var$LruParams.DEFAULT;
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemoryPersistence((e)=>$b1c6e3a850a3c735$var$__PRIVATE_MemoryLruDelegate.C_(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class $b1c6e3a850a3c735$export$d66dc83d8cfc8dd extends $b1c6e3a850a3c735$export$1fbe638ecf81657e {
    constructor(e, t, n){
        super(), this.fc = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.fc.initialize(this, e), // Enqueue writes from a previous session
        await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineEnsureWriteCallbacks(this.fc.syncEngine), await $b1c6e3a850a3c735$var$__PRIVATE_fillWritePipeline(this.fc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence._o(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    Ac(e) {
        return $b1c6e3a850a3c735$var$__PRIVATE_newLocalStore(this.persistence, new $b1c6e3a850a3c735$var$__PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Vc(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new $b1c6e3a850a3c735$var$__PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    dc(e, t) {
        const n = new $b1c6e3a850a3c735$var$__PRIVATE_IndexBackfiller(t, this.persistence);
        return new $b1c6e3a850a3c735$var$__PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Ic(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? $b1c6e3a850a3c735$var$LruParams.withCacheSize(this.cacheSizeBytes) : $b1c6e3a850a3c735$var$LruParams.DEFAULT;
        return new $b1c6e3a850a3c735$var$__PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, $b1c6e3a850a3c735$var$__PRIVATE_getWindow(), $b1c6e3a850a3c735$var$getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Rc(e) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class $b1c6e3a850a3c735$export$92108d983e8ee699 extends $b1c6e3a850a3c735$export$d66dc83d8cfc8dd {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.fc = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.fc.syncEngine;
        this.sharedClientState instanceof $b1c6e3a850a3c735$var$__PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Na: $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyBatchState.bind(null, t),
            La: $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Ba: $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            po: $b1c6e3a850a3c735$var$__PRIVATE_syncEngineGetActiveClients.bind(null, t),
            Ma: $b1c6e3a850a3c735$var$__PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence._o(async (e)=>{
            await $b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyPrimaryState(this.fc.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Rc(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_getWindow();
        if (!$b1c6e3a850a3c735$var$__PRIVATE_WebStorageSharedClientState.C(t)) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = $b1c6e3a850a3c735$var$__PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new $b1c6e3a850a3c735$var$__PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class $b1c6e3a850a3c735$export$6554612db691658e {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>$b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await $b1c6e3a850a3c735$var$__PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new $b1c6e3a850a3c735$var$__PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = $b1c6e3a850a3c735$export$b4171a6734a65d42(e.databaseInfo.databaseId), n = $b1c6e3a850a3c735$var$__PRIVATE_newConnection(e.databaseInfo);
        return $b1c6e3a850a3c735$var$__PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new $b1c6e3a850a3c735$var$__PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>$b1c6e3a850a3c735$var$__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return $b1c6e3a850a3c735$var$__PRIVATE_BrowserConnectivityMonitor.C() ? new $b1c6e3a850a3c735$var$__PRIVATE_BrowserConnectivityMonitor : new $b1c6e3a850a3c735$var$__PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, _) {
            const o = new $b1c6e3a850a3c735$var$__PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return _ && (o.cc = !0), o;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Rn, "RemoteStore shutting down."), t.tu.add(5 /* OfflineCause.Shutdown */ ), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(t), t.ru.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.iu.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
$b1c6e3a850a3c735$export$6554612db691658e.provider = {
    build: ()=>new $b1c6e3a850a3c735$export$6554612db691658e
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.mc(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.mc(this.observer.error, e) : $b1c6e3a850a3c735$var$__PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    gc() {
        this.muted = !0;
    }
    mc(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.yc = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.wc = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.bc().then((e)=>{
            e && e.yu() ? this.metadata.resolve(e.gu.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.gu)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.yc.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Pc() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.bc();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async bc() {
        const e = await this.vc();
        if (null === e) return null;
        const t = this.wc.decode(e), n = Number(t);
        isNaN(n) && this.Sc(`length string (${t}) is not valid number`);
        const r = await this.Dc(n);
        return new $b1c6e3a850a3c735$var$__PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ xc() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async vc() {
        for(; this.xc() < 0;){
            if (await this.Cc()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.xc();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.Sc("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Dc(e) {
        for(; this.buffer.length < e;)await this.Cc() && this.Sc("Reached the end of bundle when more is expected.");
        const t = this.wc.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    Sc(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.yc.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Cc() {
        const e = await this.yc.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Pc();
        if (!n || !n.yu()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.gu)}`);
        this.metadata = n;
        do n = this.Pc(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ t() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Pc() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.vc(), t = this.Dc(e);
        return new $b1c6e3a850a3c735$var$__PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ Dc(e) {
        if (this.cursor + e > this.bundleData.length) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ vc() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class $b1c6e3a850a3c735$var$Transaction {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_toName(n.serializer, e))
            }, i = await n.$t("BatchGetDocuments", n.serializer.databaseId, $b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = $b1c6e3a850a3c735$var$__PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const _ = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(!!t, 55234, {
                    key: e
                }), _.push(t);
            }), _;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new $b1c6e3a850a3c735$export$6559d589eb85fbb6(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = $b1c6e3a850a3c735$export$90a7f3efeed30595.fromPath(t);
            this.mutations.push(new $b1c6e3a850a3c735$var$__PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>$b1c6e3a850a3c735$var$toMutation(n.serializer, e))
            };
            await n.Bt("Commit", n.serializer.databaseId, $b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw $b1c6e3a850a3c735$export$8743009a87fcb00f(50498, {
                Oc: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = $b1c6e3a850a3c735$var$SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min()) ? $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.exists(!1) : $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.updateTime(t) : $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual($b1c6e3a850a3c735$var$SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class $b1c6e3a850a3c735$var$__PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Mc = n.maxAttempts, this.xn = new $b1c6e3a850a3c735$var$__PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Nc() {
        this.Mc -= 1, this.Lc();
    }
    Lc() {
        this.xn.mn(async ()=>{
            const e = new $b1c6e3a850a3c735$var$Transaction(this.datastore), t = this.Bc(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Uc(e);
                    }));
            }).catch((e)=>{
                this.Uc(e);
            });
        });
    }
    Bc(e) {
        try {
            const t = this.updateFunction(e);
            return !$b1c6e3a850a3c735$var$__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Uc(e) {
        this.Mc > 0 && this.kc(e) ? (this.Mc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Lc(), Promise.resolve()))) : this.deferred.reject(e);
    }
    kc(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !$b1c6e3a850a3c735$var$__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$Vn = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class $b1c6e3a850a3c735$var$FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = $b1c6e3a850a3c735$var$User.UNAUTHENTICATED, this.clientId = $b1c6e3a850a3c735$export$971d5caa766a69d7.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this._databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function $b1c6e3a850a3c735$var$__PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await $b1c6e3a850a3c735$var$__PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function $b1c6e3a850a3c735$var$__PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await $b1c6e3a850a3c735$var$__PRIVATE_ensureOfflineComponents(e);
    $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>$b1c6e3a850a3c735$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>$b1c6e3a850a3c735$var$__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function $b1c6e3a850a3c735$var$__PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Using user provided OfflineComponentProvider");
            try {
                await $b1c6e3a850a3c735$var$__PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === $b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION || e.code === $b1c6e3a850a3c735$export$f1e1789686576879.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                $b1c6e3a850a3c735$export$ee7c8ad385a60b7b("Error using user provided cache. Falling back to memory cache: " + n), await $b1c6e3a850a3c735$var$__PRIVATE_setOfflineComponentProvider(e, new $b1c6e3a850a3c735$export$1fbe638ecf81657e);
            }
        } else $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Using default OfflineComponentProvider"), await $b1c6e3a850a3c735$var$__PRIVATE_setOfflineComponentProvider(e, new $b1c6e3a850a3c735$export$493d36ec626b6698(void 0));
    }
    return e._offlineComponents;
}
async function $b1c6e3a850a3c735$var$__PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Using user provided OnlineComponentProvider"), await $b1c6e3a850a3c735$var$__PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : ($b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Vn, "Using default OnlineComponentProvider"), await $b1c6e3a850a3c735$var$__PRIVATE_setOnlineComponentProvider(e, new $b1c6e3a850a3c735$export$6554612db691658e))), e._onlineComponents;
}
function $b1c6e3a850a3c735$var$__PRIVATE_getPersistence(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function $b1c6e3a850a3c735$var$__PRIVATE_getRemoteStore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function $b1c6e3a850a3c735$var$__PRIVATE_getSyncEngine(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function $b1c6e3a850a3c735$var$__PRIVATE_getDatastore(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e) {
    const t = await $b1c6e3a850a3c735$var$__PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = $b1c6e3a850a3c735$var$__PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = $b1c6e3a850a3c735$var$__PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = $b1c6e3a850a3c735$var$__PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $b1c6e3a850a3c735$var$__PRIVATE_getPersistence(e), n = await $b1c6e3a850a3c735$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            return t.tu.delete(0 /* OfflineCause.UserDisabled */ ), $b1c6e3a850a3c735$var$__PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await $b1c6e3a850a3c735$var$__PRIVATE_getPersistence(e), n = await $b1c6e3a850a3c735$var$__PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            t.tu.add(0 /* OfflineCause.UserDisabled */ ), await $b1c6e3a850a3c735$var$__PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.iu.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function $b1c6e3a850a3c735$export$555508cbc6add439(e, t, n, r) {
    const i = new $b1c6e3a850a3c735$var$__PRIVATE_AsyncObserver(r), s = new $b1c6e3a850a3c735$var$__PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(async ()=>$b1c6e3a850a3c735$var$__PRIVATE_eventManagerListen(await $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e), s)), ()=>{
        i.gc(), e.asyncQueue.enqueueAndForget(async ()=>$b1c6e3a850a3c735$var$__PRIVATE_eventManagerUnlisten(await $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e), s));
    };
}
function $b1c6e3a850a3c735$export$2e2af4578d910ddf(e, t) {
    const n = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $b1c6e3a850a3c735$export$a8550f7dbe79f93a(e, t, n = {}) {
    const r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new $b1c6e3a850a3c735$var$__PRIVATE_AsyncObserver({
                next: (o)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.gc(), t.enqueueAndForget(()=>$b1c6e3a850a3c735$var$__PRIVATE_eventManagerUnlisten(e, _));
                    const a = o.docs.has(n);
                    !a && o.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && o.fromCache && r && "server" === r.source ? i.reject(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(o);
                },
                error: (e)=>i.reject(e)
            }), _ = new $b1c6e3a850a3c735$var$__PRIVATE_QueryListener($b1c6e3a850a3c735$export$7910e0436ed8d1de(n.path), s, {
                includeMetadataChanges: !0,
                waitForSyncWhenOnline: !0
            });
            return $b1c6e3a850a3c735$var$__PRIVATE_eventManagerListen(e, _);
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $b1c6e3a850a3c735$export$c3950d9923825c02(e, t) {
    const n = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await $b1c6e3a850a3c735$var$__PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new $b1c6e3a850a3c735$var$__PRIVATE_View(t, r.Jo), s = i.ku(r.documents), _ = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(_.snapshot);
            } catch (e) {
                const r = $b1c6e3a850a3c735$var$__PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function $b1c6e3a850a3c735$export$a93c5207d687da10(e, t, n = {}) {
    const r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new $b1c6e3a850a3c735$var$__PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.gc(), t.enqueueAndForget(()=>$b1c6e3a850a3c735$var$__PRIVATE_eventManagerUnlisten(e, _)), n.fromCache && "server" === r.source ? i.reject(new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), _ = new $b1c6e3a850a3c735$var$__PRIVATE_QueryListener(n instanceof $b1c6e3a850a3c735$var$__PRIVATE_RealtimePipeline ? $b1c6e3a850a3c735$var$__PRIVATE_toCorePipeline(n) : n, s, {
                includeMetadataChanges: !0,
                waitForSyncWhenOnline: !0
            });
            return $b1c6e3a850a3c735$var$__PRIVATE_eventManagerListen(e, _);
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function $b1c6e3a850a3c735$export$2329c99376c9d0a4(e, t, n) {
    const r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await $b1c6e3a850a3c735$var$__PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), { request: i, wt: s, parent: _ } = $b1c6e3a850a3c735$var$__PRIVATE_toRunAggregationQueryRequest(r.serializer, $b1c6e3a850a3c735$var$__PRIVATE_queryToAggregateTarget(t), n);
                r.connection.Ot || delete i.parent;
                const o = (await r.$t("RunAggregationQuery", r.serializer.databaseId, _, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                $b1c6e3a850a3c735$var$__PRIVATE_hardAssert(1 === o.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = o[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function $b1c6e3a850a3c735$export$62d08d6fa708df47(e, t) {
    const n = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        try {
            const r = await $b1c6e3a850a3c735$var$__PRIVATE_getDatastore(e);
            n.resolve(async function __PRIVATE_invokeExecutePipeline(e, t) {
                const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = {
                    database: $b1c6e3a850a3c735$var$__PRIVATE_getEncodedDatabaseId(n.serializer),
                    structuredPipeline: t._toProto(n.serializer)
                }, i = await n.$t("ExecutePipeline", n.serializer.databaseId, $b1c6e3a850a3c735$export$db202ddc8be9136.emptyPath(), r), s = [];
                return i.forEach((e)=>{
                    if (e.results && 0 !== e.results.length) return e.results.forEach((t)=>s.push($b1c6e3a850a3c735$var$__PRIVATE_fromPipelineResponse(n.serializer, e, t)));
                    s.push($b1c6e3a850a3c735$var$__PRIVATE_fromPipelineResponse(n.serializer, e));
                }), s;
            }(r, t));
        } catch (e) {
            n.reject(e);
        }
    }), n.promise;
}
function $b1c6e3a850a3c735$export$c9170ad7d4cd7e57(e, t) {
    const n = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>$b1c6e3a850a3c735$var$__PRIVATE_syncEngineWrite(await $b1c6e3a850a3c735$var$__PRIVATE_getSyncEngine(e), t, n)), n.promise;
}
function $b1c6e3a850a3c735$export$f787f51d84a910ad(e, t) {
    const n = new $b1c6e3a850a3c735$var$__PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).Pu.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e), n)), ()=>{
        n.gc(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).Pu.delete(t);
            })(await $b1c6e3a850a3c735$var$__PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function $b1c6e3a850a3c735$export$efca4cbe5dd06740(e, t, n) {
    const r = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        const i = await $b1c6e3a850a3c735$var$__PRIVATE_getDatastore(e);
        new $b1c6e3a850a3c735$var$__PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Nc();
    }), r.promise;
}
function $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? $b1c6e3a850a3c735$var$__PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new $b1c6e3a850a3c735$var$__PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return $b1c6e3a850a3c735$var$__PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return $b1c6e3a850a3c735$var$__PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, $b1c6e3a850a3c735$export$b4171a6734a65d42(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        $b1c6e3a850a3c735$var$__PRIVATE_syncEngineLoadBundle(await $b1c6e3a850a3c735$var$__PRIVATE_getSyncEngine(e), i, r);
    });
}
function $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.w_.getNamedQuery(e, t));
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e), t));
}
function $b1c6e3a850a3c735$export$3466f893ebf79586(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new $b1c6e3a850a3c735$var$__PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function $b1c6e3a850a3c735$export$ab83b03e4111b1d0(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>(function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, _ = t.length;
                        let o = 0, a = 0;
                        for(; o < _ && a < s;){
                            const s = n(e[a], t[o]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[o++]) : (o++, a++);
                        }
                        for(; o < _;)r(t[o++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, $b1c6e3a850a3c735$var$__PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>$b1c6e3a850a3c735$var$PersistencePromise.waitFor(i)));
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e), t));
}
function $b1c6e3a850a3c735$export$7a38258bbe170828(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e).qo.Do = t;
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e), t));
}
function $b1c6e3a850a3c735$export$1a82df3d29112e01(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = $b1c6e3a850a3c735$var$__PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await $b1c6e3a850a3c735$var$__PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b1c6e3a850a3c735$var$dn = "AsyncQueue";
class $b1c6e3a850a3c735$var$__PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.qc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.$c = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Kc = [], // visible for testing
        this.Wc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Qc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Gc = !1, // List of TimerIds to fast-forward delays for.
        this.zc = [], // Backoff timer used to schedule retries for retryable operations
        this.xn = new $b1c6e3a850a3c735$var$__PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.jc = ()=>{
            const e = $b1c6e3a850a3c735$var$getDocument();
            e && $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$dn, "Visibility state changed to " + e.visibilityState), this.xn.gn();
        }, this.Hc = e;
        const t = $b1c6e3a850a3c735$var$getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.jc);
    }
    get isShuttingDown() {
        return this.$c;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.Jc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Yc(e);
    }
    enterRestrictedMode(e) {
        if (!this.$c) {
            this.$c = !0, this.Gc = e || !1;
            const t = $b1c6e3a850a3c735$var$getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.jc);
        }
    }
    enqueue(e) {
        if (this.Jc(), this.$c) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
        return this.Yc(()=>this.$c && this.Gc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.qc.push(e), this.Zc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async Zc() {
        if (0 !== this.qc.length) {
            try {
                await this.qc[0](), this.qc.shift(), this.xn.reset();
            } catch (e) {
                if (!$b1c6e3a850a3c735$var$__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$dn, "Operation failed with retryable error: " + e);
            }
            this.qc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.xn.mn(()=>this.Zc());
        }
    }
    Yc(e) {
        const t = this.Hc.then(()=>(this.Qc = !0, e().catch((e)=>{
                this.Wc = e, this.Qc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw $b1c6e3a850a3c735$var$__PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", $b1c6e3a850a3c735$var$__PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.Qc = !1, e))));
        return this.Hc = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.Jc(), // Fast-forward delays for timerIds that have been overridden.
        this.zc.indexOf(e) > -1 && (t = 0);
        const r = $b1c6e3a850a3c735$var$DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.Xc(e));
        return this.Kc.push(r), r;
    }
    Jc() {
        this.Wc && $b1c6e3a850a3c735$export$8743009a87fcb00f(47125, {
            el: $b1c6e3a850a3c735$var$__PRIVATE_getMessageOrStack(this.Wc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async tl() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.Hc, await e;
        while (e !== this.Hc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ nl(e) {
        for (const t of this.Kc)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ rl(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.tl().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Kc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.Kc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.tl();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ il(e) {
        this.zc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ Xc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.Kc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Kc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function $b1c6e3a850a3c735$var$__PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ class $b1c6e3a850a3c735$export$9d398bebfec1c039 {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const $b1c6e3a850a3c735$export$9fa96a7d116ea3ce = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class $b1c6e3a850a3c735$export$d66501df72047452 extends $b1c6e3a850a3c735$var$Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new $b1c6e3a850a3c735$var$__PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new $b1c6e3a850a3c735$var$__PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function $b1c6e3a850a3c735$export$8c78c7c36408ea29(e, t, n) {
    n || (n = $b1c6e3a850a3c735$var$st);
    const r = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, $029952e65115eee5$export$9cb4719e2e525b7a)(i, t)) return e;
        throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < $b1c6e3a850a3c735$var$Ut) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, $029952e65115eee5$export$5b4d24b45140ad90)(t.host) && (0, $029952e65115eee5$export$c0f0d0ce4283a937)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function $b1c6e3a850a3c735$export$a17c37559e1db147(e, n) {
    const r = "object" == typeof e ? e : (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), i = "string" == typeof e ? e : n || $b1c6e3a850a3c735$var$st, s = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)("firestore");
        e && $b1c6e3a850a3c735$export$667d3bf0c5f83305(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function $b1c6e3a850a3c735$export$df995fae86a55f06(e) {
    if (e._terminated) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || $b1c6e3a850a3c735$var$__PRIVATE_configureFirestore(e), e._firestoreClient;
}
function $b1c6e3a850a3c735$var$__PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = $b1c6e3a850a3c735$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e._app?.options.appId || "", e._persistenceKey, e._app?.options.apiKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new $b1c6e3a850a3c735$var$FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function $b1c6e3a850a3c735$export$1a8f5705751d8277(e, t) {
    $b1c6e3a850a3c735$export$ee7c8ad385a60b7b("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return $b1c6e3a850a3c735$var$__PRIVATE_setPersistenceProviders(e, $b1c6e3a850a3c735$export$6554612db691658e.provider, {
        build: (e)=>new $b1c6e3a850a3c735$export$d66dc83d8cfc8dd(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function $b1c6e3a850a3c735$export$e171bab687b50e0(e) {
    $b1c6e3a850a3c735$export$ee7c8ad385a60b7b("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    $b1c6e3a850a3c735$var$__PRIVATE_setPersistenceProviders(e, $b1c6e3a850a3c735$export$6554612db691658e.provider, {
        build: (e)=>new $b1c6e3a850a3c735$export$92108d983e8ee699(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function $b1c6e3a850a3c735$var$__PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$export$d66501df72047452))._firestoreClient || e._terminated) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, $b1c6e3a850a3c735$var$__PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function $b1c6e3a850a3c735$export$f96d196f7728bb5(e) {
    if (e._initialized && !e._terminated) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!$b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.C()) return Promise.resolve();
                const t = e + $b1c6e3a850a3c735$var$an;
                await $b1c6e3a850a3c735$var$__PRIVATE_SimpleDb.delete(t);
            }($b1c6e3a850a3c735$var$__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function $b1c6e3a850a3c735$export$ad4aebacdcaf47f8(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new $b1c6e3a850a3c735$var$__PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>$b1c6e3a850a3c735$var$__PRIVATE_syncEngineRegisterPendingWritesCallback(await $b1c6e3a850a3c735$var$__PRIVATE_getSyncEngine(e), t)), t.promise;
    }($b1c6e3a850a3c735$export$df995fae86a55f06(e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$export$d66501df72047452)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function $b1c6e3a850a3c735$export$527e9aa3390079e9(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientEnableNetwork($b1c6e3a850a3c735$export$df995fae86a55f06(e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$export$d66501df72047452)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function $b1c6e3a850a3c735$export$1ee57be6f6687d2c(e) {
    return $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientDisableNetwork($b1c6e3a850a3c735$export$df995fae86a55f06(e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$export$d66501df72047452)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function $b1c6e3a850a3c735$export$c18d01048907ea92(e) {
    return (0, $5e587d655f0a08bb$export$48d18de2ff1c45a5)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function $b1c6e3a850a3c735$export$2219238a014317b0(e, t) {
    const n = $b1c6e3a850a3c735$export$df995fae86a55f06(e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$export$d66501df72047452)), r = new $b1c6e3a850a3c735$export$9d398bebfec1c039;
    return $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function $b1c6e3a850a3c735$export$4c3d22f3d993c33f(e, t) {
    return $b1c6e3a850a3c735$var$__PRIVATE_firestoreClientGetNamedQuery($b1c6e3a850a3c735$export$df995fae86a55f06(e = $b1c6e3a850a3c735$export$4a5767248b18ef41(e, $b1c6e3a850a3c735$export$d66501df72047452)), t).then((t)=>t ? new $b1c6e3a850a3c735$export$3722cfe417b6ed86(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class $b1c6e3a850a3c735$export$ebd11618f299a286 {
    convertValue(e, t = "none") {
        switch($b1c6e3a850a3c735$var$__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes($b1c6e3a850a3c735$var$__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw $b1c6e3a850a3c735$export$8743009a87fcb00f(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return $b1c6e3a850a3c735$var$forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[$b1c6e3a850a3c735$var$ct].arrayValue?.values?.map((e)=>$b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.doubleValue));
        return new $b1c6e3a850a3c735$export$24baa2b76016ce0e(t);
    }
    convertGeoPoint(e) {
        return new $b1c6e3a850a3c735$export$91c6e00c14e7e6fd($b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.latitude), $b1c6e3a850a3c735$var$__PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = $b1c6e3a850a3c735$var$__PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp($b1c6e3a850a3c735$var$__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = $b1c6e3a850a3c735$var$__PRIVATE_normalizeTimestamp(e);
        return new $b1c6e3a850a3c735$export$890c4ad488842ce7(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = $b1c6e3a850a3c735$export$db202ddc8be9136.fromString(e);
        $b1c6e3a850a3c735$var$__PRIVATE_hardAssert($b1c6e3a850a3c735$var$__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new $b1c6e3a850a3c735$export$cf2f7c5792f80b46(n.get(1), n.get(3)), i = new $b1c6e3a850a3c735$export$90a7f3efeed30595(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        $b1c6e3a850a3c735$var$__PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd extends $b1c6e3a850a3c735$export$ebd11618f299a286 {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new $b1c6e3a850a3c735$export$ef35774e6d314e91(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new $b1c6e3a850a3c735$export$96f57966bedc81b4(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $b1c6e3a850a3c735$export$1314441b8d04e1d5 {
    constructor(e = {}, t = {}){
        this.sl = e, this._l = t, this.ol = new $b1c6e3a850a3c735$var$OptionsUtil({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    _readUserData(e) {
        this.proto = this.ol.getOptionsProto(e, this.sl, this._l);
    }
}
class $b1c6e3a850a3c735$export$c69d65aa55814164 {
    constructor(e, t){
        this.pipeline = e, this.options = t;
    }
    _toProto(e) {
        return {
            pipeline: this.pipeline._toProto(e),
            options: this.options.proto
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b1c6e3a850a3c735$export$91477dc880baac21(e) {
    const t = $b1c6e3a850a3c735$export$df995fae86a55f06($b1c6e3a850a3c735$export$4a5767248b18ef41(e.firestore, $b1c6e3a850a3c735$export$d66501df72047452)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : $b1c6e3a850a3c735$var$__PRIVATE_toQueryTarget(n, $b1c6e3a850a3c735$var$__PRIVATE_queryToTarget(e._query)).yt;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function $b1c6e3a850a3c735$export$23ebac1979863676(e, t) {
    const n = $b1c6e3a850a3c735$export$a9c23c6ac3fc3eca(t, (e, t)=>new $b1c6e3a850a3c735$export$d24c54395ce0c509(t, e.aggregateType, e._internalFieldPath)), r = $b1c6e3a850a3c735$export$df995fae86a55f06($b1c6e3a850a3c735$export$4a5767248b18ef41(e.firestore, $b1c6e3a850a3c735$export$d66501df72047452)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : $b1c6e3a850a3c735$var$__PRIVATE_toRunAggregationQueryRequest(i, $b1c6e3a850a3c735$var$__PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ !0).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function $b1c6e3a850a3c735$export$60e660859c376841(e) {
    if (!e._db) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "This pipeline was created without a database and cannot be serialized for execution.");
    const t = $b1c6e3a850a3c735$export$4a5767248b18ef41(e._db, $b1c6e3a850a3c735$export$d66501df72047452), n = $b1c6e3a850a3c735$export$39b482c5e57630a8(t).createContext(3 /* UserDataSource.Argument */ , "_internalPipelineToExecutePipelineRequestProto");
    e._readUserData(n);
    const r = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore$1(e) {
        if (e._terminated) throw new $b1c6e3a850a3c735$export$4368d992c4eafac0($b1c6e3a850a3c735$export$f1e1789686576879.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!$b1c6e3a850a3c735$var$Mt.has(e)) {
            $b1c6e3a850a3c735$export$306ddfe3a8403e2($b1c6e3a850a3c735$var$Ot, "Initializing Datastore");
            const t = $b1c6e3a850a3c735$var$__PRIVATE_newConnection($b1c6e3a850a3c735$var$__PRIVATE_makeDatabaseInfo(e._databaseId, e.app.options.appId || "", e._persistenceKey, e.app.options.apiKey, e._freezeSettings())), n = $b1c6e3a850a3c735$export$b4171a6734a65d42(e._databaseId), r = $b1c6e3a850a3c735$var$__PRIVATE_newDatastore(e._authCredentials, e._appCheckCredentials, t, n);
            $b1c6e3a850a3c735$var$Mt.set(e, r);
        }
        return $b1c6e3a850a3c735$var$Mt.get(e);
    }(t), i = r.serializer;
    if (void 0 === i) return null;
    const s = new $b1c6e3a850a3c735$export$c69d65aa55814164(e, new $b1c6e3a850a3c735$export$1314441b8d04e1d5);
    return {
        database: $b1c6e3a850a3c735$var$__PRIVATE_getEncodedDatabaseId(i),
        structuredPipeline: s._toProto(i)
    };
}







const $a33cbddcd7bfa0a9$var$Yt = "@firebase/firestore", $a33cbddcd7bfa0a9$var$Kt = "4.16.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class $a33cbddcd7bfa0a9$export$fada2345be8928cf {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType - Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath - Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class $a33cbddcd7bfa0a9$export$40257fef64be808b {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ _fieldsProto() {
        // Return the cloned value to prevent manipulation of the Snapshot's data
        return new (0, $b1c6e3a850a3c735$export$c4ce752e73470fba)({
            mapValue: {
                fields: this._data
            }
        }).clone().value.mapValue.fields;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, r, s){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = s;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new (0, $b1c6e3a850a3c735$export$96f57966bedc81b4)(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new $a33cbddcd7bfa0a9$var$QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ _fieldsProto() {
        // Return a cloned value to prevent manipulation of the Snapshot's data
        return this._document?.data.clone().value.mapValue.fields ?? void 0;
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field((0, $b1c6e3a850a3c735$export$35e795649ee09318)("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class $a33cbddcd7bfa0a9$var$QueryDocumentSnapshot$1 extends $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
}
function $a33cbddcd7bfa0a9$export$2fa187e846a241c4(t, e, ...n) {
    let r = [];
    e instanceof $a33cbddcd7bfa0a9$var$AppliableConstraint && r.push(e), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2).length, n = t.filter((t)=>t instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439).length;
        if (e > 1 || e > 0 && n > 0) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const e of r)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$f765fc5789dfd439 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$f765fc5789dfd439(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(t._query, e), new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $b1c6e3a850a3c735$export$2d1720544b23b823)(t._query, e));
    }
    _parse(t) {
        const e = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(t.firestore), n = function __PRIVATE_newQueryFilter(t, e, n, r, s, a, o) {
            let i;
            if (s.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === a || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === a) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
                if ("in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a) {
                    $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(o, a);
                    const e = [];
                    for (const n of o)e.push($a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, t, n));
                    i = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else i = $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(r, t, o);
            } else "in" /* Operator.IN */  !== a && "not-in" /* Operator.NOT_IN */  !== a && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== a || $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(o, a), i = (0, $b1c6e3a850a3c735$export$dda1d9f60106f0e9)(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a);
            const c = (0, $b1c6e3a850a3c735$export$23f2a1d2818174ef).create(s, a, i);
            return c;
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$9c59b80dda569a6e(t, e, n) {
    const r = e, s = (0, $b1c6e3a850a3c735$export$35e795649ee09318)("where", t);
    return $a33cbddcd7bfa0a9$export$f765fc5789dfd439._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2 extends $a33cbddcd7bfa0a9$var$AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : (0, $b1c6e3a850a3c735$export$e7094788287c5e9b).create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let n = t;
            const r = e.getFlattenedFilters();
            for (const t of r)$a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(n, t), n = (0, $b1c6e3a850a3c735$export$2d1720544b23b823)(n, t);
        }(t._query, e), new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $b1c6e3a850a3c735$export$2d1720544b23b823)(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$252bb8b3bbdf6749(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("or", t)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function $a33cbddcd7bfa0a9$export$21c0ac7fe1cef1b8(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>$a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint("and", t)), $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, n) {
            if (null !== t.startAt) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new (0, $b1c6e3a850a3c735$export$8a5498727ef6be21)(e, n);
            return r;
        }(t._query, this._field, this._direction);
        return new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $b1c6e3a850a3c735$export$342063e11d6c3cad)(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f18af21d6f4dafd8(t, e = "asc") {
    const n = e, r = (0, $b1c6e3a850a3c735$export$35e795649ee09318)("orderBy", t);
    return $a33cbddcd7bfa0a9$export$65a9ba8bbd6ed9e3._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class $a33cbddcd7bfa0a9$export$49bb5356ca788047 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$49bb5356ca788047(t, e, n);
    }
    _apply(t) {
        return new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $b1c6e3a850a3c735$export$882b5998b3b9117c)(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$ee37e834aaad6f7e(t) {
    return (0, $b1c6e3a850a3c735$export$953cecd6e717a553)("limit", t), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function $a33cbddcd7bfa0a9$export$f823b3589f69d3b8(t) {
    return (0, $b1c6e3a850a3c735$export$953cecd6e717a553)("limitToLast", t), $a33cbddcd7bfa0a9$export$49bb5356ca788047._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$d92e2830aca1d816 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$d92e2830aca1d816(t, e, n);
    }
    _apply(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $b1c6e3a850a3c735$export$7ccc53e8f1e7dfc5)(t._query, e));
    }
}
function $a33cbddcd7bfa0a9$export$859941c5fc8eba6b(...t) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAt", t, /*inclusive=*/ !0);
}
function $a33cbddcd7bfa0a9$export$dd8dee5f7b804673(...t) {
    return $a33cbddcd7bfa0a9$export$d92e2830aca1d816._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class $a33cbddcd7bfa0a9$export$fd1782fd870d1e06 extends $a33cbddcd7bfa0a9$export$b0e86f2c7431df4e {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new $a33cbddcd7bfa0a9$export$fd1782fd870d1e06(t, e, n);
    }
    _apply(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t.firestore, t.converter, (0, $b1c6e3a850a3c735$export$ae1af26003f05816)(t._query, e));
    }
}
function $a33cbddcd7bfa0a9$export$57203950645b8b11(...t) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endBefore", t, /*inclusive=*/ !1);
}
function $a33cbddcd7bfa0a9$export$28ec54a8428bdb3f(...t) {
    return $a33cbddcd7bfa0a9$export$fd1782fd870d1e06._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function $a33cbddcd7bfa0a9$var$__PRIVATE_newQueryBoundFromDocOrFields(t, e, n, r) {
    if (n[0] = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n[0]), n[0] instanceof $a33cbddcd7bfa0a9$var$DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(t, e, n, r, s) {
        if (!r) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const a = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of (0, $b1c6e3a850a3c735$export$9e5f44173e64f162)(t))if (n.field.isKeyField()) a.push((0, $b1c6e3a850a3c735$export$43caf9889c228507)(e, r.key));
        else {
            const t = r.data.field(n.field);
            if ((0, $b1c6e3a850a3c735$export$2408f22a0fab9ae5)(t)) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            a.push(t);
        }
        return new (0, $b1c6e3a850a3c735$export$625550452a3fa3ec)(a, s);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    {
        const s = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, n, r, s, a) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (s.length > o.length) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const i = [];
            for(let a = 0; a < s.length; a++){
                const c = s[a];
                if (o[a].field.isKeyField()) {
                    if ("string" != typeof c) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof c}`);
                    if (!(0, $b1c6e3a850a3c735$export$3b14a55fb2447963)(t) && -1 !== c.indexOf("/")) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child((0, $b1c6e3a850a3c735$export$db202ddc8be9136).fromString(c));
                    if (!(0, $b1c6e3a850a3c735$export$90a7f3efeed30595).isDocumentKey(n)) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const s = new (0, $b1c6e3a850a3c735$export$90a7f3efeed30595)(n);
                    i.push((0, $b1c6e3a850a3c735$export$43caf9889c228507)(e, s));
                } else {
                    const t = (0, $b1c6e3a850a3c735$export$dda1d9f60106f0e9)(n, r, c);
                    i.push(t);
                }
            }
            return new (0, $b1c6e3a850a3c735$export$625550452a3fa3ec)(i, a);
        }(t._query, t.firestore._databaseId, s, e, n, r);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_parseDocumentIdValue(t, e, n) {
    if ("string" == typeof (n = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(n))) {
        if ("" === n) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, $b1c6e3a850a3c735$export$3b14a55fb2447963)(e) && -1 !== n.indexOf("/")) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = e.path.child((0, $b1c6e3a850a3c735$export$db202ddc8be9136).fromString(n));
        if (!(0, $b1c6e3a850a3c735$export$90a7f3efeed30595).isDocumentKey(r)) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return (0, $b1c6e3a850a3c735$export$43caf9889c228507)(t, new (0, $b1c6e3a850a3c735$export$90a7f3efeed30595)(r));
    }
    if (n instanceof (0, $b1c6e3a850a3c735$export$96f57966bedc81b4)) return (0, $b1c6e3a850a3c735$export$43caf9889c228507)(t, n._key);
    throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${(0, $b1c6e3a850a3c735$export$efccba1c4a2ef57b)(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_validateNewFieldFilter(t, e) {
    const n = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof $a33cbddcd7bfa0a9$export$f765fc5789dfd439 || e instanceof $a33cbddcd7bfa0a9$export$6bbc7aef0717f3d2)) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t, e, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, r;
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter extends (0, $b1c6e3a850a3c735$export$ebd11618f299a286) {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new (0, $b1c6e3a850a3c735$export$ef35774e6d314e91)(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new (0, $b1c6e3a850a3c735$export$96f57966bedc81b4)(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to sum across the result set.
 */ function $a33cbddcd7bfa0a9$export$8a63f25cc62965f1(t) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("sum", (0, $b1c6e3a850a3c735$export$35e795649ee09318)("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function $a33cbddcd7bfa0a9$export$cc6710ee5f037d57(t) {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("avg", (0, $b1c6e3a850a3c735$export$35e795649ee09318)("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function $a33cbddcd7bfa0a9$export$85b9a36db797e02b() {
    return new $a33cbddcd7bfa0a9$export$fada2345be8928cf("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function $a33cbddcd7bfa0a9$export$31fa8ec66e0239ad(t, e) {
    return t instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && e instanceof $a33cbddcd7bfa0a9$export$fada2345be8928cf && t.aggregateType === e.aggregateType && t._internalFieldPath?.canonicalString() === e._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function $a33cbddcd7bfa0a9$export$104f59389a332076(t, e) {
    return (0, $b1c6e3a850a3c735$export$d141bba7fdc215a3)(t.query, e.query) && (0, $029952e65115eee5$export$9cb4719e2e525b7a)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function $a33cbddcd7bfa0a9$export$b1de1b12889d0afb(t) {
    return $a33cbddcd7bfa0a9$export$a51511de2fae49b3(t, {
        count: $a33cbddcd7bfa0a9$export$85b9a36db797e02b()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function $a33cbddcd7bfa0a9$export$a51511de2fae49b3(t, e) {
    const n = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), r = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(n), s = (0, $b1c6e3a850a3c735$export$a9c23c6ac3fc3eca)(e, (t, e)=>new (0, $b1c6e3a850a3c735$export$d24c54395ce0c509)(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (0, $b1c6e3a850a3c735$export$2329c99376c9d0a4)(r, t._query, s).then((e)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(t, e, n) {
            const r = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(t), s = new $a33cbddcd7bfa0a9$export$40257fef64be808b(e, r, n);
            return s;
        })(n, t, e));
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = (0, $b1c6e3a850a3c735$export$6554612db691658e).provider, this._offlineComponentProvider = t?.garbageCollector ? t.garbageCollector._offlineComponentProvider : {
            build: ()=>new (0, $b1c6e3a850a3c735$export$493d36ec626b6698)(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl {
    constructor(t){
        let e;
        this.kind = "persistent", t?.tabManager ? (t.tabManager._initialize(t), e = t.tabManager) : (e = $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = (0, $b1c6e3a850a3c735$export$1fbe638ecf81657e).provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new (0, $b1c6e3a850a3c735$export$493d36ec626b6698)(t)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function $a33cbddcd7bfa0a9$export$574728f3be606189() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function $a33cbddcd7bfa0a9$export$2340f88905cc0c23(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLruGarbageCollectorImpl(t?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function $a33cbddcd7bfa0a9$export$72ef71adb739a32c(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MemoryLocalCacheImpl(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function $a33cbddcd7bfa0a9$export$51b321e43d5331d5(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_PersistentLocalCacheImpl(t);
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $b1c6e3a850a3c735$export$6554612db691658e).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $b1c6e3a850a3c735$export$d66dc83d8cfc8dd)(e, t?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, $b1c6e3a850a3c735$export$6554612db691658e).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, $b1c6e3a850a3c735$export$92108d983e8ee699)(e, t?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function $a33cbddcd7bfa0a9$export$d5f96a3c009e86ac(t) {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_SingleTabManagerImpl(t?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function $a33cbddcd7bfa0a9$export$57e9d290b0b4dc04() {
    return new $a33cbddcd7bfa0a9$var$__PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $a33cbddcd7bfa0a9$var$Xt = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class $a33cbddcd7bfa0a9$export$99d61448206ab5cd {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 extends $a33cbddcd7bfa0a9$var$DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(t, e, n, r, s, a){
        super(t, e, n, r, a), this._firestore = t, this._firestoreImpl = t, this.metadata = s;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field((0, $b1c6e3a850a3c735$export$35e795649ee09318)("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const t = this._document, e = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (e.type = $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion, e.bundle = "", e.bundleSource = "DocumentSnapshot", e.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return e;
        this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
        return e.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), e;
    }
}
function $a33cbddcd7bfa0a9$export$bbac1bdeb8972634(t, e, n) {
    if ((0, $b1c6e3a850a3c735$export$9bb611d729802a56)(e, $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema)) {
        if (e.bundle === $a33cbddcd7bfa0a9$var$Xt) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $b1c6e3a850a3c735$export$b4171a6734a65d42)(t._databaseId), s = (0, $b1c6e3a850a3c735$export$3466f893ebf79586)(e.bundle, r), a = s.t(), o = new (0, $b1c6e3a850a3c735$export$61196ced6d74a310)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        // Ensure that we have the correct number of documents in the bundle.
        const i = o.documents;
        if (1 !== i.length) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${i.length} documents.`);
        // Build out the internal document data.
        const c = (0, $b1c6e3a850a3c735$export$3a1a48c8f6ef640e)(r, i[0].document), h = new (0, $b1c6e3a850a3c735$export$90a7f3efeed30595)((0, $b1c6e3a850a3c735$export$db202ddc8be9136).fromString(e.bundleName));
        // Return the external facing DocumentSnapshot.
        return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(t), h, c, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion = "firestore/documentSnapshot/1.0", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchema = {
    type: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string", $a33cbddcd7bfa0a9$export$acab0e6ef25eb301._jsonSchemaVersion),
    bundleSource: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string", "DocumentSnapshot"),
    bundleName: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string"),
    bundle: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string")
};
class $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c extends $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class $a33cbddcd7bfa0a9$export$8f21149d8133945c {
    /** @hideconstructor */ constructor(t, e, n, r){
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(this._firestore, this._userDataWriter, n.key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    (0, $b1c6e3a850a3c735$export$a07804094c3ecf2d)(t._snapshot.query) ? (0, $b1c6e3a850a3c735$export$56c0d5a1e737357d)(t._snapshot.query) : (0, $b1c6e3a850a3c735$export$25ce5a424b770e84)(t.query._query);
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, n.doc.key, n.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const r = new $a33cbddcd7bfa0a9$export$6d4d04e42af6b03c(t._firestore, t._userDataWriter, e.doc.key, e.doc, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let s = -1, a = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (s = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), a = n.indexOf(e.doc.key)), {
                        type: $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(e.type),
                        doc: r,
                        oldIndex: s,
                        newIndex: a
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = {};
        t.type = $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = (0, $b1c6e3a850a3c735$export$971d5caa766a69d7).newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const e = [], n = [], r = [];
        return this.docs.forEach((t)=>{
            null !== t._document && (e.push(t._document), n.push(this._userDataWriter.convertObjectMap(t._document.data.value.mapValue.fields, "previous")), r.push(t.ref.path));
        }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
    }
}
function $a33cbddcd7bfa0a9$export$5bed7af38da9d026(t, e, n) {
    if ((0, $b1c6e3a850a3c735$export$9bb611d729802a56)(e, $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema)) {
        if (e.bundle === $a33cbddcd7bfa0a9$var$Xt) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, $b1c6e3a850a3c735$export$b4171a6734a65d42)(t._databaseId), s = (0, $b1c6e3a850a3c735$export$3466f893ebf79586)(e.bundle, r), a = s.t(), o = new (0, $b1c6e3a850a3c735$export$61196ced6d74a310)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        if (1 !== o.queries.length) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const i = (0, $b1c6e3a850a3c735$export$3a6d5c9ae78a2c08)(o.queries[0].bundledQuery), c = o.documents;
        // Construct the arrays of document data for the query.
        let h = new (0, $b1c6e3a850a3c735$export$e7c866399fa523f5);
        c.map((t)=>{
            const e = (0, $b1c6e3a850a3c735$export$3a1a48c8f6ef640e)(r, t.document);
            h = h.add(e);
        });
        // Create a view snapshot of the query and documents.
        const d = (0, $b1c6e3a850a3c735$export$71cec2538cb2c617).fromInitialDocuments(i, h, (0, $b1c6e3a850a3c735$export$78acf4525d8a74c4)(), /* fromCache= */ !1, /* hasCachedResults= */ !1), p = new (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86)(t, n || null, i);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new $a33cbddcd7bfa0a9$export$8f21149d8133945c(t, new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(t), p, d);
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_resultChangeType(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return (0, $b1c6e3a850a3c735$export$8743009a87fcb00f)(61501, {
                type: t
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function $a33cbddcd7bfa0a9$export$f243a5d948512846(t, e) {
    return t instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 && e instanceof $a33cbddcd7bfa0a9$export$acab0e6ef25eb301 ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && e instanceof $a33cbddcd7bfa0a9$export$8f21149d8133945c && t._firestore === e._firestore && (0, $b1c6e3a850a3c735$export$d141bba7fdc215a3)(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion = "firestore/querySnapshot/1.0", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchema = {
    type: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string", $a33cbddcd7bfa0a9$export$8f21149d8133945c._jsonSchemaVersion),
    bundleSource: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string", "QuerySnapshot"),
    bundleName: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string"),
    bundle: (0, $b1c6e3a850a3c735$export$ffb5f4729a158638)("string")
};
const $a33cbddcd7bfa0a9$var$Zt = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class $a33cbddcd7bfa0a9$export$d94ed661b1cfd435 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $b1c6e3a850a3c735$export$dc98b0b04f4c7758)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
        return this._mutations.push(a.toMutation(r._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).none())), this;
    }
    update(t, e, n, ...r) {
        this._verifyNotCommitted();
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $b1c6e3a850a3c735$export$34aec0b863436764) ? (0, $b1c6e3a850a3c735$export$3c2fa207a37baaea)(this._dataReader, "WriteBatch.update", s._key, e, n, r) : (0, $b1c6e3a850a3c735$export$ce26c07117d59d6a)(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(a.toMutation(s._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new (0, $b1c6e3a850a3c735$export$6559d589eb85fbb6)(e._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, e) {
    if ((t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t)).firestore !== e) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$var$Transaction$1 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), n = new $a33cbddcd7bfa0a9$var$__PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return (0, $b1c6e3a850a3c735$export$8743009a87fcb00f)(24041);
            const r = t[0];
            if (r.isFoundDocument()) return new $a33cbddcd7bfa0a9$var$DocumentSnapshot$1(this._firestore, n, r.key, r, e.converter);
            if (r.isNoDocument()) return new $a33cbddcd7bfa0a9$var$DocumentSnapshot$1(this._firestore, n, e._key, null, e.converter);
            throw (0, $b1c6e3a850a3c735$export$8743009a87fcb00f)(18433, {
                doc: r
            });
        });
    }
    set(t, e, n) {
        const r = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, $b1c6e3a850a3c735$export$dc98b0b04f4c7758)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
        return this._transaction.set(r._key, a), this;
    }
    update(t, e, n, ...r) {
        const s = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $b1c6e3a850a3c735$export$34aec0b863436764) ? (0, $b1c6e3a850a3c735$export$3c2fa207a37baaea)(this._dataReader, "Transaction.update", s._key, e, n, r) : (0, $b1c6e3a850a3c735$export$ce26c07117d59d6a)(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, a), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class $a33cbddcd7bfa0a9$export$febc5573c75cefb0 extends $a33cbddcd7bfa0a9$var$Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = $a33cbddcd7bfa0a9$var$__PRIVATE_validateReference(t, this._firestore), n = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(this._firestore);
        return super.get(t).then((t)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(this._firestore, n, e._key, t._document, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function $a33cbddcd7bfa0a9$export$3c54e006bf9c93b7(t, e, n) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$d66501df72047452));
    const r = {
        ...$a33cbddcd7bfa0a9$var$Zt,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    const s = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t);
    return (0, $b1c6e3a850a3c735$export$efca4cbe5dd06740)(s, (n)=>e(new $a33cbddcd7bfa0a9$export$febc5573c75cefb0(t, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$11eb3b5ef9574821(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$96f57966bedc81b4));
    const e = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(e);
    return (0, $b1c6e3a850a3c735$export$a8550f7dbe79f93a)(n, t._key).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$a58bd92642f7fb58(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$96f57966bedc81b4));
    const e = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(e), r = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(e);
    return (0, $b1c6e3a850a3c735$export$2e2af4578d910ddf)(n, t._key).then((n)=>new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(e, r, t._key, n, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function $a33cbddcd7bfa0a9$export$35dd759aed9686b4(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$96f57966bedc81b4));
    const e = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(e);
    return (0, $b1c6e3a850a3c735$export$a8550f7dbe79f93a)(n, t._key, {
        source: "server"
    }).then((n)=>$a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(e, t, n));
}
function $a33cbddcd7bfa0a9$export$81d3477bd73c86ef(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86));
    const e = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(e), r = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(e);
    return $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query), (0, $b1c6e3a850a3c735$export$a93c5207d687da10)(n, t._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$3fd010f18eac1dd(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86));
    const e = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(e), r = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(e);
    return (0, $b1c6e3a850a3c735$export$c3950d9923825c02)(n, t._query).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function $a33cbddcd7bfa0a9$export$ec7d9e44f349c77b(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86));
    const e = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(e), r = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(e);
    return (0, $b1c6e3a850a3c735$export$a93c5207d687da10)(n, t._query, {
        source: "server"
    }).then((n)=>new $a33cbddcd7bfa0a9$export$8f21149d8133945c(e, r, t, n));
}
function $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12(t, e, n) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$96f57966bedc81b4));
    const r = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e, n), o = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(r);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(r, [
        (0, $b1c6e3a850a3c735$export$dc98b0b04f4c7758)(o, "setDoc", t._key, s, null !== t.converter, n).toMutation(t._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).none())
    ]);
}
function $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2(t, e, n, ...r) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$96f57966bedc81b4));
    const s = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), o = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(s);
    let i;
    i = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(e)) || e instanceof (0, $b1c6e3a850a3c735$export$34aec0b863436764) ? (0, $b1c6e3a850a3c735$export$3c2fa207a37baaea)(o, "updateDoc", t._key, e, n, r) : (0, $b1c6e3a850a3c735$export$ce26c07117d59d6a)(o, "updateDoc", t._key, e);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(s, [
        i.toMutation(t._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully deleted from the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error deleting the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given data _will_ be immediately deleted from the local cache and will be
 * reflected in future "get" operations as if it had been successfully
 * deleted from the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be deleted from the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the document to delete.
 * @returns A `Promise` that resolves once the document has been successfully
 * deleted from the backend or rejects once the backend reports an error
 * deleting the document.
 */ function $a33cbddcd7bfa0a9$export$a4f20481fae8f78b(t) {
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613((0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), [
        new (0, $b1c6e3a850a3c735$export$6559d589eb85fbb6)(t._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully created to the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error creating the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given document _will_ be immediately created in the local cache and will be
 * incorporated into future "get" operations as if it had been successfully
 * created in the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be created in the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` that resolves once the docoument has been successfully
 * created in the backend or rejects once the backend reports an error creating
 * the document.
 */ function $a33cbddcd7bfa0a9$export$a13890143fb1c2dd(t, e) {
    const n = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), r = (0, $b1c6e3a850a3c735$export$a9c996f45e5784d0)(t), s = $a33cbddcd7bfa0a9$var$__PRIVATE_applyFirestoreDataConverter(t.converter, e), o = (0, $b1c6e3a850a3c735$export$39b482c5e57630a8)(t.firestore);
    return $a33cbddcd7bfa0a9$export$1945f8fec9dda613(n, [
        (0, $b1c6e3a850a3c735$export$dc98b0b04f4c7758)(o, "addDoc", r._key, s, null !== t.converter, {}).toMutation(r._key, (0, $b1c6e3a850a3c735$export$3d8c2f653ac9d0b9).exists(!1))
    ]).then(()=>r);
}
function $a33cbddcd7bfa0a9$export$d36370812fb26935(t, ...e) {
    // onSnapshot for Query or Document.
    t = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t);
    let n = {
        includeMetadataChanges: !1,
        source: "default"
    }, r = 0;
    "object" != typeof e[r] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e[r]) || (n = e[r++]);
    const s = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if ($a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e[r])) {
        const t = e[r];
        e[r] = t.next?.bind(t), e[r + 1] = t.error?.bind(t), e[r + 2] = t.complete?.bind(t);
    }
    let o, i, c;
    if (t instanceof (0, $b1c6e3a850a3c735$export$96f57966bedc81b4)) i = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), c = (0, $b1c6e3a850a3c735$export$7910e0436ed8d1de)(t._key.path), o = {
        next: (n)=>{
            e[r] && e[r]($a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(i, t, n));
        },
        error: e[r + 1],
        complete: e[r + 2]
    };
    else {
        const n = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$3722cfe417b6ed86));
        i = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(n.firestore, (0, $b1c6e3a850a3c735$export$d66501df72047452)), c = n._query;
        const s = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(i);
        o = {
            next: (t)=>{
                e[r] && e[r](new $a33cbddcd7bfa0a9$export$8f21149d8133945c(i, s, n, t));
            },
            error: e[r + 1],
            complete: e[r + 2]
        }, $a33cbddcd7bfa0a9$var$__PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query);
    }
    const h = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(i);
    return (0, $b1c6e3a850a3c735$export$555508cbc6add439)(h, c, s, o);
}
function $a33cbddcd7bfa0a9$export$a1ef90ed3b4a87fa(t, e, ...n) {
    const r = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(t), s = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(t) {
        const e = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in t)) {
                e.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = t[r];
            if ("string" != typeof n) {
                e.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                e.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? e.bundle = n : "bundleName" === r ? e.bundleName = n : "bundleSource" === r && (e.bundleSource = n);
        }
        return e;
    }(e);
    if (s.error) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, s.error);
    let a, o = 0;
    if ("object" != typeof n[o] || $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o]) || (a = n[o++]), "QuerySnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $b1c6e3a850a3c735$export$2219238a014317b0)(t, e.bundle);
            return i.then(()=>(0, $b1c6e3a850a3c735$export$4c3d22f3d993c33f)(t, e.bundleName)).then((t)=>{
                if (t && !o) s && t.withConverter(s), a = $a33cbddcd7bfa0a9$export$d36370812fb26935(t, n || {}, r);
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    if ("DocumentSnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, $b1c6e3a850a3c735$export$2219238a014317b0)(t, e.bundle);
            return i.then(()=>{
                if (!o) {
                    const o = new (0, $b1c6e3a850a3c735$export$96f57966bedc81b4)(t, s || null, (0, $b1c6e3a850a3c735$export$90a7f3efeed30595).fromPath(e.bundleName));
                    a = $a33cbddcd7bfa0a9$export$d36370812fb26935(o, n || {}, r);
                }
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, `unsupported bundle source: ${s.bundleSource}`);
}
function $a33cbddcd7bfa0a9$export$9dff4f5aba83e348(t, e) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$d66501df72047452));
    const n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t), r = $a33cbddcd7bfa0a9$var$__PRIVATE_isPartialObserver(e) ? e : {
        next: e
    };
    return (0, $b1c6e3a850a3c735$export$f787f51d84a910ad)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function $a33cbddcd7bfa0a9$export$1945f8fec9dda613(t, e) {
    const n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t);
    return (0, $b1c6e3a850a3c735$export$c9170ad7d4cd7e57)(n, e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function $a33cbddcd7bfa0a9$var$__PRIVATE_convertToDocSnapshot(t, e, n) {
    const r = n.docs.get(e._key), s = new (0, $b1c6e3a850a3c735$export$7f8ddf7c7c20b3cd)(t);
    return new $a33cbddcd7bfa0a9$export$acab0e6ef25eb301(t, s, e._key, r, new $a33cbddcd7bfa0a9$export$99d61448206ab5cd(n.hasPendingWrites, n.fromCache), e.converter);
}
function $a33cbddcd7bfa0a9$export$44cd1c9d57edd9b1(t) {
    return t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$d66501df72047452)), (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t), new $a33cbddcd7bfa0a9$export$d94ed661b1cfd435(t, (e)=>$a33cbddcd7bfa0a9$export$1945f8fec9dda613(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $a33cbddcd7bfa0a9$export$ff1663c0c1304f1a(t, e) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$d66501df72047452));
    const n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, $b1c6e3a850a3c735$export$ee7c8ad385a60b7b)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(t) {
        const e = "string" == typeof t ? function __PRIVATE_tryParseJson(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Failed to parse JSON: " + t?.message);
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, "collectionGroup"), r = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(e, "fieldPath"), n = (0, $b1c6e3a850a3c735$export$995eb9fca571757)("setIndexConfiguration", t);
                "CONTAINS" === e.arrayConfig ? r.push(new (0, $b1c6e3a850a3c735$export$f38c853ae54ed474)(n, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? r.push(new (0, $b1c6e3a850a3c735$export$f38c853ae54ed474)(n, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && r.push(new (0, $b1c6e3a850a3c735$export$f38c853ae54ed474)(n, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new (0, $b1c6e3a850a3c735$export$3b513254972cfc9c)((0, $b1c6e3a850a3c735$export$3b513254972cfc9c).UNKNOWN_ID, e, r, (0, $b1c6e3a850a3c735$export$21579262ef46735b).empty()));
        }
        return n;
    }(e);
    return (0, $b1c6e3a850a3c735$export$ab83b03e4111b1d0)(n, r);
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_tryGetString(t, e) {
    if ("string" != typeof t[e]) throw new (0, $b1c6e3a850a3c735$export$4368d992c4eafac0)((0, $b1c6e3a850a3c735$export$f1e1789686576879).INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8 {
    /** @hideconstructor */ constructor(t){
        this._firestore = t, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function $a33cbddcd7bfa0a9$export$61c6347b57bdfa06(t) {
    t = (0, $b1c6e3a850a3c735$export$4a5767248b18ef41)(t, (0, $b1c6e3a850a3c735$export$d66501df72047452));
    const e = $a33cbddcd7bfa0a9$var$te.get(t);
    if (e) return e;
    const n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new $a33cbddcd7bfa0a9$export$cf4db3c220e88bd8(t);
    return $a33cbddcd7bfa0a9$var$te.set(t, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function $a33cbddcd7bfa0a9$export$9b2c0a7aacbcd151(t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function $a33cbddcd7bfa0a9$export$5b460d5f48076743(t) {
    $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function $a33cbddcd7bfa0a9$export$72809fc2fc5083d5(t) {
    const e = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t._firestore);
    (0, $b1c6e3a850a3c735$export$1a82df3d29112e01)(e).then((t)=>(0, $b1c6e3a850a3c735$export$306ddfe3a8403e2)("deleting all persistent cache indexes succeeded")).catch((t)=>(0, $b1c6e3a850a3c735$export$ee7c8ad385a60b7b)("deleting all persistent cache indexes failed", t));
}
function $a33cbddcd7bfa0a9$var$__PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, e) {
    const n = (0, $b1c6e3a850a3c735$export$df995fae86a55f06)(t._firestore);
    (0, $b1c6e3a850a3c735$export$7a38258bbe170828)(n, e).then((t)=>(0, $b1c6e3a850a3c735$export$306ddfe3a8403e2)(`setting persistent cache index auto creation isEnabled=${e} succeeded`)).catch((t)=>(0, $b1c6e3a850a3c735$export$ee7c8ad385a60b7b)(`setting persistent cache index auto creation isEnabled=${e} failed`, t));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const $a33cbddcd7bfa0a9$var$te = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class $a33cbddcd7bfa0a9$export$3ab3ff3652492b82 {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(t) {
        return $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(t);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.i = new Map;
    }
    static get instance() {
        return $a33cbddcd7bfa0a9$var$ee || ($a33cbddcd7bfa0a9$var$ee = new $a33cbddcd7bfa0a9$var$__PRIVATE_TestingHooksSpiImpl, (0, $b1c6e3a850a3c735$export$2f6ca3d3b1f80bf5)($a33cbddcd7bfa0a9$var$ee)), $a33cbddcd7bfa0a9$var$ee;
    }
    u(t) {
        this.i.forEach((e)=>e(t));
    }
    onExistenceFilterMismatch(t) {
        const e = Symbol(), n = this.i;
        return n.set(e, t), ()=>n.delete(e);
    }
}
let $a33cbddcd7bfa0a9$var$ee = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(h, d = !0) {
    (0, $b1c6e3a850a3c735$export$71511d61b312f219)((0, $5e587d655f0a08bb$export$31499a9cd224b78c)), (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)("firestore", (t, { instanceIdentifier: e, options: n })=>{
        const r = t.getProvider("app").getImmediate(), s = new (0, $b1c6e3a850a3c735$export$d66501df72047452)(new (0, $b1c6e3a850a3c735$export$407448d2b89b1813)(t.getProvider("auth-internal")), new (0, $b1c6e3a850a3c735$export$8b22cf2602fb60ce)(r, t.getProvider("app-check-internal")), (0, $b1c6e3a850a3c735$export$db3b6bfb95261072)(r, e), r);
        return n = {
            useFetchStreams: d,
            ...n
        }, s._setSettings(n), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$Yt, $a33cbddcd7bfa0a9$var$Kt, h), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($a33cbddcd7bfa0a9$var$Yt, $a33cbddcd7bfa0a9$var$Kt, "esm2020");
}();







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const $63c1f7f3542429ef$var$DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const $63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const $63c1f7f3542429ef$var$DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const $63c1f7f3542429ef$var$DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const $63c1f7f3542429ef$var$DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class $63c1f7f3542429ef$export$697502632950e9d3 extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super($63c1f7f3542429ef$var$prependCode(code), `Firebase Storage: ${message} (${$63c1f7f3542429ef$var$prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, $63c1f7f3542429ef$export$697502632950e9d3.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return $63c1f7f3542429ef$var$prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var $63c1f7f3542429ef$export$54592d666d6ce114;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})($63c1f7f3542429ef$export$54592d666d6ce114 || ($63c1f7f3542429ef$export$54592d666d6ce114 = {}));
function $63c1f7f3542429ef$var$prependCode(code) {
    return 'storage/' + code;
}
function $63c1f7f3542429ef$var$unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNKNOWN, message);
}
function $63c1f7f3542429ef$var$objectNotFound(path) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function $63c1f7f3542429ef$var$quotaExceeded(bucket) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function $63c1f7f3542429ef$var$unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNAUTHENTICATED, message);
}
function $63c1f7f3542429ef$var$unauthorizedApp() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function $63c1f7f3542429ef$var$unauthorized(path) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function $63c1f7f3542429ef$var$retryLimitExceeded() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function $63c1f7f3542429ef$var$canceled() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.CANCELED, 'User canceled the upload/download.');
}
function $63c1f7f3542429ef$var$invalidUrl(url) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_URL, "Invalid URL '" + url + "'.");
}
function $63c1f7f3542429ef$var$invalidDefaultBucket(bucket) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function $63c1f7f3542429ef$var$noDefaultBucket() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + $63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function $63c1f7f3542429ef$var$cannotSliceBlob() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function $63c1f7f3542429ef$var$serverFileWrongSize() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function $63c1f7f3542429ef$var$noDownloadURL() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function $63c1f7f3542429ef$var$missingPolyFill(polyFill) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function $63c1f7f3542429ef$export$8f74d9881d1936fd(message) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_ARGUMENT, message);
}
function $63c1f7f3542429ef$var$appDeleted() {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function $63c1f7f3542429ef$export$61f54cdc36500ad(name) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function $63c1f7f3542429ef$var$invalidFormat(format, message) {
    return new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function $63c1f7f3542429ef$var$internalError(message) {
    throw new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class $63c1f7f3542429ef$export$adb98fff6714334 {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = $63c1f7f3542429ef$export$adb98fff6714334.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new $63c1f7f3542429ef$export$adb98fff6714334(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw $63c1f7f3542429ef$var$invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === $63c1f7f3542429ef$var$DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new $63c1f7f3542429ef$export$adb98fff6714334(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw $63c1f7f3542429ef$var$invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class $63c1f7f3542429ef$var$FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function $63c1f7f3542429ef$var$start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function $63c1f7f3542429ef$var$stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function $63c1f7f3542429ef$var$isFunction(p) {
    return typeof p === 'function';
}
function $63c1f7f3542429ef$var$isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function $63c1f7f3542429ef$var$isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function $63c1f7f3542429ef$var$isNativeBlob(p) {
    return $63c1f7f3542429ef$var$isNativeBlobDefined() && p instanceof Blob;
}
function $63c1f7f3542429ef$var$isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function $63c1f7f3542429ef$var$validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw $63c1f7f3542429ef$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw $63c1f7f3542429ef$export$8f74d9881d1936fd(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function $63c1f7f3542429ef$var$makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var $63c1f7f3542429ef$var$ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})($63c1f7f3542429ef$var$ErrorCode || ($63c1f7f3542429ef$var$ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function $63c1f7f3542429ef$var$isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class $63c1f7f3542429ef$var$NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true, isUsingEmulator = false){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.isUsingEmulator = isUsingEmulator;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.isUsingEmulator, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === $63c1f7f3542429ef$var$ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || $63c1f7f3542429ef$var$isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === $63c1f7f3542429ef$var$ErrorCode.ABORT;
                    backoffCallback(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new $63c1f7f3542429ef$var$RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if ($63c1f7f3542429ef$var$isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = $63c1f7f3542429ef$var$unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? $63c1f7f3542429ef$var$appDeleted() : $63c1f7f3542429ef$var$canceled();
                    reject(err);
                } else {
                    const err = $63c1f7f3542429ef$var$retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new $63c1f7f3542429ef$var$RequestEndStatus(false, null, true));
        else this.backoffId_ = $63c1f7f3542429ef$var$start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) $63c1f7f3542429ef$var$stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class $63c1f7f3542429ef$var$RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function $63c1f7f3542429ef$var$addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function $63c1f7f3542429ef$var$addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion ?? 'AppManager');
}
function $63c1f7f3542429ef$var$addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function $63c1f7f3542429ef$var$addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function $63c1f7f3542429ef$var$makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true, isUsingEmulator = false) {
    const queryPart = $63c1f7f3542429ef$var$makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    $63c1f7f3542429ef$var$addGmpidHeader_(headers, appId);
    $63c1f7f3542429ef$var$addAuthHeader_(headers, authToken);
    $63c1f7f3542429ef$var$addVersionHeader_(headers, firebaseVersion);
    $63c1f7f3542429ef$var$addAppCheckHeader_(headers, appCheckToken);
    return new $63c1f7f3542429ef$var$NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry, isUsingEmulator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function $63c1f7f3542429ef$var$getBlob$1(...args) {
    const BlobBuilder1 = $63c1f7f3542429ef$var$getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if ($63c1f7f3542429ef$var$isNativeBlobDefined()) return new Blob(args);
        else throw new $63c1f7f3542429ef$export$697502632950e9d3($63c1f7f3542429ef$export$54592d666d6ce114.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function $63c1f7f3542429ef$var$sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function $63c1f7f3542429ef$var$decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw $63c1f7f3542429ef$var$missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const $63c1f7f3542429ef$export$f22e7fe56db8ae03 = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class $63c1f7f3542429ef$var$StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function $63c1f7f3542429ef$export$d80b9b5a2ccdd3e0(format, stringData) {
    switch(format){
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.RAW:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$utf8Bytes_(stringData));
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64:
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64URL:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$base64Bytes_(format, stringData));
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.DATA_URL:
            return new $63c1f7f3542429ef$var$StringData($63c1f7f3542429ef$var$dataURLBytes_(stringData), $63c1f7f3542429ef$var$dataURLContentType_(stringData));
    }
    // assert(false);
    throw $63c1f7f3542429ef$var$unknown();
}
function $63c1f7f3542429ef$var$utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function $63c1f7f3542429ef$var$percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw $63c1f7f3542429ef$var$invalidFormat($63c1f7f3542429ef$export$f22e7fe56db8ae03.DATA_URL, 'Malformed data URL.');
    }
    return $63c1f7f3542429ef$var$utf8Bytes_(decoded);
}
function $63c1f7f3542429ef$var$base64Bytes_(format, value) {
    switch(format){
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case $63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw $63c1f7f3542429ef$var$invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = $63c1f7f3542429ef$var$decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw $63c1f7f3542429ef$var$invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class $63c1f7f3542429ef$var$DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw $63c1f7f3542429ef$var$invalidFormat($63c1f7f3542429ef$export$f22e7fe56db8ae03.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = $63c1f7f3542429ef$var$endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function $63c1f7f3542429ef$var$dataURLBytes_(dataUrl) {
    const parts = new $63c1f7f3542429ef$var$DataURLParts(dataUrl);
    if (parts.base64) return $63c1f7f3542429ef$var$base64Bytes_($63c1f7f3542429ef$export$f22e7fe56db8ae03.BASE64, parts.rest);
    else return $63c1f7f3542429ef$var$percentEncodedBytes_(parts.rest);
}
function $63c1f7f3542429ef$var$dataURLContentType_(dataUrl) {
    const parts = new $63c1f7f3542429ef$var$DataURLParts(dataUrl);
    return parts.contentType;
}
function $63c1f7f3542429ef$var$endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class $63c1f7f3542429ef$export$8deea8629ff0b8a7 {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if ($63c1f7f3542429ef$var$isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if ($63c1f7f3542429ef$var$isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = $63c1f7f3542429ef$var$sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7(slice, true);
        }
    }
    static getBlob(...args) {
        if ($63c1f7f3542429ef$var$isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof $63c1f7f3542429ef$export$8deea8629ff0b8a7) return val.data_;
                else return val;
            });
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7($63c1f7f3542429ef$var$getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if ($63c1f7f3542429ef$var$isString(val)) return $63c1f7f3542429ef$export$d80b9b5a2ccdd3e0($63c1f7f3542429ef$export$f22e7fe56db8ae03.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new $63c1f7f3542429ef$export$8deea8629ff0b8a7(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function $63c1f7f3542429ef$var$jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if ($63c1f7f3542429ef$var$isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function $63c1f7f3542429ef$var$parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function $63c1f7f3542429ef$var$child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function $63c1f7f3542429ef$var$lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$noXform_(metadata, value) {
    return value;
}
class $63c1f7f3542429ef$var$Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || $63c1f7f3542429ef$var$noXform_;
    }
}
let $63c1f7f3542429ef$var$mappings_ = null;
function $63c1f7f3542429ef$var$xformPath(fullPath) {
    if (!$63c1f7f3542429ef$var$isString(fullPath) || fullPath.length < 2) return fullPath;
    else return $63c1f7f3542429ef$var$lastComponent(fullPath);
}
function $63c1f7f3542429ef$var$getMappings() {
    if ($63c1f7f3542429ef$var$mappings_) return $63c1f7f3542429ef$var$mappings_;
    const mappings = [];
    mappings.push(new $63c1f7f3542429ef$var$Mapping('bucket'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('generation'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('metageneration'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return $63c1f7f3542429ef$var$xformPath(fullPath);
    }
    const nameMapping = new $63c1f7f3542429ef$var$Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new $63c1f7f3542429ef$var$Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new $63c1f7f3542429ef$var$Mapping('timeCreated'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('updated'));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('md5Hash', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('cacheControl', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentDisposition', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentEncoding', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentLanguage', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('contentType', null, true));
    mappings.push(new $63c1f7f3542429ef$var$Mapping('metadata', 'customMetadata', true));
    $63c1f7f3542429ef$var$mappings_ = mappings;
    return $63c1f7f3542429ef$var$mappings_;
}
function $63c1f7f3542429ef$var$addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new $63c1f7f3542429ef$export$adb98fff6714334(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function $63c1f7f3542429ef$var$fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    $63c1f7f3542429ef$var$addRef(metadata, service);
    return metadata;
}
function $63c1f7f3542429ef$var$fromResourceString(service, resourceString, mappings) {
    const obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $63c1f7f3542429ef$var$fromResource(service, resource, mappings);
}
function $63c1f7f3542429ef$var$downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!$63c1f7f3542429ef$var$isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = $63c1f7f3542429ef$var$makeUrl(urlPart, host, protocol);
        const queryString = $63c1f7f3542429ef$var$makeQueryString({
            alt: 'media',
            token: token
        });
        return base + queryString;
    });
    return urls[0];
}
function $63c1f7f3542429ef$var$toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $63c1f7f3542429ef$var$PREFIXES_KEY = 'prefixes';
const $63c1f7f3542429ef$var$ITEMS_KEY = 'items';
function $63c1f7f3542429ef$var$fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[$63c1f7f3542429ef$var$PREFIXES_KEY]) for (const path of resource[$63c1f7f3542429ef$var$PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new $63c1f7f3542429ef$export$adb98fff6714334(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[$63c1f7f3542429ef$var$ITEMS_KEY]) for (const item of resource[$63c1f7f3542429ef$var$ITEMS_KEY]){
        const reference = service._makeStorageReference(new $63c1f7f3542429ef$export$adb98fff6714334(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function $63c1f7f3542429ef$var$fromResponseString(service, bucket, resourceString) {
    const obj = $63c1f7f3542429ef$var$jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return $63c1f7f3542429ef$var$fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class $63c1f7f3542429ef$var$RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function $63c1f7f3542429ef$var$handlerCheck(cndn) {
    if (!cndn) throw $63c1f7f3542429ef$var$unknown();
}
function $63c1f7f3542429ef$var$metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $63c1f7f3542429ef$var$fromResourceString(service, text, mappings);
        $63c1f7f3542429ef$var$handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function $63c1f7f3542429ef$var$listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = $63c1f7f3542429ef$var$fromResponseString(service, bucket, text);
        $63c1f7f3542429ef$var$handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function $63c1f7f3542429ef$var$downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = $63c1f7f3542429ef$var$fromResourceString(service, text, mappings);
        $63c1f7f3542429ef$var$handlerCheck(metadata !== null);
        return $63c1f7f3542429ef$var$downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function $63c1f7f3542429ef$var$sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = $63c1f7f3542429ef$var$unauthorizedApp();
            else newErr = $63c1f7f3542429ef$var$unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = $63c1f7f3542429ef$var$quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = $63c1f7f3542429ef$var$unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $63c1f7f3542429ef$var$objectErrorHandler(location) {
    const shared = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = $63c1f7f3542429ef$var$objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function $63c1f7f3542429ef$var$getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function $63c1f7f3542429ef$var$getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = $63c1f7f3542429ef$var$toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = $63c1f7f3542429ef$var$objectErrorHandler(location);
    return requestInfo;
}
function $63c1f7f3542429ef$var$determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = $63c1f7f3542429ef$var$determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function $63c1f7f3542429ef$var$multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata);
    const metadataString = $63c1f7f3542429ef$var$toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = $63c1f7f3542429ef$export$8deea8629ff0b8a7.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw $63c1f7f3542429ef$var$cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, $63c1f7f3542429ef$var$metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class $63c1f7f3542429ef$var$ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function $63c1f7f3542429ef$var$checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        $63c1f7f3542429ef$var$handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    $63c1f7f3542429ef$var$handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function $63c1f7f3542429ef$var$createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = $63c1f7f3542429ef$var$metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = $63c1f7f3542429ef$var$makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = $63c1f7f3542429ef$var$toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        $63c1f7f3542429ef$var$checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            $63c1f7f3542429ef$var$handlerCheck(false);
        }
        $63c1f7f3542429ef$var$handlerCheck($63c1f7f3542429ef$var$isString(url));
        return url;
    }
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function $63c1f7f3542429ef$var$getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = $63c1f7f3542429ef$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            $63c1f7f3542429ef$var$handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        $63c1f7f3542429ef$var$handlerCheck(false);
        const size = Number(sizeString);
        $63c1f7f3542429ef$var$handlerCheck(!isNaN(size));
        return new $63c1f7f3542429ef$var$ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const $63c1f7f3542429ef$var$RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function $63c1f7f3542429ef$var$continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new $63c1f7f3542429ef$var$ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw $63c1f7f3542429ef$var$serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw $63c1f7f3542429ef$var$cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = $63c1f7f3542429ef$var$checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = $63c1f7f3542429ef$var$metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new $63c1f7f3542429ef$var$ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new $63c1f7f3542429ef$var$RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = $63c1f7f3542429ef$var$sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const $63c1f7f3542429ef$export$2cf04e0422ce9b07 = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const $63c1f7f3542429ef$export$9dc4203728a9a7c9 = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function $63c1f7f3542429ef$var$taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $63c1f7f3542429ef$var$Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = $63c1f7f3542429ef$var$isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error ?? undefined;
            this.complete = complete ?? undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $63c1f7f3542429ef$var$async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let $63c1f7f3542429ef$var$textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class $63c1f7f3542429ef$var$XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = $63c1f7f3542429ef$var$ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, isUsingEmulator, body, headers) {
        if (this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .send() more than once');
        if ((0, $029952e65115eee5$export$5b4d24b45140ad90)(url) && isUsingEmulator) this.xhr_.withCredentials = true;
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw $63c1f7f3542429ef$var$internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class $63c1f7f3542429ef$var$XhrTextConnection extends $63c1f7f3542429ef$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function $63c1f7f3542429ef$var$newTextConnection() {
    return $63c1f7f3542429ef$var$textFactoryOverride ? $63c1f7f3542429ef$var$textFactoryOverride() : new $63c1f7f3542429ef$var$XhrTextConnection();
}
class $63c1f7f3542429ef$var$XhrBytesConnection extends $63c1f7f3542429ef$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function $63c1f7f3542429ef$var$newBytesConnection() {
    return new $63c1f7f3542429ef$var$XhrBytesConnection();
}
class $63c1f7f3542429ef$var$XhrBlobConnection extends $63c1f7f3542429ef$var$XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function $63c1f7f3542429ef$var$newBlobConnection() {
    return new $63c1f7f3542429ef$var$XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class $63c1f7f3542429ef$export$86a2a9b92406a048 {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = $63c1f7f3542429ef$var$getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals($63c1f7f3542429ef$export$54592d666d6ce114.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if ($63c1f7f3542429ef$var$isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = $63c1f7f3542429ef$var$retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, $63c1f7f3542429ef$var$DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals($63c1f7f3542429ef$export$54592d666d6ce114.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = $63c1f7f3542429ef$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new $63c1f7f3542429ef$var$ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = $63c1f7f3542429ef$var$continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = $63c1f7f3542429ef$var$RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = $63c1f7f3542429ef$var$multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, $63c1f7f3542429ef$var$newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = $63c1f7f3542429ef$var$canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = $63c1f7f3542429ef$var$taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new $63c1f7f3542429ef$var$Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch($63c1f7f3542429ef$var$taskStateFromInternalTaskState(this._state)){
                case $63c1f7f3542429ef$export$9dc4203728a9a7c9.SUCCESS:
                    $63c1f7f3542429ef$var$async(this._resolve.bind(null, this.snapshot))();
                    break;
                case $63c1f7f3542429ef$export$9dc4203728a9a7c9.CANCELED:
                case $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR:
                    const toCall = this._reject;
                    $63c1f7f3542429ef$var$async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = $63c1f7f3542429ef$var$taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.RUNNING:
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.PAUSED:
                if (observer.next) $63c1f7f3542429ef$var$async(observer.next.bind(observer, this.snapshot))();
                break;
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.SUCCESS:
                if (observer.complete) $63c1f7f3542429ef$var$async(observer.complete.bind(observer))();
                break;
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.CANCELED:
            case $63c1f7f3542429ef$export$9dc4203728a9a7c9.ERROR:
                if (observer.error) $63c1f7f3542429ef$var$async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) $63c1f7f3542429ef$var$async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class $63c1f7f3542429ef$var$Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof $63c1f7f3542429ef$export$adb98fff6714334) this._location = location;
        else this._location = $63c1f7f3542429ef$export$adb98fff6714334.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new $63c1f7f3542429ef$var$Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new $63c1f7f3542429ef$export$adb98fff6714334(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return $63c1f7f3542429ef$var$lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = $63c1f7f3542429ef$var$parent(this._location.path);
        if (newPath === null) return null;
        const location = new $63c1f7f3542429ef$export$adb98fff6714334(this._location.bucket, newPath);
        return new $63c1f7f3542429ef$var$Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw $63c1f7f3542429ef$export$61f54cdc36500ad(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function $63c1f7f3542429ef$var$getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = $63c1f7f3542429ef$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function $63c1f7f3542429ef$var$getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = $63c1f7f3542429ef$var$getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$var$uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = $63c1f7f3542429ef$var$multipartUpload(ref.storage, ref._location, $63c1f7f3542429ef$var$getMappings(), new $63c1f7f3542429ef$export$8deea8629ff0b8a7(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref: ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function $63c1f7f3542429ef$var$uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new $63c1f7f3542429ef$export$86a2a9b92406a048(ref, new $63c1f7f3542429ef$export$8deea8629ff0b8a7(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$var$uploadString$1(ref, value, format = $63c1f7f3542429ef$export$f22e7fe56db8ae03.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = $63c1f7f3542429ef$export$d80b9b5a2ccdd3e0(format, value);
    const metadataClone = {
        ...metadata
    };
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return $63c1f7f3542429ef$var$uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $63c1f7f3542429ef$var$listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return $63c1f7f3542429ef$var$listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function $63c1f7f3542429ef$var$listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        pageToken: // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await $63c1f7f3542429ef$var$list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await $63c1f7f3542429ef$var$listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $63c1f7f3542429ef$var$list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') $63c1f7f3542429ef$var$validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = $63c1f7f3542429ef$var$list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function $63c1f7f3542429ef$var$getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = $63c1f7f3542429ef$var$getMetadata$2(ref.storage, ref._location, $63c1f7f3542429ef$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function $63c1f7f3542429ef$var$updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = $63c1f7f3542429ef$var$updateMetadata$2(ref.storage, ref._location, metadata, $63c1f7f3542429ef$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $63c1f7f3542429ef$var$getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = $63c1f7f3542429ef$var$getDownloadUrl(ref.storage, ref._location, $63c1f7f3542429ef$var$getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection).then((url)=>{
        if (url === null) throw $63c1f7f3542429ef$var$noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $63c1f7f3542429ef$var$deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = $63c1f7f3542429ef$var$deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, $63c1f7f3542429ef$var$newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function $63c1f7f3542429ef$var$_getChild$1(ref, childPath) {
    const newPath = $63c1f7f3542429ef$var$child(ref._location.path, childPath);
    const location = new $63c1f7f3542429ef$export$adb98fff6714334(ref._location.bucket, newPath);
    return new $63c1f7f3542429ef$var$Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $63c1f7f3542429ef$var$isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function $63c1f7f3542429ef$var$refFromURL(service, url) {
    return new $63c1f7f3542429ef$var$Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function $63c1f7f3542429ef$var$refFromPath(ref, path) {
    if (ref instanceof $63c1f7f3542429ef$var$FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw $63c1f7f3542429ef$var$noDefaultBucket();
        const reference = new $63c1f7f3542429ef$var$Reference(service, service._bucket);
        if (path != null) return $63c1f7f3542429ef$var$refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return $63c1f7f3542429ef$var$_getChild$1(ref, path);
        else return ref;
    }
}
function $63c1f7f3542429ef$var$ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && $63c1f7f3542429ef$var$isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof $63c1f7f3542429ef$var$FirebaseStorageImpl) return $63c1f7f3542429ef$var$refFromURL(serviceOrRef, pathOrUrl);
        else throw $63c1f7f3542429ef$export$8f74d9881d1936fd('To use ref(service, url), the first argument must be a Storage instance.');
    } else return $63c1f7f3542429ef$var$refFromPath(serviceOrRef, pathOrUrl);
}
function $63c1f7f3542429ef$var$extractBucket(host, config) {
    const bucketString = config?.[$63c1f7f3542429ef$var$CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return $63c1f7f3542429ef$export$adb98fff6714334.makeFromBucketSpec(bucketString, host);
}
function $63c1f7f3542429ef$var$connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    const useSsl = (0, $029952e65115eee5$export$5b4d24b45140ad90)(host);
    // Workaround to get cookies in Firebase Studio
    if (useSsl) (0, $029952e65115eee5$export$c0f0d0ce4283a937)(`https://${storage.host}/b`);
    storage._isUsingEmulator = true;
    storage._protocol = useSsl ? 'https' : 'http';
    const { mockUserToken: mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, $029952e65115eee5$export$367bf224123348f1)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class $63c1f7f3542429ef$var$FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion, _isUsingEmulator = false){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._isUsingEmulator = _isUsingEmulator;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = $63c1f7f3542429ef$var$DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = $63c1f7f3542429ef$var$DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = $63c1f7f3542429ef$var$DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = $63c1f7f3542429ef$export$adb98fff6714334.makeFromBucketSpec(_url, this._host);
        else this._bucket = $63c1f7f3542429ef$var$extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = $63c1f7f3542429ef$export$adb98fff6714334.makeFromBucketSpec(this._url, host);
        else this._bucket = $63c1f7f3542429ef$var$extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        $63c1f7f3542429ef$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        $63c1f7f3542429ef$var$validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new $63c1f7f3542429ef$var$Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = $63c1f7f3542429ef$var$makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry, this._isUsingEmulator);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new $63c1f7f3542429ef$var$FailRequest($63c1f7f3542429ef$var$appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const $63c1f7f3542429ef$var$name = "@firebase/storage";
const $63c1f7f3542429ef$var$version = "0.14.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const $63c1f7f3542429ef$var$STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function $63c1f7f3542429ef$export$a3521add2594f3c8(ref, maxDownloadSizeBytes) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$export$ac40f56b52f99dd1(ref, data, metadata) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function $63c1f7f3542429ef$export$d885b2eb178808b3(ref, value, format, metadata) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function $63c1f7f3542429ef$export$3895d39eb7ac9b25(ref, data, metadata) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function $63c1f7f3542429ef$export$8548546c0aa631e6(ref) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function $63c1f7f3542429ef$export$f64791b2d30456a0(ref, metadata) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function $63c1f7f3542429ef$export$8837f4fc672e936d(ref, options) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function $63c1f7f3542429ef$export$6a265a7d315dec03(ref) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function $63c1f7f3542429ef$export$c8bf645a0c2a7d9f(ref) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function $63c1f7f3542429ef$export$39c5ed4ec960eade(ref) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$deleteObject$1(ref);
}
function $63c1f7f3542429ef$export$eff4d24c3ff7876e(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(serviceOrRef);
    return $63c1f7f3542429ef$var$ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function $63c1f7f3542429ef$export$9acd24c0fce96a85(ref, childPath) {
    return $63c1f7f3542429ef$var$_getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function $63c1f7f3542429ef$export$fbd9b57a66480737(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), bucketUrl) {
    app = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(app);
    const storageProvider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)(app, $63c1f7f3542429ef$var$STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)('storage');
    if (emulator) $63c1f7f3542429ef$export$9850e656f954b889(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function $63c1f7f3542429ef$export$9850e656f954b889(storage, host, port, options = {}) {
    $63c1f7f3542429ef$var$connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function $63c1f7f3542429ef$export$37610328929d7521(ref, maxDownloadSizeBytes) {
    ref = (0, $029952e65115eee5$export$4befe9b5fa509a1b)(ref);
    return $63c1f7f3542429ef$var$getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function $63c1f7f3542429ef$export$747191980cdf43e8(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function $63c1f7f3542429ef$var$factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new $63c1f7f3542429ef$var$FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, $5e587d655f0a08bb$export$31499a9cd224b78c));
}
function $63c1f7f3542429ef$var$registerStorage() {
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)($63c1f7f3542429ef$var$STORAGE_TYPE, $63c1f7f3542429ef$var$factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($63c1f7f3542429ef$var$name, $63c1f7f3542429ef$var$version, '');
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($63c1f7f3542429ef$var$name, $63c1f7f3542429ef$var$version, 'esm2020');
}
$63c1f7f3542429ef$var$registerStorage();







/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd535d61f8c6f0dc$var$LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
const $fd535d61f8c6f0dc$var$UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';
function $fd535d61f8c6f0dc$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $fd535d61f8c6f0dc$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === 'number' && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === '[object String]') return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$fd535d61f8c6f0dc$var$encode(x));
    if (typeof data === 'function' || typeof data === 'object') return $fd535d61f8c6f0dc$var$mapValues(data, (x)=>$fd535d61f8c6f0dc$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error('Data cannot be encoded in JSON: ' + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $fd535d61f8c6f0dc$var$decode(json) {
    if (json == null) return json;
    if (json['@type']) switch(json['@type']){
        case $fd535d61f8c6f0dc$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $fd535d61f8c6f0dc$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json['value']);
                if (isNaN(value)) throw new Error('Data cannot be decoded from JSON: ' + json);
                return value;
            }
        default:
            throw new Error('Data cannot be decoded from JSON: ' + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$fd535d61f8c6f0dc$var$decode(x));
    if (typeof json === 'function' || typeof json === 'object') return $fd535d61f8c6f0dc$var$mapValues(json, (x)=>$fd535d61f8c6f0dc$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $fd535d61f8c6f0dc$var$FUNCTIONS_TYPE = 'functions';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $fd535d61f8c6f0dc$var$errorCodeMap = {
    OK: 'ok',
    CANCELLED: 'cancelled',
    UNKNOWN: 'unknown',
    INVALID_ARGUMENT: 'invalid-argument',
    DEADLINE_EXCEEDED: 'deadline-exceeded',
    NOT_FOUND: 'not-found',
    ALREADY_EXISTS: 'already-exists',
    PERMISSION_DENIED: 'permission-denied',
    UNAUTHENTICATED: 'unauthenticated',
    RESOURCE_EXHAUSTED: 'resource-exhausted',
    FAILED_PRECONDITION: 'failed-precondition',
    ABORTED: 'aborted',
    OUT_OF_RANGE: 'out-of-range',
    UNIMPLEMENTED: 'unimplemented',
    INTERNAL: 'internal',
    UNAVAILABLE: 'unavailable',
    DATA_LOSS: 'data-loss'
};
/**
 * An error returned by the Firebase Functions client SDK.
 *
 * See {@link FunctionsErrorCode} for full documentation of codes.
 *
 * @public
 */ class $fd535d61f8c6f0dc$export$738689d52335bb3c extends (0, $029952e65115eee5$export$dd24e9cd51226c56) {
    /**
     * Constructs a new instance of the `FunctionsError` class.
     */ constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Additional details to be converted to JSON and included in the error response.
     */ details){
        super(`${$fd535d61f8c6f0dc$var$FUNCTIONS_TYPE}/${code}`, message || '');
        this.details = details;
        // Since the FirebaseError constructor sets the prototype of `this` to FirebaseError.prototype,
        // we also have to do it in all subclasses to allow for correct `instanceof` checks.
        Object.setPrototypeOf(this, $fd535d61f8c6f0dc$export$738689d52335bb3c.prototype);
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $fd535d61f8c6f0dc$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return 'ok';
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return 'internal';
        case 400:
            return 'invalid-argument';
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission-denied';
        case 404:
            return 'not-found';
        case 409:
            return 'aborted';
        case 429:
            return 'resource-exhausted';
        case 499:
            return 'cancelled';
        case 500:
            return 'internal';
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline-exceeded';
    }
    return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $fd535d61f8c6f0dc$var$_errorForResponse(status, bodyJSON) {
    let code = $fd535d61f8c6f0dc$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === 'string') {
                if (!$fd535d61f8c6f0dc$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $fd535d61f8c6f0dc$export$738689d52335bb3c('internal', 'internal');
                code = $fd535d61f8c6f0dc$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === 'string') description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $fd535d61f8c6f0dc$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === 'ok') // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $fd535d61f8c6f0dc$export$738689d52335bb3c(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $fd535d61f8c6f0dc$var$ContextProvider {
    constructor(app, authProvider, messagingProvider, appCheckProvider){
        this.app = app;
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.serverAppAppCheckToken = null;
        if ((0, $5e587d655f0a08bb$export$643c8bc6c389f34e)(app) && app.settings.appCheckToken) this.serverAppAppCheckToken = app.settings.appCheckToken;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider?.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token?.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !('Notification' in self) || Notification.permission !== 'granted') return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken(limitedUseAppCheckTokens) {
        if (this.serverAppAppCheckToken) return this.serverAppAppCheckToken;
        if (this.appCheck) {
            const result = limitedUseAppCheckTokens ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext(limitedUseAppCheckTokens) {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd535d61f8c6f0dc$var$DEFAULT_REGION = 'us-central1';
const $fd535d61f8c6f0dc$var$responseLineRE = /^data: (.*?)(?:\n|$)/;
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $fd535d61f8c6f0dc$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $fd535d61f8c6f0dc$export$738689d52335bb3c('deadline-exceeded', 'deadline-exceeded'));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $fd535d61f8c6f0dc$var$FunctionsService {
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $fd535d61f8c6f0dc$var$DEFAULT_REGION, fetchImpl = (...args)=>fetch(...args)){
        this.app = app;
        this.fetchImpl = fetchImpl;
        this.emulatorOrigin = null;
        this.contextProvider = new $fd535d61f8c6f0dc$var$ContextProvider(app, authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin + (url.pathname === '/' ? '' : url.pathname);
            this.region = $fd535d61f8c6f0dc$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $fd535d61f8c6f0dc$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    const useSsl = (0, $029952e65115eee5$export$5b4d24b45140ad90)(host);
    functionsInstance.emulatorOrigin = `http${useSsl ? 's' : ''}://${host}:${port}`;
    // Workaround to get cookies in Firebase Studio
    if (useSsl) (0, $029952e65115eee5$export$c0f0d0ce4283a937)(functionsInstance.emulatorOrigin + '/backends');
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$var$httpsCallable$1(functionsInstance, name, options) {
    const callable = (data)=>{
        return $fd535d61f8c6f0dc$var$call(functionsInstance, name, data, options || {});
    };
    callable.stream = (data, options)=>{
        return $fd535d61f8c6f0dc$var$stream(functionsInstance, name, data, options);
    };
    return callable;
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    const callable = (data)=>{
        return $fd535d61f8c6f0dc$var$callAtURL(functionsInstance, url, data, options || {});
    };
    callable.stream = (data, options)=>{
        return $fd535d61f8c6f0dc$var$streamAtURL(functionsInstance, url, data, options || {});
    };
    return callable;
}
function $fd535d61f8c6f0dc$var$getCredentials(functionsInstance) {
    return functionsInstance.emulatorOrigin && (0, $029952e65115eee5$export$5b4d24b45140ad90)(functionsInstance.emulatorOrigin) ? 'include' : undefined;
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @param functionsInstance functions instance that is calling postJSON
 * @return A Promise that will succeed when the request finishes.
 */ async function $fd535d61f8c6f0dc$var$postJSON(url, body, headers, fetchImpl, functionsInstance) {
    headers['Content-Type'] = 'application/json';
    let response;
    try {
        response = await fetchImpl(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: headers,
            credentials: $fd535d61f8c6f0dc$var$getCredentials(functionsInstance)
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Creates authorization headers for Firebase Functions requests.
 * @param functionsInstance The Firebase Functions service instance.
 * @param options Options for the callable function, including AppCheck token settings.
 * @return A Promise that resolves a headers map to include in outgoing fetch request.
 */ async function $fd535d61f8c6f0dc$var$makeAuthHeaders(functionsInstance, options) {
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext(options.limitedUseAppCheckTokens);
    if (context.authToken) headers['Authorization'] = 'Bearer ' + context.authToken;
    if (context.messagingToken) headers['Firebase-Instance-ID-Token'] = context.messagingToken;
    if (context.appCheckToken !== null) headers['X-Firebase-AppCheck'] = context.appCheckToken;
    return headers;
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.
 */ function $fd535d61f8c6f0dc$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $fd535d61f8c6f0dc$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.
 */ async function $fd535d61f8c6f0dc$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $fd535d61f8c6f0dc$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = await $fd535d61f8c6f0dc$var$makeAuthHeaders(functionsInstance, options);
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $fd535d61f8c6f0dc$var$failAfter(timeout);
    const response = await Promise.race([
        $fd535d61f8c6f0dc$var$postJSON(url, body, headers, functionsInstance.fetchImpl, functionsInstance),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $fd535d61f8c6f0dc$export$738689d52335bb3c('cancelled', 'Firebase Functions instance was deleted.');
    // Check for an error status, regardless of http status.
    const error = $fd535d61f8c6f0dc$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $fd535d61f8c6f0dc$export$738689d52335bb3c('internal', 'Response is not valid JSON object.');
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === 'undefined') responseData = response.json.result;
    if (typeof responseData === 'undefined') // Consider the response malformed.
    throw new $fd535d61f8c6f0dc$export$738689d52335bb3c('internal', 'Response is missing data field.');
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $fd535d61f8c6f0dc$var$decode(responseData);
    return {
        data: decodedData
    };
}
/**
 * Calls a callable function asynchronously and returns a streaming result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.
 * @param options Streaming request options.
 */ function $fd535d61f8c6f0dc$var$stream(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $fd535d61f8c6f0dc$var$streamAtURL(functionsInstance, url, data, options || {});
}
/**
 * Calls a callable function asynchronously and return a streaming result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.
 * @param options Streaming request options.
 */ async function $fd535d61f8c6f0dc$var$streamAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $fd535d61f8c6f0dc$var$encode(data);
    const body = {
        data: data
    };
    //
    // Add a header for the authToken.
    const headers = await $fd535d61f8c6f0dc$var$makeAuthHeaders(functionsInstance, options);
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'text/event-stream';
    let response;
    try {
        response = await functionsInstance.fetchImpl(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: headers,
            signal: options?.signal,
            credentials: $fd535d61f8c6f0dc$var$getCredentials(functionsInstance)
        });
    } catch (e) {
        if (e instanceof Error && e.name === 'AbortError') {
            const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c('cancelled', 'Request was cancelled.');
            return {
                data: Promise.reject(error),
                stream: {
                    [Symbol.asyncIterator] () {
                        return {
                            next () {
                                return Promise.reject(error);
                            }
                        };
                    }
                }
            };
        }
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        const error = $fd535d61f8c6f0dc$var$_errorForResponse(0, null);
        return {
            data: Promise.reject(error),
            // Return an empty async iterator
            stream: {
                [Symbol.asyncIterator] () {
                    return {
                        next () {
                            return Promise.reject(error);
                        }
                    };
                }
            }
        };
    }
    let resultResolver;
    let resultRejecter;
    const resultPromise = new Promise((resolve, reject)=>{
        resultResolver = resolve;
        resultRejecter = reject;
    });
    options?.signal?.addEventListener('abort', ()=>{
        const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c('cancelled', 'Request was cancelled.');
        resultRejecter(error);
    });
    const reader = response.body.getReader();
    const rstream = $fd535d61f8c6f0dc$var$createResponseStream(reader, resultResolver, resultRejecter, options?.signal);
    return {
        stream: {
            [Symbol.asyncIterator] () {
                const rreader = rstream.getReader();
                return {
                    async next () {
                        const { value: value, done: done } = await rreader.read();
                        return {
                            value: value,
                            done: done
                        };
                    },
                    async return () {
                        await rreader.cancel();
                        return {
                            done: true,
                            value: undefined
                        };
                    }
                };
            }
        },
        data: resultPromise
    };
}
/**
 * Creates a ReadableStream that processes a streaming response from a streaming
 * callable function that returns data in server-sent event format.
 *
 * @param reader The underlying reader providing raw response data
 * @param resultResolver Callback to resolve the final result when received
 * @param resultRejecter Callback to reject with an error if encountered
 * @param signal Optional AbortSignal to cancel the stream processing
 * @returns A ReadableStream that emits decoded messages from the response
 *
 * The returned ReadableStream:
 *   1. Emits individual messages when "message" data is received
 *   2. Resolves with the final result when a "result" message is received
 *   3. Rejects with an error if an "error" message is received
 */ function $fd535d61f8c6f0dc$var$createResponseStream(reader, resultResolver, resultRejecter, signal) {
    const processLine = (line, controller)=>{
        const match = line.match($fd535d61f8c6f0dc$var$responseLineRE);
        // ignore all other lines (newline, comments, etc.)
        if (!match) return;
        const data = match[1];
        try {
            const jsonData = JSON.parse(data);
            if ('result' in jsonData) {
                resultResolver($fd535d61f8c6f0dc$var$decode(jsonData.result));
                return;
            }
            if ('message' in jsonData) {
                controller.enqueue($fd535d61f8c6f0dc$var$decode(jsonData.message));
                return;
            }
            if ('error' in jsonData) {
                const error = $fd535d61f8c6f0dc$var$_errorForResponse(0, jsonData);
                controller.error(error);
                resultRejecter(error);
                return;
            }
        } catch (error) {
            if (error instanceof $fd535d61f8c6f0dc$export$738689d52335bb3c) {
                controller.error(error);
                resultRejecter(error);
                return;
            }
        // ignore other parsing errors
        }
    };
    const decoder = new TextDecoder();
    return new ReadableStream({
        start (controller) {
            let currentText = '';
            return pump();
            async function pump() {
                if (signal?.aborted) {
                    const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c('cancelled', 'Request was cancelled');
                    controller.error(error);
                    resultRejecter(error);
                    return Promise.resolve();
                }
                try {
                    const { value: value, done: done } = await reader.read();
                    if (done) {
                        if (currentText.trim()) processLine(currentText.trim(), controller);
                        controller.close();
                        return;
                    }
                    if (signal?.aborted) {
                        const error = new $fd535d61f8c6f0dc$export$738689d52335bb3c('cancelled', 'Request was cancelled');
                        controller.error(error);
                        resultRejecter(error);
                        await reader.cancel();
                        return;
                    }
                    currentText += decoder.decode(value, {
                        stream: true
                    });
                    const lines = currentText.split('\n');
                    currentText = lines.pop() || '';
                    for (const line of lines)if (line.trim()) processLine(line.trim(), controller);
                    return pump();
                } catch (error) {
                    const functionsError = error instanceof $fd535d61f8c6f0dc$export$738689d52335bb3c ? error : $fd535d61f8c6f0dc$var$_errorForResponse(0, null);
                    controller.error(functionsError);
                    resultRejecter(functionsError);
                }
            }
        },
        cancel () {
            return reader.cancel();
        }
    });
}
const $fd535d61f8c6f0dc$var$name = "@firebase/functions";
const $fd535d61f8c6f0dc$var$version = "0.13.5";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fd535d61f8c6f0dc$var$AUTH_INTERNAL_NAME = 'auth-internal';
const $fd535d61f8c6f0dc$var$APP_CHECK_INTERNAL_NAME = 'app-check-internal';
const $fd535d61f8c6f0dc$var$MESSAGING_INTERNAL_NAME = 'messaging-internal';
function $fd535d61f8c6f0dc$var$registerFunctions(variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider('app').getImmediate();
        const authProvider = container.getProvider($fd535d61f8c6f0dc$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($fd535d61f8c6f0dc$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($fd535d61f8c6f0dc$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $fd535d61f8c6f0dc$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain);
    };
    (0, $5e587d655f0a08bb$export$c930050e7bb63965)(new (0, $5782dd2556309534$export$16fa2f45be04daa8)($fd535d61f8c6f0dc$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($fd535d61f8c6f0dc$var$name, $fd535d61f8c6f0dc$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, $5e587d655f0a08bb$export$d29d5299a7137abc)($fd535d61f8c6f0dc$var$name, $fd535d61f8c6f0dc$var$version, 'esm2020');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $fd535d61f8c6f0dc$export$7d4c14593b8a2193(app = (0, $5e587d655f0a08bb$export$f9962582c9e66d99)(), regionOrCustomDomain = $fd535d61f8c6f0dc$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $5e587d655f0a08bb$export$fa0d6da0f5838f50)((0, $029952e65115eee5$export$4befe9b5fa509a1b)(app), $fd535d61f8c6f0dc$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    const emulator = (0, $029952e65115eee5$export$a3febcf1f14a3a0c)('functions');
    if (emulator) $fd535d61f8c6f0dc$export$472343ee9d485d97(functionsInstance, ...emulator);
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $fd535d61f8c6f0dc$export$472343ee9d485d97(functionsInstance, host, port) {
    $fd535d61f8c6f0dc$var$connectFunctionsEmulator$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $fd535d61f8c6f0dc$var$httpsCallable$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $fd535d61f8c6f0dc$export$486b60b301a0b194(functionsInstance, url, options) {
    return $fd535d61f8c6f0dc$var$httpsCallableFromURL$1((0, $029952e65115eee5$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $fd535d61f8c6f0dc$var$registerFunctions();




// Your web app's Firebase configuration
const $f0c5fb609932756e$var$firebaseConfig = {
    apiKey: "AIzaSyCl9_WbmxOKPe9nA0dtlhH_3zLjmDMplQU",
    authDomain: "canal-de-denuncias-3fb8e.firebaseapp.com",
    projectId: "canal-de-denuncias-3fb8e",
    storageBucket: "canal-de-denuncias-3fb8e.firebasestorage.app",
    messagingSenderId: "1009325818637",
    appId: "1:1009325818637:web:331b507ca6dedb15bc6644",
    measurementId: "G-G4XBGPE94W"
};
// Initialize Firebase
const $f0c5fb609932756e$var$app = (0, $5e587d655f0a08bb$export$68ddedf7d44b3bdf)().length ? (0, $5e587d655f0a08bb$export$f9962582c9e66d99)() : (0, $5e587d655f0a08bb$export$c55cfd413944906d)($f0c5fb609932756e$var$firebaseConfig);
const $f0c5fb609932756e$export$73693bad9f5880b0 = (0, $c079a574c124a39d$export$ffb5f4729a158638)($f0c5fb609932756e$var$app);
const $f0c5fb609932756e$export$f932f06c7eb6abeb = (0, $b1c6e3a850a3c735$export$a17c37559e1db147)($f0c5fb609932756e$var$app);
const $f0c5fb609932756e$export$ddcffe0146c8f882 = (0, $63c1f7f3542429ef$export$fbd9b57a66480737)($f0c5fb609932756e$var$app);
const $f0c5fb609932756e$export$18af1f934c132a41 = (0, $fd535d61f8c6f0dc$export$7d4c14593b8a2193)($f0c5fb609932756e$var$app, 'southamerica-east1');





const $5cdc329eeebd56d0$export$f7a0da2fbc1e2969 = [
    "Ass\xe9dio Moral",
    "Ass\xe9dio Sexual",
    "Abuso de poder",
    "Conduta Anti\xe9tica",
    "Reclama\xe7\xf5es em Geral",
    "Apela\xe7\xe3o"
];
const $5cdc329eeebd56d0$export$12e8a2a80dd698a = [
    "Reclama\xe7\xf5es em Geral",
    "Apela\xe7\xe3o"
];
const $5cdc329eeebd56d0$export$9b8a516c80353b6c = 8;
const $5cdc329eeebd56d0$export$434762a68b8fd11b = 5;
const $5cdc329eeebd56d0$export$dc81b9d5f78b445 = 10;
const $5cdc329eeebd56d0$export$433956e63db518d1 = 20971520;
const $5cdc329eeebd56d0$export$f3f9086f84dd7167 = [
    'application/pdf'
];
const $5cdc329eeebd56d0$export$9b1d063312b70c15 = [
    'image/',
    'audio/'
];



const $820877bea407f5fe$export$bbf52f06d1ed0ffc = ()=>{
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    const randomValues = new Uint8Array((0, $5cdc329eeebd56d0$export$9b8a516c80353b6c));
    if (globalThis.crypto?.getRandomValues) globalThis.crypto.getRandomValues(randomValues);
    else for(let i = 0; i < randomValues.length; i += 1)randomValues[i] = Math.floor(Math.random() * 256);
    const randomChars = Array.from(randomValues, (value)=>chars[value % chars.length]).join('');
    return `RTA-${randomChars}`;
};
const $820877bea407f5fe$export$ca28e4dddf04f350 = ()=>Math.floor(100000 + Math.random() * 900000).toString();
const $820877bea407f5fe$export$d93229bb4cede1c9 = (file)=>(0, $5cdc329eeebd56d0$export$f3f9086f84dd7167).includes(file.type) || (0, $5cdc329eeebd56d0$export$9b1d063312b70c15).some((prefix)=>file.type.startsWith(prefix));
const $820877bea407f5fe$export$88d978873bc146b9 = (file)=>{
    if (!$820877bea407f5fe$export$d93229bb4cede1c9(file)) return `O arquivo "${file.name}" n\xe3o \xe9 permitido. Use apenas PDF, imagem ou \xe1udio.`;
    if (file.size > (0, $5cdc329eeebd56d0$export$433956e63db518d1)) return `O arquivo "${file.name}" excede o limite de 20 MB.`;
    return null;
};




const $1404c1c60e8681b8$export$7c109d41ed3721ca = (0, $fd535d61f8c6f0dc$export$438b58c7f2c6bf5e)((0, $f0c5fb609932756e$export$18af1f934c132a41), 'buscarDenunciaPorPin');
const $1404c1c60e8681b8$export$4db8353dbbfd963f = (0, $fd535d61f8c6f0dc$export$438b58c7f2c6bf5e)((0, $f0c5fb609932756e$export$18af1f934c132a41), 'enviarMensagemRelator');




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $5921600fb4e81be8$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $ebab042c7bf4d462$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $679cfb4006de9dc2$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());


const $05938c6aab1a7024$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $679cfb4006de9dc2$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $b02e0cdef8864a93$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $08ed9cd30f364255$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};




var $acw62 = parcelRequire("acw62");
"use strict";
"use client";
const $fdd26cba762f63b6$var$LucideContext = (0, $acw62.createContext)({});
function $fdd26cba762f63b6$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $acw62.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $acw62.createElement)($fdd26cba762f63b6$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $fdd26cba762f63b6$export$52ee7576b6cde767 = ()=>(0, $acw62.useContext)($fdd26cba762f63b6$var$LucideContext);


"use strict";
"use client";
const $8c69f6577678916e$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $fdd26cba762f63b6$export$52ee7576b6cde767)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $b02e0cdef8864a93$export$2e2bcd8739ae039),
        width: size ?? contextSize ?? (0, $b02e0cdef8864a93$export$2e2bcd8739ae039).width,
        height: size ?? contextSize ?? (0, $b02e0cdef8864a93$export$2e2bcd8739ae039).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $5921600fb4e81be8$export$3d46f4579dba46e5)("lucide", contextClass, className),
        ...!children && !(0, $08ed9cd30f364255$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $cb908d1b06653674$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $8c69f6577678916e$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $5921600fb4e81be8$export$3d46f4579dba46e5)(`lucide-${(0, $ebab042c7bf4d462$export$73bda83cddbc7187)((0, $05938c6aab1a7024$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $05938c6aab1a7024$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $5389c2c2de1c7f38$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "18",
            height: "11",
            x: "3",
            y: "11",
            rx: "2",
            ry: "2",
            key: "1w4ew1"
        }
    ],
    [
        "path",
        {
            d: "M7 11V7a5 5 0 0 1 10 0v4",
            key: "fwvmzm"
        }
    ]
];
const $5389c2c2de1c7f38$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("lock", $5389c2c2de1c7f38$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1f9a22d99de63c6e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 5h16",
            key: "1tepv9"
        }
    ],
    [
        "path",
        {
            d: "M4 12h16",
            key: "1lakjw"
        }
    ],
    [
        "path",
        {
            d: "M4 19h16",
            key: "1djgab"
        }
    ]
];
const $1f9a22d99de63c6e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("menu", $1f9a22d99de63c6e$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ced0e4b49801900d$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M8 12h8",
            key: "1wcyev"
        }
    ],
    [
        "path",
        {
            d: "M12 8v8",
            key: "napkw2"
        }
    ]
];
const $ced0e4b49801900d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("circle-plus", $ced0e4b49801900d$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30b4d9519dd12f8d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $30b4d9519dd12f8d$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("search", $30b4d9519dd12f8d$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4b6a18bc128c0629$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $4b6a18bc128c0629$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("x", $4b6a18bc128c0629$export$3efd853dbb351e94);


const $db9ed9a2274fc7a3$export$42cfbb80f7861e77 = ({ view: view, setView: setView, setTrackedId: setTrackedId })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $acw62.useState)(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        className: "bg-slate-900 text-white shadow-md sticky top-0 z-50",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "max-w-6xl mx-auto px-4 py-3 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-3 cursor-pointer",
                        onClick: ()=>{
                            setView('public');
                            setTrackedId(null);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: "https://i.postimg.cc/hjqs4KF5/RTA.jpg",
                                alt: "RTA Logo",
                                className: "h-10 bg-white p-1 rounded object-contain"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                        className: "font-bold text-base sm:text-lg leading-tight",
                                        children: "Canal de Integridade"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "hidden sm:block text-xs text-slate-400",
                                        children: "Ambiente Seguro e Confidencial"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hidden md:flex flex-wrap justify-center gap-6",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>{
                                    setView('public');
                                    setTrackedId(null);
                                    setIsMenuOpen(false);
                                },
                                className: `text-sm font-medium hover:text-blue-400 transition-colors flex items-center gap-2 ${view === 'public' ? 'text-blue-400' : 'text-slate-300'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ced0e4b49801900d$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Novo Relato"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>{
                                    setView('track');
                                    setIsMenuOpen(false);
                                },
                                className: `text-sm font-medium hover:text-blue-400 transition-colors flex items-center gap-2 ${view === 'track' ? 'text-blue-400' : 'text-slate-300'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Acompanhar Situa\xe7\xe3o"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                onClick: ()=>{
                                    setView('admin');
                                    setIsMenuOpen(false);
                                },
                                className: `text-sm font-medium hover:text-blue-400 transition-colors flex items-center gap-2 ${view === 'admin' ? 'text-blue-400' : 'text-slate-300'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                                        size: 16
                                    }),
                                    " Painel Admin"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "md:hidden flex items-center",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>setIsMenuOpen(!isMenuOpen),
                            className: "text-slate-300 hover:text-white p-1",
                            children: isMenuOpen ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b6a18bc128c0629$export$2e2bcd8739ae039), {
                                size: 26
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f9a22d99de63c6e$export$2e2bcd8739ae039), {
                                size: 26
                            })
                        })
                    })
                ]
            }),
            isMenuOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "md:hidden bg-slate-800 border-t border-slate-700 px-4 pt-2 pb-4 space-y-2 shadow-inner animate-fadeIn",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>{
                            setView('public');
                            setTrackedId(null);
                            setIsMenuOpen(false);
                        },
                        className: `w-full text-left py-3 px-3 rounded-md text-sm font-medium transition-colors flex items-center gap-3 ${view === 'public' ? 'bg-slate-700 text-blue-400' : 'text-slate-300 hover:bg-slate-700'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ced0e4b49801900d$export$2e2bcd8739ae039), {
                                size: 18
                            }),
                            " Novo Relato"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>{
                            setView('track');
                            setIsMenuOpen(false);
                        },
                        className: `w-full text-left py-3 px-3 rounded-md text-sm font-medium transition-colors flex items-center gap-3 ${view === 'track' ? 'bg-slate-700 text-blue-400' : 'text-slate-300 hover:bg-slate-700'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
                                size: 18
                            }),
                            " Acompanhar Situa\xe7\xe3o"
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: ()=>{
                            setView('admin');
                            setIsMenuOpen(false);
                        },
                        className: `w-full text-left py-3 px-3 rounded-md text-sm font-medium transition-colors flex items-center gap-3 ${view === 'admin' ? 'bg-slate-700 text-blue-400' : 'text-slate-300 hover:bg-slate-700'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                                size: 18
                            }),
                            " Painel Admin"
                        ]
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f66de94054a4f331$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $f66de94054a4f331$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("triangle-alert", $f66de94054a4f331$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ba16dd414953e5a4$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 16v-4",
            key: "1dtifu"
        }
    ],
    [
        "path",
        {
            d: "M12 8h.01",
            key: "e9boi3"
        }
    ]
];
const $ba16dd414953e5a4$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("info", $ba16dd414953e5a4$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3365fede8cd1121a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-6.219-8.56",
            key: "13zald"
        }
    ]
];
const $3365fede8cd1121a$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("loader-circle", $3365fede8cd1121a$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $824b163d7442530e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 6-8.414 8.586a2 2 0 0 0 2.829 2.829l8.414-8.586a4 4 0 1 0-5.657-5.657l-8.379 8.551a6 6 0 1 0 8.485 8.485l8.379-8.551",
            key: "1miecu"
        }
    ]
];
const $824b163d7442530e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("paperclip", $824b163d7442530e$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6c49d7be4abd1b80$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
            key: "1ffxy3"
        }
    ],
    [
        "path",
        {
            d: "m21.854 2.147-10.94 10.939",
            key: "12cjpa"
        }
    ]
];
const $6c49d7be4abd1b80$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("send", $6c49d7be4abd1b80$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ecd42070e67b4bc2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
            key: "oel41y"
        }
    ]
];
const $ecd42070e67b4bc2$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("shield", $ecd42070e67b4bc2$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ff4d96da330336c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $ff4d96da330336c2$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("user", $ff4d96da330336c2$export$3efd853dbb351e94);



const $a1a7b862c7e55c39$export$e04cb87a357104e9 = ({ states: states, handlers: handlers })=>{
    const { categoria: categoria, descricao: descricao, anonimo: anonimo, nome: nome, email: email, telefone: telefone, anexos: anexos, isSubmitting: isSubmitting } = states;
    const { setCategoria: setCategoria, setDescricao: setDescricao, setAnonimo: setAnonimo, setNome: setNome, setEmail: setEmail, setTelefone: setTelefone, handleFileChange: handleFileChange, removeAnexo: removeAnexo, handleSubmit: handleSubmit } = handlers;
    const isIdentificacaoObrigatoria = (0, $5cdc329eeebd56d0$export$12e8a2a80dd698a).includes(categoria);
    (0, $acw62.useEffect)(()=>{
        if (isIdentificacaoObrigatoria) setAnonimo(false);
    }, [
        categoria,
        isIdentificacaoObrigatoria,
        setAnonimo
    ]);
    return(// Alterado para max-w-5xl para alargar o formulário e p-5/mt-4 para reduzir espaços vazios
    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-5xl mx-auto mt-4 p-5 md:p-6 bg-white rounded-xl shadow-lg border border-slate-100 animate-fadeIn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-5 text-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ecd42070e67b4bc2$export$2e2bcd8739ae039), {
                        className: "mx-auto text-blue-600 mb-2",
                        size: 36
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-slate-800",
                        children: "Novo Relato"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-slate-600 mt-1 text-xs sm:text-sm",
                        children: "Este \xe9 um ambiente seguro. A RTA garante a confidencialidade das informa\xe7\xf5es e a n\xe3o retalia\xe7\xe3o contra quem relata de boa-f\xe9."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-6 bg-[#f4f8ff] rounded-r-lg border-l-4 border-blue-500 p-4 flex items-center justify-center gap-3 shadow-sm",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba16dd414953e5a4$export$2e2bcd8739ae039), {
                        size: 20,
                        className: "text-blue-600 shrink-0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-blue-900 font-medium leading-relaxed text-center",
                        children: "Prezado cliente, caso queira saber como ser\xe1 o processo de tratamento da sua reclama\xe7\xe3o, solicite \xe0 RTA que envie c\xf3pia do PA 05 - Procedimento de tratamento de reclama\xe7\xe3o."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit,
                className: "grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-semibold text-slate-700 mb-1",
                                        children: "Qual a natureza da situa\xe7\xe3o? *"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                        value: categoria,
                                        onChange: (e)=>setCategoria(e.target.value),
                                        className: "w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-slate-50 outline-none text-sm",
                                        required: true,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                value: "",
                                                disabled: true,
                                                children: "Selecione uma op\xe7\xe3o..."
                                            }),
                                            (0, $5cdc329eeebd56d0$export$f7a0da2fbc1e2969).map((cat)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                    value: cat,
                                                    children: cat
                                                }, cat))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-semibold text-slate-700 mb-1",
                                        children: "Descreva o que aconteceu em detalhes *"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-[11px] text-slate-500 mb-2",
                                        children: "Inclua datas, locais e nomes de pessoas envolvidas."
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                                        value: descricao,
                                        onChange: (e)=>setDescricao(e.target.value),
                                        rows: "4",
                                        className: "w-full flex-1 p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-slate-50 outline-none resize-none text-sm",
                                        placeholder: "Descreva a situa\xe7\xe3o aqui...",
                                        required: true
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-col space-y-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                        className: "block text-sm font-semibold text-slate-700 mb-1",
                                        children: "Anexar Evid\xeancias (Opcional)"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "border-2 border-dashed border-slate-300 rounded-lg p-3 bg-slate-50 text-center",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "file",
                                                multiple: true,
                                                onChange: handleFileChange,
                                                className: "hidden",
                                                id: "file-upload"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                htmlFor: "file-upload",
                                                className: "cursor-pointer flex flex-col items-center gap-1 text-slate-600 hover:text-blue-600 transition-colors",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $824b163d7442530e$export$2e2bcd8739ae039), {
                                                        size: 20
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "text-xs font-medium",
                                                        children: "Clique para anexar arquivos (Fotos, \xc1udios, PDFs)"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    anexos.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                        className: "mt-2 space-y-1 max-h-24 overflow-y-auto",
                                        children: anexos.map((file, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                                className: "flex items-center justify-between bg-white p-1.5 border border-slate-200 rounded text-xs text-slate-700",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "truncate flex-1 pr-2",
                                                        children: file.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        type: "button",
                                                        onClick: ()=>removeAnexo(index),
                                                        className: "text-red-500 hover:text-red-700 font-bold",
                                                        children: "X"
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "bg-slate-50 p-4 rounded-lg border border-slate-200",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                        className: "text-sm font-semibold text-slate-800 flex items-center gap-2 mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff4d96da330336c2$export$2e2bcd8739ae039), {
                                                size: 16
                                            }),
                                            " Identifica\xe7\xe3o"
                                        ]
                                    }),
                                    isIdentificacaoObrigatoria ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "bg-amber-50 border border-amber-200 text-amber-800 p-2.5 rounded-md flex gap-2 text-xs mb-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                                                size: 16,
                                                className: "shrink-0"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                                children: [
                                                    "Identifica\xe7\xe3o obrigat\xf3ria para ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: categoria
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                        className: "flex items-center gap-2 mb-3 cursor-pointer",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: anonimo,
                                                onChange: (e)=>setAnonimo(e.target.checked),
                                                className: "w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "text-xs font-bold uppercase text-slate-700",
                                                children: "Desejo fazer este relato de forma an\xf4nima."
                                            })
                                        ]
                                    }),
                                    !anonimo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "space-y-3 animate-fadeIn",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                type: "text",
                                                value: nome,
                                                onChange: (e)=>setNome(e.target.value),
                                                className: "w-full p-2 text-sm border border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none",
                                                placeholder: "Nome Completo *",
                                                required: !anonimo
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                className: "grid grid-cols-2 gap-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "email",
                                                        value: email,
                                                        onChange: (e)=>setEmail(e.target.value),
                                                        className: "w-full p-2 text-sm border border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none",
                                                        placeholder: "E-mail"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                        type: "tel",
                                                        value: telefone,
                                                        onChange: (e)=>setTelefone(e.target.value),
                                                        className: "w-full p-2 text-sm border border-slate-300 rounded-md focus:ring-2 focus:ring-blue-500 outline-none",
                                                        placeholder: "Telefone / WhatsApp"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "md:col-span-2 mt-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            disabled: isSubmitting,
                            className: "w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg flex items-center justify-center gap-2 shadow-md disabled:bg-slate-400 disabled:cursor-not-allowed",
                            children: isSubmitting ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3365fede8cd1121a$export$2e2bcd8739ae039), {
                                        size: 18,
                                        className: "animate-spin"
                                    }),
                                    " Enviando..."
                                ]
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
                                        size: 18
                                    }),
                                    " Enviar Relato de Forma Segura"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    }));
};



parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ac057c7c97a18da7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $ac057c7c97a18da7$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("circle-check-big", $ac057c7c97a18da7$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $85a15a5b7c5dbb98$export$3efd853dbb351e94 = [
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "9",
            y2: "9",
            key: "4lhtct"
        }
    ],
    [
        "line",
        {
            x1: "4",
            x2: "20",
            y1: "15",
            y2: "15",
            key: "vyu0kd"
        }
    ],
    [
        "line",
        {
            x1: "10",
            x2: "8",
            y1: "3",
            y2: "21",
            key: "1ggp8o"
        }
    ],
    [
        "line",
        {
            x1: "16",
            x2: "14",
            y1: "3",
            y2: "21",
            key: "weycgp"
        }
    ]
];
const $85a15a5b7c5dbb98$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("hash", $85a15a5b7c5dbb98$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7af1accd6f7fdb20$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4",
            key: "g0fldk"
        }
    ],
    [
        "path",
        {
            d: "m21 2-9.6 9.6",
            key: "1j0ho8"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "15.5",
            r: "5.5",
            key: "yqb3hr"
        }
    ]
];
const $7af1accd6f7fdb20$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("key", $7af1accd6f7fdb20$export$3efd853dbb351e94);


const $06713472d571543c$export$be5117c66bf44cb9 = ({ protocoloGerado: protocoloGerado, pinGerado: pinGerado, setBuscaProtocolo: setBuscaProtocolo, setBuscaPin: setBuscaPin, setView: setView, setTrackedId: setTrackedId })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-2xl mx-auto mt-12 p-8 bg-white rounded-xl shadow-lg border border-slate-100 text-center animate-fadeIn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac057c7c97a18da7$export$2e2bcd8739ae039), {
                className: "mx-auto text-emerald-500 mb-4",
                size: 64
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                className: "text-3xl font-bold text-slate-800 mb-2",
                children: "Relato Enviado com Sucesso!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-slate-600 mb-6",
                children: "Agradecemos sua confian\xe7a. A RTA analisar\xe1 as informa\xe7\xf5es com a m\xe1xima seriedade e confidencialidade."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-slate-50 border border-slate-200 p-6 rounded-lg mb-8 inline-block shadow-inner w-full sm:w-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-slate-500 uppercase tracking-wider font-semibold mb-1",
                                children: "Protocolo"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-3xl font-mono font-bold text-blue-700 flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85a15a5b7c5dbb98$export$2e2bcd8739ae039), {
                                        size: 24,
                                        className: "text-blue-400"
                                    }),
                                    " ",
                                    protocoloGerado
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "pt-4 border-t border-slate-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "text-sm text-slate-500 uppercase tracking-wider font-semibold mb-1",
                                children: "PIN de Acesso"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-3xl font-mono font-bold text-slate-800 flex items-center justify-center gap-2 tracking-widest",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7af1accd6f7fdb20$export$2e2bcd8739ae039), {
                                        size: 24,
                                        className: "text-slate-400"
                                    }),
                                    " ",
                                    pinGerado
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-amber-50 border border-amber-200 text-amber-800 text-xs mt-4 p-3 rounded text-left",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: "\u26A0\uFE0F ATEN\xc7\xc3O:"
                            }),
                            " Anote o seu N\xfamero de Protocolo e o PIN. Voc\xea precisar\xe1 de ambos para acompanhar o andamento."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                    onClick: ()=>{
                        setBuscaProtocolo(protocoloGerado);
                        setBuscaPin(pinGerado);
                        setView('track');
                    },
                    className: "bg-slate-800 hover:bg-slate-900 text-white font-medium py-3 px-6 rounded-lg flex items-center justify-center gap-2 mx-auto",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
                            size: 18
                        }),
                        " Acompanhar Situa\xe7\xe3o Agora"
                    ]
                })
            })
        ]
    });



parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $4980c56854bb97ce$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $4980c56854bb97ce$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("calendar", $4980c56854bb97ce$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2b71f7c0d2454a8e$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ]
];
const $2b71f7c0d2454a8e$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("clock", $2b71f7c0d2454a8e$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fc88d8cf02c9ed12$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 3h6v6",
            key: "1q9fwt"
        }
    ],
    [
        "path",
        {
            d: "M10 14 21 3",
            key: "gplh6r"
        }
    ],
    [
        "path",
        {
            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
            key: "a6xqqp"
        }
    ]
];
const $fc88d8cf02c9ed12$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("external-link", $fc88d8cf02c9ed12$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ffa913da585dd100$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
            key: "18887p"
        }
    ]
];
const $ffa913da585dd100$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("message-square", $ffa913da585dd100$export$3efd853dbb351e94);


const $f7d864864214d4dc$export$c22448ecaa24cc8f = ({ denuncia: denuncia, isAdminView: isAdminView, novaMensagem: novaMensagem, setNovaMensagem: setNovaMensagem, enviarMensagemUsuarioChat: enviarMensagemUsuarioChat, adminNovaMensagem: adminNovaMensagem, setAdminNovaMensagem: setAdminNovaMensagem, enviarMensagemAdminChat: enviarMensagemAdminChat, loggedAdminEmail: loggedAdminEmail })=>{
    if (!denuncia) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-center p-8 flex justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3365fede8cd1121a$export$2e2bcd8739ae039), {
                className: "animate-spin mr-2"
            }),
            "Carregando detalhes..."
        ]
    });
    const isChatEnabled = denuncia.status === "Em an\xe1lise";
    const checarSeEhComite = (remetente)=>remetente.toLowerCase().includes('rta responde');
    const formatTimestamp = (timestamp)=>{
        if (!timestamp) return "Data indispon\xedvel";
        if (timestamp.seconds) return new Date(timestamp.seconds * 1000).toLocaleString('pt-BR');
        if (timestamp instanceof Date) return timestamp.toLocaleString('pt-BR');
        return String(timestamp);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "grid md:grid-cols-3 gap-6 animate-fadeIn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "md:col-span-1 space-y-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white p-5 rounded-xl shadow-sm border border-slate-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                                className: "text-xs font-bold text-slate-400 uppercase tracking-wider mb-2",
                                children: "Status Atual"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `text-lg font-bold flex items-center gap-2 ${denuncia.status === 'Em Aberto' ? 'text-red-600' : denuncia.status === "Em an\xe1lise" ? 'text-amber-600' : 'text-emerald-600'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
                                        size: 20
                                    }),
                                    " ",
                                    denuncia.status
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-xs text-slate-500 mt-2",
                                children: [
                                    "Setor Respons\xe1vel: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        className: "text-slate-700",
                                        children: denuncia.setor
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white p-5 rounded-xl shadow-sm border border-slate-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 border-b pb-2 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff4d96da330336c2$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Dados do Relator"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "space-y-3 text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "block text-slate-500 text-xs",
                                                children: "Nome"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium text-slate-800",
                                                children: denuncia.nome
                                            })
                                        ]
                                    }),
                                    !denuncia.anonimo && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "block text-slate-500 text-xs",
                                                        children: "E-mail"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-slate-800",
                                                        children: denuncia.email
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "block text-slate-500 text-xs",
                                                        children: "Telefone"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        className: "font-medium text-slate-800",
                                                        children: denuncia.telefone
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "block text-slate-500 text-xs",
                                                children: "Categoria Relatada"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-medium text-slate-800",
                                                children: denuncia.categoria
                                            })
                                        ]
                                    }),
                                    denuncia.arquivos && denuncia.arquivos.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "block text-slate-500 text-xs mb-1",
                                                children: "Arquivos Anexados"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                                className: "text-xs space-y-2",
                                                children: denuncia.arquivos.map((arq, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                            href: arq.url,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "bg-blue-50 text-blue-700 hover:bg-blue-100 p-2 rounded flex items-center justify-between border border-blue-100 transition-colors",
                                                            children: [
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                                    className: "flex items-center gap-1 font-medium",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $824b163d7442530e$export$2e2bcd8739ae039), {
                                                                            size: 12
                                                                        }),
                                                                        " ",
                                                                        arq.nomeExibicao
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                                                    size: 12
                                                                })
                                                            ]
                                                        })
                                                    }, idx))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white p-5 rounded-xl shadow-sm border border-slate-200",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 border-b pb-2 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4980c56854bb97ce$export$2e2bcd8739ae039), {
                                        size: 14
                                    }),
                                    " Hist\xf3rico"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "relative border-l-2 border-slate-200 ml-2 pl-4 py-2 space-y-4",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                            className: "absolute -left-[23px] top-1 w-3 h-3 bg-blue-500 rounded-full border-2 border-white"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-xs text-slate-500",
                                            children: formatTimestamp(denuncia.dataCompleta)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                            className: "text-sm font-medium text-slate-700",
                                            children: "Relato Enviado"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "md:col-span-2 bg-white rounded-xl shadow-sm border border-slate-200 flex flex-col h-[600px]",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "p-4 border-b border-slate-200 bg-slate-50 rounded-t-xl flex justify-between items-center",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                                className: "font-bold text-slate-800 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa913da585dd100$export$2e2bcd8739ae039), {
                                        size: 18,
                                        className: "text-blue-600"
                                    }),
                                    " Mensagens e Intera\xe7\xf5es"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "font-mono text-sm font-bold bg-white px-3 py-1 rounded border border-slate-200",
                                children: denuncia.id
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "flex-1 p-4 overflow-y-auto space-y-4 bg-slate-50",
                        children: (denuncia.mensagens || []).map((msg)=>{
                            const isComite = checarSeEhComite(msg.remetenteExibicao);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: `flex flex-col ${isComite ? 'items-start' : 'items-end'}`,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                        className: "text-[10px] text-slate-400 mb-1 flex items-center gap-1",
                                        children: [
                                            msg.remetenteExibicao,
                                            " \u2022 ",
                                            msg.data,
                                            " ",
                                            isAdminView && isComite && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "bg-slate-200 text-slate-600 px-1.5 py-0.5 rounded ml-2",
                                                children: [
                                                    "Log: ",
                                                    msg.remetenteInterno
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: `p-3 rounded-xl max-w-[85%] text-sm shadow-sm ${isComite ? 'bg-white border border-slate-200 text-slate-700 rounded-tl-none' : 'bg-blue-600 text-white rounded-tr-none'}`,
                                        children: msg.texto
                                    })
                                ]
                            }, msg.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "p-4 border-t border-slate-200 bg-white rounded-b-xl",
                        children: !isChatEnabled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "bg-slate-100 p-3 rounded text-center text-sm text-slate-500 border border-slate-200",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                                    size: 16,
                                    className: "mx-auto mb-1 text-slate-400"
                                }),
                                "O chat s\xf3 estar\xe1 dispon\xedvel quando o status for ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                    children: '"Em an\xe1lise"'
                                }),
                                "."
                            ]
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                            onSubmit: isAdminView ? (e)=>enviarMensagemAdminChat(e, denuncia) : enviarMensagemUsuarioChat,
                            className: "flex gap-2",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    value: isAdminView ? adminNovaMensagem : novaMensagem,
                                    onChange: (e)=>isAdminView ? setAdminNovaMensagem(e.target.value) : setNovaMensagem(e.target.value),
                                    placeholder: isAdminView ? "Escreva sua resposta como Comit\xea..." : "Digite sua mensagem para o comit\xea...",
                                    className: "flex-1 p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none text-sm"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    type: "submit",
                                    className: "bg-blue-600 hover:bg-blue-700 text-white p-3 rounded-lg transition-colors flex items-center justify-center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
                                        size: 18
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");
/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ce8c437c319961cc$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $ce8c437c319961cc$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("arrow-left", $ce8c437c319961cc$export$3efd853dbb351e94);



const $327ff33e961188fd$export$600f95652e45663 = (props)=>{
    const { denunciaRastreada: denunciaRastreada, trackedId: trackedId, setTrackedId: setTrackedId, buscaProtocolo: buscaProtocolo, setBuscaProtocolo: setBuscaProtocolo, buscaPin: buscaPin, setBuscaPin: setBuscaPin, handleBuscarDenuncia: handleBuscarDenuncia } = props;
    if (!trackedId) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-md mx-auto mt-16 p-8 bg-white rounded-xl shadow-lg border border-slate-100 animate-fadeIn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-center mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
                        className: "mx-auto text-blue-600 mb-3",
                        size: 40
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-slate-800",
                        children: "Acompanhar Situa\xe7\xe3o"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-slate-500 text-sm mt-1",
                        children: "Insira seus dados para acessar o andamento do seu relato."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleBuscarDenuncia,
                className: "space-y-5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-semibold text-slate-700 mb-1",
                                children: "N\xfamero do Protocolo"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                value: buscaProtocolo,
                                onChange: (e)=>setBuscaProtocolo(e.target.value.toUpperCase()),
                                placeholder: "RTA-XXXXXXXX",
                                className: "w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none uppercase font-mono",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-semibold text-slate-700 mb-1",
                                children: "PIN de Acesso (6 d\xedgitos)"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                maxLength: "6",
                                value: buscaPin,
                                onChange: (e)=>setBuscaPin(e.target.value),
                                placeholder: "000000",
                                className: "w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none font-mono tracking-widest text-center",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "submit",
                        className: "w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg shadow",
                        children: "Consultar Relato"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto mt-8 px-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: ()=>setTrackedId(null),
                className: "text-blue-600 text-sm font-medium mb-4 flex items-center gap-1 hover:underline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce8c437c319961cc$export$2e2bcd8739ae039), {
                        size: 16
                    }),
                    " Voltar para a busca"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d864864214d4dc$export$c22448ecaa24cc8f), {
                ...props,
                denuncia: denunciaRastreada,
                isAdminView: false
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $175ba32226cc3913$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 10h.01",
            key: "1nrarc"
        }
    ],
    [
        "path",
        {
            d: "M12 14h.01",
            key: "1etili"
        }
    ],
    [
        "path",
        {
            d: "M12 6h.01",
            key: "1vi96p"
        }
    ],
    [
        "path",
        {
            d: "M16 10h.01",
            key: "1m94wz"
        }
    ],
    [
        "path",
        {
            d: "M16 14h.01",
            key: "1gbofw"
        }
    ],
    [
        "path",
        {
            d: "M16 6h.01",
            key: "1x0f13"
        }
    ],
    [
        "path",
        {
            d: "M8 10h.01",
            key: "19clt8"
        }
    ],
    [
        "path",
        {
            d: "M8 14h.01",
            key: "6423bh"
        }
    ],
    [
        "path",
        {
            d: "M8 6h.01",
            key: "1dz90k"
        }
    ],
    [
        "path",
        {
            d: "M9 22v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3",
            key: "cabbwy"
        }
    ],
    [
        "rect",
        {
            x: "4",
            y: "2",
            width: "16",
            height: "20",
            rx: "2",
            key: "1uxh74"
        }
    ]
];
const $175ba32226cc3913$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("building", $175ba32226cc3913$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839cd39f53db0480$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $839cd39f53db0480$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("eye", $839cd39f53db0480$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $df9771111904a5d5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "M10 9H8",
            key: "b1mrlr"
        }
    ],
    [
        "path",
        {
            d: "M16 13H8",
            key: "t4e002"
        }
    ],
    [
        "path",
        {
            d: "M16 17H8",
            key: "z1uh3a"
        }
    ]
];
const $df9771111904a5d5$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("file-text", $df9771111904a5d5$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.20.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fe506e7c2094458f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $fe506e7c2094458f$export$2e2bcd8739ae039 = (0, $cb908d1b06653674$export$2e2bcd8739ae039)("log-out", $fe506e7c2094458f$export$3efd853dbb351e94);



const $0075c5ef3314e518$export$a8faf1410a7a0ce1 = (props)=>{
    const { denuncias: denuncias, adminSearch: adminSearch, setAdminSearch: setAdminSearch, loggedAdminEmail: loggedAdminEmail, handleAdminLogout: handleAdminLogout, updateDenuncia: updateDenuncia, adminActiveChatId: adminActiveChatId, setAdminActiveChatId: setAdminActiveChatId } = props;
    const [denunciaAtiva, setDenunciaAtiva] = (0, $acw62.useState)(null);
    // Novos estados para os filtros
    const [filterStatus, setFilterStatus] = (0, $acw62.useState)('Todos');
    const [filterDataInicio, setFilterDataInicio] = (0, $acw62.useState)('');
    const [filterDataFim, setFilterDataFim] = (0, $acw62.useState)('');
    (0, $acw62.useEffect)(()=>{
        if (adminActiveChatId) {
            const unsub = (0, $a33cbddcd7bfa0a9$export$d36370812fb26935)((0, $b1c6e3a850a3c735$export$a9c996f45e5784d0)((0, $f0c5fb609932756e$export$f932f06c7eb6abeb), 'denuncias', adminActiveChatId), (snapshot)=>{
                setDenunciaAtiva({
                    id: snapshot.id,
                    ...snapshot.data()
                });
            });
            return ()=>unsub();
        } else setDenunciaAtiva(null);
    }, [
        adminActiveChatId
    ]);
    const formatTimestamp = (timestamp)=>{
        if (!timestamp) return "Data indispon\xedvel";
        if (timestamp.seconds) return new Date(timestamp.seconds * 1000).toLocaleString('pt-BR');
        if (timestamp instanceof Date) return timestamp.toLocaleString('pt-BR');
        return String(timestamp);
    };
    if (denunciaAtiva) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto mt-8 px-4",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: ()=>setAdminActiveChatId(null),
                className: "text-blue-600 text-sm font-medium mb-4 flex items-center gap-1 hover:underline",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce8c437c319961cc$export$2e2bcd8739ae039), {
                        size: 16
                    }),
                    " Voltar para o Painel Geral"
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f7d864864214d4dc$export$c22448ecaa24cc8f), {
                ...props,
                denuncia: denunciaAtiva,
                isAdminView: true
            })
        ]
    });
    // Lógica de Filtros Combinados (Busca + Status + Data)
    const denunciasFiltradas = denuncias.filter((d)=>{
        // 1. Filtro de Texto (Search)
        let matchSearch = true;
        if (adminSearch) {
            const termo = adminSearch.toLowerCase();
            matchSearch = d.id.toLowerCase().includes(termo) || d.nome.toLowerCase().includes(termo) || d.categoria.toLowerCase().includes(termo) || d.descricao.toLowerCase().includes(termo) || d.status.toLowerCase().includes(termo) || d.setor.toLowerCase().includes(termo);
        }
        // 2. Filtro de Status
        let matchStatus = true;
        if (filterStatus !== 'Todos') matchStatus = d.status === filterStatus;
        // 3. Filtro de Data
        let matchDate = true;
        if (filterDataInicio || filterDataFim) {
            let dateToCompare = null;
            if (d.dataCompleta && d.dataCompleta.toDate) dateToCompare = d.dataCompleta.toDate();
            else if (d.dataCompleta && d.dataCompleta.seconds) dateToCompare = new Date(d.dataCompleta.seconds * 1000);
            if (dateToCompare) {
                dateToCompare.setHours(0, 0, 0, 0);
                if (filterDataInicio) {
                    const start = new Date(filterDataInicio + 'T00:00:00');
                    if (dateToCompare < start) matchDate = false;
                }
                if (filterDataFim) {
                    const end = new Date(filterDataFim + 'T23:59:59');
                    if (dateToCompare > end) matchDate = false;
                }
            }
        }
        return matchSearch && matchStatus && matchDate;
    });
    // Contadores para os Cards
    const total = denuncias.length;
    const abertas = denuncias.filter((d)=>d.status === 'Em Aberto').length;
    const emAnalise = denuncias.filter((d)=>d.status === "Em an\xe1lise").length;
    const concluidas = denuncias.filter((d)=>d.status === "Conclu\xedda").length;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-6xl mx-auto mt-8 px-4 animate-fadeIn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                className: "text-2xl font-bold text-slate-800 flex items-center gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                                        size: 24,
                                        className: "text-slate-600"
                                    }),
                                    " Painel de Gest\xe3o de Den\xfancias"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                className: "text-slate-500 text-sm",
                                children: [
                                    "Logado como: ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: loggedAdminEmail
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        onClick: handleAdminLogout,
                        className: "bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2 rounded-lg text-sm font-medium transition-colors border border-red-200 flex items-center gap-2 shadow-sm",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe506e7c2094458f$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " Sair"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 md:grid-cols-4 gap-3 mb-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setFilterStatus('Todos'),
                        className: `p-2 rounded-lg shadow-sm border flex flex-col items-center justify-center transition-all hover:shadow-md cursor-pointer hover:-translate-y-0.5 ${filterStatus === 'Todos' ? 'bg-slate-100 border-slate-400 ring-1 ring-slate-400' : 'bg-white border-slate-200'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[10px] text-slate-500 font-bold uppercase tracking-wider mb-0.5",
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-lg font-bold text-slate-800",
                                children: total
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setFilterStatus('Em Aberto'),
                        className: `p-2 rounded-lg shadow-sm border flex flex-col items-center justify-center transition-all hover:shadow-md cursor-pointer hover:-translate-y-0.5 ${filterStatus === 'Em Aberto' ? 'bg-red-100 border-red-400 ring-1 ring-red-400' : 'bg-red-50 border-red-200'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[10px] text-red-600 font-bold uppercase tracking-wider mb-0.5",
                                children: "Abertas"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-lg font-bold text-red-700",
                                children: abertas
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setFilterStatus("Em an\xe1lise"),
                        className: `p-2 rounded-lg shadow-sm border flex flex-col items-center justify-center transition-all hover:shadow-md cursor-pointer hover:-translate-y-0.5 ${filterStatus === "Em an\xe1lise" ? 'bg-amber-100 border-amber-400 ring-1 ring-amber-400' : 'bg-amber-50 border-amber-200'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[10px] text-amber-600 font-bold uppercase tracking-wider mb-0.5",
                                children: "Em An\xe1lise"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-lg font-bold text-amber-700",
                                children: emAnalise
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        onClick: ()=>setFilterStatus("Conclu\xedda"),
                        className: `p-2 rounded-lg shadow-sm border flex flex-col items-center justify-center transition-all hover:shadow-md cursor-pointer hover:-translate-y-0.5 ${filterStatus === "Conclu\xedda" ? 'bg-emerald-100 border-emerald-400 ring-1 ring-emerald-400' : 'bg-emerald-50 border-emerald-200'}`,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-[10px] text-emerald-600 font-bold uppercase tracking-wider mb-0.5",
                                children: "Conclu\xeddas"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-lg font-bold text-emerald-700",
                                children: concluidas
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "mb-8 bg-white p-4 rounded-xl shadow-sm border border-slate-200 flex flex-col xl:flex-row gap-4 items-center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex-1 w-full flex items-center gap-3 bg-slate-50 rounded-lg px-3 py-1 border border-slate-200 focus-within:ring-2 focus-within:ring-blue-500",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30b4d9519dd12f8d$export$2e2bcd8739ae039), {
                                className: "text-slate-400 shrink-0",
                                size: 20
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                value: adminSearch,
                                onChange: (e)=>setAdminSearch(e.target.value),
                                placeholder: "Buscar por protocolo, nome, categoria ou descri\xe7\xe3o...",
                                className: "w-full p-2 outline-none text-slate-700 bg-transparent text-sm"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex flex-wrap items-center gap-3 w-full xl:w-auto",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                value: filterStatus,
                                onChange: (e)=>setFilterStatus(e.target.value),
                                className: "p-2.5 text-sm border border-slate-300 rounded-lg outline-none bg-slate-50 text-slate-700 focus:ring-2 focus:ring-blue-500",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "Todos",
                                        children: "Todos os Status"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "Em Aberto",
                                        children: "Em Aberto"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "Em an\xe1lise",
                                        children: "Em an\xe1lise"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                        value: "Conclu\xedda",
                                        children: "Conclu\xedda"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex items-center gap-2 bg-slate-50 border border-slate-300 rounded-lg px-2",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-slate-400 font-medium pl-1",
                                        children: "De"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        value: filterDataInicio,
                                        onChange: (e)=>setFilterDataInicio(e.target.value),
                                        className: "p-2 text-sm bg-transparent outline-none text-slate-700"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "text-xs text-slate-400 font-medium",
                                        children: "At\xe9"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "date",
                                        value: filterDataFim,
                                        onChange: (e)=>setFilterDataFim(e.target.value),
                                        className: "p-2 text-sm bg-transparent outline-none text-slate-700"
                                    })
                                ]
                            }),
                            (filterStatus !== 'Todos' || filterDataInicio || filterDataFim || adminSearch) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>{
                                    setFilterStatus('Todos');
                                    setFilterDataInicio('');
                                    setFilterDataFim('');
                                    setAdminSearch('');
                                },
                                className: "text-sm text-red-500 hover:text-red-700 hover:underline px-2 font-medium",
                                children: "Limpar Filtros"
                            })
                        ]
                    })
                ]
            }),
            denunciasFiltradas.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "bg-white p-12 text-center rounded-xl shadow-sm border border-slate-200",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df9771111904a5d5$export$2e2bcd8739ae039), {
                        className: "mx-auto text-slate-300 mb-4",
                        size: 48
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        className: "text-lg font-medium text-slate-600",
                        children: "Nenhuma den\xfancia encontrada com os filtros atuais."
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid gap-4",
                children: denunciasFiltradas.map((d)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-white p-5 rounded-xl shadow-sm border border-slate-200 flex flex-col lg:flex-row gap-6 transition-all hover:shadow-md",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "flex-1 space-y-3",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "font-mono bg-slate-100 text-slate-700 px-2 py-1 rounded text-sm font-bold border border-slate-200",
                                                children: d.id
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "text-xs text-slate-500 bg-slate-50 px-2 py-1 rounded border border-slate-100 flex items-center gap-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4980c56854bb97ce$export$2e2bcd8739ae039), {
                                                        size: 12
                                                    }),
                                                    " ",
                                                    formatTimestamp(d.dataCompleta)
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                className: "px-2 py-1 rounded text-xs font-bold uppercase bg-blue-50 text-blue-700 border border-blue-100",
                                                children: d.categoria
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        className: "text-slate-700 text-sm line-clamp-3 bg-slate-50 p-3 rounded border border-slate-100",
                                        children: d.descricao
                                    }),
                                    d.arquivos && d.arquivos.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-wrap gap-2 mt-2",
                                        children: d.arquivos.map((arq, idx)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                href: arq.url,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-[11px] bg-blue-50 text-blue-600 hover:bg-blue-100 px-2 py-1 rounded flex items-center gap-1 border border-blue-200 transition-colors",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $824b163d7442530e$export$2e2bcd8739ae039), {
                                                        size: 10
                                                    }),
                                                    " ",
                                                    arq.nomeExibicao,
                                                    " ",
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fc88d8cf02c9ed12$export$2e2bcd8739ae039), {
                                                        size: 10
                                                    })
                                                ]
                                            }, idx))
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        className: "flex flex-wrap items-center gap-2 text-xs text-slate-500 pt-2 border-t border-slate-100 mt-2",
                                        children: d.anonimo ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "bg-slate-200 text-slate-700 px-2 py-1 rounded-full flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839cd39f53db0480$export$2e2bcd8739ae039), {
                                                    size: 12
                                                }),
                                                " Den\xfancia An\xf4nima"
                                            ]
                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                            className: "bg-amber-100 text-amber-800 px-2 py-1 rounded-full flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ff4d96da330336c2$export$2e2bcd8739ae039), {
                                                    size: 12
                                                }),
                                                " ",
                                                d.nome,
                                                " | ",
                                                d.email,
                                                " | ",
                                                d.telefone
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "w-full lg:w-64 flex flex-col gap-3 bg-slate-50 p-4 rounded-lg border border-slate-100",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "text-xs font-bold text-slate-500 uppercase flex items-center gap-1 mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2b71f7c0d2454a8e$export$2e2bcd8739ae039), {
                                                        size: 12
                                                    }),
                                                    " Status"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: d.status,
                                                onChange: (e)=>updateDenuncia(d.id, 'status', e.target.value),
                                                className: `w-full p-2 text-sm border rounded outline-none font-medium cursor-pointer ${d.status === 'Em Aberto' ? 'bg-red-50 border-red-200 text-red-700' : d.status === "Em an\xe1lise" ? 'bg-amber-50 border-amber-200 text-amber-700' : 'bg-emerald-50 border-emerald-200 text-emerald-700'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Em Aberto",
                                                        children: "Em Aberto"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Em an\xe1lise",
                                                        children: "Em an\xe1lise"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Conclu\xedda",
                                                        children: "Conclu\xedda"
                                                    })
                                                ]
                                            }),
                                            d.status === 'Em Aberto' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                                className: "text-[10px] text-red-500 mt-1",
                                                children: 'Altere para "Em an\xe1lise" para habilitar o chat.'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                                className: "text-xs font-bold text-slate-500 uppercase flex items-center gap-1 mb-1",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $175ba32226cc3913$export$2e2bcd8739ae039), {
                                                        size: 12
                                                    }),
                                                    " Local / Setor"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("select", {
                                                value: d.setor,
                                                onChange: (e)=>updateDenuncia(d.id, 'setor', e.target.value),
                                                className: "w-full p-2 text-sm border border-slate-300 rounded outline-none bg-white text-slate-700 cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "N\xe3o Atribu\xeddo",
                                                        children: "N\xe3o Atribu\xeddo"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "RH",
                                                        children: "RH"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "INMETRO",
                                                        children: "INMETRO"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Dire\xe7\xe3o",
                                                        children: "Dire\xe7\xe3o"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", {
                                                        value: "Devolvida",
                                                        children: "Devolvida"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                        onClick: ()=>setAdminActiveChatId(d.id),
                                        className: "mt-2 w-full bg-slate-800 hover:bg-slate-900 text-white text-xs py-2 rounded flex justify-center items-center gap-1 transition-colors shadow-sm",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa913da585dd100$export$2e2bcd8739ae039), {
                                                size: 12
                                            }),
                                            " ",
                                            d.status === "Em an\xe1lise" ? 'Responder Relator' : 'Ver Detalhes'
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, d.id))
            })
        ]
    });
};



parcelRequire("acw62");

const $2ffcc6ff61f69058$export$7f0e280f8eb4158b = ({ adminEmailInput: adminEmailInput, setAdminEmailInput: setAdminEmailInput, adminPasswordInput: adminPasswordInput, setAdminPasswordInput: setAdminPasswordInput, handleAdminLogin: handleAdminLogin, loginError: loginError })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "max-w-md mx-auto mt-16 p-8 bg-white rounded-xl shadow-lg border border-slate-100 animate-fadeIn",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-center mb-8",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "w-16 h-16 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5389c2c2de1c7f38$export$2e2bcd8739ae039), {
                            className: "text-slate-600",
                            size: 32
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        className: "text-2xl font-bold text-slate-800",
                        children: "Acesso Restrito"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-slate-500 text-sm mt-1",
                        children: "Insira suas credenciais para acessar o painel administrativo."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleAdminLogin,
                className: "space-y-5",
                children: [
                    loginError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "bg-red-50 border border-red-200 text-red-600 p-3 rounded-lg text-sm flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f66de94054a4f331$export$2e2bcd8739ae039), {
                                size: 16
                            }),
                            " ",
                            loginError
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-semibold text-slate-700 mb-1",
                                children: "E-mail Corporativo"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "email",
                                value: adminEmailInput,
                                onChange: (e)=>setAdminEmailInput(e.target.value),
                                placeholder: "nome@rta.eng.br",
                                className: "w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                className: "block text-sm font-semibold text-slate-700 mb-1",
                                children: "Senha"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "password",
                                value: adminPasswordInput,
                                onChange: (e)=>setAdminPasswordInput(e.target.value),
                                placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                className: "w-full p-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none",
                                required: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "submit",
                        className: "w-full bg-slate-800 hover:bg-slate-900 text-white font-bold py-3 rounded-lg flex justify-center items-center gap-2 mt-2",
                        children: [
                            "Entrar no Painel ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6c49d7be4abd1b80$export$2e2bcd8739ae039), {
                                size: 16
                            })
                        ]
                    })
                ]
            })
        ]
    });




// --- Componente Principal ---
function $efd3ba4ec2608b1d$var$App() {
    const [view, setView] = (0, $acw62.useState)('public');
    const [denuncias, setDenuncias] = (0, $acw62.useState)([]);
    const [isAdminLoggedIn, setIsAdminLoggedIn] = (0, $acw62.useState)(false);
    const [adminEmailInput, setAdminEmailInput] = (0, $acw62.useState)('');
    const [adminPasswordInput, setAdminPasswordInput] = (0, $acw62.useState)('');
    const [loginError, setLoginError] = (0, $acw62.useState)('');
    const [loggedAdminEmail, setLoggedAdminEmail] = (0, $acw62.useState)('');
    const [adminSearch, setAdminSearch] = (0, $acw62.useState)('');
    const [adminActiveChatId, setAdminActiveChatId] = (0, $acw62.useState)(null);
    const [adminNovaMensagem, setAdminNovaMensagem] = (0, $acw62.useState)('');
    const [categoria, setCategoria] = (0, $acw62.useState)('');
    const [descricao, setDescricao] = (0, $acw62.useState)('');
    const [anonimo, setAnonimo] = (0, $acw62.useState)(false);
    const [nome, setNome] = (0, $acw62.useState)('');
    const [email, setEmail] = (0, $acw62.useState)('');
    const [telefone, setTelefone] = (0, $acw62.useState)('');
    const [anexos, setAnexos] = (0, $acw62.useState)([]);
    const [protocoloGerado, setProtocoloGerado] = (0, $acw62.useState)('');
    const [pinGerado, setPinGerado] = (0, $acw62.useState)('');
    const [buscaProtocolo, setBuscaProtocolo] = (0, $acw62.useState)('');
    const [buscaPin, setBuscaPin] = (0, $acw62.useState)('');
    // AQUI: Usando trackedId como "chave" para iniciar o listener
    const [trackedId, setTrackedId] = (0, $acw62.useState)(null);
    const [denunciaRastreada, setDenunciaRastreada] = (0, $acw62.useState)(null);
    const [novaMensagem, setNovaMensagem] = (0, $acw62.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let unsubscribeFirestore = null;
        const unsubscribeAuth = (0, $c079a574c124a39d$export$df995fae86a55f06)((0, $f0c5fb609932756e$export$73693bad9f5880b0), (user)=>{
            setIsAdminLoggedIn(!!user);
            if (user) {
                setLoggedAdminEmail(user.email);
                const denunciasQuery = (0, $a33cbddcd7bfa0a9$export$2fa187e846a241c4)((0, $b1c6e3a850a3c735$export$738ab4df8bf92ae9)((0, $f0c5fb609932756e$export$f932f06c7eb6abeb), "denuncias"), (0, $a33cbddcd7bfa0a9$export$f18af21d6f4dafd8)("dataCompleta", "desc"));
                unsubscribeFirestore = (0, $a33cbddcd7bfa0a9$export$d36370812fb26935)(denunciasQuery, (snapshot)=>{
                    const denunciasData = snapshot.docs.map((doc)=>({
                            id: doc.id,
                            ...doc.data()
                        }));
                    setDenuncias(denunciasData);
                }, (error)=>console.error("Erro no listener de den\xfancias:", error));
            } else {
                if (unsubscribeFirestore) {
                    unsubscribeFirestore();
                    unsubscribeFirestore = null;
                }
                setDenuncias([]);
                setLoggedAdminEmail('');
            }
        });
        return ()=>{
            unsubscribeAuth();
            if (unsubscribeFirestore) unsubscribeFirestore();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!trackedId) setDenunciaRastreada(null);
    }, [
        trackedId
    ]);
    const handleFileChange = (0, $acw62.useCallback)((e)=>{
        const selectedFiles = Array.from(e.target.files || []);
        if (selectedFiles.length === 0) return;
        const invalidMessage = selectedFiles.map((0, $820877bea407f5fe$export$88d978873bc146b9)).find(Boolean);
        if (invalidMessage) {
            alert(invalidMessage);
            e.target.value = '';
            return;
        }
        setAnexos((prev)=>{
            if (prev.length + selectedFiles.length > (0, $5cdc329eeebd56d0$export$dc81b9d5f78b445)) {
                alert(`\xc9 permitido anexar no m\xe1ximo ${(0, $5cdc329eeebd56d0$export$dc81b9d5f78b445)} arquivos por relato.`);
                return prev;
            }
            return [
                ...prev,
                ...selectedFiles
            ];
        });
        e.target.value = '';
    }, []);
    const removeAnexo = (0, $acw62.useCallback)((index)=>{
        setAnexos((prev)=>prev.filter((_, i)=>i !== index));
    }, []);
    const gerarProtocoloDisponivel = (0, $acw62.useCallback)(async ()=>{
        for(let attempt = 0; attempt < (0, $5cdc329eeebd56d0$export$434762a68b8fd11b); attempt += 1){
            const protocolo = (0, $820877bea407f5fe$export$bbf52f06d1ed0ffc)();
            const existingDoc = await (0, $a33cbddcd7bfa0a9$export$11eb3b5ef9574821)((0, $b1c6e3a850a3c735$export$a9c996f45e5784d0)((0, $f0c5fb609932756e$export$f932f06c7eb6abeb), "denuncias", protocolo));
            if (!existingDoc.exists) return protocolo;
        }
        throw new Error("N\xe3o foi poss\xedvel gerar um protocolo \xfanico. Tente novamente.");
    }, []);
    const handleSubmit = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        if (isSubmitting) return;
        if (!categoria || !descricao) return alert("Por favor, preencha a categoria e a descri\xe7\xe3o.");
        if (!anonimo && (!nome || !email && !telefone)) return alert("Para esta categoria ou escolha, nome e pelo menos um contato (email ou telefone) s\xe3o obrigat\xf3rios.");
        const invalidAnexoMessage = anexos.map((0, $820877bea407f5fe$export$88d978873bc146b9)).find(Boolean);
        if (invalidAnexoMessage) return alert(invalidAnexoMessage);
        setIsSubmitting(true);
        try {
            const novoProtocolo = await gerarProtocoloDisponivel();
            const novoPin = (0, $820877bea407f5fe$export$ca28e4dddf04f350)();
            const dataHoraAtual = (0, $b1c6e3a850a3c735$export$890c4ad488842ce7).now();
            const arquivosProcessados = await Promise.all(anexos.map(async (file)=>{
                const anexoRef = (0, $63c1f7f3542429ef$export$eff4d24c3ff7876e)((0, $f0c5fb609932756e$export$ddcffe0146c8f882), `anexos/${novoProtocolo}/${file.name}`);
                await (0, $63c1f7f3542429ef$export$ac40f56b52f99dd1)(anexoRef, file);
                const url = await (0, $63c1f7f3542429ef$export$c8bf645a0c2a7d9f)(anexoRef);
                return {
                    nomeExibicao: file.name,
                    url: url,
                    nomeOriginal: file.name
                };
            }));
            const novaDenuncia = {
                id: novoProtocolo,
                pin: novoPin,
                dataCompleta: dataHoraAtual,
                categoria: categoria,
                descricao: descricao,
                anonimo: anonimo,
                nome: anonimo ? "An\xf4nimo" : nome,
                email: anonimo ? 'N/A' : email,
                telefone: anonimo ? 'N/A' : telefone,
                arquivos: arquivosProcessados,
                status: 'Em Aberto',
                setor: "N\xe3o Atribu\xeddo",
                mensagens: [
                    {
                        id: Date.now(),
                        remetenteExibicao: anonimo ? "An\xf4nimo (Autor)" : nome,
                        remetenteInterno: anonimo ? "An\xf4nimo" : email || telefone,
                        texto: descricao,
                        data: new Date().toLocaleString('pt-BR')
                    }
                ]
            };
            await (0, $a33cbddcd7bfa0a9$export$5ff77ddaff3c9e12)((0, $b1c6e3a850a3c735$export$a9c996f45e5784d0)((0, $f0c5fb609932756e$export$f932f06c7eb6abeb), "denuncias", novoProtocolo), novaDenuncia);
            setProtocoloGerado(novoProtocolo);
            setPinGerado(novoPin);
            setView('success');
            setCategoria('');
            setDescricao('');
            setAnonimo(false);
            setNome('');
            setEmail('');
            setTelefone('');
            setAnexos([]);
        } catch (error) {
            console.error("Erro ao enviar den\xfancia:", error);
            alert(`Ocorreu um erro ao enviar a den\xfancia. Por favor, verifique sua conex\xe3o ou as permiss\xf5es de armazenamento. Erro: ${error.message}`);
        } finally{
            setIsSubmitting(false);
        }
    }, [
        categoria,
        descricao,
        anonimo,
        nome,
        email,
        telefone,
        anexos,
        isSubmitting,
        gerarProtocoloDisponivel
    ]);
    const updateDenuncia = (0, $acw62.useCallback)(async (id, campo, valor)=>{
        try {
            await (0, $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2)((0, $b1c6e3a850a3c735$export$a9c996f45e5784d0)((0, $f0c5fb609932756e$export$f932f06c7eb6abeb), "denuncias", id), {
                [campo]: valor
            });
        } catch (error) {
            console.error("Erro ao atualizar den\xfancia:", error);
            alert("N\xe3o foi poss\xedvel atualizar a den\xfancia. Tente novamente.");
        }
    }, []);
    const handleBuscarDenuncia = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        try {
            const protocolo = buscaProtocolo.trim().toUpperCase();
            const result = await (0, $1404c1c60e8681b8$export$7c109d41ed3721ca)({
                protocolo: protocolo,
                pin: buscaPin.trim()
            });
            const denuncia = result.data.denuncia;
            setDenunciaRastreada(denuncia);
            setTrackedId(denuncia.id);
        } catch (error) {
            console.error("Erro ao buscar den\xfancia:", error);
            alert(error.message || "Protocolo ou PIN incorretos.");
        }
    }, [
        buscaProtocolo,
        buscaPin
    ]);
    const enviarMensagemUsuarioChat = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        if (!novaMensagem.trim() || !denunciaRastreada) return;
        try {
            const result = await (0, $1404c1c60e8681b8$export$4db8353dbbfd963f)({
                protocolo: denunciaRastreada.id,
                pin: buscaPin.trim(),
                texto: novaMensagem
            });
            setDenunciaRastreada(result.data.denuncia);
            setNovaMensagem('');
        } catch (error) {
            console.error("Erro ao enviar mensagem do relator:", error);
            alert(error.message || "N\xe3o foi poss\xedvel enviar a mensagem. Tente novamente.");
        }
    }, [
        novaMensagem,
        denunciaRastreada,
        buscaPin
    ]);
    const handleAdminLogin = (0, $acw62.useCallback)(async (e)=>{
        e.preventDefault();
        try {
            await (0, $c079a574c124a39d$export$2219238a014317b0)((0, $f0c5fb609932756e$export$73693bad9f5880b0), adminEmailInput, adminPasswordInput);
            setLoginError('');
            setAdminEmailInput('');
            setAdminPasswordInput('');
        } catch (error) {
            setLoginError('E-mail ou senha incorretos.');
        }
    }, [
        adminEmailInput,
        adminPasswordInput
    ]);
    const handleAdminLogout = (0, $acw62.useCallback)(async ()=>{
        try {
            await (0, $c079a574c124a39d$export$96f57966bedc81b4)((0, $f0c5fb609932756e$export$73693bad9f5880b0));
            setAdminActiveChatId(null);
        } catch (error) {
            console.error("Erro ao sair do painel:", error);
            alert("N\xe3o foi poss\xedvel sair do painel. Tente novamente.");
        }
    }, []);
    const enviarMensagemAdminChat = (0, $acw62.useCallback)(async (e, denuncia)=>{
        e.preventDefault();
        if (!adminNovaMensagem.trim() || !denuncia.id) return;
        try {
            const msg = {
                id: Date.now(),
                remetenteExibicao: 'RTA responde',
                remetenteInterno: loggedAdminEmail,
                texto: adminNovaMensagem,
                data: new Date().toLocaleString('pt-BR')
            };
            await (0, $a33cbddcd7bfa0a9$export$22d1fdd1e73faff2)((0, $b1c6e3a850a3c735$export$a9c996f45e5784d0)((0, $f0c5fb609932756e$export$f932f06c7eb6abeb), "denuncias", denuncia.id), {
                mensagens: (0, $b1c6e3a850a3c735$export$2ed0fc6709e59212)(msg)
            });
            setAdminNovaMensagem('');
        } catch (error) {
            console.error("Erro ao enviar mensagem do admin:", error);
            alert("N\xe3o foi poss\xedvel enviar a resposta. Tente novamente.");
        }
    }, [
        adminNovaMensagem,
        loggedAdminEmail
    ]);
    const props = {
        view: view,
        setView: setView,
        denuncias: denuncias,
        isAdminLoggedIn: isAdminLoggedIn,
        adminEmailInput: adminEmailInput,
        setAdminEmailInput: setAdminEmailInput,
        adminPasswordInput: adminPasswordInput,
        setAdminPasswordInput: setAdminPasswordInput,
        loginError: loginError,
        loggedAdminEmail: loggedAdminEmail,
        adminSearch: adminSearch,
        setAdminSearch: setAdminSearch,
        adminActiveChatId: adminActiveChatId,
        setAdminActiveChatId: setAdminActiveChatId,
        adminNovaMensagem: adminNovaMensagem,
        setAdminNovaMensagem: setAdminNovaMensagem,
        categoria: categoria,
        setCategoria: setCategoria,
        descricao: descricao,
        setDescricao: setDescricao,
        anonimo: anonimo,
        setAnonimo: setAnonimo,
        nome: nome,
        setNome: setNome,
        email: email,
        setEmail: setEmail,
        telefone: telefone,
        setTelefone: setTelefone,
        anexos: anexos,
        setAnexos: setAnexos,
        protocoloGerado: protocoloGerado,
        pinGerado: pinGerado,
        buscaProtocolo: buscaProtocolo,
        setBuscaProtocolo: setBuscaProtocolo,
        buscaPin: buscaPin,
        setBuscaPin: setBuscaPin,
        denunciaRastreada: denunciaRastreada,
        setDenunciaRastreada: setDenunciaRastreada,
        novaMensagem: novaMensagem,
        setNovaMensagem: setNovaMensagem,
        isSubmitting: isSubmitting,
        handleFileChange: handleFileChange,
        removeAnexo: removeAnexo,
        handleSubmit: handleSubmit,
        updateDenuncia: updateDenuncia,
        handleBuscarDenuncia: handleBuscarDenuncia,
        enviarMensagemUsuarioChat: enviarMensagemUsuarioChat,
        handleAdminLogin: handleAdminLogin,
        handleAdminLogout: handleAdminLogout,
        enviarMensagemAdminChat: enviarMensagemAdminChat,
        trackedId: trackedId,
        setTrackedId: setTrackedId
    };
    const publicFormProps = {
        states: {
            categoria: categoria,
            descricao: descricao,
            anonimo: anonimo,
            nome: nome,
            email: email,
            telefone: telefone,
            anexos: anexos,
            isSubmitting: isSubmitting
        },
        handlers: {
            setCategoria: setCategoria,
            setDescricao: setDescricao,
            setAnonimo: setAnonimo,
            setNome: setNome,
            setEmail: setEmail,
            setTelefone: setTelefone,
            handleFileChange: handleFileChange,
            removeAnexo: removeAnexo,
            handleSubmit: handleSubmit
        }
    };
    const renderContent = ()=>{
        switch(view){
            case 'public':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1a7b862c7e55c39$export$e04cb87a357104e9), {
                    ...publicFormProps
                });
            case 'success':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $06713472d571543c$export$be5117c66bf44cb9), {
                    protocoloGerado: protocoloGerado,
                    pinGerado: pinGerado,
                    setBuscaProtocolo: setBuscaProtocolo,
                    setBuscaPin: setBuscaPin,
                    setView: setView,
                    setTrackedId: setTrackedId
                });
            case 'track':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $327ff33e961188fd$export$600f95652e45663), {
                    ...props
                });
            case 'admin':
                return isAdminLoggedIn ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0075c5ef3314e518$export$a8faf1410a7a0ce1), {
                    ...props
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ffcc6ff61f69058$export$7f0e280f8eb4158b), {
                    ...props
                });
            default:
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1a7b862c7e55c39$export$e04cb87a357104e9), {
                    ...publicFormProps
                });
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-slate-50 pb-12 font-sans",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db9ed9a2274fc7a3$export$42cfbb80f7861e77), {
                view: view,
                setView: setView,
                setTrackedId: setTrackedId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                className: "transition-all duration-300",
                children: renderContent()
            })
        ]
    });
}
const $efd3ba4ec2608b1d$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($7e96a608cb33bf79$exports))).createRoot(document.getElementById('root'));
$efd3ba4ec2608b1d$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($efd3ba4ec2608b1d$var$App, {}));


//# sourceMappingURL=Ouvidoria.b098b65a.js.map
